// Generated by the Exylon v4 core contract pipeline. Do not edit.
export type AbandonCatalogMediaProvisionalsRequest = Readonly<{
  readonly editor_intent_id: string;
  readonly provisionals: readonly (Readonly<{
      readonly expected_version: number;
      readonly media_id: string;
      readonly sha256_digest: string;
    }>)[];
}>
export type AccessPolicyBlocker = Readonly<{
  readonly code: "active_work_requires_workspace" | "based_on_configuration_not_active" | "configuration_fingerprint_changed" | "default_workspace_missing" | "default_workspace_not_assigned" | "derived_workspace_manual_assignment" | "employee_foreign_or_missing" | "employee_inactive" | "employee_membership_missing" | "manager_membership_not_allowed" | "membership_duplicate" | "workspace_duplicate" | "workspace_not_enabled" | "workforce_fingerprint_changed";
  readonly employee_id: string | null;
  readonly membership_id: string | null;
  readonly message: string;
  readonly path: string;
  readonly workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
}>
export type AccessPolicyConfigurationIntent = Readonly<{
  readonly enabled_configurable_workspace_ids: readonly ("ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY")[];
  readonly manager_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
}>
export type AccessPolicyCurrentGrantBatch = Readonly<{
  readonly active_policy_version: number;
  readonly authority_version: number;
  readonly contract: "exylon.identity-access.current-grant-batch@1.0";
  readonly coverage: "complete";
  readonly items: readonly (AccessPolicyCurrentGrantObservation)[];
  readonly observed_at: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type AccessPolicyCurrentGrantBatchEnvelope = Readonly<{
  readonly result: AccessPolicyCurrentGrantBatch;
  readonly statusCode: number;
  readonly success: true;
}>
export type AccessPolicyCurrentGrantBatchQuery = Readonly<{
  readonly employee_ids: readonly (string)[];
}>
export type AccessPolicyCurrentGrantObservation = Readonly<{
  readonly employee_id: string;
  readonly grant: Readonly<{
    readonly default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
    readonly employee_id: string;
    readonly membership_id: string;
    readonly membership_version: number;
    readonly principal_id: string;
    readonly workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
  }> | null;
}>
export type AccessPolicyDiffEntry = Readonly<{
  readonly added_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
  readonly employee_id: string;
  readonly membership_id: string;
  readonly next_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
  readonly previous_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
  readonly removed_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
}>
export type AccessPolicyDirectory = Readonly<{
  readonly contract: "exylon.identity-access.policy-directory@1.0";
  readonly employees: readonly (Readonly<{
      readonly active_work_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
      readonly avatar_url: string | null;
      readonly derived_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "POS")[];
      readonly display_name: string;
      readonly employee_id: string;
      readonly is_manager: boolean;
      readonly is_suspended: boolean;
      readonly job_title: string;
      readonly membership_id: string;
      readonly principal_id: string;
    }>)[];
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly workforce_fingerprint: string;
}>
export type AccessPolicyDirectoryEmployee = Readonly<{
  readonly active_work_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
  readonly avatar_url: string | null;
  readonly derived_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "POS")[];
  readonly display_name: string;
  readonly employee_id: string;
  readonly is_manager: boolean;
  readonly is_suspended: boolean;
  readonly job_title: string;
  readonly membership_id: string;
  readonly principal_id: string;
}>
export type AccessPolicyDirectoryEnvelope = Readonly<{
  readonly result: AccessPolicyDirectory;
  readonly statusCode: number;
  readonly success: true;
}>
export type AccessPolicyDraft = Readonly<{
  readonly active_policy_version: number;
  readonly content: Readonly<{
    readonly manager_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
    readonly memberships: readonly (Readonly<{
        readonly default_workspace_id: "ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY" | null;
        readonly employee_id: string;
        readonly membership_id: string;
        readonly principal_id: string;
        readonly workspace_ids: readonly ("ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY")[];
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.identity-access.policy-draft@1.0";
  readonly draft_revision: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly updated_by: string;
}>
export type AccessPolicyDraftCommandResponse = Readonly<{
  readonly receipt_id: string;
  readonly replayed: boolean;
  readonly result: AccessPolicyDraft;
}>
export type AccessPolicyMembership = Readonly<{
  readonly default_workspace_id: "ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY" | null;
  readonly employee_id: string;
  readonly membership_id: string;
  readonly principal_id: string;
  readonly workspace_ids: readonly ("ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY")[];
}>
export type AccessPolicyReceipt = Readonly<{
  readonly actor_id: string;
  readonly audit_fact_ids: readonly (string)[];
  readonly command_type: "identity.access-policy.draft.replace" | "identity.access-policy.publish" | "identity.access-policy.restore";
  readonly completed_at: string;
  readonly contract: "exylon.identity-access.policy-receipt@1.0";
  readonly event_ids: readonly (string)[];
  readonly outbox_message_ids: readonly (string)[];
  readonly receipt_id: string;
  readonly replayed: boolean;
  readonly restaurant_id: string;
  readonly result: AccessPolicyDraft | AccessPolicyVersion;
  readonly tenant_id: string;
}>
export type AccessPolicyReceiptEnvelope = Readonly<{
  readonly result: AccessPolicyReceipt;
  readonly statusCode: number;
  readonly success: true;
}>
export type AccessPolicyValidation = Readonly<{
  readonly blockers: readonly (Readonly<{
      readonly code: "active_work_requires_workspace" | "based_on_configuration_not_active" | "configuration_fingerprint_changed" | "default_workspace_missing" | "default_workspace_not_assigned" | "derived_workspace_manual_assignment" | "employee_foreign_or_missing" | "employee_inactive" | "employee_membership_missing" | "manager_membership_not_allowed" | "membership_duplicate" | "workspace_duplicate" | "workspace_not_enabled" | "workforce_fingerprint_changed";
      readonly employee_id: string | null;
      readonly membership_id: string | null;
      readonly message: string;
      readonly path: string;
      readonly workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
    }>)[];
  readonly configuration_content_hash: string;
  readonly configuration_publication_version: number;
  readonly content_hash: string;
  readonly contract: "exylon.identity-access.policy-validation@1.0";
  readonly diff: readonly (Readonly<{
      readonly added_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
      readonly employee_id: string;
      readonly membership_id: string;
      readonly next_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
      readonly previous_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
      readonly removed_workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
    }>)[];
  readonly draft_revision: number;
  readonly expected_active_policy_version: number;
  readonly privacy_consequences: readonly (Readonly<{
      readonly disclosure: "employee_personal_compensation_schedule_and_private_performance_data";
      readonly employee_id: string;
      readonly membership_id: string;
      readonly workspace_id: "HR";
    }>)[];
  readonly restaurant_id: string;
  readonly review_hash: string;
  readonly tenant_id: string;
  readonly valid: boolean;
  readonly workforce_fingerprint: string;
}>
export type AccessPolicyValidationEnvelope = Readonly<{
  readonly result: AccessPolicyValidation;
  readonly statusCode: number;
  readonly success: true;
}>
export type AccessPolicyVersion = Readonly<{
  readonly compiled_grants: readonly (Readonly<{
      readonly default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
      readonly employee_id: string;
      readonly membership_id: string;
      readonly membership_version: number;
      readonly principal_id: string;
      readonly workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
    }>)[];
  readonly configuration_content_hash: string;
  readonly configuration_publication_version: number;
  readonly content: Readonly<{
    readonly manager_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
    readonly memberships: readonly (Readonly<{
        readonly default_workspace_id: "ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY" | null;
        readonly employee_id: string;
        readonly membership_id: string;
        readonly principal_id: string;
        readonly workspace_ids: readonly ("ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY")[];
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.identity-access.policy-version@1.0";
  readonly policy_version: number;
  readonly published_at: string;
  readonly published_by: string;
  readonly restaurant_id: string;
  readonly restored_from_policy_version: number | null;
  readonly review_hash: string;
  readonly source_draft_revision: number;
  readonly tenant_id: string;
  readonly workforce_fingerprint: string;
}>
export type AccessPolicyVersionCommandEnvelope = Readonly<{
  readonly result: AccessPolicyVersionCommandResponse;
  readonly statusCode: number;
  readonly success: true;
}>
export type AccessPolicyVersionCommandResponse = Readonly<{
  readonly receipt_id: string;
  readonly replayed: boolean;
  readonly result: AccessPolicyVersion;
}>
export type AccessPolicyVersionList = readonly (AccessPolicyVersion)[]
export type AnswerRelationshipGuestQuestionRequest = Readonly<{
  readonly answer: "yes" | "no" | "bad" | "ok" | "good";
  readonly question_id: string;
  readonly table_session_id: string;
}>
export type ApplyRestaurantConfigurationRequest = Readonly<{
  readonly content: Readonly<{
    readonly departments: readonly (Readonly<{
        readonly active: boolean;
        readonly artwork_key: "kitchen" | "cold-kitchen" | "grill" | "fryer" | "desserts" | "cocktails" | null;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly kind: "kitchen" | "direct_service" | "access";
        readonly location_id: string;
        readonly name: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly width: number;
        readonly workspace_id: "MARKETING" | "LOYALTY" | "CUSTOMER_HISTORY" | "HR" | "INVENTORY" | "ANALYTICS" | "MENU" | "POS" | null;
      }>)[];
    readonly floors: readonly (Readonly<{
        readonly active: boolean;
        readonly canvas_height?: number;
        readonly canvas_width?: number;
        readonly grid_size?: number;
        readonly id: string;
        readonly location_id: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly settings: readonly (RestaurantConfigurationSetting)[];
    readonly tables: readonly (Readonly<{
        readonly active: boolean;
        readonly capacity: number;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly label: string;
        readonly location_id: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly shape?: "rectangular" | "round" | "bar";
        readonly width: number;
      }>)[];
  }>;
  readonly expected_published_version: number;
}> | Readonly<{
  readonly expected_published_version: number;
  readonly layout: Readonly<{
    readonly departments: readonly (Readonly<{
        readonly active: boolean;
        readonly artwork_key: "kitchen" | "cold-kitchen" | "grill" | "fryer" | "desserts" | "cocktails" | null;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly kind: "kitchen" | "direct_service" | "access";
        readonly location_id: string;
        readonly name: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly width: number;
        readonly workspace_id: "MARKETING" | "LOYALTY" | "CUSTOMER_HISTORY" | "HR" | "INVENTORY" | "ANALYTICS" | "MENU" | "POS" | null;
      }>)[];
    readonly floors: readonly (Readonly<{
        readonly active: boolean;
        readonly canvas_height?: number;
        readonly canvas_width?: number;
        readonly grid_size?: number;
        readonly id: string;
        readonly location_id: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly tables: readonly (Readonly<{
        readonly active: boolean;
        readonly capacity: number;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly label: string;
        readonly location_id: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly shape?: "rectangular" | "round" | "bar";
        readonly width: number;
      }>)[];
  }>;
}> | Readonly<{
  readonly expected_published_version: number;
  readonly settings: readonly (Readonly<{
      readonly key: string;
      readonly setting: RestaurantConfigurationSetting | null;
    }>)[];
}>
export type ArchiveOfferDefinitionRequest = Readonly<{
  readonly expected_version: number;
  readonly reason_code?: string;
}>
export type AssignRelationshipRecommendationRequest = Readonly<{
  readonly assigned_at: string;
  readonly catalog_publication_version: number;
  readonly client_session_id: string;
  readonly surface: string;
}>
export type BillingActivateRequest = Readonly<{
  readonly expected_version: number;
  readonly from: string;
}>
export type BillingChargeDisposition = Readonly<{
  readonly disposition: "exylon" | "terminal" | "before_activation" | "no_lines";
  readonly payment_id: string;
}>
export type BillingConfiguration = Readonly<{
  readonly activated_from: string | null;
  readonly checklist: Readonly<{
    readonly compliance: boolean;
    readonly default_tax: boolean;
    readonly establishment: boolean;
    readonly external_terminal: boolean;
    readonly identity: boolean;
    readonly provider: boolean;
  }>;
  readonly compliance: readonly (Readonly<{
      readonly title: string;
      readonly url: string;
    }>)[];
  readonly default_tax_rate_bps: 1000 | null;
  readonly establishment: Readonly<{
    readonly address: string;
    readonly name: string;
  }> | null;
  readonly external_terminal_issuer: "exylon" | "terminal";
  readonly identity: Readonly<{
    readonly fiscal_address: string;
    readonly legal_name: string;
    readonly nif: string;
    readonly regime: "general" | "simplificado";
  }> | null;
  readonly pending: Readonly<{
    readonly count: number;
    readonly oldest_at: string | null;
  }>;
  readonly provider: Readonly<{
    readonly connected: boolean;
    readonly mandate_state: "missing" | "pending" | "signed";
    readonly mandate_url: string | null;
    readonly provider_id: "verifacti" | "fake" | null;
    readonly status: "ok" | "degraded" | "down" | null;
  }>;
  readonly state: "inactive" | "preparing" | "active";
  readonly verifactu: boolean;
  readonly verifactu_locked_until: string | null;
  readonly version: number;
}>
export type BillingConfigurationApplyRequest = Readonly<{
  readonly compliance_acknowledged?: true;
  readonly default_tax_rate_bps?: 1000;
  readonly establishment?: Readonly<{
    readonly address: string;
    readonly name: string;
  }>;
  readonly expected_version: number;
  readonly external_terminal_issuer?: "exylon" | "terminal";
  readonly identity?: Readonly<{
    readonly fiscal_address: string;
    readonly legal_name: string;
    readonly nif: string;
    readonly regime: "general" | "simplificado";
  }>;
  readonly verifactu?: boolean;
}>
export type BillingDocumentsByCheck = Readonly<{
  readonly charge_dispositions: readonly (BillingChargeDisposition)[];
  readonly check_id: string;
  readonly documents: readonly (BillingDocumentSummary)[];
  readonly requests: readonly (BillingRequestSummary)[];
}>
export type BillingDocumentsByChecks = Readonly<{
  readonly checks: readonly (BillingDocumentsByCheck)[];
}>
export type BillingDocumentsByChecksQuery = Readonly<{
  readonly check_ids: readonly (string)[];
}>
export type BillingDocumentSummary = Readonly<{
  readonly communication_state: "pending" | "accepted" | "rejected" | null;
  readonly display_number: string | null;
  readonly held_offline?: true;
  readonly id: string;
  readonly issued_at: string | null;
  readonly kind: "simplificada" | "completa" | "rectificativa";
  readonly operation_at: string;
  readonly pdf_available: boolean;
  readonly recipient: Readonly<{
    readonly legal_name: string;
    readonly nif: string;
  }> | null;
  readonly record_held?: boolean;
  readonly rectifies_document_id?: string | null;
  readonly replaced_by_document_id: string | null;
  readonly replaces_document_id: string | null;
  readonly source: "document" | "intent";
  readonly source_payment_id: string | null;
  readonly state: "pending" | "issued" | "uncertain" | "failed" | "voided";
  readonly total_minor: number;
  readonly verifactu?: boolean;
}>
export type BillingEmissionHealth = Readonly<{
  readonly breaker: "closed" | "open";
  readonly breaker_opened_at: string | null;
  readonly credential: "valid" | "refused";
  readonly credential_refused_at: string | null;
}>
export type BillingExportList = Readonly<{
  readonly exports: readonly (BillingExportSummary)[];
  readonly next: string | null;
}>
export type BillingExportListQuery = Readonly<{
  readonly before?: string;
}>
export type BillingExportPrepareRequest = Readonly<{
  readonly from_day: string;
  readonly purchase_pages?: boolean;
  readonly until_day: string;
}>
export type BillingExportSummary = Readonly<{
  readonly completed_at: string | null;
  readonly formats: readonly ("xlsx" | "csv" | "pdf")[];
  readonly from_day: string;
  readonly id: string;
  readonly includes_invoices: boolean;
  readonly pdf_too_long_rows: number | null;
  readonly provisional: boolean;
  readonly replaces_version: number | null;
  readonly requested_at: string;
  readonly state: "preparing" | "ready" | "failed";
  readonly until_day: string;
  readonly version: number;
}>
export type BillingFiscalIncident = Readonly<{
  readonly class: "two_sales_one_number" | "sale_invoiced_twice" | "repeated_send" | "document_defect" | "display_defect" | "old_nif_uncertain";
  readonly events: readonly (Readonly<{
      readonly at: string;
      readonly note: string;
      readonly state: "open" | "with_gestoria" | "indication_received" | "closed";
    }>)[];
  readonly evidence: Readonly<{
    readonly documents: readonly (Readonly<Record<string, unknown>>)[];
    readonly intents: readonly (Readonly<Record<string, unknown>>)[];
  }>;
  readonly id: string;
  readonly note: string;
  readonly opened_at: string;
  readonly owner: "support" | "support_with_taxpayer";
  readonly state: "open" | "with_gestoria" | "indication_received" | "closed";
  readonly updated_at: string;
}>
export type BillingFiscalIncidentList = Readonly<{
  readonly candidates: readonly (Readonly<{
      readonly class: "two_sales_one_number" | "sale_invoiced_twice" | "repeated_send" | "document_defect" | "display_defect" | "old_nif_uncertain";
      readonly detail: string | null;
      readonly document_ids: readonly (string)[];
      readonly intent_ids: readonly (string)[];
    }>)[];
  readonly incidents: readonly (BillingFiscalIncident)[];
}>
export type BillingFiscalIncidentMoveRequest = Readonly<{
  readonly note: string;
  readonly state: "open" | "with_gestoria" | "indication_received" | "closed";
}>
export type BillingFiscalIncidentRecordRequest = Readonly<{
  readonly class: "two_sales_one_number" | "sale_invoiced_twice" | "repeated_send" | "document_defect" | "display_defect" | "old_nif_uncertain";
  readonly document_ids: readonly (string)[];
  readonly intent_ids: readonly (string)[];
  readonly note: string;
}>
export type BillingIncident = Readonly<{
  readonly check_id: string;
  readonly code: string | null;
  readonly display_number: string | null;
  readonly id: string;
  readonly kind: "simplificada" | "completa" | "rectificativa";
  readonly message: string | null;
  readonly occurred_at: string;
  readonly provider_state: string | null;
  readonly record_held?: boolean;
  readonly reissue?: "recipient" | "same_content" | null;
  readonly retryable_after_fix: boolean;
  readonly state: "pending" | "sent" | "uncertain" | "failed" | "issued";
  readonly subject: "intent" | "document";
  readonly voidable?: boolean;
}>
export type BillingIncidentListQuery = Readonly<{
  readonly before?: string;
}>
export type BillingIncidentPage = Readonly<{
  readonly count: number;
  readonly items: readonly (BillingIncident)[];
  readonly next: string | null;
}>
export type BillingIntentActionRequest = Readonly<{
  readonly reason?: string;
}>
export type BillingIntentCompleteRequest = Readonly<{
  readonly recipient: BillingRecipientInput;
}>
export type BillingIntentReissueRequest = Readonly<{
  readonly recipient?: BillingRecipientInput;
}>
export type BillingInvoiceLink = Readonly<{
  readonly amount_minor: number;
  readonly document: Readonly<{
    readonly display_number: string;
    readonly kind: "simplificada" | "completa" | "rectificativa";
  }> | null;
  readonly operation_date: string;
  readonly replaced_by_complete: boolean;
  readonly restaurant_name: string;
  readonly state: "pending" | "issued" | "voided";
}>
export type BillingInvoiceLinkDocumentQuery = Readonly<{
  readonly paper?: "a4" | "thermal80";
}>
export type BillingIssuerSuccession = Readonly<{
  readonly from_nif: string;
  readonly kind: "merger" | "extinction" | "succession";
  readonly recorded_at: string;
}>
export type BillingIssuerSuccessionRequest = Readonly<{
  readonly from_nif: string;
  readonly kind: "merger" | "extinction" | "succession";
  readonly note: string;
}>
export type BillingLegibleCopy = Readonly<{
  readonly document_id: string;
  readonly paper: "a4" | "thermal80";
  readonly replaces_sha256: string;
  readonly sha256: string;
}>
export type BillingLegibleCopyRequest = Readonly<{
  readonly paper: "a4" | "thermal80";
  readonly reason: string;
}>
export type BillingOfflineIntentsReleaseRequest = Readonly<{
  readonly intent_ids?: readonly (string)[];
}>
export type BillingOfflineIntentsReleaseResult = Readonly<{
  readonly released: readonly (Readonly<{
      readonly intent_id: string;
      readonly operation_at: string;
      readonly payment_id: string;
    }>)[];
  readonly remaining: number;
}>
export type BillingPaymentInvoiceRequest = Readonly<{
  readonly recipient: BillingRecipientInput;
  readonly requester_participant_id?: string;
}>
export type BillingProviderConnectRequest = Readonly<{
  readonly api_key: string;
  readonly mandate_reference?: string;
  readonly provider_id?: "verifacti" | "fake";
}>
export type BillingRecipient = Readonly<{
  readonly fiscal_address: string;
  readonly legal_name: string;
  readonly nif: string;
}> | Readonly<{
  readonly country: string;
  readonly fiscal_address: string;
  readonly id_type: "eu_vat" | "passport" | "foreign_id";
  readonly legal_name: string;
  readonly nif: string;
}>
export type BillingRecipientInput = Readonly<{
  readonly city?: string;
  readonly country?: string;
  readonly fiscal_address?: string;
  readonly id_type?: "nif" | "eu_vat" | "passport" | "foreign_id";
  readonly legal_name: string;
  readonly nif: string;
  readonly postal_code?: string;
  readonly province?: string;
  readonly street?: string;
}>
export type BillingRequestCreateRequest = Readonly<{
  readonly idempotency_key: string;
  readonly kind?: "f3_exchange" | "rectification";
  readonly reason?: string;
  readonly recipient: BillingRecipientInput;
  readonly requester_participant_id?: string;
  readonly source?: "tpv" | "historial";
  readonly target_document_id: string;
}>
export type BillingRequestCreateResult = Readonly<{
  readonly created_at: string;
  readonly document: BillingDocumentSummary | null;
  readonly id: string;
  readonly recipient: BillingRecipient;
  readonly source: "tpv" | "historial" | "guest";
  readonly state: "open" | "issued" | "needs_staff" | "refused";
  readonly target_document_id: string;
}>
export type BillingRequestSummary = Readonly<{
  readonly created_at: string;
  readonly id: string;
  readonly recipient: BillingRecipient;
  readonly source: "tpv" | "historial" | "guest";
  readonly state: "open" | "issued" | "needs_staff" | "refused";
  readonly target_document_id: string;
}>
export type BillingStatusSummary = Readonly<{
  readonly emission?: BillingEmissionHealth;
  readonly external_terminal_invoices?: boolean;
  readonly incidents: Readonly<{
    readonly count: number;
    readonly items: readonly (BillingIncident)[];
  }>;
  readonly invoice_link_base?: string | null;
  readonly offline_held_count: number;
  readonly offline_issue?: "held" | "automatic";
  readonly pending: Readonly<{
    readonly count: number;
    readonly oldest_at: string | null;
  }>;
  readonly provider_status: "ok" | "degraded" | "down" | null;
  readonly simplified_invoice_max_minor: number;
  readonly state: "inactive" | "preparing" | "active";
  readonly verifactu?: boolean;
}>
export type CancelOfferCouponCodeRequest = Readonly<{
  readonly reason_code?: string;
}>
export type CatalogAiCredentialUnavailableHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode: "CATALOG_AI_CREDENTIAL_UNAVAILABLE";
  }>;
  readonly message: string;
  readonly statusCode: 503;
}>
export type CatalogAiDishCopyOption = Readonly<{
  readonly description: string;
  readonly name: string;
}>
export type CatalogAiDishCopyProposalRequest = Readonly<{
  readonly dish_id: string;
  readonly expected_publication_version: number;
  readonly retry_token: string | null;
}>
export type CatalogAiDishCopyProposalResult = Readonly<{
  readonly authoritative: false;
  readonly contract: "exylon.catalog.ai-dish-copy-proposal@1.0";
  readonly options: readonly (Readonly<{
      readonly description: string;
      readonly name: string;
    }>)[];
  readonly published: false;
  readonly request_fingerprint: string;
  readonly retry_token: string;
  readonly retryable: boolean;
  readonly saved: false;
  readonly source_publication_version: number;
  readonly source_recipe_fingerprint: string | null;
  readonly status: "completed" | "invalid_candidate" | "source_unavailable" | "provider_unavailable" | "custody_unavailable" | "indeterminate";
  readonly usage_fact_id: string | null;
}>
export type CatalogAiHelperOperation = "ingredient_autocomplete" | "translation" | "image_enhancement" | "dish_copy"
export type CatalogAiHelperUsageFact = Readonly<{
  readonly actor_id: string;
  readonly contract: "catalog.ai_helper_usage.v1";
  readonly credential_version: number;
  readonly estimated_cost_micros: number;
  readonly fact_id: string;
  readonly input_tokens: number;
  readonly input_units: number;
  readonly occurred_at: string;
  readonly operation: "ingredient_autocomplete" | "translation" | "image_enhancement" | "dish_copy";
  readonly output_tokens: number;
  readonly output_units: number;
  readonly provider: "openai";
  readonly provider_currency: "USD";
  readonly provider_invocation_fingerprint: string;
  readonly request_fingerprint: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogAiPhotoEnhancementPreviewRequest = Readonly<{
  readonly digest: string;
  readonly editor_intent_id: string;
  readonly version: number;
}>
export type CatalogAiPhotoEnhancementProposal = Readonly<{
  readonly alt_text: string;
  readonly byte_size: number;
  readonly content_type: "image/jpeg" | "image/png" | "image/webp";
  readonly editor_intent_id: string;
  readonly expires_at: string;
  readonly height: number;
  readonly media_id: string;
  readonly provisional_version: number;
  readonly sha256_digest: string;
  readonly target: Readonly<{
    readonly entity_id: string;
    readonly entity_type: "category" | "dish" | "modifier_option";
  }>;
  readonly width: number;
}>
export type CatalogAiPhotoEnhancementProposalRequest = Readonly<{
  readonly editor_intent_id: string;
  readonly retry_token: string | null;
  readonly source_media_id: string;
  readonly target: Readonly<{
    readonly entity_id: string;
    readonly entity_type: "category" | "dish" | "modifier_option";
  }>;
}>
export type CatalogAiPhotoEnhancementProposalResult = Readonly<{
  readonly authoritative: false;
  readonly contract: "exylon.catalog.ai-photo-enhancement-proposal@1.0";
  readonly photo_style: "natural" | "taberna" | "mediterraneo" | "brasa" | "gastrobar" | "alta_cocina" | "brunch" | "trattoria" | "minimal";
  readonly prompt_version: number;
  readonly proposal: Readonly<{
    readonly alt_text: string;
    readonly byte_size: number;
    readonly content_type: "image/jpeg" | "image/png" | "image/webp";
    readonly editor_intent_id: string;
    readonly expires_at: string;
    readonly height: number;
    readonly media_id: string;
    readonly provisional_version: number;
    readonly sha256_digest: string;
    readonly target: Readonly<{
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_option";
    }>;
    readonly width: number;
  }> | null;
  readonly request_fingerprint: string;
  readonly retry_token: string;
  readonly retryable: boolean;
  readonly saved: false;
  readonly status: "completed" | "invalid_candidate" | "provider_unavailable" | "custody_unavailable" | "timed_out" | "indeterminate";
  readonly usage_fact_id: string | null;
}>
export type CatalogAiPhotoTarget = Readonly<{
  readonly entity_id: string;
  readonly entity_type: "category" | "dish" | "modifier_option";
}>
export type CatalogAiProviderCredentialDeleteRequest = Readonly<{
  readonly expected_version: number;
  readonly provider: "openai";
}>
export type CatalogAiProviderCredentialReadRequest = Readonly<{
  readonly provider: "openai";
}>
export type CatalogAiProviderCredentialSetRequest = Readonly<{
  readonly credential: string;
  readonly expected_version: number;
  readonly provider: "openai";
}>
export type CatalogAiProviderCredentialStatus = Readonly<{
  readonly capability: "unavailable";
  readonly configured: true;
  readonly contract: "exylon.catalog.ai-provider-credential-status@1.0";
  readonly credential_version: number;
  readonly masked_credential: "********";
  readonly operations: readonly ("ingredient_autocomplete" | "translation" | "image_enhancement" | "dish_copy")[];
  readonly provider: "openai";
  readonly refused: boolean;
  readonly updated_at: string;
}> | Readonly<{
  readonly capability: "unavailable";
  readonly configured: false;
  readonly contract: "exylon.catalog.ai-provider-credential-status@1.0";
  readonly credential_version: 0;
  readonly masked_credential: null;
  readonly operations: readonly ("ingredient_autocomplete" | "translation" | "image_enhancement" | "dish_copy")[];
  readonly provider: "openai";
  readonly refused: false;
  readonly updated_at: null;
}> | Readonly<{
  readonly capability: "unavailable";
  readonly configured: false;
  readonly contract: "exylon.catalog.ai-provider-credential-status@1.0";
  readonly credential_version: number;
  readonly masked_credential: null;
  readonly operations: readonly ("ingredient_autocomplete" | "translation" | "image_enhancement" | "dish_copy")[];
  readonly provider: "openai";
  readonly refused: false;
  readonly updated_at: string;
}> | Readonly<{
  readonly capability: "available";
  readonly configured: true;
  readonly contract: "exylon.catalog.ai-provider-credential-status@1.0";
  readonly credential_version: number;
  readonly masked_credential: "********";
  readonly operations: readonly ["ingredient_autocomplete", "translation", "image_enhancement", "dish_copy"];
  readonly provider: "openai";
  readonly refused: boolean;
  readonly updated_at: string;
}> | Readonly<{
  readonly capability: "available";
  readonly configured: false;
  readonly contract: "exylon.catalog.ai-provider-credential-status@1.0";
  readonly credential_version: 0;
  readonly masked_credential: null;
  readonly operations: readonly ["ingredient_autocomplete", "translation", "image_enhancement", "dish_copy"];
  readonly provider: "openai";
  readonly refused: false;
  readonly updated_at: null;
}> | Readonly<{
  readonly capability: "available";
  readonly configured: false;
  readonly contract: "exylon.catalog.ai-provider-credential-status@1.0";
  readonly credential_version: number;
  readonly masked_credential: null;
  readonly operations: readonly ["ingredient_autocomplete", "translation", "image_enhancement", "dish_copy"];
  readonly provider: "openai";
  readonly refused: false;
  readonly updated_at: string;
}>
export type CatalogAiTranslationEntityType = "category" | "dish" | "modifier_group" | "modifier_option" | "section"
export type CatalogAiTranslationProposal = Readonly<{
  readonly description: string;
  readonly entity_id: string;
  readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
  readonly locale: string;
  readonly name: string;
}>
export type CatalogAiTranslationProposalRequest = Readonly<{
  readonly entity_id: string;
  readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
  readonly retry_token: string | null;
  readonly source_locale: string;
  readonly target_locale: string;
}>
export type CatalogAiTranslationProposalResult = Readonly<{
  readonly authoritative: false;
  readonly contract: "exylon.catalog.ai-translation-proposal@1.0";
  readonly proposal: Readonly<{
    readonly description: string;
    readonly entity_id: string;
    readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
    readonly locale: string;
    readonly name: string;
  }> | null;
  readonly request_fingerprint: string;
  readonly retry_token: string;
  readonly retryable: boolean;
  readonly saved: false;
  readonly status: "completed" | "invalid_candidate" | "provider_unavailable" | "custody_unavailable" | "timed_out" | "indeterminate";
  readonly usage_fact_id: string | null;
}>
export type CatalogAiUsageMonth = Readonly<{
  readonly contract: "exylon.catalog.ai-usage-month@1.0";
  readonly from_inclusive: string;
  readonly groups: readonly (Readonly<{
      readonly estimated_cost_micros: number;
      readonly invocation_count: number;
      readonly operation: "ingredient_autocomplete" | "translation" | "image_enhancement" | "dish_copy";
      readonly provider_currency: "USD";
    }>)[];
  readonly month: string;
  readonly restaurant_id: string;
  readonly timezone: "Europe/Madrid";
  readonly to_exclusive: string;
}>
export type CatalogAiUsageMonthGroup = Readonly<{
  readonly estimated_cost_micros: number;
  readonly invocation_count: number;
  readonly operation: "ingredient_autocomplete" | "translation" | "image_enhancement" | "dish_copy";
  readonly provider_currency: "USD";
}>
export type CatalogAllergen = Readonly<{
  readonly active: boolean;
  readonly code: string;
  readonly description: string;
  readonly id: string;
  readonly name: string;
  readonly version: number;
}>
export type CatalogAuthoringCategory = Readonly<{
  readonly active: boolean;
  readonly department_id?: string | null;
  readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
  readonly featured: boolean;
  readonly icon: string | null;
  readonly id: string;
  readonly internal_name: string;
  readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
  readonly media_object_id: string | null;
  readonly sort_order?: number;
  readonly version: number;
}>
export type CatalogAuthoringContent = Readonly<{
  readonly allergens: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly categories: readonly (Readonly<{
      readonly active: boolean;
      readonly department_id?: string | null;
      readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
      readonly featured: boolean;
      readonly icon: string | null;
      readonly id: string;
      readonly internal_name: string;
      readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
      readonly media_object_id: string | null;
      readonly sort_order?: number;
      readonly version: number;
    }>)[];
  readonly diet_tags: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly dish_allergens: readonly (Readonly<{
      readonly allergen_id: string;
      readonly dish_id: string;
      readonly presence: "contains" | "may_contain";
      readonly source: "manual";
    }>)[];
  readonly dish_media: readonly (Readonly<{
      readonly dish_id: string;
      readonly media_object_id: string;
      readonly sort_order: number;
    }>)[];
  readonly dish_modifier_groups: readonly (Readonly<{
      readonly dish_id: string;
      readonly modifier_group_id: string;
      readonly sort_order: number;
    }>)[];
  readonly dish_sensory_profiles: readonly (Readonly<{
      readonly basis_version: string;
      readonly confidence: number;
      readonly coverage: number;
      readonly density_defaulted: boolean;
      readonly derivation_status: "available" | "unavailable";
      readonly dimensions: readonly (Readonly<{
          readonly confidence: number;
          readonly dimension_code: string;
          readonly dimension_label?: string;
          readonly group_code?: string;
          readonly group_label?: string;
          readonly ingredient_score: number;
          readonly layers: Readonly<{
            readonly base: number;
            readonly preparation: number;
            readonly seasoning: number;
          }>;
          readonly preparation_delta: number;
          readonly score: number;
          readonly sources: readonly (Readonly<{
              readonly confidence: number;
              readonly contribution: number;
              readonly source_code: string;
              readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
            }>)[];
        }>)[];
      readonly dish_id: string;
      readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
      readonly flavour_tags: readonly (Readonly<{
          readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
          readonly confidence: number;
          readonly dominant_layer: "base" | "preparation" | "seasoning";
          readonly score: number;
        }>)[];
      readonly input_fingerprint: string;
      readonly profile_version: number;
      readonly provenance: string;
      readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
    }>)[];
  readonly dishes: readonly (Readonly<{
      readonly active: boolean;
      readonly available: boolean;
      readonly bottle_dish_id?: string | null;
      readonly category_id: string;
      readonly currency: "EUR";
      readonly id: string;
      readonly internal_name: string;
      readonly preparation_time_minutes: number | null;
      readonly price_minor: number;
      readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
      readonly seasoning_style_codes: readonly (string)[];
      readonly sort_order?: number;
      readonly star_dish?: boolean;
      readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
      readonly version: number;
    }>)[];
  readonly ingredient_allergens: readonly (Readonly<{
      readonly allergen_id: string;
      readonly ingredient_id: string;
      readonly presence: "contains" | "may_contain";
      readonly provenance: string;
      readonly version: number;
    }>)[];
  readonly ingredient_concept_mappings: readonly (Readonly<{
      readonly allergen_coverage: "verified" | "incomplete" | "unknown";
      readonly concept_id: string | null;
      readonly coverage: "verified" | "incomplete" | "unknown";
      readonly diet_coverage: "verified" | "incomplete" | "unknown";
      readonly ingredient_id: string;
      readonly provenance: string;
      readonly registry_version: number;
      readonly version: number;
    }>)[];
  readonly ingredient_diet_properties: readonly (Readonly<{
      readonly conflicts: boolean;
      readonly diet_tag_id: string;
      readonly explanation: string;
      readonly ingredient_id: string;
      readonly property_code: string;
      readonly provenance: string;
      readonly version: number;
    }>)[];
  readonly ingredient_sensory_profiles: readonly (Readonly<{
      readonly basis_version: string;
      readonly confidence: number;
      readonly dimensions: readonly (Readonly<{
          readonly confidence: number;
          readonly dimension_code: string;
          readonly score: number;
        }>)[];
      readonly ingredient_id: string;
      readonly profile_version: number;
      readonly provenance: string;
    }>)[];
  readonly ingredients: readonly (Readonly<{
      readonly active: boolean;
      readonly base_unit_code: string;
      readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
      readonly density_g_per_ml: number | null;
      readonly description: string;
      readonly id: string;
      readonly mass_per_unit_mg: number | null;
      readonly name: string;
      readonly seasoning_signature: readonly (Readonly<{
          readonly delta: number;
          readonly dimension_code: string;
        }>)[];
      readonly version: number;
    }>)[];
  readonly media_objects: readonly (CatalogMediaObject)[];
  readonly modifier_group_options: readonly (Readonly<{
      readonly is_default: boolean;
      readonly modifier_group_id: string;
      readonly modifier_option_id: string;
      readonly sort_order: number;
    }>)[];
  readonly modifier_groups: readonly (Readonly<{
      readonly available: boolean;
      readonly course_codes: readonly (string)[];
      readonly id: string;
      readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
      readonly name: string;
      readonly selection_max: number;
      readonly selection_min: number;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly modifier_option_allergens: readonly (Readonly<{
      readonly allergen_id: string;
      readonly modifier_option_id: string;
      readonly presence: "contains" | "may_contain";
      readonly source: "manual";
    }>)[];
  readonly modifier_option_ingredients: readonly (Readonly<{
      readonly ingredient_id: string;
      readonly inventory_rule: "deducts" | "inform_only";
      readonly modifier_option_id: string;
      readonly quantity_base_units: number;
      readonly unit_code: string;
    }>)[];
  readonly modifier_options: readonly (Readonly<{
      readonly adds_no_ingredients?: true;
      readonly available: boolean;
      readonly currency: "EUR";
      readonly id: string;
      readonly media_object_id: string | null;
      readonly name: string;
      readonly price_delta_minor: number;
      readonly version: number;
    }>)[];
  readonly preparation_choices: readonly (Readonly<{
      readonly available: boolean;
      readonly code: string;
      readonly default_selected: boolean;
      readonly dish_id: string;
      readonly id: string;
      readonly name: string;
      readonly semantic_provenance: string;
      readonly semantic_version: number;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly preparation_sensory_modifiers: readonly (Readonly<{
      readonly basis_version: string;
      readonly confidence: number;
      readonly dimension_code: string;
      readonly modifier: number;
      readonly preparation_code: string;
      readonly preparation_semantic_version: number;
      readonly provenance: string;
    }>)[];
  readonly recipe_lines: readonly (Readonly<{
      readonly dish_id: string;
      readonly ingredient_id: string;
      readonly inventory_rule: "deducts" | "inform_only";
      readonly preparation_code: string | null;
      readonly quantity_base_units: number;
      readonly recipe_version: number;
      readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
      readonly unit_code: string;
    }>)[];
  readonly safety_registry_version: number;
  readonly seasoning_style_modifiers: readonly (Readonly<{
      readonly basis_version: string;
      readonly confidence: number;
      readonly dimension_code: string;
      readonly modifier: number;
      readonly provenance: string;
      readonly seasoning_style_code: string;
    }>)[];
  readonly section_categories: readonly (Readonly<{
      readonly category_id: string;
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly sections: readonly (Readonly<{
      readonly available: boolean;
      readonly id: string;
      readonly internal_name: string;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly sensory_bases: readonly (Readonly<{
      readonly basis_version: string;
      readonly provenance: string;
      readonly status: "active" | "retired";
      readonly version: number;
    }>)[];
  readonly sensory_dimensions: readonly (Readonly<{
      readonly basis_version: string;
      readonly code: string;
      readonly dimension_label?: string;
      readonly group_code: string;
      readonly group_label?: string;
      readonly name: string;
      readonly sort_order: number;
    }>)[];
  readonly served_form_sensory_modifiers: readonly (Readonly<{
      readonly basis_version: string;
      readonly confidence: number;
      readonly dimension_code: string;
      readonly modifier: number;
      readonly preparation_code: string;
      readonly provenance: string;
    }>)[];
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
  readonly unit_definitions: readonly (Readonly<{
      readonly denominator_to_base: number;
      readonly dimension: "mass" | "volume" | "count";
      readonly numerator_to_base: number;
      readonly unit_code: string;
      readonly version: number;
    }>)[];
}>
export type CatalogAuthoringDish = Readonly<{
  readonly active: boolean;
  readonly available: boolean;
  readonly bottle_dish_id?: string | null;
  readonly category_id: string;
  readonly currency: "EUR";
  readonly id: string;
  readonly internal_name: string;
  readonly preparation_time_minutes: number | null;
  readonly price_minor: number;
  readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
  readonly seasoning_style_codes: readonly (string)[];
  readonly sort_order?: number;
  readonly star_dish?: boolean;
  readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
  readonly version: number;
}>
export type CatalogBridgeDraftQuery = Readonly<{
  readonly action?: string;
  readonly category_id?: string;
  readonly category_ids?: string;
  readonly diet_code?: string;
  readonly dish_id?: string;
  readonly dish_ids?: string;
  readonly expected_published_version?: string;
  readonly expected_revision?: string;
  readonly field?: string;
  readonly form: "catalog.draft.replace";
  readonly inventory_rule?: string;
  readonly is_default?: string;
  readonly option_id?: string;
  readonly position_in_category?: string;
  readonly preparation_time_minutes?: string;
  readonly price_minor?: string;
  readonly stock_item_id?: string;
}>
export type CatalogBridgeMediaQuery = Readonly<{
  readonly dish_ids?: string;
  readonly form: "catalog.media.write";
  readonly intent?: string;
}>
export type CatalogBridgePublishQuery = Readonly<{
  readonly expected_revision?: string;
  readonly form: "catalog.publish";
}>
export type CatalogBridgeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.catalog.bridge-revalidation@1.0";
  readonly form: "catalog.draft.replace" | "catalog.media.write" | "catalog.publish";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{ readonly [key: string]: string | number | boolean | readonly (string)[] | readonly (number)[] }>;
  readonly verdict: "open" | "refused";
}>
export type CatalogCartaChangeReceipt = Readonly<{
  readonly action: "apply" | "undo";
  readonly applied_at: string;
  readonly change_id: string;
  readonly content_hash: string;
  readonly contract: "exylon.catalog.carta-change-receipt@1.0";
  readonly dish_id: string;
  readonly draft_revision: number;
  readonly effect: Readonly<{
    readonly after_order: readonly (string)[];
    readonly before_order: readonly (string)[];
    readonly category_id: string;
    readonly kind: "dish_order";
  }> | Readonly<{
    readonly after_selection_min: number;
    readonly before_selection_min: number;
    readonly kind: "modifier_required";
    readonly modifier_group_id: string;
  }> | Readonly<{
    readonly after_active: boolean;
    readonly allergen_codes: readonly (string)[];
    readonly before_active: boolean;
    readonly kind: "trial_dish";
    readonly recipe_lines: number;
    readonly trial_date?: string;
  }> | Readonly<{
    readonly after_name: string;
    readonly before_name: string;
    readonly kind: "dish_name";
    readonly locale: string;
  }> | Readonly<{
    readonly after_description: string;
    readonly before_description: string;
    readonly kind: "dish_description";
    readonly locale: string;
  }> | Readonly<{
    readonly after_price_minor: number;
    readonly before_price_minor: number;
    readonly kind: "dish_price";
  }> | Readonly<{
    readonly after_active: boolean;
    readonly before_active: boolean;
    readonly kind: "dish_hidden";
  }> | Readonly<{
    readonly dishes: readonly (Readonly<{
        readonly allergen_codes: readonly (string)[];
        readonly dish_id: string;
        readonly recipe_fingerprint: string;
        readonly recipe_lines: number;
      }>)[];
    readonly kind: "dish_recipes";
  }>;
  readonly prior_publication_version: number;
  readonly publication_version: number;
  readonly restaurant_id: string;
}>
export type CatalogCartaChangeUndoRequest = Readonly<{
  readonly receipt: CatalogCartaChangeReceipt;
}>
export type CatalogCartaFisicaChoice = Readonly<{
  readonly colour: string;
  readonly cover: string;
  readonly language: "es" | "en";
  readonly photos: "none" | "stars" | "all";
  readonly phrase: string | null;
  readonly show_allergens: boolean;
  readonly show_descriptions: boolean;
  readonly style: "futura" | "oyster";
}>
export type CatalogCartaFisicaDocumentRequest = Readonly<{
  readonly choice: Readonly<{
    readonly colour: string;
    readonly cover: string;
    readonly language: "es" | "en";
    readonly photos: "none" | "stars" | "all";
    readonly phrase: string | null;
    readonly show_allergens: boolean;
    readonly show_descriptions: boolean;
    readonly style: "futura" | "oyster";
  }>;
  readonly output: "casa" | "imprenta" | "mascara-oro";
}>
export type CatalogCartaFisicaFit = Readonly<{
  readonly columns: number;
  readonly format: "a4-doblado" | "a3-doblado";
  readonly panels: readonly (number)[];
  readonly step: number;
}>
export type CatalogCartaFisicaPreview = Readonly<{
  readonly choice: Readonly<{
    readonly colour: string;
    readonly cover: string;
    readonly language: "es" | "en";
    readonly photos: "none" | "stars" | "all";
    readonly phrase: string | null;
    readonly show_allergens: boolean;
    readonly show_descriptions: boolean;
    readonly style: "futura" | "oyster";
  }>;
  readonly contract: "exylon.catalog.carta-fisica-preview@1.0";
  readonly fit: Readonly<{
    readonly columns: number;
    readonly format: "a4-doblado" | "a3-doblado";
    readonly panels: readonly (number)[];
    readonly step: number;
  }>;
  readonly page_size_mm: Readonly<{
    readonly height: number;
    readonly width: number;
  }>;
  readonly pages: readonly (Readonly<{
      readonly image_data_url: string;
      readonly role: "cover" | "inside-left" | "inside-right" | "back";
    }>)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly size: "large" | "thumbnail";
  readonly untranslated_dish_count: number;
}>
export type CatalogCartaFisicaPreviewRequest = Readonly<{
  readonly choice: Readonly<{
    readonly colour: string;
    readonly cover: string;
    readonly language: "es" | "en";
    readonly photos: "none" | "stars" | "all";
    readonly phrase: string | null;
    readonly show_allergens: boolean;
    readonly show_descriptions: boolean;
    readonly style: "futura" | "oyster";
  }>;
  readonly size: "large" | "thumbnail";
}>
export type CatalogCartaFisicaState = Readonly<{
  readonly contract: "exylon.catalog.carta-fisica-state@1.0";
  readonly default_choice: Readonly<{
    readonly colour: string;
    readonly cover: string;
    readonly language: "es" | "en";
    readonly photos: "none" | "stars" | "all";
    readonly phrase: string | null;
    readonly show_allergens: boolean;
    readonly show_descriptions: boolean;
    readonly style: "futura" | "oyster";
  }>;
  readonly english: Readonly<{
    readonly available: boolean;
    readonly untranslated_dish_count: number;
  }>;
  readonly has_logo: boolean;
  readonly printable_dish_count: number;
  readonly publication: Readonly<{
    readonly edition_date: string;
    readonly version: number;
  }> | null;
  readonly recommended_style: "futura" | "oyster";
  readonly restaurant_id: string;
  readonly saved_choice: Readonly<{
    readonly colour: string;
    readonly cover: string;
    readonly language: "es" | "en";
    readonly photos: "none" | "stars" | "all";
    readonly phrase: string | null;
    readonly show_allergens: boolean;
    readonly show_descriptions: boolean;
    readonly style: "futura" | "oyster";
  }> | null;
  readonly styles: readonly (Readonly<{
      readonly colours: readonly (Readonly<{
          readonly dark: boolean;
          readonly id: string;
          readonly label: string;
        }>)[];
      readonly covers: readonly (Readonly<{
          readonly id: string;
          readonly label: string;
          readonly thumbnail_data_url: string;
        }>)[];
      readonly default_cover: string;
      readonly gold_mask: boolean;
      readonly home_colour: string;
      readonly home_paper: string;
      readonly id: "futura" | "oyster";
      readonly name: string;
      readonly print_shop_note: string;
    }>)[];
}>
export type CatalogCategory = Readonly<{
  readonly active: boolean;
  readonly department_id?: string | null;
  readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
  readonly featured: boolean;
  readonly icon: string | null;
  readonly id: string;
  readonly internal_name: string;
  readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
  readonly media_object_id: string | null;
  readonly sort_order: number;
  readonly version: number;
}>
export type CatalogDailySuggestion = Readonly<{
  readonly contract: "exylon.catalog.dish-daily-suggestion@1.0";
  readonly dish_id: string;
  readonly from_date: string;
  readonly restaurant_id: string;
  readonly set_at: string;
  readonly source: "manager" | "parte";
  readonly state: "active" | "withdrawn";
  readonly suggestion_id: string;
  readonly to_date: string;
  readonly version: number;
  readonly withdrawn_at: string | null;
}>
export type CatalogDailySuggestionList = Readonly<{
  readonly contract: "exylon.catalog.dish-daily-suggestion-list@1.0";
  readonly daily_limit: number;
  readonly items: readonly (CatalogDailySuggestion)[];
  readonly local_date: string;
}>
export type CatalogDailySuggestionSetRequest = Readonly<{
  readonly dish_id: string;
  readonly from_date: string;
  readonly suggestion_id: string;
  readonly to_date: string;
}>
export type CatalogDailySuggestionWithdrawRequest = Readonly<Record<never, never>>
export type CatalogDietaryAssessment = Readonly<{
  readonly confidence: number;
  readonly coverage: number;
  readonly diet_tag_id: string;
  readonly dish_id: string;
  readonly explanation: string;
  readonly input_fingerprint: string;
  readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
  readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
  readonly version: number;
}>
export type CatalogDietTag = Readonly<{
  readonly active: boolean;
  readonly code: string;
  readonly description: string;
  readonly id: string;
  readonly name: string;
  readonly version: number;
}>
export type CatalogDish = Readonly<{
  readonly active: boolean;
  readonly available: boolean;
  readonly bottle_dish_id?: string | null;
  readonly category_id: string;
  readonly currency: "EUR";
  readonly id: string;
  readonly internal_name: string;
  readonly preparation_time_minutes: number | null;
  readonly price_minor: number;
  readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
  readonly seasoning_style_codes: readonly (string)[];
  readonly sort_order: number;
  readonly star_dish?: boolean;
  readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
  readonly version: number;
}>
export type CatalogDishCopyApplied = Readonly<{
  readonly change: CatalogDishCopyChange;
  readonly source_receipt_id: string;
}>
export type CatalogDishCopyApplyRequest = Readonly<{
  readonly review: CatalogDishCopyReview;
}>
export type CatalogDishCopyChange = Readonly<{
  readonly action: "apply" | "undo";
  readonly applied_draft_revision: number;
  readonly change_hash: string;
  readonly contract: "exylon.catalog.dish-copy-change@1.0";
  readonly published: false;
  readonly review: CatalogDishCopyReview;
}>
export type CatalogDishCopyReview = Readonly<{
  readonly after: Readonly<{
    readonly description: string;
    readonly name: string;
  }>;
  readonly authoritative: false;
  readonly before: Readonly<{
    readonly description: string;
    readonly name: string;
  }>;
  readonly changed_fields: readonly ("name" | "description")[];
  readonly contract: "exylon.catalog.dish-copy-review@1.0";
  readonly dish_id: string;
  readonly dish_version: number;
  readonly draft_revision: number;
  readonly locale: string;
  readonly published: false;
  readonly published_version: number;
  readonly recipe_fingerprint: string;
  readonly restaurant_id: string;
  readonly review_hash: string;
  readonly tenant_id: string;
}>
export type CatalogDishCopyReviewRequest = Readonly<{
  readonly after: Readonly<{
    readonly description: string;
    readonly name: string;
  }>;
  readonly dish_id: string;
  readonly expected_dish_version: number;
  readonly expected_draft_revision: number;
  readonly expected_published_version: number;
  readonly locale: string;
}>
export type CatalogDishCopyUndoRequest = Readonly<{
  readonly change: CatalogDishCopyChange;
  readonly receipt?: CatalogReviewedPublicationReceipt;
}>
export type CatalogDishDerivationPreview = Readonly<{
  readonly authoritative: false;
  readonly contract: "exylon.catalog.dish-derivation-preview@1.0";
  readonly dish_id: string;
  readonly draft_revision: number;
  readonly findings: readonly (Readonly<{
      readonly code: string;
      readonly message: string;
      readonly path: string;
    }>)[];
  readonly ingredients: readonly (Readonly<{
      readonly in_draft: boolean;
      readonly ingredient_id: string;
      readonly name: string;
    }>)[];
  readonly safety: Readonly<{
    readonly allergen_coverage: "verified" | "incomplete" | "unknown";
    readonly allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly inherited_ingredient_ids: readonly (string)[];
        readonly manual_caution: boolean;
        readonly presence: "contains" | "may_contain";
      }>)[];
    readonly contract: "exylon.catalog.safety-derivation@1.0";
    readonly coverage: "verified" | "incomplete" | "unknown";
    readonly derivation_fingerprint: string;
    readonly diet_coverage: "verified" | "incomplete" | "unknown";
    readonly diets: readonly (Readonly<{
        readonly contradictory_ingredient_ids: readonly (string)[];
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly diet_tag_id: string;
        readonly status: "verified" | "conflict" | "incomplete" | "unknown";
        readonly unverified_ingredient_ids: readonly (string)[];
      }>)[];
    readonly ingredient_inputs: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly allergen_fact_versions: readonly (Readonly<{
            readonly allergen_id: string;
            readonly presence: "contains" | "may_contain";
            readonly version: number;
          }>)[];
        readonly concept_id: string | null;
        readonly concept_version: number | null;
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly diet_fact_versions: readonly (Readonly<{
            readonly conflicts: boolean;
            readonly diet_tag_id: string;
            readonly version: number;
          }>)[];
        readonly ingredient_id: string;
        readonly ingredient_version: number;
        readonly mapping_version: number | null;
        readonly provenance: string;
      }>)[];
    readonly input_fingerprint: string;
    readonly registry_fingerprint: string;
    readonly registry_version: number;
    readonly subject_id: string;
    readonly subject_type: "dish" | "modifier_option";
    readonly unverified_allergen_ids: readonly (string)[];
  }>;
  readonly saved: false;
  readonly sensory: Readonly<{
    readonly basis_version: string;
    readonly confidence: number;
    readonly coverage: number;
    readonly density_defaulted: boolean;
    readonly derivation_status: "available" | "unavailable";
    readonly dimensions: readonly (Readonly<{
        readonly confidence: number;
        readonly dimension_code: string;
        readonly dimension_label?: string;
        readonly group_code?: string;
        readonly group_label?: string;
        readonly ingredient_score: number;
        readonly layers: Readonly<{
          readonly base: number;
          readonly preparation: number;
          readonly seasoning: number;
        }>;
        readonly preparation_delta: number;
        readonly score: number;
        readonly sources: readonly (Readonly<{
            readonly confidence: number;
            readonly contribution: number;
            readonly source_code: string;
            readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
          }>)[];
      }>)[];
    readonly dish_id: string;
    readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
    readonly flavour_tags: readonly (Readonly<{
        readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
        readonly confidence: number;
        readonly dominant_layer: "base" | "preparation" | "seasoning";
        readonly score: number;
      }>)[];
    readonly input_fingerprint: string;
    readonly profile_version: number;
    readonly provenance: string;
    readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
  }> | null;
}>
export type CatalogDishDerivationPreviewRequest = Readonly<{
  readonly dish_id: string;
  readonly lines: readonly (Readonly<{
      readonly ingredient_id: string;
      readonly inventory_rule?: "deducts" | "inform_only";
      readonly preparation_code: string | null;
      readonly quantity_base_units: number;
      readonly role?: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
    }>)[];
  readonly manual_allergens: readonly (Readonly<{
      readonly allergen_id: string;
      readonly presence: "contains" | "may_contain";
    }>)[];
  readonly seasoning_style_codes: readonly (string)[];
}>
export type CatalogDishFlavourTag = Readonly<{
  readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
  readonly confidence: number;
  readonly dominant_layer: "base" | "preparation" | "seasoning";
  readonly score: number;
}>
export type CatalogDishNameApplyRequest = Readonly<{
  readonly option: number;
}>
export type CatalogDishNameSuggestion = Readonly<{
  readonly applied_at: string | null;
  readonly applied_option: number | null;
  readonly before: Readonly<{
    readonly description: string;
    readonly name: string;
  }> | null;
  readonly contract: "exylon.catalog.dish-name-suggestion@1.0";
  readonly dish_id: string;
  readonly expires_at: string;
  readonly locale: string | null;
  readonly options: readonly (Readonly<{
      readonly description: string;
      readonly name: string;
    }>)[];
  readonly publication_version: number | null;
  readonly reason: "not_configured" | "budget_exhausted" | "provider_unavailable" | "invalid_candidate" | "source_unavailable" | "indeterminate" | "source_changed" | null;
  readonly receipt: CatalogReviewedPublicationReceipt | null;
  readonly recipe_fingerprint: string | null;
  readonly requested_at: string;
  readonly restaurant_id: string;
  readonly source_case: "meeting";
  readonly source_id: string;
  readonly state: "requested" | "preparing" | "prepared" | "unavailable" | "applied" | "undone";
  readonly suggestion_id: string;
  readonly undo_receipt: CatalogReviewedPublicationReceipt | null;
  readonly undo_until: string | null;
  readonly updated_at: string;
  readonly version: number;
}>
export type CatalogDishNameSuggestionList = Readonly<{
  readonly contract: "exylon.catalog.dish-name-suggestion-list@1.0";
  readonly items: readonly (CatalogDishNameSuggestion)[];
}>
export type CatalogDishNameUndoRequest = Readonly<Record<never, never>>
export type CatalogDishPromotionPreview = Readonly<{
  readonly badge?: string;
  readonly badge_label: string;
  readonly benefit_kind: "percentage" | "fixed_amount" | "free_item" | "buy_x_get_y";
  readonly buy_quantity: number;
  readonly conditions: Readonly<{
    readonly feedback_only: boolean;
    readonly loyalty_tier_id: string | null;
    readonly minimum_party_size: number;
    readonly minimum_subtotal_minor: number;
    readonly new_guest_only: boolean;
    readonly weekdays: readonly (number)[];
  }>;
  readonly contract: "exylon.catalog.dish-promotion-preview@1.0";
  readonly currency: "EUR";
  readonly display_price_minor: number;
  readonly free_dish?: boolean;
  readonly original_price_minor: number;
  readonly reward_quantity: number;
  readonly show_compare_at_price: boolean;
}>
export type CatalogDishProposalApplication = Readonly<{
  readonly contract: "exylon.catalog.dish-proposal-application@1.0";
  readonly created: boolean;
  readonly dish_id: string;
  readonly draft: CatalogDraft;
  readonly materialized_ingredient_ids: readonly (string)[];
  readonly outcome_count: number;
  readonly proposal_id: string;
}>
export type CatalogDishProposalApplyRequest = Readonly<{
  readonly dish: Readonly<{
    readonly category_id: string;
    readonly currency: "EUR";
    readonly description: string;
    readonly id: string;
    readonly name: string;
    readonly price_minor: number;
    readonly seasoning_style_codes: readonly (string)[];
  }>;
  readonly editor_intent_id: string;
  readonly lines: readonly (Readonly<{
      readonly ingredient_id: string;
      readonly preparation_code: string | null;
      readonly quantity_base_units: number;
      readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
      readonly search_term: string | null;
      readonly source: Readonly<{
        readonly kind: "proposal";
        readonly line_id: string;
      }> | Readonly<{
        readonly kind: "unmatched";
        readonly line_id: string;
      }> | Readonly<{
        readonly kind: "manual";
      }>;
    }>)[];
  readonly photo: Readonly<{
    readonly expected_version: number;
    readonly media_id: string;
    readonly sha256_digest: string;
  }> | null;
}>
export type CatalogDishSensoryProfile = Readonly<{
  readonly basis_version: string;
  readonly confidence: number;
  readonly coverage: number;
  readonly density_defaulted: boolean;
  readonly derivation_status: "available" | "unavailable";
  readonly dimensions: readonly (Readonly<{
      readonly confidence: number;
      readonly dimension_code: string;
      readonly dimension_label?: string;
      readonly group_code?: string;
      readonly group_label?: string;
      readonly ingredient_score: number;
      readonly layers: Readonly<{
        readonly base: number;
        readonly preparation: number;
        readonly seasoning: number;
      }>;
      readonly preparation_delta: number;
      readonly score: number;
      readonly sources: readonly (Readonly<{
          readonly confidence: number;
          readonly contribution: number;
          readonly source_code: string;
          readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
        }>)[];
    }>)[];
  readonly dish_id: string;
  readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
  readonly flavour_tags: readonly (Readonly<{
      readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
      readonly confidence: number;
      readonly dominant_layer: "base" | "preparation" | "seasoning";
      readonly score: number;
    }>)[];
  readonly input_fingerprint: string;
  readonly profile_version: number;
  readonly provenance: string;
  readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
}>
export type CatalogDishSensoryProfileSummary = Readonly<{
  readonly basis_version: string;
  readonly derivation_status: "available" | "unavailable";
  readonly dish_id: string;
  readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
  readonly flavour_tags: readonly (Readonly<{
      readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
      readonly confidence: number;
      readonly dominant_layer: "base" | "preparation" | "seasoning";
      readonly score: number;
    }>)[];
  readonly input_fingerprint: string;
  readonly profile_version: number;
}>
export type CatalogDishTrial = Readonly<{
  readonly answered_at: string | null;
  readonly contract: "exylon.catalog.dish-trial@1.0";
  readonly dish_id: string;
  readonly dish_name: string;
  readonly opened_at: string;
  readonly restaurant_id: string;
  readonly state: "pending" | "passed" | "failed" | "withdrawn" | "unanswered";
  readonly trial_date: string;
  readonly trial_id: string;
  readonly version: number;
}>
export type CatalogDishTrialAnswerRequest = Readonly<{
  readonly outcome: "passed" | "failed";
}>
export type CatalogDishTrialList = Readonly<{
  readonly contract: "exylon.catalog.dish-trial-list@1.0";
  readonly items: readonly (CatalogDishTrial)[];
  readonly local_date: string;
}>
export type CatalogDraft = Readonly<{
  readonly content: Readonly<{
    readonly allergens: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly categories: readonly (Readonly<{
        readonly active: boolean;
        readonly department_id?: string | null;
        readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
        readonly featured: boolean;
        readonly icon: string | null;
        readonly id: string;
        readonly internal_name: string;
        readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
        readonly media_object_id: string | null;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly diet_tags: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly dietary_assessments: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly dish_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly dish_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly dish_diet_tags: readonly (Readonly<{
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly source: "manual" | "deterministic";
      }>)[];
    readonly dish_media: readonly (Readonly<{
        readonly dish_id: string;
        readonly media_object_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_modifier_groups: readonly (Readonly<{
        readonly dish_id: string;
        readonly modifier_group_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_sensory_profiles: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly coverage: number;
        readonly density_defaulted: boolean;
        readonly derivation_status: "available" | "unavailable";
        readonly dimensions: readonly (Readonly<{
            readonly confidence: number;
            readonly dimension_code: string;
            readonly dimension_label?: string;
            readonly group_code?: string;
            readonly group_label?: string;
            readonly ingredient_score: number;
            readonly layers: Readonly<{
              readonly base: number;
              readonly preparation: number;
              readonly seasoning: number;
            }>;
            readonly preparation_delta: number;
            readonly score: number;
            readonly sources: readonly (Readonly<{
                readonly confidence: number;
                readonly contribution: number;
                readonly source_code: string;
                readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
              }>)[];
          }>)[];
        readonly dish_id: string;
        readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
        readonly flavour_tags: readonly (Readonly<{
            readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
            readonly confidence: number;
            readonly dominant_layer: "base" | "preparation" | "seasoning";
            readonly score: number;
          }>)[];
        readonly input_fingerprint: string;
        readonly profile_version: number;
        readonly provenance: string;
        readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
      }>)[];
    readonly dishes: readonly (Readonly<{
        readonly active: boolean;
        readonly available: boolean;
        readonly bottle_dish_id?: string | null;
        readonly category_id: string;
        readonly currency: "EUR";
        readonly id: string;
        readonly internal_name: string;
        readonly preparation_time_minutes: number | null;
        readonly price_minor: number;
        readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
        readonly seasoning_style_codes: readonly (string)[];
        readonly sort_order: number;
        readonly star_dish?: boolean;
        readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
        readonly version: number;
      }>)[];
    readonly ingredient_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly ingredient_id: string;
        readonly presence: "contains" | "may_contain";
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_concept_mappings: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly concept_id: string | null;
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly ingredient_id: string;
        readonly provenance: string;
        readonly registry_version: number;
        readonly version: number;
      }>)[];
    readonly ingredient_diet_properties: readonly (Readonly<{
        readonly conflicts: boolean;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly ingredient_id: string;
        readonly property_code: string;
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_sensory_profiles: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimensions: readonly (Readonly<{
            readonly confidence: number;
            readonly dimension_code: string;
            readonly score: number;
          }>)[];
        readonly ingredient_id: string;
        readonly profile_version: number;
        readonly provenance: string;
      }>)[];
    readonly ingredients: readonly (Readonly<{
        readonly active: boolean;
        readonly base_unit_code: string;
        readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly density_g_per_ml: number | null;
        readonly description: string;
        readonly id: string;
        readonly mass_per_unit_mg: number | null;
        readonly name: string;
        readonly seasoning_signature: readonly (Readonly<{
            readonly delta: number;
            readonly dimension_code: string;
          }>)[];
        readonly version: number;
      }>)[];
    readonly media_objects: readonly (CatalogMediaObject)[];
    readonly menu_items: readonly (Readonly<{
        readonly available: boolean;
        readonly dish_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_group_options: readonly (Readonly<{
        readonly is_default: boolean;
        readonly modifier_group_id: string;
        readonly modifier_option_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_groups: readonly (Readonly<{
        readonly available: boolean;
        readonly course_codes: readonly (string)[];
        readonly id: string;
        readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
        readonly name: string;
        readonly selection_max: number;
        readonly selection_min: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly modifier_option_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly modifier_option_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly modifier_option_dietary_assessments: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly modifier_option_id: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly modifier_option_ingredients: readonly (Readonly<{
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly modifier_option_id: string;
        readonly quantity_base_units: number;
        readonly unit_code: string;
      }>)[];
    readonly modifier_options: readonly (Readonly<{
        readonly adds_no_ingredients?: true;
        readonly available: boolean;
        readonly currency: "EUR";
        readonly id: string;
        readonly media_object_id: string | null;
        readonly name: string;
        readonly price_delta_minor: number;
        readonly version: number;
      }>)[];
    readonly preparation_choices: readonly (Readonly<{
        readonly available: boolean;
        readonly code: string;
        readonly default_selected: boolean;
        readonly dish_id: string;
        readonly id: string;
        readonly name: string;
        readonly semantic_provenance: string;
        readonly semantic_version: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly preparation_sensory_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly preparation_semantic_version: number;
        readonly provenance: string;
      }>)[];
    readonly recipe_lines: readonly (Readonly<{
        readonly dish_id: string;
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly preparation_code: string | null;
        readonly quantity_base_units: number;
        readonly recipe_version: number;
        readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly unit_code: string;
      }>)[];
    readonly safety_derivations: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly allergens: readonly (Readonly<{
            readonly allergen_id: string;
            readonly inherited_ingredient_ids: readonly (string)[];
            readonly manual_caution: boolean;
            readonly presence: "contains" | "may_contain";
          }>)[];
        readonly contract: "exylon.catalog.safety-derivation@1.0";
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly derivation_fingerprint: string;
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly diets: readonly (Readonly<{
            readonly contradictory_ingredient_ids: readonly (string)[];
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_tag_id: string;
            readonly status: "verified" | "conflict" | "incomplete" | "unknown";
            readonly unverified_ingredient_ids: readonly (string)[];
          }>)[];
        readonly ingredient_inputs: readonly (Readonly<{
            readonly allergen_coverage: "verified" | "incomplete" | "unknown";
            readonly allergen_fact_versions: readonly (Readonly<{
                readonly allergen_id: string;
                readonly presence: "contains" | "may_contain";
                readonly version: number;
              }>)[];
            readonly concept_id: string | null;
            readonly concept_version: number | null;
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_coverage: "verified" | "incomplete" | "unknown";
            readonly diet_fact_versions: readonly (Readonly<{
                readonly conflicts: boolean;
                readonly diet_tag_id: string;
                readonly version: number;
              }>)[];
            readonly ingredient_id: string;
            readonly ingredient_version: number;
            readonly mapping_version: number | null;
            readonly provenance: string;
          }>)[];
        readonly input_fingerprint: string;
        readonly registry_fingerprint: string;
        readonly registry_version: number;
        readonly subject_id: string;
        readonly subject_type: "dish" | "modifier_option";
        readonly unverified_allergen_ids: readonly (string)[];
      }>)[];
    readonly safety_registry_version: number;
    readonly seasoning_style_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly provenance: string;
        readonly seasoning_style_code: string;
      }>)[];
    readonly section_categories: readonly (Readonly<{
        readonly category_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly sections: readonly (Readonly<{
        readonly available: boolean;
        readonly id: string;
        readonly internal_name: string;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly sensory_bases: readonly (Readonly<{
        readonly basis_version: string;
        readonly provenance: string;
        readonly status: "active" | "retired";
        readonly version: number;
      }>)[];
    readonly sensory_dimensions: readonly (Readonly<{
        readonly basis_version: string;
        readonly code: string;
        readonly dimension_label?: string;
        readonly group_code: string;
        readonly group_label?: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly served_form_sensory_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly provenance: string;
      }>)[];
    readonly translations: readonly (Readonly<{
        readonly description: string;
        readonly entity_id: string;
        readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
        readonly locale: string;
        readonly name: string;
      }>)[];
    readonly unit_definitions: readonly (Readonly<{
        readonly denominator_to_base: number;
        readonly dimension: "mass" | "volume" | "count";
        readonly numerator_to_base: number;
        readonly unit_code: string;
        readonly version: number;
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.catalog.draft@1.0";
  readonly draft_revision: number;
  readonly published_version: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly updated_by: string;
}>
export type CatalogDraftChangedEntity = Readonly<{
  readonly authoring_hash: string | null;
  readonly id: string;
  readonly kind: "dish" | "category" | "section" | "modifier_group" | "modifier_option" | "ingredient" | "media_object" | "translation_set" | "collection";
  readonly rows?: Readonly<{
    readonly allergens?: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly categories?: readonly (Readonly<{
        readonly active: boolean;
        readonly department_id?: string | null;
        readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
        readonly featured: boolean;
        readonly icon: string | null;
        readonly id: string;
        readonly internal_name: string;
        readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
        readonly media_object_id: string | null;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly diet_tags?: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly dietary_assessments?: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly dish_allergens?: readonly (Readonly<{
        readonly allergen_id: string;
        readonly dish_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly dish_diet_tags?: readonly (Readonly<{
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly source: "manual" | "deterministic";
      }>)[];
    readonly dish_media?: readonly (Readonly<{
        readonly dish_id: string;
        readonly media_object_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_modifier_groups?: readonly (Readonly<{
        readonly dish_id: string;
        readonly modifier_group_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_sensory_profiles?: readonly (Readonly<{
        readonly basis_version: string;
        readonly derivation_status: "available" | "unavailable";
        readonly dish_id: string;
        readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
        readonly flavour_tags: readonly (Readonly<{
            readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
            readonly confidence: number;
            readonly dominant_layer: "base" | "preparation" | "seasoning";
            readonly score: number;
          }>)[];
        readonly input_fingerprint: string;
        readonly profile_version: number;
      }>)[];
    readonly dishes?: readonly (Readonly<{
        readonly active: boolean;
        readonly available: boolean;
        readonly bottle_dish_id?: string | null;
        readonly category_id: string;
        readonly currency: "EUR";
        readonly id: string;
        readonly internal_name: string;
        readonly preparation_time_minutes: number | null;
        readonly price_minor: number;
        readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
        readonly seasoning_style_codes: readonly (string)[];
        readonly sort_order: number;
        readonly star_dish?: boolean;
        readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
        readonly version: number;
      }>)[];
    readonly ingredient_allergens?: readonly (Readonly<{
        readonly allergen_id: string;
        readonly ingredient_id: string;
        readonly presence: "contains" | "may_contain";
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_concept_mappings?: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly concept_id: string | null;
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly ingredient_id: string;
        readonly provenance: string;
        readonly registry_version: number;
        readonly version: number;
      }>)[];
    readonly ingredient_diet_properties?: readonly (Readonly<{
        readonly conflicts: boolean;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly ingredient_id: string;
        readonly property_code: string;
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_sensory_profiles?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimensions: readonly (Readonly<{
            readonly confidence: number;
            readonly dimension_code: string;
            readonly score: number;
          }>)[];
        readonly ingredient_id: string;
        readonly profile_version: number;
        readonly provenance: string;
      }>)[];
    readonly ingredients?: readonly (Readonly<{
        readonly active: boolean;
        readonly base_unit_code: string;
        readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly density_g_per_ml: number | null;
        readonly description: string;
        readonly id: string;
        readonly mass_per_unit_mg: number | null;
        readonly name: string;
        readonly seasoning_signature: readonly (Readonly<{
            readonly delta: number;
            readonly dimension_code: string;
          }>)[];
        readonly version: number;
      }>)[];
    readonly media_objects?: readonly (CatalogMediaObject)[];
    readonly menu_items?: readonly (Readonly<{
        readonly available: boolean;
        readonly dish_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_group_options?: readonly (Readonly<{
        readonly is_default: boolean;
        readonly modifier_group_id: string;
        readonly modifier_option_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_groups?: readonly (Readonly<{
        readonly available: boolean;
        readonly course_codes: readonly (string)[];
        readonly id: string;
        readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
        readonly name: string;
        readonly selection_max: number;
        readonly selection_min: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly modifier_option_allergens?: readonly (Readonly<{
        readonly allergen_id: string;
        readonly modifier_option_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly modifier_option_dietary_assessments?: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly modifier_option_id: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly modifier_option_ingredients?: readonly (Readonly<{
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly modifier_option_id: string;
        readonly quantity_base_units: number;
        readonly unit_code: string;
      }>)[];
    readonly modifier_options?: readonly (Readonly<{
        readonly adds_no_ingredients?: true;
        readonly available: boolean;
        readonly currency: "EUR";
        readonly id: string;
        readonly media_object_id: string | null;
        readonly name: string;
        readonly price_delta_minor: number;
        readonly version: number;
      }>)[];
    readonly preparation_choices?: readonly (Readonly<{
        readonly available: boolean;
        readonly code: string;
        readonly default_selected: boolean;
        readonly dish_id: string;
        readonly id: string;
        readonly name: string;
        readonly semantic_provenance: string;
        readonly semantic_version: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly preparation_sensory_modifiers?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly preparation_semantic_version: number;
        readonly provenance: string;
      }>)[];
    readonly recipe_lines?: readonly (Readonly<{
        readonly dish_id: string;
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly preparation_code: string | null;
        readonly quantity_base_units: number;
        readonly recipe_version: number;
        readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly unit_code: string;
      }>)[];
    readonly safety_derivations?: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly allergens: readonly (Readonly<{
            readonly allergen_id: string;
            readonly inherited_ingredient_ids: readonly (string)[];
            readonly manual_caution: boolean;
            readonly presence: "contains" | "may_contain";
          }>)[];
        readonly contract: "exylon.catalog.safety-derivation@1.0";
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly derivation_fingerprint: string;
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly diets: readonly (Readonly<{
            readonly contradictory_ingredient_ids: readonly (string)[];
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_tag_id: string;
            readonly status: "verified" | "conflict" | "incomplete" | "unknown";
            readonly unverified_ingredient_ids: readonly (string)[];
          }>)[];
        readonly ingredient_inputs: readonly (Readonly<{
            readonly allergen_coverage: "verified" | "incomplete" | "unknown";
            readonly allergen_fact_versions: readonly (Readonly<{
                readonly allergen_id: string;
                readonly presence: "contains" | "may_contain";
                readonly version: number;
              }>)[];
            readonly concept_id: string | null;
            readonly concept_version: number | null;
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_coverage: "verified" | "incomplete" | "unknown";
            readonly diet_fact_versions: readonly (Readonly<{
                readonly conflicts: boolean;
                readonly diet_tag_id: string;
                readonly version: number;
              }>)[];
            readonly ingredient_id: string;
            readonly ingredient_version: number;
            readonly mapping_version: number | null;
            readonly provenance: string;
          }>)[];
        readonly input_fingerprint: string;
        readonly registry_fingerprint: string;
        readonly registry_version: number;
        readonly subject_id: string;
        readonly subject_type: "dish" | "modifier_option";
        readonly unverified_allergen_ids: readonly (string)[];
      }>)[];
    readonly seasoning_style_modifiers?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly provenance: string;
        readonly seasoning_style_code: string;
      }>)[];
    readonly section_categories?: readonly (Readonly<{
        readonly category_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly sections?: readonly (Readonly<{
        readonly available: boolean;
        readonly id: string;
        readonly internal_name: string;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly sensory_bases?: readonly (Readonly<{
        readonly basis_version: string;
        readonly provenance: string;
        readonly status: "active" | "retired";
        readonly version: number;
      }>)[];
    readonly sensory_dimensions?: readonly (Readonly<{
        readonly basis_version: string;
        readonly code: string;
        readonly dimension_label?: string;
        readonly group_code: string;
        readonly group_label?: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly served_form_sensory_modifiers?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly provenance: string;
      }>)[];
    readonly translations?: readonly (Readonly<{
        readonly description: string;
        readonly entity_id: string;
        readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
        readonly locale: string;
        readonly name: string;
      }>)[];
    readonly unit_definitions?: readonly (Readonly<{
        readonly denominator_to_base: number;
        readonly dimension: "mass" | "volume" | "count";
        readonly numerator_to_base: number;
        readonly unit_code: string;
        readonly version: number;
      }>)[];
  }> | null;
}>
export type CatalogDraftChangeSummary = Readonly<{
  readonly draft_revision: number;
  readonly entities: readonly (Readonly<{
      readonly change: "added" | "changed";
      readonly id: string;
      readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
    }>)[];
  readonly families: readonly (Readonly<{
      readonly added: number;
      readonly changed: number;
      readonly family: "dishes" | "categories" | "modifier_options" | "modifier_groups" | "sections";
      readonly removed: number;
    }>)[];
  readonly other_changed: boolean;
  readonly published_version: number;
  readonly removed: readonly (Readonly<{
      readonly id: string;
      readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
    }>)[];
  readonly total: number;
}>
export type CatalogDraftDocument = Readonly<{
  readonly content: Readonly<{
    readonly categories: readonly (Readonly<{
        readonly active: boolean;
        readonly department_id?: string | null;
        readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
        readonly featured: boolean;
        readonly icon: string | null;
        readonly id: string;
        readonly internal_name: string;
        readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
        readonly media_object_id: string | null;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly dietary_assessments: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly dish_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly dish_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly dish_diet_tags: readonly (Readonly<{
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly source: "manual" | "deterministic";
      }>)[];
    readonly dish_media: readonly (Readonly<{
        readonly dish_id: string;
        readonly media_object_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_modifier_groups: readonly (Readonly<{
        readonly dish_id: string;
        readonly modifier_group_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_sensory_profiles: readonly (Readonly<{
        readonly basis_version: string;
        readonly derivation_status: "available" | "unavailable";
        readonly dish_id: string;
        readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
        readonly flavour_tags: readonly (Readonly<{
            readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
            readonly confidence: number;
            readonly dominant_layer: "base" | "preparation" | "seasoning";
            readonly score: number;
          }>)[];
        readonly input_fingerprint: string;
        readonly profile_version: number;
      }>)[];
    readonly dishes: readonly (Readonly<{
        readonly active: boolean;
        readonly available: boolean;
        readonly bottle_dish_id?: string | null;
        readonly category_id: string;
        readonly currency: "EUR";
        readonly id: string;
        readonly internal_name: string;
        readonly preparation_time_minutes: number | null;
        readonly price_minor: number;
        readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
        readonly seasoning_style_codes: readonly (string)[];
        readonly sort_order: number;
        readonly star_dish?: boolean;
        readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
        readonly version: number;
      }>)[];
    readonly ingredient_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly ingredient_id: string;
        readonly presence: "contains" | "may_contain";
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_diet_properties: readonly (Readonly<{
        readonly conflicts: boolean;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly ingredient_id: string;
        readonly property_code: string;
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredients: readonly (Readonly<{
        readonly active: boolean;
        readonly base_unit_code: string;
        readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly density_g_per_ml: number | null;
        readonly description: string;
        readonly id: string;
        readonly mass_per_unit_mg: number | null;
        readonly name: string;
        readonly seasoning_signature: readonly (Readonly<{
            readonly delta: number;
            readonly dimension_code: string;
          }>)[];
        readonly version: number;
      }>)[];
    readonly media_objects: readonly (CatalogMediaObject)[];
    readonly menu_items: readonly (Readonly<{
        readonly available: boolean;
        readonly dish_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_group_options: readonly (Readonly<{
        readonly is_default: boolean;
        readonly modifier_group_id: string;
        readonly modifier_option_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_groups: readonly (Readonly<{
        readonly available: boolean;
        readonly course_codes: readonly (string)[];
        readonly id: string;
        readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
        readonly name: string;
        readonly selection_max: number;
        readonly selection_min: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly modifier_option_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly modifier_option_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly modifier_option_dietary_assessments: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly modifier_option_id: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly modifier_option_ingredients: readonly (Readonly<{
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly modifier_option_id: string;
        readonly quantity_base_units: number;
        readonly unit_code: string;
      }>)[];
    readonly modifier_options: readonly (Readonly<{
        readonly adds_no_ingredients?: true;
        readonly available: boolean;
        readonly currency: "EUR";
        readonly id: string;
        readonly media_object_id: string | null;
        readonly name: string;
        readonly price_delta_minor: number;
        readonly version: number;
      }>)[];
    readonly preparation_choices: readonly (Readonly<{
        readonly available: boolean;
        readonly code: string;
        readonly default_selected: boolean;
        readonly dish_id: string;
        readonly id: string;
        readonly name: string;
        readonly semantic_provenance: string;
        readonly semantic_version: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly preparation_sensory_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly preparation_semantic_version: number;
        readonly provenance: string;
      }>)[];
    readonly recipe_lines: readonly (Readonly<{
        readonly dish_id: string;
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly preparation_code: string | null;
        readonly quantity_base_units: number;
        readonly recipe_version: number;
        readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly unit_code: string;
      }>)[];
    readonly safety_derivations: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly allergens: readonly (Readonly<{
            readonly allergen_id: string;
            readonly inherited_ingredient_ids: readonly (string)[];
            readonly manual_caution: boolean;
            readonly presence: "contains" | "may_contain";
          }>)[];
        readonly contract: "exylon.catalog.safety-derivation@1.0";
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly derivation_fingerprint: string;
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly diets: readonly (Readonly<{
            readonly contradictory_ingredient_ids: readonly (string)[];
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_tag_id: string;
            readonly status: "verified" | "conflict" | "incomplete" | "unknown";
            readonly unverified_ingredient_ids: readonly (string)[];
          }>)[];
        readonly ingredient_inputs: readonly (Readonly<{
            readonly allergen_coverage: "verified" | "incomplete" | "unknown";
            readonly allergen_fact_versions: readonly (Readonly<{
                readonly allergen_id: string;
                readonly presence: "contains" | "may_contain";
                readonly version: number;
              }>)[];
            readonly concept_id: string | null;
            readonly concept_version: number | null;
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_coverage: "verified" | "incomplete" | "unknown";
            readonly diet_fact_versions: readonly (Readonly<{
                readonly conflicts: boolean;
                readonly diet_tag_id: string;
                readonly version: number;
              }>)[];
            readonly ingredient_id: string;
            readonly ingredient_version: number;
            readonly mapping_version: number | null;
            readonly provenance: string;
          }>)[];
        readonly input_fingerprint: string;
        readonly registry_fingerprint: string;
        readonly registry_version: number;
        readonly subject_id: string;
        readonly subject_type: "dish" | "modifier_option";
        readonly unverified_allergen_ids: readonly (string)[];
      }>)[];
    readonly safety_registry_version: number;
    readonly seasoning_style_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly provenance: string;
        readonly seasoning_style_code: string;
      }>)[];
    readonly section_categories: readonly (Readonly<{
        readonly category_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly sections: readonly (Readonly<{
        readonly available: boolean;
        readonly id: string;
        readonly internal_name: string;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly served_form_sensory_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly provenance: string;
      }>)[];
    readonly translations: readonly (Readonly<{
        readonly description: string;
        readonly entity_id: string;
        readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
        readonly locale: string;
        readonly name: string;
      }>)[];
    readonly unit_definitions: readonly (Readonly<{
        readonly denominator_to_base: number;
        readonly dimension: "mass" | "volume" | "count";
        readonly numerator_to_base: number;
        readonly unit_code: string;
        readonly version: number;
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.catalog.draft-document@2.0";
  readonly draft_revision: number;
  readonly published_version: number;
  readonly reference_digest: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly updated_by: string;
}>
export type CatalogDraftEntityConflictHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly entities: readonly (Readonly<{
        readonly id: string;
        readonly kind: "dish" | "category" | "section" | "modifier_group" | "modifier_option" | "ingredient" | "media_object" | "translation_set" | "collection";
        readonly reason: "changed";
      }>)[];
    readonly errorCode: "CATALOG_VERSION_CONFLICT";
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type CatalogDraftEntityInvalidHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly entities: readonly (Readonly<{
        readonly code: string;
        readonly id: string;
        readonly kind: "dish" | "category" | "section" | "modifier_group" | "modifier_option" | "ingredient" | "media_object" | "translation_set" | "collection";
        readonly message: string;
        readonly path: string;
        readonly reason: "invalid";
      }>)[];
    readonly errorCode: "CATALOG_INVALID";
  }>;
  readonly message: string;
  readonly statusCode: 400;
}>
export type CatalogDraftEntityPatch = Readonly<{
  readonly base_hash?: string | null;
  readonly id: string;
  readonly kind: "dish" | "category" | "section" | "modifier_group" | "modifier_option" | "ingredient" | "media_object" | "translation_set" | "collection";
  readonly rows: Readonly<{
    readonly allergens?: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly categories?: readonly (Readonly<{
        readonly active: boolean;
        readonly department_id?: string | null;
        readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
        readonly featured: boolean;
        readonly icon: string | null;
        readonly id: string;
        readonly internal_name: string;
        readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
        readonly media_object_id: string | null;
        readonly sort_order?: number;
        readonly version: number;
      }>)[];
    readonly diet_tags?: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly dish_allergens?: readonly (Readonly<{
        readonly allergen_id: string;
        readonly dish_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual";
      }>)[];
    readonly dish_media?: readonly (Readonly<{
        readonly dish_id: string;
        readonly media_object_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_modifier_groups?: readonly (Readonly<{
        readonly dish_id: string;
        readonly modifier_group_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dishes?: readonly (Readonly<{
        readonly active: boolean;
        readonly available: boolean;
        readonly bottle_dish_id?: string | null;
        readonly category_id: string;
        readonly currency: "EUR";
        readonly id: string;
        readonly internal_name: string;
        readonly preparation_time_minutes: number | null;
        readonly price_minor: number;
        readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
        readonly seasoning_style_codes: readonly (string)[];
        readonly sort_order?: number;
        readonly star_dish?: boolean;
        readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
        readonly version: number;
      }>)[];
    readonly ingredient_allergens?: readonly (Readonly<{
        readonly allergen_id: string;
        readonly ingredient_id: string;
        readonly presence: "contains" | "may_contain";
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_concept_mappings?: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly concept_id: string | null;
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly ingredient_id: string;
        readonly provenance: string;
        readonly registry_version: number;
        readonly version: number;
      }>)[];
    readonly ingredient_diet_properties?: readonly (Readonly<{
        readonly conflicts: boolean;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly ingredient_id: string;
        readonly property_code: string;
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_sensory_profiles?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimensions: readonly (Readonly<{
            readonly confidence: number;
            readonly dimension_code: string;
            readonly score: number;
          }>)[];
        readonly ingredient_id: string;
        readonly profile_version: number;
        readonly provenance: string;
      }>)[];
    readonly ingredients?: readonly (Readonly<{
        readonly active: boolean;
        readonly base_unit_code: string;
        readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly density_g_per_ml: number | null;
        readonly description: string;
        readonly id: string;
        readonly mass_per_unit_mg: number | null;
        readonly name: string;
        readonly seasoning_signature: readonly (Readonly<{
            readonly delta: number;
            readonly dimension_code: string;
          }>)[];
        readonly version: number;
      }>)[];
    readonly media_objects?: readonly (CatalogMediaObject)[];
    readonly modifier_group_options?: readonly (Readonly<{
        readonly is_default: boolean;
        readonly modifier_group_id: string;
        readonly modifier_option_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_groups?: readonly (Readonly<{
        readonly available: boolean;
        readonly course_codes: readonly (string)[];
        readonly id: string;
        readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
        readonly name: string;
        readonly selection_max: number;
        readonly selection_min: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly modifier_option_allergens?: readonly (Readonly<{
        readonly allergen_id: string;
        readonly modifier_option_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual";
      }>)[];
    readonly modifier_option_ingredients?: readonly (Readonly<{
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly modifier_option_id: string;
        readonly quantity_base_units: number;
        readonly unit_code: string;
      }> | Readonly<{
        readonly entered_quantity: Readonly<{
          readonly unit_code: "mg" | "g" | "kg" | "ml" | "l" | "unit";
          readonly value: string;
        }>;
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly modifier_option_id: string;
        readonly unit_code: string;
      }>)[];
    readonly modifier_options?: readonly (Readonly<{
        readonly adds_no_ingredients?: true;
        readonly available: boolean;
        readonly currency: "EUR";
        readonly id: string;
        readonly media_object_id: string | null;
        readonly name: string;
        readonly price_delta_minor: number;
        readonly version: number;
      }>)[];
    readonly preparation_choices?: readonly (Readonly<{
        readonly available: boolean;
        readonly code: string;
        readonly default_selected: boolean;
        readonly dish_id: string;
        readonly id: string;
        readonly name: string;
        readonly semantic_provenance: string;
        readonly semantic_version: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly preparation_sensory_modifiers?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly preparation_semantic_version: number;
        readonly provenance: string;
      }>)[];
    readonly recipe_lines?: readonly (Readonly<{
        readonly dish_id: string;
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly preparation_code: string | null;
        readonly quantity_base_units: number;
        readonly recipe_version: number;
        readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly unit_code: string;
      }> | Readonly<{
        readonly dish_id: string;
        readonly entered_quantity: Readonly<{
          readonly unit_code: "mg" | "g" | "kg" | "ml" | "l" | "unit";
          readonly value: string;
        }>;
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly preparation_code: string | null;
        readonly recipe_version: number;
        readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly unit_code: string;
      }>)[];
    readonly seasoning_style_modifiers?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly provenance: string;
        readonly seasoning_style_code: string;
      }>)[];
    readonly section_categories?: readonly (Readonly<{
        readonly category_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly sections?: readonly (Readonly<{
        readonly available: boolean;
        readonly id: string;
        readonly internal_name: string;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly sensory_bases?: readonly (Readonly<{
        readonly basis_version: string;
        readonly provenance: string;
        readonly status: "active" | "retired";
        readonly version: number;
      }>)[];
    readonly sensory_dimensions?: readonly (Readonly<{
        readonly basis_version: string;
        readonly code: string;
        readonly dimension_label?: string;
        readonly group_code: string;
        readonly group_label?: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly served_form_sensory_modifiers?: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly provenance: string;
      }>)[];
    readonly translations?: readonly (Readonly<{
        readonly description: string;
        readonly entity_id: string;
        readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
        readonly locale: string;
        readonly name: string;
      }>)[];
    readonly unit_definitions?: readonly (Readonly<{
        readonly denominator_to_base: number;
        readonly dimension: "mass" | "volume" | "count";
        readonly numerator_to_base: number;
        readonly unit_code: string;
        readonly version: number;
      }>)[];
  }> | null;
}>
export type CatalogDraftEntityPatchResult = Readonly<{
  readonly base_revision: number;
  readonly change_summary: Readonly<{
    readonly draft_revision: number;
    readonly entities: readonly (Readonly<{
        readonly change: "added" | "changed";
        readonly id: string;
        readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
      }>)[];
    readonly families: readonly (Readonly<{
        readonly added: number;
        readonly changed: number;
        readonly family: "dishes" | "categories" | "modifier_options" | "modifier_groups" | "sections";
        readonly removed: number;
      }>)[];
    readonly other_changed: boolean;
    readonly published_version: number;
    readonly removed: readonly (Readonly<{
        readonly id: string;
        readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
      }>)[];
    readonly total: number;
  }> | null;
  readonly changed: readonly (Readonly<{
      readonly authoring_hash: string | null;
      readonly id: string;
      readonly kind: "dish" | "category" | "section" | "modifier_group" | "modifier_option" | "ingredient" | "media_object" | "translation_set" | "collection";
      readonly rows?: Readonly<{
        readonly allergens?: readonly (Readonly<{
            readonly active: boolean;
            readonly code: string;
            readonly description: string;
            readonly id: string;
            readonly name: string;
            readonly version: number;
          }>)[];
        readonly categories?: readonly (Readonly<{
            readonly active: boolean;
            readonly department_id?: string | null;
            readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
            readonly featured: boolean;
            readonly icon: string | null;
            readonly id: string;
            readonly internal_name: string;
            readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
            readonly media_object_id: string | null;
            readonly sort_order: number;
            readonly version: number;
          }>)[];
        readonly diet_tags?: readonly (Readonly<{
            readonly active: boolean;
            readonly code: string;
            readonly description: string;
            readonly id: string;
            readonly name: string;
            readonly version: number;
          }>)[];
        readonly dietary_assessments?: readonly (Readonly<{
            readonly confidence: number;
            readonly coverage: number;
            readonly diet_tag_id: string;
            readonly dish_id: string;
            readonly explanation: string;
            readonly input_fingerprint: string;
            readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
            readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
            readonly version: number;
          }>)[];
        readonly dish_allergens?: readonly (Readonly<{
            readonly allergen_id: string;
            readonly dish_id: string;
            readonly presence: "contains" | "may_contain";
            readonly source: "manual" | "ingredient" | "modifier_option";
          }>)[];
        readonly dish_diet_tags?: readonly (Readonly<{
            readonly diet_tag_id: string;
            readonly dish_id: string;
            readonly source: "manual" | "deterministic";
          }>)[];
        readonly dish_media?: readonly (Readonly<{
            readonly dish_id: string;
            readonly media_object_id: string;
            readonly sort_order: number;
          }>)[];
        readonly dish_modifier_groups?: readonly (Readonly<{
            readonly dish_id: string;
            readonly modifier_group_id: string;
            readonly sort_order: number;
          }>)[];
        readonly dish_sensory_profiles?: readonly (Readonly<{
            readonly basis_version: string;
            readonly derivation_status: "available" | "unavailable";
            readonly dish_id: string;
            readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
            readonly flavour_tags: readonly (Readonly<{
                readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
                readonly confidence: number;
                readonly dominant_layer: "base" | "preparation" | "seasoning";
                readonly score: number;
              }>)[];
            readonly input_fingerprint: string;
            readonly profile_version: number;
          }>)[];
        readonly dishes?: readonly (Readonly<{
            readonly active: boolean;
            readonly available: boolean;
            readonly bottle_dish_id?: string | null;
            readonly category_id: string;
            readonly currency: "EUR";
            readonly id: string;
            readonly internal_name: string;
            readonly preparation_time_minutes: number | null;
            readonly price_minor: number;
            readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
            readonly seasoning_style_codes: readonly (string)[];
            readonly sort_order: number;
            readonly star_dish?: boolean;
            readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
            readonly version: number;
          }>)[];
        readonly ingredient_allergens?: readonly (Readonly<{
            readonly allergen_id: string;
            readonly ingredient_id: string;
            readonly presence: "contains" | "may_contain";
            readonly provenance: string;
            readonly version: number;
          }>)[];
        readonly ingredient_concept_mappings?: readonly (Readonly<{
            readonly allergen_coverage: "verified" | "incomplete" | "unknown";
            readonly concept_id: string | null;
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_coverage: "verified" | "incomplete" | "unknown";
            readonly ingredient_id: string;
            readonly provenance: string;
            readonly registry_version: number;
            readonly version: number;
          }>)[];
        readonly ingredient_diet_properties?: readonly (Readonly<{
            readonly conflicts: boolean;
            readonly diet_tag_id: string;
            readonly explanation: string;
            readonly ingredient_id: string;
            readonly property_code: string;
            readonly provenance: string;
            readonly version: number;
          }>)[];
        readonly ingredient_sensory_profiles?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimensions: readonly (Readonly<{
                readonly confidence: number;
                readonly dimension_code: string;
                readonly score: number;
              }>)[];
            readonly ingredient_id: string;
            readonly profile_version: number;
            readonly provenance: string;
          }>)[];
        readonly ingredients?: readonly (Readonly<{
            readonly active: boolean;
            readonly base_unit_code: string;
            readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
            readonly density_g_per_ml: number | null;
            readonly description: string;
            readonly id: string;
            readonly mass_per_unit_mg: number | null;
            readonly name: string;
            readonly seasoning_signature: readonly (Readonly<{
                readonly delta: number;
                readonly dimension_code: string;
              }>)[];
            readonly version: number;
          }>)[];
        readonly media_objects?: readonly (CatalogMediaObject)[];
        readonly menu_items?: readonly (Readonly<{
            readonly available: boolean;
            readonly dish_id: string;
            readonly section_id: string;
            readonly sort_order: number;
          }>)[];
        readonly modifier_group_options?: readonly (Readonly<{
            readonly is_default: boolean;
            readonly modifier_group_id: string;
            readonly modifier_option_id: string;
            readonly sort_order: number;
          }>)[];
        readonly modifier_groups?: readonly (Readonly<{
            readonly available: boolean;
            readonly course_codes: readonly (string)[];
            readonly id: string;
            readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
            readonly name: string;
            readonly selection_max: number;
            readonly selection_min: number;
            readonly sort_order: number;
            readonly version: number;
          }>)[];
        readonly modifier_option_allergens?: readonly (Readonly<{
            readonly allergen_id: string;
            readonly modifier_option_id: string;
            readonly presence: "contains" | "may_contain";
            readonly source: "manual" | "ingredient" | "modifier_option";
          }>)[];
        readonly modifier_option_dietary_assessments?: readonly (Readonly<{
            readonly confidence: number;
            readonly coverage: number;
            readonly diet_tag_id: string;
            readonly explanation: string;
            readonly input_fingerprint: string;
            readonly modifier_option_id: string;
            readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
            readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
            readonly version: number;
          }>)[];
        readonly modifier_option_ingredients?: readonly (Readonly<{
            readonly ingredient_id: string;
            readonly inventory_rule: "deducts" | "inform_only";
            readonly modifier_option_id: string;
            readonly quantity_base_units: number;
            readonly unit_code: string;
          }>)[];
        readonly modifier_options?: readonly (Readonly<{
            readonly adds_no_ingredients?: true;
            readonly available: boolean;
            readonly currency: "EUR";
            readonly id: string;
            readonly media_object_id: string | null;
            readonly name: string;
            readonly price_delta_minor: number;
            readonly version: number;
          }>)[];
        readonly preparation_choices?: readonly (Readonly<{
            readonly available: boolean;
            readonly code: string;
            readonly default_selected: boolean;
            readonly dish_id: string;
            readonly id: string;
            readonly name: string;
            readonly semantic_provenance: string;
            readonly semantic_version: number;
            readonly sort_order: number;
            readonly version: number;
          }>)[];
        readonly preparation_sensory_modifiers?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimension_code: string;
            readonly modifier: number;
            readonly preparation_code: string;
            readonly preparation_semantic_version: number;
            readonly provenance: string;
          }>)[];
        readonly recipe_lines?: readonly (Readonly<{
            readonly dish_id: string;
            readonly ingredient_id: string;
            readonly inventory_rule: "deducts" | "inform_only";
            readonly preparation_code: string | null;
            readonly quantity_base_units: number;
            readonly recipe_version: number;
            readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
            readonly unit_code: string;
          }>)[];
        readonly safety_derivations?: readonly (Readonly<{
            readonly allergen_coverage: "verified" | "incomplete" | "unknown";
            readonly allergens: readonly (Readonly<{
                readonly allergen_id: string;
                readonly inherited_ingredient_ids: readonly (string)[];
                readonly manual_caution: boolean;
                readonly presence: "contains" | "may_contain";
              }>)[];
            readonly contract: "exylon.catalog.safety-derivation@1.0";
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly derivation_fingerprint: string;
            readonly diet_coverage: "verified" | "incomplete" | "unknown";
            readonly diets: readonly (Readonly<{
                readonly contradictory_ingredient_ids: readonly (string)[];
                readonly coverage: "verified" | "incomplete" | "unknown";
                readonly diet_tag_id: string;
                readonly status: "verified" | "conflict" | "incomplete" | "unknown";
                readonly unverified_ingredient_ids: readonly (string)[];
              }>)[];
            readonly ingredient_inputs: readonly (Readonly<{
                readonly allergen_coverage: "verified" | "incomplete" | "unknown";
                readonly allergen_fact_versions: readonly (Readonly<{
                    readonly allergen_id: string;
                    readonly presence: "contains" | "may_contain";
                    readonly version: number;
                  }>)[];
                readonly concept_id: string | null;
                readonly concept_version: number | null;
                readonly coverage: "verified" | "incomplete" | "unknown";
                readonly diet_coverage: "verified" | "incomplete" | "unknown";
                readonly diet_fact_versions: readonly (Readonly<{
                    readonly conflicts: boolean;
                    readonly diet_tag_id: string;
                    readonly version: number;
                  }>)[];
                readonly ingredient_id: string;
                readonly ingredient_version: number;
                readonly mapping_version: number | null;
                readonly provenance: string;
              }>)[];
            readonly input_fingerprint: string;
            readonly registry_fingerprint: string;
            readonly registry_version: number;
            readonly subject_id: string;
            readonly subject_type: "dish" | "modifier_option";
            readonly unverified_allergen_ids: readonly (string)[];
          }>)[];
        readonly seasoning_style_modifiers?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimension_code: string;
            readonly modifier: number;
            readonly provenance: string;
            readonly seasoning_style_code: string;
          }>)[];
        readonly section_categories?: readonly (Readonly<{
            readonly category_id: string;
            readonly section_id: string;
            readonly sort_order: number;
          }>)[];
        readonly sections?: readonly (Readonly<{
            readonly available: boolean;
            readonly id: string;
            readonly internal_name: string;
            readonly sort_order: number;
            readonly version: number;
          }>)[];
        readonly sensory_bases?: readonly (Readonly<{
            readonly basis_version: string;
            readonly provenance: string;
            readonly status: "active" | "retired";
            readonly version: number;
          }>)[];
        readonly sensory_dimensions?: readonly (Readonly<{
            readonly basis_version: string;
            readonly code: string;
            readonly dimension_label?: string;
            readonly group_code: string;
            readonly group_label?: string;
            readonly name: string;
            readonly sort_order: number;
          }>)[];
        readonly served_form_sensory_modifiers?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimension_code: string;
            readonly modifier: number;
            readonly preparation_code: string;
            readonly provenance: string;
          }>)[];
        readonly translations?: readonly (Readonly<{
            readonly description: string;
            readonly entity_id: string;
            readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
            readonly locale: string;
            readonly name: string;
          }>)[];
        readonly unit_definitions?: readonly (Readonly<{
            readonly denominator_to_base: number;
            readonly dimension: "mass" | "volume" | "count";
            readonly numerator_to_base: number;
            readonly unit_code: string;
            readonly version: number;
          }>)[];
      }> | null;
    }>)[];
  readonly content_hash: string;
  readonly contract: "exylon.catalog.draft-entity-patch-result@2.0";
  readonly draft_revision: number;
  readonly published_version: number;
  readonly rebased: boolean;
  readonly reference_digest: string | null;
  readonly replayed: boolean;
  readonly restaurant_id: string;
  readonly safety_registry_version: number;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly updated_by: string;
}>
export type CatalogDraftPhotoRenditions = Readonly<{
  readonly contract: "exylon.catalog.draft-photo-renditions@1.0";
  readonly photos: readonly (Readonly<{
      readonly glow: string;
      readonly media_id: string;
      readonly renditions: Readonly<{
        readonly card: Readonly<{
          readonly byte_size: number;
          readonly height: number;
          readonly url: string;
          readonly width: number;
        }>;
        readonly detail: Readonly<{
          readonly byte_size: number;
          readonly height: number;
          readonly url: string;
          readonly width: number;
        }>;
        readonly staff: Readonly<{
          readonly byte_size: number;
          readonly height: number;
          readonly url: string;
          readonly width: number;
        }>;
        readonly thumb: Readonly<{
          readonly byte_size: number;
          readonly height: number;
          readonly url: string;
          readonly width: number;
        }>;
      }>;
      readonly sha256_digest: string;
      readonly version: number;
    }>)[];
  readonly restaurant_id: string;
}>
export type CatalogDraftState = Readonly<{
  readonly changes: readonly (Readonly<{
      readonly allergen_code: string | null;
      readonly code: string;
      readonly field: string | null;
      readonly ingredient_id: string | null;
      readonly ingredient_name: string | null;
      readonly path: string;
      readonly subject_id: string | null;
      readonly subject_name: string | null;
      readonly subject_type: "dish" | "modifier_option" | "ingredient" | "category" | "section" | "catalog";
      readonly text: string;
    }>)[];
  readonly changes_total: number;
  readonly current: boolean;
  readonly draft_revision: number;
  readonly equals_publication: boolean;
  readonly published_version: number;
  readonly stored_content_hash: string;
}>
export type CatalogDraftSummary = Readonly<{
  readonly change_summary: Readonly<{
    readonly draft_revision: number;
    readonly entities: readonly (Readonly<{
        readonly change: "added" | "changed";
        readonly id: string;
        readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
      }>)[];
    readonly families: readonly (Readonly<{
        readonly added: number;
        readonly changed: number;
        readonly family: "dishes" | "categories" | "modifier_options" | "modifier_groups" | "sections";
        readonly removed: number;
      }>)[];
    readonly other_changed: boolean;
    readonly published_version: number;
    readonly removed: readonly (Readonly<{
        readonly id: string;
        readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
      }>)[];
    readonly total: number;
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.catalog.draft-summary@1.0";
  readonly draft_revision: number;
  readonly entities: readonly (Readonly<{
      readonly authoring_hash: string;
      readonly id: string;
      readonly kind: "dish" | "category" | "section" | "modifier_group" | "modifier_option" | "ingredient" | "media_object" | "translation_set" | "collection";
    }>)[];
  readonly published_at: string | null;
  readonly published_version: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogGuestDailySuggestions = Readonly<{
  readonly contract: "exylon.catalog.guest-daily-suggestions@1.0";
  readonly dish_ids: readonly (string)[];
  readonly local_date: string;
  readonly restaurant_id: string;
}>
export type CatalogGuestEntryCatalogue = Readonly<{
  readonly contract: "exylon.catalog.guest-entry-catalogue@1.0";
  readonly depleted_dish_ids: readonly (string)[];
  readonly document_url: string;
  readonly inventory_ready: boolean;
  readonly preload_urls: readonly (string)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
}>
export type CatalogGuestLiveOverlay = Readonly<{
  readonly contract: "exylon.catalog.guest-live-overlay@1.0";
  readonly depleted_dish_ids: readonly (string)[];
  readonly document_url: string;
  readonly documents: readonly (Readonly<{
      readonly document_url: string;
      readonly publication_version: number;
    }>)[];
  readonly inventory_ready: boolean;
  readonly promotion_previews: readonly (Readonly<{
      readonly dish_id: string;
      readonly preview: CatalogDishPromotionPreview;
    }>)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
}>
export type CatalogGuestMenuDocument = Readonly<{
  readonly categories: readonly (Readonly<{
      readonly active: boolean;
      readonly department_id?: string | null;
      readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
      readonly featured: boolean;
      readonly icon: string | null;
      readonly id: string;
      readonly internal_name: string;
      readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
      readonly media: CatalogPublicMediaReference | null;
      readonly media_object_id: string | null;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.catalog.guest-menu-document@2.0";
  readonly course_map: readonly (Readonly<{
      readonly category_ids: readonly (string)[];
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly dishes: readonly (CatalogGuestMenuDocumentDish)[];
  readonly media: readonly (Readonly<{
      readonly card_url: string;
      readonly detail_url: string;
      readonly id: string;
    }>)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety_fingerprint: string;
  readonly safety_registry_version: number;
  readonly sections: readonly (Readonly<{
      readonly available: boolean;
      readonly id: string;
      readonly internal_name: string;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
  readonly unlisted_dishes: readonly (CatalogGuestMenuDocumentDish)[];
}>
export type CatalogGuestMenuDocumentDish = Readonly<{
  readonly active: boolean;
  readonly allergens: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly available: boolean;
  readonly category_id: string;
  readonly contract: "exylon.catalog.published-dish@1.0";
  readonly currency: "EUR";
  readonly description: string;
  readonly diet_tags: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly dietary_assessments: readonly (Readonly<{
      readonly confidence: number;
      readonly coverage: number;
      readonly diet_tag_id: string;
      readonly dish_id: string;
      readonly explanation: string;
      readonly input_fingerprint: string;
      readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
      readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
      readonly version: number;
    }>)[];
  readonly dish_id: string;
  readonly first_published_at: string;
  readonly media: readonly (CatalogPublicMediaReference)[];
  readonly modifier_groups: readonly (Readonly<{
      readonly available: boolean;
      readonly course_codes: readonly (string)[];
      readonly id: string;
      readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
      readonly name: string;
      readonly options: readonly (Readonly<{
          readonly adds_no_ingredients?: true;
          readonly allergens: readonly (Readonly<{
              readonly active: boolean;
              readonly code: string;
              readonly description: string;
              readonly id: string;
              readonly name: string;
              readonly version: number;
            }>)[];
          readonly available: boolean;
          readonly currency: "EUR";
          readonly id: string;
          readonly ingredients: readonly (CatalogPublicIngredientReference)[];
          readonly is_default: boolean;
          readonly media: CatalogPublicMediaReference | null;
          readonly media_object_id: string | null;
          readonly name: string;
          readonly price_delta_minor: number;
          readonly safety: CatalogPublicSafetyOutcome;
          readonly sort_order: number;
          readonly translations: readonly (Readonly<{
              readonly description: string;
              readonly entity_id: string;
              readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
              readonly locale: string;
              readonly name: string;
            }>)[];
          readonly version: number;
        }>)[];
      readonly selection_max: number;
      readonly selection_min: number;
      readonly sort_order: number;
      readonly translations: readonly (Readonly<{
          readonly description: string;
          readonly entity_id: string;
          readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
          readonly locale: string;
          readonly name: string;
        }>)[];
      readonly version: number;
    }>)[];
  readonly name: string;
  readonly placements: readonly (Readonly<{
      readonly available: boolean;
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly preparation_choices: readonly (Readonly<{
      readonly available: boolean;
      readonly code: string;
      readonly default_selected: boolean;
      readonly dish_id: string;
      readonly id: string;
      readonly name: string;
      readonly semantic_provenance: string;
      readonly semantic_version: number;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly preparation_time_minutes: number | null;
  readonly price_minor: number;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety: CatalogPublicSafetyOutcome;
  readonly sort_order: number;
  readonly star_dish: boolean;
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
  readonly version: number;
}>
export type CatalogGuestMenuDocuments = Readonly<{
  readonly contract: "exylon.catalog.guest-menu-documents@1.0";
  readonly documents: readonly (Readonly<{
      readonly document_url: string;
      readonly publication_version: number;
    }>)[];
  readonly restaurant_id: string;
}>
export type CatalogGuestPublishedCatalogue = Readonly<{
  readonly categories: readonly (Readonly<{
      readonly active: boolean;
      readonly department_id?: string | null;
      readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
      readonly featured: boolean;
      readonly icon: string | null;
      readonly id: string;
      readonly internal_name: string;
      readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
      readonly media: CatalogPublicMediaReference | null;
      readonly media_object_id: string | null;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.catalog.published-catalogue@1.0";
  readonly course_map: readonly (Readonly<{
      readonly category_ids: readonly (string)[];
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly dishes: readonly (CatalogGuestPublishedDish)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety_fingerprint: string;
  readonly safety_registry_version: number;
  readonly sections: readonly (Readonly<{
      readonly available: boolean;
      readonly id: string;
      readonly internal_name: string;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
}>
export type CatalogGuestPublishedDish = Readonly<{
  readonly active: boolean;
  readonly allergens: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly available: boolean;
  readonly category_id: string;
  readonly contract: "exylon.catalog.published-dish@1.0";
  readonly currency: "EUR";
  readonly description: string;
  readonly diet_tags: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly dietary_assessments: readonly (Readonly<{
      readonly confidence: number;
      readonly coverage: number;
      readonly diet_tag_id: string;
      readonly dish_id: string;
      readonly explanation: string;
      readonly input_fingerprint: string;
      readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
      readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
      readonly version: number;
    }>)[];
  readonly dish_id: string;
  readonly first_published_at: string;
  readonly media: readonly (CatalogPublicMediaReference)[];
  readonly modifier_groups: readonly (Readonly<{
      readonly available: boolean;
      readonly course_codes: readonly (string)[];
      readonly id: string;
      readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
      readonly name: string;
      readonly options: readonly (Readonly<{
          readonly adds_no_ingredients?: true;
          readonly allergens: readonly (Readonly<{
              readonly active: boolean;
              readonly code: string;
              readonly description: string;
              readonly id: string;
              readonly name: string;
              readonly version: number;
            }>)[];
          readonly available: boolean;
          readonly currency: "EUR";
          readonly id: string;
          readonly ingredients: readonly (CatalogPublicIngredientReference)[];
          readonly is_default: boolean;
          readonly media: CatalogPublicMediaReference | null;
          readonly media_object_id: string | null;
          readonly name: string;
          readonly price_delta_minor: number;
          readonly safety: CatalogPublicSafetyOutcome;
          readonly sort_order: number;
          readonly translations: readonly (Readonly<{
              readonly description: string;
              readonly entity_id: string;
              readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
              readonly locale: string;
              readonly name: string;
            }>)[];
          readonly version: number;
        }>)[];
      readonly selection_max: number;
      readonly selection_min: number;
      readonly sort_order: number;
      readonly translations: readonly (Readonly<{
          readonly description: string;
          readonly entity_id: string;
          readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
          readonly locale: string;
          readonly name: string;
        }>)[];
      readonly version: number;
    }>)[];
  readonly name: string;
  readonly placements: readonly (Readonly<{
      readonly available: boolean;
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly preparation_choices: readonly (Readonly<{
      readonly available: boolean;
      readonly code: string;
      readonly default_selected: boolean;
      readonly dish_id: string;
      readonly id: string;
      readonly name: string;
      readonly semantic_provenance: string;
      readonly semantic_version: number;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly preparation_time_minutes: number | null;
  readonly price_minor: number;
  readonly promotion_preview: CatalogDishPromotionPreview | null;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety: CatalogPublicSafetyOutcome;
  readonly sensory_profile: Readonly<{
    readonly basis_version: string;
    readonly confidence: number;
    readonly coverage: number;
    readonly density_defaulted: boolean;
    readonly derivation_status: "available" | "unavailable";
    readonly dimensions: readonly (Readonly<{
        readonly confidence: number;
        readonly dimension_code: string;
        readonly dimension_label?: string;
        readonly group_code?: string;
        readonly group_label?: string;
        readonly ingredient_score: number;
        readonly layers: Readonly<{
          readonly base: number;
          readonly preparation: number;
          readonly seasoning: number;
        }>;
        readonly preparation_delta: number;
        readonly score: number;
        readonly sources: readonly (Readonly<{
            readonly confidence: number;
            readonly contribution: number;
            readonly source_code: string;
            readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
          }>)[];
      }>)[];
    readonly dish_id: string;
    readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
    readonly flavour_tags: readonly (Readonly<{
        readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
        readonly confidence: number;
        readonly dominant_layer: "base" | "preparation" | "seasoning";
        readonly score: number;
      }>)[];
    readonly input_fingerprint: string;
    readonly profile_version: number;
    readonly provenance: string;
    readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
  }> | null;
  readonly sort_order: number;
  readonly star_dish: boolean;
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
  readonly version: number;
}>
export type CatalogIngredient = Readonly<{
  readonly active: boolean;
  readonly base_unit_code: string;
  readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
  readonly density_g_per_ml: number | null;
  readonly description: string;
  readonly id: string;
  readonly mass_per_unit_mg: number | null;
  readonly name: string;
  readonly seasoning_signature: readonly (Readonly<{
      readonly delta: number;
      readonly dimension_code: string;
    }>)[];
  readonly version: number;
}>
export type CatalogIngredientAllergen = Readonly<{
  readonly allergen_id: string;
  readonly ingredient_id: string;
  readonly presence: "contains" | "may_contain";
  readonly provenance: string;
  readonly version: number;
}>
export type CatalogIngredientAutocomplete = Readonly<{
  readonly accepted: readonly (Readonly<{
      readonly alternatives: readonly (Readonly<{
          readonly code: string;
          readonly dimension: "mass" | "volume" | "count";
          readonly from_query: string;
          readonly in_pantry: boolean;
          readonly master_ingredient_id: string;
          readonly name: string;
          readonly rank: number;
          readonly safety_preview: Readonly<{
            readonly allergens_contains: readonly (string)[];
            readonly allergens_unknown?: readonly (string)[];
            readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
            readonly provenance?: Readonly<{
              readonly allergen_coverage: "verified" | "incomplete" | "unknown";
              readonly diet_coverage: "verified" | "incomplete" | "unknown";
              readonly master_registry_version: number;
              readonly safety_registry_version: number;
              readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
              readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
            }>;
          }> | null;
          readonly score: number;
          readonly unit_code: "MG" | "ML" | "UNIT";
        }>)[];
      readonly code: string;
      readonly confidence: number;
      readonly decomposed_from: string | null;
      readonly dimension: "mass" | "volume" | "count";
      readonly evidence: "photo" | "title" | "description" | "canonical_recipe" | null;
      readonly implied_by: string | null;
      readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other" | null;
      readonly line_id: string;
      readonly master_ingredient_id: string;
      readonly name: string;
      readonly needs_review: boolean;
      readonly origin: "model" | "implied" | "merged";
      readonly preparation_code: string | null;
      readonly preparation_source: "model" | "query" | null;
      readonly quantity_base_units: number;
      readonly quantity_display: Readonly<{
        readonly unit: "g" | "ml" | "unit";
        readonly value: number;
      }>;
      readonly review_flags: readonly ("unit_bridged" | "count_rounded" | "quantity_out_of_range" | "merged_duplicate" | "share_implausible" | "low_confidence" | "alternatives_close" | "canonical_only" | "forced_finish" | "implied")[];
      readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
      readonly safety_preview: Readonly<{
        readonly allergens_contains: readonly (string)[];
        readonly allergens_unknown?: readonly (string)[];
        readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
        readonly provenance?: Readonly<{
          readonly allergen_coverage: "verified" | "incomplete" | "unknown";
          readonly diet_coverage: "verified" | "incomplete" | "unknown";
          readonly master_registry_version: number;
          readonly safety_registry_version: number;
          readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
          readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
        }>;
      }> | null;
      readonly unit_code: "MG" | "ML" | "UNIT";
    }>)[];
  readonly authoritative: false;
  readonly contract: "exylon.catalog.ingredient-autocomplete@3.0";
  readonly dish_observations: string;
  readonly expires_at: string | null;
  readonly preview: CatalogDishDerivationPreview | null;
  readonly proposal_id: string | null;
  readonly request_fingerprint: string;
  readonly retry_token: string;
  readonly retryable: boolean;
  readonly reused: boolean;
  readonly review_flags: readonly ("total_mass_low" | "total_mass_high" | "no_main_line" | "many_lines" | "finish_salvaged" | "search_budget_exhausted")[];
  readonly saved: false;
  readonly seasoning_style_hints: readonly (Readonly<{
      readonly code: string;
      readonly confidence: number;
    }>)[];
  readonly section_hint: string | null;
  readonly session: Readonly<{
    readonly elapsed_ms: number;
    readonly finish_attempts: number;
    readonly forced_finish: boolean;
    readonly image: "sent" | "skipped_unreadable" | "none";
    readonly model_turns: number;
    readonly provider: "openai" | "recorded" | "deterministic";
    readonly queries: readonly (Readonly<{
        readonly preparation_hint: string | null;
        readonly query: string;
        readonly result_codes: readonly (string)[];
        readonly searched_as: string;
      }>)[];
    readonly searches: number;
  }>;
  readonly status: "completed" | "basic" | "partially_completed" | "invalid_candidate" | "provider_unavailable" | "custody_unavailable" | "timed_out" | "indeterminate" | "search_failed";
  readonly stop_reason: "finished" | "finish_forced" | "max_turns" | "max_searches" | "max_tokens" | "wall_time" | "looping" | "provider_error" | "provider_indeterminate" | "provider_unavailable" | "refusal" | "invalid_output" | "none";
  readonly unmatched: readonly (Readonly<{
      readonly candidate_name: string;
      readonly code: string | null;
      readonly decomposed_from: string | null;
      readonly line_id: string;
      readonly quantity: Readonly<{
        readonly denominator: number;
        readonly numerator: number;
      }> | null;
      readonly reason: "no_candidate" | "house_component_unknown_composition" | "candidates_not_equivalent" | "unseen_master" | "unit_unbridgeable" | "quantity_invalid" | "already_present" | "loop_cut" | "deprecated_master";
      readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
      readonly search_prefill: string;
      readonly suggestions: readonly (Readonly<{
          readonly code: string;
          readonly in_pantry: boolean;
          readonly master_ingredient_id: string;
          readonly name: string;
          readonly safety_preview: Readonly<{
            readonly allergens_contains: readonly (string)[];
            readonly allergens_unknown?: readonly (string)[];
            readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
            readonly provenance?: Readonly<{
              readonly allergen_coverage: "verified" | "incomplete" | "unknown";
              readonly diet_coverage: "verified" | "incomplete" | "unknown";
              readonly master_registry_version: number;
              readonly safety_registry_version: number;
              readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
              readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
            }>;
          }> | null;
          readonly score: number;
        }>)[];
      readonly unit: "g" | "ml" | "unit" | null;
    }>)[];
  readonly usage_fact_id: string | null;
  readonly warnings: readonly ("media_unavailable" | "media_downscaled" | "pantry_truncated" | "already_in_recipe_truncated")[];
}>
export type CatalogIngredientAutocompleteRequest = Readonly<{
  readonly current_ingredient_ids: readonly (string)[];
  readonly description: string;
  readonly flavour_brief?: string | null;
  readonly include_media?: boolean;
  readonly locale: string;
  readonly media: Readonly<{
    readonly kind: "draft";
    readonly media_object_id: string;
  }> | Readonly<{
    readonly editor_intent_id: string;
    readonly kind: "provisional";
    readonly media_id: string;
  }> | null;
  readonly mode?: "propose_recipe" | "complete";
  readonly regenerate?: boolean;
  readonly retry_token: string | null;
  readonly title: string;
}>
export type CatalogIngredientConcept = Readonly<{
  readonly aliases: readonly (string)[];
  readonly allergen_facts: readonly (Readonly<{
      readonly allergen_id: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly status: "contains" | "may_contain" | "absent" | "unknown";
    }>)[];
  readonly code: string;
  readonly default_unit_code: "MG" | "ML" | "UNIT";
  readonly default_unit_dimension: "mass" | "volume" | "count";
  readonly diet_facts: readonly (Readonly<{
      readonly diet_id: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly status: "compatible" | "contradicts" | "unknown";
    }>)[];
  readonly id: string;
  readonly name: string;
  readonly version: number;
}>
export type CatalogIngredientConceptMapping = Readonly<{
  readonly allergen_coverage: "verified" | "incomplete" | "unknown";
  readonly concept_id: string | null;
  readonly coverage: "verified" | "incomplete" | "unknown";
  readonly diet_coverage: "verified" | "incomplete" | "unknown";
  readonly ingredient_id: string;
  readonly provenance: string;
  readonly registry_version: number;
  readonly version: number;
}>
export type CatalogIngredientDemand = Readonly<{
  readonly base_unit_code: string;
  readonly denominator_to_base: number;
  readonly denominator_to_canonical_base: number;
  readonly dimension: "mass" | "volume" | "count";
  readonly ingredient_concept_id: string | null;
  readonly ingredient_concept_version: number | null;
  readonly ingredient_id: string;
  readonly ingredient_mapping_coverage: "verified" | "incomplete" | "unknown";
  readonly ingredient_mapping_version: number | null;
  readonly input_fingerprint: string;
  readonly inventory_rule: "deducts" | "inform_only";
  readonly modifier_option_version: number | null;
  readonly numerator_to_base: number;
  readonly numerator_to_canonical_base: number;
  readonly publication_version: number;
  readonly quantity_base_units: number;
  readonly recipe_version: number | null;
  readonly restaurant_ingredient_active: boolean;
  readonly restaurant_ingredient_version: number;
  readonly safety_registry_version: number;
  readonly source_version: number;
  readonly unit_definition_version: number;
}>
export type CatalogIngredientDietProperty = Readonly<{
  readonly conflicts: boolean;
  readonly diet_tag_id: string;
  readonly explanation: string;
  readonly ingredient_id: string;
  readonly property_code: string;
  readonly provenance: string;
  readonly version: number;
}>
export type CatalogIngredientRecipe = Readonly<{
  readonly contract: "exylon.catalog.ingredient-recipe@1.0";
  readonly dish_id: string;
  readonly ingredients: readonly (Readonly<{
      readonly allergens: readonly (Readonly<{
          readonly active: boolean;
          readonly code: string;
          readonly description: string;
          readonly id: string;
          readonly name: string;
          readonly version: number;
        }>)[];
      readonly base_unit_code: string;
      readonly denominator_to_base: number;
      readonly denominator_to_canonical_base: number;
      readonly dimension: "mass" | "volume" | "count";
      readonly ingredient_concept_id: string | null;
      readonly ingredient_concept_version: number | null;
      readonly ingredient_id: string;
      readonly ingredient_mapping_coverage: "verified" | "incomplete" | "unknown";
      readonly ingredient_mapping_version: number | null;
      readonly input_fingerprint: string;
      readonly inventory_rule: "deducts" | "inform_only";
      readonly modifier_option_version: number | null;
      readonly name: string;
      readonly numerator_to_base: number;
      readonly numerator_to_canonical_base: number;
      readonly publication_version: number;
      readonly quantity_base_units: number;
      readonly recipe_version: number | null;
      readonly restaurant_ingredient_active: boolean;
      readonly restaurant_ingredient_version: number;
      readonly safety_registry_version: number;
      readonly sensory_profile: Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimensions: readonly (Readonly<{
            readonly confidence: number;
            readonly dimension_code: string;
            readonly score: number;
          }>)[];
        readonly ingredient_id: string;
        readonly profile_version: number;
        readonly provenance: string;
      }> | null;
      readonly source_version: number;
      readonly unit_definition_version: number;
    }>)[];
  readonly input_fingerprint: string;
  readonly modifier_options: readonly (Readonly<{
      readonly ingredients: readonly (Readonly<{
          readonly base_unit_code: string;
          readonly denominator_to_base: number;
          readonly denominator_to_canonical_base: number;
          readonly dimension: "mass" | "volume" | "count";
          readonly ingredient_concept_id: string | null;
          readonly ingredient_concept_version: number | null;
          readonly ingredient_id: string;
          readonly ingredient_mapping_coverage: "verified" | "incomplete" | "unknown";
          readonly ingredient_mapping_version: number | null;
          readonly input_fingerprint: string;
          readonly inventory_rule: "deducts" | "inform_only";
          readonly modifier_option_version: number | null;
          readonly numerator_to_base: number;
          readonly numerator_to_canonical_base: number;
          readonly publication_version: number;
          readonly quantity_base_units: number;
          readonly recipe_version: number | null;
          readonly restaurant_ingredient_active: boolean;
          readonly restaurant_ingredient_version: number;
          readonly safety_registry_version: number;
          readonly source_version: number;
          readonly unit_definition_version: number;
        }>)[];
      readonly input_fingerprint: string;
      readonly modifier_option_id: string;
      readonly modifier_option_version: number;
    }>)[];
  readonly publication_version: number;
  readonly recipe_version: number | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogIngredientSensoryProfile = Readonly<{
  readonly basis_version: string;
  readonly confidence: number;
  readonly dimensions: readonly (Readonly<{
      readonly confidence: number;
      readonly dimension_code: string;
      readonly score: number;
    }>)[];
  readonly ingredient_id: string;
  readonly profile_version: number;
  readonly provenance: string;
}>
export type CatalogLiveMasterRegistryNotice = Readonly<{
  readonly current_basis_version: string;
  readonly current_master_registry_version: number;
  readonly publication_version: number;
  readonly published_basis_version: string | null;
  readonly published_content_hash: string;
  readonly published_master_registry_version: number | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogLiveRegistryNotice = Readonly<{
  readonly current_registry_fingerprint: string;
  readonly current_registry_version: number;
  readonly publication_version: number;
  readonly published_content_hash: string;
  readonly published_registry_version: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogMasterIngredientMaterialization = Readonly<{
  readonly contract: "exylon.catalog.master-ingredient-materialization@3.0";
  readonly draft: CatalogDraftEntityPatchResult;
  readonly ingredient_id: string | null;
  readonly master_ingredient_id: string | null;
  readonly materialized: readonly (Readonly<{
      readonly ingredient_id: string;
      readonly master_ingredient_id: string;
    }>)[];
  readonly target: Readonly<{
    readonly dish_id: string;
    readonly inventory_rule: "deducts" | "inform_only";
    readonly kind: "dish_recipe";
    readonly quantity_base_units: number;
  }> | Readonly<{
    readonly inventory_rule: "deducts" | "inform_only";
    readonly kind: "modifier_option";
    readonly modifier_option_id: string;
    readonly quantity_base_units: number;
  }> | null;
}>
export type CatalogMasterIngredientMaterializationRequest = Readonly<{
  readonly editor_intent_id: string;
  readonly master_ingredient_id: string;
  readonly target: Readonly<{
    readonly dish_id: string;
    readonly inventory_rule: "deducts" | "inform_only";
    readonly kind: "dish_recipe";
    readonly quantity_base_units: number;
  }> | Readonly<{
    readonly inventory_rule: "deducts" | "inform_only";
    readonly kind: "modifier_option";
    readonly modifier_option_id: string;
    readonly quantity_base_units: number;
  }> | Readonly<{
    readonly dish_id: string;
    readonly entered_quantity: Readonly<{
      readonly unit_code: "mg" | "g" | "kg" | "ml" | "l" | "unit";
      readonly value: string;
    }>;
    readonly inventory_rule: "deducts" | "inform_only";
    readonly kind: "dish_recipe";
  }> | Readonly<{
    readonly entered_quantity: Readonly<{
      readonly unit_code: "mg" | "g" | "kg" | "ml" | "l" | "unit";
      readonly value: string;
    }>;
    readonly inventory_rule: "deducts" | "inform_only";
    readonly kind: "modifier_option";
    readonly modifier_option_id: string;
  }>;
}> | Readonly<{
  readonly editor_intent_id: string;
  readonly master_ingredient_ids: readonly (string)[];
}>
export type CatalogMasterIngredientSearch = Readonly<{
  readonly contract: "exylon.catalog.master-ingredient-search@1.0";
  readonly limit: number;
  readonly query: string;
  readonly results: readonly (Readonly<{
      readonly brand?: string | null;
      readonly code: string;
      readonly combined_score: number;
      readonly deprecated_by: string | null;
      readonly dimension: "mass";
      readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
      readonly lexical_score: number;
      readonly master_ingredient_id: string;
      readonly match_source: "canonical_name" | "alias" | "code";
      readonly match_type: "exact" | "prefix" | "contains" | "trigram" | "semantic";
      readonly matched_text: string;
      readonly name: string;
      readonly preparation_code: string | null;
      readonly rrf_score: number | null;
      readonly safety_preview: Readonly<{
        readonly allergens_contains: readonly (string)[];
        readonly allergens_unknown?: readonly (string)[];
        readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
        readonly provenance?: Readonly<{
          readonly allergen_coverage: "verified" | "incomplete" | "unknown";
          readonly diet_coverage: "verified" | "incomplete" | "unknown";
          readonly master_registry_version: number;
          readonly safety_registry_version: number;
          readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
          readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
        }>;
      }> | null;
      readonly trigram_score: number;
      readonly unit_code: "MG";
    }> | Readonly<{
      readonly brand?: string | null;
      readonly code: string;
      readonly combined_score: number;
      readonly deprecated_by: string | null;
      readonly dimension: "volume";
      readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
      readonly lexical_score: number;
      readonly master_ingredient_id: string;
      readonly match_source: "canonical_name" | "alias" | "code";
      readonly match_type: "exact" | "prefix" | "contains" | "trigram" | "semantic";
      readonly matched_text: string;
      readonly name: string;
      readonly preparation_code: string | null;
      readonly rrf_score: number | null;
      readonly safety_preview: Readonly<{
        readonly allergens_contains: readonly (string)[];
        readonly allergens_unknown?: readonly (string)[];
        readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
        readonly provenance?: Readonly<{
          readonly allergen_coverage: "verified" | "incomplete" | "unknown";
          readonly diet_coverage: "verified" | "incomplete" | "unknown";
          readonly master_registry_version: number;
          readonly safety_registry_version: number;
          readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
          readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
        }>;
      }> | null;
      readonly trigram_score: number;
      readonly unit_code: "ML";
    }> | Readonly<{
      readonly brand?: string | null;
      readonly code: string;
      readonly combined_score: number;
      readonly deprecated_by: string | null;
      readonly dimension: "count";
      readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
      readonly lexical_score: number;
      readonly master_ingredient_id: string;
      readonly match_source: "canonical_name" | "alias" | "code";
      readonly match_type: "exact" | "prefix" | "contains" | "trigram" | "semantic";
      readonly matched_text: string;
      readonly name: string;
      readonly preparation_code: string | null;
      readonly rrf_score: number | null;
      readonly safety_preview: Readonly<{
        readonly allergens_contains: readonly (string)[];
        readonly allergens_unknown?: readonly (string)[];
        readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
        readonly provenance?: Readonly<{
          readonly allergen_coverage: "verified" | "incomplete" | "unknown";
          readonly diet_coverage: "verified" | "incomplete" | "unknown";
          readonly master_registry_version: number;
          readonly safety_registry_version: number;
          readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
          readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
        }>;
      }> | null;
      readonly trigram_score: number;
      readonly unit_code: "UNIT";
    }>)[];
  readonly runtime_mode: "lexical_trigram" | "hybrid_rrf";
  readonly side_effect: "none";
}>
export type CatalogMasterIngredientSearchRequest = Readonly<{
  readonly limit?: number;
  readonly q: string;
}>
export type CatalogMasterIngredientSearchResult = Readonly<{
  readonly brand?: string | null;
  readonly code: string;
  readonly combined_score: number;
  readonly deprecated_by: string | null;
  readonly dimension: "mass";
  readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
  readonly lexical_score: number;
  readonly master_ingredient_id: string;
  readonly match_source: "canonical_name" | "alias" | "code";
  readonly match_type: "exact" | "prefix" | "contains" | "trigram" | "semantic";
  readonly matched_text: string;
  readonly name: string;
  readonly preparation_code: string | null;
  readonly rrf_score: number | null;
  readonly safety_preview: Readonly<{
    readonly allergens_contains: readonly (string)[];
    readonly allergens_unknown?: readonly (string)[];
    readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
    readonly provenance?: Readonly<{
      readonly allergen_coverage: "verified" | "incomplete" | "unknown";
      readonly diet_coverage: "verified" | "incomplete" | "unknown";
      readonly master_registry_version: number;
      readonly safety_registry_version: number;
      readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
      readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
    }>;
  }> | null;
  readonly trigram_score: number;
  readonly unit_code: "MG";
}> | Readonly<{
  readonly brand?: string | null;
  readonly code: string;
  readonly combined_score: number;
  readonly deprecated_by: string | null;
  readonly dimension: "volume";
  readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
  readonly lexical_score: number;
  readonly master_ingredient_id: string;
  readonly match_source: "canonical_name" | "alias" | "code";
  readonly match_type: "exact" | "prefix" | "contains" | "trigram" | "semantic";
  readonly matched_text: string;
  readonly name: string;
  readonly preparation_code: string | null;
  readonly rrf_score: number | null;
  readonly safety_preview: Readonly<{
    readonly allergens_contains: readonly (string)[];
    readonly allergens_unknown?: readonly (string)[];
    readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
    readonly provenance?: Readonly<{
      readonly allergen_coverage: "verified" | "incomplete" | "unknown";
      readonly diet_coverage: "verified" | "incomplete" | "unknown";
      readonly master_registry_version: number;
      readonly safety_registry_version: number;
      readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
      readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
    }>;
  }> | null;
  readonly trigram_score: number;
  readonly unit_code: "ML";
}> | Readonly<{
  readonly brand?: string | null;
  readonly code: string;
  readonly combined_score: number;
  readonly deprecated_by: string | null;
  readonly dimension: "count";
  readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
  readonly lexical_score: number;
  readonly master_ingredient_id: string;
  readonly match_source: "canonical_name" | "alias" | "code";
  readonly match_type: "exact" | "prefix" | "contains" | "trigram" | "semantic";
  readonly matched_text: string;
  readonly name: string;
  readonly preparation_code: string | null;
  readonly rrf_score: number | null;
  readonly safety_preview: Readonly<{
    readonly allergens_contains: readonly (string)[];
    readonly allergens_unknown?: readonly (string)[];
    readonly diets: Readonly<{ readonly [key: string]: "compatible" | "contradicts" | "unknown" }>;
    readonly provenance?: Readonly<{
      readonly allergen_coverage: "verified" | "incomplete" | "unknown";
      readonly diet_coverage: "verified" | "incomplete" | "unknown";
      readonly master_registry_version: number;
      readonly safety_registry_version: number;
      readonly safety_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
      readonly sensory_source: "authored_v3" | "authored_v2" | "archive_v1" | "unknown" | "generated";
    }>;
  }> | null;
  readonly trigram_score: number;
  readonly unit_code: "UNIT";
}>
export type CatalogMasterRegistryAllergenFact = Readonly<{
  readonly allergen_id: string;
  readonly confidence: number;
  readonly evidence: string;
  readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
  readonly source_code: "milk" | "egg" | "fish" | "shellfish" | "peanut" | "tree_nut" | "soy" | "wheat" | "sesame" | "sulphites" | "mustard" | "celery" | "lupin" | "molluscs";
  readonly status: "contains" | "may_contain" | "absent" | "unknown";
}>
export type CatalogMasterRegistryAllergenSourceCode = "milk" | "egg" | "fish" | "shellfish" | "peanut" | "tree_nut" | "soy" | "wheat" | "sesame" | "sulphites" | "mustard" | "celery" | "lupin" | "molluscs"
export type CatalogMasterRegistryDietFact = Readonly<{
  readonly diet_id: string;
  readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
  readonly status: "compatible" | "contradicts" | "unknown";
}>
export type CatalogMasterRegistryDimension = "mass" | "volume" | "count"
export type CatalogMasterRegistryIngredient = Readonly<{
  readonly aliases: readonly (string)[];
  readonly allergen_facts: readonly (Readonly<{
      readonly allergen_id: string;
      readonly confidence: number;
      readonly evidence: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly source_code: "milk" | "egg" | "fish" | "shellfish" | "peanut" | "tree_nut" | "soy" | "wheat" | "sesame" | "sulphites" | "mustard" | "celery" | "lupin" | "molluscs";
      readonly status: "contains" | "may_contain" | "absent" | "unknown";
    }>)[];
  readonly code: string;
  readonly concept_id: string;
  readonly default_role?: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
  readonly denominator_to_base: 1;
  readonly density_g_per_ml?: number | null;
  readonly deprecated_by: string | null;
  readonly diet_facts: readonly (Readonly<{
      readonly diet_id: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly status: "compatible" | "contradicts" | "unknown";
    }>)[];
  readonly dimension: "mass";
  readonly id: string;
  readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
  readonly mass_per_unit_mg: number | null;
  readonly master_registry_version: number;
  readonly name: string;
  readonly numerator_to_base: 1000;
  readonly row_fingerprint: string;
  readonly safety_registry_version: number;
  readonly source_unit_code: "g";
  readonly status?: "active" | "retired";
  readonly unit_code: "MG";
  readonly version: number;
}> | Readonly<{
  readonly aliases: readonly (string)[];
  readonly allergen_facts: readonly (Readonly<{
      readonly allergen_id: string;
      readonly confidence: number;
      readonly evidence: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly source_code: "milk" | "egg" | "fish" | "shellfish" | "peanut" | "tree_nut" | "soy" | "wheat" | "sesame" | "sulphites" | "mustard" | "celery" | "lupin" | "molluscs";
      readonly status: "contains" | "may_contain" | "absent" | "unknown";
    }>)[];
  readonly code: string;
  readonly concept_id: string;
  readonly default_role?: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
  readonly denominator_to_base: 1;
  readonly density_g_per_ml?: number | null;
  readonly deprecated_by: string | null;
  readonly diet_facts: readonly (Readonly<{
      readonly diet_id: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly status: "compatible" | "contradicts" | "unknown";
    }>)[];
  readonly dimension: "volume";
  readonly id: string;
  readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
  readonly mass_per_unit_mg: number | null;
  readonly master_registry_version: number;
  readonly name: string;
  readonly numerator_to_base: 1000;
  readonly row_fingerprint: string;
  readonly safety_registry_version: number;
  readonly source_unit_code: "ml";
  readonly status?: "active" | "retired";
  readonly unit_code: "ML";
  readonly version: number;
}> | Readonly<{
  readonly aliases: readonly (string)[];
  readonly allergen_facts: readonly (Readonly<{
      readonly allergen_id: string;
      readonly confidence: number;
      readonly evidence: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly source_code: "milk" | "egg" | "fish" | "shellfish" | "peanut" | "tree_nut" | "soy" | "wheat" | "sesame" | "sulphites" | "mustard" | "celery" | "lupin" | "molluscs";
      readonly status: "contains" | "may_contain" | "absent" | "unknown";
    }>)[];
  readonly code: string;
  readonly concept_id: string;
  readonly default_role?: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
  readonly denominator_to_base: 1;
  readonly density_g_per_ml?: number | null;
  readonly deprecated_by: string | null;
  readonly diet_facts: readonly (Readonly<{
      readonly diet_id: string;
      readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
      readonly status: "compatible" | "contradicts" | "unknown";
    }>)[];
  readonly dimension: "count";
  readonly id: string;
  readonly ingredient_type: "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other";
  readonly mass_per_unit_mg: number | null;
  readonly master_registry_version: number;
  readonly name: string;
  readonly numerator_to_base: 1;
  readonly row_fingerprint: string;
  readonly safety_registry_version: number;
  readonly source_unit_code: "piece";
  readonly status?: "active" | "retired";
  readonly unit_code: "UNIT";
  readonly version: number;
}>
export type CatalogMasterRegistryIngredientType = "meat" | "fish" | "seafood" | "vegetable" | "fruit" | "dairy" | "grain" | "legume" | "nut_seed" | "spice" | "herb" | "oil_fat" | "sauce" | "sweetener" | "beverage" | "other"
export type CatalogMasterRegistrySensoryDimension = Readonly<{
  readonly code: string;
  readonly confidence: number;
  readonly group: "aroma" | "ingredient_family" | "intensity" | "mouthfeel" | "preparation" | "seasoning_style" | "taste" | "temperature" | "texture";
  readonly score: number;
}>
export type CatalogMasterRegistrySensoryGroup = "aroma" | "ingredient_family" | "intensity" | "mouthfeel" | "preparation" | "seasoning_style" | "taste" | "temperature" | "texture"
export type CatalogMasterRegistrySensoryModifier = Readonly<{
  readonly basis_version: string;
  readonly confidence: number;
  readonly dimension_code: string;
  readonly master_registry_version: number;
  readonly modifier: number;
  readonly modifier_version: number;
  readonly row_fingerprint: string;
  readonly source_code: string;
  readonly source_group: "preparation" | "seasoning_style";
  readonly source_member: "preparation_sensory_modifiers.seed.json" | "seasoning_style_modifiers.seed.json" | "mi_ingredients_v2_2026_05.modifiers.v2.json";
  readonly source_ordinal: number;
}>
export type CatalogMasterRegistrySensoryProfile = Readonly<{
  readonly basis_version: string;
  readonly confidence_score: number;
  readonly dimensions: readonly (Readonly<{
      readonly code: string;
      readonly confidence: number;
      readonly group: "aroma" | "ingredient_family" | "intensity" | "mouthfeel" | "preparation" | "seasoning_style" | "taste" | "temperature" | "texture";
      readonly score: number;
    }>)[];
  readonly master_ingredient_id: string;
  readonly master_registry_version: number;
  readonly profile_summary: string;
  readonly profile_version: number;
  readonly seasoning_signature?: readonly (Readonly<{
      readonly delta: number;
      readonly dimension_code: string;
    }>)[];
  readonly source: string;
}>
export type CatalogMasterRegistrySourceUnitCode = "g" | "ml" | "piece"
export type CatalogMasterRegistryUnitScale = Readonly<{
  readonly denominator_to_base: 1;
  readonly dimension: "mass";
  readonly numerator_to_base: 1000;
  readonly source_unit_code: "g";
  readonly unit_code: "MG";
}> | Readonly<{
  readonly denominator_to_base: 1;
  readonly dimension: "volume";
  readonly numerator_to_base: 1000;
  readonly source_unit_code: "ml";
  readonly unit_code: "ML";
}> | Readonly<{
  readonly denominator_to_base: 1;
  readonly dimension: "count";
  readonly numerator_to_base: 1;
  readonly source_unit_code: "piece";
  readonly unit_code: "UNIT";
}>
export type CatalogMasterRegistryVersion = Readonly<{
  readonly authored_safety_row_count: number | null;
  readonly authored_sensory_row_count: number | null;
  readonly master_count: number;
  readonly package_fingerprint: string;
  readonly package_version: string;
  readonly registry_version: number;
  readonly safety_registry_version: number;
  readonly sensory_profile_count: number;
  readonly source_archive_sha256: string;
  readonly source_locale: "es";
  readonly spanish_names_sha256: string;
  readonly spanish_names_version: string;
}>
export type CatalogMediaDelivery = Readonly<{
  readonly byte_size: number;
  readonly content_type: "image/jpeg" | "image/png" | "image/webp";
  readonly content_version: number | null;
  readonly contract: "exylon.catalog.media-delivery@1.0";
  readonly delivery_url: string;
  readonly height?: number;
  readonly master_sha256_digest?: string;
  readonly media_id: string;
  readonly photo_crop?: Readonly<{
    readonly height: number;
    readonly left: number;
    readonly top: number;
    readonly width: number;
  }>;
  readonly photo_rendition?: "card" | "detail" | "source";
  readonly restaurant_id: string;
  readonly sha256_digest: string;
  readonly version: number;
  readonly width?: number;
}>
export type CatalogMediaDeliveryRequest = Readonly<{
  readonly content_version: number | null;
  readonly digest: string;
  readonly editor_intent_id?: string;
  readonly photo_rendition?: "card" | "detail" | "source";
  readonly version: number;
}>
export type CatalogMediaObject = Readonly<{
  readonly alt_text: string;
  readonly byte_size: number;
  readonly content_type: string;
  readonly height: number | null;
  readonly id: string;
  readonly lifecycle: "staged" | "ready" | "retired" | "gc_pending";
  readonly object_ref: string;
  readonly sha256_digest: string;
  readonly version: number;
  readonly width: number | null;
}>
export type CatalogMediaRenditions = Readonly<{
  readonly content_version: number | null;
  readonly contract: "exylon.catalog.media-renditions@1.0";
  readonly glow: string;
  readonly media_id: string;
  readonly renditions: Readonly<{
    readonly card: Readonly<{
      readonly byte_size: number;
      readonly height: number;
      readonly url: string;
      readonly width: number;
    }>;
    readonly detail: Readonly<{
      readonly byte_size: number;
      readonly height: number;
      readonly url: string;
      readonly width: number;
    }>;
    readonly staff: Readonly<{
      readonly byte_size: number;
      readonly height: number;
      readonly url: string;
      readonly width: number;
    }>;
    readonly thumb: Readonly<{
      readonly byte_size: number;
      readonly height: number;
      readonly url: string;
      readonly width: number;
    }>;
  }>;
  readonly restaurant_id: string;
  readonly sha256_digest: string;
  readonly version: number;
}>
export type CatalogMediaRenditionsRequest = Readonly<{
  readonly digest: string;
  readonly version: number;
}>
export type CatalogMenuSection = Readonly<{
  readonly available: boolean;
  readonly id: string;
  readonly internal_name: string;
  readonly sort_order: number;
  readonly version: number;
}>
export type CatalogModifierGroup = Readonly<{
  readonly available: boolean;
  readonly course_codes: readonly (string)[];
  readonly id: string;
  readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
  readonly name: string;
  readonly selection_max: number;
  readonly selection_min: number;
  readonly sort_order: number;
  readonly version: number;
}>
export type CatalogModifierOption = Readonly<{
  readonly adds_no_ingredients?: true;
  readonly available: boolean;
  readonly currency: "EUR";
  readonly id: string;
  readonly media_object_id: string | null;
  readonly name: string;
  readonly price_delta_minor: number;
  readonly version: number;
}>
export type CatalogModifierOptionDietaryAssessment = Readonly<{
  readonly confidence: number;
  readonly coverage: number;
  readonly diet_tag_id: string;
  readonly explanation: string;
  readonly input_fingerprint: string;
  readonly modifier_option_id: string;
  readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
  readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
  readonly version: number;
}>
export type CatalogModifierOptionIngredientDemand = Readonly<{
  readonly ingredients: readonly (Readonly<{
      readonly base_unit_code: string;
      readonly denominator_to_base: number;
      readonly denominator_to_canonical_base: number;
      readonly dimension: "mass" | "volume" | "count";
      readonly ingredient_concept_id: string | null;
      readonly ingredient_concept_version: number | null;
      readonly ingredient_id: string;
      readonly ingredient_mapping_coverage: "verified" | "incomplete" | "unknown";
      readonly ingredient_mapping_version: number | null;
      readonly input_fingerprint: string;
      readonly inventory_rule: "deducts" | "inform_only";
      readonly modifier_option_version: number | null;
      readonly numerator_to_base: number;
      readonly numerator_to_canonical_base: number;
      readonly publication_version: number;
      readonly quantity_base_units: number;
      readonly recipe_version: number | null;
      readonly restaurant_ingredient_active: boolean;
      readonly restaurant_ingredient_version: number;
      readonly safety_registry_version: number;
      readonly source_version: number;
      readonly unit_definition_version: number;
    }>)[];
  readonly input_fingerprint: string;
  readonly modifier_option_id: string;
  readonly modifier_option_version: number;
}>
export type CatalogPhotoCorrectionApplied = Readonly<{
  readonly change: CatalogPhotoCorrectionChange;
  readonly source_receipt_id: string;
}>
export type CatalogPhotoCorrectionApplyRequest = Readonly<{
  readonly review: CatalogPhotoCorrectionReview;
}>
export type CatalogPhotoCorrectionChange = Readonly<{
  readonly action: "apply" | "undo";
  readonly applied_draft_revision: number;
  readonly applied_media_version: number;
  readonly change_hash: string;
  readonly contract: "exylon.catalog.photo-correction-change@1.0";
  readonly published: false;
  readonly review: CatalogPhotoCorrectionReview;
}>
export type CatalogPhotoCorrectionReview = Readonly<{
  readonly after: Readonly<{
    readonly media_id: string;
    readonly sha256_digest: string;
    readonly version: number;
  }>;
  readonly allowed_field: "dish_media.primary_photo";
  readonly authoritative: false;
  readonly before: Readonly<{
    readonly media_id: string;
    readonly sha256_digest: string;
    readonly version: number;
  }> | null;
  readonly contract: "exylon.catalog.photo-correction-review@1.0";
  readonly dish_id: string;
  readonly dish_version: number;
  readonly draft_revision: number;
  readonly editor_intent_id: string;
  readonly published: false;
  readonly published_version: number;
  readonly recipe_fingerprint: string;
  readonly restaurant_id: string;
  readonly review_hash: string;
  readonly tenant_id: string;
}>
export type CatalogPhotoCorrectionReviewRequest = Readonly<{
  readonly candidate: Readonly<{
    readonly media_id: string;
    readonly sha256_digest: string;
    readonly version: number;
  }>;
  readonly dish_id: string;
  readonly editor_intent_id: string;
  readonly expected_dish_version: number;
  readonly expected_draft_revision: number;
  readonly expected_published_version: number;
}>
export type CatalogPhotoCorrectionUndoRequest = Readonly<{
  readonly change: CatalogPhotoCorrectionChange;
}>
export type CatalogPhotoStyle = "natural" | "taberna" | "mediterraneo" | "brasa" | "gastrobar" | "alta_cocina" | "brunch" | "trattoria" | "minimal"
export type CatalogPosPublishedRouting = Readonly<{
  readonly contract: "exylon.catalog.pos-published-routing@1.0";
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly section_categories: readonly (Readonly<{
      readonly category_id: string;
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly sections: readonly (Readonly<{
      readonly available: boolean;
      readonly id: string;
      readonly internal_name: string;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly tenant_id: string;
}>
export type CatalogPreauthenticatedDish = Readonly<{
  readonly active: boolean;
  readonly allergens: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly available: boolean;
  readonly category_id: string;
  readonly contract: "exylon.catalog.preauthenticated-dish@1.0";
  readonly currency: "EUR";
  readonly description: string;
  readonly diet_tags: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly dietary_assessments: readonly (Readonly<{
      readonly confidence: number;
      readonly coverage: number;
      readonly diet_tag_id: string;
      readonly dish_id: string;
      readonly explanation: string;
      readonly input_fingerprint: string;
      readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
      readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
      readonly version: number;
    }>)[];
  readonly dish_id: string;
  readonly first_published_at: string;
  readonly media: readonly (CatalogPublicMediaReference)[];
  readonly modifier_groups: readonly (Readonly<{
      readonly available: boolean;
      readonly course_codes: readonly (string)[];
      readonly id: string;
      readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
      readonly name: string;
      readonly options: readonly (Readonly<{
          readonly adds_no_ingredients?: true;
          readonly allergens: readonly (Readonly<{
              readonly active: boolean;
              readonly code: string;
              readonly description: string;
              readonly id: string;
              readonly name: string;
              readonly version: number;
            }>)[];
          readonly available: boolean;
          readonly currency: "EUR";
          readonly id: string;
          readonly ingredients: readonly (CatalogPublicIngredientReference)[];
          readonly is_default: boolean;
          readonly media: CatalogPublicMediaReference | null;
          readonly media_object_id: string | null;
          readonly name: string;
          readonly price_delta_minor: number;
          readonly safety: CatalogPublicSafetyOutcome;
          readonly sort_order: number;
          readonly translations: readonly (Readonly<{
              readonly description: string;
              readonly entity_id: string;
              readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
              readonly locale: string;
              readonly name: string;
            }>)[];
          readonly version: number;
        }>)[];
      readonly selection_max: number;
      readonly selection_min: number;
      readonly sort_order: number;
      readonly translations: readonly (Readonly<{
          readonly description: string;
          readonly entity_id: string;
          readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
          readonly locale: string;
          readonly name: string;
        }>)[];
      readonly version: number;
    }>)[];
  readonly name: string;
  readonly placements: readonly (Readonly<{
      readonly available: boolean;
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly preparation_choices: readonly (Readonly<{
      readonly available: boolean;
      readonly code: string;
      readonly default_selected: boolean;
      readonly dish_id: string;
      readonly id: string;
      readonly name: string;
      readonly semantic_provenance: string;
      readonly semantic_version: number;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly preparation_time_minutes: number | null;
  readonly price_minor: number;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety: CatalogPublicSafetyOutcome;
  readonly sensory_profile: Readonly<{
    readonly basis_version: string;
    readonly confidence: number;
    readonly coverage: number;
    readonly density_defaulted: boolean;
    readonly derivation_status: "available" | "unavailable";
    readonly dimensions: readonly (Readonly<{
        readonly confidence: number;
        readonly dimension_code: string;
        readonly dimension_label?: string;
        readonly group_code?: string;
        readonly group_label?: string;
        readonly ingredient_score: number;
        readonly layers: Readonly<{
          readonly base: number;
          readonly preparation: number;
          readonly seasoning: number;
        }>;
        readonly preparation_delta: number;
        readonly score: number;
        readonly sources: readonly (Readonly<{
            readonly confidence: number;
            readonly contribution: number;
            readonly source_code: string;
            readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
          }>)[];
      }>)[];
    readonly dish_id: string;
    readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
    readonly flavour_tags: readonly (Readonly<{
        readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
        readonly confidence: number;
        readonly dominant_layer: "base" | "preparation" | "seasoning";
        readonly score: number;
      }>)[];
    readonly input_fingerprint: string;
    readonly profile_version: number;
    readonly provenance: string;
    readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
  }> | null;
  readonly sort_order: number;
  readonly star_dish: boolean;
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
  readonly version: number;
}>
export type CatalogPreauthenticatedFeatured = Readonly<{
  readonly categories: readonly (Readonly<{
      readonly active: boolean;
      readonly department_id?: string | null;
      readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
      readonly featured: boolean;
      readonly icon: string | null;
      readonly id: string;
      readonly internal_name: string;
      readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
      readonly media: CatalogPublicMediaReference | null;
      readonly media_object_id: string | null;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.catalog.preauthenticated-featured@1.0";
  readonly dishes: readonly (CatalogPreauthenticatedDish)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety_fingerprint: string;
  readonly safety_registry_version: number;
}>
export type CatalogPreauthenticatedMediaDelivery = Readonly<{
  readonly byte_size: number;
  readonly content_type: "image/jpeg" | "image/png" | "image/webp";
  readonly content_version: number;
  readonly contract: "exylon.catalog.preauthenticated-media-delivery@1.0";
  readonly delivery_url: string;
  readonly media_id: string;
  readonly restaurant_id: string;
  readonly sha256_digest: string;
  readonly version: number;
}>
export type CatalogPreauthenticatedMediaDeliveryRequest = Readonly<{
  readonly content_version: number;
  readonly digest: string;
  readonly scan_ticket: string;
  readonly table_id: string;
  readonly version: number;
}>
export type CatalogPreparationChoice = Readonly<{
  readonly available: boolean;
  readonly code: string;
  readonly default_selected: boolean;
  readonly dish_id: string;
  readonly id: string;
  readonly name: string;
  readonly semantic_provenance: string;
  readonly semantic_version: number;
  readonly sort_order: number;
  readonly version: number;
}>
export type CatalogProvisionalMedia = Readonly<{
  readonly alt_text: string;
  readonly byte_size: number;
  readonly content_type: "image/jpeg" | "image/png" | "image/webp";
  readonly contract: "exylon.catalog.provisional-media@1.0";
  readonly editor_intent_id: string;
  readonly expires_at: string;
  readonly height: number;
  readonly media_id: string;
  readonly provisional_version: number;
  readonly restaurant_id: string;
  readonly sha256_digest: string;
  readonly width: number;
}>
export type CatalogProvisionalMediaAbandonment = Readonly<{
  readonly abandoned_media_ids: readonly (string)[];
  readonly contract: "exylon.catalog.provisional-media-abandonment@1.0";
  readonly editor_intent_id: string;
  readonly restaurant_id: string;
  readonly retained_media_ids: readonly (string)[];
}>
export type CatalogProvisionalMediaClaim = Readonly<{
  readonly expected_version: number;
  readonly media_id: string;
  readonly sha256_digest: string;
}>
export type CatalogPublication = Readonly<{
  readonly content: Readonly<{
    readonly allergens: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly categories: readonly (Readonly<{
        readonly active: boolean;
        readonly department_id?: string | null;
        readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
        readonly featured: boolean;
        readonly icon: string | null;
        readonly id: string;
        readonly internal_name: string;
        readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
        readonly media_object_id: string | null;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly diet_tags: readonly (Readonly<{
        readonly active: boolean;
        readonly code: string;
        readonly description: string;
        readonly id: string;
        readonly name: string;
        readonly version: number;
      }>)[];
    readonly dietary_assessments: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly dish_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly dish_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly dish_diet_tags: readonly (Readonly<{
        readonly diet_tag_id: string;
        readonly dish_id: string;
        readonly source: "manual" | "deterministic";
      }>)[];
    readonly dish_media: readonly (Readonly<{
        readonly dish_id: string;
        readonly media_object_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_modifier_groups: readonly (Readonly<{
        readonly dish_id: string;
        readonly modifier_group_id: string;
        readonly sort_order: number;
      }>)[];
    readonly dish_sensory_profiles: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly coverage: number;
        readonly density_defaulted: boolean;
        readonly derivation_status: "available" | "unavailable";
        readonly dimensions: readonly (Readonly<{
            readonly confidence: number;
            readonly dimension_code: string;
            readonly dimension_label?: string;
            readonly group_code?: string;
            readonly group_label?: string;
            readonly ingredient_score: number;
            readonly layers: Readonly<{
              readonly base: number;
              readonly preparation: number;
              readonly seasoning: number;
            }>;
            readonly preparation_delta: number;
            readonly score: number;
            readonly sources: readonly (Readonly<{
                readonly confidence: number;
                readonly contribution: number;
                readonly source_code: string;
                readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
              }>)[];
          }>)[];
        readonly dish_id: string;
        readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
        readonly flavour_tags: readonly (Readonly<{
            readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
            readonly confidence: number;
            readonly dominant_layer: "base" | "preparation" | "seasoning";
            readonly score: number;
          }>)[];
        readonly input_fingerprint: string;
        readonly profile_version: number;
        readonly provenance: string;
        readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
      }>)[];
    readonly dishes: readonly (Readonly<{
        readonly active: boolean;
        readonly available: boolean;
        readonly bottle_dish_id?: string | null;
        readonly category_id: string;
        readonly currency: "EUR";
        readonly id: string;
        readonly internal_name: string;
        readonly preparation_time_minutes: number | null;
        readonly price_minor: number;
        readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
        readonly seasoning_style_codes: readonly (string)[];
        readonly sort_order: number;
        readonly star_dish?: boolean;
        readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
        readonly version: number;
      }>)[];
    readonly ingredient_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly ingredient_id: string;
        readonly presence: "contains" | "may_contain";
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_concept_mappings: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly concept_id: string | null;
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly ingredient_id: string;
        readonly provenance: string;
        readonly registry_version: number;
        readonly version: number;
      }>)[];
    readonly ingredient_diet_properties: readonly (Readonly<{
        readonly conflicts: boolean;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly ingredient_id: string;
        readonly property_code: string;
        readonly provenance: string;
        readonly version: number;
      }>)[];
    readonly ingredient_sensory_profiles: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimensions: readonly (Readonly<{
            readonly confidence: number;
            readonly dimension_code: string;
            readonly score: number;
          }>)[];
        readonly ingredient_id: string;
        readonly profile_version: number;
        readonly provenance: string;
      }>)[];
    readonly ingredients: readonly (Readonly<{
        readonly active: boolean;
        readonly base_unit_code: string;
        readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly density_g_per_ml: number | null;
        readonly description: string;
        readonly id: string;
        readonly mass_per_unit_mg: number | null;
        readonly name: string;
        readonly seasoning_signature: readonly (Readonly<{
            readonly delta: number;
            readonly dimension_code: string;
          }>)[];
        readonly version: number;
      }>)[];
    readonly media_objects: readonly (CatalogMediaObject)[];
    readonly menu_items: readonly (Readonly<{
        readonly available: boolean;
        readonly dish_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_group_options: readonly (Readonly<{
        readonly is_default: boolean;
        readonly modifier_group_id: string;
        readonly modifier_option_id: string;
        readonly sort_order: number;
      }>)[];
    readonly modifier_groups: readonly (Readonly<{
        readonly available: boolean;
        readonly course_codes: readonly (string)[];
        readonly id: string;
        readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
        readonly name: string;
        readonly selection_max: number;
        readonly selection_min: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly modifier_option_allergens: readonly (Readonly<{
        readonly allergen_id: string;
        readonly modifier_option_id: string;
        readonly presence: "contains" | "may_contain";
        readonly source: "manual" | "ingredient" | "modifier_option";
      }>)[];
    readonly modifier_option_dietary_assessments: readonly (Readonly<{
        readonly confidence: number;
        readonly coverage: number;
        readonly diet_tag_id: string;
        readonly explanation: string;
        readonly input_fingerprint: string;
        readonly modifier_option_id: string;
        readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
        readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
        readonly version: number;
      }>)[];
    readonly modifier_option_ingredients: readonly (Readonly<{
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly modifier_option_id: string;
        readonly quantity_base_units: number;
        readonly unit_code: string;
      }>)[];
    readonly modifier_options: readonly (Readonly<{
        readonly adds_no_ingredients?: true;
        readonly available: boolean;
        readonly currency: "EUR";
        readonly id: string;
        readonly media_object_id: string | null;
        readonly name: string;
        readonly price_delta_minor: number;
        readonly version: number;
      }>)[];
    readonly preparation_choices: readonly (Readonly<{
        readonly available: boolean;
        readonly code: string;
        readonly default_selected: boolean;
        readonly dish_id: string;
        readonly id: string;
        readonly name: string;
        readonly semantic_provenance: string;
        readonly semantic_version: number;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly preparation_sensory_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly preparation_semantic_version: number;
        readonly provenance: string;
      }>)[];
    readonly recipe_lines: readonly (Readonly<{
        readonly dish_id: string;
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly preparation_code: string | null;
        readonly quantity_base_units: number;
        readonly recipe_version: number;
        readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        readonly unit_code: string;
      }>)[];
    readonly safety_derivations: readonly (Readonly<{
        readonly allergen_coverage: "verified" | "incomplete" | "unknown";
        readonly allergens: readonly (Readonly<{
            readonly allergen_id: string;
            readonly inherited_ingredient_ids: readonly (string)[];
            readonly manual_caution: boolean;
            readonly presence: "contains" | "may_contain";
          }>)[];
        readonly contract: "exylon.catalog.safety-derivation@1.0";
        readonly coverage: "verified" | "incomplete" | "unknown";
        readonly derivation_fingerprint: string;
        readonly diet_coverage: "verified" | "incomplete" | "unknown";
        readonly diets: readonly (Readonly<{
            readonly contradictory_ingredient_ids: readonly (string)[];
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_tag_id: string;
            readonly status: "verified" | "conflict" | "incomplete" | "unknown";
            readonly unverified_ingredient_ids: readonly (string)[];
          }>)[];
        readonly ingredient_inputs: readonly (Readonly<{
            readonly allergen_coverage: "verified" | "incomplete" | "unknown";
            readonly allergen_fact_versions: readonly (Readonly<{
                readonly allergen_id: string;
                readonly presence: "contains" | "may_contain";
                readonly version: number;
              }>)[];
            readonly concept_id: string | null;
            readonly concept_version: number | null;
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_coverage: "verified" | "incomplete" | "unknown";
            readonly diet_fact_versions: readonly (Readonly<{
                readonly conflicts: boolean;
                readonly diet_tag_id: string;
                readonly version: number;
              }>)[];
            readonly ingredient_id: string;
            readonly ingredient_version: number;
            readonly mapping_version: number | null;
            readonly provenance: string;
          }>)[];
        readonly input_fingerprint: string;
        readonly registry_fingerprint: string;
        readonly registry_version: number;
        readonly subject_id: string;
        readonly subject_type: "dish" | "modifier_option";
        readonly unverified_allergen_ids: readonly (string)[];
      }>)[];
    readonly safety_registry_version: number;
    readonly seasoning_style_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly provenance: string;
        readonly seasoning_style_code: string;
      }>)[];
    readonly section_categories: readonly (Readonly<{
        readonly category_id: string;
        readonly section_id: string;
        readonly sort_order: number;
      }>)[];
    readonly sections: readonly (Readonly<{
        readonly available: boolean;
        readonly id: string;
        readonly internal_name: string;
        readonly sort_order: number;
        readonly version: number;
      }>)[];
    readonly sensory_bases: readonly (Readonly<{
        readonly basis_version: string;
        readonly provenance: string;
        readonly status: "active" | "retired";
        readonly version: number;
      }>)[];
    readonly sensory_dimensions: readonly (Readonly<{
        readonly basis_version: string;
        readonly code: string;
        readonly dimension_label?: string;
        readonly group_code: string;
        readonly group_label?: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly served_form_sensory_modifiers: readonly (Readonly<{
        readonly basis_version: string;
        readonly confidence: number;
        readonly dimension_code: string;
        readonly modifier: number;
        readonly preparation_code: string;
        readonly provenance: string;
      }>)[];
    readonly translations: readonly (Readonly<{
        readonly description: string;
        readonly entity_id: string;
        readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
        readonly locale: string;
        readonly name: string;
      }>)[];
    readonly unit_definitions: readonly (Readonly<{
        readonly denominator_to_base: number;
        readonly dimension: "mass" | "volume" | "count";
        readonly numerator_to_base: number;
        readonly unit_code: string;
        readonly version: number;
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.catalog.publication@1.0";
  readonly publication_version: number;
  readonly published_at: string;
  readonly published_by: string;
  readonly restaurant_id: string;
  readonly safety_fingerprint: string;
  readonly safety_registry_version: number;
  readonly source_draft_revision: number;
  readonly tenant_id: string;
  readonly trial_dishes_left_out?: readonly (Readonly<{
      readonly dish_id: string;
      readonly dish_name: string;
      readonly trial_date: string;
      readonly trial_id: string;
    }>)[];
}>
export type CatalogPublicationPage = Readonly<{
  readonly contract: "exylon.catalog.publication-page@1.0";
  readonly items: readonly (CatalogPublicationSummary)[];
  readonly next_before_version: number | null;
}>
export type CatalogPublicationReceipt = Readonly<{
  readonly change_summary: Readonly<{
    readonly draft_revision: number;
    readonly entities: readonly (Readonly<{
        readonly change: "added" | "changed";
        readonly id: string;
        readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
      }>)[];
    readonly families: readonly (Readonly<{
        readonly added: number;
        readonly changed: number;
        readonly family: "dishes" | "categories" | "modifier_options" | "modifier_groups" | "sections";
        readonly removed: number;
      }>)[];
    readonly other_changed: boolean;
    readonly published_version: number;
    readonly removed: readonly (Readonly<{
        readonly id: string;
        readonly kind: "dish" | "category" | "modifier_option" | "modifier_group" | "section";
      }>)[];
    readonly total: number;
  }> | null;
  readonly content_hash: string;
  readonly contract: "exylon.catalog.publication-receipt@1.0";
  readonly publication_version: number;
  readonly published_at: string;
  readonly published_by: string;
  readonly restaurant_id: string;
  readonly source_draft_revision: number;
  readonly tenant_id: string;
  readonly trial_dishes_left_out?: readonly (Readonly<{
      readonly dish_id: string;
      readonly dish_name: string;
      readonly trial_date: string;
      readonly trial_id: string;
    }>)[];
}>
export type CatalogPublicationSummary = Readonly<{
  readonly content_hash: string;
  readonly contract: "exylon.catalog.publication-summary@1.0";
  readonly publication_version: number;
  readonly published_at: string;
  readonly published_by: string;
  readonly restaurant_id: string;
  readonly source_draft_revision: number;
  readonly tenant_id: string;
}>
export type CatalogPublicIngredientReference = Readonly<{
  readonly allergen_coverage: "verified" | "incomplete" | "unknown";
  readonly contract: "exylon.catalog.public-ingredient-reference@1.0";
  readonly coverage: "verified" | "incomplete" | "unknown";
  readonly diet_coverage: "verified" | "incomplete" | "unknown";
  readonly name: string;
}>
export type CatalogPublicMediaReference = Readonly<{
  readonly alt_text: string;
  readonly byte_size: number;
  readonly content_type: string;
  readonly height: number | null;
  readonly id: string;
  readonly lifecycle: "staged" | "ready" | "retired" | "gc_pending";
  readonly sha256_digest: string;
  readonly version: number;
  readonly width: number | null;
}>
export type CatalogPublicSafetyOutcome = Readonly<{
  readonly allergen_coverage: "verified" | "incomplete" | "unknown";
  readonly allergen_outcomes: readonly (Readonly<{
      readonly allergen_id: string;
      readonly code: string;
      readonly name: string;
      readonly presence: "contains" | "may_contain";
      readonly source_ingredients: readonly (Readonly<{
          readonly name: string;
        }>)[];
    }>)[];
  readonly contract: "exylon.catalog.public-safety-outcome@1.0";
  readonly coverage: "verified" | "incomplete" | "unknown";
  readonly diet_coverage: "verified" | "incomplete" | "unknown";
  readonly diet_outcomes: readonly (Readonly<{
      readonly blocking_ingredients: readonly (Readonly<{
          readonly name: string;
        }>)[];
      readonly code: string;
      readonly diet_id: string;
      readonly name: string;
      readonly status: "verified" | "conflict" | "incomplete" | "unknown";
    }>)[];
  readonly fingerprint: string;
  readonly unverified_allergens: readonly (Readonly<{
      readonly allergen_id: string;
      readonly code: string;
      readonly name: string;
    }>)[];
}>
export type CatalogPublishedCatalogue = Readonly<{
  readonly categories: readonly (Readonly<{
      readonly active: boolean;
      readonly department_id?: string | null;
      readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
      readonly featured: boolean;
      readonly icon: string | null;
      readonly id: string;
      readonly internal_name: string;
      readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
      readonly media: CatalogPublicMediaReference | null;
      readonly media_object_id: string | null;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.catalog.published-catalogue@1.0";
  readonly dishes: readonly (CatalogPublishedDish)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety_fingerprint: string;
  readonly safety_registry_version: number;
  readonly sections: readonly (Readonly<{
      readonly available: boolean;
      readonly id: string;
      readonly internal_name: string;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly tenant_id: string;
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
}>
export type CatalogPublishedCategory = Readonly<{
  readonly active: boolean;
  readonly department_id?: string | null;
  readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
  readonly featured: boolean;
  readonly icon: string | null;
  readonly id: string;
  readonly internal_name: string;
  readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
  readonly media: CatalogPublicMediaReference | null;
  readonly media_object_id: string | null;
  readonly sort_order: number;
  readonly version: number;
}>
export type CatalogPublishedCourseSection = Readonly<{
  readonly category_ids: readonly (string)[];
  readonly section_id: string;
  readonly sort_order: number;
}>
export type CatalogPublishedDish = Readonly<{
  readonly active: boolean;
  readonly allergens: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly available: boolean;
  readonly category_id: string;
  readonly contract: "exylon.catalog.published-dish@1.0";
  readonly currency: "EUR";
  readonly description: string;
  readonly diet_tags: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly dietary_assessments: readonly (Readonly<{
      readonly confidence: number;
      readonly coverage: number;
      readonly diet_tag_id: string;
      readonly dish_id: string;
      readonly explanation: string;
      readonly input_fingerprint: string;
      readonly source: "manual" | "ingredient_rules" | "nutrition_rules";
      readonly status: "verified" | "not_verified" | "conflict" | "incomplete" | "unknown";
      readonly version: number;
    }>)[];
  readonly dish_id: string;
  readonly first_published_at: string;
  readonly media: readonly (CatalogPublicMediaReference)[];
  readonly modifier_groups: readonly (Readonly<{
      readonly available: boolean;
      readonly course_codes: readonly (string)[];
      readonly id: string;
      readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
      readonly name: string;
      readonly options: readonly (Readonly<{
          readonly adds_no_ingredients?: true;
          readonly allergens: readonly (Readonly<{
              readonly active: boolean;
              readonly code: string;
              readonly description: string;
              readonly id: string;
              readonly name: string;
              readonly version: number;
            }>)[];
          readonly available: boolean;
          readonly currency: "EUR";
          readonly id: string;
          readonly ingredients: readonly (CatalogPublicIngredientReference)[];
          readonly is_default: boolean;
          readonly media: CatalogPublicMediaReference | null;
          readonly media_object_id: string | null;
          readonly name: string;
          readonly price_delta_minor: number;
          readonly safety: CatalogPublicSafetyOutcome;
          readonly sort_order: number;
          readonly translations: readonly (Readonly<{
              readonly description: string;
              readonly entity_id: string;
              readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
              readonly locale: string;
              readonly name: string;
            }>)[];
          readonly version: number;
        }>)[];
      readonly selection_max: number;
      readonly selection_min: number;
      readonly sort_order: number;
      readonly translations: readonly (Readonly<{
          readonly description: string;
          readonly entity_id: string;
          readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
          readonly locale: string;
          readonly name: string;
        }>)[];
      readonly version: number;
    }>)[];
  readonly name: string;
  readonly placements: readonly (Readonly<{
      readonly available: boolean;
      readonly section_id: string;
      readonly sort_order: number;
    }>)[];
  readonly preparation_choices: readonly (Readonly<{
      readonly available: boolean;
      readonly code: string;
      readonly default_selected: boolean;
      readonly dish_id: string;
      readonly id: string;
      readonly name: string;
      readonly semantic_provenance: string;
      readonly semantic_version: number;
      readonly sort_order: number;
      readonly version: number;
    }>)[];
  readonly preparation_time_minutes: number | null;
  readonly price_minor: number;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly safety: CatalogPublicSafetyOutcome;
  readonly sensory_profile: Readonly<{
    readonly basis_version: string;
    readonly confidence: number;
    readonly coverage: number;
    readonly density_defaulted: boolean;
    readonly derivation_status: "available" | "unavailable";
    readonly dimensions: readonly (Readonly<{
        readonly confidence: number;
        readonly dimension_code: string;
        readonly dimension_label?: string;
        readonly group_code?: string;
        readonly group_label?: string;
        readonly ingredient_score: number;
        readonly layers: Readonly<{
          readonly base: number;
          readonly preparation: number;
          readonly seasoning: number;
        }>;
        readonly preparation_delta: number;
        readonly score: number;
        readonly sources: readonly (Readonly<{
            readonly confidence: number;
            readonly contribution: number;
            readonly source_code: string;
            readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
          }>)[];
      }>)[];
    readonly dish_id: string;
    readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
    readonly flavour_tags: readonly (Readonly<{
        readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
        readonly confidence: number;
        readonly dominant_layer: "base" | "preparation" | "seasoning";
        readonly score: number;
      }>)[];
    readonly input_fingerprint: string;
    readonly profile_version: number;
    readonly provenance: string;
    readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
  }> | null;
  readonly sort_order: number;
  readonly star_dish: boolean;
  readonly tenant_id: string;
  readonly translations: readonly (Readonly<{
      readonly description: string;
      readonly entity_id: string;
      readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
      readonly locale: string;
      readonly name: string;
    }>)[];
  readonly version: number;
}>
export type CatalogPublishedIngredientUsageItem = Readonly<{
  readonly dish_id: string;
  readonly dish_name: string | null;
  readonly provenance_kind: "dish_recipe";
}> | Readonly<{
  readonly dish_id: string;
  readonly dish_name: string | null;
  readonly modifier_group_id: string;
  readonly modifier_group_name: string | null;
  readonly modifier_option_id: string;
  readonly modifier_option_name: string | null;
  readonly provenance_kind: "modifier_option_recipe";
}>
export type CatalogPublishedIngredientUsagePage = Readonly<{
  readonly catalog_content_hash: string;
  readonly catalog_ingredient_id: string;
  readonly catalog_publication_version: number;
  readonly contract: "exylon.catalog.published-ingredient-usage@1.0";
  readonly items: readonly (Readonly<{
      readonly dish_id: string;
      readonly dish_name: string | null;
      readonly provenance_kind: "dish_recipe";
    }> | Readonly<{
      readonly dish_id: string;
      readonly dish_name: string | null;
      readonly modifier_group_id: string;
      readonly modifier_group_name: string | null;
      readonly modifier_option_id: string;
      readonly modifier_option_name: string | null;
      readonly provenance_kind: "modifier_option_recipe";
    }>)[];
  readonly locale: "es";
  readonly next_cursor: string | null;
  readonly restaurant_id: string;
  readonly stock_item_id: string;
  readonly tenant_id: string;
  readonly total_count: number;
}>
export type CatalogPublishedInventoryIngredientFact = Readonly<{
  readonly active: boolean;
  readonly base_unit_code: string;
  readonly catalog_unit_definition_version: number;
  readonly catalog_unit_denominator_to_base: number;
  readonly catalog_unit_numerator_to_base: number;
  readonly contract: "exylon.catalog.published-inventory-ingredient@1.0";
  readonly dimension: "mass" | "volume" | "count";
  readonly ingredient_concept_id: string | null;
  readonly ingredient_concept_version: number | null;
  readonly ingredient_id: string;
  readonly ingredient_mapping_coverage: "verified" | "incomplete" | "unknown";
  readonly ingredient_mapping_version: number | null;
  readonly input_fingerprint: string;
  readonly name: string;
  readonly publication_content_hash: string;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly restaurant_ingredient_version: number;
  readonly safety_registry_version: number;
  readonly tenant_id: string;
}>
export type CatalogPublishedMediaDeliveryRequest = Readonly<{
  readonly digest: string;
  readonly version: number;
}>
export type CatalogPublishFinding = Readonly<{
  readonly allergen_code: string | null;
  readonly code: string;
  readonly field: string | null;
  readonly ingredient_id: string | null;
  readonly ingredient_name: string | null;
  readonly path: string;
  readonly subject_id: string | null;
  readonly subject_name: string | null;
  readonly subject_type: "dish" | "modifier_option" | "ingredient" | "category" | "section" | "catalog";
  readonly text: string;
}>
export type CatalogPublishRefusedHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly actions: readonly ("refresh_draft" | "open_item")[];
    readonly draft_equals_publication: boolean;
    readonly draft_revision: number;
    readonly errorCode: "CATALOG_PUBLISH_REFUSED";
    readonly findings: readonly (Readonly<{
        readonly allergen_code: string | null;
        readonly code: string;
        readonly field: string | null;
        readonly ingredient_id: string | null;
        readonly ingredient_name: string | null;
        readonly path: string;
        readonly subject_id: string | null;
        readonly subject_name: string | null;
        readonly subject_type: "dish" | "modifier_option" | "ingredient" | "category" | "section" | "catalog";
        readonly text: string;
      }>)[];
    readonly findings_total: number;
    readonly published_version: number;
    readonly reason_code: "draft_invalid" | "draft_stale" | "dish_in_trial";
    readonly reason_text: string;
  }>;
  readonly message: string;
  readonly statusCode: 400;
}>
export type CatalogRecipeCoverage = Readonly<{
  readonly contract: "exylon.catalog.recipe-coverage@1.0";
  readonly coverage: Readonly<{
    readonly status: "available";
    readonly value: Readonly<{
      readonly active_dish_count: number;
      readonly dishes: readonly (Readonly<{
          readonly dish_id: string;
          readonly name: string;
          readonly recipe_line_count: number;
          readonly state: "no_recipe" | "partial";
        }>)[];
      readonly no_recipe_count: number;
      readonly partial_count: number;
      readonly publication_version: number;
      readonly published_at: string;
      readonly unverified_allergen_count?: number;
    }>;
  }> | Readonly<{
    readonly reason: "catalog_not_published";
    readonly status: "no_data";
  }>;
  readonly population: "active_dishes_of_current_publication";
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogRecipeLine = Readonly<{
  readonly dish_id: string;
  readonly ingredient_id: string;
  readonly inventory_rule: "deducts" | "inform_only";
  readonly preparation_code: string | null;
  readonly quantity_base_units: number;
  readonly recipe_version: number;
  readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
  readonly unit_code: string;
}>
export type CatalogRecipePortions = Readonly<{
  readonly availability_generation: number;
  readonly contract: "exylon.catalog.el-parte-recipe-portions@2.0";
  readonly dishes: readonly (Readonly<{
      readonly coverage: "complete" | "incomplete";
      readonly depleted: boolean;
      readonly dish_id: string;
      readonly dish_version: number;
      readonly menu_active: boolean;
      readonly recipe_lines: readonly (Readonly<{
          readonly base_unit_code: string | null;
          readonly complete: boolean;
          readonly dimension: "mass" | "volume" | "count" | null;
          readonly ingredient_id: string;
          readonly ingredient_name: string | null;
          readonly ingredient_version: number | null;
          readonly inventory_rule: "deducts" | "inform_only";
          readonly quantity_base_units: number;
          readonly unit_definition_version: number | null;
        }>)[];
    }>)[];
  readonly observed_at: string;
  readonly publication_version: number;
  readonly published_at: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogReferenceDocument = Readonly<{
  readonly allergens: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.catalog.reference-document@1.0";
  readonly diet_tags: readonly (Readonly<{
      readonly active: boolean;
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly digest: string;
  readonly ingredient_concept_mappings: readonly (Readonly<{
      readonly allergen_coverage: "verified" | "incomplete" | "unknown";
      readonly concept_id: string | null;
      readonly coverage: "verified" | "incomplete" | "unknown";
      readonly diet_coverage: "verified" | "incomplete" | "unknown";
      readonly ingredient_id: string;
      readonly provenance: string;
      readonly registry_version: number;
      readonly version: number;
    }>)[];
  readonly ingredient_sensory_profiles: readonly (Readonly<{
      readonly basis_version: string;
      readonly confidence: number;
      readonly dimensions: readonly (Readonly<{
          readonly confidence: number;
          readonly dimension_code: string;
          readonly score: number;
        }>)[];
      readonly ingredient_id: string;
      readonly profile_version: number;
      readonly provenance: string;
    }>)[];
  readonly restaurant_id: string;
  readonly sensory_bases: readonly (Readonly<{
      readonly basis_version: string;
      readonly provenance: string;
      readonly status: "active" | "retired";
      readonly version: number;
    }>)[];
  readonly sensory_dimensions: readonly (Readonly<{
      readonly basis_version: string;
      readonly code: string;
      readonly dimension_label?: string;
      readonly group_code: string;
      readonly group_label?: string;
      readonly name: string;
      readonly sort_order: number;
    }>)[];
}>
export type CatalogRepairedMasterHolding = Readonly<{
  readonly decided_at: string;
  readonly dish_id: string;
  readonly dish_name: string;
  readonly extra_name: string | null;
  readonly in_draft: boolean;
  readonly in_published: boolean;
  readonly ingredient_id: string;
  readonly ingredient_name: string;
  readonly kind: "quarantine" | "supersede";
  readonly reason: string;
  readonly replacement_name: string | null;
}>
export type CatalogRepairedMasterHoldings = Readonly<{
  readonly contract: "exylon.catalog.repaired-master-holdings@1.0";
  readonly holdings: readonly (Readonly<{
      readonly decided_at: string;
      readonly dish_id: string;
      readonly dish_name: string;
      readonly extra_name: string | null;
      readonly in_draft: boolean;
      readonly in_published: boolean;
      readonly ingredient_id: string;
      readonly ingredient_name: string;
      readonly kind: "quarantine" | "supersede";
      readonly reason: string;
      readonly replacement_name: string | null;
    }>)[];
  readonly published_version: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type CatalogReviewedPreparation = Readonly<{
  readonly action: "publish" | "undo";
  readonly contract: "exylon.proposals.catalog-reviewed-preparation@1.0";
  readonly intent_hash: string | null;
  readonly intent_id: string | null;
  readonly reason: "source_changed" | "expired" | null;
  readonly request_id: string;
  readonly requested_at: string;
  readonly restaurant_id: string;
  readonly source_receipt_id: string;
  readonly status: "pending" | "prepared" | "unavailable";
  readonly updated_at: string;
  readonly version: number;
}>
export type CatalogReviewedPrepareRequest = Readonly<{
  readonly apply_receipt?: CatalogReviewedPublicationReceipt;
  readonly change: CatalogDishCopyChange | CatalogPhotoCorrectionChange;
  readonly expected_draft_revision: number;
  readonly expected_published_version: number;
  readonly original_intent_id?: string;
  readonly source_receipt_id: string;
}>
export type CatalogReviewedProposalPreview = Readonly<{
  readonly accepted_receipt: CatalogReviewedPublicationReceipt | null;
  readonly action: "publish" | "undo";
  readonly change: CatalogDishCopyChange | CatalogPhotoCorrectionChange;
  readonly dish_id: string;
  readonly expected_draft_revision: number;
  readonly expected_published_version: number;
  readonly field: "copy" | "photo";
  readonly original_apply_receipt: CatalogReviewedPublicationReceipt | null;
  readonly source_receipt_id: string;
}>
export type CatalogReviewedPublicationReceipt = Readonly<{
  readonly action: "apply" | "undo";
  readonly content_hash: string;
  readonly contract: "exylon.catalog.reviewed-publication-receipt@1.0";
  readonly dish_id: string;
  readonly field: "copy" | "photo";
  readonly prior_publication_version: number;
  readonly publication_version: number;
  readonly published: true;
  readonly receipt_hash: string;
  readonly restaurant_id: string;
  readonly source_change_hash: string;
  readonly source_draft_revision: number;
  readonly tenant_id: string;
}>
export type CatalogReviewedPublicationRequest = Readonly<{
  readonly change: CatalogDishCopyChange | CatalogPhotoCorrectionChange;
  readonly expected_published_version: number;
}>
export type CatalogReviewedPublicationUndoRequest = Readonly<{
  readonly change: CatalogDishCopyChange | CatalogPhotoCorrectionChange;
  readonly expected_published_version: number;
  readonly receipt: CatalogReviewedPublicationReceipt;
}>
export type CatalogSafetyDerivation = Readonly<{
  readonly allergen_coverage: "verified" | "incomplete" | "unknown";
  readonly allergens: readonly (Readonly<{
      readonly allergen_id: string;
      readonly inherited_ingredient_ids: readonly (string)[];
      readonly manual_caution: boolean;
      readonly presence: "contains" | "may_contain";
    }>)[];
  readonly contract: "exylon.catalog.safety-derivation@1.0";
  readonly coverage: "verified" | "incomplete" | "unknown";
  readonly derivation_fingerprint: string;
  readonly diet_coverage: "verified" | "incomplete" | "unknown";
  readonly diets: readonly (Readonly<{
      readonly contradictory_ingredient_ids: readonly (string)[];
      readonly coverage: "verified" | "incomplete" | "unknown";
      readonly diet_tag_id: string;
      readonly status: "verified" | "conflict" | "incomplete" | "unknown";
      readonly unverified_ingredient_ids: readonly (string)[];
    }>)[];
  readonly ingredient_inputs: readonly (Readonly<{
      readonly allergen_coverage: "verified" | "incomplete" | "unknown";
      readonly allergen_fact_versions: readonly (Readonly<{
          readonly allergen_id: string;
          readonly presence: "contains" | "may_contain";
          readonly version: number;
        }>)[];
      readonly concept_id: string | null;
      readonly concept_version: number | null;
      readonly coverage: "verified" | "incomplete" | "unknown";
      readonly diet_coverage: "verified" | "incomplete" | "unknown";
      readonly diet_fact_versions: readonly (Readonly<{
          readonly conflicts: boolean;
          readonly diet_tag_id: string;
          readonly version: number;
        }>)[];
      readonly ingredient_id: string;
      readonly ingredient_version: number;
      readonly mapping_version: number | null;
      readonly provenance: string;
    }>)[];
  readonly input_fingerprint: string;
  readonly registry_fingerprint: string;
  readonly registry_version: number;
  readonly subject_id: string;
  readonly subject_type: "dish" | "modifier_option";
  readonly unverified_allergen_ids: readonly (string)[];
}>
export type CatalogSafetyRegistry = Readonly<{
  readonly allergens: readonly (Readonly<{
      readonly aliases: readonly (string)[];
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.catalog.safety-registry@1.0";
  readonly diets: readonly (Readonly<{
      readonly aliases: readonly (string)[];
      readonly code: string;
      readonly description: string;
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly fingerprint: string;
  readonly ingredient_concepts: readonly (Readonly<{
      readonly aliases: readonly (string)[];
      readonly allergen_facts: readonly (Readonly<{
          readonly allergen_id: string;
          readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
          readonly status: "contains" | "may_contain" | "absent" | "unknown";
        }>)[];
      readonly code: string;
      readonly default_unit_code: "MG" | "ML" | "UNIT";
      readonly default_unit_dimension: "mass" | "volume" | "count";
      readonly diet_facts: readonly (Readonly<{
          readonly diet_id: string;
          readonly review: "human_verified" | "owner_approved_import" | "owner_reviewed_authoring" | "unreviewed";
          readonly status: "compatible" | "contradicts" | "unknown";
        }>)[];
      readonly id: string;
      readonly name: string;
      readonly version: number;
    }>)[];
  readonly registry_version: number;
}>
export type CatalogSensoryLabels = Readonly<{
  readonly basis_fingerprint: string;
  readonly basis_version: string;
  readonly dimensions: readonly (Readonly<{
      readonly dimension_code: string;
      readonly group_code: "aroma" | "ingredient_family" | "intensity" | "mouthfeel" | "preparation" | "seasoning_style" | "taste" | "temperature" | "texture";
      readonly label: string;
    }>)[];
  readonly fingerprint: string;
  readonly groups: readonly (Readonly<{
      readonly group_code: "aroma" | "ingredient_family" | "intensity" | "mouthfeel" | "preparation" | "seasoning_style" | "taste" | "temperature" | "texture";
      readonly label: string;
    }>)[];
  readonly labels_version: string;
  readonly locale: "es";
}>
export type CatalogStockDeactivationWarning = Readonly<{
  readonly has_positive_stock: boolean;
  readonly target_id: string;
  readonly target_type: "ingredient" | "dish";
}>
export type CatalogStockDeactivationWarningRequest = Readonly<{
  readonly target_id: string;
  readonly target_type: "ingredient" | "dish";
}>
export type CatalogTranslation = Readonly<{
  readonly description: string;
  readonly entity_id: string;
  readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
  readonly locale: string;
  readonly name: string;
}>
export type CatalogUnitDefinition = Readonly<{
  readonly denominator_to_base: number;
  readonly dimension: "mass" | "volume" | "count";
  readonly numerator_to_base: number;
  readonly unit_code: string;
  readonly version: number;
}>
export type CatalogValidation = Readonly<{
  readonly content_hash: string;
  readonly contract: "exylon.catalog.validation@1.0";
  readonly draft_state?: Readonly<{
    readonly changes: readonly (Readonly<{
        readonly allergen_code: string | null;
        readonly code: string;
        readonly field: string | null;
        readonly ingredient_id: string | null;
        readonly ingredient_name: string | null;
        readonly path: string;
        readonly subject_id: string | null;
        readonly subject_name: string | null;
        readonly subject_type: "dish" | "modifier_option" | "ingredient" | "category" | "section" | "catalog";
        readonly text: string;
      }>)[];
    readonly changes_total: number;
    readonly current: boolean;
    readonly draft_revision: number;
    readonly equals_publication: boolean;
    readonly published_version: number;
    readonly stored_content_hash: string;
  }>;
  readonly errors: readonly (Readonly<{
      readonly code: string;
      readonly message: string;
      readonly path: string;
    }>)[];
  readonly valid: boolean;
  readonly warnings: readonly (Readonly<{
      readonly code: string;
      readonly message: string;
      readonly path: string;
    }>)[];
}>
export type CatalogWorkshopCandidate = Readonly<{
  readonly candidate_id: string;
  readonly contract: "exylon.catalog.workshop-candidate@1.0";
  readonly evaluation: CatalogWorkshopEvaluation;
  readonly guest_visible: false;
  readonly kitchen_observation: string;
  readonly published: false;
  readonly status: "private_candidate";
  readonly trial_id: string;
  readonly verdict: "promising";
  readonly version: 1;
}>
export type CatalogWorkshopEvaluateRequest = Readonly<{
  readonly expected_draft_revision: number;
  readonly expected_published_version: number;
  readonly idea_name: string;
  readonly recipe: Readonly<{
    readonly dish_id: string;
    readonly lines: readonly (Readonly<{
        readonly ingredient_id: string;
        readonly inventory_rule: "deducts" | "inform_only";
        readonly preparation_code: string | null;
        readonly quantity_base_units: number;
        readonly role?: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
      }>)[];
  }>;
}>
export type CatalogWorkshopEvaluation = Readonly<{
  readonly allergen_risks: readonly (Readonly<{
      readonly allergen_id: string;
      readonly inherited_ingredient_ids: readonly (string)[];
      readonly manual_caution: boolean;
      readonly presence: "contains" | "may_contain";
    }>)[];
  readonly authoritative: false;
  readonly candidate_coverage: "incomplete" | "unknown";
  readonly contract: "exylon.catalog.workshop-evaluation@1.0";
  readonly diet_blockers: readonly (Readonly<{
      readonly contradictory_ingredient_ids: readonly (string)[];
      readonly diet_tag_id: string;
      readonly status: "conflict" | "incomplete" | "unknown";
      readonly unverified_ingredient_ids: readonly (string)[];
    }>)[];
  readonly draft_revision: number;
  readonly evaluation_hash: string;
  readonly findings: readonly (string)[];
  readonly guest_visible: false;
  readonly published_version: number;
  readonly recipe_fingerprint: string;
  readonly registry_fingerprint: string;
  readonly registry_version: number;
  readonly request: Readonly<{
    readonly expected_draft_revision: number;
    readonly expected_published_version: number;
    readonly idea_name: string;
    readonly recipe: Readonly<{
      readonly dish_id: string;
      readonly lines: readonly (Readonly<{
          readonly ingredient_id: string;
          readonly inventory_rule: "deducts" | "inform_only";
          readonly preparation_code: string | null;
          readonly quantity_base_units: number;
          readonly role?: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
        }>)[];
    }>;
  }>;
  readonly restaurant_id: string;
  readonly saved: false;
  readonly sensory_estimate: Readonly<{
    readonly basis_version: string;
    readonly confidence: number;
    readonly coverage: number;
    readonly density_defaulted: boolean;
    readonly derivation_status: "available" | "unavailable";
    readonly dimensions: readonly (Readonly<{
        readonly confidence: number;
        readonly dimension_code: string;
        readonly dimension_label?: string;
        readonly group_code?: string;
        readonly group_label?: string;
        readonly ingredient_score: number;
        readonly layers: Readonly<{
          readonly base: number;
          readonly preparation: number;
          readonly seasoning: number;
        }>;
        readonly preparation_delta: number;
        readonly score: number;
        readonly sources: readonly (Readonly<{
            readonly confidence: number;
            readonly contribution: number;
            readonly source_code: string;
            readonly source_type: "ingredient" | "preparation" | "seasoning_style" | "seasoning_ingredient";
          }>)[];
      }>)[];
    readonly dish_id: string;
    readonly evidence_state?: "sufficient" | "weak_sources" | "incomplete";
    readonly flavour_tags: readonly (Readonly<{
        readonly code: "dulce" | "acido" | "salado" | "umami" | "amargo" | "picante" | "ahumado_tostado" | "herbal_citrico" | "fermentado" | "mantecoso_cremoso" | "crujiente" | "fresco_ligero";
        readonly confidence: number;
        readonly dominant_layer: "base" | "preparation" | "seasoning";
        readonly score: number;
      }>)[];
    readonly input_fingerprint: string;
    readonly profile_version: number;
    readonly provenance: string;
    readonly unavailable_reason: "incomparable_unit_dimensions" | "invalid_unit_definition" | "rational_overflow" | null;
  }> | null;
  readonly tenant_id: string;
  readonly unverified_allergen_ids: readonly (string)[];
}>
export type CatalogWorkshopSaveRequest = Readonly<{
  readonly expected_draft_revision: number;
  readonly expected_published_version: number;
  readonly expected_trial_version: 1;
  readonly trial_id: string;
}>
export type CatalogWorkshopTrial = Readonly<{
  readonly contract: "exylon.catalog.workshop-trial@1.0";
  readonly draft_revision: number;
  readonly evaluation_hash: string;
  readonly guest_visible: false;
  readonly published_version: number;
  readonly saved_candidate_id: null;
  readonly trial_id: string;
  readonly trial_version: 1;
  readonly verdict: "promising" | "needs_work" | "rejected";
}>
export type CatalogWorkshopTrialRequest = Readonly<{
  readonly evaluation: CatalogWorkshopEvaluation;
  readonly kitchen_observation: string;
  readonly verdict: "promising" | "needs_work" | "rejected";
}>
export type CloseRelationshipLoyaltyMonthRequest = Readonly<{
  readonly after_account_id?: string;
  readonly evaluated_at: string;
  readonly period_month: string;
}>
export type CompiledWorkspaceGrant = Readonly<{
  readonly default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
  readonly employee_id: string;
  readonly membership_id: string;
  readonly membership_version: number;
  readonly principal_id: string;
  readonly workspace_ids: readonly ("SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY")[];
}>
export type CompleteRelationshipGoogleConnectionRequest = Readonly<{
  readonly code: string;
  readonly state: string;
}>
export type CompleteRelationshipGoogleConnectionResponse = Readonly<{
  readonly expires_at: string;
  readonly locations: readonly (RelationshipGoogleLocation)[];
  readonly selection_id: string;
}>
export type ConfigurationBridgeApplyQuery = Readonly<{
  readonly expected_revision?: string;
  readonly form: "restaurant.configuration.apply";
  readonly setting_key?: string;
  readonly value_boolean?: string;
  readonly value_code?: string;
  readonly value_integer?: string;
}>
export type ConfigurationBridgeFloorQuery = Readonly<{
  readonly expected_revision?: string;
  readonly floor_id?: string;
  readonly form: "restaurant-configuration.floor.open";
  readonly table_ids?: string;
}>
export type ConfigurationBridgeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.restaurant-configuration.bridge-revalidation@1.0";
  readonly form: "restaurant.configuration.apply" | "restaurant-configuration.floor.open";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{ readonly [key: string]: string | number | boolean | readonly (string)[] | readonly (number)[] }>;
  readonly verdict: "open" | "refused";
}>
export type ConfigurationChanges = Readonly<{
  readonly contract: "exylon.restaurant-configuration.el-parte-changes@1.0";
  readonly coverage: "publication_snapshots_and_metadata_only_drafts_with_origin";
  readonly from: string;
  readonly items: readonly (Readonly<{
      readonly changed_fields: readonly (string)[];
      readonly event_key: string;
      readonly event_type: "configuration.publication" | "configuration.draft";
      readonly field_details_available: boolean;
      readonly occurred_at: string;
      readonly origin: "team" | "platform" | "person" | "unknown";
      readonly prior_snapshot_available: boolean;
      readonly source_draft_revision: number | null;
      readonly version: number;
    }>)[];
  readonly next_cursor: Readonly<{
    readonly event_key: string;
    readonly occurred_at: string;
  }> | null;
  readonly population: "configuration_publications_and_draft_revisions_in_period";
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly until: string;
}>
export type CreateGuestProfileRequest = Readonly<{
  readonly avatar_object_key: string | null;
  readonly display_name: string;
  readonly identity_kind: "anonymous" | "registered";
  readonly locale: string;
  readonly profile_id: string;
}>
export type CreateInventorySupplierRequest = Readonly<{
  readonly name: string;
  readonly notes: string | null;
  readonly order_cut_off?: string | null;
  readonly phone: string | null;
}>
export type CreateOfferQuoteRequest = Readonly<{
  readonly campaign_code: string | null;
  readonly cart_id: string;
  readonly coupon_issuance_id: string | null;
  readonly guest_id: string | null;
}>
export type DeleteRelationshipExternalReviewReplyRequest = Readonly<{
  readonly expected_version: number;
}>
export type DisconnectRelationshipGoogleConnectionRequest = Readonly<Record<never, never>>
export type EarnRelationshipLoyaltyRequest = Readonly<{
  readonly allocation_id: string;
  readonly captured_at: string;
  readonly guest_profile_id: string;
  readonly payment_id: string;
  readonly ticket_id: string;
}>
export type EffectiveWorkspaceAccess = Readonly<{
  readonly access_policy_version_id: string;
  readonly access_version: number;
  readonly authority_source: "published_access_policy";
  readonly canonical_hash: string;
  readonly contract: "exylon.identity-access.effective-workspaces@2.0";
  readonly contract_version: 2;
  readonly default_route: string | null;
  readonly effective_from: string;
  readonly employee_id: string;
  readonly etag: string;
  readonly exact_permissions: readonly (string)[];
  readonly generated_at: string;
  readonly membership_id: string;
  readonly membership_version: number;
  readonly navigation_enabled: boolean;
  readonly restaurant_id: string;
  readonly socket_audiences: readonly (string)[];
  readonly subject_user_id: string;
  readonly workspace_grants: readonly (Readonly<{
      readonly provenance: "published_membership" | "derived_assignment" | "manager_configuration";
      readonly version: 1;
      readonly workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY";
    }>)[];
  readonly workspace_refs: readonly (Readonly<{
      readonly version: 1;
      readonly workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY";
    }>)[];
}>
export type EraseGuestAccountRequest = Readonly<{
  readonly at: string;
  readonly expected_profile_id?: string;
  readonly reason_code: string;
}>
export type EraseGuestPrivacyRequest = Readonly<{
  readonly at: string;
  readonly expected_profile_id?: string;
  readonly expected_profile_version: number;
  readonly reason_code: string;
}>
export type GeocodeCandidate = Readonly<{
  readonly ine_municipality: Readonly<{
    readonly code: string;
    readonly display_name: string;
    readonly province_name: string;
  }> | null;
  readonly label: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly municipality_name: string | null;
  readonly postcode: string | null;
  readonly precision: "address" | "street" | "place" | "locality";
  readonly province_name: string | null;
}>
export type GeocodeSearch = Readonly<{
  readonly candidates: readonly (GeocodeCandidate)[];
  readonly contract: "exylon.restaurant-configuration.geocode-search@1.0";
  readonly provider: Readonly<{
    readonly attribution: string | null;
    readonly attribution_url: string | null;
    readonly name: "off" | "nominatim" | "google" | "recorded";
    readonly suggest_as_you_type: boolean;
  }>;
  readonly query: string;
}>
export type GeocodeSearchRequest = Readonly<{
  readonly q: string;
}>
export type GeocodeSearchUnavailableHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly cause: "provider_failed" | "provider_timeout" | "provider_busy";
    readonly errorCode: "RESTAURANT_CONFIGURATION_GEOCODING_UNAVAILABLE";
  }>;
  readonly message: string;
  readonly statusCode: 503;
}>
export type GuestAccountErasure = Readonly<{
  readonly completed_at: string;
  readonly contract: "exylon.guest.account-erasure@1.0";
  readonly erasures: readonly (Readonly<{
      readonly erasure_id: string;
      readonly restaurant_id: string;
    }>)[];
  readonly passkey_credential_ids: readonly (string)[];
  readonly profile_id: string;
  readonly rp_id: string;
}>
export type GuestBillingDocumentList = Readonly<{
  readonly billing: Readonly<{
    readonly restaurant_id: string;
    readonly state: "inactive" | "preparing" | "active";
  }> | null;
  readonly contract: "exylon.guest.billing@1.0";
  readonly documents: readonly (Readonly<{
      readonly check_id: string;
      readonly document: GuestBillingDocumentSummary;
      readonly invoice_id: string;
      readonly restaurant: Readonly<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly status: "issuing" | "late" | "issued" | "with_restaurant";
    }>)[];
  readonly next_cursor: string | null;
}>
export type GuestBillingDocumentListQuery = Readonly<{
  readonly check_id?: string;
  readonly cursor?: string;
  readonly limit?: string;
  readonly restaurant_id?: string;
}>
export type GuestBillingDocumentSummary = Readonly<{
  readonly communication_state: "pending" | "accepted" | "rejected" | null;
  readonly display_number: string | null;
  readonly id: string;
  readonly issued_at: string | null;
  readonly kind: "simplificada" | "completa" | "rectificativa";
  readonly operation_at: string;
  readonly pdf_available: boolean;
  readonly recipient: Readonly<{
    readonly legal_name: string;
    readonly nif: string;
  }> | null;
  readonly rectifies_document_id: string | null;
  readonly replaced_by_document_id: string | null;
  readonly replaces_document_id: string | null;
  readonly source_payment_id: string | null;
  readonly state: "pending" | "issued" | "uncertain" | "failed";
  readonly total_minor: number;
}>
export type GuestBillingInvoiceDocument = Readonly<{
  readonly display_number: string;
  readonly id: string;
  readonly issued_at: string;
  readonly kind: "simplificada" | "completa" | "rectificativa";
  readonly pdf_available: boolean;
  readonly total_minor: number;
}>
export type GuestBillingInvoiceReason = "failed" | "record_held" | "held_offline" | "company_invoice" | "inactive" | "before_activation" | "terminal" | "no_lines" | null
export type GuestBillingInvoiceStatus = "issuing" | "late" | "issued" | "with_restaurant" | "not_invoiced" | "voided"
export type GuestBillingRectification = Readonly<{
  readonly document: GuestBillingInvoiceDocument | null;
  readonly downloadable: boolean;
  readonly reason: GuestBillingInvoiceReason;
  readonly since: string | null;
  readonly status: GuestBillingInvoiceStatus;
}>
export type GuestBillingSessionCharge = Readonly<{
  readonly amount_minor: number;
  readonly captured_at: string;
  readonly covers_my_lines: boolean;
  readonly invoice: Readonly<{
    readonly document: GuestBillingInvoiceDocument | null;
    readonly downloadable: boolean;
    readonly reason: GuestBillingInvoiceReason;
    readonly rectifications: readonly (GuestBillingRectification)[];
    readonly since: string | null;
    readonly status: GuestBillingInvoiceStatus;
  }>;
  readonly payer: "me" | "other" | "table" | "unnamed";
  readonly payment_id: string;
  readonly split: Readonly<{
    readonly mode: "equal" | "free";
    readonly part_count: number;
    readonly part_ordinal: number;
  }> | null;
}>
export type GuestBillingSessionCharges = Readonly<{
  readonly billing_active: boolean;
  readonly charges: readonly (GuestBillingSessionCharge)[];
  readonly contract: "exylon.guest.billing@1.0";
  readonly next_cursor: string | null;
  readonly table_session_id: string;
}>
export type GuestBillingSessionChargesQuery = Readonly<{
  readonly cursor?: string;
}>
export type GuestConsent = Readonly<{
  readonly analytics_enabled: boolean;
  readonly contract: "exylon.guest.consent@1.0";
  readonly id: string;
  readonly marketing_enabled: boolean;
  readonly personalization_enabled: boolean;
  readonly privacy_notice_version: string;
  readonly profile_id: string;
  readonly recorded_at: string;
  readonly recorded_by: string;
  readonly source: "default_minimized" | "explicit_guest" | "privacy_erasure" | "synthetic_fixture";
  readonly terms_version: string;
  readonly version: number;
}>
export type GuestDiagnosticsReceipt = Readonly<{
  readonly accepted: number;
  readonly contract: "exylon.guest.diagnostics-receipt@1.0";
  readonly dropped: number;
}>
export type GuestIdentitySuggestion = Readonly<{
  readonly contract: "exylon.guest.identity-suggestion@2.0";
  readonly derivation_version: 2;
  readonly suggestions: readonly (Readonly<{
      readonly avatar_object_key: string;
      readonly display_name: string;
    }>)[];
}>
export type GuestIdentitySuggestionRequest = Readonly<{
  readonly count?: number;
  readonly exclude?: readonly (string)[];
  readonly locale: string;
  readonly nonce: string;
  readonly seen?: readonly (string)[];
}>
export type GuestLoyaltyCard = Readonly<{
  readonly account: RelationshipLoyaltyAccount;
  readonly program: RelationshipGuestLoyaltyProgram;
  readonly qualification: Readonly<{
    readonly spend_minor: number;
    readonly visits: number;
    readonly window_end_month: string;
    readonly window_start_month: string;
  }> | null;
  readonly restaurant: TenantDirectoryGuestRestaurantPresentation;
}>
export type GuestLoyaltyCardDetail = Readonly<{
  readonly card: GuestLoyaltyCard;
  readonly contract: "exylon.guest.loyalty-card-detail@1.0";
  readonly coupons: readonly (OfferGuestWalletEntry)[];
  readonly guest_profile_id: string;
  readonly history: ServiceGuestHistory;
  readonly visit_pending?: Readonly<{
    readonly cashback_minor: number;
    readonly held_tier_id: string | null;
    readonly points: number;
    readonly projected_tier_id: string | null;
    readonly promoted: boolean;
    readonly spend_minor: number;
    readonly unlocks: readonly (Readonly<{
        readonly issues_coupons: boolean;
        readonly tier_id: string;
      }>)[];
    readonly visits: number;
    readonly window_spend_minor: number;
    readonly window_visits: number;
  }> | null;
}>
export type GuestLoyaltyCardDetailRead = Readonly<{
  readonly contract: "exylon.guest.loyalty-card-detail-read@1.0";
  readonly detail: GuestLoyaltyCardDetail | null;
  readonly guest_profile_id: string;
}>
export type GuestLoyaltyCardList = Readonly<{
  readonly cards: readonly (GuestLoyaltyCard)[];
  readonly contract: "exylon.guest.loyalty-card-list@1.0";
  readonly guest_profile_id: string;
}>
export type GuestOffersCouponSubjectClassification = Readonly<{
  readonly contract: "exylon.guest.offers-coupon-subject-classification@1.0";
  readonly guest_profile_id: string;
  readonly guest_profile_version: number;
  readonly restaurant_id: string;
  readonly source_fingerprint: string;
  readonly subject_kind: "identified_guest" | "guest_session";
  readonly tenant_id: string;
}>
export type GuestPersonalizationSetting = Readonly<{
  readonly contract: "exylon.guest.personalization-setting@1.0";
  readonly effective: boolean;
  readonly personalized_recommendations: boolean;
  readonly profile_id: string;
  readonly restaurant_opt_out: boolean;
  readonly updated_at: string | null;
  readonly version: number;
}>
export type GuestPrivacyErasure = Readonly<{
  readonly completed_at: string;
  readonly contract: "exylon.guest.privacy-erasure@1.0";
  readonly derived_owner_refs: readonly (string)[];
  readonly id: string;
  readonly prior_profile_version: number;
  readonly profile_id: string;
  readonly requested_by: string;
  readonly resulting_profile_version: number;
}>
export type GuestPrivacyExport = Readonly<{
  readonly consent_history: readonly (GuestConsent)[];
  readonly contract: "exylon.guest.privacy-export@1.0";
  readonly excluded_identity_facts: readonly (string)[];
  readonly exported_at: string;
  readonly personalization_settings: readonly (Readonly<{
      readonly personalized_recommendations: boolean;
      readonly recorded_at: string;
      readonly version: number;
    }>)[];
  readonly profile: GuestProfile;
}>
export type GuestProfile = Readonly<{
  readonly avatar_object_key: string | null;
  readonly contract: "exylon.guest.profile@1.0";
  readonly created_at: string;
  readonly display_name: string;
  readonly erased_at: string | null;
  readonly id: string;
  readonly identity_kind: "anonymous" | "registered";
  readonly locale: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type IdentityAuthorization = Readonly<{
  readonly actor_id: string;
  readonly allowed: boolean;
  readonly contract: "exylon.identity-access.authorization@1.0";
  readonly membership_version: number;
  readonly permission: string;
  readonly reason: string;
  readonly resource_id: string;
  readonly tenant_id: string;
  readonly tenant_type: "platform" | "franchise" | "restaurant";
}>
export type IdentityCurrentStaffSessionResponse = Readonly<{
  readonly result: Readonly<{
    readonly franchise: Readonly<{
      readonly address: string;
      readonly email: string | null;
      readonly id: string;
      readonly is_active: boolean;
      readonly logo_url?: string | null;
      readonly name: string;
      readonly phone: string | null;
    }> | null;
    readonly restaurant: Readonly<{
      readonly email: string | null;
      readonly franchise_id: string | null;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null;
    }> | null;
    readonly session: Readonly<{
      readonly expires_at: string;
      readonly issued_at: string;
      readonly membership_tenant_id: string;
      readonly membership_tenant_type: "platform" | "franchise" | "restaurant";
      readonly membership_version: number;
    }>;
    readonly settings: readonly (Readonly<{
        readonly key: string;
        readonly type: string;
        readonly value: string;
      }>)[] | null;
    readonly user: Readonly<{
      readonly authority_version: number;
      readonly avatar_url?: string | null;
      readonly deleted_at?: string | null;
      readonly email?: string;
      readonly employee_id?: string;
      readonly first_surname?: string | null;
      readonly id: string;
      readonly isClient?: false;
      readonly membership_id?: string;
      readonly name?: string;
      readonly phone?: string;
      readonly roles: readonly (string)[];
      readonly rotation_required: boolean;
      readonly second_surname?: string | null;
      readonly two_factor_enabled: boolean;
    }>;
    readonly workspaces?: Readonly<{
      readonly authenticated_identity: Readonly<{
        readonly auth_version: number;
        readonly authority: string;
        readonly canonical_roles: readonly (string)[];
        readonly membership_id: string;
        readonly restaurant_id: string;
        readonly subject_user_id: string;
      }>;
      readonly result: Readonly<{
        readonly access_policy_version_id: string;
        readonly access_version: number;
        readonly authority_source: "published_access_policy";
        readonly canonical_hash: string;
        readonly contract: "exylon.identity-access.effective-workspaces@2.0";
        readonly contract_version: 2;
        readonly default_route: string | null;
        readonly effective_from: string;
        readonly employee_id: string;
        readonly etag: string;
        readonly exact_permissions: readonly (string)[];
        readonly generated_at: string;
        readonly membership_id: string;
        readonly membership_version: number;
        readonly navigation_enabled: boolean;
        readonly navigation_scope: "management" | "service" | "kitchen";
        readonly restaurant_id: string;
        readonly socket_audiences: readonly (string)[];
        readonly subject_user_id: string;
        readonly workspace_grants: readonly (Readonly<{
            readonly provenance: "published_membership" | "derived_assignment" | "manager_configuration";
            readonly version: 1;
            readonly workspace_id: string;
          }>)[];
        readonly workspace_refs: readonly (Readonly<{
            readonly version: 1;
            readonly workspace_id: string;
          }>)[];
      }>;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityDecision = Readonly<{
  readonly actor_id: string;
  readonly actor_type: "staff" | "guest" | "service";
  readonly allowed: boolean;
  readonly contract: "exylon.identity-access.decision@1.0";
  readonly franchise_id: string | null;
  readonly location_id: string | null;
  readonly membership_id?: string | null;
  readonly membership_version: number;
  readonly permission: string;
  readonly purpose: string;
  readonly reason: string;
  readonly resource_id: string;
  readonly resource_type: "actor" | "platform" | "franchise" | "restaurant" | "location";
  readonly restaurant_id: string | null;
  readonly roles: readonly (string)[];
  readonly tenant_id: string;
  readonly tenant_type: "platform" | "franchise" | "restaurant";
}>
export type IdentityGuestAdmissionDeniedHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly access_policy_status: "blocked" | "banned";
    readonly errorCode: "GUEST_ADMISSION_DENIED";
  }>;
  readonly message: string;
  readonly statusCode: 403;
}>
export type IdentityGuestAdmissionDeniedOrHttpError = PlatformRefusal | IdentityGuestAdmissionDeniedHttpError
export type IdentityLoginCompletedResponse = Readonly<{
  readonly result: Readonly<{
    readonly franchise: Readonly<{
      readonly address: string;
      readonly email: string | null;
      readonly id: string;
      readonly is_active: boolean;
      readonly logo_url?: string | null;
      readonly name: string;
      readonly phone: string | null;
    }> | null;
    readonly message: string;
    readonly requiresTwoFactor: false;
    readonly restaurant: Readonly<{
      readonly email: string | null;
      readonly franchise_id: string | null;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null;
    }> | null;
    readonly settings: readonly (Readonly<{
        readonly key: string;
        readonly type: string;
        readonly value: string;
      }>)[] | null;
    readonly token: string;
    readonly user: Readonly<{
      readonly authority_version: number;
      readonly avatar_url?: string | null;
      readonly deleted_at?: string | null;
      readonly email?: string;
      readonly employee_id?: string;
      readonly first_surname?: string | null;
      readonly id: string;
      readonly isClient?: false;
      readonly membership_id?: string;
      readonly name?: string;
      readonly phone?: string;
      readonly roles: readonly (string)[];
      readonly rotation_required: boolean;
      readonly second_surname?: string | null;
      readonly two_factor_enabled: boolean;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityLoginMembershipSelectionResponse = Readonly<{
  readonly result: Readonly<{
    readonly memberships: readonly (Readonly<{
        readonly disabled_reason: "restaurant_inactive" | "franchise_inactive" | "membership_suspended" | "membership_revoked" | "membership_version_changed" | "no_permitted_entry" | null;
        readonly membership_id: string;
        readonly restaurant_id: string;
        readonly restaurant_name: string;
        readonly roles: readonly (string)[];
        readonly status: "active" | "inactive";
      }>)[];
    readonly person_name: string;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityLoginRequest = Readonly<{
  readonly franchise_id?: string;
  readonly identifier: string;
  readonly password: string;
  readonly rememberMe?: boolean;
  readonly restaurant_id?: string;
  readonly twoFactorCode?: string;
}>
export type IdentityLoginResponse = Readonly<{
  readonly result: Readonly<{
    readonly message: string;
    readonly requiresTwoFactor: true;
  }> | Readonly<{
    readonly membershipSelectionProof: string;
    readonly message: string;
    readonly requiresMembershipSelection: true;
    readonly requiresTwoFactor: false;
  }> | Readonly<{
    readonly franchise: Readonly<{
      readonly address: string;
      readonly email: string | null;
      readonly id: string;
      readonly is_active: boolean;
      readonly logo_url?: string | null;
      readonly name: string;
      readonly phone: string | null;
    }> | null;
    readonly message: string;
    readonly requiresTwoFactor: false;
    readonly restaurant: Readonly<{
      readonly email: string | null;
      readonly franchise_id: string | null;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null;
    }> | null;
    readonly settings: readonly (Readonly<{
        readonly key: string;
        readonly type: string;
        readonly value: string;
      }>)[] | null;
    readonly token: string;
    readonly user: Readonly<{
      readonly authority_version: number;
      readonly avatar_url?: string | null;
      readonly deleted_at?: string | null;
      readonly email?: string;
      readonly employee_id?: string;
      readonly first_surname?: string | null;
      readonly id: string;
      readonly isClient?: false;
      readonly membership_id?: string;
      readonly name?: string;
      readonly phone?: string;
      readonly roles: readonly (string)[];
      readonly rotation_required: boolean;
      readonly second_surname?: string | null;
      readonly two_factor_enabled: boolean;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityLogoutResponse = Readonly<{
  readonly result: Readonly<{
    readonly loggedOut: true;
    readonly message: string;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityMembership = Readonly<{
  readonly actor_id: string;
  readonly actor_type: "staff";
  readonly contract: "exylon.identity-access.membership@1.0";
  readonly roles: readonly (string)[];
  readonly scope: Readonly<{
    readonly scope_type: "platform";
  }> | Readonly<{
    readonly franchise_id: string;
    readonly scope_type: "franchise";
  }> | Readonly<{
    readonly restaurant_id: string;
    readonly scope_type: "restaurant";
  }>;
  readonly status: "active" | "suspended" | "revoked";
  readonly version: number;
}>
export type IdentityQrRestaurantConfigurationUnavailableHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly cause: "setting_key_duplicate";
    readonly errorCode: "RESTAURANT_CONFIGURATION_UNAVAILABLE";
    readonly reason_text?: string;
    readonly setting_key: string;
  }>;
  readonly message: string;
  readonly statusCode: 503;
}>
export type IdentityQrTableToken = Readonly<{
  readonly active: boolean;
  readonly bootstrap_url: string;
  readonly configuration_version: number;
  readonly contract: "exylon.identity-access.qr-table-token@1.0";
  readonly id: string;
  readonly issued_at: string;
  readonly issued_by_actor_id: string;
  readonly location_id: string;
  readonly printed_at: string | null;
  readonly printed_label: string | null;
  readonly reactivated_at: string | null;
  readonly restaurant_id: string;
  readonly revoked_at: string | null;
  readonly scan_counter: number;
  readonly state: "active" | "suspended" | "revoked";
  readonly suspended_at: string | null;
  readonly table_id: string;
  readonly tenant_id: string;
  readonly transport_type: "QR";
  readonly updated_at: string;
  readonly version: number;
}>
export type IdentityQrTableTokenList = Readonly<{
  readonly contract: "exylon.identity-access.qr-table-token-list@1.0";
  readonly count: number;
  readonly restaurant_id: string;
  readonly table_id: string;
  readonly tokens: readonly (IdentityQrTableToken)[];
}>
export type IdentityQrTableTokenLiveList = Readonly<{
  readonly contract: "exylon.identity-access.qr-table-token-live-list@1.0";
  readonly restaurant_id: string;
  readonly tokens: readonly (IdentityQrTableToken)[];
}>
export type IdentityQrTableTokenPrint = Readonly<{
  readonly contract: "exylon.identity-access.qr-table-token-print@1.0";
  readonly restaurant_id: string;
  readonly tokens: readonly (IdentityQrTableToken)[];
}>
export type IdentityQrTableTokenReplacement = Readonly<{
  readonly contract: "exylon.identity-access.qr-table-token-replacement@1.0";
  readonly replaced_token: IdentityQrTableToken;
  readonly replaced_token_id: string;
  readonly replacement_token: IdentityQrTableToken;
  readonly replacement_token_id: string;
}>
export type IdentityRenewResponse = Readonly<{
  readonly result: Readonly<{
    readonly renewed: boolean;
    readonly token: string;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityRequestEmployeeInvitationClaim = Readonly<{
  readonly password: string;
  readonly token: string;
}>
export type IdentityRequestEmployeeInvitationRecover = Readonly<{
  readonly email: string;
}>
export type IdentityRequestFranchiseCreate = Readonly<{
  readonly director: Readonly<{
    readonly email: string;
    readonly name: string;
    readonly phone: string;
  }>;
  readonly franchise: Readonly<{
    readonly name: string;
  }>;
}>
export type IdentityRequestFranchiseDelete = Readonly<Record<never, never>>
export type IdentityRequestFranchiseManagerEmailUpdate = Readonly<{
  readonly email: string;
}>
export type IdentityRequestFranchiseReactivate = Readonly<Record<never, never>>
export type IdentityRequestFranchiseUpdateById = Readonly<{
  readonly franchise: Readonly<{
    readonly address?: string;
    readonly email?: string | "";
    readonly logo_url?: null;
    readonly name?: string;
    readonly phone?: string | "";
  }>;
}>
export type IdentityRequestGuestAccountSave = Readonly<{
  readonly consent_text_version: string;
  readonly diagnostics?: Readonly<Record<string, unknown>> | string;
  readonly surface?: "order" | "payment" | "coupon" | "card" | "settings";
}>
export type IdentityRequestGuestAdmissionBlock = Readonly<{
  readonly reason_code: "unpaid_balance" | "inappropriate_behavior" | "suspected_coupon_fraud" | "false_or_abusive_review" | "staff_assault";
  readonly restaurant_id: string;
}> | Readonly<{
  readonly note: string;
  readonly reason_code: "other";
  readonly restaurant_id: string;
}>
export type IdentityRequestGuestAdmissionBlockLift = Readonly<{
  readonly reason_code: "nobody_here";
  readonly restaurant_id: string;
}> | Readonly<{
  readonly note?: string;
  readonly reason_code: "unpaid_balance" | "inappropriate_behavior" | "suspected_coupon_fraud" | "false_or_abusive_review" | "staff_assault";
  readonly restaurant_id: string;
}> | Readonly<{
  readonly note: string;
  readonly reason_code: "other";
  readonly restaurant_id: string;
}>
export type IdentityRequestGuestAdmissionNotice = Readonly<{
  readonly reason_code: "unpaid_balance" | "inappropriate_behavior" | "suspected_coupon_fraud" | "false_or_abusive_review" | "staff_assault";
  readonly restaurant_id: string;
}> | Readonly<{
  readonly note: string;
  readonly reason_code: "other";
  readonly restaurant_id: string;
}>
export type IdentityRequestGuestAdmissionNoticeClear = Readonly<{
  readonly restaurant_id: string;
}>
export type IdentityRequestGuestAdmissionStaffRead = Readonly<{
  readonly restaurant_id: string;
}>
export type IdentityRequestGuestEntry = Readonly<{
  readonly diagnostics?: Readonly<Record<string, unknown>> | string;
  readonly handoff_token?: string;
  readonly qr_id?: string;
}>
export type IdentityRequestGuestForget = Readonly<{
  readonly diagnostics?: Readonly<Record<string, unknown>> | string;
}>
export type IdentityRequestGuestPasskeyChallenge = Readonly<{
  readonly diagnostics?: Readonly<Record<string, unknown>> | string;
  readonly purpose: "save" | "recover";
}>
export type IdentityRequestGuestPasskeyRecover = Readonly<{
  readonly challenge_token: string;
  readonly credential: Readonly<{
    readonly authenticatorAttachment?: string | null;
    readonly clientExtensionResults?: Readonly<{
      readonly credProps?: Readonly<{
        readonly rk?: boolean;
      }>;
    }>;
    readonly id: string;
    readonly rawId?: string;
    readonly response: Readonly<{
      readonly attestationObject?: string;
      readonly authenticatorData?: string;
      readonly clientDataJSON: string;
      readonly publicKey?: string;
      readonly publicKeyAlgorithm?: number;
      readonly signature?: string;
      readonly transports?: readonly (string)[];
      readonly userHandle?: string | null;
    }>;
    readonly type: "public-key";
  }>;
  readonly diagnostics?: Readonly<Record<string, unknown>> | string;
}>
export type IdentityRequestGuestPasskeySave = Readonly<{
  readonly challenge_token: string;
  readonly credential: Readonly<{
    readonly authenticatorAttachment?: string | null;
    readonly clientExtensionResults?: Readonly<{
      readonly credProps?: Readonly<{
        readonly rk?: boolean;
      }>;
    }>;
    readonly id: string;
    readonly rawId?: string;
    readonly response: Readonly<{
      readonly attestationObject?: string;
      readonly authenticatorData?: string;
      readonly clientDataJSON: string;
      readonly publicKey?: string;
      readonly publicKeyAlgorithm?: number;
      readonly signature?: string;
      readonly transports?: readonly (string)[];
      readonly userHandle?: string | null;
    }>;
    readonly type: "public-key";
  }>;
  readonly diagnostics?: Readonly<Record<string, unknown>> | string;
}>
export type IdentityRequestGuestStartOrder = Readonly<{
  readonly bootstrap_mode?: string | null;
  readonly diagnostics?: Readonly<Record<string, unknown>> | string;
  readonly handoff_token?: string | null;
  readonly items?: readonly (Readonly<{
      readonly foodId: string;
      readonly quantity: number;
    }>)[];
  readonly response_mode?: "full" | "compact";
  readonly restaurant_id: string;
  readonly scan_ticket?: string | null;
  readonly table_id: string;
}>
export type IdentityRequestQrTableTokenPrint = Readonly<{
  readonly prints: readonly (Readonly<{
      readonly label: string;
      readonly token_id: string;
    }>)[];
}>
export type IdentityRequestQrTableTokenReplace = Readonly<{
  readonly expected_version: number;
}>
export type IdentityRequestRestaurantCreate = Readonly<{
  readonly manager_invitation: Readonly<{
    readonly email: string;
    readonly name: string;
    readonly phone: string;
  }>;
  readonly restaurant: Readonly<{
    readonly address: string;
    readonly name: string;
  }>;
}>
export type IdentityRequestRestaurantDelete = Readonly<Record<never, never>>
export type IdentityRequestRestaurantReactivate = Readonly<Record<never, never>>
export type IdentityRequestRestaurantUpdate = Readonly<{
  readonly address?: string;
  readonly email?: string | "";
  readonly name?: string;
  readonly phone?: string | "";
  readonly remove_logo?: boolean;
}>
export type IdentityRequestStaff2faDeleteSecret = Readonly<{
  readonly code: string;
}>
export type IdentityRequestStaff2faDisable = Readonly<{
  readonly code: string;
}>
export type IdentityRequestStaff2faEnable = Readonly<{
  readonly code: string;
}>
export type IdentityRequestStaff2faGenerate = Readonly<Record<never, never>>
export type IdentityRequestStaffCredentialRecoverFranchiseDirector = Readonly<Record<never, never>>
export type IdentityRequestStaffInvitationAdminRecoverScopedManager = Readonly<{
  readonly employee_id: string;
}>
export type IdentityRequestStaffInvitationAdminReissue = Readonly<Record<never, never>>
export type IdentityRequestStaffInvitationAdminResolveDeliveryOutcome = Readonly<{
  readonly provider_message_id?: string | null;
  readonly resolution: "delivered" | "delivery_failed";
}>
export type IdentityRequestStaffInvitationAdminRevoke = Readonly<Record<never, never>>
export type IdentityRequestStaffLogin = Readonly<{
  readonly franchise_id?: string;
  readonly identifier: string | string;
  readonly password: string;
  readonly rememberMe?: boolean;
  readonly twoFactorCode?: string;
}> | Readonly<{
  readonly identifier: string | string;
  readonly password: string;
  readonly rememberMe?: boolean;
  readonly restaurant_id?: string;
  readonly twoFactorCode?: string;
}>
export type IdentityRequestStaffLoginMembershipSelectionComplete = Readonly<{
  readonly membership_id: string;
  readonly membershipSelectionProof: string;
}>
export type IdentityRequestStaffLoginMembershipSelectionRead = Readonly<{
  readonly membershipSelectionProof: string;
}>
export type IdentityRequestStaffLogout = Readonly<Record<never, never>>
export type IdentityRequestStaffRenew = Readonly<Record<never, never>>
export type IdentityRequestStaffSelfCredentialUpdate = Readonly<{
  readonly current_credential: string;
  readonly new_pin: string;
}>
export type IdentityRequestStaffSelfProfileUpdate = Readonly<{
  readonly avatar_url?: "/images/avatar.png" | null;
  readonly email?: string;
  readonly name?: string;
  readonly phone?: string;
}>
export type IdentityRequestStaffSessionRevoke = Readonly<Record<never, never>>
export type IdentityRequestStaffSessionsRevokeAll = Readonly<{
  readonly expected_sessions: readonly (Readonly<{
      readonly generation: number;
      readonly session_id: string;
    }>)[];
}>
export type IdentityResponseDefinitionBinaryImage = string
export type IdentityResponseDefinitionFranchise = Readonly<{
  readonly result: TenantDirectoryFranchise;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionFranchiseCreate = Readonly<{
  readonly result: Readonly<{
    readonly director: TenantDirectoryFranchiseDirectorPresentation;
    readonly director_onboarding: Readonly<{
      readonly principal_id: string;
      readonly replayed: false;
      readonly temporary_password?: string;
    }> | Readonly<{
      readonly principal_id: string;
      readonly replayed: true;
    }>;
    readonly franchise: TenantDirectoryFranchise;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionFranchiseDetails = Readonly<{
  readonly result: TenantDirectoryFranchiseDetails;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionFranchiseManagerEmailUpdate = Readonly<{
  readonly result: Readonly<{
    readonly authority_version: number;
    readonly email: string;
    readonly principal_id: string;
    readonly replayed: boolean;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionFranchisePage = Readonly<{
  readonly result: Readonly<{
    readonly data: readonly (TenantDirectoryFranchiseListItem)[];
    readonly pagination: Readonly<{
      readonly page: number;
      readonly size: number;
      readonly total: number;
      readonly totalPages: number;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestAccountSave = Readonly<{
  readonly result: Readonly<{
    readonly client_id: string;
    readonly credential_expires_at: string;
    readonly credential_kind: "saved";
    readonly csrf_token: string;
    readonly promoted_profiles: number;
    readonly recognition_consent: Readonly<{
      readonly given_at: string;
      readonly renew_at: string;
      readonly text_version: string;
    }>;
    readonly saved: true;
    readonly visit: "promoted" | "not_seated" | "held_elsewhere" | "none";
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestAdmission = Readonly<{
  readonly result: Readonly<{
    readonly message: string;
    readonly policy: Readonly<{
      readonly clientId: string;
      readonly decidedByUserId: string | null;
      readonly notes: string | null;
      readonly reason: string | null;
      readonly restaurantId: string;
      readonly source: "default" | "notice" | "manual_block" | "manual_ban" | "manual_restore" | "synthetic_fixture" | "nobody_here";
      readonly status: "active" | "flagged" | "blocked" | "banned";
      readonly updatedAt: string | null;
      readonly version: number;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestAdmissionStaffRead = Readonly<{
  readonly result: Readonly<{
    readonly reason: string | null;
    readonly source: "default" | "notice" | "manual_block" | "manual_ban" | "manual_restore" | "synthetic_fixture" | "nobody_here";
    readonly status: "active" | "flagged" | "blocked" | "banned";
    readonly updated_at: string | null;
    readonly version: number;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestCurrent = Readonly<{
  readonly result: Readonly<{
    readonly authenticated: boolean;
    readonly state: string;
  }> | Readonly<{
    readonly access_policy?: Readonly<{
      readonly policyId?: string | null;
      readonly reason?: string | null;
      readonly source?: string | null;
      readonly status?: string | null;
    }> | null;
    readonly active_table_order_id?: string | null;
    readonly authenticated: boolean;
    readonly can_request_payment?: boolean;
    readonly client: Readonly<{
      readonly authority_version?: number;
      readonly avatar_url?: string | null;
      readonly email?: string | null;
      readonly id: string;
      readonly identity_source?: string;
      readonly is_anonymous?: boolean;
      readonly name?: string | null;
      readonly number?: string | null;
      readonly saved_account?: boolean;
    }>;
    readonly client_id: string;
    readonly client_session?: Readonly<{
      readonly can_request_payment?: boolean;
      readonly client?: Readonly<{
        readonly authority_version?: number;
        readonly avatar_url?: string | null;
        readonly email?: string | null;
        readonly id: string;
        readonly identity_source?: string;
        readonly is_anonymous?: boolean;
        readonly name?: string | null;
        readonly number?: string | null;
        readonly saved_account?: boolean;
      }> | null;
      readonly created_at?: string | null;
      readonly current_total?: number | null;
      readonly discount_applied?: number | null;
      readonly expires_at?: string | null;
      readonly id: string;
      readonly in_waiting_room?: boolean;
      readonly is_host?: boolean;
      readonly last_seen_at?: string | null;
      readonly payment_requested?: boolean;
      readonly payment_state?: string | null;
      readonly restaurant_id?: string | null;
      readonly state?: string | null;
      readonly sub_total?: number | null;
      readonly table_session_id?: string | null;
      readonly tax_applied?: number | null;
      readonly waiting_room_cart_id?: string | null;
      readonly waiting_room_cart_version?: number | null;
      readonly waiting_room_entered_at?: string | null;
      readonly waiting_room_state?: string | null;
    }> | null;
    readonly client_state?: "profile_complete" | "profile_incomplete";
    readonly credential_expires_at: string;
    readonly credential_kind: "visit" | "saved";
    readonly csrf_token: string;
    readonly next_step?: string;
    readonly payment_requested?: boolean;
    readonly payment_state?: string | null;
    readonly restaurant_id?: string;
    readonly restore_versions?: Readonly<{
      readonly client_session: Readonly<{
        readonly id?: string | null;
        readonly last_seen_at?: string | null;
        readonly state?: string | null;
        readonly table_session_id?: string | null;
        readonly waiting_room_cart_id?: string | null;
        readonly waiting_room_cart_version?: number | null;
        readonly waiting_room_state?: string | null;
      }>;
      readonly table_session: Readonly<{
        readonly financial_status?: string | null;
        readonly id?: string | null;
        readonly order_id?: string | null;
      }>;
    }>;
    readonly state: string;
    readonly submitted_order_id?: string | null;
    readonly table_id?: string;
    readonly table_session?: Readonly<{
      readonly ended_at?: string | null;
      readonly financial_status?: string | null;
      readonly id: string | null;
      readonly order_id?: string | null;
      readonly remaining_balance?: number | null;
      readonly started_at?: string | null;
      readonly status?: string | null;
      readonly table_id?: string | null;
      readonly total_ordered?: number | null;
      readonly total_paid?: number | null;
    }> | null;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestEntry = Readonly<{
  readonly result: Readonly<{
    readonly catalogue: CatalogGuestEntryCatalogue | null;
    readonly contract: "exylon.identity-access.guest-entry@1.0";
    readonly current: Readonly<{
      readonly body: unknown;
      readonly headers: Readonly<{ readonly [key: string]: string }>;
      readonly status: number;
    }> | null;
    readonly resolve: Readonly<{
      readonly body: unknown;
      readonly headers: Readonly<{ readonly [key: string]: string }>;
      readonly status: number;
    }>;
    readonly table_faces: readonly (string)[];
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestForget = Readonly<{
  readonly result: Readonly<{
    readonly forgotten: true;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestHome = Readonly<{
  readonly result: Readonly<{
    readonly catalogue: Readonly<{
      readonly body: unknown;
      readonly headers: Readonly<{ readonly [key: string]: string }>;
      readonly status: number;
    }> | null;
    readonly contract: "exylon.identity-access.guest-home@1.0";
    readonly identity: Readonly<{
      readonly body: unknown;
      readonly headers: Readonly<{ readonly [key: string]: string }>;
      readonly status: number;
    }>;
    readonly notices: Readonly<{
      readonly body: unknown;
      readonly headers: Readonly<{ readonly [key: string]: string }>;
      readonly status: number;
    }> | null;
    readonly snapshot: Readonly<{
      readonly body: unknown;
      readonly headers: Readonly<{ readonly [key: string]: string }>;
      readonly status: number;
    }> | null;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestPasskeyChallenge = Readonly<{
  readonly result: Readonly<{
    readonly challenge_token: string;
    readonly public_key: Readonly<{
      readonly challenge: string;
      readonly hints: readonly ("client-device")[];
      readonly rp?: Readonly<{
        readonly id?: string;
        readonly name: string;
      }>;
      readonly rpId?: string;
      readonly userVerification?: "required";
    }>;
    readonly purpose: "save" | "recover";
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestPasskeyRecover = Readonly<{
  readonly result: Readonly<{
    readonly client_id: string;
    readonly csrf_token: string | null;
    readonly entry_outcome: "recovered";
    readonly outcome: "recovered" | "same" | "folded" | "switched";
    readonly restaurant_id: string | null;
    readonly signal: Readonly<{
      readonly accepted_credential_ids: readonly (string)[];
      readonly display_name: string;
      readonly name: string;
      readonly rp_id: string;
      readonly user_id: string;
    }>;
    readonly table_id: string | null;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestPasskeySave = Readonly<{
  readonly result: Readonly<{
    readonly client_id: string;
    readonly credential_id: string;
    readonly saved: true;
    readonly signal: Readonly<{
      readonly accepted_credential_ids: readonly (string)[];
      readonly display_name: string;
      readonly name: string;
      readonly rp_id: string;
      readonly user_id: string;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestQrHandoff = Readonly<{
  readonly result: Readonly<{
    readonly bootstrap_mode: string | null;
    readonly restaurant_id: string;
    readonly restaurant_settings: Readonly<{ readonly [key: string]: Readonly<{
        readonly type: string;
        readonly value: string;
      }> }> | null;
    readonly scan_counter: number | null;
    readonly scan_ticket: string | null;
    readonly scan_ticket_expires_in_seconds: number | null;
    readonly source_bootstrap_mode: string | null;
    readonly table_id: string;
    readonly table_info: Readonly<{
      readonly capacity?: number | null;
      readonly label?: string | null;
    }> | null;
    readonly token_id: string;
    readonly transport_type: string | null;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestQrResolve = Readonly<{
  readonly result: Readonly<{
    readonly bootstrap_mode: string | null;
    readonly bootstrap_url?: string;
    readonly handoff_expires_in_seconds: number | null;
    readonly handoff_token: string | null;
    readonly handoff_url: string | null;
    readonly qr_id?: string;
    readonly qr_url: string;
    readonly restaurant_id: string;
    readonly restaurant_settings: Readonly<{ readonly [key: string]: Readonly<{
        readonly type: string;
        readonly value: string;
      }> }> | null;
    readonly scan_counter: number | null;
    readonly scan_ticket: string | null;
    readonly scan_ticket_expires_in_seconds: number | null;
    readonly state: string;
    readonly table_id: string;
    readonly table_info: Readonly<{
      readonly capacity?: number | null;
      readonly label?: string | null;
    }> | null;
    readonly token_id: string;
    readonly transport_type: string | null;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestRestaurantPresentation = Readonly<{
  readonly result: TenantDirectoryGuestRestaurantPresentation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionGuestStartOrder = Readonly<{
  readonly result: Readonly<{
    readonly access_policy: Readonly<{
      readonly policyId?: string | null;
      readonly reason?: string | null;
      readonly source?: string | null;
      readonly status?: string | null;
    }> | null;
    readonly active_table_order_id?: string | null;
    readonly authenticated: boolean;
    readonly can_request_payment: boolean;
    readonly client: Readonly<{
      readonly authority_version?: number;
      readonly avatar_url?: string | null;
      readonly email?: string | null;
      readonly id: string;
      readonly identity_source?: string;
      readonly is_anonymous?: boolean;
      readonly name?: string | null;
      readonly number?: string | null;
      readonly saved_account?: boolean;
    }>;
    readonly client_id: string;
    readonly client_session: Readonly<{
      readonly can_request_payment?: boolean;
      readonly client?: Readonly<{
        readonly authority_version?: number;
        readonly avatar_url?: string | null;
        readonly email?: string | null;
        readonly id: string;
        readonly identity_source?: string;
        readonly is_anonymous?: boolean;
        readonly name?: string | null;
        readonly number?: string | null;
        readonly saved_account?: boolean;
      }> | null;
      readonly created_at?: string | null;
      readonly current_total?: number | null;
      readonly discount_applied?: number | null;
      readonly expires_at?: string | null;
      readonly id: string;
      readonly in_waiting_room?: boolean;
      readonly is_host?: boolean;
      readonly last_seen_at?: string | null;
      readonly payment_requested?: boolean;
      readonly payment_state?: string | null;
      readonly restaurant_id?: string | null;
      readonly state?: string | null;
      readonly sub_total?: number | null;
      readonly table_session_id?: string | null;
      readonly tax_applied?: number | null;
      readonly waiting_room_cart_id?: string | null;
      readonly waiting_room_cart_version?: number | null;
      readonly waiting_room_entered_at?: string | null;
      readonly waiting_room_state?: string | null;
    }> | null;
    readonly credential_kind: "visit" | "saved";
    readonly csrf_token?: string;
    readonly deferred?: boolean;
    readonly entry_outcome: "recognised" | "new" | "recovered";
    readonly payment_requested?: boolean;
    readonly payment_state: string | null;
    readonly response_mode?: string;
    readonly restaurant_id?: string;
    readonly state: string;
    readonly submitted_order_id?: string | null;
    readonly table_id?: string;
    readonly table_session: Readonly<{
      readonly ended_at?: string | null;
      readonly financial_status?: string | null;
      readonly id: string | null;
      readonly order_id?: string | null;
      readonly remaining_balance?: number | null;
      readonly started_at?: string | null;
      readonly status?: string | null;
      readonly table_id?: string | null;
      readonly total_ordered?: number | null;
      readonly total_paid?: number | null;
    }> | null;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionInvitationAccepted = Readonly<{
  readonly result: Readonly<{
    readonly accepted: true;
    readonly message: string;
    readonly next_step?: "sign_in";
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionInvitationRecoveryAccepted = Readonly<{
  readonly result: Readonly<{
    readonly accepted: true;
    readonly message: string;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionLocationPage = Readonly<{
  readonly result: Readonly<{
    readonly data: readonly (TenantDirectoryLocation)[];
    readonly pagination: Readonly<{
      readonly page: number;
      readonly size: number;
      readonly total: number;
      readonly totalPages: number;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionMessage = Readonly<{
  readonly result: Readonly<{
    readonly message: string;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionQrTableTokenList = Readonly<{
  readonly result: IdentityQrTableTokenList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionQrTableTokenLiveList = Readonly<{
  readonly result: IdentityQrTableTokenLiveList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionQrTableTokenPrint = Readonly<{
  readonly result: IdentityQrTableTokenPrint;
  readonly statusCode: 201;
  readonly success: true;
}>
export type IdentityResponseDefinitionQrTableTokenReplacement = Readonly<{
  readonly result: IdentityQrTableTokenReplacement;
  readonly statusCode: 201;
  readonly success: true;
}>
export type IdentityResponseDefinitionRestaurant = Readonly<{
  readonly result: TenantDirectoryRestaurant;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionRestaurantCreate = Readonly<{
  readonly result: Readonly<{
    readonly manager_onboarding: Readonly<{
      readonly employee_id: string;
      readonly principal_id: string;
      readonly replayed: false;
      readonly temporary_password?: string;
    }> | Readonly<{
      readonly employee_id: string;
      readonly principal_id: string;
      readonly replayed: true;
    }>;
    readonly restaurant: TenantDirectoryRestaurant;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionRestaurantDetails = Readonly<{
  readonly result: TenantDirectoryRestaurantDetails;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionRestaurantPage = Readonly<{
  readonly result: Readonly<{
    readonly data: readonly (TenantDirectoryRestaurantListItem)[];
    readonly pagination: Readonly<{
      readonly page: number;
      readonly size: number;
      readonly total: number;
      readonly totalPages: number;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffCredentialRecovery = Readonly<{
  readonly result: Readonly<{
    readonly principal_id: string;
    readonly replayed: false;
    readonly temporary_password: string;
  }> | Readonly<{
    readonly principal_id: string;
    readonly replayed: true;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffInvitationAdminMutation = Readonly<{
  readonly result: Readonly<{
    readonly invitation: Readonly<{
      readonly claimed_at: string | null;
      readonly delivered_at: string | null;
      readonly delivery_attempt_count: number;
      readonly delivery_error_code: string | null;
      readonly delivery_failed_at: string | null;
      readonly delivery_outcome_resolved_at: string | null;
      readonly delivery_provider_message_id: string | null;
      readonly employee_id: string;
      readonly expires_at: string | null;
      readonly id: string;
      readonly invitation_kind: "account_claim" | "account_recovery" | "existing_user_membership";
      readonly restaurant_id: string;
      readonly revoked_at: string | null;
      readonly state: "pending" | "delivered" | "delivery_failed" | "delivery_outcome_unknown" | "delivery_suppressed" | "claimed" | "expired" | "revoked";
      readonly updated_at: string;
      readonly version: number;
    }>;
    readonly replayed: boolean;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffInvitationAdminReissue = Readonly<{
  readonly result: Readonly<{
    readonly delivery_queued: boolean;
    readonly invitation: Readonly<{
      readonly claimed_at: string | null;
      readonly delivered_at: string | null;
      readonly delivery_attempt_count: number;
      readonly delivery_error_code: string | null;
      readonly delivery_failed_at: string | null;
      readonly delivery_outcome_resolved_at: string | null;
      readonly delivery_provider_message_id: string | null;
      readonly employee_id: string;
      readonly expires_at: string | null;
      readonly id: string;
      readonly invitation_kind: "account_claim" | "account_recovery" | "existing_user_membership";
      readonly restaurant_id: string;
      readonly revoked_at: string | null;
      readonly state: "pending" | "delivered" | "delivery_failed" | "delivery_outcome_unknown" | "delivery_suppressed" | "claimed" | "expired" | "revoked";
      readonly updated_at: string;
      readonly version: number;
    }>;
    readonly previous_invitation_id: string;
    readonly replayed: boolean;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffInvitationAdminStatus = Readonly<{
  readonly result: Readonly<{
    readonly claimed_at: string | null;
    readonly delivered_at: string | null;
    readonly delivery_attempt_count: number;
    readonly delivery_error_code: string | null;
    readonly delivery_failed_at: string | null;
    readonly delivery_outcome_resolved_at: string | null;
    readonly delivery_provider_message_id: string | null;
    readonly employee_id: string;
    readonly expires_at: string | null;
    readonly id: string;
    readonly invitation_kind: "account_claim" | "account_recovery" | "existing_user_membership";
    readonly restaurant_id: string;
    readonly revoked_at: string | null;
    readonly state: "pending" | "delivered" | "delivery_failed" | "delivery_outcome_unknown" | "delivery_suppressed" | "claimed" | "expired" | "revoked";
    readonly updated_at: string;
    readonly version: number;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffSelfCredentialUpdate = Readonly<{
  readonly result: Readonly<{
    readonly authority_version: number;
    readonly other_sessions_revoked: number;
    readonly receipt_id: string;
    readonly replayed: boolean;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffSelfProfileRead = Readonly<{
  readonly result: Readonly<{
    readonly result: Readonly<{
      readonly authority_version: number;
      readonly avatar_url: string | null;
      readonly contract: "exylon.identity-access.staff-self-profile@1.0";
      readonly email: string;
      readonly name: string;
      readonly phone: string;
      readonly subject_user_id: string;
      readonly two_factor_enabled: boolean;
      readonly version: number;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffSelfProfileUpdate = Readonly<{
  readonly result: Readonly<{
    readonly receipt_id: string;
    readonly replayed: boolean;
    readonly result: Readonly<{
      readonly authority_version: number;
      readonly avatar_url: string | null;
      readonly contract: "exylon.identity-access.staff-self-profile@1.0";
      readonly email: string;
      readonly name: string;
      readonly phone: string;
      readonly subject_user_id: string;
      readonly two_factor_enabled: boolean;
      readonly version: number;
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffSessionsRead = Readonly<{
  readonly result: Readonly<{
    readonly sessions: readonly (Readonly<{
        readonly authentication_method: "passkey" | "password" | "unknown";
        readonly browser_family: "chrome" | "edge" | "firefox" | "other" | "safari" | "unknown";
        readonly contract: "exylon.identity-access.staff-sessions@1.0";
        readonly current: boolean;
        readonly device_kind: "desktop" | "mobile" | "other" | "tablet" | "unknown";
        readonly expires_at: string;
        readonly generation: number;
        readonly last_authenticated_at: string;
        readonly os_family: "android" | "ios" | "linux" | "macos" | "other" | "unknown" | "windows";
        readonly session_id: string;
        readonly started_at: string;
      }>)[];
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffSessionsRevocation = Readonly<{
  readonly result: Readonly<{
    readonly current_session_revoked: boolean;
    readonly receipt_id: string;
    readonly replayed: boolean;
    readonly revoked_sessions: readonly (Readonly<{
        readonly generation: number;
        readonly session_id: string;
      }>)[];
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffTwoFactorDelete = Readonly<{
  readonly result: Readonly<{
    readonly authorityVersion: number;
    readonly enabled: false;
    readonly message: string;
    readonly replayed: boolean;
    readonly secretDeleted: true;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffTwoFactorDisable = Readonly<{
  readonly result: Readonly<{
    readonly authorityVersion: number;
    readonly enabled: false;
    readonly message: string;
    readonly replayed: boolean;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffTwoFactorEnable = Readonly<{
  readonly result: Readonly<{
    readonly authorityVersion: number;
    readonly enabled: true;
    readonly message: string;
    readonly replayed: boolean;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDefinitionStaffTwoFactorGenerate = Readonly<{
  readonly result: Readonly<{
    readonly manualEntryKey: string;
    readonly qrCode: string;
    readonly secret: string;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IdentityResponseDELETEClientsClientIdBlock = IdentityResponseDefinitionGuestAdmission
export type IdentityResponseDELETEClientsClientIdNotice = IdentityResponseDefinitionGuestAdmissionStaffRead
export type IdentityResponseDELETEFranchisesFranchiseId = IdentityResponseDefinitionFranchise
export type IdentityResponseDELETEMeSessionsSessionId = IdentityResponseDefinitionStaffSessionsRevocation
export type IdentityResponseDELETERestaurantsRestaurantId = IdentityResponseDefinitionRestaurant
export type IdentityResponseGETAuthCurrent = IdentityCurrentStaffSessionResponse
export type IdentityResponseGETClientsClientIdAdmission = IdentityResponseDefinitionGuestAdmissionStaffRead
export type IdentityResponseGETFranchises = IdentityResponseDefinitionFranchisePage
export type IdentityResponseGETFranchisesFranchiseId = IdentityResponseDefinitionFranchiseDetails
export type IdentityResponseGETFranchisesFranchiseIdLogo = IdentityResponseDefinitionBinaryImage
export type IdentityResponseGETGuestHome = IdentityResponseDefinitionGuestHome
export type IdentityResponseGETGuestRestaurantPresentation = IdentityResponseDefinitionGuestRestaurantPresentation
export type IdentityResponseGETIdentityAccessRestaurantsRestaurantIdQrTokens = IdentityResponseDefinitionQrTableTokenLiveList
export type IdentityResponseGETIdentityAccessRestaurantsRestaurantIdTablesTableIdQrTokens = IdentityResponseDefinitionQrTableTokenList
export type IdentityResponseGETIdentityGuestAuthCurrent = IdentityResponseDefinitionGuestCurrent
export type IdentityResponseGETIdentityGuestQrHandoffHandoffToken = IdentityResponseDefinitionGuestQrHandoff
export type IdentityResponseGETIdentityGuestQrResolveQrId = IdentityResponseDefinitionGuestQrResolve
export type IdentityResponseGETMeProfile = IdentityResponseDefinitionStaffSelfProfileRead
export type IdentityResponseGETMeSessions = IdentityResponseDefinitionStaffSessionsRead
export type IdentityResponseGETMeWorkspaces = IdentityWorkspaceResponse
export type IdentityResponseGETRestaurants = IdentityResponseDefinitionRestaurantPage
export type IdentityResponseGETRestaurantsRestaurantId = IdentityResponseDefinitionRestaurantDetails
export type IdentityResponseGETRestaurantsRestaurantIdAccessPolicyCurrentGrants = AccessPolicyCurrentGrantBatch
export type IdentityResponseGETRestaurantsRestaurantIdAccessPolicyDirectory = AccessPolicyDirectory
export type IdentityResponseGETRestaurantsRestaurantIdAccessPolicyReceiptsReceiptId = AccessPolicyReceipt
export type IdentityResponseGETRestaurantsRestaurantIdLocations = IdentityResponseDefinitionLocationPage
export type IdentityResponseGETRestaurantsRestaurantIdLogo = IdentityResponseDefinitionBinaryImage
export type IdentityResponseGETRestaurantsRestaurantIdStaffInvitationsInvitationId = IdentityResponseDefinitionStaffInvitationAdminStatus
export type IdentityResponseGETUsersUserIdAvatar = IdentityResponseDefinitionBinaryImage
export type IdentityResponsePOSTAuth2faDeleteSecret = IdentityResponseDefinitionStaffTwoFactorDelete
export type IdentityResponsePOSTAuth2faDisable = IdentityResponseDefinitionStaffTwoFactorDisable
export type IdentityResponsePOSTAuth2faEnable = IdentityResponseDefinitionStaffTwoFactorEnable
export type IdentityResponsePOSTAuth2faGenerate = IdentityResponseDefinitionStaffTwoFactorGenerate
export type IdentityResponsePOSTAuthEmployeeInvitationsClaim = IdentityResponseDefinitionInvitationAccepted
export type IdentityResponsePOSTAuthEmployeeInvitationsRecover = IdentityResponseDefinitionInvitationRecoveryAccepted
export type IdentityResponsePOSTAuthLogin = IdentityLoginResponse
export type IdentityResponsePOSTAuthLoginMemberships = IdentityLoginMembershipSelectionResponse
export type IdentityResponsePOSTAuthLoginMembershipsSelect = IdentityLoginCompletedResponse
export type IdentityResponsePOSTAuthLogout = IdentityLogoutResponse
export type IdentityResponsePOSTAuthRenew = IdentityRenewResponse
export type IdentityResponsePOSTClientsClientIdBlock = IdentityResponseDefinitionGuestAdmission
export type IdentityResponsePOSTClientsClientIdNotice = IdentityResponseDefinitionGuestAdmission
export type IdentityResponsePOSTFranchises = IdentityResponseDefinitionFranchiseCreate
export type IdentityResponsePOSTFranchisesFranchiseIdFranchiseDirectorsDirectorIdRecoverAccess = IdentityResponseDefinitionStaffCredentialRecovery
export type IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensPrints = IdentityResponseDefinitionQrTableTokenPrint
export type IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensTokenIdReplace = IdentityResponseDefinitionQrTableTokenReplacement
export type IdentityResponsePOSTIdentityGuestAccountSave = IdentityResponseDefinitionGuestAccountSave
export type IdentityResponsePOSTIdentityGuestAuthForget = IdentityResponseDefinitionGuestForget
export type IdentityResponsePOSTIdentityGuestEntry = IdentityResponseDefinitionGuestEntry
export type IdentityResponsePOSTIdentityGuestEntryStartOrder = IdentityResponseDefinitionGuestStartOrder
export type IdentityResponsePOSTIdentityGuestPasskeyChallenge = IdentityResponseDefinitionGuestPasskeyChallenge
export type IdentityResponsePOSTIdentityGuestPasskeyRecover = IdentityResponseDefinitionGuestPasskeyRecover
export type IdentityResponsePOSTIdentityGuestPasskeySave = IdentityResponseDefinitionGuestPasskeySave
export type IdentityResponsePOSTMeCredential = IdentityResponseDefinitionStaffSelfCredentialUpdate
export type IdentityResponsePOSTMeSessionsRevokeAll = IdentityResponseDefinitionStaffSessionsRevocation
export type IdentityResponsePOSTRestaurants = IdentityResponseDefinitionRestaurantCreate
export type IdentityResponsePOSTRestaurantsRestaurantIdAccessPolicyRestore = AccessPolicyVersionCommandResponse
export type IdentityResponsePOSTRestaurantsRestaurantIdAccessPolicyRestoreValidate = AccessPolicyValidation
export type IdentityResponsePOSTRestaurantsRestaurantIdStaffInvitationsRecover = IdentityResponseDefinitionStaffCredentialRecovery
export type IdentityResponsePUTFranchisesFranchiseId = IdentityResponseDefinitionFranchise
export type IdentityResponsePUTFranchisesFranchiseIdReactivate = IdentityResponseDefinitionFranchise
export type IdentityResponsePUTMeProfile = IdentityResponseDefinitionStaffSelfProfileUpdate
export type IdentityResponsePUTRestaurantsRestaurantId = IdentityResponseDefinitionRestaurant
export type IdentityResponsePUTRestaurantsRestaurantIdManagersManagerIdEmail = IdentityResponseDefinitionFranchiseManagerEmailUpdate
export type IdentityResponsePUTRestaurantsRestaurantIdReactivate = IdentityResponseDefinitionRestaurant
export type IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdReissue = IdentityResponseDefinitionStaffInvitationAdminReissue
export type IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdResolveDeliveryOutcome = IdentityResponseDefinitionStaffInvitationAdminMutation
export type IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdRevoke = IdentityResponseDefinitionStaffInvitationAdminMutation
export type IdentityRoutePolicy = unknown
export type IdentityRoutePolicySchema = Readonly<{
  readonly contract: "exylon.identity-access.route-policy@1.0";
  readonly routes: readonly (Readonly<{
      readonly audiences?: readonly ("guest" | "panel" | "public" | "internal")[];
      readonly method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
      readonly path: string;
      readonly permission: string;
      readonly public: boolean;
      readonly resource_binding?: Readonly<{
        readonly id_key: string | null;
        readonly id_source: "path" | "body";
        readonly type: "franchises" | "restaurants" | "users";
      }>;
      readonly response_kind?: "binary-image";
      readonly scope: "none" | "platform" | "franchise" | "restaurant" | "guest-bootstrap" | "guest-session";
      readonly side_effect: "none" | "mutation" | "mutation-and-audit";
    }>)[];
  readonly version: number;
}>
export type IdentitySession = Readonly<{
  readonly actor_id: string;
  readonly actor_type: "staff" | "guest";
  readonly contract: "exylon.identity-access.session@1.0";
  readonly expires_at: string;
  readonly restaurant_id: string | null;
  readonly session_fingerprint: string;
  readonly state: "active" | "revoked";
  readonly version: number;
}>
export type IdentityWorkspaceResponse = Readonly<{
  readonly result: Readonly<{
    readonly authenticated_identity: Readonly<{
      readonly auth_version: number;
      readonly authority: string;
      readonly canonical_roles: readonly (string)[];
      readonly membership_id: string;
      readonly restaurant_id: string;
      readonly subject_user_id: string;
    }>;
    readonly result: Readonly<{
      readonly access_policy_version_id: string;
      readonly access_version: number;
      readonly authority_source: "published_access_policy";
      readonly canonical_hash: string;
      readonly contract: "exylon.identity-access.effective-workspaces@2.0";
      readonly contract_version: 2;
      readonly default_route: string | null;
      readonly effective_from: string;
      readonly employee_id: string;
      readonly etag: string;
      readonly exact_permissions: readonly (string)[];
      readonly generated_at: string;
      readonly membership_id: string;
      readonly membership_version: number;
      readonly navigation_enabled: boolean;
      readonly navigation_scope: "management" | "service" | "kitchen";
      readonly restaurant_id: string;
      readonly socket_audiences: readonly (string)[];
      readonly subject_user_id: string;
      readonly workspace_grants: readonly (Readonly<{
          readonly provenance: "published_membership" | "derived_assignment" | "manager_configuration";
          readonly version: 1;
          readonly workspace_id: string;
        }>)[];
      readonly workspace_refs: readonly (Readonly<{
          readonly version: 1;
          readonly workspace_id: string;
        }>)[];
    }>;
  }>;
  readonly statusCode: 200;
  readonly success: true;
}>
export type IneMunicipality = Readonly<{
  readonly code: string;
  readonly display_name: string;
  readonly name: string;
  readonly province_code: string;
  readonly province_name: string;
}>
export type IneMunicipalitySearch = Readonly<{
  readonly contract: "exylon.restaurant-configuration.ine-municipality-search@1.0";
  readonly municipalities: readonly (IneMunicipality)[];
  readonly query: string;
  readonly register: Readonly<{
    readonly edition: string | null;
    readonly size: number;
    readonly source: string | null;
    readonly status: "installed" | "not_installed";
  }>;
  readonly truncated: boolean;
}>
export type IneMunicipalitySearchRequest = Readonly<{
  readonly q: string;
}>
export type InsightsElParteExternalContext = Readonly<{
  readonly contract: "exylon.insights.el-parte-external-context@1.0";
  readonly daily?: readonly (Readonly<{
      readonly captured_at: string;
      readonly date: string;
      readonly fact_id: string;
      readonly rain_probability: number | null;
      readonly rain_probability_by_slot: Readonly<{
        readonly dinner: number | null;
        readonly lunch: number | null;
        readonly period_hours: 6 | 12 | null;
      }>;
      readonly sky: "clear" | "few_clouds" | "cloudy" | "overcast" | "rain" | "showers" | "storm" | "snow" | "fog" | "wind" | null;
      readonly sky_code: string | null;
      readonly sky_description: string | null;
      readonly source_version: string;
      readonly temp_max: number | null;
      readonly temp_min: number | null;
      readonly wind: Readonly<{
        readonly direction: "N" | "NE" | "E" | "SE" | "S" | "SW" | "W" | "NW" | "calm" | null;
        readonly gust_kmh: number | null;
        readonly speed_kmh: number | null;
      }>;
    }>)[];
  readonly facts: Readonly<{
    readonly status: "available";
    readonly value: readonly (Readonly<{
        readonly capture_method: "json_adapter";
        readonly captured_at: string;
        readonly fact_class: "weather_forecast_hour";
        readonly fact_id: string;
        readonly fingerprint: string;
        readonly observed_or_forecast: "forecast";
        readonly payload: Readonly<{
          readonly local_hour: string;
          readonly precipitation_probability_pct: number | null;
          readonly precipitation_tenths_mm: number | null;
          readonly sky_code: string | null;
          readonly temperature_c: number | null;
        }>;
        readonly source_version: string;
        readonly state: "current" | "cancelled";
        readonly subject_key: string;
        readonly supersedes_fact_id: string | null;
        readonly valid_from: string;
        readonly valid_until: string;
      }>)[];
  }> | Readonly<{
    readonly reason: "location_missing" | "parte_disabled" | "capture_pending" | "never_captured" | "outage" | "no_observations";
    readonly status: "no_data";
  }>;
  readonly from: string;
  readonly health: Readonly<{
    readonly state: "location_missing";
  }> | Readonly<{
    readonly location_code: string;
    readonly state: "parte_disabled" | "capture_pending" | "never_captured";
  }> | Readonly<{
    readonly last_attempt_at: string;
    readonly last_attempt_outcome: "captured" | "unchanged" | "partial" | "outage" | "rejected";
    readonly last_success_at: string | null;
    readonly last_success_source_version: string | null;
    readonly location_code: string;
    readonly outage_reason: string | null;
    readonly state: "healthy" | "outage";
  }>;
  readonly observed_at: string;
  readonly restaurant_id: string;
  readonly source: "aemet";
  readonly superseded_in_window: number;
  readonly tenant_id: string;
  readonly until: string;
}>
export type InsightsElParteNearbyEvents = Readonly<{
  readonly contract: "exylon.insights.el-parte-nearby-events@2.0";
  readonly facts: Readonly<{
    readonly status: "available";
    readonly value: readonly (Readonly<{
        readonly capture_method: "web_search_extraction";
        readonly captured_at: string;
        readonly fact_class: "event";
        readonly fact_id: string;
        readonly fingerprint: string;
        readonly payload: Readonly<{
          readonly approx_walk_minutes?: number | null;
          readonly attendance_band: "ciudad" | "masivo" | "desconocido" | "mediano";
          readonly capture_version: "@2";
          readonly coordinates_distance_m?: number | null;
          readonly dates_to_confirm?: boolean;
          readonly distance_check?: "agrees" | "disagrees" | "unchecked";
          readonly distance_m: number | null;
          readonly end_local: string | null;
          readonly extra_source_urls?: readonly (string)[];
          readonly geocoder_distance_m?: number | null;
          readonly impact_band: "lleno_antes_despues" | "vaciado_durante" | "neutral" | null;
          readonly kind: "concert" | "festival" | "sport" | "market" | "congress" | "cruise" | "other" | "theatre" | "cinema";
          readonly model_municipality: string;
          readonly municipality_check: "agrees" | "disagrees" | "unknown";
          readonly municipality_code: string;
          readonly municipality_name: string;
          readonly origin_code: string;
          readonly provenance: Readonly<{
            readonly attendance: "search_model";
            readonly attendance_basis?: "announced" | "venue_capacity" | "unknown";
            readonly discovery: "search_model";
            readonly geocoder: string | null;
            readonly location: "search_model" | "geocoder" | null;
          }>;
          readonly source_domain: string;
          readonly source_url: string;
          readonly start_local: string;
          readonly title: string;
          readonly unverified_reason: "distance_unknown" | "geocoder_off" | "restaurant_pin_missing" | "not_found" | "imprecise" | "geocoder_failed" | "geocoder_deadline" | null;
          readonly venue: string;
          readonly venue_address: string | null;
          readonly venue_capacity?: number | null;
          readonly venue_point: Readonly<{
            readonly latitude: number;
            readonly longitude: number;
          }> | null;
          readonly venue_precision: "address" | "street" | "place" | null;
          readonly verification: "verified" | "location_unverified";
        }>;
        readonly seen_again_at: string | null;
        readonly source_version: string;
        readonly state: "current" | "cancelled";
        readonly subject_key: string;
        readonly supersedes_fact_id: string | null;
        readonly valid_from: string;
        readonly valid_until: string;
      }>)[];
  }> | Readonly<{
    readonly reason: "location_missing" | "parte_disabled" | "address_missing" | "capture_pending" | "never_captured" | "municipality_unrecognised" | "outage" | "no_events_found" | "partial_search";
    readonly status: "no_data";
  }>;
  readonly from: string;
  readonly health: Readonly<{
    readonly state: "location_missing";
  }> | Readonly<{
    readonly location_code: string;
    readonly state: "parte_disabled";
  }> | Readonly<{
    readonly location_code: string;
    readonly radius_km: number;
    readonly state: "address_missing" | "capture_pending" | "never_captured" | "municipality_unrecognised";
  }> | Readonly<{
    readonly last_attempt_at: string;
    readonly last_attempt_outcome: "captured" | "unchanged" | "partial" | "outage" | "rejected";
    readonly last_success_at: string | null;
    readonly last_success_source_version: string | null;
    readonly location_code: string;
    readonly outage_reason: string | null;
    readonly radius_km: number;
    readonly state: "healthy" | "outage";
  }> | Readonly<{
    readonly last_attempt_at: string;
    readonly last_attempt_outcome: "partial";
    readonly last_success_at: string | null;
    readonly last_success_source_version: string | null;
    readonly location_code: string;
    readonly missing_families: readonly (string)[];
    readonly outage_reason: string | null;
    readonly radius_km: number;
    readonly state: "partial_search";
  }>;
  readonly observed_at: string;
  readonly restaurant_id: string;
  readonly restaurant_point?: "confirmed" | "missing" | null;
  readonly source: "web_events";
  readonly superseded_in_window: number;
  readonly tenant_id: string;
  readonly until: string;
}>
export type InsightsFlavourProfileQuery = Readonly<{
  readonly from: string;
  readonly until: string;
}>
export type InsightsFlavourProfileRead = Readonly<{
  readonly admission: Readonly<{
    readonly reasons: readonly ("window_open" | "projection_incomplete" | "projection_lagging" | "catalog_history_unavailable" | "unmatched_catalog_provenance" | "insufficient_profile_coverage" | "no_sales")[];
    readonly status: "admitted" | "abstained";
  }>;
  readonly catalog: Readonly<{
    readonly current_publication_version: number | null;
    readonly last_publication_version: number | null;
    readonly publication_versions: readonly (number)[];
  }>;
  readonly contract: "exylon.insights.flavour-profile-read@2.0";
  readonly contract_version: 2;
  readonly coverage: Readonly<{
    readonly decoded_source_event_count: number;
    readonly eligible_source_event_count: number;
    readonly issues: readonly (Readonly<{
        readonly event_count: number;
        readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
        readonly source_schema_key: string | null;
      }>)[];
    readonly measurement_started_at?: string;
    readonly observed_through?: string;
    readonly refused_source_event_count: number;
    readonly status: "complete" | "incomplete" | "unavailable";
    readonly undecoded_source_event_count: number;
    readonly window_closed?: boolean;
  }>;
  readonly demand: Readonly<{
    readonly covered_net_units: number;
    readonly profiled_units_basis_points: number | null;
    readonly total_net_units: number;
    readonly unmatched_net_units: number;
  }>;
  readonly formula_version: "supply-demand-lift-by-sensory-trait@2";
  readonly freshness: Readonly<{
    readonly as_of: string;
    readonly oldest_pending_age_milliseconds: number | null;
    readonly pending_source_event_count: number;
    readonly projection_watermark: Readonly<{
      readonly fact_ordinal: number;
      readonly occurred_at: string;
      readonly source_event_id: string;
    }> | null;
    readonly projection_watermark_advanced_at: string | null;
    readonly source_high_watermark: Readonly<{
      readonly fact_ordinal: number;
      readonly occurred_at: string;
      readonly source_event_id: string;
    }> | null;
    readonly status: "current" | "lagging" | "unavailable";
  }>;
  readonly ideas: readonly (Readonly<{
      readonly change: Readonly<{
        readonly change_kind: "add_seasoning_style" | "default_preparation";
        readonly code: string;
        readonly dish_id: string;
        readonly dish_name: string;
        readonly label: string | null;
        readonly lift_after_milli: number;
      }> | null;
      readonly kind: "more_demand" | "less_demand";
      readonly lift_milli: number;
      readonly trait_code: "crujiente" | "cremoso" | "tierno" | "jugoso" | "dulce" | "salado" | "acido" | "picante" | "umami" | "citrico" | "a_hierbas" | "ahumado" | "tostado" | "fresco" | "ligero" | "contundente" | "de_cuchara" | "intenso" | "suave" | "frito" | "a_la_brasa" | "crudo" | "frio" | "caliente" | "fresco_y_acido" | "crujiente_y_salado" | "cremoso_y_suave" | "dulce_y_cremoso";
    }>)[];
  readonly ratings: Readonly<{
    readonly review_count: number;
    readonly status: "not_read" | "measured" | "no_reviews";
  }>;
  readonly restaurant_id: string;
  readonly status: "available" | "unavailable";
  readonly supply: Readonly<{
    readonly body_dish_count: number;
    readonly covered_dish_count: number;
    readonly covered_exposure_basis_points: number;
    readonly excluded_dish_count: number;
    readonly trait_dish_count: number;
  }>;
  readonly tenant_id: string;
  readonly thresholds: Readonly<{
    readonly clear_probability_basis_points: 9500;
    readonly lift_less_milli: 870;
    readonly lift_more_milli: 1150;
    readonly min_covered_exposure_basis_points: 8000;
    readonly min_profiled_units_basis_points: 8000;
    readonly rating_delta_tenths: 3;
    readonly rating_prior_strength_reviews: 10;
    readonly rating_spread_tenths: 10;
    readonly share_prior_strength_units: 100;
    readonly speak_probability_basis_points: 8000;
  }>;
  readonly trait_map_version: string;
  readonly traits: readonly (Readonly<{
      readonly code: "crujiente" | "cremoso" | "tierno" | "jugoso" | "dulce" | "salado" | "acido" | "picante" | "umami" | "citrico" | "a_hierbas" | "ahumado" | "tostado" | "fresco" | "ligero" | "contundente" | "de_cuchara" | "intenso" | "suave" | "frito" | "a_la_brasa" | "crudo" | "frio" | "caliente" | "fresco_y_acido" | "crujiente_y_salado" | "cremoso_y_suave" | "dulce_y_cremoso";
      readonly confidence: "parece" | "claramente" | null;
      readonly demand_net_units: number;
      readonly demand_share_basis_points: number | null;
      readonly dishes_phrase: string;
      readonly group_code: string;
      readonly kind: "single" | "combination";
      readonly label: string;
      readonly lift_milli: number | null;
      readonly observed_lift_milli: number | null;
      readonly probability_less_basis_points: number | null;
      readonly probability_more_basis_points: number | null;
      readonly rating: Readonly<{
        readonly confidence: "parece" | "claramente" | null;
        readonly delta_tenths: number | null;
        readonly mean_tenths: number | null;
        readonly probability_better_basis_points: number | null;
        readonly probability_worse_basis_points: number | null;
        readonly review_count: number;
        readonly shrunk_mean_tenths: number | null;
        readonly signal: "better" | "worse" | "no_difference" | "insufficient_data";
      }> | null;
      readonly signal: "more_demand" | "less_demand" | "no_difference" | "not_offered" | "insufficient_data" | "abstained";
      readonly subject: string;
      readonly supply_dish_count: number;
      readonly supply_share_basis_points: number;
    }>)[];
  readonly unavailable_reason: "catalog_not_published" | "no_trait_dishes" | "sales_capacity_exceeded" | null;
  readonly window: Readonly<{
    readonly local_business_date_from_inclusive: string;
    readonly local_business_date_until_exclusive: string;
  }>;
}>
export type InsightsLoyaltyPeriodQuery = Readonly<{
  readonly cards?: "none";
  readonly comparePrevious?: "true" | "false";
  readonly from: string;
  readonly until: string;
}>
export type InsightsMetricSummary = Readonly<{
  readonly contract: "exylon.insights.metric-summary@1.0";
  readonly contract_version: 1;
  readonly coverage: Readonly<{
    readonly current_fact_count: number;
    readonly status: "complete" | "incomplete" | "unavailable";
    readonly unavailable_sources: readonly (string)[];
  }>;
  readonly formula_version: "integer-sum-by-key-unit-currency@1";
  readonly freshness: Readonly<{
    readonly as_of: string;
    readonly lag_milliseconds: number | null;
  }>;
  readonly local_window?: Readonly<{
    readonly basis: "restaurant_local_business_day";
    readonly local_business_date_from_inclusive: string;
    readonly local_business_date_until_exclusive: string;
  }>;
  readonly metrics: readonly (Readonly<{
      readonly currency: "EUR" | null;
      readonly dimensions?: Readonly<{ readonly [key: string]: unknown }>;
      readonly formula: "sum(integer_value)";
      readonly metric_key: string;
      readonly source_fact_count: number;
      readonly source_link_count?: number;
      readonly source_links: readonly (Readonly<{
          readonly occurred_at: string;
          readonly source_event_id: string;
        }>)[];
      readonly unit: "count" | "milliseconds" | "minor_currency_unit";
      readonly value: number;
    }>)[];
  readonly registry_fingerprint?: string;
  readonly registry_version?: string;
  readonly restaurant_id: string | null;
  readonly tenant_id: string;
  readonly time_source: "postgresql.transaction_timestamp";
  readonly watermark: Readonly<{
    readonly occurred_at: string | null;
    readonly source_event_id: string | null;
  }>;
  readonly window: Readonly<{
    readonly occurred_from: string | null;
    readonly occurred_until: string | null;
  }>;
}>
export type InsightsParteRadar = Readonly<{
  readonly calendar?: Readonly<{
    readonly absences: Readonly<{
      readonly holidays_missing_years: readonly (number)[];
      readonly matches: "healthy" | "outage" | "never_captured" | "source_unavailable";
      readonly school: "recorded" | "not_recorded";
    }>;
    readonly closed_days?: readonly (Readonly<{
        readonly closed_slots: readonly ("lunch" | "dinner")[] | null;
        readonly date: string;
        readonly note: string | null;
        readonly source: "exception" | "weekdays";
      }>)[];
    readonly from: string;
    readonly occasions: readonly (Readonly<{
        readonly date: string;
        readonly kind: "holiday";
        readonly name: string | null;
        readonly source: "recorded" | "national";
      }> | Readonly<{
        readonly bridge_days: readonly (string)[];
        readonly from: string;
        readonly holiday_dates: readonly (string)[];
        readonly kind: "puente";
        readonly until: string;
      }> | Readonly<{
        readonly date: string;
        readonly kind: "payday";
      }> | Readonly<{
        readonly from: string;
        readonly kind: "school_holiday";
        readonly name: string;
        readonly school_kind: string;
        readonly until: string;
      }> | Readonly<{
        readonly away_team: string;
        readonly competition_name: string;
        readonly date: string;
        readonly home_team: string;
        readonly interest: "spanish_club" | "top_spanish_club" | "national_team";
        readonly kickoff_at: string;
        readonly kickoff_local: string;
        readonly kind: "televised_match";
        readonly status: "scheduled" | "postponed" | "cancelled";
      }>)[];
    readonly until: string;
  }> | null;
  readonly contract: "exylon.insights.parte-radar@4.0";
  readonly effects?: Readonly<{
    readonly estimates?: readonly (Readonly<{
        readonly basis: "prior";
        readonly date: string;
        readonly effect_share: Readonly<{
          readonly lower: number;
          readonly upper: number;
        }>;
        readonly estimate: true;
        readonly event_ref: string;
        readonly occurrences?: readonly (Readonly<{
            readonly date: string;
            readonly share: number;
          }>)[];
        readonly past_times?: number;
        readonly slot_kind: "lunch" | "dinner";
      }>)[];
    readonly events: readonly (Readonly<{
        readonly date: string;
        readonly effect_share: Readonly<{
          readonly lower: number;
          readonly upper: number;
        }>;
        readonly event_ref: string;
        readonly occurrences?: readonly (Readonly<{
            readonly date: string;
            readonly share: number;
          }>)[];
        readonly past_times: number;
        readonly slot_kind: "lunch" | "dinner";
        readonly status: "measured";
      }> | Readonly<{
        readonly date: string;
        readonly event_ref: string;
        readonly past_times: 0;
        readonly status: "not_measured";
      }>)[];
    readonly matches?: readonly (Readonly<{
        readonly card: boolean;
        readonly contribution: Readonly<{
          readonly lower: number;
          readonly upper: number;
        }> | null;
        readonly date: string;
        readonly history?: Readonly<{
          readonly about: Readonly<{
            readonly kind: "team" | "competition";
            readonly name: string;
          }>;
          readonly effect: Readonly<{
            readonly date: string;
            readonly effect_share: Readonly<{
              readonly lower: number;
              readonly upper: number;
            }>;
            readonly event_ref: string;
            readonly occurrences?: readonly (Readonly<{
                readonly date: string;
                readonly share: number;
              }>)[];
            readonly past_times: number;
            readonly slot_kind: "lunch" | "dinner";
            readonly status: "measured";
          }> | Readonly<{
            readonly date: string;
            readonly event_ref: string;
            readonly past_times: 0;
            readonly status: "not_measured";
          }>;
        }>;
        readonly match_key: string;
        readonly score: number;
        readonly slot_kind: "lunch" | "dinner";
      }>)[];
    readonly ranking?: readonly (Readonly<{
        readonly card: boolean;
        readonly event_ref: string;
        readonly long_run: boolean;
        readonly score: number;
      }>)[];
  }>;
  readonly events: InsightsElParteNearbyEvents | null;
  readonly events_availability: Readonly<{
    readonly reason: null | "location_missing" | "address_missing" | "municipality_unrecognised" | "parte_disabled" | "capture_pending" | "never_captured" | "outage" | "outage_stale" | "no_observations" | "no_events_found" | "partial_search" | "expired_or_cancelled" | "invalid_source" | "source_unavailable";
    readonly status: "available" | "no_data";
    readonly usable_fact_count: number;
  }>;
  readonly events_searched_until?: string | null;
  readonly forecast?: Readonly<{
    readonly days: readonly (Readonly<{
        readonly above_normal?: boolean;
        readonly absent_slots?: readonly (Readonly<{
            readonly reason: "insufficient_history" | "calibration_under_supported";
            readonly slot_kind: "lunch" | "dinner";
          }>)[];
        readonly horizon: number;
        readonly iso_weekday: number;
        readonly service_date: string;
        readonly slots: readonly (Readonly<{
            readonly covers: Readonly<{
              readonly estimate: number;
              readonly lower: number;
              readonly upper: number;
            }>;
            readonly drivers: readonly (Readonly<{
                readonly contribution: Readonly<{
                  readonly lower: number;
                  readonly upper: number;
                }>;
                readonly describe: string;
                readonly driver: "rain" | "heat" | "cold" | "holiday" | "holiday_eve" | "event_fill" | "event_drain" | "payday" | "august" | "christmas" | "puente" | "school_holiday" | "televised_match";
                readonly matches?: number;
              }>)[];
            readonly expected: "open" | "closed";
            readonly grade?: "confirmed" | "same_weekday" | "first_days" | "declared";
            readonly normal: number | null;
            readonly slot_kind: "lunch" | "dinner";
            readonly terrace_covers: Readonly<{
              readonly estimate: number;
              readonly lower: number;
              readonly upper: number;
            }> | null;
          }>)[];
      }>)[];
    readonly interval_nominal_coverage: number;
    readonly issued_on: string;
    readonly method: string;
    readonly model_pending?: Readonly<{
      readonly expected_on: string | null;
      readonly needed_days: number;
      readonly reason: "insufficient_history" | "calibration_under_supported";
      readonly served_days: number;
    }> | null;
    readonly status: "available";
  }> | Readonly<{
    readonly reason: "no_forecast_issued" | "insufficient_history" | "source_unavailable" | "never_captured" | "outage" | "not_configured" | "nothing_scored";
    readonly status: "no_data";
  }>;
  readonly hit_rate?: Readonly<{
    readonly by_horizon: readonly (Readonly<{
        readonly baseline_mean_absolute_error: number | null;
        readonly horizon: number;
        readonly interval_coverage: number | null;
        readonly mean_absolute_error: number | null;
        readonly scored: number;
      }>)[];
    readonly days?: readonly (Readonly<{
        readonly hit: boolean;
        readonly lower: number;
        readonly observed_covers: number;
        readonly open_checks?: number;
        readonly service_date: string;
        readonly services: number;
        readonly services_inside?: number;
        readonly upper: number;
      }>)[];
    readonly status: "available";
    readonly window: Readonly<{
      readonly from: string;
      readonly to: string;
    }>;
    readonly within_range: Readonly<{
      readonly hits: number;
      readonly scored: number;
    }>;
  }> | Readonly<{
    readonly reason: "no_forecast_issued" | "insufficient_history" | "source_unavailable" | "never_captured" | "outage" | "not_configured" | "nothing_scored";
    readonly status: "no_data";
  }>;
  readonly observed_at: string;
  readonly owner_calendar: Readonly<{
    readonly availability: Readonly<{
      readonly reason: null;
      readonly status: "available";
    }> | Readonly<{
      readonly reason: "no_declarations";
      readonly status: "no_data";
    }>;
    readonly items: readonly (Readonly<{
        readonly declaration_id: string;
        readonly ends_at: string;
        readonly recorded_at: string;
        readonly source: "owner_declared";
        readonly starts_at: string;
        readonly status: "announced" | "provisional";
        readonly supersedes_version: number | null;
        readonly title: string;
        readonly version: number;
      }>)[];
    readonly source: "owner_declared";
  }>;
  readonly rain_hours?: Readonly<{
    readonly captured_at: string;
    readonly hours: readonly (Readonly<{
        readonly block_probability_pct: number | null;
        readonly local_hour: string;
        readonly precipitation_mm: number | null;
        readonly sky_code: string | null;
        readonly starts_at: string;
        readonly temperature_c: number | null;
      }>)[];
    readonly source: "aemet";
    readonly source_version: string;
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly source: "aemet";
    readonly status: "no_data";
  }>;
  readonly restaurant_id: string;
  readonly seats?: Readonly<{
    readonly bar: number | null;
    readonly inside: number | null;
    readonly source: "configuration_zones";
    readonly terrace: number | null;
  }> | null;
  readonly tenant_id: string;
  readonly timezone: "Europe/Madrid";
  readonly today_by_hour?: Readonly<{
    readonly display_only: true;
    readonly events?: readonly (Readonly<{
        readonly kind: "televised_match" | "rain";
        readonly local_time: string;
      }>)[];
    readonly grade?: "confirmed" | "same_weekday" | "first_days" | "declared";
    readonly normal: number | null;
    readonly reason: "no_forecast" | "forecast_abstained" | "no_hourly_shape" | "closed_today" | null;
    readonly service_date: string;
    readonly slots: readonly (Readonly<{
        readonly covers: Readonly<{
          readonly estimate: number;
          readonly lower: number;
          readonly upper: number;
        }>;
        readonly hours: readonly (Readonly<{
            readonly covers: Readonly<{
              readonly estimate: number;
              readonly lower: number;
              readonly upper: number;
            }>;
            readonly local_hour: string;
          }>)[];
        readonly slot_kind: "lunch" | "dinner";
      }>)[];
    readonly status: "available" | "no_data";
  }>;
  readonly weather: InsightsElParteExternalContext | null;
  readonly weather_availability: Readonly<{
    readonly reason: null | "location_missing" | "address_missing" | "municipality_unrecognised" | "parte_disabled" | "capture_pending" | "never_captured" | "outage" | "outage_stale" | "no_observations" | "no_events_found" | "partial_search" | "expired_or_cancelled" | "invalid_source" | "source_unavailable";
    readonly status: "available" | "no_data";
    readonly usable_fact_count: number;
  }>;
  readonly why?: Readonly<{
    readonly basis: "learned" | "conditions";
    readonly date: string;
    readonly rows: readonly (Readonly<{
        readonly contribution: Readonly<{
          readonly lower: number;
          readonly upper: number;
        }>;
        readonly driver: "rain" | "heat" | "cold" | "holiday" | "holiday_eve" | "event_fill" | "event_drain" | "payday" | "august" | "christmas" | "puente" | "school_holiday" | "televised_match" | "event";
        readonly estimate: boolean;
        readonly event_ref: string | null;
        readonly key: string;
        readonly label: string;
      }>)[];
  }>;
  readonly window: Readonly<{
    readonly from: string;
    readonly local_date_from_inclusive: string;
    readonly local_date_until_exclusive: string;
    readonly until: string;
  }>;
}>
export type InsightsParteRadarQuery = Readonly<{
  readonly date?: string;
}>
export type InsightsPeriodCardFeeds = Readonly<{
  readonly bill_split: Readonly<{
    readonly count_formula_version: "final-charge-paid-check-by-charge-mode-count@1";
    readonly count_metric_key: "service.check.paid_count";
    readonly coverage_status: "complete" | "incomplete";
    readonly paid_checks: Readonly<{
      readonly charge_modes: readonly (Readonly<{
          readonly charge_mode: "all" | "by_lines" | "participant" | "split_equal" | "split_free";
          readonly paid_check_count: number;
          readonly paid_check_total_minor: number;
          readonly share_basis_points: number;
        }>)[];
      readonly currency: "EUR";
      readonly paid_check_count: number;
      readonly paid_check_total_minor: number;
    }> | null;
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly status: "available";
    readonly total_formula_version: "final-charge-paid-check-total-by-charge-mode@1";
    readonly total_metric_key: "service.check.paid_total_minor";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly category_sales?: Readonly<{
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly formula_version: "publication-item-net-economics@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly catalog_publication_version: number;
        readonly category_icon: string | null;
        readonly category_id: string;
        readonly category_name: string;
        readonly currency: "EUR";
        readonly net_minor: number;
      }>)[];
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly checkout_funnel?: Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }> | Readonly<{
    readonly checkout_count: number;
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly denominator: "checkout_sessions_with_complete_bill_population";
    readonly formula_version: "owner-checkout-final-capture-review-snapshot@1";
    readonly fully_paid_count: number;
    readonly measured_duration_count: number;
    readonly p50_milliseconds: number | null;
    readonly p90_milliseconds: number | null;
    readonly paid_under_five_minutes_count: number;
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly recognition: "latest_projected_observation_for_checkout_window";
    readonly review_coverage: "complete" | "unavailable";
    readonly reviewed_after_fast_payment_count: number | null;
    readonly reviewed_after_payment_count: number | null;
    readonly settled_before_checkout_count: number;
    readonly status: "available";
  }>;
  readonly discount_pair?: Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }> | Readonly<{
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly denominator: "same_redemption_pre_discount_subtotal";
    readonly formula_version: "accepted-redemption-discount-subtotal-net@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly status: "available";
    readonly totals: Readonly<{
      readonly currency: "EUR";
      readonly exact_discount_minor: string;
      readonly exact_source_pair_count: string;
      readonly exact_subtotal_minor: string;
      readonly percentage_basis_points: number | null;
    }> | null;
  }>;
  readonly dish_sales?: Readonly<{
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly formula_version: "publication-item-net-economics@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly catalog_publication_version: number;
        readonly dish_id: string;
        readonly dish_name: string;
        readonly net_units: number;
      }>)[];
    readonly status: "available";
    readonly truncated: boolean;
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly engagement_activity?: Readonly<{
    readonly canonical_outcome_coverage: "unavailable";
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly denominator: "viewable_consented_sessions";
    readonly formula_version: "consented-session-dish-publication-intersection@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly add_intent_session_count: string;
        readonly catalog_publication_version: number;
        readonly detail_open_session_count: string;
        readonly dish_id: string;
        readonly dismissed_session_count: string;
        readonly observed_session_count: string;
        readonly viewable_session_count: string;
        readonly viewable_with_add_intent_session_count: string;
      }>)[];
    readonly status: "available";
    readonly totals?: Readonly<{
      readonly add_intent_basis_points: number | null;
      readonly viewable_session_count: string;
      readonly viewable_with_add_intent_session_count: string;
    }>;
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly force_closures?: Readonly<{
    readonly formula_version: "attested-closures-by-closing-date@1";
    readonly recognition: "closing_date";
    readonly rows: readonly (Readonly<{
        readonly amount_minor: number | null;
        readonly classification: "impago" | "cobro_externo" | "anulacion";
        readonly closure_count: number;
        readonly order_count: number;
      }>)[];
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly guest_cohorts?: Readonly<{
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly denominator: "consented_completed_visit_subjects";
    readonly formula_version: "frozen-owner-row@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly cohort: "new" | "returning" | "unidentified";
        readonly exact_count: string;
      }>)[];
    readonly status: "available";
    readonly total_exact_count?: string;
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly hour_weekday_cash?: Readonly<{
    readonly coverage_status: "complete" | "incomplete";
    readonly formula_version: "restaurant-local-hour-weekday-cash@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly captured_minor: number;
        readonly currency: "EUR";
        readonly local_hour: number;
        readonly local_weekday: number;
        readonly observed_day_count: number;
        readonly refunded_minor: number;
      }>)[];
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly loyalty_ledger?: Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }> | Readonly<{
    readonly cashback: Readonly<{
      readonly currency: "EUR";
      readonly exact_delta_minor: string;
    }> | null;
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly exact_points_delta: string;
    readonly formula_version: "frozen-owner-row@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly status: "available";
  }>;
  readonly payment_mix?: Readonly<{
    readonly charge_count: number;
    readonly coverage_status: "complete" | "partial" | "unavailable";
    readonly currency: "EUR";
    readonly formula_version: "gross-revenue-by-payment-method@1";
    readonly gross_minor: number;
    readonly metric_key: "service.revenue.gross_minor";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly charge_count: number;
        readonly gross_minor: number;
        readonly method: "card" | "cash" | "external" | "unknown";
        readonly share_basis_points: number | null;
      }>)[];
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly preferences?: Readonly<{
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly denominator: "consented_orders_with_frozen_mark";
    readonly exact_consented_order_count: string;
    readonly formula_version: "frozen-order-preference-population@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly code: string;
        readonly exact_order_count: string;
        readonly kind: "allergen" | "dietary" | "ingredient_exclusion" | "do_not_recommend";
        readonly strength: "hard" | "soft";
      }>)[];
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly preparation?: Readonly<{
    readonly coverage_status: "complete" | "incomplete";
    readonly distribution_formula_version: "nearest-rank-preparation-distribution@1";
    readonly maximum_milliseconds: number | null;
    readonly measured_item_count: number;
    readonly metric_key: "service.fulfillment.preparation_milliseconds";
    readonly minimum_milliseconds: number | null;
    readonly p50_milliseconds: number | null;
    readonly p90_milliseconds: number | null;
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly source_formula_version: "preparing-to-ready-item-duration@1";
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly ready_to_delivered: Readonly<{
    readonly coverage_status: "complete" | "incomplete";
    readonly distribution_formula_version: "nearest-rank-delivery-distribution@1";
    readonly maximum_milliseconds: number | null;
    readonly measured_item_count: number;
    readonly metric_key: "service.fulfillment.ready_to_delivered_milliseconds";
    readonly minimum_milliseconds: number | null;
    readonly over_ten_minutes_basis_points: number | null;
    readonly over_ten_minutes_count: number;
    readonly p50_milliseconds: number | null;
    readonly p90_milliseconds: number | null;
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly source_formula_version: "ready-to-delivered-item-duration@1";
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly recommendation_selection?: Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }> | Readonly<{
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly denominator: "viewed_dish_session_submitted_order_pairs";
    readonly exact_unlinked_dish_sessions: string;
    readonly formula_version: "viewable-session-attributed-order-selection@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly recognition: "attribution_recorded_in_window";
    readonly rows: readonly (Readonly<{
        readonly catalog_publication_version: number;
        readonly dish_id: string;
        readonly exact_linked_order_views: string;
        readonly exact_selected_order_views: string;
        readonly exact_unpicked_order_views: string;
      }>)[];
    readonly status: "available";
    readonly totals?: Readonly<{
      readonly exact_linked_order_views: string;
      readonly exact_selected_order_views: string;
      readonly exact_unpicked_order_views: string;
    }>;
  }>;
  readonly review_subratings?: Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }> | Readonly<{
    readonly category_average_tenths: Readonly<{
      readonly ambience: number | null;
      readonly food: number | null;
      readonly service: number | null;
    }>;
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly formula_version: "frozen-owner-row@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly category: "service" | "food" | "ambience";
        readonly exact_count: string;
        readonly rating: number;
      }>)[];
    readonly status: "available";
  }>;
  readonly review_words?: Readonly<{
    readonly exact_comment_count: Readonly<{
      readonly bad: string;
      readonly good: string;
    }>;
    readonly formula_version: "review-comment-word-count@1";
    readonly privacy_class: "aggregate_only";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly status: "available";
    readonly words: Readonly<{
      readonly bad: readonly (Readonly<{
          readonly exact_count: string;
          readonly word: string;
        }>)[];
      readonly good: readonly (Readonly<{
          readonly exact_count: string;
          readonly word: string;
        }>)[];
    }>;
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly sensory_demand: Readonly<{
    readonly contribution_scale: "1000000000000000000";
    readonly coverage: Readonly<{
      readonly basis: "supplied_complete_lineage_corpus";
      readonly complete_corpus: boolean;
      readonly complete_window: boolean;
      readonly issues: readonly (Readonly<{
          readonly reason: string;
          readonly source_line_count: number;
        }>)[];
      readonly unprojected_lines: number;
    }>;
    readonly coverage_formula_version: "sensory-coverage-floor-basis-points@1";
    readonly coverage_metric: Readonly<{
      readonly coverage_weighted_net_sold_units_micros: Readonly<{
        readonly exact_integer_value: string;
        readonly metric_key: "catalog.sensory.coverage_weighted_net_sold_units_micros";
        readonly scale: "1000000";
      }>;
      readonly profiled_coverage_basis_points: number | null;
      readonly profiled_net_sold_units: Readonly<{
        readonly exact_integer_value: string;
        readonly metric_key: "catalog.sensory.profiled_net_sold_units";
      }>;
      readonly total_net_sold_units: Readonly<{
        readonly exact_integer_value: string;
        readonly metric_key: "catalog.sensory.total_net_sold_units";
      }>;
      readonly weighted_coverage_basis_points: number | null;
    }> | null;
    readonly dimension_metrics: readonly (Readonly<{
        readonly basis_version: string;
        readonly dimension_code: string;
        readonly dimension_label: string;
        readonly exact_integer_value: string;
        readonly group_code: string;
        readonly group_label: string;
        readonly group_share_basis_points: number | null;
        readonly metric_key: "catalog.sensory.weighted_demand_scaled";
        readonly perceptual_concept: string | null;
        readonly perceptual_relationship: string | null;
        readonly scale: "1000000000000000000";
      }>)[];
    readonly formula_version: "sold-units-times-score-confidence-coverage@1";
    readonly group_share_formula_version: "sensory-group-positive-share-floor-basis-points@1";
    readonly perceptual_map_fingerprint: string;
    readonly perceptual_map_version: string;
    readonly privacy_class: "aggregate_only";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly signal: "model_derived_signal_not_measurement";
    readonly source_link_count: number;
    readonly source_links: readonly (Readonly<{
        readonly candidate_identity: string;
        readonly catalog_content_hash: string;
        readonly catalog_publication_version: number;
        readonly provenance: string;
        readonly sensory_input_fingerprint: string;
        readonly sensory_profile_version: number;
        readonly source_event_id: string;
        readonly source_payload_hash: string;
      }>)[];
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly stockout_affected_dishes: Readonly<{
    readonly active_stock_item_count: number;
    readonly affected_dish_count: number;
    readonly affected_dishes: readonly (Readonly<{
        readonly causes: readonly (Readonly<{
            readonly ingredient_id: string;
            readonly source_reference_ids: readonly (string)[];
            readonly stock_item_ids: readonly (string)[];
          }>)[];
        readonly dish_id: string;
        readonly dish_name: string;
      }>)[];
    readonly catalog_content_hash: string;
    readonly catalog_publication_version: number;
    readonly count_status: "complete" | "lower_bound";
    readonly formula_version: "active-depletion-latch-published-recipe-linkage@1";
    readonly metric_key: "catalog.stockout.affected_dish_count";
    readonly observed_at: string;
    readonly source_snapshot_fingerprint: string;
    readonly status: "available";
    readonly stock_items: readonly (Readonly<{
        readonly available_units: number;
        readonly base_unit_code: "MG" | "ML" | "UNIT";
        readonly catalog_unit_code: string;
        readonly catalog_unit_denominator_to_base: number;
        readonly catalog_unit_numerator_to_base: number;
        readonly depletion_latched: boolean;
        readonly dimension: "mass" | "volume" | "count";
        readonly id: string;
        readonly name_snapshot: string;
        readonly reorder_point_units: number;
        readonly reorder_required: boolean;
      }>)[];
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly table_occupancy: Readonly<{
    readonly formula_version: "clipped-session-union-over-observed-window@1";
    readonly metric_key: "service.table.observed_occupancy";
    readonly observed_from_inclusive: string | null;
    readonly observed_until_exclusive: string | null;
    readonly observed_window_milliseconds: number | null;
    readonly peak_hour: Readonly<{
      readonly bucket_identity: string;
      readonly from_inclusive: string;
      readonly local_business_date: string;
      readonly local_business_hour: number;
      readonly restaurant_occupancy_basis_points: number;
      readonly segment_count: number;
      readonly until_exclusive: string;
    }> | null;
    readonly peak_hour_status: "available" | "hour_partition_unavailable" | "no_observed_tables";
    readonly restaurant_occupancy_basis_points: number | null;
    readonly status: "available";
    readonly tables: readonly (Readonly<{
        readonly observed_window_milliseconds: number;
        readonly occupancy_basis_points: number;
        readonly occupied_milliseconds: number;
        readonly session_count: number;
        readonly table_id: string;
        readonly table_label: string | null;
      }>)[];
    readonly temporal_status: "complete_observed_window" | "available_as_of";
    readonly timezone: "Europe/Madrid";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly top_dishes?: Readonly<{
    readonly coverage_status?: "complete" | "partial" | "unavailable";
    readonly formula_version: "publication-item-net-economics@1";
    readonly projection: Readonly<{
      readonly coverage: Readonly<{
        readonly decoded_source_event_count: number;
        readonly eligible_source_event_count: number;
        readonly issues: readonly (Readonly<{
            readonly event_count: number;
            readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
            readonly source_schema_key: string | null;
          }>)[];
        readonly measurement_started_at?: string;
        readonly observed_through?: string;
        readonly refused_source_event_count: number;
        readonly status: "complete" | "incomplete" | "unavailable";
        readonly undecoded_source_event_count: number;
        readonly window_closed?: boolean;
      }>;
      readonly freshness: Readonly<{
        readonly as_of: string;
        readonly oldest_pending_age_milliseconds: number | null;
        readonly pending_source_event_count: number;
        readonly projection_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly projection_watermark_advanced_at: string | null;
        readonly source_high_watermark: Readonly<{
          readonly fact_ordinal: number;
          readonly occurred_at: string;
          readonly source_event_id: string;
        }> | null;
        readonly status: "current" | "lagging" | "unavailable";
      }>;
    }>;
    readonly rows: readonly (Readonly<{
        readonly catalog_publication_version: number;
        readonly category_id: string;
        readonly category_name: string;
        readonly currency: "EUR";
        readonly dish_id: string;
        readonly dish_name: string;
        readonly image?: Readonly<{
          readonly byte_size: number;
          readonly catalog_publication_version: number;
          readonly content_type: string;
          readonly media_id: string;
          readonly sha256_digest: string;
          readonly version: number;
        }> | null;
        readonly net_units: number;
      }>)[];
    readonly status: "available";
  }> | Readonly<{
    readonly reason: string;
    readonly status: "unavailable";
  }>;
}>
export type InsightsPeriodQuery = Readonly<{
  readonly cards?: "none" | "dish_sales";
  readonly comparePrevious?: "true" | "false";
  readonly comparison?: "previous_period" | "previous_calendar_month" | "same_weekdays_previous_week";
  readonly from: string;
  readonly grain?: "hour";
  readonly metricKeys: string;
  readonly until: string;
}>
export type InsightsPeriodRead = Readonly<{
  readonly card_feeds: InsightsPeriodCardFeeds;
  readonly compare_previous: boolean;
  readonly contract: "exylon.insights.period-read@1.0";
  readonly contract_version: 1;
  readonly coverage: Readonly<{
    readonly decoded_source_event_count: number;
    readonly eligible_source_event_count: number;
    readonly issues: readonly (Readonly<{
        readonly event_count: number;
        readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
        readonly source_schema_key: string | null;
      }>)[];
    readonly measurement_started_at?: string;
    readonly observed_through?: string;
    readonly refused_source_event_count: number;
    readonly status: "complete" | "incomplete" | "unavailable";
    readonly undecoded_source_event_count: number;
    readonly window_closed?: boolean;
  }> | null;
  readonly coverage_verdict?: "complete" | "observed_open_window" | "observed_partial_sources" | "lagging" | "incomplete" | null;
  readonly daily_series?: readonly (Readonly<{
      readonly currency: "EUR";
      readonly current_value: number | null;
      readonly local_business_date: string;
      readonly metric_key: string;
      readonly source_fact_count: number;
      readonly timezone: "Europe/Madrid";
    }>)[];
  readonly freshness: Readonly<{
    readonly as_of: string;
    readonly oldest_pending_age_milliseconds: number | null;
    readonly pending_source_event_count: number;
    readonly projection_watermark: Readonly<{
      readonly fact_ordinal: number;
      readonly occurred_at: string;
      readonly source_event_id: string;
    }> | null;
    readonly projection_watermark_advanced_at: string | null;
    readonly source_high_watermark: Readonly<{
      readonly fact_ordinal: number;
      readonly occurred_at: string;
      readonly source_event_id: string;
    }> | null;
    readonly status: "current" | "lagging" | "unavailable";
  }> | null;
  readonly gross_before_discount_minor?: number | null;
  readonly hourly?: Readonly<{
    readonly cash: Readonly<{
      readonly currency: "EUR";
      readonly hours: readonly (Readonly<{
          readonly from_inclusive: string;
          readonly gross_minor: number;
          readonly local_hour: string;
          readonly net_minor: number;
          readonly refunded_minor: number;
          readonly settled_accounts: number;
          readonly until_exclusive: string;
          readonly utc_offset_minutes: number;
        }>)[];
      readonly summary?: Readonly<{
        readonly active_hour_count: number;
        readonly mean_gross_per_active_hour_minor: number;
        readonly peak_hour_from: string;
        readonly quietest_active_hour_from: string;
      }> | null;
      readonly totals: Readonly<{
        readonly gross_minor: number;
        readonly net_minor: number;
        readonly refunded_minor: number;
        readonly settled_accounts: number;
      }>;
    }> | null;
    readonly coverage: Readonly<{
      readonly decoded_source_event_count: number;
      readonly eligible_source_event_count: number;
      readonly issues: readonly (Readonly<{
          readonly event_count: number;
          readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
          readonly source_schema_key: string | null;
        }>)[];
      readonly measurement_started_at?: string;
      readonly observed_through?: string;
      readonly refused_source_event_count: number;
      readonly status: "complete" | "incomplete" | "unavailable";
      readonly undecoded_source_event_count: number;
      readonly window_closed?: boolean;
    }>;
    readonly date: string;
    readonly freshness: Readonly<{
      readonly as_of: string;
      readonly oldest_pending_age_milliseconds: number | null;
      readonly pending_source_event_count: number;
      readonly projection_watermark: Readonly<{
        readonly fact_ordinal: number;
        readonly occurred_at: string;
        readonly source_event_id: string;
      }> | null;
      readonly projection_watermark_advanced_at: string | null;
      readonly source_high_watermark: Readonly<{
        readonly fact_ordinal: number;
        readonly occurred_at: string;
        readonly source_event_id: string;
      }> | null;
      readonly status: "current" | "lagging" | "unavailable";
    }>;
    readonly from_inclusive: string;
    readonly metric_version: "gross-refunded-and-paid-checks-by-hour@2";
    readonly observed_through?: string;
    readonly previous_week_same_weekday?: readonly (number | null)[];
    readonly status: "complete" | "provisional";
    readonly until_exclusive: string;
  }>;
  readonly last_observed_local_business_date?: string | null;
  readonly low_rating_count?: number | null;
  readonly metric_totals?: readonly (Readonly<{
      readonly absolute_delta: number | null;
      readonly change_basis_points: number | null;
      readonly comparison_status: "disabled" | "available" | "previous_zero" | "coverage_incomplete" | "projection_lagging" | "window_open";
      readonly currency: "EUR" | null;
      readonly current_source_fact_count: number;
      readonly current_value: number | null;
      readonly metric_key: string;
      readonly previous_source_fact_count: number;
      readonly previous_value: number | null;
      readonly unit: "count" | "milliseconds" | "minor_currency_unit";
    }>)[];
  readonly previous_coverage?: Readonly<{
    readonly decoded_source_event_count: number;
    readonly eligible_source_event_count: number;
    readonly issues: readonly (Readonly<{
        readonly event_count: number;
        readonly reason: "source_schema_discriminator_unavailable" | "source_schema_unregistered" | "invalid_source_event" | "invalid_payload" | "source_scope_mismatch" | "decoder_failure" | "invalid_candidate" | "unregistered_metric" | "currency_forbidden" | "currency_required" | "owner_effect_identity_conflict" | "owner_source_unavailable" | "measurement_not_started" | "window_not_complete";
        readonly source_schema_key: string | null;
      }>)[];
    readonly measurement_started_at?: string;
    readonly observed_through?: string;
    readonly refused_source_event_count: number;
    readonly status: "complete" | "incomplete" | "unavailable";
    readonly undecoded_source_event_count: number;
    readonly window_closed?: boolean;
  }> | null;
  readonly previous_coverage_verdict?: "complete" | "observed_open_window" | "observed_partial_sources" | "lagging" | "incomplete" | null;
  readonly previous_freshness?: Readonly<{
    readonly as_of: string;
    readonly oldest_pending_age_milliseconds: number | null;
    readonly pending_source_event_count: number;
    readonly projection_watermark: Readonly<{
      readonly fact_ordinal: number;
      readonly occurred_at: string;
      readonly source_event_id: string;
    }> | null;
    readonly projection_watermark_advanced_at: string | null;
    readonly source_high_watermark: Readonly<{
      readonly fact_ordinal: number;
      readonly occurred_at: string;
      readonly source_event_id: string;
    }> | null;
    readonly status: "current" | "lagging" | "unavailable";
  }> | null;
  readonly registry_fingerprint: string;
  readonly registry_version: string;
  readonly review_average_rating_tenths?: number | null;
  readonly series: readonly (Readonly<{
      readonly absolute_delta: number | null;
      readonly change_basis_points: number | null;
      readonly comparison_status: "disabled" | "available" | "previous_zero" | "coverage_incomplete" | "projection_lagging" | "window_open";
      readonly currency: "EUR" | null;
      readonly current_source_fact_count: number;
      readonly current_value: number | null;
      readonly dimensions: Readonly<{ readonly [key: string]: string | number | boolean | null }>;
      readonly formula_version: string;
      readonly metric_key: string;
      readonly previous_source_fact_count: number;
      readonly previous_value: number | null;
      readonly source_link_count: number;
      readonly source_links_sample: readonly (Readonly<{
          readonly aggregate_id: string;
          readonly aggregate_type: string;
          readonly correction_source_event_id: string | null;
          readonly event_type: string;
          readonly event_version: number;
          readonly occurred_at: string;
          readonly payload_hash: string;
          readonly projected_at: string;
          readonly source_event_id: string;
          readonly source_schema_key: string;
        }>)[];
      readonly unit: "count" | "milliseconds" | "minor_currency_unit";
    }>)[];
  readonly ticket_average?: Readonly<{
    readonly coverage_status: "complete" | "incomplete";
    readonly currency: "EUR";
    readonly formula_version: "paid-check-total-over-paid-checks@1";
    readonly paid_check_count: number;
    readonly paid_check_total_minor: number;
    readonly rounding: "half_up_to_minor_unit";
    readonly status: "available";
    readonly ticket_average_minor: number;
  }> | Readonly<{
    readonly formula_version: "paid-check-total-over-paid-checks@1";
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly ticket_average_previous?: Readonly<{
    readonly coverage_status: "complete" | "incomplete";
    readonly currency: "EUR";
    readonly formula_version: "paid-check-total-over-paid-checks@1";
    readonly paid_check_count: number;
    readonly paid_check_total_minor: number;
    readonly rounding: "half_up_to_minor_unit";
    readonly status: "available";
    readonly ticket_average_minor: number;
  }> | Readonly<{
    readonly formula_version: "paid-check-total-over-paid-checks@1";
    readonly reason: string;
    readonly status: "unavailable";
  }>;
  readonly unavailable_metrics: readonly (Readonly<{
      readonly metric_key: string;
      readonly reason: "metric_unregistered" | "dimensions_unobserved" | "exact_card_feed_only";
    }>)[];
  readonly window: Readonly<{
    readonly basis: "restaurant_local_business_day";
    readonly comparison_kind?: "previous_period" | "previous_calendar_month" | "same_weekdays_previous_week";
    readonly current_window: Readonly<{
      readonly local_business_date_from_inclusive: string;
      readonly local_business_date_until_exclusive: string;
    }>;
    readonly duration_local_days: number;
    readonly previous_window: Readonly<{
      readonly local_business_date_from_inclusive: string;
      readonly local_business_date_until_exclusive: string;
    }>;
    readonly restaurant_id: string;
    readonly tenant_id: string;
    readonly timezone: "Europe/Madrid";
  }>;
}>
export type InsightsPromotionMonthQuery = Readonly<{
  readonly comparePrevious?: "true" | "false";
  readonly month: string;
}>
export type InsightsPromotionMonthRead = Readonly<{
  readonly cohorts: Readonly<{
    readonly daily_series?: readonly (Readonly<{
        readonly currency: "EUR";
        readonly current_value: number | null;
        readonly local_business_date: string;
        readonly metric_key: string;
        readonly source_fact_count: number;
        readonly timezone: "Europe/Madrid";
      }>)[];
    readonly monthly_total: Readonly<{
      readonly currency: "EUR";
      readonly current: Readonly<{
        readonly discount_minor: number | null;
        readonly discounted_order_count: number | null;
        readonly net_discount_minor: number | null;
        readonly promotion_discounted_order_count: number | null;
        readonly promotion_uses: number | null;
        readonly refunded_discount_minor: number | null;
      }>;
      readonly previous: Readonly<{
        readonly discount_minor: number | null;
        readonly discounted_order_count: number | null;
        readonly net_discount_minor: number | null;
        readonly promotion_discounted_order_count: number | null;
        readonly promotion_uses: number | null;
        readonly refunded_discount_minor: number | null;
      }>;
    }> | null;
    readonly promotions: readonly (Readonly<{
        readonly currency: "EUR";
        readonly current: Readonly<{
          readonly average_bill: Readonly<{
            readonly denominator_count: number;
            readonly numerator_minor: number;
          }> | null;
          readonly bill_total_minor: number | null;
          readonly consumed_count: number | null;
          readonly discount_minor: number | null;
          readonly net_discount_minor: number | null;
          readonly refunded_discount_minor: number | null;
          readonly status: "available" | "available_as_of" | "empty_cohort" | "cohort_unavailable" | "suppressed_small_group" | "coverage_incomplete" | "projection_lagging" | "comparison_disabled";
        }>;
        readonly definition_id: string;
        readonly previous: Readonly<{
          readonly average_bill: Readonly<{
            readonly denominator_count: number;
            readonly numerator_minor: number;
          }> | null;
          readonly bill_total_minor: number | null;
          readonly consumed_count: number | null;
          readonly discount_minor: number | null;
          readonly net_discount_minor: number | null;
          readonly refunded_discount_minor: number | null;
          readonly status: "available" | "available_as_of" | "empty_cohort" | "cohort_unavailable" | "suppressed_small_group" | "coverage_incomplete" | "projection_lagging" | "comparison_disabled";
        }>;
      }>)[];
    readonly qualification: "complete" | "in_progress" | "coverage_incomplete" | "projection_lagging";
    readonly recognition: "accepted_redemption_cohort";
  }>;
  readonly contract: "exylon.insights.promotion-month-read@1.0";
  readonly contract_version: 1;
  readonly month: string;
  readonly period: InsightsPeriodRead;
}>
export type InventoryAllocation = Readonly<{
  readonly batch_id: string;
  readonly quantity_units: number;
  readonly stock_item_id: string;
}>
export type InventoryAvailabilityReconciliationResult = Readonly<{
  readonly configuration_policy_fingerprint: string;
  readonly configuration_publication_version: number;
  readonly contract: "exylon.inventory.availability-reconciliation-result@1.0";
  readonly effective_at: string;
  readonly input_fingerprint: string;
  readonly observed_stock_item_count: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly zero_epochs: readonly (Readonly<{
      readonly delivered_to_catalog: boolean;
      readonly newly_observed: boolean;
      readonly source_reference_id: string;
      readonly stock_item_id: string;
      readonly stock_item_version: number;
      readonly zero_generation: number;
    }>)[];
}>
export type InventoryAvailabilityRecoveryHandoff = Readonly<{
  readonly contract: "exylon.inventory.availability-recovery-handoff@1.0";
  readonly ingredient_id: string;
  readonly recovered_at: string;
  readonly restaurant_id: string;
  readonly source_reference_ids: readonly (string)[];
  readonly stock_item_id: string;
  readonly tenant_id: string;
}>
export type InventoryAvailabilityZeroEpoch = Readonly<{
  readonly delivered_to_catalog: boolean;
  readonly newly_observed: boolean;
  readonly source_reference_id: string;
  readonly stock_item_id: string;
  readonly stock_item_version: number;
  readonly zero_generation: number;
}>
export type InventoryAvailabilityZeroHandoff = Readonly<{
  readonly contract: "exylon.inventory.availability-zero-handoff@1.0";
  readonly ingredient_id: string;
  readonly occurred_at: string;
  readonly restaurant_id: string;
  readonly source_reference_id: string;
  readonly stock_item_id: string;
  readonly stock_policy: "hide_customer" | "hide_and_block";
  readonly tenant_id: string;
  readonly zero_generation: number;
}>
export type InventoryBatch = Readonly<{
  readonly available_units: number;
  readonly cost_minor: number | null;
  readonly currency: "EUR" | null;
  readonly expiration_state: "none" | "expired" | "today" | "within_3_days" | "within_7_days" | "within_30_days" | "later";
  readonly expires_at: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly lot_code: string;
  readonly on_hand_units: number;
  readonly received_at: string;
  readonly reserved_units: number;
  readonly restaurant_id: string;
  readonly stock_item_id: string;
  readonly tenant_id: string;
  readonly version: number;
}>
export type InventoryBridgeItemQuery = Readonly<{
  readonly expected_version?: string;
  readonly form: "inventory.stock-item.open" | "inventory.purchase-notice.open";
  readonly stock_item_id?: string;
  readonly stock_item_ids?: string;
}>
export type InventoryBridgeReconcileQuery = Readonly<{
  readonly expected_version?: string;
  readonly form: "inventory.stock-item.reconcile";
  readonly reason_code?: string;
  readonly stock_item_id?: string;
}>
export type InventoryBridgeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.inventory.bridge-revalidation@1.0";
  readonly form: "inventory.stock-item.reconcile" | "inventory.stock-item.open" | "inventory.purchase-notice.open";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{ readonly [key: string]: string | number | boolean | readonly (string)[] | readonly (number)[] }>;
  readonly verdict: "open" | "refused";
}>
export type InventoryCatalogDepletionLatch = "clear" | Readonly<{
  readonly latched_at: string;
  readonly state: "latched";
}>
export type InventoryCatalogPublicationHandoff = Readonly<{
  readonly content_hash: string;
  readonly contract: "exylon.inventory.catalog-publication-handoff@1.0";
  readonly ingredient_fingerprint: string;
  readonly ingredients: readonly (Readonly<{
      readonly active: true;
      readonly base_unit_code: string;
      readonly catalog_unit_definition_version: number;
      readonly catalog_unit_denominator_to_base: number;
      readonly catalog_unit_numerator_to_base: number;
      readonly contract: "exylon.catalog.published-inventory-ingredient@1.0";
      readonly dimension: "mass" | "volume" | "count";
      readonly ingredient_concept_id: string;
      readonly ingredient_concept_version: number;
      readonly ingredient_id: string;
      readonly ingredient_mapping_coverage: "verified";
      readonly ingredient_mapping_version: number;
      readonly input_fingerprint: string;
      readonly name: string;
      readonly publication_content_hash: string;
      readonly publication_version: number;
      readonly restaurant_id: string;
      readonly restaurant_ingredient_version: number;
      readonly safety_registry_version: number;
      readonly tenant_id: string;
    }>)[];
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type InventoryCommandResult = Readonly<{
  readonly batch?: InventoryBatch;
  readonly operation: string;
  readonly position?: InventoryPosition;
  readonly reconciliation?: Readonly<{
    readonly batch_adjustments: readonly (Readonly<{
        readonly batch_id: string;
        readonly batch_version: number;
        readonly delta_units: number | number;
        readonly expires_at: string | null;
        readonly on_hand_after_units: number;
        readonly on_hand_before_units: number;
      }>)[];
    readonly nearest_expiration_after_at: string | null;
    readonly nearest_expiration_after_batch_id: string | null;
    readonly nearest_expiration_before_at: string | null;
    readonly nearest_expiration_before_batch_id: string | null;
    readonly on_hand_after_units: number;
    readonly on_hand_before_units: number;
    readonly on_hand_delta_units: number;
    readonly reorder_point_after_units: number;
    readonly reorder_point_before_units: number;
  }>;
  readonly reservation?: InventoryReservation;
  readonly resource_id?: string;
  readonly stock_item?: InventoryStockItem;
  readonly version?: number;
}>
export type InventoryDemandSource = Readonly<{
  readonly base_unit_code: string;
  readonly catalog_ingredient_id: string;
  readonly denominator_to_canonical_base: number;
  readonly ingredient_concept_version: number;
  readonly ingredient_mapping_version: number;
  readonly input_fingerprint: string;
  readonly inventory_rule: "deducts";
  readonly modifier_option_version: number | null;
  readonly multiplier: number;
  readonly numerator_to_canonical_base: number;
  readonly publication_version: number;
  readonly quantity_base_units: number;
  readonly recipe_version: number | null;
  readonly restaurant_ingredient_version: number;
  readonly safety_registry_version: number;
  readonly source_version: number;
}>
export type InventoryDishCostingList = Readonly<{
  readonly as_of: string;
  readonly contract: "exylon.inventory.dish-costing@1.0";
  readonly cost_basis: "latest";
  readonly default_tax_rate_bps: 0 | 400 | 1000 | 2100 | null;
  readonly dishes: readonly (Readonly<{
      readonly cost_minor: number;
      readonly costed_line_count: number;
      readonly coverage: "complete" | "partial" | "none";
      readonly dish_id: string;
      readonly estimated_line_count: number;
      readonly line_count: number;
      readonly loss_loaded_cost_minor: number;
      readonly margin: Readonly<{
        readonly contribution_minor: number;
        readonly food_cost_bps: number | null;
        readonly net_price_minor: number;
        readonly price_minor: number;
        readonly status: "available";
        readonly tax_rate_bps: 0 | 400 | 1000 | 2100;
        readonly tax_rate_source: "dish" | "restaurant_default";
      }> | Readonly<{
        readonly reason: "no_lines" | "coverage_incomplete" | "cost_estimated" | "no_price" | "no_default_tax_rate";
        readonly status: "unavailable";
      }>;
      readonly name: string;
      readonly price_minor: number;
      readonly tax_rate_bps: 0 | 400 | 1000 | 2100 | null;
      readonly uncosted_ingredient_ids: readonly (string)[];
      readonly zero_cost_line_count: number;
    }>)[];
  readonly loss_window_days: 28;
  readonly population: "active_dishes_of_current_publication_with_recipe_lines";
  readonly publication_version: number | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly total: number;
  readonly truncated: boolean;
}>
export type InventoryError = Readonly<{
  readonly code: "AUTHORIZATION_DENIED" | "CONFLICT" | "EXPIRY_AMBIGUOUS" | "INPUT_INVALID" | "MISSING" | "OVERFLOW" | "RESERVATION_EXPIRED" | "RETIREMENT_BLOCKED" | "STOCK_INSUFFICIENT" | "UOM_AMBIGUOUS" | "UOM_DIMENSION_MISMATCH" | "UOM_REMAINDER" | "UNCHANGED" | "WRITE_FAILED";
  readonly message: string;
}> | Readonly<{
  readonly details: InventoryReconcileBelowReservedDetails;
  readonly errorCode: "RECONCILE_BELOW_RESERVED";
  readonly message: string;
}>
export type InventoryOrderReservationActionRequest = Readonly<{
  readonly expected_reservation_version: number;
  readonly order_id: string;
  readonly order_version: number;
  readonly reservation_id: string;
}>
export type InventoryPosition = Readonly<{
  readonly available_units: number;
  readonly base_unit_code: "MG" | "ML" | "UNIT";
  readonly batch_id: string;
  readonly catalog_ingredient_id: string;
  readonly expires_at: string | null;
  readonly lot_code: string;
  readonly on_hand_units: number;
  readonly received_at: string;
  readonly reserved_units: number;
  readonly stock_item_id: string;
  readonly version: number;
}>
export type InventoryPublishedIngredientUsagePage = CatalogPublishedIngredientUsagePage
export type InventoryPublishedPolicyDecision = RestaurantInventoryPolicyDecision
export type InventoryPurchaseArrivalAnswerRequest = Readonly<{
  readonly arrived_then: boolean;
  readonly expected_version: number;
}>
export type InventoryPurchaseDocument = Readonly<{
  readonly amounts_withheld: boolean;
  readonly buyer_tax_id_printed: boolean | null;
  readonly captured_at: string;
  readonly captured_by: string;
  readonly checks: readonly (string)[];
  readonly classification: Readonly<{
    readonly age_days: number;
    readonly arrival_doubt?: Readonly<{
      readonly read_on: string;
      readonly suggested_on: string;
    }>;
    readonly arrival_on: string;
    readonly arrival_source: "delivery_date" | "document_date" | "captured";
    readonly duplicate_rule?: "image" | "number" | "total" | "headless_lines";
    readonly headless: boolean;
    readonly paper: "purchase" | "served_on_premises" | "not_purchase";
    readonly paper_on: string;
    readonly paper_source: "delivery_date" | "document_date" | "captured";
    readonly stock: "enters" | "cost_only" | "none";
  }> | null;
  readonly contract: "exylon.inventory.purchase-documents@1.0#document";
  readonly counts: Readonly<{
    readonly applied: number;
    readonly creating: number;
    readonly expenses: number;
    readonly failed: number;
    readonly lines: number;
    readonly linked: number;
    readonly questions: number;
    readonly undone: number;
  }>;
  readonly delivery_date: string | null;
  readonly document_date: string | null;
  readonly document_id: string;
  readonly duplicate_of: string | null;
  readonly kind: "ticket" | "albaran_priced" | "albaran_unpriced" | "invoice" | "credit_note" | "not_purchase" | null;
  readonly lines: readonly (InventoryPurchaseLine)[] | null;
  readonly linked_document_ids: readonly (string)[];
  readonly net_total_minor: number | null;
  readonly number: string | null;
  readonly page_count: number;
  readonly pages: readonly (Readonly<{
      readonly byte_size: number;
      readonly content_type: "image/jpeg" | "image/png" | "image/webp" | "application/pdf";
      readonly index: number;
    }>)[];
  readonly paid_from_drawer: boolean;
  readonly paper_on: string | null;
  readonly preview_lines: readonly (Readonly<{
      readonly clean_name: string | null;
      readonly index: number;
      readonly printed: string;
      readonly quantity: number | string | null;
      readonly unit: string;
    }>)[] | null;
  readonly preview_revision: number | null;
  readonly prices_include_tax: boolean | null;
  readonly reading_state: "capturing" | "waiting" | "read" | "review" | "not_purchase" | "unreadable" | "duplicate" | "undone" | "reading" | "recognising";
  readonly received_on: string | null;
  readonly restaurant_id: string;
  readonly review_reason: string | null;
  readonly same_delivery: readonly (Readonly<{
      readonly line_index: number;
      readonly quantity_units: number;
      readonly receipt_id: string;
      readonly received_on: string;
      readonly stock_dimension: "mass" | "volume" | "count";
      readonly stock_item_id: string;
      readonly stock_item_name: string;
    }>)[];
  readonly stage: Readonly<{
    readonly attempts: number;
    readonly failure: string | null;
    readonly max_attempts: number | null;
    readonly name: "capture" | "read" | "classify" | "recognise" | "size" | "plan" | "apply" | "done";
    readonly next_attempt_at: string | null;
    readonly since: string;
    readonly status: "due" | "waiting" | "failed" | "done";
    readonly wait_reason: "model_unavailable" | "provider_refused" | "restaurant_key_refused" | "allowance_exhausted" | "switched_off" | "call_cap" | "storage_unavailable" | "masters_unavailable" | "figure_review" | null;
  }>;
  readonly state: "capturing" | "waiting" | "read" | "review" | "not_purchase" | "unreadable" | "duplicate" | "undone";
  readonly status: "received" | "reading" | "applied" | "questions" | "review" | "not_purchase" | "unreadable" | "duplicate" | "waiting_model" | "failed" | "undone";
  readonly supplier: Readonly<{
    readonly known: boolean;
    readonly name: string | null;
    readonly supplier_id: string | null;
    readonly tax_id: string | null;
  }> | null;
  readonly timing: Readonly<{
    readonly applied_at: string | null;
    readonly captured_at: string;
    readonly finished_at: string | null;
    readonly first_claimed_at: string | null;
    readonly planned_at: string | null;
    readonly read_at: string | null;
    readonly ready_at: string | null;
  }>;
  readonly total_minor: number | null;
  readonly totals: readonly (Readonly<{
      readonly base_minor: number;
      readonly rate_bps: number;
      readonly tax_minor: number | null;
    }>)[] | null;
  readonly totals_match: boolean | null;
  readonly undo_until: string | null;
  readonly undone_at: string | null;
  readonly unreadable_reason: string | null;
  readonly version: number;
  readonly waiting_reason: "model_unavailable" | "provider_refused" | "restaurant_key_refused" | "allowance_exhausted" | "switched_off" | "call_cap" | "storage_unavailable" | "masters_unavailable" | "figure_review" | null;
}>
export type InventoryPurchaseDocumentReadQuery = Readonly<Record<never, never>>
export type InventoryPurchaseDocumentUndoRequest = Readonly<{
  readonly expected_version: number;
  readonly line_index?: number;
}>
export type InventoryPurchaseFigureValidateRequest = Readonly<{
  readonly expected_version: number;
}>
export type InventoryPurchaseKeepApartRequest = Readonly<{
  readonly expected_version: number;
}>
export type InventoryPurchaseLine = Readonly<{
  readonly applied_at: string | null;
  readonly article_code: string | null;
  readonly awaiting_invoice: boolean;
  readonly brand: string | null;
  readonly category: "limpieza" | "desechables" | "menaje" | "mantenimiento" | "suministros" | "otros" | null;
  readonly clean_name: string | null;
  readonly confidence: "high" | "low" | null;
  readonly cost_corrected: boolean;
  readonly credit_effect: "goods_returned" | "price_adjustment" | "unknown" | null;
  readonly decision_source: "memory" | "recognizer" | "answer" | "link" | "rule" | "generated" | null;
  readonly expires_on: string | null;
  readonly generation: Readonly<{
    readonly attempts: number;
    readonly catalog_request_id: string | null;
    readonly failure: string | null;
    readonly master_code: string | null;
    readonly max_attempts: number;
    readonly next_attempt_at: string | null;
    readonly stage: "create" | "link";
    readonly state: "queued" | "waiting" | "done" | "failed" | "cancelled";
    readonly wait_reason: "model_unavailable" | "provider_refused" | "restaurant_key_refused" | "allowance_exhausted" | "switched_off" | "call_cap" | "storage_unavailable" | "masters_unavailable" | "figure_review" | null;
  }> | null;
  readonly is_beverage: boolean;
  readonly kind: "product" | "deposit" | "transport" | "discount" | "fee";
  readonly line_index: number;
  readonly linked_document_id: string | null;
  readonly linked_line_index: number | null;
  readonly lot: string | null;
  readonly master_code: string | null;
  readonly master_name: string | null;
  readonly net_total_minor: number | null;
  readonly paper_correction: "crossed_out" | "missing" | "returned" | null;
  readonly previous_cost: Readonly<{
    readonly cost_minor: number;
    readonly cost_version: number;
    readonly per: "kg" | "l" | "unit";
  }> | null;
  readonly price_change_bps: number | null;
  readonly price_question: boolean;
  readonly printed: string;
  readonly quantity_deficit_units: number | null;
  readonly quantity_printed: number | string | null;
  readonly quantity_units: number | null;
  readonly question: InventoryPurchaseQuestion | null;
  readonly receipt: Readonly<{
    readonly expires_on: string | null;
    readonly expiry_source: "delivery_note" | "typed" | "supplier_usual" | "usual_shelf_life" | "master_default" | "none";
    readonly receipt_id: string;
    readonly received_on: string;
    readonly reversed_at: string | null;
  }> | null;
  readonly returned_units: number | null;
  readonly size_edit?: Readonly<{
    readonly kind: "pack_size" | "quantity";
    readonly unit: "gram" | "millilitre" | "unit" | "kilogram" | "litre" | "pack";
  }> | null;
  readonly size_measure: Readonly<{
    readonly measured: boolean;
    readonly unit: "gram" | "millilitre";
  }> | null;
  readonly size_source?: "printed" | "person" | "observed" | "master" | "estimate" | null;
  readonly state: "applied" | "question" | "creating" | "expense" | "ignored" | "linked" | "cost_only" | "returned" | "undone";
  readonly stock_dimension?: "mass" | "volume" | "count" | null;
  readonly stock_item_id: string | null;
  readonly stock_item_name: string | null;
  readonly tax_rate_bps: number | null;
  readonly undo_until: string | null;
  readonly undone_at: string | null;
  readonly unit_cost: Readonly<{
    readonly cost_minor: number;
    readonly per: "kg" | "l" | "unit";
  }> | null;
  readonly unit_printed: "kilogram" | "gram" | "litre" | "millilitre" | "unit" | "pack" | null;
  readonly version: number;
}>
export type InventoryPurchaseLineAnswerRequest = Readonly<{
  readonly answer: Readonly<{
    readonly kind: "master";
    readonly master_code: string;
  }> | Readonly<{
    readonly category: "limpieza" | "desechables" | "menaje" | "mantenimiento" | "suministros" | "otros";
    readonly kind: "not_food";
  }> | Readonly<{
    readonly kind: "ignore";
  }> | Readonly<{
    readonly kind: "create_master";
  }> | Readonly<{
    readonly amount: number;
    readonly kind: "pack_size";
    readonly unit: "gram" | "millilitre" | "unit";
  }> | Readonly<{
    readonly kind: "quantity";
    readonly quantity: number;
  }> | Readonly<{
    readonly kind: "price";
    readonly line_total_minor: number;
  }> | Readonly<{
    readonly effect: "goods_returned" | "price_adjustment";
    readonly kind: "credit_effect";
  }> | Readonly<{
    readonly kind: "retry";
  }>;
  readonly expected_version: number;
  readonly line_index: number;
}>
export type InventoryPurchaseLineMeasureRequest = Readonly<{
  readonly expected_version: number;
  readonly holds_amount: number;
  readonly holds_unit: "gram" | "millilitre";
  readonly line_index: number;
}>
export type InventoryPurchaseOverview = Readonly<{
  readonly contract: "exylon.inventory.purchase-documents@1.0#overview";
  readonly documents: readonly (InventoryPurchaseDocument)[];
  readonly reading: "on" | "off" | "allowance_exhausted";
  readonly restaurant_id: string;
  readonly settings: Readonly<{
    readonly daily_document_allowance: number;
    readonly reading_enabled: boolean;
    readonly version: number;
  }>;
  readonly today: string;
  readonly upload: Readonly<{
    readonly content_types: readonly ("image/jpeg" | "image/png" | "image/webp" | "application/pdf")[];
    readonly max_bytes: number;
    readonly max_pages: number;
  }>;
}>
export type InventoryPurchaseOverviewQuery = Readonly<Record<never, never>>
export type InventoryPurchasePageUploadMetadata = Readonly<{
  readonly content_type: "image/jpeg" | "image/png" | "image/webp" | "application/pdf";
  readonly document_id: string;
  readonly page_count: number;
  readonly page_index: number;
  readonly paid_from_drawer?: boolean;
}>
export type InventoryPurchasePageUploadRequest = Readonly<{
  readonly metadata: InventoryPurchasePageUploadMetadata;
}>
export type InventoryPurchasePeriod = Readonly<{
  readonly contract: "exylon.inventory.purchase-costs@1.0#period";
  readonly days: readonly (Readonly<{
      readonly day: string;
      readonly documents: number;
      readonly spend_minor: number;
    }>)[];
  readonly document_total: number;
  readonly documents: readonly (InventoryPurchaseDocument)[];
  readonly expenses: readonly (Readonly<{
      readonly amount_minor: number;
      readonly category: "limpieza" | "desechables" | "menaje" | "mantenimiento" | "suministros" | "otros";
      readonly lines: number;
    }>)[];
  readonly from: string;
  readonly period: "week" | "month";
  readonly price_rises: readonly (Readonly<{
      readonly change_bps: number;
      readonly dish_count: number;
      readonly dishes: readonly (Readonly<{
          readonly dish_id: string;
          readonly name: string;
          readonly photo: Readonly<{
            readonly alt_text: string | null;
            readonly media_id: string;
            readonly sha256_digest: string;
            readonly version: number;
          }> | null;
        }>)[];
      readonly from: Readonly<{
        readonly cost_minor: number;
        readonly origin: "purchase_document" | "typed" | "invoice_correction";
        readonly per: "kg" | "l" | "unit";
        readonly purchase_document_id: string | null;
        readonly recorded_at: string;
        readonly supplier_id: string | null;
        readonly supplier_name: string | null;
      }>;
      readonly master_code: string | null;
      readonly name: string;
      readonly per: "kg" | "l" | "unit";
      readonly stock_item_id: string;
      readonly to: Readonly<{
        readonly cost_minor: number;
        readonly origin: "purchase_document" | "typed" | "invoice_correction";
        readonly per: "kg" | "l" | "unit";
        readonly purchase_document_id: string | null;
        readonly recorded_at: string;
        readonly supplier_id: string | null;
        readonly supplier_name: string | null;
      }>;
    }>)[];
  readonly publication_version: number | null;
  readonly register: Readonly<{
    readonly documents: number;
    readonly month: string;
    readonly total_minor: number;
    readonly without_buyer_tax_id: number;
  }>;
  readonly restaurant_id: string;
  readonly today: string;
}>
export type InventoryPurchasePeriodQuery = Readonly<{
  readonly period?: "week" | "month";
}>
export type InventoryPurchaseQuestion = Readonly<{
  readonly answer_unit: "gram" | "millilitre" | "unit" | null;
  readonly candidates: readonly (Readonly<{
      readonly master_code: string;
      readonly name: string;
      readonly score: number;
    }>)[];
  readonly kind: "product" | "quantity" | "pack_size" | "price" | "credit_effect";
  readonly preselected: string | null;
  readonly read: Readonly<{
    readonly line_total_minor: number | null;
    readonly pack_content: Readonly<{
      readonly amount: number;
      readonly unit: "gram" | "millilitre" | "unit";
    }> | null;
    readonly quantity: number | null;
    readonly unit: string;
    readonly unit_price_minor: number | null;
  }>;
  readonly reason: string | null;
  readonly suggested: Readonly<{
    readonly amount: number;
    readonly unit: string;
  }> | null;
}>
export type InventoryPurchaseSameDeliveryAnswerRequest = Readonly<{
  readonly expected_version: number;
  readonly same: boolean;
}>
export type InventoryPurchaseSettingsRequest = Readonly<{
  readonly daily_document_allowance: number;
  readonly expected_version: number;
  readonly reading_enabled: boolean;
}>
export type InventoryPurchaseSettingsResult = Readonly<{
  readonly contract: "exylon.inventory.purchase-documents@1.0#settings";
  readonly restaurant_id: string;
  readonly settings: Readonly<{
    readonly daily_document_allowance: number;
    readonly reading_enabled: boolean;
    readonly version: number;
  }>;
}>
export type InventoryPurchaseTraceDocument = Readonly<{
  readonly captured_at: string;
  readonly document_date: string;
  readonly document_id: string;
  readonly kind: "ticket" | "albaran_priced" | "albaran_unpriced" | "invoice" | "credit_note" | "not_purchase" | null;
  readonly lines: readonly (InventoryPurchaseTraceLine)[];
  readonly number: string | null;
  readonly page_count: number;
  readonly pages_available: boolean;
  readonly purged: boolean;
  readonly received_on: string | null;
  readonly retained_until: string;
  readonly supplier: Readonly<{
    readonly address: string | null;
    readonly name: string | null;
    readonly phone: string | null;
    readonly supplier_id: string | null;
    readonly tax_id: string | null;
  }> | null;
  readonly total_minor: number | null;
}>
export type InventoryPurchaseTraceExport = Readonly<{
  readonly completed_at: string | null;
  readonly contract: "exylon.inventory.purchase-trace@1.0#export";
  readonly document_count: number;
  readonly expires_at: string;
  readonly export_id: string;
  readonly failure: string | null;
  readonly files: readonly (Readonly<{
      readonly byte_size: number;
      readonly format: "csv" | "zip";
      readonly media_type: "text/csv" | "application/zip";
      readonly sha256: string;
    }>)[];
  readonly line_count: number;
  readonly page_count: number;
  readonly query: Readonly<{
    readonly from: string;
    readonly lot?: string;
    readonly master_code?: string;
    readonly product?: string;
    readonly stock_item_id?: string;
    readonly supplier?: string;
    readonly supplier_id?: string;
    readonly to: string;
  }>;
  readonly requested_at: string;
  readonly requested_by: string;
  readonly restaurant_id: string;
  readonly state: "preparing" | "ready" | "failed" | "expired";
  readonly version: number;
}>
export type InventoryPurchaseTraceExportDownloadQuery = Readonly<{
  readonly format?: "csv" | "zip";
}>
export type InventoryPurchaseTraceExportList = Readonly<{
  readonly contract: "exylon.inventory.purchase-trace@1.0#export-list";
  readonly exports: readonly (InventoryPurchaseTraceExport)[];
  readonly restaurant_id: string;
}>
export type InventoryPurchaseTraceExportListQuery = Readonly<Record<never, never>>
export type InventoryPurchaseTraceExportPrepareRequest = Readonly<{
  readonly export_id: string;
  readonly from: string;
  readonly lot?: string;
  readonly master_code?: string;
  readonly product?: string;
  readonly stock_item_id?: string;
  readonly supplier?: string;
  readonly supplier_id?: string;
  readonly to: string;
}>
export type InventoryPurchaseTraceLine = Readonly<{
  readonly brand: string | null;
  readonly expires_on: string | null;
  readonly line_index: number;
  readonly lot: string | null;
  readonly master_code: string | null;
  readonly printed: string;
  readonly product: string | null;
  readonly quantity_printed: number | string | null;
  readonly quantity_units: number | null;
  readonly receipt: Readonly<{
    readonly batch_id: string;
    readonly expires_on: string | null;
    readonly expiry_source: "delivery_note" | "typed" | "supplier_usual" | "usual_shelf_life" | "master_default" | "none";
    readonly lot_code: string | null;
    readonly receipt_id: string;
    readonly received_on: string;
    readonly reversed: boolean;
  }> | null;
  readonly state: "applied" | "question" | "creating" | "expense" | "ignored" | "linked" | "cost_only" | "returned" | "undone";
  readonly stock_item_id: string | null;
  readonly unit_printed: "kilogram" | "gram" | "litre" | "millilitre" | "unit" | "pack" | null;
}>
export type InventoryPurchaseTraceQuery = Readonly<{
  readonly from: string;
  readonly lot?: string;
  readonly master_code?: string;
  readonly product?: string;
  readonly stock_item_id?: string;
  readonly supplier?: string;
  readonly supplier_id?: string;
  readonly to: string;
}>
export type InventoryPurchaseTraceResult = Readonly<{
  readonly contract: "exylon.inventory.purchase-trace@1.0#result";
  readonly document_count: number;
  readonly documents: readonly (InventoryPurchaseTraceDocument)[];
  readonly query: Readonly<{
    readonly from: string;
    readonly lot?: string;
    readonly master_code?: string;
    readonly product?: string;
    readonly stock_item_id?: string;
    readonly supplier?: string;
    readonly supplier_id?: string;
    readonly to: string;
  }>;
  readonly restaurant_id: string;
  readonly retention_years: number;
  readonly truncated: boolean;
}>
export type InventoryRecipeCosting = Readonly<{
  readonly as_of: string;
  readonly basis: "latest" | "weighted_average";
  readonly contract: "exylon.inventory.recipe-costing@1.0";
  readonly cost_minor: number;
  readonly costed_line_count: number;
  readonly coverage: "complete" | "partial" | "none";
  readonly estimated_line_count: number;
  readonly line_count: number;
  readonly lines: readonly (Readonly<{
      readonly cost_basis: "latest" | "weighted_average" | null;
      readonly ingredient_id: string;
      readonly line_cost_minor: number | null;
      readonly quantity_base_units: number;
      readonly status: "costed" | "no_stock_item" | "no_cost" | "unit_mismatch";
      readonly stock_item_id: string | null;
      readonly unit_code: string;
      readonly unit_cost: Readonly<{
        readonly cost_minor: number;
        readonly per: "kg" | "l" | "unit";
        readonly recorded_at: string;
        readonly size_estimated: boolean;
        readonly source: "goods_receipt" | "manual" | "invoice_correction";
      }> | null;
    }>)[];
  readonly loss: Readonly<{
    readonly lines: readonly (Readonly<{
        readonly declared_loss_bps: number | null;
        readonly ingredient_id: string;
        readonly raise_bps: number;
        readonly source: "declared" | "recorded";
      }>)[];
    readonly loaded_cost_minor: number;
    readonly unmeasured_line_count: number;
    readonly window_days: 28;
  }>;
  readonly margin: Readonly<{
    readonly contribution_minor: number;
    readonly food_cost_bps: number | null;
    readonly net_price_minor: number;
    readonly price_minor: number;
    readonly status: "available";
    readonly tax_rate_bps: 0 | 400 | 1000 | 2100;
    readonly tax_rate_source: "dish" | "restaurant_default";
  }> | Readonly<{
    readonly reason: "no_lines" | "coverage_incomplete" | "cost_estimated" | "no_price" | "no_default_tax_rate";
    readonly status: "unavailable";
  }>;
  readonly options: Readonly<{
    readonly complete: boolean;
    readonly max_cost_minor: number;
    readonly min_cost_minor: number;
    readonly option_count: number;
    readonly options: readonly (Readonly<{
        readonly cost_minor: number;
        readonly costed_line_count: number;
        readonly coverage: "complete" | "partial" | "none";
        readonly group_id: string;
        readonly line_count: number;
        readonly option_id: string;
      }>)[];
  }> | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type InventoryRecipeCostingLine = Readonly<{
  readonly cost_basis: "latest" | "weighted_average" | null;
  readonly ingredient_id: string;
  readonly line_cost_minor: number | null;
  readonly quantity_base_units: number;
  readonly status: "costed" | "no_stock_item" | "no_cost" | "unit_mismatch";
  readonly stock_item_id: string | null;
  readonly unit_code: string;
  readonly unit_cost: Readonly<{
    readonly cost_minor: number;
    readonly per: "kg" | "l" | "unit";
    readonly recorded_at: string;
    readonly size_estimated: boolean;
    readonly source: "goods_receipt" | "manual" | "invoice_correction";
  }> | null;
}>
export type InventoryRecipeCostingRequest = Readonly<{
  readonly basis?: "latest" | "weighted_average";
  readonly lines: readonly (Readonly<{
      readonly ingredient_id: string;
      readonly quantity_base_units: number;
      readonly unit_code: string;
    }>)[];
  readonly option_groups?: readonly (Readonly<{
      readonly group_id: string;
      readonly options: readonly (Readonly<{
          readonly lines: readonly (Readonly<{
              readonly ingredient_id: string;
              readonly quantity_base_units: number;
              readonly unit_code: string;
            }>)[];
          readonly option_id: string;
        }>)[];
      readonly selection_max: number;
      readonly selection_min: number;
    }>)[];
  readonly price_minor: number | null;
  readonly tax_rate_bps: 0 | 400 | 1000 | 2100 | null;
}>
export type InventoryRecipeMargin = Readonly<{
  readonly contribution_minor: number;
  readonly food_cost_bps: number | null;
  readonly net_price_minor: number;
  readonly price_minor: number;
  readonly status: "available";
  readonly tax_rate_bps: 0 | 400 | 1000 | 2100;
  readonly tax_rate_source: "dish" | "restaurant_default";
}> | Readonly<{
  readonly reason: "no_lines" | "coverage_incomplete" | "cost_estimated" | "no_price" | "no_default_tax_rate";
  readonly status: "unavailable";
}>
export type InventoryReconcileBelowReservedDetails = Readonly<{
  readonly base_unit_code: "MG" | "ML" | "UNIT";
  readonly committed_quantity_units: number;
}>
export type InventoryReconcileBelowReservedHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly details: InventoryReconcileBelowReservedDetails;
    readonly errorCode: "RECONCILE_BELOW_RESERVED";
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type InventoryReservation = Readonly<{
  readonly allocations: readonly (InventoryAllocation)[];
  readonly catalog_input_fingerprint?: string;
  readonly catalog_publication_versions?: readonly (number)[];
  readonly demands?: readonly (InventoryRoundedDemand)[];
  readonly expires_at: string;
  readonly id: string;
  readonly line_outcomes: readonly (InventoryReservationLineOutcome)[];
  readonly policy: InventoryReservationPolicy;
  readonly restaurant_id: string;
  readonly service_order_id: string;
  readonly service_order_version?: number;
  readonly state: "active" | "released" | "consumed" | "expired";
  readonly tenant_id: string;
  readonly version: number;
}>
export type InventoryReservationActionRequest = Readonly<{
  readonly resource_id: string;
  readonly service_order_id: string;
  readonly service_order_version: number;
}>
export type InventoryReservationCommandResult = Readonly<{
  readonly operation: "reservation.reserve" | "reservation.release" | "reservation.consume";
  readonly reservation: InventoryReservation;
}>
export type InventoryReservationLineOutcome = Readonly<{
  readonly allocated_units: number;
  readonly requested_units: number;
  readonly shortfall_units: number;
  readonly stock_item_id: string;
}>
export type InventoryReservationPolicy = Readonly<{
  readonly input_fingerprint: string;
  readonly publication_version: number;
  readonly stock_policy: "none" | "hide_customer" | "hide_and_block";
}>
export type InventoryRoundedDemand = Readonly<{
  readonly base_unit_code: "MG" | "ML" | "UNIT";
  readonly catalog_ingredient_concept_id: string;
  readonly dimension: "mass" | "volume" | "count";
  readonly exact_denominator_units: number;
  readonly exact_numerator_units: number;
  readonly rounded_quantity_units: number;
  readonly rounding_excess_numerator: number;
  readonly rounding_policy: "ceiling_after_stock_item_aggregation";
  readonly sources: readonly (Readonly<{
      readonly base_unit_code: string;
      readonly catalog_ingredient_id: string;
      readonly denominator_to_canonical_base: number;
      readonly ingredient_concept_version: number;
      readonly ingredient_mapping_version: number;
      readonly input_fingerprint: string;
      readonly inventory_rule: "deducts";
      readonly modifier_option_version: number | null;
      readonly multiplier: number;
      readonly numerator_to_canonical_base: number;
      readonly publication_version: number;
      readonly quantity_base_units: number;
      readonly recipe_version: number | null;
      readonly restaurant_ingredient_version: number;
      readonly safety_registry_version: number;
      readonly source_version: number;
    }>)[];
  readonly stock_catalog_ingredient_concept_version: number;
  readonly stock_catalog_ingredient_mapping_version: number;
  readonly stock_catalog_restaurant_ingredient_version: number;
  readonly stock_catalog_safety_registry_version: number;
  readonly stock_item_id: string;
  readonly stock_item_version: number;
}>
export type InventoryServiceReservationConsumePayload = Readonly<{
  readonly effective_at?: string;
  readonly renew_if_uncontested?: true;
  readonly service_order_id: string;
  readonly service_order_version: number;
}>
export type InventoryServiceReservationReleasePayload = Readonly<{
  readonly effective_at?: string;
  readonly release_if_materialized_expired?: true;
  readonly service_order_id: string;
  readonly service_order_version: number;
}>
export type InventoryServiceReservationReserveConsumePayload = Readonly<{
  readonly acceptance: Readonly<{
    readonly acceptance_stage_token: string;
    readonly accepted_at: string;
    readonly anchor_id: string;
    readonly order_version: number;
    readonly service_receipt_id: string;
  }>;
  readonly catalog_input_fingerprint: string;
  readonly catalog_publication_versions: readonly (number)[];
  readonly demands: readonly (InventoryRoundedDemand)[];
  readonly effective_at: string;
  readonly expires_at: string;
  readonly lines: readonly (Readonly<{
      readonly quantity_units: number;
      readonly stock_item_id: string;
      readonly stock_item_version: number;
    }>)[];
  readonly record_shortfall?: true;
  readonly service_order_id: string;
  readonly service_order_version: number;
}>
export type InventoryServiceReservePayload = Readonly<{
  readonly catalog_input_fingerprint: string;
  readonly catalog_publication_versions: readonly (number)[];
  readonly demands: readonly (InventoryRoundedDemand)[];
  readonly effective_at: string;
  readonly expires_at: string;
  readonly lines: readonly (Readonly<{
      readonly quantity_units: number;
      readonly stock_item_id: string;
      readonly stock_item_version: number;
    }>)[];
  readonly service_order_id: string;
  readonly service_order_version: number;
}>
export type InventoryStockItem = Readonly<{
  readonly available_units: number;
  readonly base_unit_code: "MG" | "ML" | "UNIT";
  readonly catalog_ingredient_concept_id: string;
  readonly catalog_ingredient_concept_version: number;
  readonly catalog_ingredient_id: string;
  readonly catalog_ingredient_mapping_version: number;
  readonly catalog_restaurant_ingredient_version: number;
  readonly catalog_safety_registry_version: number;
  readonly catalog_unit_code: string;
  readonly catalog_unit_definition_version: number;
  readonly catalog_unit_denominator_to_base: number;
  readonly catalog_unit_numerator_to_base: number;
  readonly dimension: "mass" | "volume" | "count";
  readonly expiry_state: "expired" | "expires_soon" | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly name_snapshot: string;
  readonly next_expiration_at: string | null;
  readonly next_expiration_batch_id: string | null;
  readonly next_expiration_batch_version: number | null;
  readonly on_hand_units: number;
  readonly reorder_point_units: number;
  readonly reorder_required: boolean;
  readonly reserved_units: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly version: number;
}>
export type InventoryStockItemAvailabilityRecoveryResult = Readonly<{
  readonly available_units: number;
  readonly catalog_ingredient_id: string;
  readonly input_fingerprint: string;
  readonly operation: "stock-item.availability-reactivate";
  readonly reason_code: string;
  readonly recovered_at: string;
  readonly recovered_source_reference_ids: readonly (string)[];
  readonly resource_id: string;
  readonly stock_item_version: number;
}>
export type InventoryStockItemBatchAdjustment = Readonly<{
  readonly batch_id: string;
  readonly batch_version: number;
  readonly delta_units: number | number;
  readonly expires_at: string | null;
  readonly on_hand_after_units: number;
  readonly on_hand_before_units: number;
}>
export type InventoryStockItemCommandResult = Readonly<{
  readonly operation: "stock-item.retire";
  readonly stock_item: InventoryStockItem;
}>
export type InventoryStockItemCost = Readonly<{
  readonly cost_minor: number;
  readonly cost_version: number;
  readonly currency: "EUR";
  readonly origin: "purchase_document" | "typed" | "invoice_correction";
  readonly per: "kg" | "l" | "unit";
  readonly purchase_document_id: string | null;
  readonly received_quantity_units: number | null;
  readonly recorded_at: string;
  readonly recorded_by: string;
  readonly source: "goods_receipt" | "manual" | "invoice_correction";
  readonly supplier_id: string | null;
}>
export type InventoryStockItemCostList = Readonly<{
  readonly active_item_count: number;
  readonly as_of: string;
  readonly contract: "exylon.inventory.costs@1.0#list";
  readonly costed_item_count: number;
  readonly items: readonly (Readonly<{
      readonly latest: Readonly<{
        readonly cost_minor: number;
        readonly cost_version: number;
        readonly currency: "EUR";
        readonly origin: "purchase_document" | "typed" | "invoice_correction";
        readonly per: "kg" | "l" | "unit";
        readonly purchase_document_id: string | null;
        readonly received_quantity_units: number | null;
        readonly recorded_at: string;
        readonly recorded_by: string;
        readonly source: "goods_receipt" | "manual" | "invoice_correction";
        readonly supplier_id: string | null;
      }>;
      readonly size_estimated: boolean;
      readonly stock_item_id: string;
      readonly weighted_average: Readonly<{
        readonly cost_minor: number;
        readonly per: "kg" | "l" | "unit";
        readonly receipt_count: number;
        readonly received_quantity_units: number;
        readonly size_estimated: boolean;
      }> | null;
    }>)[];
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly weighted_window_days: 90;
  readonly yields: readonly (Readonly<{
      readonly loss_bps: number | null;
      readonly recorded_at: string;
      readonly stock_item_id: string;
      readonly yield_version: number;
    }>)[];
}>
export type InventoryStockItemLastReceipt = Readonly<{
  readonly on_hand_after_units: number;
  readonly quantity_units: number;
  readonly received_at: string;
}>
export type InventoryStockItemListEntry = Readonly<{
  readonly available_units: number;
  readonly base_unit_code: "MG" | "ML" | "UNIT";
  readonly catalog_depletion_latch: InventoryCatalogDepletionLatch;
  readonly catalog_ingredient_concept_id: string;
  readonly catalog_ingredient_concept_version: number;
  readonly catalog_ingredient_id: string;
  readonly catalog_ingredient_mapping_version: number;
  readonly catalog_restaurant_ingredient_version: number;
  readonly catalog_safety_registry_version: number;
  readonly catalog_unit_code: string;
  readonly catalog_unit_definition_version: number;
  readonly catalog_unit_denominator_to_base: number;
  readonly catalog_unit_numerator_to_base: number;
  readonly dimension: "mass" | "volume" | "count";
  readonly expiry_state: "expired" | "expires_soon" | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly last_receipt: InventoryStockItemLastReceipt | null;
  readonly name_snapshot: string;
  readonly next_expiration_at: string | null;
  readonly next_expiration_batch_id: string | null;
  readonly next_expiration_batch_version: number | null;
  readonly on_hand_units: number;
  readonly reorder_point_units: number;
  readonly reorder_required: boolean;
  readonly reserved_units: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly usual_daily_use_units: number | null;
  readonly version: number;
}>
export type InventoryStockItemPage = Readonly<{
  readonly counters?: Readonly<{
    readonly all_active: number;
    readonly all_including_retired: number;
    readonly expiry_ids: readonly (string)[];
    readonly reorder: number;
  }> | null;
  readonly items: readonly (InventoryStockItemListEntry)[];
  readonly next_cursor: string | null;
  readonly queried_at: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly total_count: number;
}>
export type InventoryStockItemReconciliation = Readonly<{
  readonly batch_adjustments: readonly (Readonly<{
      readonly batch_id: string;
      readonly batch_version: number;
      readonly delta_units: number | number;
      readonly expires_at: string | null;
      readonly on_hand_after_units: number;
      readonly on_hand_before_units: number;
    }>)[];
  readonly nearest_expiration_after_at: string | null;
  readonly nearest_expiration_after_batch_id: string | null;
  readonly nearest_expiration_before_at: string | null;
  readonly nearest_expiration_before_batch_id: string | null;
  readonly on_hand_after_units: number;
  readonly on_hand_before_units: number;
  readonly on_hand_delta_units: number;
  readonly reorder_point_after_units: number;
  readonly reorder_point_before_units: number;
}>
export type InventoryStockItemSupply = Readonly<{
  readonly delivery_weekdays: readonly (number)[];
  readonly lead_time_days: number | null;
  readonly stock_item_id: string;
  readonly supplier_id: string | null;
  readonly supply_version: number;
  readonly updated_at: string;
}>
export type InventoryStockItemYield = Readonly<{
  readonly loss_bps: number | null;
  readonly recorded_at: string;
  readonly recorded_by: string;
  readonly yield_version: number;
}>
export type InventorySupplier = Readonly<{
  readonly active: boolean;
  readonly learned_delivery_weekdays: readonly (number)[];
  readonly learned_lead_time_days: number | null;
  readonly name: string;
  readonly notes: string | null;
  readonly order_cut_off: string | null;
  readonly origin: "typed" | "document";
  readonly phone: string | null;
  readonly supplier_id: string;
  readonly tax_id: string | null;
  readonly updated_at: string;
  readonly version: number;
}>
export type InventorySupplierResult = Readonly<{
  readonly operation: "supplier.create" | "supplier.update";
  readonly supplier: Readonly<{
    readonly active: boolean;
    readonly learned_delivery_weekdays: readonly (number)[];
    readonly learned_lead_time_days: number | null;
    readonly name: string;
    readonly notes: string | null;
    readonly order_cut_off: string | null;
    readonly origin: "typed" | "document";
    readonly phone: string | null;
    readonly supplier_id: string;
    readonly tax_id: string | null;
    readonly updated_at: string;
    readonly version: number;
  }>;
}>
export type InventorySupplyList = Readonly<{
  readonly active_item_count: number;
  readonly contract: "exylon.inventory.supply@1.0#list";
  readonly items: readonly (Readonly<{
      readonly delivery_weekdays: readonly (number)[];
      readonly lead_time_days: number | null;
      readonly stock_item_id: string;
      readonly supplier_id: string | null;
      readonly supply_version: number;
      readonly updated_at: string;
    }>)[];
  readonly restaurant_id: string;
  readonly suppliers: readonly (Readonly<{
      readonly active: boolean;
      readonly learned_delivery_weekdays: readonly (number)[];
      readonly learned_lead_time_days: number | null;
      readonly name: string;
      readonly notes: string | null;
      readonly order_cut_off: string | null;
      readonly origin: "typed" | "document";
      readonly phone: string | null;
      readonly supplier_id: string;
      readonly tax_id: string | null;
      readonly updated_at: string;
      readonly version: number;
    }>)[];
  readonly tenant_id: string;
  readonly with_delivery_days_count: number;
  readonly with_supplier_count: number;
}>
export type InventoryUnitCostInput = Readonly<{
  readonly cost_minor: number;
  readonly per: "kg" | "l" | "unit";
}>
export type IssueOfferCouponCodeRequest = Readonly<{
  readonly code?: string;
  readonly definition_id: string;
}>
export type IssueOfferRewardPackRequest = Readonly<{
  readonly guest_id: string;
  readonly issued_reason: string;
  readonly pack: readonly (Readonly<{
      readonly count: number;
      readonly reward_tier: "bronze" | "silver" | "gold";
    }>)[];
  readonly source_table_session_id?: string;
}>
export type ListInventoryPublishedIngredientUsageQuery = Readonly<{
  readonly cursor?: string;
  readonly limit?: number;
}>
export type ListInventoryStockItemsQuery = Readonly<{
  readonly active?: boolean;
  readonly cursor?: string;
  readonly expiration_window_days?: 0 | 3 | 7 | 30;
  readonly limit?: number;
  readonly reorder_required?: boolean;
  readonly search?: string;
  readonly stock_item_ids?: string;
  readonly with_counters?: boolean;
}>
export type ListOfferCouponCodesQuery = Readonly<{
  readonly definition_id?: string;
  readonly page: number;
  readonly page_size: number;
  readonly search?: string;
}>
export type ListOfferDefinitionHistoryQuery = Readonly<{
  readonly page: number;
  readonly page_size: number;
}>
export type ListOfferDefinitionUsesQuery = Readonly<{
  readonly page: number;
  readonly page_size: number;
}>
export type OfferBillFacts = Readonly<{
  readonly contract: "exylon.offers.bill-facts@1.0";
  readonly currency: "EUR";
  readonly diners: readonly (Readonly<{
      readonly choice: Readonly<{
        readonly campaign_code: string | null;
        readonly chosen_at: string;
        readonly chosen_by_kind: "guest" | "staff";
        readonly coupon_issuance_id: string | null;
        readonly id: string;
        readonly version: number;
      }> | null;
      readonly feedback_eligible: boolean;
      readonly guest_profile_id: string | null;
      readonly kind: "registered" | "anonymous" | "named_by_staff" | "table";
      readonly new_guest: boolean;
      readonly participant_id: string | null;
    }>)[];
  readonly draft_cart_id: string | null;
  readonly evaluated_at: string;
  readonly facts_fingerprint: string;
  readonly lines: readonly (Readonly<{
      readonly cart_id: string;
      readonly catalog_category_id: string | null;
      readonly catalog_item_id: string;
      readonly catalog_publication_version: number;
      readonly line_id: string;
      readonly modifier_option_ids: readonly (string)[];
      readonly order_id: string | null;
      readonly paid: boolean;
      readonly participant_id: string | null;
      readonly quantity: number;
      readonly refunded: boolean;
      readonly send_rank: number;
      readonly unit_price_minor: number;
    }>)[];
  readonly party_size: number;
  readonly party_size_basis: "roster" | "stated" | "opening_hint" | "seats" | null;
  readonly party_size_roster: number | null;
  readonly party_size_stated: number | null;
  readonly restaurant_id: string;
  readonly rounds: readonly (Readonly<{
      readonly accepted: boolean;
      readonly cart_id: string;
      readonly draft: boolean;
      readonly final: boolean;
      readonly order_id: string | null;
      readonly order_version?: number | null;
      readonly placed_at: string;
      readonly quote_id: string | null;
      readonly redemption_id: string | null;
    }>)[];
  readonly table_id: string;
  readonly table_session_id: string;
  readonly tenant_id: string;
}>
export type OfferCouponCode = Readonly<{
  readonly cancelled_at?: string | null;
  readonly code: string;
  readonly contract: "exylon.offers.coupon-code@1.0";
  readonly created_at: string;
  readonly created_by: string;
  readonly definition_id: string;
  readonly id: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly use_count?: number;
}>
export type OfferCouponCodePage = Readonly<{
  readonly contract: "exylon.offers.coupon-code-page@1.0";
  readonly items: readonly (OfferCouponCode)[];
  readonly page: number;
  readonly page_size: number;
  readonly total: number;
}>
export type OfferCouponCodeTakenHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode: "OFFERS_COUPON_CODE_TAKEN";
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type OfferCouponIssuance = Readonly<{
  readonly contract: "exylon.offers.coupon-issuance@1.0";
  readonly definition_id: string;
  readonly expires_at: string | null;
  readonly guest_id: string;
  readonly id: string;
  readonly issued_at: string;
  readonly issued_by: string;
  readonly issued_reason: string;
  readonly restaurant_id: string;
  readonly source_table_session_id?: string | null;
  readonly tenant_id: string;
  readonly uses_count: number;
}>
export type OfferCouponRecall = Readonly<{
  readonly contract: "exylon.offers.coupon-recall@1.0";
  readonly definition_id: string;
  readonly definition_version: number;
  readonly kept_on_bill_count: number;
  readonly withdrawn_at: string;
  readonly withdrawn_count: number;
}>
export type OfferCouponRefusalHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode: "COUPON_EXPIRED" | "GUEST_ALREADY_USED_COUPON" | "COUPON_TOTAL_CAPACITY_REACHED" | "COUPON_WRONG_RESTAURANT" | "COUPON_CODE_NOT_FOUND" | "COUPON_SAVED_ACCOUNT_REQUIRED" | "COUPON_EARNED_IN_THIS_VISIT" | "COUPON_PARTY_SIZE_CAP_REACHED";
    readonly reason_text?: string;
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type OfferDefinition = Readonly<{
  readonly amount_minor: number | null;
  readonly archived_at?: string | null;
  readonly benefit_kind: "percentage" | "fixed_amount" | "free_item" | "buy_x_get_y";
  readonly buy_quantity: number;
  readonly contract: "exylon.offers.definition@1.0";
  readonly currency: "EUR" | null;
  readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
  readonly end_local_time?: string | null;
  readonly feedback_only: boolean;
  readonly id: string;
  readonly loyalty_tier_id: string | null;
  readonly maximum_discount_minor: number | null;
  readonly maximum_subtotal_minor: number | null;
  readonly minimum_party_size: number;
  readonly minimum_subtotal_minor: number;
  readonly name: string;
  readonly new_guest_only: boolean;
  readonly percentage_bps: number | null;
  readonly restaurant_id: string;
  readonly reward_catalog_item_id: string | null;
  readonly reward_item?: Readonly<{
    readonly id: string;
    readonly name: string;
  }> | null;
  readonly reward_quantity: number;
  readonly reward_tier?: "bronze" | "silver" | "gold" | null;
  readonly scope_kind: "ticket" | "catalog_item" | "catalog_category" | "catalog_section";
  readonly start_local_time?: string | null;
  readonly state: "active" | "retired";
  readonly targets: readonly (Readonly<{
      readonly target_id: string;
      readonly target_kind: "catalog_item" | "catalog_category" | "catalog_section";
    }>)[];
  readonly tenant_id: string;
  readonly total_redemption_limit: number | null;
  readonly updated_at: string;
  readonly updated_by: string;
  readonly uses_per_guest?: "once" | "every_visit";
  readonly valid_from_date: string | null;
  readonly valid_to_date: string | null;
  readonly version: number;
  readonly weekdays: readonly (number)[];
}>
export type OfferDefinitionArchivedHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode: "OFFERS_DEFINITION_ARCHIVED";
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type OfferDefinitionHistoryPage = Readonly<{
  readonly contract: "exylon.offers.definition-history-page@1.0";
  readonly events: readonly (Readonly<{
      readonly actor_display_name: string | null;
      readonly actor_id: string;
      readonly actor_resolution: "resolved" | "unavailable";
      readonly reason: Readonly<{
        readonly code: string;
        readonly note: string | null;
        readonly status: "recorded";
      }> | Readonly<{
        readonly code: null;
        readonly note: null;
        readonly status: "not_recorded" | "unknown_legacy";
      }>;
      readonly version: number;
    }>)[];
  readonly items: readonly (OfferHistoricalDefinition)[];
  readonly page: number;
  readonly page_size: number;
  readonly total: number;
}>
export type OfferDefinitionPage = Readonly<{
  readonly consumption: Readonly<{
    readonly as_of: string;
    readonly items: readonly (Readonly<{
        readonly consumed_count: number;
        readonly coupons?: Readonly<{
          readonly in_wallet: number;
          readonly issued: number;
          readonly on_bill: number;
          readonly used: number;
        }>;
        readonly definition_id: string;
        readonly live: "live" | "archived" | "paused" | "ended" | "scheduled" | "limit_reached" | "budget_spent" | "other_day" | "other_hours";
        readonly team?: boolean;
        readonly team_budget_spent?: boolean;
      }>)[];
  }>;
  readonly contract: "exylon.offers.definition-page@1.0";
  readonly items: readonly (OfferDefinition)[];
  readonly page: number;
  readonly page_size: number;
  readonly total: number;
}>
export type OfferDefinitionRedemptionConsumption = Readonly<{
  readonly consumed_count: number;
  readonly contract: "exylon.offers.definition-redemption-consumption@1.0";
  readonly coupons?: Readonly<{
    readonly in_wallet: number;
    readonly issued: number;
    readonly on_bill: number;
    readonly used: number;
  }>;
  readonly definition_id: string;
  readonly live: "live" | "archived" | "paused" | "ended" | "scheduled" | "limit_reached" | "budget_spent" | "other_day" | "other_hours";
  readonly restaurant_id: string;
  readonly team?: boolean;
  readonly team_budget_spent?: boolean;
  readonly tenant_id: string;
}>
export type OfferDefinitionRefusedHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode: "OFFERS_DEFINITION_REFUSED";
    readonly reason_code: "amount_zero" | "ends_in_past" | "dates_inverted" | "new_guest_with_feedback_only" | "target_not_on_carta" | "loyalty_tier_unknown" | "reward_conditions_not_allowed" | "hours_incomplete" | "uses_per_guest_not_allowed";
  }> | Readonly<{
    readonly errorCode: "OFFERS_COUPON_CODE_TAKEN";
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type OfferDefinitionSet = Readonly<{
  readonly approved_set_hash: string;
  readonly conservative_exposure_minor: number;
  readonly contract: "exylon.offers.definition-set@1.0";
  readonly created_at: string;
  readonly definitions: readonly (OfferDefinition)[];
  readonly exposure_assumption: "sum of each per-use cap times maximum uses";
  readonly id: string;
  readonly not_compensated: readonly (Readonly<{
      readonly definition_id: string;
      readonly reason: "changed" | "retired";
    }>)[];
  readonly proposal_id: string;
  readonly reserved_minor: number;
  readonly restaurant_id: string;
  readonly state: "active" | "retired";
  readonly tenant_id: string;
  readonly total_cap_minor: number;
  readonly version: number;
}>
export type OfferDefinitionUsePage = Readonly<{
  readonly contract: "exylon.offers.definition-use-page@1.0";
  readonly items: readonly (Readonly<{
      readonly at: string;
      readonly bill_minor: number | null;
      readonly id: string;
      readonly net_discount_minor: number;
      readonly source: "automatic" | "code" | "coupon";
      readonly state: "held" | "used";
    }>)[];
  readonly page: number;
  readonly page_size: number;
  readonly total: number;
}>
export type OfferDinerChoiceCheckRequest = Readonly<{
  readonly campaign_code: string | null;
  readonly coupon_issuance_id: string | null;
  readonly diner_kind: "registered" | "anonymous" | "named_by_staff" | "table";
  readonly guest_profile_id: string | null;
  readonly participant_id: string | null;
  readonly table_session_id: string;
}>
export type OfferDinerChoiceCheckResult = Readonly<{
  readonly accepted: boolean;
  readonly coupon_label: string | null;
  readonly definition_id: string | null;
  readonly refusal_reason: "COUPON_EXPIRED" | "GUEST_ALREADY_USED_COUPON" | "COUPON_TOTAL_CAPACITY_REACHED" | "COUPON_WRONG_RESTAURANT" | "COUPON_CODE_NOT_FOUND" | "COUPON_SAVED_ACCOUNT_REQUIRED" | "COUPON_EARNED_IN_THIS_VISIT" | "COUPON_PARTY_SIZE_CAP_REACHED" | null;
}>
export type OfferDinerClaimRequest = Readonly<{
  readonly from_participant_id: string;
  readonly table_session_id: string;
  readonly to_guest_profile_id: string;
  readonly to_participant_id: string;
}>
export type OfferDinerClaimResult = Readonly<{
  readonly contract: "exylon.offers.diner-claim@1.0";
  readonly holds: readonly (OfferDinerHold)[];
  readonly notices: readonly (OfferDinerNotice)[];
  readonly participant_id: string;
  readonly released_hold_ids: readonly (string)[];
  readonly table_session_id: string;
}>
export type OfferDinerHold = Readonly<{
  readonly contract: "exylon.offers.diner-hold@1.0";
  readonly coupon_code_id: string | null;
  readonly coupon_issuance_id: string | null;
  readonly definition_id: string;
  readonly definition_version: number;
  readonly discount_minor: number;
  readonly held_at: string;
  readonly id: string;
  readonly participant_id: string | null;
  readonly release_reason: "nothing_left" | "merged" | "guest_already_used" | "opened_by_mistake" | null;
  readonly released_at: string | null;
  readonly restaurant_id: string;
  readonly set_charged_minor: number;
  readonly source: "automatic" | "code" | "coupon";
  readonly state: "held" | "used" | "released";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly used_at: string | null;
  readonly uses_per_guest: "once" | "every_visit";
  readonly version: number;
}>
export type OfferDinerHoldReleaseRequest = Readonly<{
  readonly live_lines: readonly (Readonly<{
      readonly line_id: string;
      readonly participant_id: string | null;
      readonly quote_id: string;
    }>)[];
  readonly reason: "nothing_left" | "opened_by_mistake";
  readonly table_session_id: string;
}>
export type OfferDinerHoldReleaseResult = Readonly<{
  readonly contract: "exylon.offers.diner-hold-release@1.0";
  readonly released: readonly (OfferDinerHold)[];
}>
export type OfferDinerNotice = Readonly<{
  readonly applied_offer_label: string | null;
  readonly campaign_code: string | null;
  readonly condition_reasons: readonly ("eligible" | "inactive" | "not_started" | "expired" | "weekday" | "minimum_subtotal" | "maximum_subtotal" | "minimum_party_size" | "new_guest_required" | "feedback_required" | "loyalty_program_inactive" | "loyalty_tier_required" | "coverage_mismatch" | "saved_account_required" | "party_size_cap_reached")[];
  readonly coupon_issuance_id: string | null;
  readonly coupon_label: string | null;
  readonly participant_id: string | null;
  readonly reason_code: "better_offer_applied" | "equal_offer_applied" | "no_matching_items" | "conditions_not_met" | "bill_discount_cap_reached" | "total_capacity_reached" | "guest_already_used" | "coupon_expired";
}>
export type OfferGuestDefinitionSnapshot = Readonly<{
  readonly benefit_kind: "percentage";
  readonly contract: "exylon.offers.guest-definition-snapshot@1.0";
  readonly definition_id: string;
  readonly definition_version: number;
  readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
  readonly name: string;
  readonly percentage_bps: number;
  readonly reward_tier?: "bronze" | "silver" | "gold";
}> | Readonly<{
  readonly amount_minor: number;
  readonly benefit_kind: "fixed_amount";
  readonly contract: "exylon.offers.guest-definition-snapshot@1.0";
  readonly currency: "EUR";
  readonly definition_id: string;
  readonly definition_version: number;
  readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
  readonly name: string;
  readonly reward_tier?: "bronze" | "silver" | "gold";
}> | Readonly<{
  readonly benefit_kind: "free_item";
  readonly contract: "exylon.offers.guest-definition-snapshot@1.0";
  readonly definition_id: string;
  readonly definition_version: number;
  readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
  readonly name: string;
  readonly reward_catalog_item_id: string;
  readonly reward_item: Readonly<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly reward_quantity: number;
  readonly reward_tier?: "bronze" | "silver" | "gold";
}> | Readonly<{
  readonly benefit_kind: "buy_x_get_y";
  readonly buy_quantity: number;
  readonly contract: "exylon.offers.guest-definition-snapshot@1.0";
  readonly definition_id: string;
  readonly definition_version: number;
  readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
  readonly name: string;
  readonly reward_catalog_item_id: string | null;
  readonly reward_item: Readonly<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly reward_quantity: number;
  readonly reward_tier?: "bronze" | "silver" | "gold";
}>
export type OfferGuestWalletEntry = Readonly<{
  readonly conditions?: Readonly<{
    readonly end_local_time: string | null;
    readonly last_service_day: string | null;
    readonly loyalty_tier_id: string | null;
    readonly maximum_discount_minor?: number | null;
    readonly maximum_subtotal_minor: number | null;
    readonly minimum_party_size: number;
    readonly minimum_subtotal_minor: number;
    readonly start_local_time: string | null;
    readonly weekdays: readonly (number)[];
  }>;
  readonly contract: "exylon.offers.guest-wallet-entry@1.0";
  readonly coupon_issuance_id: string;
  readonly definition_snapshot: OfferGuestDefinitionSnapshot;
  readonly expires_at: string | null;
  readonly fits_tonight?: boolean | null;
  readonly issued_at: string;
  readonly issued_reason?: string;
  readonly not_tonight_reason?: "earned_tonight" | "conditions" | null;
  readonly origin?: Readonly<{
    readonly kind: "tier_unlock";
    readonly tier_id: string;
  }> | Readonly<{
    readonly kind: "review_reward" | "other";
    readonly tier_id: null;
  }>;
  readonly restaurant_id: string;
  readonly service_days_left?: number | null;
  readonly uses_count: number;
}>
export type OfferHistoricalDefinition = Readonly<{
  readonly amount_minor: number | null;
  readonly benefit_kind: "percentage" | "fixed_amount" | "free_item" | "buy_x_get_y";
  readonly buy_quantity: number;
  readonly contract: "exylon.offers.definition@1.0";
  readonly currency: "EUR" | null;
  readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
  readonly end_local_time?: string | null;
  readonly feedback_only: boolean;
  readonly id: string;
  readonly loyalty_tier_id: string | null;
  readonly maximum_discount_minor: number | null;
  readonly maximum_subtotal_minor: number | null;
  readonly minimum_party_size: number;
  readonly minimum_subtotal_minor: number;
  readonly name: string;
  readonly new_guest_only: boolean;
  readonly percentage_bps: number | null;
  readonly restaurant_id: string;
  readonly reward_catalog_item_id: string | null;
  readonly reward_item?: Readonly<{
    readonly id: string;
    readonly name: string;
  }> | null;
  readonly reward_quantity: number;
  readonly reward_tier?: "bronze" | "silver" | "gold" | null;
  readonly scope_kind: "ticket" | "catalog_item" | "catalog_category" | "catalog_section";
  readonly start_local_time?: string | null;
  readonly state: "active" | "retired";
  readonly targets: readonly (Readonly<{
      readonly target_id: string;
      readonly target_kind: "catalog_item" | "catalog_category" | "catalog_section";
    }>)[];
  readonly tenant_id: string;
  readonly total_redemption_limit: number | null;
  readonly updated_at: string;
  readonly updated_by: string;
  readonly uses_per_guest?: "once" | "every_visit";
  readonly valid_from_date: string | null;
  readonly valid_to_date: string | null;
  readonly version: number;
  readonly weekdays: readonly (number)[];
}>
export type OfferMarketingBoard = Readonly<{
  readonly as_of: string;
  readonly contract: "exylon.offers.marketing-board@1.0";
  readonly counts: Readonly<{
    readonly active: number;
    readonly all: number;
    readonly codes: number;
    readonly discounts: number;
    readonly rewards: number;
  }>;
  readonly coupon_last_day: string;
  readonly groups: Readonly<{
    readonly active: Readonly<{
      readonly codes: OfferDefinitionPage;
      readonly discounts: OfferDefinitionPage;
      readonly rewards: OfferDefinitionPage;
    }>;
    readonly ended: Readonly<{
      readonly codes: OfferDefinitionPage;
      readonly discounts: OfferDefinitionPage;
      readonly rewards: OfferDefinitionPage;
    }>;
    readonly paused: Readonly<{
      readonly codes: OfferDefinitionPage;
      readonly discounts: OfferDefinitionPage;
      readonly rewards: OfferDefinitionPage;
    }>;
    readonly scheduled: Readonly<{
      readonly codes: OfferDefinitionPage;
      readonly discounts: OfferDefinitionPage;
      readonly rewards: OfferDefinitionPage;
    }>;
  }>;
  readonly service_day: string;
  readonly tiers: readonly (Readonly<{
      readonly id: string;
      readonly name: string;
      readonly sort_order: number;
    }>)[];
}>
export type OfferMarketingReplay = Readonly<{
  readonly checks: readonly (Readonly<{
      readonly actual_total_minor: number;
      readonly business_date: string;
      readonly currency: "EUR";
      readonly evidence_status: "available";
      readonly nonqualification_reasons: readonly ("inactive" | "not_started" | "expired" | "weekday" | "minimum_subtotal" | "maximum_subtotal" | "minimum_party_size" | "new_guest_required" | "feedback_required" | "loyalty_program_inactive" | "loyalty_tier_required" | "coverage_mismatch")[];
      readonly qualification_status: "qualified";
      readonly sample_reference: string;
      readonly would_discount_minor: number;
      readonly would_pay_minor: number;
    }> | Readonly<{
      readonly actual_total_minor: number;
      readonly business_date: string;
      readonly currency: "EUR";
      readonly evidence_status: "available";
      readonly nonqualification_reasons: readonly ("inactive" | "not_started" | "expired" | "weekday" | "minimum_subtotal" | "maximum_subtotal" | "minimum_party_size" | "new_guest_required" | "feedback_required" | "loyalty_program_inactive" | "loyalty_tier_required" | "coverage_mismatch")[];
      readonly qualification_status: "not_qualified";
      readonly sample_reference: string;
      readonly would_discount_minor: number;
      readonly would_pay_minor: number;
    }> | Readonly<{
      readonly actual_total_minor: number;
      readonly business_date: string;
      readonly currency: "EUR";
      readonly evidence_status: "insufficient_historical_evidence";
      readonly nonqualification_reasons: readonly ("inactive" | "not_started" | "expired" | "weekday" | "minimum_subtotal" | "maximum_subtotal" | "minimum_party_size" | "new_guest_required" | "feedback_required" | "loyalty_program_inactive" | "loyalty_tier_required" | "coverage_mismatch")[];
      readonly qualification_status: "not_evaluated";
      readonly sample_reference: string;
      readonly would_discount_minor: null;
      readonly would_pay_minor: null;
    }>)[];
  readonly completeness: "complete" | "truncated";
  readonly contract: "exylon.offers.marketing-replay@2.0";
  readonly sample_limit: 20;
  readonly sampled_count: number;
  readonly selection_window: Readonly<{
    readonly business_date: string;
  }>;
}>
export type OfferQuote = Readonly<{
  readonly adjustments: readonly (Readonly<{
      readonly adjustment_kind: "percentage" | "fixed_amount" | "free_item" | "buy_x_get_y";
      readonly amount_minor: number;
      readonly coupon_code_id: string | null;
      readonly coupon_issuance_id: string | null;
      readonly definition_id: string;
      readonly id: string;
      readonly reward_catalog_item_id: string | null;
      readonly reward_quantity: number | null;
    }>)[];
  readonly cart_id: string;
  readonly contract: "exylon.offers.quote@1.0";
  readonly created_at: string;
  readonly created_by: string;
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly eligibility_snapshot: Readonly<{
    readonly applied_offers: readonly (Readonly<{
        readonly amount_minor: number;
        readonly campaign_code?: string;
        readonly coupon_code_id: string | null;
        readonly coupon_issuance_id: string | null;
        readonly covered_line_ids: readonly (string)[];
        readonly definition: OfferHistoricalDefinition;
        readonly line_allocations: readonly (Readonly<{
            readonly amount_minor: number;
            readonly line_id: string;
          }>)[];
        readonly line_id: string | null;
        readonly reward_catalog_item_id: string | null;
        readonly reward_quantity: number | null;
        readonly source_id: string;
        readonly source_kind: "offer_definition";
      }>)[];
    readonly bill_discount_cap_minor?: number;
    readonly evaluated_at: string;
    readonly loyalty: RelationshipLoyaltyDecision;
    readonly outcomes: readonly (Readonly<{
        readonly definition_id: string;
        readonly definition_version: number;
        readonly eligible: boolean;
        readonly reasons: readonly ("eligible" | "inactive" | "not_started" | "expired" | "weekday" | "minimum_subtotal" | "maximum_subtotal" | "minimum_party_size" | "new_guest_required" | "feedback_required" | "loyalty_program_inactive" | "loyalty_tier_required" | "coverage_mismatch" | "saved_account_required" | "party_size_cap_reached")[];
      }>)[];
    readonly policy_version: "deterministic_offer_eligibility_v1";
    readonly quote_facts: OfferQuoteFacts;
    readonly selected_coupon?: OfferSelectedCouponVerdict;
    readonly timezone: "Europe/Madrid";
    readonly visit?: Readonly<{
      readonly bill_discount_cap_minor: number | null;
      readonly bill_facts_fingerprint: string;
      readonly diners: readonly (OfferQuoteDiner)[];
      readonly mode: "open" | "fix";
      readonly round_cart_id: string;
      readonly table_session_id: string;
    }>;
  }>;
  readonly eligibility_snapshot_hash: string;
  readonly guest_id: string | null;
  readonly id: string;
  readonly request_hash: string;
  readonly restaurant_id: string;
  readonly subtotal_minor: number;
  readonly tenant_id: string;
  readonly total_minor: number;
}>
export type OfferQuoteDiner = Readonly<{
  readonly applied_offers: readonly (Readonly<{
      readonly coupon_code_id: string | null;
      readonly coupon_issuance_id: string | null;
      readonly definition_id: string;
      readonly definition_version: number;
      readonly name: string;
      readonly round_amount_minor: number;
      readonly source: "automatic" | "code" | "coupon";
      readonly visit_amount_minor: number;
    }>)[];
  readonly choice_verdict: OfferSelectedCouponVerdict | null;
  readonly discount_minor: number;
  readonly feedback_eligible: boolean;
  readonly gross_minor: number;
  readonly identity_kind: "registered" | "anonymous" | "none";
  readonly loyalty_tier_id: string | null;
  readonly loyalty_tier_order: number | null;
  readonly new_guest: boolean;
  readonly participant_id: string | null;
  readonly withheld?: readonly (Readonly<{
      readonly definition_id: string;
      readonly name: string;
      readonly reason_code: "saved_account_required" | "party_size_cap_reached";
    }>)[];
}>
export type OfferQuoteFacts = Readonly<{
  readonly cart_id: string;
  readonly contract: "exylon.offers.quote-facts@1.0";
  readonly currency: "EUR";
  readonly eligibility_at?: string;
  readonly evaluated_at: string;
  readonly facts_fingerprint: string;
  readonly feedback_eligible: boolean;
  readonly guest_id: string | null;
  readonly items: readonly (Readonly<{
      readonly available: boolean;
      readonly catalog_category_id: string | null;
      readonly catalog_item_id: string;
      readonly catalog_publication_version: number;
      readonly catalog_section_ids: readonly (string)[];
      readonly guest_profile_id?: string | null;
      readonly line_id: string;
      readonly modifier_option_ids: readonly (string)[];
      readonly quantity: number;
      readonly unit_price_minor: number;
    }>)[];
  readonly new_guest: boolean;
  readonly party_size: number;
  readonly party_size_basis?: "roster" | "stated" | "opening_hint" | "seats";
  readonly party_size_roster?: number;
  readonly party_size_stated?: number | null;
  readonly restaurant_id: string;
  readonly source_kind: "direct_cart" | "waiting_round";
  readonly source_version: number;
  readonly tenant_id: string;
}>
export type OfferRedemption = Readonly<{
  readonly applied_offers: readonly (Readonly<{
      readonly amount_minor: number;
      readonly coupon_code_id: string | null;
      readonly coupon_issuance_id: string | null;
      readonly covered_line_ids: readonly (string)[];
      readonly definition: OfferHistoricalDefinition;
      readonly line_allocations: readonly (Readonly<{
          readonly amount_minor: number;
          readonly line_id: string;
        }>)[];
      readonly line_id: string | null;
      readonly reward_catalog_item_id: string | null;
      readonly reward_quantity: number | null;
      readonly source_id: string;
      readonly source_kind: "offer_definition";
    }>)[];
  readonly contract: "exylon.offers.redemption@1.0";
  readonly eligibility_snapshot_hash: string;
  readonly final_total_minor: number;
  readonly guest_id: string | null;
  readonly id: string;
  readonly quote_id: string;
  readonly redeemed_at: string;
  readonly redeemed_by: string;
  readonly restaurant_id: string;
  readonly service_order_id: string;
  readonly service_order_version: number;
  readonly tenant_id: string;
  readonly version: number;
  readonly void_id: string | null;
  readonly void_reason_code: string | null;
  readonly voided_at: string | null;
}>
export type OfferRedemptionRefund = Readonly<{
  readonly contract: "exylon.offers.redemption-refund@1.0";
  readonly id: string;
  readonly reason_code: string;
  readonly redemption_id: string;
  readonly refund_scope: "full";
  readonly refunded_at: string;
  readonly refunded_by: string;
  readonly restaurant_id: string;
  readonly service_order_id: string;
  readonly service_refund_id: string;
  readonly tenant_id: string;
  readonly version: 1;
}>
export type OfferRewardPack = Readonly<{
  readonly contract: "exylon.offers.reward-pack@1.0";
  readonly guest_id: string;
  readonly issued: readonly (OfferCouponIssuance)[];
  readonly issued_at: string;
  readonly issued_reason: string;
  readonly requested: readonly (Readonly<{
      readonly count: number;
      readonly reward_tier: "bronze" | "silver" | "gold";
    }>)[];
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type OffersBridgePutQuery = Readonly<{
  readonly amount_minor?: string;
  readonly benefit_kind?: string;
  readonly code?: string;
  readonly definition_id?: string;
  readonly dish_id?: string;
  readonly distribution_kind?: string;
  readonly expected_version?: string;
  readonly form: "offers.definition.put";
  readonly loyalty_tier_id?: string;
  readonly maximum_discount_minor?: string;
  readonly minimum_subtotal_minor?: string;
  readonly mode?: string;
  readonly new_definition_id?: string;
  readonly preset?: string;
  readonly scope_kind?: string;
  readonly source_definition_id?: string;
  readonly total_redemption_limit?: string;
  readonly valid_from_date?: string;
  readonly valid_to?: string;
  readonly valid_to_date?: string;
  readonly weekdays?: string;
}>
export type OffersBridgeRetireQuery = Readonly<{
  readonly definition_id?: string;
  readonly expected_version?: string;
  readonly form: "offers.definition.retire";
  readonly reason_code?: string;
}>
export type OffersBridgeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.offers.bridge-revalidation@1.0";
  readonly form: "offers.definition.put" | "offers.definition.retire";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{ readonly [key: string]: string | number | boolean | readonly (string)[] | readonly (number)[] }>;
  readonly verdict: "open" | "refused";
}>
export type OfferSelectedCouponVerdict = Readonly<{
  readonly applied: boolean;
  readonly applied_offer_definition_id: string | null;
  readonly applied_offer_label: string | null;
  readonly applied_saving_minor: number;
  readonly coupon_code_id: string | null;
  readonly coupon_definition_id: string;
  readonly coupon_issuance_id: string | null;
  readonly coupon_label: string;
  readonly coupon_saving_minor: number;
  readonly reason: "better_offer_applied" | "equal_offer_applied" | "no_matching_items" | "bill_discount_cap_reached" | null;
}>
export type OfferVisitPricingRequest = Readonly<{
  readonly bill_facts: OfferBillFacts;
  readonly mode: "open" | "fix";
  readonly reopened_diner: Readonly<{
    readonly participant_id: string | null;
  }> | null;
}>
export type OfferVisitPricingResult = Readonly<{
  readonly bill_discount_cap_minor: number | null;
  readonly bill_discount_minor: number;
  readonly bill_facts_fingerprint: string;
  readonly contract: "exylon.offers.visit-pricing@1.0";
  readonly diners: readonly (OfferQuoteDiner)[];
  readonly evaluated_at: string;
  readonly holds: readonly (OfferDinerHold)[];
  readonly mode: "open" | "fix";
  readonly notices: readonly (OfferDinerNotice)[];
  readonly rounds: readonly (Readonly<{
      readonly cart_id: string;
      readonly changed: boolean;
      readonly discount_minor: number;
      readonly draft: boolean;
      readonly economic_adjustment?: Readonly<{
        readonly id: string;
        readonly version: number;
      }> | null;
      readonly order_id: string | null;
      readonly quote: OfferQuote | null;
      readonly redemption: OfferRedemption | null;
      readonly subtotal_minor: number;
      readonly total_minor: number;
    }>)[];
  readonly table_session_id: string;
}>
export type OwnerCalendarCancelRequest = Readonly<{
  readonly expected_version: number;
}>
export type OwnerCalendarDeclaration = Readonly<{
  readonly cancelled_at: string | null;
  readonly contract: "exylon.proposals.owner-calendar-declaration@1.0";
  readonly declaration_id: string;
  readonly ends_at: string;
  readonly recorded_at: string;
  readonly restaurant_id: string;
  readonly source: "owner_declared";
  readonly starts_at: string;
  readonly status: "announced" | "provisional" | "cancelled";
  readonly supersedes_version: number | null;
  readonly title: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type OwnerCalendarHistory = Readonly<{
  readonly contract: "exylon.proposals.owner-calendar-history@1.0";
  readonly declaration_id: string;
  readonly observed_at: string;
  readonly restaurant_id: string;
  readonly source: "owner_declared";
  readonly versions: readonly (OwnerCalendarVersion)[];
}>
export type OwnerCalendarList = Readonly<{
  readonly contract: "exylon.proposals.owner-calendar-list@1.0";
  readonly items: readonly (OwnerCalendarDeclaration)[];
  readonly observed_at: string;
  readonly restaurant_id: string;
  readonly timezone: "Europe/Madrid";
  readonly window: Readonly<{
    readonly from: string;
    readonly local_date_from_inclusive: string;
    readonly local_date_until_exclusive: string;
    readonly until: string;
  }>;
}>
export type OwnerCalendarPutRequest = Readonly<{
  readonly ends_at: string;
  readonly expected_version: number;
  readonly starts_at: string;
  readonly status: "announced" | "provisional";
  readonly title: string;
}>
export type OwnerCalendarVersion = Readonly<{
  readonly ends_at: string;
  readonly recorded_at: string;
  readonly starts_at: string;
  readonly status: "announced" | "provisional" | "cancelled";
  readonly supersedes_version: number | null;
  readonly title: string;
  readonly version: number;
}>
export type OwnerCalendarWindowQuery = Readonly<{
  readonly from_date: string;
  readonly until_date: string;
}>
export type ParteAbsenceReason = "no_source" | "not_permitted" | "not_published" | "source_unavailable" | "no_observations" | "research_budget" | "not_configured" | "source_disabled" | "source_outage" | "no_operating_days" | "projection_lagging" | "coverage_incomplete" | "rows_truncated" | "capacity_exceeded" | "group_suppressed"
export type ParteAbsent = Readonly<{
  readonly detail?: string;
  readonly kind: "absent";
  readonly period: PartePeriod;
  readonly reason: "no_source" | "not_permitted" | "not_published" | "source_unavailable" | "no_observations";
  readonly source: ParteSourceRef;
}>
export type ParteAdvisorLibrary = Readonly<{
  readonly as_of: string;
  readonly contract: "exylon.parte.advisor-library@1.0";
  readonly entries: readonly (ParteAdvisorLibraryEntry)[];
  readonly restaurant_id: string;
}>
export type ParteAdvisorLibraryEntry = Readonly<{
  readonly decided_on: string | null;
  readonly family: "H1" | "H2" | "H3";
  readonly held_by: "open_gate" | "manager_review";
  readonly pattern_id: string;
  readonly reason: string | null;
  readonly reviewed_by: "you" | "someone_else" | null;
  readonly state: "pending" | "withdrawn";
  readonly version: number;
}>
export type ParteAdvisorLibraryReviewRequest = Readonly<{
  readonly decision: "withdraw";
  readonly expected_version: number;
  readonly pattern_id: string;
  readonly reason: string;
}>
export type ParteAiAudit = Readonly<{
  readonly ai_cost_minor: number | null;
  readonly contract: "exylon.parte.ai-audit@1.0";
  readonly desks: readonly (Readonly<{
      readonly ai_cost_minor: number | null;
      readonly approved_by_owner: number;
      readonly checks: number;
      readonly closed: Readonly<{
        readonly empeora: number;
        readonly mejora_probable: number;
        readonly no_medible: number;
        readonly sin_efecto_claro: number;
      }>;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly objected: number;
      readonly ran_alone: number;
      readonly undone: number;
    }>)[];
  readonly error_rate_bps: number | null;
  readonly from: string;
  readonly mistakes: readonly (Readonly<{
      readonly change_key: string;
      readonly describe: string;
      readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
      readonly kind: "closed_worse" | "undone_by_owner";
      readonly money: boolean;
      readonly object: Readonly<{
        readonly object_id: string;
        readonly object_type: string;
        readonly owner: string;
      }>;
      readonly on: string;
      readonly tool_id: string | null;
    }>)[];
  readonly restaurant_id: string;
  readonly to: string;
  readonly truncated: boolean;
}>
export type ParteAiAuditQuery = Readonly<{
  readonly from?: string;
  readonly to?: string;
}>
export type ParteArqueo = Readonly<{
  readonly cash_difference?: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: Readonly<{
      readonly counted_closes: number;
      readonly difference: ParteMoney;
      readonly open_sessions: number;
      readonly uncounted_closes: number;
    }>;
  }> | ParteAbsent;
  readonly collected: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteMoney;
  }> | ParteAbsent;
  readonly open_tables: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: Readonly<{
      readonly count: number;
      readonly pending: ParteMoney;
    }>;
  }> | ParteAbsent;
  readonly paid_outside: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteMoney;
  }> | ParteAbsent;
  readonly pending_close?: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: readonly (Readonly<{
        readonly due: ParteMoney;
        readonly opened_at: string;
        readonly table_id: string;
        readonly table_label: string | null;
      }>)[];
  }> | ParteAbsent;
  readonly reconciliation?: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: Readonly<{
      readonly difference: ParteMoney | null;
      readonly service_total: ParteMoney;
    }>;
  }> | ParteAbsent;
  readonly refunded: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteMoney;
  }> | ParteAbsent;
  readonly unpaid_written_off: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteMoney;
  }> | ParteAbsent;
}>
export type ParteAutonomy = Readonly<{
  readonly acting_alone: boolean;
  readonly always_asks_list?: readonly (Readonly<{
      readonly detail: string | null;
      readonly text: string;
    }>)[];
  readonly budgets: readonly (Readonly<{
      readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly cap_minor: number | null;
      readonly held?: Readonly<{
        readonly by: "allergen_measure";
      }> | null;
      readonly label: string;
      readonly pacto_line_id: string | null;
      readonly pending?: Readonly<{
        readonly pacto_line_id: string;
        readonly proposed_by: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly proposed_minor: number;
      }>;
      readonly proposed_by: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
      readonly proposed_minor: number | null;
      readonly spent_minor: number;
      readonly standing?: readonly (Readonly<{
          readonly amount_minor: number | null;
          readonly label: string;
          readonly source: string;
          readonly state: "admitted" | "reserved" | "pending" | "lapsed";
        }>)[];
      readonly state: "team_proposed" | "accepted";
    }>)[];
  readonly classes: readonly (Readonly<{
      readonly always_asks: string | null;
      readonly asks_beyond?: string | null;
      readonly ceiling: 0 | 1 | 2 | 3;
      readonly ceiling_reason?: "alone_not_proven" | "guest_food_text" | "kind_limit";
      readonly context: string | null;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly executed_total?: number;
      readonly first_week: Readonly<{
        readonly alone_from_day: number;
        readonly guest_visible: boolean;
        readonly team_day: number;
      }>;
      readonly floor: 0 | 1 | 2 | 3;
      readonly label: string;
      readonly last_demotion: Readonly<{
        readonly at: string;
        readonly because: "undone" | "closed_worse";
      }> | null;
      readonly level: 0 | 1 | 2 | 3;
      readonly offer: Readonly<{
        readonly from: 0 | 1 | 2 | 3;
        readonly kind: "regain" | "widen";
        readonly offer_id: string;
        readonly offered_on: string;
        readonly state: "open" | "accepted" | "declined";
        readonly text: string;
        readonly to: 0 | 1 | 2 | 3;
      }> | null;
      readonly probation: Readonly<{
        readonly checked: number;
        readonly of: 5;
        readonly started_at: string;
      }> | null;
      readonly streak: Readonly<{
        readonly clean: number;
        readonly threshold: 10 | 15;
      }>;
      readonly tool_id: string;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.parte.autonomy@1.0";
  readonly month: Readonly<{
    readonly ai_cost_minor: number | null;
    readonly alone: number | null;
    readonly month: string;
    readonly stopped: number | null;
    readonly undone: number | null;
    readonly undone_by_desk?: readonly (Readonly<{
        readonly count: number;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      }>)[];
  }>;
  readonly platform_stopped: boolean;
  readonly restaurant_id: string;
  readonly restaurant_stopped: boolean;
  readonly team_day: number;
}>
export type ParteAutonomyOfferAnswerRequest = Readonly<{
  readonly answer: "yes" | "no";
  readonly expected_version: number;
  readonly offer_id: string;
}>
export type ParteBalanceChanges = Readonly<{
  readonly coverage: Readonly<{
    readonly catalog: "complete" | "more_unlisted" | "not_read";
    readonly configuration: "complete" | "more_unlisted" | "not_read";
    readonly offers: "complete" | "more_unlisted" | "not_read";
  }>;
  readonly from_date: string;
  readonly items: readonly (Readonly<{
      readonly aspects: readonly (Readonly<{
          readonly aspect: "price" | "name" | "description" | "photo" | "recipe" | "dish_other" | "carta" | "translation" | "opening_days" | "event_context" | "floor" | "setting" | "promotion_new" | "promotion_changed" | "promotion_retired";
          readonly count: number;
        }>)[];
      readonly event_key: string;
      readonly occurred_at: string;
      readonly owner: "catalog" | "configuration" | "offers";
    }>)[];
  readonly until_date: string;
}>
export type ParteBalanceDishes = Readonly<{
  readonly moves: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: Readonly<{
      readonly compared_weeks: number;
      readonly down: readonly (Readonly<{
          readonly dish_ref: string;
          readonly name: string;
          readonly prior_max: number;
          readonly prior_min: number;
          readonly sold_out_during_week: boolean | null;
          readonly units: number;
        }>)[];
      readonly up: readonly (Readonly<{
          readonly dish_ref: string;
          readonly name: string;
          readonly prior_max: number;
          readonly prior_min: number;
          readonly sold_out_during_week: boolean | null;
          readonly units: number;
        }>)[];
    }>;
  }> | ParteAbsent;
}>
export type ParteBalanceFigures = Readonly<{
  readonly amount_per_check: Readonly<{
    readonly previous: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
    readonly week: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
  }>;
  readonly checks: Readonly<{
    readonly previous: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: number;
    }> | ParteAbsent;
    readonly week: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: number;
    }> | ParteAbsent;
  }>;
  readonly collected: Readonly<{
    readonly previous: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
    readonly week: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
  }>;
  readonly comparison: Readonly<{
    readonly closed_days: readonly (string)[];
    readonly incomplete_days: readonly (string)[];
    readonly reason: "closed_day" | "incomplete_day" | "no_previous_week" | "no_data" | null;
    readonly state: "comparable" | "not_comparable";
  }>;
  readonly discounted: Readonly<{
    readonly previous: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
    readonly week: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
  }>;
  readonly paid_outside: Readonly<{
    readonly previous: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
    readonly week: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
  }>;
  readonly refunded: Readonly<{
    readonly previous: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
    readonly week: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
  }>;
  readonly unpaid: Readonly<{
    readonly previous: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
    readonly week: Readonly<{
      readonly coverage: ParteCoverage;
      readonly kind: "value";
      readonly period: PartePeriod;
      readonly source: ParteSourceRef;
      readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
      readonly value: ParteMoney;
    }> | ParteAbsent;
  }>;
}>
export type ParteBalanceHealth = Readonly<{
  readonly areas: readonly (Readonly<{
      readonly area: "demanda" | "ritmo" | "carta" | "genero" | "caja" | "reputacion" | "fidelidad" | "seguridad";
      readonly basis: string | null;
      readonly reason: string;
      readonly word: "en_orden" | "a_vigilar" | "actuar" | "sin_datos";
    }>)[];
  readonly rule_version: "health-words-v1";
  readonly summary: string;
}>
export type ParteBalancePromotions = Readonly<{
  readonly promotions: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: readonly (Readonly<{
        readonly checks_before: number | null;
        readonly checks_during: number | null;
        readonly definition_ref: string;
        readonly discount_week: ParteMoney | null;
        readonly ends_on: string | null;
        readonly name: string;
        readonly promotion_checks_during: number | null;
        readonly remaining_uses: number | null;
        readonly source_kind: "promotion" | "tier" | "code" | "reward";
        readonly uses_week: number;
      }>)[];
  }> | ParteAbsent;
}>
export type ParteBalanceReviews = Readonly<{
  readonly previous_week: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteReviewAggregate;
  }> | ParteAbsent;
  readonly survey: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteSurveyAggregate;
  }> | ParteAbsent;
  readonly tags: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: Readonly<{
      readonly current: readonly (Readonly<{
          readonly count: number;
          readonly tag: string;
        }>)[];
      readonly current_count: number;
      readonly prior: readonly (Readonly<{
          readonly count: number;
          readonly tag: string;
        }>)[];
      readonly prior_count: number;
    }>;
  }> | ParteAbsent;
  readonly week: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteReviewAggregate;
  }> | ParteAbsent;
}>
export type ParteBalanceSections = Readonly<{
  readonly changes?: ParteBalanceChanges;
  readonly dishes: ParteBalanceDishes;
  readonly figures: ParteBalanceFigures;
  readonly health?: ParteBalanceHealth;
  readonly promotions: ParteBalancePromotions;
  readonly reviews: ParteBalanceReviews;
  readonly team: ParteBalanceTeam;
}>
export type ParteBalanceTeam = Readonly<{
  readonly comparison_reason?: string;
  readonly comparison_unavailable: boolean;
  readonly house: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: Readonly<{
      readonly average_delivery_seconds: number | null;
      readonly dishes_delivered: number;
      readonly kitchen_items: number;
      readonly remade: number;
      readonly waited_longer: number;
      readonly waits_measured: number;
    }>;
  }> | ParteAbsent;
  readonly refused_indicators: readonly (string)[];
}>
export type ParteBalanceWeekSeries = Readonly<{
  readonly caja: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly contribution?: Readonly<{
    readonly basis: "closed_month" | "month_to_date";
    readonly contribution_minor: number;
    readonly cost_minor: number;
    readonly food_cost_bps: number;
    readonly month: string;
    readonly net_minor: number;
  }>;
  readonly covers: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly covers_weeks: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly goal?: Readonly<{
    readonly actual_minor: number | null;
    readonly expected_by_now_minor: number | null;
    readonly expected_share_of_target_bps: number | null;
    readonly period: Readonly<{
      readonly from: string;
      readonly kind: "service_week" | "service_month";
      readonly to: string;
    }>;
    readonly position: "not_started" | "ahead" | "on_pace" | "behind" | "met" | "unmeasured";
    readonly progress_key: Readonly<{
      readonly as_of: string;
      readonly goal_id: string;
      readonly metric_no: number;
      readonly revision: number;
    }>;
    readonly share_of_target_bps: number | null;
    readonly target_minor: number;
  }>;
  readonly reviews?: Readonly<{
    readonly average_tenths: number | null;
    readonly count: number;
    readonly low: number;
  }>;
  readonly sales: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly sales_months?: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly sales_weeks: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly split: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly stars: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
}>
export type ParteBusinessDay = Readonly<{
  readonly business_date: string;
  readonly contradiction?: boolean;
  readonly iso_weekday: number;
  readonly opening: "open" | "closed" | "unknown";
  readonly opening_source: "exception" | "declared" | "observed" | "default" | "published_setting" | "derived" | null;
  readonly source: ParteSourceRef;
}>
export type ParteButton = Readonly<{
  readonly label: string;
  readonly role: "verb" | "look" | "fix" | "not_now";
}>
export type ParteCallList = Readonly<{
  readonly built_at: string | null;
  readonly contract: "exylon.parte.call-list@1.0";
  readonly count_suggestions: readonly (Readonly<{
      readonly label: string;
      readonly on_hand?: Readonly<{
        readonly amount: number;
        readonly unit: "kilograms" | "litres" | "units";
      }> | null;
      readonly risk: "expiring" | "variance" | "high_value" | "stockout_risk" | "never_counted";
      readonly stock_item_id: string;
    }>)[];
  readonly entries: readonly (Readonly<{
      readonly call_by: Readonly<{
        readonly date: string;
        readonly time: string | null;
      }>;
      readonly delivery_on: string;
      readonly entry_id: string;
      readonly items: readonly (Readonly<{
          readonly added?: Readonly<{
            readonly action_id: string | null;
            readonly amount: number;
            readonly money_at_risk_minor: number;
            readonly unit: "kilograms" | "litres" | "units";
          }>;
          readonly basis: Readonly<{
            readonly forecast_portions: Readonly<{
              readonly estimate: number;
              readonly lower: number;
              readonly upper: number;
            }>;
            readonly on_hand: number | null;
            readonly rule: "newsvendor" | "cover_to_next_delivery";
            readonly shelf_life_days: number | null;
          }>;
          readonly estimated: boolean;
          readonly estimated_cost_minor: number | null;
          readonly label: string;
          readonly note: string | null;
          readonly quantity: Readonly<{
            readonly amount: number;
            readonly unit: "kilograms" | "litres" | "units";
          }>;
          readonly stock_item_id: string;
        }>)[];
      readonly line: string;
      readonly send?: Readonly<{
        readonly sms: string;
        readonly whatsapp: string;
      }> | null;
      readonly supplier: Readonly<{
        readonly name: string;
        readonly phone: string | null;
        readonly supplier_id: string;
      }>;
    }>)[];
  readonly forecast: Readonly<{
    readonly contract: "exylon.parte.demand-forecast@1.0";
    readonly grade?: "confirmed" | "same_weekday" | "first_days" | "declared";
    readonly issued_on: string;
    readonly method: string;
  }> | null;
  readonly forecast_abstention?: Readonly<{
    readonly needed_days: number;
    readonly reason: "insufficient_history" | "calibration_under_supported";
    readonly served_days: number;
  }>;
  readonly late?: boolean;
  readonly reason: "no_forecast" | "insufficient_history" | "declared_only" | "no_suppliers" | "nothing_to_order" | null;
  readonly recorded_at?: string;
  readonly restaurant_id: string;
  readonly service_date: string;
  readonly status: "available" | "no_data";
  readonly system_contacts_supplier: false;
  readonly unsupplied: readonly (Readonly<{
      readonly label: string;
      readonly stock_item_id: string;
    }>)[];
}>
export type ParteCallListQuery = Readonly<{
  readonly service_date?: string;
}>
export type ParteCard = Readonly<{
  readonly audience?: "owner";
  readonly body: string;
  readonly buttons: readonly (ParteButton)[];
  readonly case_id: string;
  readonly certainty?: "confirmed" | "probable" | "possible" | "not_confirmed" | "observed";
  readonly change_proposal: boolean;
  readonly cost: Readonly<{
    readonly max: ParteMoney | null;
    readonly text: string;
  }> | null;
  readonly desk?: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
  readonly dish_ideas?: ParteDishIdeasCard;
  readonly fact_fingerprint: string;
  readonly figures: readonly (ParteFigure)[];
  readonly headline: string;
  readonly kind: "info" | "decision" | "setup";
  readonly lesson?: Readonly<{
    readonly closed_on: string;
    readonly lesson_id: string;
  }>;
  readonly linked_proposal?: ParteLinkedProposal;
  readonly operation?: Readonly<{
    readonly components: number;
    readonly encargo_id?: string | null;
    readonly goal?: string;
    readonly kind?: "weekly_plan" | "decision_set" | "daily_set";
    readonly offer_expires_at: string;
    readonly operation_id: string;
    readonly partly_applied: boolean;
    readonly pieces?: readonly (Readonly<{
        readonly option_key: string | null;
        readonly preview: Readonly<{
          readonly changes: readonly (Readonly<{
              readonly after: Readonly<{
                readonly text: string;
                readonly type: "text";
              }> | Readonly<{
                readonly figure: Readonly<{
                  readonly period: Readonly<{
                    readonly kind: "standing";
                  }>;
                  readonly provenance: Readonly<{
                    readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                  }>;
                  readonly scale: number;
                  readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                  readonly value: number;
                }>;
                readonly type: "figure";
              }> | Readonly<{
                readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
                readonly type: "state";
              }> | Readonly<{
                readonly date: string;
                readonly type: "date";
              }> | Readonly<{
                readonly at: string;
                readonly type: "instant";
              }> | Readonly<{
                readonly days: readonly (number)[];
                readonly type: "weekdays";
              }> | Readonly<{
                readonly type: "windows";
                readonly windows: readonly (Readonly<{
                    readonly from_minute: number;
                    readonly until_minute: number;
                    readonly weekday: number;
                  }>)[];
              }> | Readonly<{
                readonly items: readonly (string)[];
                readonly type: "list";
              }> | Readonly<{
                readonly at: "body" | number;
                readonly core_text_id: string;
                readonly sha256: string | null;
                readonly type: "core_text";
              }> | Readonly<{
                readonly rewards: readonly (Readonly<{
                    readonly count: number;
                    readonly tier: string;
                  }>)[];
                readonly type: "rewards";
              }>;
              readonly before: Readonly<{
                readonly text: string;
                readonly type: "text";
              }> | Readonly<{
                readonly figure: Readonly<{
                  readonly period: Readonly<{
                    readonly kind: "standing";
                  }>;
                  readonly provenance: Readonly<{
                    readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                  }>;
                  readonly scale: number;
                  readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                  readonly value: number;
                }>;
                readonly type: "figure";
              }> | Readonly<{
                readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
                readonly type: "state";
              }> | Readonly<{
                readonly date: string;
                readonly type: "date";
              }> | Readonly<{
                readonly at: string;
                readonly type: "instant";
              }> | Readonly<{
                readonly days: readonly (number)[];
                readonly type: "weekdays";
              }> | Readonly<{
                readonly type: "windows";
                readonly windows: readonly (Readonly<{
                    readonly from_minute: number;
                    readonly until_minute: number;
                    readonly weekday: number;
                  }>)[];
              }> | Readonly<{
                readonly items: readonly (string)[];
                readonly type: "list";
              }> | Readonly<{
                readonly at: "body" | number;
                readonly core_text_id: string;
                readonly sha256: string | null;
                readonly type: "core_text";
              }> | Readonly<{
                readonly rewards: readonly (Readonly<{
                    readonly count: number;
                    readonly tier: string;
                  }>)[];
                readonly type: "rewards";
              }> | null;
              readonly field: "dish_name" | "dish_description" | "dish_price" | "dish_position" | "dish_shown" | "dish_option_required" | "dish_daily_suggestion" | "dish_featured" | "promotion_state" | "promotion_name" | "promotion_percent" | "promotion_amount" | "promotion_max_per_diner" | "promotion_max_diners" | "promotion_minimum_bill" | "promotion_from" | "promotion_to" | "promotion_weekdays" | "promotion_hours" | "promotion_applies_to" | "review_reply" | "guest_question" | "reward_packs" | "win_back_pack" | "win_back_guests" | "opening_days" | "service_hours" | "bill_discount_cap" | "stock_minimum" | "order_quantity" | "notice_title" | "notice_body" | "trial_what" | "trial_procedure" | "trial_services" | "waste_plan_measures" | "service_staff";
              readonly guest_reads: boolean;
              readonly label: string;
              readonly part: string | null;
              readonly part_name: string | null;
              readonly printed: Readonly<{
                readonly after: string;
                readonly before: string | null;
              }>;
            }>)[];
          readonly contract: "exylon.parte.piece-preview@1.0";
          readonly ends_at: string | null;
          readonly exposure?: Readonly<{
            readonly basis: "own_sales" | "estimate";
            readonly days: number;
            readonly estimate_minor: number;
          }> | null;
          readonly money: Readonly<{
            readonly at_risk: Readonly<{
              readonly period: Readonly<{
                readonly kind: "standing";
              }>;
              readonly provenance: Readonly<{
                readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
              }>;
              readonly scale: number;
              readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
              readonly value: number;
            }>;
            readonly diners: Readonly<{
              readonly period: Readonly<{
                readonly kind: "standing";
              }>;
              readonly provenance: Readonly<{
                readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
              }>;
              readonly scale: number;
              readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
              readonly value: number;
            }> | null;
            readonly per_diner: Readonly<{
              readonly period: Readonly<{
                readonly kind: "standing";
              }>;
              readonly provenance: Readonly<{
                readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
              }>;
              readonly scale: number;
              readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
              readonly value: number;
            }> | null;
          }>;
          readonly object: Readonly<{
            readonly name: string | null;
            readonly object_id: string;
            readonly object_type: string;
            readonly owner: string;
          }>;
          readonly staffing?: Readonly<{
            readonly after: readonly (Readonly<{
                readonly employment_id: string;
                readonly role_name: string;
              }>)[];
            readonly before: readonly (Readonly<{
                readonly employment_id: string;
                readonly role_name: string;
              }>)[];
            readonly cost_per_service_minor: number | null;
            readonly direction: "add" | "remove";
            readonly forecast: Readonly<{
              readonly high_covers: number;
              readonly low_covers: number;
              readonly services_counted: number;
            }> | null;
            readonly history: readonly (Readonly<{
                readonly covers: number | null;
                readonly people: number | null;
                readonly per_person: number | null;
                readonly service_date: string;
              }>)[];
            readonly month_effect: Readonly<{
              readonly basis: "own_sales" | "estimate";
              readonly estimate_minor: number;
              readonly high_minor: number;
              readonly low_minor: number;
            }> | null;
            readonly person: Readonly<{
              readonly employment_id: string;
              readonly end: string;
              readonly role_name: string;
              readonly start: string;
            }>;
            readonly repeats: Readonly<{
              readonly until: string;
              readonly weekdays: readonly (number)[];
            }> | null;
            readonly service: Readonly<{
              readonly date: string;
              readonly role_name: string;
              readonly slot: "lunch" | "dinner";
            }>;
            readonly week_start: string;
          }> | null;
          readonly starts_at: string | null;
          readonly told: readonly ("guests" | "staff" | "public" | "owner")[];
          readonly tool_id: string;
          readonly undo: Readonly<{
            readonly window_hours: number;
          }> | null;
        }>;
      }>)[];
    readonly version: number;
  }>;
  readonly return: Readonly<{
    readonly date: string;
    readonly text: string;
  }> | null;
  readonly section?: "decide" | "to_know";
  readonly signature?: "lucia" | "brais" | "mateo" | "sara";
  readonly staff_relay?: Readonly<{
    readonly text: string;
    readonly to: "cocina" | "sala";
  }>;
  readonly story?: Readonly<{
    readonly measure: string;
    readonly objects: readonly (string)[];
    readonly rows: string;
  }>;
  readonly subject?: Readonly<{
    readonly ids: readonly (string)[];
    readonly kind: "dish" | "stock_item" | "stock_batch" | "offer" | "offer_definition" | "zone" | "category" | "section" | "modifier_option" | "loyalty_tier";
  }>;
  readonly voice?: Readonly<{
    readonly advice: string | null;
    readonly why: string | null;
  }>;
  readonly why: readonly (ParteWhy)[];
  readonly written?: "team" | "plain";
}>
export type ParteCartaReading = Readonly<{
  readonly categories: readonly (Readonly<{
      readonly basis: "owner_answer" | "stored" | "reading" | "derived" | null;
      readonly category_id: string;
      readonly kind: "starter" | "main" | "dessert" | "drink" | "other" | null;
      readonly name: string;
    }>)[];
  readonly contract: "exylon.parte.carta-reading@1.0";
}>
export type ParteCartaReadingCorrectRequest = Readonly<{
  readonly kind: "starter" | "main" | "dessert" | "drink" | "other";
}>
export type ParteCoach = Readonly<{
  readonly contract: "exylon.parte.coach@1.0";
  readonly names_to_provider: false;
  readonly people: readonly (Readonly<{
      readonly employment_id: string;
      readonly first_name: string;
      readonly role: "floor" | "kitchen";
      readonly shared_at: string | null;
      readonly strength: string;
      readonly to_try: string | null;
    }>)[];
  readonly restaurant_id: string;
  readonly status: "available" | "no_data";
  readonly team_recognition: Readonly<{
    readonly body: string;
    readonly title: string;
  }> | null;
  readonly version: number;
  readonly week_start: string;
}>
export type ParteCoachQuery = Readonly<{
  readonly week_start?: string;
}>
export type ParteCoachShareRequest = Readonly<{
  readonly employment_id: string;
  readonly expected_version: number;
  readonly role: "floor" | "kitchen";
  readonly week_start: string;
}>
export type ParteComplianceCalendar = Readonly<{
  readonly contract: "exylon.parte.compliance-calendar@1.0";
  readonly deadlines: readonly (Readonly<{
      readonly deadline_id: string;
      readonly due_on: string;
      readonly obligation: string;
      readonly remind_from: string;
      readonly source: "dated_return" | "allergen_matrix" | "time_record" | "food_waste_plan" | "verifactu_ready";
      readonly state: "upcoming" | "due" | "done";
    }>)[];
  readonly horizon_days: number;
  readonly restaurant_id: string;
  readonly today: string;
}>
export type ParteConsejo = Readonly<{
  readonly contract: "exylon.parte.consejo@1.0";
  readonly month: string;
  readonly pack: Readonly<{
    readonly decisions: readonly (Readonly<{
        readonly answer_with: Readonly<{
          readonly intent_hash: string;
          readonly intent_id: string;
          readonly kind: "proposal";
        }> | Readonly<{
          readonly kind: "operation";
          readonly operation_id: string;
          readonly version: number;
        }> | Readonly<{
          readonly from: 0 | 1 | 2 | 3;
          readonly kind: "autonomy_offer";
          readonly offer_id: string;
          readonly to: 0 | 1 | 2 | 3;
          readonly tool_id: string;
        }>;
        readonly decision_id: string;
        readonly describe: string | null;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly index: number;
        readonly kind_label: string;
        readonly proposed_on?: string;
        readonly state: "open" | "accepted" | "declined" | "expired" | "superseded" | "unavailable";
        readonly title: string;
      }>)[];
    readonly goals: readonly (Readonly<{
        readonly actual: number | null;
        readonly direction: "at_least" | "at_most";
        readonly kind: "sales" | "food_cost";
        readonly label: string;
        readonly note: string | null;
        readonly status: "met" | "missed" | "no_data";
        readonly target: number;
        readonly unit: "minor" | "bps";
      }>)[];
    readonly lessons: readonly (Readonly<{
        readonly lesson: Readonly<{
          readonly closed_on: string;
          readonly credited_to: Readonly<{
            readonly desk_ids: readonly (string)[];
            readonly kind: "desks";
            readonly with_owner?: true;
          }> | Readonly<{
            readonly kind: "operation";
            readonly operation_id: string;
            readonly with_owner?: true;
          }> | Readonly<{
            readonly kind: "owner";
          }>;
          readonly evidence: Readonly<{
            readonly interval: Readonly<{
              readonly estimate: number;
              readonly high: number;
              readonly level: 0.8 | 0.9 | 0.95;
              readonly low: number;
            }> | null;
            readonly measure_id: string;
            readonly net_minor: Readonly<{
              readonly estimate: number;
              readonly high: number;
              readonly low: number;
            }> | null;
            readonly reference: "own_comparable_services" | "controls" | "switchback";
            readonly window: Readonly<{
              readonly from: string;
              readonly to: string;
            }>;
          }>;
          readonly label: "mejora_probable" | "sin_efecto_claro" | "empeora" | "no_medible";
          readonly lesson: string | null;
          readonly lesson_id: string;
          readonly object?: Readonly<{
            readonly label?: string | null;
            readonly object_id: string;
            readonly object_type: string;
            readonly owner: string;
          }> | null;
        }>;
        readonly missing_data_question_id: string | null;
        readonly outcome: "kept_in_house_memory" | "undone" | "missing_data";
        readonly undone_on: string | null;
      }>)[];
    readonly numbers: Readonly<{
      readonly cash: Readonly<{
        readonly closes: number;
        readonly closes_with_difference: number;
        readonly difference_minor: number;
      }> | null;
      readonly contribution: Readonly<{
        readonly assumed_iva?: boolean;
        readonly basis: "before_staff_and_fixed";
        readonly minor: number;
        readonly sales_without_tax_minor?: number;
      }> | null;
      readonly food_cost: Readonly<{
        readonly bps: number;
        readonly dishes_costed: number;
        readonly dishes_total: number;
        readonly estimated: number;
      }> | null;
      readonly net_sales: Readonly<{
        readonly by_slot: Readonly<{
          readonly dinner_minor: number;
          readonly lunch_minor: number;
          readonly other_minor: number;
        }> | null;
        readonly last_12_months: readonly (Readonly<{
            readonly minor: number | null;
            readonly month: string;
          }>)[];
        readonly minor: number;
        readonly vs_previous_month_bps: number | null;
      }> | null;
      readonly return_rate_bps: number | null;
      readonly reviews: Readonly<{
        readonly average: number;
        readonly new_count: number;
      }> | null;
    }>;
    readonly plan: Readonly<{
      readonly goal: Readonly<{
        readonly food_cost_cap_bps: number | null;
        readonly sales_target_minor: number;
      }> | null;
      readonly items: readonly (Readonly<{
          readonly decision_index: number | null;
          readonly from: string;
          readonly kind: "operation" | "trial" | "measurement";
          readonly operation_id: string | null;
          readonly slot: "lunch" | "dinner" | null;
          readonly title: string;
          readonly until: string;
          readonly weekdays: readonly (number)[];
        }>)[];
      readonly month: string;
    }>;
    readonly prepared_on: string;
    readonly reading_minutes: number;
    readonly risks: Readonly<{
      readonly deadlines: readonly (Readonly<{
          readonly deadline_id: string;
          readonly due_on: string;
          readonly obligation: string;
          readonly remind_from: string;
          readonly source: "dated_return" | "allergen_matrix" | "time_record" | "food_waste_plan" | "verifactu_ready";
          readonly state: "upcoming" | "due" | "done";
        }>)[];
      readonly integrity: readonly (Readonly<{
          readonly amount_minor: number;
          readonly code: "void_after_print" | "refund" | "discount" | "cash_difference";
          readonly count: number;
          readonly describe: string;
        }>)[];
      readonly tax_reserve: Readonly<{
        readonly due_on: string;
        readonly quarter: string;
        readonly set_aside_minor: number;
      }> | null;
    }>;
    readonly sentence: string | null;
    readonly team: Readonly<{
      readonly audit: Readonly<{
        readonly ai_cost_minor: number | null;
        readonly alone: number;
        readonly money_mistakes: number;
        readonly undone: number;
      }>;
      readonly level_changes: readonly (Readonly<{
          readonly because: "owner_raised" | "owner_lowered" | "regained" | "undone" | "closed_worse";
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly from: 0 | 1 | 2 | 3;
          readonly label: string;
          readonly on: string;
          readonly to: 0 | 1 | 2 | 3;
          readonly tool_id: string;
        }>)[];
      readonly stopped: number;
    }>;
    readonly team_results: Readonly<{
      readonly rows: readonly (Readonly<{
          readonly change_key: string;
          readonly credit: Readonly<{
            readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
            readonly kind: "desks";
            readonly with_owner?: true;
          }> | Readonly<{
            readonly kind: "operation";
            readonly operation_id: string;
            readonly with_owner?: true;
          }> | Readonly<{
            readonly kind: "owner";
          }>;
          readonly describe: string;
          readonly label: "mejora_probable" | "sin_efecto_claro" | "empeora" | "no_medible";
          readonly net_minor: Readonly<{
            readonly estimate: number;
            readonly high: number;
            readonly low: number;
          }> | null;
          readonly reason: string | null;
        }>)[];
      readonly team_month: Readonly<{
        readonly added: number;
        readonly month: string;
        readonly net_minor: Readonly<{
          readonly estimate: number;
          readonly high: number;
          readonly low: number;
        }> | null;
        readonly not_measurable: number;
        readonly provisional: number;
        readonly reason: "nothing_closed" | "overlap_unmerged" | "costs_not_covered" | null;
        readonly shared_with_owner?: number;
        readonly status: "available" | "no_data";
      }>;
      readonly truncated: boolean;
    }>;
  }> | null;
  readonly reason: "month_not_closed" | "no_history" | null;
  readonly restaurant_id: string;
  readonly status: "ready" | "preparing" | "not_available";
}>
export type ParteCoreStaleHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly current: ParteGoalView;
    readonly errorCode: "PARTE_GOAL_STALE";
  }> | Readonly<{
    readonly current: ParteQueueItemView;
    readonly errorCode: "PARTE_QUEUE_ITEM_STALE";
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type ParteCoverage = Readonly<{
  readonly note: string | null;
  readonly observed_day_count: number | null;
  readonly state: "complete" | "partial";
}>
export type ParteDegradedSource = Readonly<{
  readonly reader: "L1" | "L5" | "L8" | "L18" | "L32" | "L33" | "L43" | "L2" | "L9" | "L11" | "L12" | "L13" | "L14" | "L17" | "L19" | "L20" | "L23" | "L24" | "L26" | "L27" | "L28" | "L29" | "L34" | "L35" | "L38" | "L39" | "L41" | "L42" | "L30" | "L31" | "L36" | "L37" | "EP-N04" | "C1" | "C2" | "C2-service" | "C2-occupancy" | "L2-latch" | "L43-expired" | "L13-weeks" | "L13-reorder" | "L26-annulled" | "L11-paid" | "L2-changes" | "L40" | "L12-prep" | "L17-notices" | "L38-dishes" | "L12-start" | "L9-late" | "L12-station" | "L9-remakes" | "L12-dish" | "L41-notices" | "L12-bill" | "L28-reviews" | "L13-voids" | "L43-usage" | "L43-unused" | "L11-dessert" | "L5-axes" | "L38-coupons" | "L1-weekdays" | "L15" | "L39-overrides" | "L17-pace" | "L17-delivered" | "L17-cooks" | "L32-placement" | "L17-people" | "L38-invitations" | "L38-mentions" | "L38-praise" | "L40-return" | "L38-question" | "L13-costing" | "L33-control" | "L11-floor" | "L39-load" | "L13-ideas" | "L20-sensory" | "L45";
  readonly reason: "source_unavailable" | "research_budget" | "not_permitted" | "not_published";
}>
export type ParteDishCosts = Readonly<{
  readonly contract: "exylon.parte.dish-costs@1.0";
  readonly dishes: readonly (Readonly<{
      readonly category?: Readonly<{
        readonly category_id: string;
        readonly name: string;
      }> | null;
      readonly cost_minor: number | null;
      readonly coverage: Readonly<{
        readonly lines: number;
        readonly missing_ingredient_ids: readonly (string)[];
        readonly priced_lines: number;
      }>;
      readonly dish_id: string;
      readonly draft_recipe: boolean;
      readonly iva_unknown?: boolean;
      readonly label: "real" | "estimado" | "sin_datos";
      readonly lines: readonly (Readonly<{
          readonly estimated: boolean;
          readonly ingredient_id: string;
          readonly line_cost_minor: number | null;
          readonly price_base: "kilogram" | "litre" | "unit";
          readonly price_per_base_minor: number | null;
          readonly quantity: Readonly<{
            readonly amount: number;
            readonly unit: "grams" | "millilitres" | "units";
          }>;
          readonly quantity_source: "draft_recipe" | "confirmed_recipe";
          readonly source: Readonly<{
            readonly confirmed_at: string;
            readonly delivery_note_id: string;
            readonly kind: "delivery_note";
            readonly line_index: number;
          }> | Readonly<{
            readonly bulletin: string;
            readonly kind: "market_estimate";
            readonly product_ref: string;
            readonly published_on: string;
          }> | Readonly<{
            readonly declared_at: string;
            readonly entry: "goods_receipt" | "manual";
            readonly kind: "owner";
            readonly via: "voice" | "text" | "panel";
          }> | null;
        }>)[];
      readonly low_margin?: boolean | null;
      readonly margin_bps: number | null;
      readonly name: string;
      readonly net_price_minor?: number;
      readonly photo?: Readonly<{
        readonly alt_text: string | null;
        readonly media_id: string;
        readonly sha256_digest: string;
        readonly version: number;
      }> | null;
      readonly price_minor: number;
      readonly real: Readonly<{
        readonly kind: "delivery_note" | "goods_receipt" | "manual";
        readonly since: string;
      }> | null;
    }>)[];
  readonly figures: Readonly<{
    readonly assumed_iva?: boolean;
    readonly costed: number;
    readonly dishes: number;
    readonly draft_recipes: number;
    readonly estimated: number;
    readonly food_cost_bps: number | null;
    readonly real: number;
    readonly sold_food_cost?: Readonly<{
      readonly bps: number | null;
      readonly covers?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
      readonly month: string;
    }>;
    readonly target_food_cost_bps?: Readonly<{
      readonly bps: number;
      readonly source: "pacto_goal" | "default";
    }>;
  }>;
  readonly priced_on: string;
  readonly publication_version: number | null;
  readonly restaurant_id: string;
}>
export type ParteDishCostsQuery = Readonly<{
  readonly priced_on?: string;
}>
export type ParteDishIdeasCard = Readonly<{
  readonly basis: "more_demand" | "thin_supply";
  readonly ideas: readonly (Readonly<{
      readonly allergens: readonly (string)[];
      readonly category_name: string;
      readonly cost_per_portion_minor: number;
      readonly description: string;
      readonly diets: readonly (string)[];
      readonly estimated_line_count: number;
      readonly idea_id: string;
      readonly intent_id: string;
      readonly kind: "pantry" | "creative";
      readonly lines: readonly (Readonly<{
          readonly name: string;
          readonly preparation_label: string | null;
          readonly quantity_text: string;
          readonly to_buy: boolean;
        }>)[];
      readonly name: string;
      readonly portion_grams: number;
      readonly price: Readonly<{
        readonly high_minor: number;
        readonly low_minor: number;
        readonly margin_high_minor: number;
        readonly margin_low_minor: number;
        readonly suggested_minor: number;
      }>;
      readonly steps: readonly (string)[];
      readonly to_buy: readonly (string)[];
    }>)[];
  readonly publication_version: number;
  readonly set_id: string;
  readonly trait_label: string;
  readonly week_monday: string;
}>
export type ParteEdition = Readonly<{
  readonly business_date: string;
  readonly content: ParteEditionContent | ParteWeeklyEditionContent | null;
  readonly contract: "exylon.parte.edition@1.0";
  readonly drafting: "model" | "deterministic" | null;
  readonly drafting_note: "nothing_to_draft" | "no_provider_key" | "model_output_rejected" | "model_failed" | "model_response_lost" | "over_research_budget" | "budget_exhausted" | "provider_not_dispatched" | "model_unchanged" | "model_mixed" | null;
  readonly edition_id: string;
  readonly edition_kind: "daily" | "weekly";
  readonly failure_reason: string | null;
  readonly prepared_at: string | null;
  readonly published_at: string | null;
  readonly restaurant_id: string;
  readonly scheduled_at: string;
  readonly state: "preparing" | "indeterminate" | "published" | "failed";
  readonly tenant_id: string;
  readonly version: number;
  readonly window: ParteWindow;
}>
export type ParteEditionAudio = Readonly<{
  readonly business_date: string;
  readonly contract: "exylon.parte.edition-audio@1.0";
  readonly edition_kind: "daily" | "weekly";
  readonly segments: readonly (Readonly<{
      readonly desk_id: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly index: number;
      readonly mime_type: "audio/mpeg";
      readonly voice: "alloy" | "ash" | "ballad" | "coral" | "echo" | "fable" | "nova" | "onyx" | "sage" | "shimmer" | "verse";
    }>)[];
  readonly status: "complete" | "partial" | "unavailable" | "preparing";
  readonly stopped_because: string | null;
}>
export type ParteEditionContent = Readonly<{
  readonly arqueo: ParteArqueo;
  readonly autonomy?: Readonly<{
    readonly budget: Readonly<{
      readonly areas: readonly (Readonly<{
          readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly label: string;
          readonly proposed_minor: number;
        }>)[];
    }> | null;
    readonly demotions: readonly (Readonly<{
        readonly at: string;
        readonly because: "undone" | "closed_worse";
        readonly context: string | null;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly label: string;
        readonly level: 0 | 1 | 2 | 3;
        readonly tool_id: string;
      }>)[];
    readonly offer: Readonly<{
      readonly context: string | null;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly from: 0 | 1 | 2 | 3;
      readonly kind: "regain" | "widen";
      readonly label: string;
      readonly offer_id: string;
      readonly text: string;
      readonly to: 0 | 1 | 2 | 3;
      readonly tool_id: string;
      readonly version: number;
    }> | null;
  }>;
  readonly briefing_texts?: readonly (Readonly<{
      readonly kind: "previa";
      readonly service_date: string;
      readonly slot: "lunch" | "dinner";
      readonly text: string;
    }>)[];
  readonly business_day?: ParteBusinessDay;
  readonly c2_references?: Readonly<{
    readonly hourly?: Readonly<{
      readonly candidate_dates: number;
      readonly cohort: Readonly<{
        readonly registry_version: string;
        readonly restaurant_id: string;
        readonly timezone: "Europe/Madrid";
      }>;
      readonly computed_at: string;
      readonly contract: "exylon.insights.el-parte-comparable-services@1.0";
      readonly excluded: readonly (Readonly<{
          readonly business_date: string;
          readonly reason: string;
        }>)[];
      readonly metric: "net_cash_minor_per_local_hour";
      readonly population: "operating_days_with_complete_fresh_coverage";
      readonly references: Readonly<{
        readonly status: "available";
        readonly value: readonly (Readonly<{
            readonly currency: "EUR";
            readonly local_hour: number;
            readonly reference: Readonly<{
              readonly centre: number | null;
              readonly day_type: "weekday_without_holiday_calendar";
              readonly excluded: readonly (Readonly<{
                  readonly business_date: string;
                  readonly reason: string;
                }>)[];
              readonly formula_version: "comparable-services-median-range@1";
              readonly input_fingerprint: string;
              readonly missing_for_weekday: number;
              readonly n: number;
              readonly observations: readonly (Readonly<{
                  readonly business_date: string;
                  readonly value: number;
                }>)[];
              readonly parameters: Readonly<{
                readonly history_days: 120;
                readonly max_observations: 10;
                readonly provisional: true;
                readonly second_extremes_from: 6;
                readonly weekday_group_minimum: 4;
                readonly weekday_minimum: 3;
              }>;
              readonly range: Readonly<{
                readonly high: number;
                readonly low: number;
                readonly rule: "min_max" | "second_min_second_max";
              }> | null;
              readonly specificity: "weekday" | "weekday_group" | "none";
              readonly target_date: string;
              readonly target_iso_weekday: number;
            }>;
          }>)[];
      }> | Readonly<{
        readonly reason: "no_operating_days";
        readonly status: "no_data";
      }>;
      readonly registry_version: string;
      readonly restaurant_id: string;
      readonly slot_kind: "local_hour";
      readonly target_date: string;
      readonly tenant_id: string;
      readonly timezone: "Europe/Madrid";
      readonly unit: "money_minor";
    }>;
    readonly occupancy?: Readonly<{
      readonly candidate_dates: number;
      readonly contract: "exylon.insights.parte-occupancy-reference@1.0";
      readonly definition: "observed_table_time_over_available_table_time" | "open_bill_guests_over_published_seats";
      readonly observed_at: string;
      readonly owner_read_calls: number;
      readonly population: "service_slots_with_observed_table_sessions" | "service_slots_with_recorded_open_bill_participant_intervals";
      readonly restaurant_id: string;
      readonly slots: readonly (Readonly<{
          readonly local_start: string;
          readonly reference: Readonly<{
            readonly centre: number | null;
            readonly day_type: "weekday_without_holiday_calendar";
            readonly excluded: readonly (Readonly<{
                readonly business_date: string;
                readonly reason: string;
              }>)[];
            readonly formula_version: "comparable-services-median-range@1";
            readonly input_fingerprint: string;
            readonly missing_for_weekday: number;
            readonly n: number;
            readonly observations: readonly (Readonly<{
                readonly business_date: string;
                readonly value: number;
              }>)[];
            readonly parameters: Readonly<{
              readonly history_days: 120;
              readonly max_observations: 10;
              readonly provisional: true;
              readonly second_extremes_from: 6;
              readonly weekday_group_minimum: 4;
              readonly weekday_minimum: 3;
            }>;
            readonly range: Readonly<{
              readonly high: number;
              readonly low: number;
              readonly rule: "min_max" | "second_min_second_max";
            }> | null;
            readonly specificity: "weekday" | "weekday_group" | "none";
            readonly target_date: string;
            readonly target_iso_weekday: number;
          }>;
          readonly target: Readonly<{
            readonly occupancy_basis_points: number | null;
            readonly reason: "window_open" | "slot_not_observed" | "coverage_incomplete" | null;
            readonly status: "available" | "no_data";
          }>;
        }>)[];
      readonly target_date: string;
      readonly tenant_id: string;
      readonly timezone: "Europe/Madrid";
      readonly unit: "basis_points";
    }>;
    readonly service_slots?: Readonly<{
      readonly candidate_dates: number;
      readonly contract: "exylon.insights.el-parte-service-slots@1.0";
      readonly currency: "EUR";
      readonly observed_at: string;
      readonly population: "services_with_recorded_in_app_paid_checks";
      readonly references: readonly (Readonly<{
          readonly kind: "lunch" | "dinner";
          readonly metric: "in_app_paid_checks" | "collected_minor" | "net_sales_minor";
          readonly reference: Readonly<{
            readonly centre: number | null;
            readonly day_type: "weekday_without_holiday_calendar";
            readonly excluded: readonly (Readonly<{
                readonly business_date: string;
                readonly reason: string;
              }>)[];
            readonly formula_version: "comparable-services-median-range@1";
            readonly input_fingerprint: string;
            readonly missing_for_weekday: number;
            readonly n: number;
            readonly observations: readonly (Readonly<{
                readonly business_date: string;
                readonly value: number;
              }>)[];
            readonly parameters: Readonly<{
              readonly history_days: 120;
              readonly max_observations: 10;
              readonly provisional: true;
              readonly second_extremes_from: 6;
              readonly weekday_group_minimum: 4;
              readonly weekday_minimum: 3;
            }>;
            readonly range: Readonly<{
              readonly high: number;
              readonly low: number;
              readonly rule: "min_max" | "second_min_second_max";
            }> | null;
            readonly specificity: "weekday" | "weekday_group" | "none";
            readonly target_date: string;
            readonly target_iso_weekday: number;
          }>;
        }>)[];
      readonly registry_version: string;
      readonly restaurant_id: string;
      readonly slots: readonly (Readonly<{
          readonly collected_minor: number | null;
          readonly from: string;
          readonly from_hour: number;
          readonly in_app_paid_checks: number | null;
          readonly kind: "lunch" | "dinner";
          readonly net_sales_minor: number | null;
          readonly reason: "coverage_incomplete" | "window_open" | "projection_lagging" | "hourly_count_mismatch" | "slot_not_observed" | null;
          readonly refunded_minor: number | null;
          readonly status: "available" | "no_data";
          readonly until: string;
          readonly until_hour: number;
        }>)[];
      readonly target_date: string;
      readonly tenant_id: string;
      readonly timezone: "Europe/Madrid";
    }>;
  }>;
  readonly cards: readonly (ParteCard)[];
  readonly completion?: Readonly<{
    readonly completed_at: string | null;
    readonly missing: readonly (Readonly<{
        readonly desk?: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly part: string;
      }>)[];
    readonly on_way: readonly (Readonly<{
        readonly desk?: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly part: string;
      }>)[];
    readonly parts: number;
    readonly ready: number;
    readonly state: "completing" | "complete" | "closed";
    readonly until: string;
  }>;
  readonly decisions_outside?: readonly ("recipe_batch" | "consejo" | "rota")[];
  readonly degraded?: readonly (ParteDegradedSource)[];
  readonly did?: readonly (Readonly<{
      readonly action_id: string;
      readonly describe: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly done_at: string;
      readonly level: 1 | 2 | 3;
      readonly operation: Readonly<{
        readonly component_id: string;
        readonly operation_id: string;
      }> | null;
      readonly probation: Readonly<{
        readonly index: number;
        readonly of: 5;
      }> | null;
      readonly receipt_id: string;
      readonly spent_minor: number;
      readonly timeline: readonly (Readonly<{
          readonly at: string;
          readonly state: string;
        }>)[];
      readonly tool_id: string;
      readonly undo: Readonly<{
        readonly operation: string;
        readonly until: string;
      }> | null;
      readonly undo_requested: boolean;
      readonly version: number;
      readonly why: string | null;
    }>)[];
  readonly equipment?: readonly (Readonly<{
      readonly call_line: string | null;
      readonly issue_id: string;
      readonly reported_at: string;
      readonly status: "open" | "in_progress";
      readonly title: string | null;
    }>)[];
  readonly front_page?: Readonly<{
    readonly chosen_by: "direccion" | "code";
    readonly code: Readonly<{
      readonly builder_asks: readonly (string)[];
      readonly decisions: readonly (string)[];
      readonly folded: readonly (string)[];
      readonly to_know: readonly (string)[];
    }>;
    readonly corrected?: number;
    readonly decisions: readonly (string)[];
    readonly fallback?: "no_model" | "not_sent" | "model_failed" | "invalid_choice" | "nothing_to_choose";
    readonly folded: readonly (string)[];
    readonly left_out?: readonly (string)[];
    readonly left_out_stories?: readonly (Readonly<{
        readonly case_id: string;
        readonly measure: string;
        readonly objects: readonly (string)[];
        readonly rows: string;
      }>)[];
    readonly must_ask?: readonly (string)[];
    readonly on_table?: readonly (string)[];
    readonly on_table_operations?: readonly (Readonly<{
        readonly key: string;
        readonly operation_id: string;
        readonly partly_applied?: boolean;
      }>)[];
    readonly printed?: Readonly<{
      readonly papers: readonly (string)[];
      readonly subjects: number;
    }>;
    readonly to_know: readonly (string)[];
  }>;
  readonly hoy: readonly (ParteHoySlot)[];
  readonly kind?: "daily";
  readonly missing?: readonly (Readonly<{
      readonly line: string;
      readonly part: "team_meeting" | "team_actions" | "team_month" | "questions" | "autonomy";
    }>)[];
  readonly night_line?: "night_cut" | "radar_partial" | "weather_stale";
  readonly notebook: readonly (ParteNotebookRef)[];
  readonly pending_operations?: readonly (Readonly<{
      readonly goal: string;
      readonly name: string | null;
      readonly operation_id: string;
      readonly partly_applied: boolean;
    }>)[];
  readonly questions?: readonly (Readonly<{
      readonly answer: Readonly<{
        readonly kind: string;
      }>;
      readonly applies_through: Readonly<{
        readonly tool_id: string;
        readonly via: "toolbox";
      }> | Readonly<{
        readonly operation: string;
        readonly via: "owner_operation";
      }>;
      readonly asked_on: string;
      readonly desk: string;
      readonly question_id: string;
      readonly text: string;
      readonly topic: string;
      readonly version: number;
      readonly why?: string;
    }>)[];
  readonly reputation: ParteReputation;
  readonly setup: readonly (ParteCard)[];
  readonly setup_more?: readonly (ParteSetupWaiting)[];
  readonly team_month?: Readonly<{
    readonly added: number;
    readonly month: string;
    readonly net_minor: Readonly<{
      readonly estimate: number;
      readonly high: number;
      readonly low: number;
    }> | null;
    readonly not_measurable: number;
    readonly provisional: number;
    readonly reason: "nothing_closed" | "overlap_unmerged" | "costs_not_covered" | null;
    readonly shared_with_owner?: number;
    readonly status: "available" | "no_data";
  }>;
  readonly today_by_hour?: Readonly<{
    readonly display_only: true;
    readonly events?: readonly (Readonly<{
        readonly kind: "televised_match" | "rain";
        readonly local_time: string;
      }>)[];
    readonly grade?: "confirmed" | "same_weekday" | "first_days" | "declared";
    readonly normal: number | null;
    readonly reason: "no_forecast" | "forecast_abstained" | "no_hourly_shape" | "closed_today" | null;
    readonly service_date: string;
    readonly slots: readonly (Readonly<{
        readonly covers: Readonly<{
          readonly estimate: number;
          readonly lower: number;
          readonly upper: number;
        }>;
        readonly hours: readonly (Readonly<{
            readonly covers: Readonly<{
              readonly estimate: number;
              readonly lower: number;
              readonly upper: number;
            }>;
            readonly local_hour: string;
          }>)[];
        readonly slot_kind: "lunch" | "dinner";
      }>)[];
    readonly status: "available" | "no_data";
  }>;
  readonly top_band?: Readonly<{
    readonly audio: Readonly<{
      readonly absent_because?: "text_only";
      readonly duration_seconds: number | null;
      readonly status: "available" | "preparing" | "unavailable";
    }>;
    readonly emphasis: readonly (Readonly<{
        readonly end: number;
        readonly start: number;
      }>)[];
    readonly opening?: Readonly<{
      readonly emphasis: readonly (Readonly<{
          readonly end: number;
          readonly start: number;
        }>)[];
      readonly replaces: string;
      readonly text: string;
      readonly whole?: true;
    }>;
    readonly sentence: string | null;
  }>;
  readonly will_do?: readonly (Readonly<{
      readonly action_id: string;
      readonly at: string;
      readonly budget: Readonly<{
        readonly cap_minor: number;
        readonly spent_minor: number;
      }> | null;
      readonly describe: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly level: 1 | 2 | 3;
      readonly operation: Readonly<{
        readonly component_id: string;
        readonly operation_id: string;
      }> | null;
      readonly stoppable: boolean;
      readonly tool_id: string;
      readonly until: string | null;
      readonly version: number;
      readonly waits_on?: readonly (Readonly<{
          readonly component_id: string;
          readonly label: string;
          readonly operation_id: string;
        }>)[];
    }>)[];
  readonly yesterday_comparison?: ParteYesterdayComparison;
}>
export type ParteEditionList = Readonly<{
  readonly contract: "exylon.parte.edition-list@1.0";
  readonly editions: readonly (ParteEditionSummary)[];
  readonly next_before: string | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type ParteEditionListQuery = Readonly<{
  readonly before?: string;
  readonly limit?: string;
}>
export type ParteEditionSummary = Readonly<{
  readonly business_date: string;
  readonly card_count: number;
  readonly drafting: "model" | "deterministic" | null;
  readonly edition_id: string;
  readonly edition_kind: "daily" | "weekly";
  readonly notebook_count: number;
  readonly published_at: string | null;
  readonly setup_count: number;
  readonly state: "preparing" | "indeterminate" | "published" | "failed";
  readonly version: number;
}>
export type ParteEncargo = Readonly<{
  readonly answer: Readonly<{
    readonly answered_at: string;
    readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
    readonly findings: readonly (string)[];
    readonly lead_desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly nothing_prepared_because: string | null;
    readonly outcome?: "answers" | "could_not_answer";
    readonly prepared: readonly (Readonly<{
        readonly describe: string;
        readonly intent_id: string;
        readonly kind: "proposal";
      }> | Readonly<{
        readonly describe: string;
        readonly kind: "operation";
        readonly operation_id: string;
      }> | Readonly<{
        readonly describe: string;
        readonly kind: "question";
        readonly question_id: string;
      }>)[];
    readonly rows?: readonly (Readonly<{
        readonly dish_id?: string;
        readonly display: string;
        readonly from: string;
        readonly label: string;
        readonly measure: string;
        readonly measure_id: string;
        readonly rank: number | null;
        readonly ranked: number | null;
        readonly to: string;
      }>)[];
    readonly series?: readonly (Readonly<{
        readonly label: string;
        readonly measure: string;
        readonly series: Readonly<{
          readonly coverage: Readonly<{
            readonly expected: number;
            readonly observed: number;
            readonly state: "complete" | "partial" | "young";
          }>;
          readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
          readonly normal: Readonly<{
            readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
            readonly estimate: boolean;
            readonly hi: number;
            readonly lo: number;
            readonly mid: number | null;
            readonly observed: number;
            readonly window?: Readonly<{
              readonly from: string;
              readonly to: string;
            }>;
          }> | null;
          readonly of: string;
          readonly points: readonly (Readonly<{
              readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
              readonly days?: Readonly<{
                readonly observed: number;
                readonly of: number;
              }>;
              readonly part?: string;
              readonly partial?: true;
              readonly partial_reason?: "running" | "opened" | "uncounted";
              readonly range?: Readonly<{
                readonly hi: number;
                readonly lo: number;
              }>;
              readonly value: number | null;
              readonly window: Readonly<{
                readonly from: string;
                readonly to: string;
              }>;
            }>)[];
          readonly previous?: readonly (Readonly<{
              readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
              readonly days?: Readonly<{
                readonly observed: number;
                readonly of: number;
              }>;
              readonly part?: string;
              readonly partial?: true;
              readonly partial_reason?: "running" | "opened" | "uncounted";
              readonly range?: Readonly<{
                readonly hi: number;
                readonly lo: number;
              }>;
              readonly value: number | null;
              readonly window: Readonly<{
                readonly from: string;
                readonly to: string;
              }>;
            }>)[];
          readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
        }>;
      }>)[];
    readonly summary: string;
    readonly table?: Readonly<{
      readonly on: string;
      readonly rows: readonly (Readonly<{
          readonly display: string;
          readonly label: string;
          readonly note: string | null;
        }>)[];
      readonly title: string;
    }> | null;
    readonly unconfirmed?: readonly (string)[];
    readonly unknowns?: readonly (string)[];
  }> | null;
  readonly answer_due_at: string;
  readonly answer_first_due_at?: string;
  readonly contract: "exylon.parte.encargo@1.0";
  readonly encargo_id: string;
  readonly nights_worked?: number;
  readonly plan?: Readonly<{
    readonly answer_on: string;
    readonly consulted: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
    readonly lead_desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly moved_because: string | null;
    readonly needs: readonly (Readonly<{
        readonly field: string | null;
        readonly kind: "fact";
        readonly set: "sales" | "service" | "team" | "stock" | "guests" | "street" | "changes";
      }> | Readonly<{
        readonly kind: "data_question";
        readonly question_id: string | null;
        readonly topic: string;
      }> | Readonly<{
        readonly kind: "tool";
        readonly tool_id: string | null;
        readonly what: string;
      }>)[];
    readonly planned_on: string;
  }> | null;
  readonly requested_at: string;
  readonly restaurant_id: string;
  readonly revisit?: Readonly<{
    readonly kind: "date";
    readonly on: string;
  }> | Readonly<{
    readonly kind: "question_answered";
    readonly question_id: string;
  }> | Readonly<{
    readonly field: string | null;
    readonly kind: "fact_available";
    readonly set: "sales" | "service" | "team" | "stock" | "guests" | "street" | "changes";
  }> | Readonly<{
    readonly change_key: string;
    readonly kind: "change_result";
  }> | Readonly<{
    readonly kind: "measure_changed";
    readonly measure_id: string;
    readonly request_id: string;
    readonly until: string;
    readonly version: number;
  }> | null;
  readonly state: "requested" | "planned" | "working" | "waiting" | "answered";
  readonly team_note?: string | null;
  readonly text: string;
  readonly version: number;
  readonly via: "voice" | "text";
  readonly waiting_series?: readonly (Readonly<{
      readonly label: string;
      readonly measure: string;
      readonly series: Readonly<{
        readonly coverage: Readonly<{
          readonly expected: number;
          readonly observed: number;
          readonly state: "complete" | "partial" | "young";
        }>;
        readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
        readonly normal: Readonly<{
          readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
          readonly estimate: boolean;
          readonly hi: number;
          readonly lo: number;
          readonly mid: number | null;
          readonly observed: number;
          readonly window?: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }> | null;
        readonly of: string;
        readonly points: readonly (Readonly<{
            readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
            readonly days?: Readonly<{
              readonly observed: number;
              readonly of: number;
            }>;
            readonly part?: string;
            readonly partial?: true;
            readonly partial_reason?: "running" | "opened" | "uncounted";
            readonly range?: Readonly<{
              readonly hi: number;
              readonly lo: number;
            }>;
            readonly value: number | null;
            readonly window: Readonly<{
              readonly from: string;
              readonly to: string;
            }>;
          }>)[];
        readonly previous?: readonly (Readonly<{
            readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
            readonly days?: Readonly<{
              readonly observed: number;
              readonly of: number;
            }>;
            readonly part?: string;
            readonly partial?: true;
            readonly partial_reason?: "running" | "opened" | "uncounted";
            readonly range?: Readonly<{
              readonly hi: number;
              readonly lo: number;
            }>;
            readonly value: number | null;
            readonly window: Readonly<{
              readonly from: string;
              readonly to: string;
            }>;
          }>)[];
        readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
      }>;
    }>)[] | null;
  readonly waiting_since?: string | null;
  readonly working_desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
}>
export type ParteEncargoCreateRequest = Readonly<{
  readonly encargo_id: string;
  readonly rota_week?: string | null;
  readonly text: string;
  readonly via: "voice" | "text";
  readonly voice_answer_id: string | null;
}>
export type ParteEncargoList = Readonly<{
  readonly contract: "exylon.parte.encargo-list@1.0";
  readonly items: readonly (ParteEncargo)[];
  readonly restaurant_id: string;
}>
export type ParteFigure = Readonly<{
  readonly basis?: "reading" | "derived" | "proposal" | "reference";
  readonly chart?: "spark" | "columns";
  readonly counted?: boolean;
  readonly coverage?: ParteCoverage;
  readonly display: string;
  readonly id: string;
  readonly in_headline: boolean;
  readonly label?: string;
  readonly nominal?: "recognition" | "registered_fact";
  readonly of: string;
  readonly period?: PartePeriod;
  readonly population?: Readonly<{
    readonly of: string;
    readonly size: number | null;
  }>;
  readonly registry?: "catalog_allergens";
  readonly series?: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly source: ParteSourceRef;
  readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds" | "label";
  readonly value: number | string;
}>
export type ParteFinanzasDailyAccountRead = Readonly<{
  readonly account: Readonly<{
    readonly assumed_iva?: boolean;
    readonly contract: "exylon.parte.daily-account@1.0";
    readonly contribution_minor: number | null;
    readonly delivery: Readonly<{
      readonly status: "not_connected";
    }> | Readonly<{
      readonly commission_minor: number;
      readonly gross_minor: number;
      readonly net_minor: number;
      readonly status: "connected";
    }>;
    readonly discounts_minor: number | null;
    readonly estimated: boolean;
    readonly fixed_costs: Readonly<{
      readonly status: "not_declared";
    }> | Readonly<{
      readonly daily_share_minor: number;
      readonly status: "declared";
    }>;
    readonly food_cost: Readonly<{
      readonly costed_dishes: number;
      readonly estimated: boolean;
      readonly estimated_dishes: number;
      readonly minor: number | null;
      readonly missing_dish_ids: readonly (string)[];
      readonly sold_dishes: number;
    }>;
    readonly headline: "beneficio" | "contribucion";
    readonly labour: Readonly<{
      readonly status: "not_declared";
    }> | Readonly<{
      readonly incomplete: boolean;
      readonly minor: number;
      readonly missing_roles: readonly (string)[];
      readonly status: "declared";
    }>;
    readonly result_minor: number | null;
    readonly sales_net_minor: number | null;
    readonly sales_with_tax_minor?: number | null;
    readonly service_date: string;
  }> | null;
  readonly contract: "exylon.parte.finanzas-daily-account-read@1.0";
  readonly cost_inflation: Readonly<{
    readonly compared_with: string;
    readonly ingredients: readonly (Readonly<{
        readonly change_bps: number;
        readonly dishes: readonly (Readonly<{
            readonly cost_after_minor: number | null;
            readonly cost_before_minor: number | null;
            readonly delta_per_portion_minor: number;
            readonly dish_id: string;
            readonly name: string;
          }>)[];
        readonly ingredient_id: string;
        readonly price_after_minor: number;
        readonly price_base: "kilogram" | "litre" | "unit";
        readonly price_before_minor: number;
        readonly raised_on?: string;
        readonly stock_item_id: string | null;
      }>)[];
    readonly on: string;
  }> | null;
  readonly declarations: Readonly<{
    readonly fixed_costs: Readonly<{
      readonly contract: "exylon.parte.fixed-costs-declaration@1.0";
      readonly declared_at: string;
      readonly declared_by: string;
      readonly lines: readonly (Readonly<{
          readonly kind: "rent" | "utilities" | "insurance" | "gestoria" | "financing" | "other";
          readonly label: string;
          readonly monthly_minor: number;
        }>)[];
      readonly restaurant_id: string;
      readonly verbatim: string | null;
      readonly version: number;
      readonly via: "voice" | "text" | "panel";
    }> | null;
    readonly labour_averages: Readonly<{
      readonly contract: "exylon.parte.labour-averages-declaration@1.0";
      readonly declared_at: string;
      readonly declared_by: string;
      readonly restaurant_id: string;
      readonly roles: readonly (Readonly<{
          readonly average_cost_per_hour_minor: number;
          readonly role_name: string;
        }>)[];
      readonly verbatim: string | null;
      readonly version: number;
      readonly via: "voice" | "text" | "panel";
    }> | null;
  }>;
  readonly gestoria_pack: Readonly<{
    readonly list_operation: "billing.export.list";
    readonly month: string;
    readonly path: string;
    readonly prepare_operation: "billing.export.prepare";
  }> | null;
  readonly gestoria_pack_absence: "no_sales_that_month" | "no_morning" | null;
  readonly late: boolean;
  readonly morning_of: string | null;
  readonly recorded_at: string | null;
  readonly restaurant_id: string;
  readonly tax_reserve: Readonly<{
    readonly coverage: Readonly<{
      readonly days: number;
      readonly days_read: number;
      readonly missing_dates: readonly (string)[];
    }>;
    readonly due_on: string;
    readonly from: string;
    readonly output_tax_minor: number | null;
    readonly quarter: string;
    readonly through: string;
  }> | null;
}>
export type ParteFinanzasNumberOfTodayRead = Readonly<{
  readonly contract: "exylon.parte.finanzas-number-of-today-read@1.0";
  readonly late: boolean;
  readonly morning_of: string | null;
  readonly number: Readonly<{
    readonly break_even: Readonly<{
      readonly daily_sales_minor: number;
      readonly status: "known";
    }> | Readonly<{
      readonly missing: readonly ("fixed_costs" | "labour" | "margin")[];
      readonly status: "unknown";
    }>;
    readonly contract: "exylon.parte.number-of-today@1.0";
    readonly forecast_sales: Readonly<{
      readonly estimate: number;
      readonly lower: number;
      readonly upper: number;
    }> | null;
    readonly month: Readonly<{
      readonly needed_per_day_minor: number;
      readonly progress_key?: Readonly<{
        readonly as_of: string;
        readonly goal_id: string;
        readonly metric_no: number;
        readonly revision: number;
      }>;
      readonly remaining_open_days: number;
      readonly target_minor: number;
      readonly to_date_minor: number;
    }> | null;
    readonly service_date: string;
  }> | null;
  readonly recorded_at: string | null;
  readonly restaurant_id: string;
}>
export type ParteFinanzasReadQuery = Readonly<{
  readonly morning_of?: string;
}>
export type ParteFixedCostsDeclaration = Readonly<{
  readonly contract: "exylon.parte.fixed-costs-declaration@1.0";
  readonly declared_at: string;
  readonly declared_by: string;
  readonly lines: readonly (Readonly<{
      readonly kind: "rent" | "utilities" | "insurance" | "gestoria" | "financing" | "other";
      readonly label: string;
      readonly monthly_minor: number;
    }>)[];
  readonly restaurant_id: string;
  readonly verbatim: string | null;
  readonly version: number;
  readonly via: "voice" | "text" | "panel";
}>
export type ParteFixedCostsDeclareRequest = Readonly<{
  readonly expected_version: number;
  readonly lines: readonly (Readonly<{
      readonly kind: "rent" | "utilities" | "insurance" | "gestoria" | "financing" | "other";
      readonly label: string;
      readonly monthly_minor: number;
    }>)[];
  readonly verbatim: string | null;
  readonly via: "voice" | "text" | "panel";
}>
export type ParteFoodWastePlan = Readonly<{
  readonly adopted_at: string | null;
  readonly adopted_on: string | null;
  readonly contract: "exylon.parte.food-waste-plan@1.0";
  readonly current: boolean;
  readonly measures: readonly (Readonly<{
      readonly code: "prep_from_forecast" | "order_from_forecast" | "first_in_first_out" | "record_waste_and_cause" | "leftovers_to_take_away" | "surplus_feeds_the_team" | "donate_surplus";
      readonly required: boolean;
      readonly text: string;
    }>)[];
  readonly proposed: readonly (Readonly<{
      readonly code: "prep_from_forecast" | "order_from_forecast" | "first_in_first_out" | "record_waste_and_cause" | "leftovers_to_take_away" | "surplus_feeds_the_team" | "donate_surplus";
      readonly required: boolean;
      readonly text: string;
    }>)[];
  readonly restaurant_id: string;
  readonly review_by: string | null;
  readonly status: "adopted" | "not_adopted";
  readonly team_update: Readonly<{
    readonly added: readonly (Readonly<{
        readonly code: "prep_from_forecast" | "order_from_forecast" | "first_in_first_out" | "record_waste_and_cause" | "leftovers_to_take_away" | "surplus_feeds_the_team" | "donate_surplus";
        readonly reason: string;
        readonly text: string;
      }>)[];
    readonly based_on_version: number;
    readonly measures: readonly (Readonly<{
        readonly code: "prep_from_forecast" | "order_from_forecast" | "first_in_first_out" | "record_waste_and_cause" | "leftovers_to_take_away" | "surplus_feeds_the_team" | "donate_surplus";
        readonly required: boolean;
        readonly text: string;
      }>)[];
    readonly proposed_at: string;
    readonly week_start: string;
  }> | null;
  readonly team_update_undo: Readonly<{
    readonly measures: readonly (Readonly<{
        readonly code: "prep_from_forecast" | "order_from_forecast" | "first_in_first_out" | "record_waste_and_cause" | "leftovers_to_take_away" | "surplus_feeds_the_team" | "donate_surplus";
        readonly required: boolean;
        readonly text: string;
      }>)[];
    readonly previous_version: number;
  }> | null;
  readonly version: number;
}>
export type ParteFoodWastePlanAdoptRequest = Readonly<{
  readonly expected_version: number;
  readonly measures: readonly ("prep_from_forecast" | "order_from_forecast" | "first_in_first_out" | "record_waste_and_cause" | "leftovers_to_take_away" | "surplus_feeds_the_team" | "donate_surplus")[];
}>
export type ParteFoodWastePlanQuery = Readonly<Record<never, never>>
export type ParteFoodWastePlanUpdateDeclineRequest = Readonly<{
  readonly based_on_version: number;
}>
export type ParteGoalConfirmRequest = Readonly<{
  readonly expected_version: number;
}>
export type ParteGoalCorrectRequest = Readonly<{
  readonly expected_version: number;
  readonly via: "text" | "voice";
  readonly words: string;
}>
export type ParteGoalDeclineRequest = Readonly<{
  readonly expected_version: number;
  readonly words: string | null;
}>
export type ParteGoalSayRequest = Readonly<{
  readonly goal_id: string;
  readonly supersedes: string | null;
  readonly via: "text" | "voice";
  readonly words: string;
}>
export type ParteGoalsQuery = Readonly<{
  readonly view?: "hoy" | "pacto";
}>
export type ParteGoalsRead = Readonly<{
  readonly contract: "exylon.parte.goals@1.0";
  readonly goals: readonly (ParteGoalView)[];
  readonly in_force: number;
  readonly max_in_force: 3;
  readonly read_at: string;
  readonly restaurant_id: string;
  readonly service_date: string;
  readonly view: "hoy" | "pacto";
}>
export type ParteGoalView = Readonly<{
  readonly goal: Readonly<{
    readonly author: Readonly<{
      readonly kind: "owner";
      readonly principal_id: string;
    }> | Readonly<{
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly kind: "team";
      readonly run_id: string | null;
    }>;
    readonly closed_at: string | null;
    readonly confirmed_at: string | null;
    readonly confirmed_by: string | null;
    readonly corrections: readonly (Readonly<{
        readonly said_at: string;
        readonly text: string;
        readonly via: "text" | "voice";
      }>)[];
    readonly created_at: string;
    readonly goal_id: string;
    readonly matter_id: string;
    readonly metrics: readonly (Readonly<{
        readonly direction: "at_least" | "at_most" | null;
        readonly final_actual: number | null;
        readonly measure: string | null;
        readonly measure_definition: string | null;
        readonly measure_label: string | null;
        readonly measure_version: number | null;
        readonly metric_no: number;
        readonly quoted_words: string;
        readonly result: "met" | "missed" | "unmeasured" | null;
        readonly scope: Readonly<{
          readonly kind: "house";
        }> | Readonly<{
          readonly kind: "slot";
          readonly slot: "lunch" | "dinner";
        }> | Readonly<{
          readonly kind: "weekday";
          readonly weekday: 1 | 2 | 3 | 4 | 5 | 6 | 7;
        }>;
        readonly state: "typed" | "needs_definition";
        readonly target: number | null;
        readonly unit: "eur_minor" | "covers" | "tables" | null;
      }>)[];
    readonly outcome: "met" | "missed" | "partly_met" | "unmeasured" | null;
    readonly period: Readonly<{
      readonly from: string;
      readonly kind: "service_week" | "service_month";
      readonly to: string;
    }> | null;
    readonly proposed_at: string | null;
    readonly restaurant_id: string;
    readonly source_line_id: string | null;
    readonly state: "needs_definition" | "proposed" | "in_force" | "closed" | "declined" | "withdrawn" | "superseded" | "lapsed";
    readonly superseded_by: string | null;
    readonly superseded_by_words: string | null;
    readonly supersedes: string | null;
    readonly updated_at: string;
    readonly version: number;
    readonly words: Readonly<{
      readonly said_at: string;
      readonly text: string;
      readonly via: "text" | "voice";
    }> | null;
  }>;
  readonly matter: Readonly<{
    readonly attempts_without_progress: number;
    readonly closed_at: string | null;
    readonly consulted_desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
    readonly escalation: number;
    readonly goal_id: string | null;
    readonly kind: "goal_pursuit" | "owner_request";
    readonly late_since: string | null;
    readonly lead_desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly line: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly live_run: Readonly<{
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly interrupt_reason: "budget" | "deadline" | "provider" | "fault" | null;
      readonly purpose: "intake" | "pursue" | "consult" | "read_back" | "answer_request" | "morning";
      readonly resume_at: string | null;
      readonly run_id: string;
      readonly started_at: string | null;
      readonly state: "due" | "running" | "interrupted";
    }> | null;
    readonly matter_id: string;
    readonly next_run_at: string | null;
    readonly opened_at: string;
    readonly outcome: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly plan: readonly (Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly due_on: string | null;
        readonly ref: Readonly<{
          readonly id: string;
          readonly kind: "operation" | "queue_item";
        }> | null;
        readonly state: "todo" | "doing" | "done" | "dropped";
        readonly step_key: string;
        readonly words: string | null;
      }>)[];
    readonly promise: Readonly<{
      readonly promised_on: string;
    }> | null;
    readonly promise_history: readonly (Readonly<{
        readonly because: Readonly<{
          readonly body: string;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly parts: readonly (string)[] | null;
          readonly text_id: string;
          readonly verified_at: string;
        }> | null;
        readonly promised_on: string;
        readonly set_at: string;
      }>)[];
    readonly runs_count: number;
    readonly state: "open" | "planned" | "working" | "waiting" | "done" | "dropped" | "answered";
    readonly title: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly version: number;
    readonly waiting_on: Readonly<{
      readonly item_id: string;
      readonly kind: "owner";
    }> | Readonly<{
      readonly kind: "fact";
      readonly measure_id: string;
      readonly until: string;
    }> | Readonly<{
      readonly kind: "date";
      readonly on: string;
    }> | null;
  }>;
  readonly open_item_ids: readonly (string)[];
  readonly progress: readonly (Readonly<{
      readonly actual: number | null;
      readonly as_of: string;
      readonly computed_at: string;
      readonly coverage: Readonly<{
        readonly missing: number;
        readonly not_operating: number;
        readonly observed: number;
      }>;
      readonly definition_version: number;
      readonly expected_by_now: number | null;
      readonly expected_share_of_target_bps: number | null;
      readonly fact_ids: readonly (string)[];
      readonly forecast: Readonly<{
        readonly basis: Readonly<{
          readonly revenue_per_cover: readonly (Readonly<{
              readonly denominator: number;
              readonly iso_weekday: number;
              readonly numerator: number;
            }>)[] | null;
          readonly stated_share_bps: number | null;
        }>;
        readonly days: readonly (Readonly<{
            readonly grade: string | null;
            readonly high: number;
            readonly low: number;
            readonly mid: number;
            readonly service_date: string;
          }>)[];
        readonly fact_ids: readonly (string)[];
        readonly grade: string | null;
        readonly high: number;
        readonly low: number;
        readonly method: string;
        readonly mid: number;
      }> | null;
      readonly forecast_gap_to_target: Readonly<{
        readonly high: number;
        readonly low: number;
      }> | null;
      readonly gap_to_pace: number | null;
      readonly gap_to_target: number | null;
      readonly goal_id: string;
      readonly metric_no: number;
      readonly open_days: Readonly<{
        readonly elapsed: number;
        readonly remaining: number;
        readonly total: number;
      }>;
      readonly outlook: "likely" | "at_risk" | "unlikely" | null;
      readonly position: "not_started" | "ahead" | "on_pace" | "behind" | "met" | "unmeasured";
      readonly required_per_open_day: number | null;
      readonly revision: number;
      readonly share_of_expected_bps: number | null;
      readonly share_of_target_bps: number | null;
    }>)[];
}>
export type ParteGoalWithdrawRequest = Readonly<{
  readonly expected_version: number;
}>
export type ParteHouseMemory = Readonly<{
  readonly contract: "exylon.parte.house-memory@1.0";
  readonly lessons: readonly (Readonly<{
      readonly closed_on: string;
      readonly credited_to: Readonly<{
        readonly desk_ids: readonly (string)[];
        readonly kind: "desks";
        readonly with_owner?: true;
      }> | Readonly<{
        readonly kind: "operation";
        readonly operation_id: string;
        readonly with_owner?: true;
      }> | Readonly<{
        readonly kind: "owner";
      }>;
      readonly evidence: Readonly<{
        readonly interval: Readonly<{
          readonly estimate: number;
          readonly high: number;
          readonly level: 0.8 | 0.9 | 0.95;
          readonly low: number;
        }> | null;
        readonly measure_id: string;
        readonly net_minor: Readonly<{
          readonly estimate: number;
          readonly high: number;
          readonly low: number;
        }> | null;
        readonly reference: "own_comparable_services" | "controls" | "switchback";
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>;
      readonly label: "mejora_probable" | "sin_efecto_claro" | "empeora" | "no_medible";
      readonly lesson: string | null;
      readonly lesson_id: string;
      readonly object?: Readonly<{
        readonly label?: string | null;
        readonly object_id: string;
        readonly object_type: string;
        readonly owner: string;
      }> | null;
    }>)[];
  readonly restaurant_id: string;
  readonly team_lessons?: readonly (Readonly<{
      readonly desk: string;
      readonly evidence: readonly (string)[];
      readonly lesson_id: string;
      readonly objects: readonly (Readonly<{
          readonly label?: string | null;
          readonly object_id: string;
          readonly object_type: string;
          readonly owner: string;
        }>)[];
      readonly supersedes: string | null;
      readonly text: string;
      readonly topic: string;
      readonly written_on: string;
    }>)[];
  readonly team_month: Readonly<{
    readonly added: number;
    readonly month: string;
    readonly net_minor: Readonly<{
      readonly estimate: number;
      readonly high: number;
      readonly low: number;
    }> | null;
    readonly not_measurable: number;
    readonly provisional: number;
    readonly reason: "nothing_closed" | "overlap_unmerged" | "costs_not_covered" | null;
    readonly shared_with_owner?: number;
    readonly status: "available" | "no_data";
  }>;
}>
export type ParteHouseMemoryQuery = Readonly<{
  readonly since?: string;
  readonly until?: string;
}>
export type ParteHoy = Readonly<{
  readonly asks: Readonly<{
    readonly answered: readonly (Readonly<{
        readonly case_id: string;
        readonly edition_kind: "daily" | "weekly";
        readonly key: string;
        readonly kind: "card";
        readonly operation: Readonly<{
          readonly operation_id: string;
          readonly partly_applied: boolean;
          readonly pieces?: number;
          readonly result: "applied" | "partly_applied" | "not_applied" | "undone" | null;
          readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
          readonly version: number;
        }> | null;
      }>)[];
    readonly core_item_ids?: readonly (string)[];
    readonly counts?: Readonly<{
      readonly core_queue?: number;
      readonly decisions: number;
      readonly questions: number;
    }>;
    readonly decisions: readonly (Readonly<{
        readonly case_id: string;
        readonly edition_kind: "daily" | "weekly";
        readonly key: string;
        readonly kind: "card";
        readonly operation: Readonly<{
          readonly operation_id: string;
          readonly partly_applied: boolean;
          readonly pieces?: number;
          readonly result: "applied" | "partly_applied" | "not_applied" | "undone" | null;
          readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
          readonly version: number;
        }> | null;
      }> | Readonly<{
        readonly goal: string;
        readonly key: string;
        readonly kind: "operation";
        readonly name: string | null;
        readonly offer_expires_at: string;
        readonly operation: Readonly<{
          readonly operation_id: string;
          readonly partly_applied: boolean;
          readonly pieces?: number;
          readonly result: "applied" | "partly_applied" | "not_applied" | "undone" | null;
          readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
          readonly version: number;
        }>;
        readonly operation_kind: "occasion" | "weekly_plan" | "daily_set" | "intent" | "seasonal" | "format_pilot" | "plan";
        readonly pieces: number;
      }> | Readonly<{
        readonly key: string;
        readonly kind: "autonomy_offer";
        readonly offer: Readonly<{
          readonly context: string | null;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly from: 0 | 1 | 2 | 3;
          readonly kind: "regain" | "widen";
          readonly label: string;
          readonly offer_id: string;
          readonly text: string;
          readonly to: 0 | 1 | 2 | 3;
          readonly tool_id: string;
          readonly version: number;
        }>;
      }> | Readonly<{
        readonly areas: readonly (Readonly<{
            readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
            readonly label: string;
            readonly proposed_minor: number;
          }>)[];
        readonly key: string;
        readonly kind: "budget";
      }> | Readonly<{
        readonly key: string;
        readonly kind: "consejo";
        readonly month: string;
        readonly open_decisions: number;
        readonly prepared_on: string;
        readonly reading_minutes: number;
      }> | Readonly<{
        readonly cost_minor: number | null;
        readonly key: string;
        readonly kind: "rota";
        readonly people: number;
        readonly planned_minutes: number;
        readonly shortfall: Readonly<{
          readonly objection: Readonly<{
            readonly by: "intervencion";
            readonly kind: "coverage_short";
            readonly objects_to: "publish_with_gaps";
          }>;
          readonly options: readonly ("extend_hours" | "ask_extra_staff" | "reduce_service" | "publish_with_gaps")[];
          readonly people_short: number;
          readonly services_short: number;
        }> | null;
        readonly week_start: string;
      }> | Readonly<{
        readonly drafts: number;
        readonly key: string;
        readonly kind: "recipe_batch";
      }>)[];
    readonly emphasis?: readonly (Readonly<{
        readonly end: number;
        readonly start: number;
      }>)[];
    readonly reads: Readonly<{
      readonly actions: "read" | "partial" | "unreadable";
      readonly decisions: "read" | "partial" | "unreadable";
      readonly questions: "read" | "partial" | "unreadable";
    }>;
    readonly sentence?: string;
    readonly waiting: readonly (Readonly<{
        readonly case_id: string;
        readonly edition_kind: "daily" | "weekly";
        readonly key: string;
        readonly kind: "card";
        readonly operation: Readonly<{
          readonly operation_id: string;
          readonly partly_applied: boolean;
          readonly pieces?: number;
          readonly result: "applied" | "partly_applied" | "not_applied" | "undone" | null;
          readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
          readonly version: number;
        }> | null;
      }> | Readonly<{
        readonly goal: string;
        readonly key: string;
        readonly kind: "operation";
        readonly name: string | null;
        readonly offer_expires_at: string;
        readonly operation: Readonly<{
          readonly operation_id: string;
          readonly partly_applied: boolean;
          readonly pieces?: number;
          readonly result: "applied" | "partly_applied" | "not_applied" | "undone" | null;
          readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
          readonly version: number;
        }>;
        readonly operation_kind: "occasion" | "weekly_plan" | "daily_set" | "intent" | "seasonal" | "format_pilot" | "plan";
        readonly pieces: number;
      }> | Readonly<{
        readonly key: string;
        readonly kind: "autonomy_offer";
        readonly offer: Readonly<{
          readonly context: string | null;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly from: 0 | 1 | 2 | 3;
          readonly kind: "regain" | "widen";
          readonly label: string;
          readonly offer_id: string;
          readonly text: string;
          readonly to: 0 | 1 | 2 | 3;
          readonly tool_id: string;
          readonly version: number;
        }>;
      }> | Readonly<{
        readonly areas: readonly (Readonly<{
            readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
            readonly label: string;
            readonly proposed_minor: number;
          }>)[];
        readonly key: string;
        readonly kind: "budget";
      }> | Readonly<{
        readonly key: string;
        readonly kind: "consejo";
        readonly month: string;
        readonly open_decisions: number;
        readonly prepared_on: string;
        readonly reading_minutes: number;
      }> | Readonly<{
        readonly cost_minor: number | null;
        readonly key: string;
        readonly kind: "rota";
        readonly people: number;
        readonly planned_minutes: number;
        readonly shortfall: Readonly<{
          readonly objection: Readonly<{
            readonly by: "intervencion";
            readonly kind: "coverage_short";
            readonly objects_to: "publish_with_gaps";
          }>;
          readonly options: readonly ("extend_hours" | "ask_extra_staff" | "reduce_service" | "publish_with_gaps")[];
          readonly people_short: number;
          readonly services_short: number;
        }> | null;
        readonly week_start: string;
      }> | Readonly<{
        readonly drafts: number;
        readonly key: string;
        readonly kind: "recipe_batch";
      }>)[];
  }>;
  readonly audio: Readonly<{
    readonly status: "available";
    readonly value: Readonly<{
      readonly absent_because?: "text_only";
      readonly duration_seconds: number | null;
      readonly state: "ready" | "partial" | "preparing" | "unavailable";
    }>;
  }> | Readonly<{
    readonly reason: "not_wired" | "no_data" | "unreadable" | "not_due";
    readonly status: "absent";
  }>;
  readonly business_date: string;
  readonly contract: "exylon.parte.hoy@1.0";
  readonly did: readonly (Readonly<{
      readonly action_id: string;
      readonly briefing?: Readonly<{
        readonly reason: string | null;
        readonly state: "delivered" | "not_rewritten" | "not_sent" | "stopped" | "nothing_to_say";
        readonly text: string | null;
      }> | null;
      readonly delivered?: Readonly<{
        readonly at: string;
        readonly audience?: "whole_team" | "floor_team" | null;
        readonly rewritten?: Readonly<{
          readonly at: string;
          readonly changed: readonly (string)[];
          readonly untold: readonly (string)[];
        }> | null;
        readonly text: string;
      }> | null;
      readonly describe: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly done_at: string;
      readonly level: 1 | 2 | 3;
      readonly operation: Readonly<{
        readonly component_id: string;
        readonly operation_id: string;
      }> | null;
      readonly probation: Readonly<{
        readonly index: number;
        readonly of: 5;
      }> | null;
      readonly receipt_id: string;
      readonly routine?: Readonly<{
        readonly audience: "whole_team" | "floor_team";
        readonly kind: "previa" | "cierre";
        readonly slot: "lunch" | "dinner";
        readonly worded: boolean;
      }> | null;
      readonly spent_minor: number;
      readonly timeline: readonly (Readonly<{
          readonly at: string;
          readonly state: string;
        }>)[];
      readonly tool_id: string;
      readonly trial_ended?: Readonly<{
        readonly after_clean_window: boolean;
        readonly day: number;
        readonly of: number;
      }> | null;
      readonly undo: Readonly<{
        readonly operation: string;
        readonly until: string;
      }> | null;
      readonly undo_requested: boolean;
      readonly undo_state: "open" | "requested" | "undone" | "closed";
      readonly version: number;
      readonly why: string | null;
      readonly withheld?: true;
    }>)[];
  readonly edition: Readonly<{
    readonly edition_id: string;
    readonly published_at: string | null;
  }> | null;
  readonly encargos_answered: readonly (Readonly<{
      readonly answered_at: string;
      readonly desks?: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
      readonly encargo_id: string;
      readonly rows?: readonly (Readonly<{
          readonly display: string;
          readonly label: string;
          readonly rank: number | null;
        }>)[];
      readonly summary: string;
      readonly text: string;
    }>)[];
  readonly encargos_waiting?: readonly (Readonly<{
      readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
      readonly encargo_id: string;
      readonly line: string;
      readonly revisit: Readonly<{
        readonly kind: "date";
        readonly on: string;
      }> | Readonly<{
        readonly kind: "question_answered" | "fact_available" | "change_result" | "measure_changed";
      }>;
      readonly since: string | null;
      readonly text: string;
    }>)[];
  readonly knowing: Readonly<{
    readonly status: "available";
    readonly value: Readonly<{
      readonly day: number | null;
      readonly first_service_on: string | null;
      readonly first_week: Readonly<{
        readonly day: number;
        readonly of: number;
      }> | null;
      readonly grade: "declared" | "first_days" | "same_weekday" | "confirmed";
      readonly served_days: number;
    }>;
  }> | Readonly<{
    readonly reason: "not_wired" | "no_data" | "unreadable" | "not_due";
    readonly status: "absent";
  }>;
  readonly night: Readonly<{
    readonly status: "available";
    readonly value: Readonly<{
      readonly finished_at: string | null;
      readonly late: boolean;
      readonly met: boolean;
      readonly state: "due" | "running" | "done" | "failed" | "expired";
    }>;
  }> | Readonly<{
    readonly reason: "not_wired" | "no_data" | "unreadable" | "not_due";
    readonly status: "absent";
  }>;
  readonly outlook: Readonly<{
    readonly status: "available";
    readonly value: Readonly<{
      readonly normal: number | null;
      readonly partial: boolean;
      readonly service_date: string;
      readonly services: readonly (Readonly<{
          readonly covers: Readonly<{
            readonly estimate: number;
            readonly lower: number;
            readonly upper: number;
          }> | null;
          readonly expected: "open" | "closed";
          readonly grade: "declared" | "first_days" | "same_weekday" | "confirmed" | "unknown";
          readonly slot_kind: "lunch" | "dinner";
        }>)[];
    }>;
  }> | Readonly<{
    readonly reason: "not_wired" | "no_data" | "unreadable" | "not_due";
    readonly status: "absent";
  }>;
  readonly questions: readonly (Readonly<{
      readonly answer: Readonly<{
        readonly kind: string;
      }>;
      readonly applies_through: Readonly<{
        readonly tool_id: string;
        readonly via: "toolbox";
      }> | Readonly<{
        readonly operation: string;
        readonly via: "owner_operation";
      }>;
      readonly asked_on: string;
      readonly desk: string;
      readonly question_id: string;
      readonly text: string;
      readonly topic: string;
      readonly version: number;
      readonly why?: string;
    }>)[];
  readonly read_at: string;
  readonly restaurant_id: string;
  readonly running?: Readonly<{
    readonly status: "available";
    readonly value: Readonly<{
      readonly changes: readonly (Readonly<{
          readonly closed_on: string | null;
          readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
          readonly effect: Readonly<{
            readonly estimate: number;
            readonly high: number;
            readonly low: number;
          }> | null;
          readonly key: string;
          readonly label: "mejora_probable" | "sin_efecto_claro" | "empeora" | "no_medible" | null;
          readonly life: "applying" | "measuring" | "result";
          readonly measure: Readonly<{
            readonly label: string;
            readonly unit: string;
          }> | null;
          readonly members?: readonly (string)[];
          readonly name: string;
          readonly net_minor: Readonly<{
            readonly estimate: number;
            readonly high: number;
            readonly low: number;
          }> | null;
          readonly planned_end: string | null;
          readonly reading: Readonly<{
            readonly before: number;
            readonly now: number;
            readonly observed_days: number;
          }> | null;
          readonly started_at: string;
          readonly trial: Readonly<{
            readonly day: number;
            readonly of: number;
          }> | null;
          readonly undo: Readonly<{
            readonly action_id: string;
            readonly last_day: string;
            readonly until: string;
            readonly version: number;
          }> | null;
          readonly undone_on_day: number | null;
        }>)[];
      readonly count: number;
    }>;
  }> | Readonly<{
    readonly reason: "not_wired" | "no_data" | "unreadable" | "not_due";
    readonly status: "absent";
  }>;
  readonly team_stop: Readonly<{
    readonly status: "available";
    readonly value: Readonly<{
      readonly changed_at: string | null;
      readonly platform_stopped: boolean;
      readonly restaurant_stopped: boolean;
      readonly stop_version: number;
      readonly team_exists: boolean;
    }>;
  }> | Readonly<{
    readonly reason: "not_wired" | "no_data" | "unreadable" | "not_due";
    readonly status: "absent";
  }>;
  readonly unchanged?: readonly (Readonly<{
      readonly case_id: string;
      readonly figures: readonly (Readonly<{
          readonly label: string;
          readonly value: string;
        }>)[];
      readonly mornings: number;
      readonly since: string;
      readonly state: "same" | "left_out";
    }>)[];
  readonly will_do: readonly (Readonly<{
      readonly action_id: string;
      readonly at: string;
      readonly budget: Readonly<{
        readonly cap_minor: number;
        readonly spent_minor: number;
      }> | null;
      readonly describe: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly level: 1 | 2 | 3;
      readonly operation: Readonly<{
        readonly component_id: string;
        readonly operation_id: string;
      }> | null;
      readonly routine?: Readonly<{
        readonly audience: "whole_team" | "floor_team";
        readonly kind: "previa" | "cierre";
        readonly slot: "lunch" | "dinner";
        readonly worded: boolean;
      }> | null;
      readonly state: "scheduled" | "stopped";
      readonly stoppable: boolean;
      readonly stopped_at?: string | null;
      readonly tool_id: string;
      readonly until: string | null;
      readonly version: number;
      readonly waits_on?: readonly (Readonly<{
          readonly component_id: string;
          readonly label: string;
          readonly operation_id: string;
        }>)[];
      readonly withheld?: true;
    }>)[];
}>
export type ParteHoySlot = Readonly<{
  readonly reading: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteMoney;
  }> | ParteAbsent;
  readonly slot: "collected";
}> | Readonly<{
  readonly open: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: number;
  }> | ParteAbsent;
  readonly paid: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: number;
  }> | ParteAbsent;
  readonly slot: "checks";
}> | Readonly<{
  readonly reading: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteMoney;
  }> | ParteAbsent;
  readonly slot: "amount_per_check";
}> | Readonly<{
  readonly reviews: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteReviewAggregate;
  }> | ParteAbsent;
  readonly slot: "rating";
  readonly survey: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteSurveyAggregate;
  }> | ParteAbsent;
}>
export type ParteLabourAveragesDeclaration = Readonly<{
  readonly contract: "exylon.parte.labour-averages-declaration@1.0";
  readonly declared_at: string;
  readonly declared_by: string;
  readonly restaurant_id: string;
  readonly roles: readonly (Readonly<{
      readonly average_cost_per_hour_minor: number;
      readonly role_name: string;
    }>)[];
  readonly verbatim: string | null;
  readonly version: number;
  readonly via: "voice" | "text" | "panel";
}>
export type ParteLabourAveragesDeclareRequest = Readonly<{
  readonly expected_version: number;
  readonly roles: readonly (Readonly<{
      readonly average_cost_per_hour_minor: number;
      readonly role_name: string;
    }>)[];
  readonly verbatim: string | null;
  readonly via: "voice" | "text" | "panel";
}>
export type ParteLinkedProposal = Readonly<{
  readonly destination: "promotions" | "menu" | "dishes" | "inventory" | "order_history" | "orders" | "employees" | "cards" | "config" | "floor_plan";
  readonly form: string;
  readonly operation_key?: string | null;
  readonly parameters: Readonly<{ readonly [key: string]: string | number | boolean | null | readonly (string | number)[] }>;
  readonly path: string;
  readonly proposal_id?: string;
  readonly refs: readonly (ParteOpaqueRef)[];
}>
export type ParteMatterRead = Readonly<{
  readonly contract: "exylon.parte.matter@1.0";
  readonly events: readonly (Readonly<{
      readonly actor: Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly kind: "team";
      }> | Readonly<{
        readonly kind: "owner";
      }> | Readonly<{
        readonly kind: "code";
        readonly rule: string;
      }>;
      readonly at: string;
      readonly from_state: "open" | "planned" | "working" | "waiting" | "done" | "dropped" | "answered" | null;
      readonly kind: "opened" | "transition" | "plan" | "promise" | "late" | "wake" | "escalated" | "owner_act";
      readonly run_id: string | null;
      readonly seq: number;
      readonly to_state: "open" | "planned" | "working" | "waiting" | "done" | "dropped" | "answered" | null;
    }>)[];
  readonly events_omitted: number;
  readonly goal: Readonly<{
    readonly goal_id: string;
    readonly metrics: readonly (Readonly<{
        readonly direction: "at_least" | "at_most" | null;
        readonly final_actual: number | null;
        readonly measure: string | null;
        readonly measure_definition: string | null;
        readonly measure_label: string | null;
        readonly measure_version: number | null;
        readonly metric_no: number;
        readonly quoted_words: string;
        readonly result: "met" | "missed" | "unmeasured" | null;
        readonly scope: Readonly<{
          readonly kind: "house";
        }> | Readonly<{
          readonly kind: "slot";
          readonly slot: "lunch" | "dinner";
        }> | Readonly<{
          readonly kind: "weekday";
          readonly weekday: 1 | 2 | 3 | 4 | 5 | 6 | 7;
        }>;
        readonly state: "typed" | "needs_definition";
        readonly target: number | null;
        readonly unit: "eur_minor" | "covers" | "tables" | null;
      }>)[];
    readonly period: Readonly<{
      readonly from: string;
      readonly kind: "service_week" | "service_month";
      readonly to: string;
    }> | null;
    readonly version: number;
    readonly words: Readonly<{
      readonly said_at: string;
      readonly text: string;
      readonly via: "text" | "voice";
    }> | null;
  }> | null;
  readonly matter: Readonly<{
    readonly attempts_without_progress: number;
    readonly closed_at: string | null;
    readonly consulted_desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
    readonly escalation: number;
    readonly goal_id: string | null;
    readonly kind: "goal_pursuit" | "owner_request";
    readonly late_since: string | null;
    readonly lead_desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly line: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly live_run: Readonly<{
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly interrupt_reason: "budget" | "deadline" | "provider" | "fault" | null;
      readonly purpose: "intake" | "pursue" | "consult" | "read_back" | "answer_request" | "morning";
      readonly resume_at: string | null;
      readonly run_id: string;
      readonly started_at: string | null;
      readonly state: "due" | "running" | "interrupted";
    }> | null;
    readonly matter_id: string;
    readonly next_run_at: string | null;
    readonly opened_at: string;
    readonly outcome: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly plan: readonly (Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly due_on: string | null;
        readonly ref: Readonly<{
          readonly id: string;
          readonly kind: "operation" | "queue_item";
        }> | null;
        readonly state: "todo" | "doing" | "done" | "dropped";
        readonly step_key: string;
        readonly words: string | null;
      }>)[];
    readonly promise: Readonly<{
      readonly promised_on: string;
    }> | null;
    readonly promise_history: readonly (Readonly<{
        readonly because: Readonly<{
          readonly body: string;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly parts: readonly (string)[] | null;
          readonly text_id: string;
          readonly verified_at: string;
        }> | null;
        readonly promised_on: string;
        readonly set_at: string;
      }>)[];
    readonly runs_count: number;
    readonly state: "open" | "planned" | "working" | "waiting" | "done" | "dropped" | "answered";
    readonly title: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly version: number;
    readonly waiting_on: Readonly<{
      readonly item_id: string;
      readonly kind: "owner";
    }> | Readonly<{
      readonly kind: "fact";
      readonly measure_id: string;
      readonly until: string;
    }> | Readonly<{
      readonly kind: "date";
      readonly on: string;
    }> | null;
  }>;
  readonly plans: readonly (Readonly<{
      readonly components: readonly (Readonly<{
          readonly action_id: string;
          readonly describe: string;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly ends_at: string | null;
          readonly label: Readonly<{
            readonly body: string;
            readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
            readonly parts: readonly (string)[] | null;
            readonly text_id: string;
            readonly verified_at: string;
          }> | null;
          readonly money_at_risk_minor: number;
          readonly preview: Readonly<{
            readonly changes: readonly (Readonly<{
                readonly after: Readonly<{
                  readonly text: string;
                  readonly type: "text";
                }> | Readonly<{
                  readonly figure: Readonly<{
                    readonly period: Readonly<{
                      readonly kind: "standing";
                    }>;
                    readonly provenance: Readonly<{
                      readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                    }>;
                    readonly scale: number;
                    readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                    readonly value: number;
                  }>;
                  readonly type: "figure";
                }> | Readonly<{
                  readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
                  readonly type: "state";
                }> | Readonly<{
                  readonly date: string;
                  readonly type: "date";
                }> | Readonly<{
                  readonly at: string;
                  readonly type: "instant";
                }> | Readonly<{
                  readonly days: readonly (number)[];
                  readonly type: "weekdays";
                }> | Readonly<{
                  readonly type: "windows";
                  readonly windows: readonly (Readonly<{
                      readonly from_minute: number;
                      readonly until_minute: number;
                      readonly weekday: number;
                    }>)[];
                }> | Readonly<{
                  readonly items: readonly (string)[];
                  readonly type: "list";
                }> | Readonly<{
                  readonly at: "body" | number;
                  readonly core_text_id: string;
                  readonly sha256: string | null;
                  readonly type: "core_text";
                }> | Readonly<{
                  readonly rewards: readonly (Readonly<{
                      readonly count: number;
                      readonly tier: string;
                    }>)[];
                  readonly type: "rewards";
                }>;
                readonly before: Readonly<{
                  readonly text: string;
                  readonly type: "text";
                }> | Readonly<{
                  readonly figure: Readonly<{
                    readonly period: Readonly<{
                      readonly kind: "standing";
                    }>;
                    readonly provenance: Readonly<{
                      readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                    }>;
                    readonly scale: number;
                    readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                    readonly value: number;
                  }>;
                  readonly type: "figure";
                }> | Readonly<{
                  readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
                  readonly type: "state";
                }> | Readonly<{
                  readonly date: string;
                  readonly type: "date";
                }> | Readonly<{
                  readonly at: string;
                  readonly type: "instant";
                }> | Readonly<{
                  readonly days: readonly (number)[];
                  readonly type: "weekdays";
                }> | Readonly<{
                  readonly type: "windows";
                  readonly windows: readonly (Readonly<{
                      readonly from_minute: number;
                      readonly until_minute: number;
                      readonly weekday: number;
                    }>)[];
                }> | Readonly<{
                  readonly items: readonly (string)[];
                  readonly type: "list";
                }> | Readonly<{
                  readonly at: "body" | number;
                  readonly core_text_id: string;
                  readonly sha256: string | null;
                  readonly type: "core_text";
                }> | Readonly<{
                  readonly rewards: readonly (Readonly<{
                      readonly count: number;
                      readonly tier: string;
                    }>)[];
                  readonly type: "rewards";
                }> | null;
                readonly field: "dish_name" | "dish_description" | "dish_price" | "dish_position" | "dish_shown" | "dish_option_required" | "dish_daily_suggestion" | "dish_featured" | "promotion_state" | "promotion_name" | "promotion_percent" | "promotion_amount" | "promotion_max_per_diner" | "promotion_max_diners" | "promotion_minimum_bill" | "promotion_from" | "promotion_to" | "promotion_weekdays" | "promotion_hours" | "promotion_applies_to" | "review_reply" | "guest_question" | "reward_packs" | "win_back_pack" | "win_back_guests" | "opening_days" | "service_hours" | "bill_discount_cap" | "stock_minimum" | "order_quantity" | "notice_title" | "notice_body" | "trial_what" | "trial_procedure" | "trial_services" | "waste_plan_measures" | "service_staff";
                readonly guest_reads: boolean;
                readonly label: string;
                readonly part: string | null;
                readonly part_name: string | null;
                readonly printed: Readonly<{
                  readonly after: string;
                  readonly before: string | null;
                }>;
              }>)[];
            readonly contract: "exylon.parte.piece-preview@1.0";
            readonly ends_at: string | null;
            readonly exposure?: Readonly<{
              readonly basis: "own_sales" | "estimate";
              readonly days: number;
              readonly estimate_minor: number;
            }> | null;
            readonly money: Readonly<{
              readonly at_risk: Readonly<{
                readonly period: Readonly<{
                  readonly kind: "standing";
                }>;
                readonly provenance: Readonly<{
                  readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                }>;
                readonly scale: number;
                readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                readonly value: number;
              }>;
              readonly diners: Readonly<{
                readonly period: Readonly<{
                  readonly kind: "standing";
                }>;
                readonly provenance: Readonly<{
                  readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                }>;
                readonly scale: number;
                readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                readonly value: number;
              }> | null;
              readonly per_diner: Readonly<{
                readonly period: Readonly<{
                  readonly kind: "standing";
                }>;
                readonly provenance: Readonly<{
                  readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                }>;
                readonly scale: number;
                readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                readonly value: number;
              }> | null;
            }>;
            readonly object: Readonly<{
              readonly name: string | null;
              readonly object_id: string;
              readonly object_type: string;
              readonly owner: string;
            }>;
            readonly staffing?: Readonly<{
              readonly after: readonly (Readonly<{
                  readonly employment_id: string;
                  readonly role_name: string;
                }>)[];
              readonly before: readonly (Readonly<{
                  readonly employment_id: string;
                  readonly role_name: string;
                }>)[];
              readonly cost_per_service_minor: number | null;
              readonly direction: "add" | "remove";
              readonly forecast: Readonly<{
                readonly high_covers: number;
                readonly low_covers: number;
                readonly services_counted: number;
              }> | null;
              readonly history: readonly (Readonly<{
                  readonly covers: number | null;
                  readonly people: number | null;
                  readonly per_person: number | null;
                  readonly service_date: string;
                }>)[];
              readonly month_effect: Readonly<{
                readonly basis: "own_sales" | "estimate";
                readonly estimate_minor: number;
                readonly high_minor: number;
                readonly low_minor: number;
              }> | null;
              readonly person: Readonly<{
                readonly employment_id: string;
                readonly end: string;
                readonly role_name: string;
                readonly start: string;
              }>;
              readonly repeats: Readonly<{
                readonly until: string;
                readonly weekdays: readonly (number)[];
              }> | null;
              readonly service: Readonly<{
                readonly date: string;
                readonly role_name: string;
                readonly slot: "lunch" | "dinner";
              }>;
              readonly week_start: string;
            }> | null;
            readonly starts_at: string | null;
            readonly told: readonly ("guests" | "staff" | "public" | "owner")[];
            readonly tool_id: string;
            readonly undo: Readonly<{
              readonly window_hours: number;
            }> | null;
          }> | null;
          readonly runs_alone: boolean;
          readonly runs_at: string | null;
          readonly state: "planned" | "scheduled" | "applied" | "skipped" | "failed" | "undone" | "stopped";
          readonly tool_id: string;
        }>)[];
      readonly effects: readonly (Readonly<{
          readonly basis: readonly (string)[];
          readonly goal_id: string;
          readonly high: number;
          readonly low: number;
          readonly measure_label: string | null;
          readonly method: "desk_estimate";
          readonly metric_no: number;
          readonly stated_by: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly unit: "eur_minor" | "covers" | "tables";
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }>)[];
      readonly money_at_risk_minor: number;
      readonly objections: readonly (Readonly<{
          readonly answer: Readonly<{
            readonly body: string;
            readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
            readonly parts: readonly (string)[] | null;
            readonly text_id: string;
            readonly verified_at: string;
          }> | null;
          readonly kind: "alternative_explanation" | "cannibalisation" | "staff_impact" | "legal_risk" | "food_safety" | "money_beyond_budget" | "trial_conflict";
          readonly objection_id: string;
          readonly resolution: "changed" | "justified" | null;
          readonly rule: string | null;
          readonly state: "open" | "answered";
          readonly words: Readonly<{
            readonly body: string;
            readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
            readonly parts: readonly (string)[] | null;
            readonly text_id: string;
            readonly verified_at: string;
          }> | null;
        }>)[];
      readonly offer_expires_at: string;
      readonly operation_id: string;
      readonly purpose: Readonly<{
        readonly body: string;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly parts: readonly (string)[] | null;
        readonly text_id: string;
        readonly verified_at: string;
      }> | null;
      readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
      readonly version: number;
      readonly why: Readonly<{
        readonly body: string;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly parts: readonly (string)[] | null;
        readonly text_id: string;
        readonly verified_at: string;
      }> | null;
    }>)[];
  readonly plans_omitted: number;
  readonly read_at: string;
  readonly runs: readonly (Readonly<{
      readonly cancel_reason: "matter_closed" | "goal_withdrawn" | "superseded_by_owner_act" | "consult_abandoned" | "emergency_stop" | "morning_passed" | null;
      readonly created_at: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly ended_at: string | null;
      readonly interrupt_reason: "budget" | "deadline" | "provider" | "fault" | null;
      readonly outcome_to: "open" | "planned" | "working" | "waiting" | "done" | "dropped" | "answered" | null;
      readonly purpose: "intake" | "pursue" | "consult" | "read_back" | "answer_request" | "morning";
      readonly resume_at: string | null;
      readonly run_id: string;
      readonly state: "due" | "running" | "interrupted" | "ended" | "cancelled";
      readonly window: "night" | "day";
    }>)[];
  readonly runs_omitted: number;
  readonly service_date: string;
}>
export type ParteMattersRead = Readonly<{
  readonly contract: "exylon.parte.matters@1.0";
  readonly kind: "owner_request";
  readonly matters: readonly (ParteOwnerRequestView)[];
  readonly read_at: string;
  readonly service_date: string;
  readonly total: number;
  readonly truncated: boolean;
}>
export type ParteMissingDataAnswered = Readonly<{
  readonly answered_at: string;
  readonly contract: "exylon.parte.missing-data-answered@1.0";
  readonly question_id: string;
  readonly receipt_id: string;
  readonly state: "answered";
  readonly version: number;
}>
export type ParteMissingDataAnswerRequest = Readonly<{
  readonly expected_version: number;
  readonly value: Readonly<{
    readonly amount: number;
    readonly kind: "quantity";
    readonly unit?: "grams" | "millilitres" | "units";
  }> | Readonly<{
    readonly kind: "price";
    readonly price_per_base_minor: number;
  }> | Readonly<{
    readonly ingredient_id: string;
    readonly kind: "registry_ingredient";
  }> | Readonly<{
    readonly kind: "registry_ingredient";
    readonly name: string;
  }> | Readonly<{
    readonly amount: number;
    readonly kind: "minimum";
    readonly unit?: "grams" | "millilitres" | "units";
  }> | Readonly<{
    readonly cut_off: string | null;
    readonly delivery_weekdays: readonly (number)[];
    readonly kind: "supplier";
    readonly name: string;
    readonly phone: string | null;
  }> | Readonly<{
    readonly kind: "fixed_costs";
    readonly label: string;
    readonly monthly_minor: number;
  }> | Readonly<{
    readonly average_cost_per_hour_minor: number;
    readonly kind: "labour_average";
  }> | Readonly<{
    readonly kind: "house_fact";
    readonly text: string;
  }> | Readonly<{
    readonly date: string;
    readonly kind: "opening_exception";
    readonly open: boolean;
    readonly slots: readonly ("lunch" | "dinner")[] | null;
  }> | Readonly<{
    readonly iso_weekday: number;
    readonly kind: "opening_weekday";
    readonly open: boolean;
  }> | Readonly<{
    readonly iso_weekdays: readonly (number)[];
    readonly kind: "opening_weekdays";
  }> | Readonly<{
    readonly kind: "tax_rate";
    readonly rate_bps: 0 | 400 | 1000 | 2100;
  }> | Readonly<{
    readonly cause: "made_too_much" | "spoiled_in_storage" | "recording_error" | "unknown";
    readonly kind: "waste_cause";
  }> | Readonly<{
    readonly category_kind: "starter" | "main" | "dessert" | "drink" | "other";
    readonly kind: "category_kind";
  }> | Readonly<{
    readonly confirm: true;
    readonly kind: "restaurant_point";
  }>;
  readonly verbatim: string | null;
  readonly via: "panel" | "text" | "voice";
}>
export type ParteMoney = Readonly<{
  readonly currency: "EUR";
  readonly minor: number;
}>
export type ParteNotebook = Readonly<{
  readonly business_date: string;
  readonly contract: "exylon.parte.notebook@1.0";
  readonly edition_id: string;
  readonly edition_kind: "daily" | "weekly";
  readonly entries: readonly (ParteNotebookEntry)[];
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type ParteNotebookEntry = Readonly<{
  readonly case_id: string;
  readonly detail?: "source_unavailable" | "not_permitted" | "not_published" | "no_observations";
  readonly headline?: ParteNotebookHeadline;
  readonly operands?: ParteNotebookOperands;
  readonly read_at: string;
  readonly reason: "no_data" | "over_budget" | "r2_second_decision" | "below_threshold" | "duplicate" | "research_budget" | "no_source" | "not_permitted" | "compiler_fault" | "verification_held";
  readonly source_refs: readonly (ParteSourceRef)[];
  readonly threshold_value?: ParteNotebookThresholdValue;
}>
export type ParteNotebookHeadline = Readonly<{
  readonly rank: number;
  readonly text: string;
}>
export type ParteNotebookOperands = Readonly<{
  readonly threshold: string | null;
  readonly values: Readonly<{ readonly [key: string]: number }>;
}>
export type ParteNotebookRef = Readonly<{
  readonly case_id: string;
  readonly detail?: "source_unavailable" | "not_permitted" | "not_published" | "no_observations";
  readonly fault_code?: string;
  readonly operands?: ParteNotebookOperands;
  readonly reason: "no_data" | "over_budget" | "r2_second_decision" | "below_threshold" | "duplicate" | "research_budget" | "no_source" | "not_permitted" | "compiler_fault" | "verification_held";
}>
export type ParteNotebookThresholdValue = Readonly<{
  readonly calibration?: "laboratory" | "restaurant";
  readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
  readonly value: number;
}>
export type ParteOpaqueRef = Readonly<{
  readonly id: string;
  readonly kind: "check" | "table" | "order" | "stock_item" | "stock_batch" | "dish" | "metric" | "publication" | "review" | "edition" | "order_item" | "table_session" | "zone" | "category" | "section" | "bill_request" | "fulfillment_event" | "offer" | "employment" | "follow_up" | "offer_definition" | "modifier_option" | "external_fact" | "loyalty_tier";
}>
export type ParteOperation = Readonly<{
  readonly applied_count: number;
  readonly approval: Readonly<{
    readonly approved_at: string;
    readonly principal_id: string;
  }> | null;
  readonly asks_because: string | null;
  readonly chosen_option_key?: string | null;
  readonly components: readonly (Readonly<{
      readonly component_id: string;
      readonly describe: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly effect?: Readonly<{
        readonly checked_at: string;
        readonly differences: readonly (Readonly<{
            readonly expected: Readonly<{
              readonly text: string;
              readonly type: "text";
            }> | Readonly<{
              readonly figure: Readonly<{
                readonly period: Readonly<{
                  readonly kind: "standing";
                }>;
                readonly provenance: Readonly<{
                  readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                }>;
                readonly scale: number;
                readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                readonly value: number;
              }>;
              readonly type: "figure";
            }> | Readonly<{
              readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
              readonly type: "state";
            }> | Readonly<{
              readonly date: string;
              readonly type: "date";
            }> | Readonly<{
              readonly at: string;
              readonly type: "instant";
            }> | Readonly<{
              readonly days: readonly (number)[];
              readonly type: "weekdays";
            }> | Readonly<{
              readonly type: "windows";
              readonly windows: readonly (Readonly<{
                  readonly from_minute: number;
                  readonly until_minute: number;
                  readonly weekday: number;
                }>)[];
            }> | Readonly<{
              readonly items: readonly (string)[];
              readonly type: "list";
            }> | Readonly<{
              readonly at: "body" | number;
              readonly core_text_id: string;
              readonly sha256: string | null;
              readonly type: "core_text";
            }> | Readonly<{
              readonly rewards: readonly (Readonly<{
                  readonly count: number;
                  readonly tier: string;
                }>)[];
              readonly type: "rewards";
            }>;
            readonly field: "dish_name" | "dish_description" | "dish_price" | "dish_position" | "dish_shown" | "dish_option_required" | "dish_daily_suggestion" | "dish_featured" | "promotion_state" | "promotion_name" | "promotion_percent" | "promotion_amount" | "promotion_max_per_diner" | "promotion_max_diners" | "promotion_minimum_bill" | "promotion_from" | "promotion_to" | "promotion_weekdays" | "promotion_hours" | "promotion_applies_to" | "review_reply" | "guest_question" | "reward_packs" | "win_back_pack" | "win_back_guests" | "opening_days" | "service_hours" | "bill_discount_cap" | "stock_minimum" | "order_quantity" | "notice_title" | "notice_body" | "trial_what" | "trial_procedure" | "trial_services" | "waste_plan_measures" | "service_staff";
            readonly observed: Readonly<{
              readonly text: string;
              readonly type: "text";
            }> | Readonly<{
              readonly figure: Readonly<{
                readonly period: Readonly<{
                  readonly kind: "standing";
                }>;
                readonly provenance: Readonly<{
                  readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                }>;
                readonly scale: number;
                readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                readonly value: number;
              }>;
              readonly type: "figure";
            }> | Readonly<{
              readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
              readonly type: "state";
            }> | Readonly<{
              readonly date: string;
              readonly type: "date";
            }> | Readonly<{
              readonly at: string;
              readonly type: "instant";
            }> | Readonly<{
              readonly days: readonly (number)[];
              readonly type: "weekdays";
            }> | Readonly<{
              readonly type: "windows";
              readonly windows: readonly (Readonly<{
                  readonly from_minute: number;
                  readonly until_minute: number;
                  readonly weekday: number;
                }>)[];
            }> | Readonly<{
              readonly items: readonly (string)[];
              readonly type: "list";
            }> | Readonly<{
              readonly at: "body" | number;
              readonly core_text_id: string;
              readonly sha256: string | null;
              readonly type: "core_text";
            }> | Readonly<{
              readonly rewards: readonly (Readonly<{
                  readonly count: number;
                  readonly tier: string;
                }>)[];
              readonly type: "rewards";
            }> | null;
            readonly part: string | null;
          }>)[];
        readonly read: boolean;
      }> | null;
      readonly ends_at: string | null;
      readonly intent: Readonly<{
        readonly intent_hash: string;
        readonly intent_id: string;
      }> | null;
      readonly label?: string | null;
      readonly money_at_risk_minor: number;
      readonly note: string | null;
      readonly object: Readonly<{
        readonly object_id: string;
        readonly object_type: string;
        readonly owner: string;
      }>;
      readonly option_key?: string | null;
      readonly prerequisites: readonly (string)[];
      readonly preview?: Readonly<{
        readonly changes: readonly (Readonly<{
            readonly after: Readonly<{
              readonly text: string;
              readonly type: "text";
            }> | Readonly<{
              readonly figure: Readonly<{
                readonly period: Readonly<{
                  readonly kind: "standing";
                }>;
                readonly provenance: Readonly<{
                  readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                }>;
                readonly scale: number;
                readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                readonly value: number;
              }>;
              readonly type: "figure";
            }> | Readonly<{
              readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
              readonly type: "state";
            }> | Readonly<{
              readonly date: string;
              readonly type: "date";
            }> | Readonly<{
              readonly at: string;
              readonly type: "instant";
            }> | Readonly<{
              readonly days: readonly (number)[];
              readonly type: "weekdays";
            }> | Readonly<{
              readonly type: "windows";
              readonly windows: readonly (Readonly<{
                  readonly from_minute: number;
                  readonly until_minute: number;
                  readonly weekday: number;
                }>)[];
            }> | Readonly<{
              readonly items: readonly (string)[];
              readonly type: "list";
            }> | Readonly<{
              readonly at: "body" | number;
              readonly core_text_id: string;
              readonly sha256: string | null;
              readonly type: "core_text";
            }> | Readonly<{
              readonly rewards: readonly (Readonly<{
                  readonly count: number;
                  readonly tier: string;
                }>)[];
              readonly type: "rewards";
            }>;
            readonly before: Readonly<{
              readonly text: string;
              readonly type: "text";
            }> | Readonly<{
              readonly figure: Readonly<{
                readonly period: Readonly<{
                  readonly kind: "standing";
                }>;
                readonly provenance: Readonly<{
                  readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                }>;
                readonly scale: number;
                readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                readonly value: number;
              }>;
              readonly type: "figure";
            }> | Readonly<{
              readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
              readonly type: "state";
            }> | Readonly<{
              readonly date: string;
              readonly type: "date";
            }> | Readonly<{
              readonly at: string;
              readonly type: "instant";
            }> | Readonly<{
              readonly days: readonly (number)[];
              readonly type: "weekdays";
            }> | Readonly<{
              readonly type: "windows";
              readonly windows: readonly (Readonly<{
                  readonly from_minute: number;
                  readonly until_minute: number;
                  readonly weekday: number;
                }>)[];
            }> | Readonly<{
              readonly items: readonly (string)[];
              readonly type: "list";
            }> | Readonly<{
              readonly at: "body" | number;
              readonly core_text_id: string;
              readonly sha256: string | null;
              readonly type: "core_text";
            }> | Readonly<{
              readonly rewards: readonly (Readonly<{
                  readonly count: number;
                  readonly tier: string;
                }>)[];
              readonly type: "rewards";
            }> | null;
            readonly field: "dish_name" | "dish_description" | "dish_price" | "dish_position" | "dish_shown" | "dish_option_required" | "dish_daily_suggestion" | "dish_featured" | "promotion_state" | "promotion_name" | "promotion_percent" | "promotion_amount" | "promotion_max_per_diner" | "promotion_max_diners" | "promotion_minimum_bill" | "promotion_from" | "promotion_to" | "promotion_weekdays" | "promotion_hours" | "promotion_applies_to" | "review_reply" | "guest_question" | "reward_packs" | "win_back_pack" | "win_back_guests" | "opening_days" | "service_hours" | "bill_discount_cap" | "stock_minimum" | "order_quantity" | "notice_title" | "notice_body" | "trial_what" | "trial_procedure" | "trial_services" | "waste_plan_measures" | "service_staff";
            readonly guest_reads: boolean;
            readonly label: string;
            readonly part: string | null;
            readonly part_name: string | null;
            readonly printed: Readonly<{
              readonly after: string;
              readonly before: string | null;
            }>;
          }>)[];
        readonly contract: "exylon.parte.piece-preview@1.0";
        readonly ends_at: string | null;
        readonly exposure?: Readonly<{
          readonly basis: "own_sales" | "estimate";
          readonly days: number;
          readonly estimate_minor: number;
        }> | null;
        readonly money: Readonly<{
          readonly at_risk: Readonly<{
            readonly period: Readonly<{
              readonly kind: "standing";
            }>;
            readonly provenance: Readonly<{
              readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
            }>;
            readonly scale: number;
            readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
            readonly value: number;
          }>;
          readonly diners: Readonly<{
            readonly period: Readonly<{
              readonly kind: "standing";
            }>;
            readonly provenance: Readonly<{
              readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
            }>;
            readonly scale: number;
            readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
            readonly value: number;
          }> | null;
          readonly per_diner: Readonly<{
            readonly period: Readonly<{
              readonly kind: "standing";
            }>;
            readonly provenance: Readonly<{
              readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
            }>;
            readonly scale: number;
            readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
            readonly value: number;
          }> | null;
        }>;
        readonly object: Readonly<{
          readonly name: string | null;
          readonly object_id: string;
          readonly object_type: string;
          readonly owner: string;
        }>;
        readonly staffing?: Readonly<{
          readonly after: readonly (Readonly<{
              readonly employment_id: string;
              readonly role_name: string;
            }>)[];
          readonly before: readonly (Readonly<{
              readonly employment_id: string;
              readonly role_name: string;
            }>)[];
          readonly cost_per_service_minor: number | null;
          readonly direction: "add" | "remove";
          readonly forecast: Readonly<{
            readonly high_covers: number;
            readonly low_covers: number;
            readonly services_counted: number;
          }> | null;
          readonly history: readonly (Readonly<{
              readonly covers: number | null;
              readonly people: number | null;
              readonly per_person: number | null;
              readonly service_date: string;
            }>)[];
          readonly month_effect: Readonly<{
            readonly basis: "own_sales" | "estimate";
            readonly estimate_minor: number;
            readonly high_minor: number;
            readonly low_minor: number;
          }> | null;
          readonly person: Readonly<{
            readonly employment_id: string;
            readonly end: string;
            readonly role_name: string;
            readonly start: string;
          }>;
          readonly repeats: Readonly<{
            readonly until: string;
            readonly weekdays: readonly (number)[];
          }> | null;
          readonly service: Readonly<{
            readonly date: string;
            readonly role_name: string;
            readonly slot: "lunch" | "dinner";
          }>;
          readonly week_start: string;
        }> | null;
        readonly starts_at: string | null;
        readonly told: readonly ("guests" | "staff" | "public" | "owner")[];
        readonly tool_id: string;
        readonly undo: Readonly<{
          readonly window_hours: number;
        }> | null;
      }> | null;
      readonly receipt_id: string | null;
      readonly runs_alone: boolean;
      readonly runs_at: string | null;
      readonly skip_reason: "object_changed" | "prerequisite_not_applied" | "limit_exceeded" | "budget_exceeded" | "restaurant_stopped" | "platform_stopped" | "stopped_by_owner" | "expired" | "check_refused" | "command_refused" | "declined" | "not_chosen" | "nothing_to_say" | "not_delivered" | "withdrawn" | null;
      readonly state: "planned" | "scheduled" | "applied" | "skipped" | "failed" | "undone" | "stopped";
      readonly tool_id: string;
      readonly undo: Readonly<{
        readonly operation: string;
        readonly until: string;
      }> | null;
      readonly undone_at?: string | null;
      readonly version: number;
    }>)[];
  readonly contract: "exylon.parte.operation@1.0";
  readonly decided_at?: string | null;
  readonly decline_reason?: string | null;
  readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
  readonly encargo_id: string | null;
  readonly goal: string;
  readonly kind: "occasion" | "weekly_plan" | "daily_set" | "intent" | "seasonal" | "format_pilot" | "plan";
  readonly lead_desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
  readonly measurement: Readonly<{
    readonly describe: string;
    readonly result_on: string;
  }> | null;
  readonly money: Readonly<{
    readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly budget: Readonly<{
      readonly cap_minor: number;
      readonly spent_minor: number;
    }> | null;
    readonly max_minor: number;
  }> | null;
  readonly name: string | null;
  readonly offer_expires_at: string;
  readonly operation_id: string;
  readonly options?: readonly (Readonly<{
      readonly label: string;
      readonly month_effect?: Readonly<{
        readonly basis: "own_sales" | "estimate";
        readonly estimate_minor: number;
        readonly high_minor: number;
        readonly low_minor: number;
      }> | null;
      readonly option_key: string;
    }>)[];
  readonly owner_steps?: readonly (Readonly<{
      readonly option_key?: string | null;
      readonly reason: "contact" | "publish";
      readonly text: string;
    }>)[];
  readonly partial_choice: "keep_as_is" | "undo_applied" | null;
  readonly pieces_in_force?: Readonly<{
    readonly component_ids: readonly (string)[];
    readonly option_key: string | null;
  }>;
  readonly restaurant_id: string;
  readonly result: "applied" | "partly_applied" | "not_applied" | "undone" | null;
  readonly runs_alone: boolean;
  readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
  readonly version: number;
  readonly window: Readonly<{
    readonly from: string;
    readonly until: string;
  }>;
}>
export type ParteOperationApproveRequest = Readonly<{
  readonly choices?: Readonly<{
    readonly trial_date?: string;
    readonly without_companion_notice?: boolean;
  }>;
  readonly expected_version: number;
  readonly option_key?: string;
}>
export type ParteOperationDeclineRequest = Readonly<{
  readonly expected_version: number;
  readonly reason: string | null;
}>
export type ParteOperationResolveRequest = Readonly<{
  readonly choice: "keep_as_is" | "undo_applied";
  readonly expected_version: number;
}>
export type ParteOwnerRequestView = Readonly<{
  readonly carried: readonly (Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly purpose: "matter_title" | "matter_line" | "matter_plan" | "goal_question" | "plan_purpose" | "plan_why" | "component_label" | "staff_notice" | "guest_text" | "queue_line" | "tradeoff_options" | "objection" | "objection_answer" | "consult_question" | "consult_answer" | "read_back" | "lesson" | "request_answer";
      readonly text_id: string;
      readonly written_at: string;
    }>)[];
  readonly matter: Readonly<{
    readonly attempts_without_progress: number;
    readonly closed_at: string | null;
    readonly consulted_desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
    readonly escalation: number;
    readonly goal_id: string | null;
    readonly kind: "goal_pursuit" | "owner_request";
    readonly late_since: string | null;
    readonly lead_desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly line: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly live_run: Readonly<{
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly interrupt_reason: "budget" | "deadline" | "provider" | "fault" | null;
      readonly purpose: "intake" | "pursue" | "consult" | "read_back" | "answer_request" | "morning";
      readonly resume_at: string | null;
      readonly run_id: string;
      readonly started_at: string | null;
      readonly state: "due" | "running" | "interrupted";
    }> | null;
    readonly matter_id: string;
    readonly next_run_at: string | null;
    readonly opened_at: string;
    readonly outcome: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly plan: readonly (Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly due_on: string | null;
        readonly ref: Readonly<{
          readonly id: string;
          readonly kind: "operation" | "queue_item";
        }> | null;
        readonly state: "todo" | "doing" | "done" | "dropped";
        readonly step_key: string;
        readonly words: string | null;
      }>)[];
    readonly promise: Readonly<{
      readonly promised_on: string;
    }> | null;
    readonly promise_history: readonly (Readonly<{
        readonly because: Readonly<{
          readonly body: string;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly parts: readonly (string)[] | null;
          readonly text_id: string;
          readonly verified_at: string;
        }> | null;
        readonly promised_on: string;
        readonly set_at: string;
      }>)[];
    readonly runs_count: number;
    readonly state: "open" | "planned" | "working" | "waiting" | "done" | "dropped" | "answered";
    readonly title: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly version: number;
    readonly waiting_on: Readonly<{
      readonly item_id: string;
      readonly kind: "owner";
    }> | Readonly<{
      readonly kind: "fact";
      readonly measure_id: string;
      readonly until: string;
    }> | Readonly<{
      readonly kind: "date";
      readonly on: string;
    }> | null;
  }>;
  readonly promise: Readonly<{
    readonly first_promised_on: string | null;
    readonly moved_because: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly promised_on: string | null;
  }>;
  readonly request: Readonly<{
    readonly said_at: string;
    readonly via: "text" | "voice";
    readonly words: string;
  }>;
}>
export type PartePacto = Readonly<{
  readonly authorship: Readonly<{
    readonly by_line?: readonly (Readonly<{
        readonly by: "owner" | "team" | "default" | "to_confirm";
        readonly line_id: string;
      }>)[];
    readonly default: number;
    readonly owner: number;
    readonly team: number;
    readonly to_confirm: number;
  }>;
  readonly contract: "exylon.parte.pacto@1.0";
  readonly goal_history: readonly (Readonly<{
      readonly author: Readonly<{
        readonly kind: "owner";
        readonly principal_id: string;
        readonly via: "voice" | "text" | "panel" | "ahora_no";
      }> | Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly evidence: readonly (string)[];
        readonly kind: "team";
      }> | Readonly<{
        readonly kind: "default";
      }>;
      readonly body: Readonly<{
        readonly facet: "cuisine" | "price_position" | "style" | "known_for" | "kitchen_strength" | "equipment_limit";
        readonly kind: "identity";
        readonly section: "quienes_somos";
        readonly text: string;
      }> | Readonly<{
        readonly confirmation: "confirmed" | "awaiting_confirmation";
        readonly kind: "red_line";
        readonly section: "lo_que_nunca";
      }> | Readonly<{
        readonly context?: string | null;
        readonly kind: "mandate";
        readonly level: 0 | 1 | 2 | 3;
        readonly section: "sin_preguntarme";
        readonly tool_id: string;
      }> | Readonly<{
        readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly kind: "budget";
        readonly monthly_cap_minor: number;
        readonly section: "sin_preguntarme";
      }> | Readonly<{
        readonly formats: readonly ("text" | "audio")[];
        readonly interruptions: Readonly<{
          readonly channels: readonly ("panel_inbox" | "web_push")[];
          readonly max_per_service: number;
        }>;
        readonly kind: "delivery";
        readonly length: "short" | "normal";
        readonly paper_at: string;
        readonly section: "como_me_lo_contais";
      }> | Readonly<{
        readonly horizon: "month" | "season" | "year";
        readonly kind: "goal";
        readonly measure: Readonly<{
          readonly measure_id: string;
          readonly target: number;
          readonly unit: string;
        }> | null;
        readonly period: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
        readonly section: "que_queremos";
        readonly text: string;
      }>;
      readonly confirmed_at?: string | null;
      readonly covers: Readonly<{
        readonly kind: "restaurant";
      }> | Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly kind: "area";
      }> | Readonly<{
        readonly kind: "tool";
        readonly label: string | null;
      }> | Readonly<{
        readonly kind: "object";
        readonly label: string | null;
      }>;
      readonly line_id: string;
      readonly origin: Readonly<{
        readonly kind: "manager_preference";
        readonly preference_id: string;
      }> | null;
      readonly quoted: Readonly<{
        readonly last_on: string | null;
        readonly last_where: "paper" | null;
        readonly times: number;
      }>;
      readonly recording_ref?: string | null;
      readonly said_at: string;
      readonly scope: Readonly<{
        readonly kind: "restaurant";
      }> | Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly kind: "area";
      }> | Readonly<{
        readonly kind: "tool";
        readonly tool_id: string;
      }> | Readonly<{
        readonly id: string;
        readonly kind: "object";
        readonly object_type: string;
        readonly owner: string;
      }>;
      readonly status: "inferred" | "confirmed" | "retired";
      readonly supersedes: string | null;
      readonly valid_from: string;
      readonly valid_until: string | null;
      readonly verbatim: string | null;
      readonly version: number;
    }>)[];
  readonly house?: Readonly<{
    readonly address?: string | null;
    readonly food_cost_target?: Readonly<{
      readonly bps: number;
      readonly source: "pacto_goal" | "default";
    }>;
    readonly kitchen_hours?: Readonly<{
      readonly days: readonly (Readonly<{
          readonly declared_until_minute: number | null;
          readonly iso_weekday: number;
          readonly observed_days: number;
          readonly observed_last_minute: number | null;
          readonly slot: "lunch" | "dinner";
        }>)[];
      readonly declared: boolean;
      readonly observed_from: string | null;
    }> | null;
    readonly seats: Readonly<{
      readonly terrace: number | null;
      readonly total: number;
    }> | null;
    readonly ticket_average: Readonly<{
      readonly from: string;
      readonly minor: number;
      readonly paid_checks: number;
      readonly until: string;
    }> | null;
  }>;
  readonly lines: readonly (Readonly<{
      readonly author: Readonly<{
        readonly kind: "owner";
        readonly principal_id: string;
        readonly via: "voice" | "text" | "panel" | "ahora_no";
      }> | Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly evidence: readonly (string)[];
        readonly kind: "team";
      }> | Readonly<{
        readonly kind: "default";
      }>;
      readonly body: Readonly<{
        readonly facet: "cuisine" | "price_position" | "style" | "known_for" | "kitchen_strength" | "equipment_limit";
        readonly kind: "identity";
        readonly section: "quienes_somos";
        readonly text: string;
      }> | Readonly<{
        readonly confirmation: "confirmed" | "awaiting_confirmation";
        readonly kind: "red_line";
        readonly section: "lo_que_nunca";
      }> | Readonly<{
        readonly context?: string | null;
        readonly kind: "mandate";
        readonly level: 0 | 1 | 2 | 3;
        readonly section: "sin_preguntarme";
        readonly tool_id: string;
      }> | Readonly<{
        readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly kind: "budget";
        readonly monthly_cap_minor: number;
        readonly section: "sin_preguntarme";
      }> | Readonly<{
        readonly formats: readonly ("text" | "audio")[];
        readonly interruptions: Readonly<{
          readonly channels: readonly ("panel_inbox" | "web_push")[];
          readonly max_per_service: number;
        }>;
        readonly kind: "delivery";
        readonly length: "short" | "normal";
        readonly paper_at: string;
        readonly section: "como_me_lo_contais";
      }> | Readonly<{
        readonly horizon: "month" | "season" | "year";
        readonly kind: "goal";
        readonly measure: Readonly<{
          readonly measure_id: string;
          readonly target: number;
          readonly unit: string;
        }> | null;
        readonly period: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
        readonly section: "que_queremos";
        readonly text: string;
      }>;
      readonly confirmed_at?: string | null;
      readonly covers: Readonly<{
        readonly kind: "restaurant";
      }> | Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly kind: "area";
      }> | Readonly<{
        readonly kind: "tool";
        readonly label: string | null;
      }> | Readonly<{
        readonly kind: "object";
        readonly label: string | null;
      }>;
      readonly line_id: string;
      readonly origin: Readonly<{
        readonly kind: "manager_preference";
        readonly preference_id: string;
      }> | null;
      readonly quoted: Readonly<{
        readonly last_on: string | null;
        readonly last_where: "paper" | null;
        readonly times: number;
      }>;
      readonly recording_ref?: string | null;
      readonly said_at: string;
      readonly scope: Readonly<{
        readonly kind: "restaurant";
      }> | Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly kind: "area";
      }> | Readonly<{
        readonly kind: "tool";
        readonly tool_id: string;
      }> | Readonly<{
        readonly id: string;
        readonly kind: "object";
        readonly object_type: string;
        readonly owner: string;
      }>;
      readonly status: "inferred" | "confirmed" | "retired";
      readonly supersedes: string | null;
      readonly valid_from: string;
      readonly valid_until: string | null;
      readonly verbatim: string | null;
      readonly version: number;
    }>)[];
  readonly restaurant_id: string;
  readonly stop: ParteTeamStop;
  readonly version: number;
}>
export type PartePactoLineConfirmRequest = Readonly<{
  readonly expected_version: number;
  readonly line_id: string;
  readonly valid_until?: string | null;
}>
export type PartePactoLinePutRequest = Readonly<{
  readonly body: Readonly<{
    readonly facet: "cuisine" | "price_position" | "style" | "known_for" | "kitchen_strength" | "equipment_limit";
    readonly kind: "identity";
    readonly section: "quienes_somos";
    readonly text: string;
  }> | Readonly<{
    readonly confirmation: "confirmed" | "awaiting_confirmation";
    readonly kind: "red_line";
    readonly section: "lo_que_nunca";
  }> | Readonly<{
    readonly context?: string | null;
    readonly kind: "mandate";
    readonly level: 0 | 1 | 2 | 3;
    readonly section: "sin_preguntarme";
    readonly tool_id: string;
  }> | Readonly<{
    readonly area: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly kind: "budget";
    readonly monthly_cap_minor: number;
    readonly section: "sin_preguntarme";
  }> | Readonly<{
    readonly formats: readonly ("text" | "audio")[];
    readonly interruptions: Readonly<{
      readonly channels: readonly ("panel_inbox" | "web_push")[];
      readonly max_per_service: number;
    }>;
    readonly kind: "delivery";
    readonly length: "short" | "normal";
    readonly paper_at: string;
    readonly section: "como_me_lo_contais";
  }>;
  readonly expected_version: number;
  readonly line_id: string;
  readonly scope: Readonly<{
    readonly kind: "restaurant";
  }> | Readonly<{
    readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly kind: "area";
  }> | Readonly<{
    readonly kind: "tool";
    readonly tool_id: string;
  }> | Readonly<{
    readonly id: string;
    readonly kind: "object";
    readonly object_type: string;
    readonly owner: string;
  }>;
  readonly supersedes: string | null;
  readonly valid_from: string | null;
  readonly valid_until: string | null;
  readonly verbatim: string | null;
  readonly via: "voice" | "text" | "panel";
}>
export type PartePactoLineRetireRequest = Readonly<{
  readonly expected_version: number;
  readonly line_id: string;
}>
export type PartePageNotes = Readonly<{
  readonly contract: "exylon.parte.page-notes@1.0";
  readonly notes: readonly (Readonly<{
      readonly as_of: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly facts: readonly (string)[];
      readonly marked: string | null;
      readonly note_id: string;
      readonly slot: string;
      readonly slot_key: string | null;
      readonly text: string;
      readonly valid_until: string;
      readonly written_at: string;
    }>)[];
  readonly page: "radar" | "reputacion" | "tu_equipo" | "la_semana" | "costes" | "consejo" | "balance";
  readonly paper_day: string;
  readonly restaurant_id: string;
  readonly sections?: readonly ("numbers" | "team" | "lessons" | "plan")[];
}>
export type PartePendiente = Readonly<{
  readonly card: Readonly<{
    readonly body: string;
    readonly case_id: string;
    readonly headline: string;
    readonly kind: "info" | "decision" | "setup";
    readonly signature: string | null;
  }>;
  readonly case_id: string;
  readonly change_mark: Readonly<{
    readonly field: "name" | "price" | "description" | "photo" | "recipe" | "category";
    readonly on: string;
  }> | null;
  readonly dismissable: boolean;
  readonly dismissed_on: string | null;
  readonly edition_kind: "daily" | "weekly";
  readonly fact_fingerprint: string;
  readonly last_seen_edition_id: string;
  readonly last_seen_on: string;
  readonly opened_edition_id: string;
  readonly opened_on: string;
  readonly pendiente_id: string;
  readonly resolved_on: string | null;
  readonly state: "open" | "resolved" | "dismissed";
  readonly version: number;
}>
export type PartePendienteDismissRequest = Readonly<{
  readonly expected_version: number;
}>
export type PartePendientes = Readonly<{
  readonly continuing: readonly (PartePendiente)[];
  readonly contract: "exylon.parte.pendientes@1.0";
  readonly dismissed_count: number;
  readonly enabled: boolean;
  readonly latest_edition: Readonly<{
    readonly edition_id: string;
    readonly publication_date: string;
  }> | null;
  readonly limit: number;
  readonly next_offset: number | null;
  readonly offset: number;
  readonly open_total: number;
  readonly pendientes: readonly (PartePendiente)[];
  readonly resolved: readonly (PartePendiente)[];
  readonly restaurant_id: string;
}>
export type PartePendientesQuery = Readonly<{
  readonly limit?: string;
  readonly offset?: string;
}>
export type PartePeriod = Readonly<{
  readonly from: string | null;
  readonly kind: "business_day" | "last_7_days" | "prior_same_weekdays" | "same_weekday_last_week" | "week_to_date" | "at_run" | "configuration" | "closed_week" | "previous_week" | "trailing_days" | "month_to_date" | "previous_month" | "calendar_week" | "local_days" | "table_session";
  readonly until: string | null;
}>
export type PartePersonWithdrawal = Readonly<{
  readonly contract: "exylon.parte.person-withdrawal@1.0";
  readonly editions: number;
  readonly withdrawal_id: string;
  readonly withdrawn_at: string;
}>
export type PartePersonWithdrawalRequest = Readonly<{
  readonly employment_id: string;
}>
export type PartePostDraftDecisionRequest = Readonly<{
  readonly expected_version: number;
}>
export type PartePrepPlan = Readonly<{
  readonly contract: "exylon.parte.prep-plan@1.0";
  readonly expires_at: string | null;
  readonly forecast: Readonly<{
    readonly contract: "exylon.parte.demand-forecast@1.0";
    readonly issued_on: string;
    readonly method: string;
  }> | null;
  readonly late: boolean;
  readonly lines: readonly (Readonly<{
      readonly label: string;
      readonly note: string | null;
      readonly on_hand: number | null;
      readonly portions: Readonly<{
        readonly estimate: number;
        readonly lower: number;
        readonly upper: number;
      }>;
      readonly prep_quantity: Readonly<{
        readonly amount: number;
        readonly unit: "kilograms" | "litres" | "units";
      }> | null;
      readonly subject: Readonly<{
        readonly dish_id: string;
        readonly kind: "dish";
      }> | Readonly<{
        readonly kind: "stock_item";
        readonly stock_item_id: string;
      }>;
    }>)[];
  readonly mode: "shadow" | "live" | null;
  readonly outcome: string | null;
  readonly recorded_at: string | null;
  readonly restaurant_id: string;
  readonly service_date: string;
  readonly status: "available" | "no_data";
}>
export type PartePushKey = Readonly<{
  readonly contract: "exylon.parte.push-key@1.0";
  readonly vapid_public_key: string | null;
}>
export type PartePushSubscriptionRegisterRequest = Readonly<{
  readonly device_label: string | null;
  readonly endpoint: string;
  readonly keys: Readonly<{
    readonly auth: string;
    readonly p256dh: string;
  }>;
  readonly subscription_id: string;
}>
export type PartePushSubscriptionRemoveRequest = Readonly<Record<never, never>>
export type PartePushSubscriptionResult = Readonly<{
  readonly contract: "exylon.parte.push-subscription@1.0";
  readonly restaurant_devices: number;
  readonly status: "subscribed" | "removed";
  readonly subscription_id: string;
}>
export type ParteQueueAnswerRequest = Readonly<{
  readonly act: "choose";
  readonly expected_version: number;
  readonly option_key: string;
}> | Readonly<{
  readonly act: "words";
  readonly expected_version: number;
  readonly words: string;
}>
export type ParteQueueItemView = Readonly<{
  readonly desks: Readonly<{
    readonly consulted: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
    readonly lead: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
  }>;
  readonly goal: Readonly<{
    readonly goal_id: string;
    readonly metrics: readonly (Readonly<{
        readonly direction: "at_least" | "at_most" | null;
        readonly final_actual: number | null;
        readonly measure: string | null;
        readonly measure_definition: string | null;
        readonly measure_label: string | null;
        readonly measure_version: number | null;
        readonly metric_no: number;
        readonly quoted_words: string;
        readonly result: "met" | "missed" | "unmeasured" | null;
        readonly scope: Readonly<{
          readonly kind: "house";
        }> | Readonly<{
          readonly kind: "slot";
          readonly slot: "lunch" | "dinner";
        }> | Readonly<{
          readonly kind: "weekday";
          readonly weekday: 1 | 2 | 3 | 4 | 5 | 6 | 7;
        }>;
        readonly state: "typed" | "needs_definition";
        readonly target: number | null;
        readonly unit: "eur_minor" | "covers" | "tables" | null;
      }>)[];
    readonly period: Readonly<{
      readonly from: string;
      readonly kind: "service_week" | "service_month";
      readonly to: string;
    }> | null;
    readonly version: number;
    readonly words: Readonly<{
      readonly said_at: string;
      readonly text: string;
      readonly via: "text" | "voice";
    }> | null;
  }> | null;
  readonly item: Readonly<{
    readonly answer: Readonly<{
      readonly act: "confirm" | "correct" | "decline" | "approve" | "choose" | "words" | "data";
      readonly at: string;
      readonly by: string;
      readonly option_key: string | null;
      readonly words: string | null;
    }> | null;
    readonly answered_at: string | null;
    readonly asked_at: string | null;
    readonly asked_via: "hoy" | "digest" | "push" | null;
    readonly created_at: string;
    readonly created_by_run: string | null;
    readonly deadline_at: string;
    readonly expired_at: string | null;
    readonly goal_id: string | null;
    readonly item_id: string;
    readonly kind: "goal_confirmation" | "goal_question" | "decision" | "tradeoff" | "blocker" | "data_question";
    readonly line_text_id: string | null;
    readonly matter_id: string;
    readonly metric_no: number | null;
    readonly operation_id: string | null;
    readonly options: readonly (Readonly<{
        readonly operation_id: string | null;
        readonly option_key: string;
        readonly part_no: number;
      }>)[];
    readonly restaurant_id: string;
    readonly state: "open" | "asked" | "answered" | "expired" | "withdrawn";
    readonly told_at: string | null;
    readonly value: Readonly<{
      readonly high: number;
      readonly low: number;
      readonly unit: "eur_minor" | "covers" | "tables";
    }> | null;
    readonly version: number;
    readonly withdrawn_at: string | null;
    readonly withdrawn_because: Readonly<{
      readonly kind: "replaced" | "superseded_plan" | "plan_withdrawn" | "goal_withdrawn" | "matter_closed";
      readonly ref: string | null;
    }> | null;
  }>;
  readonly line: Readonly<{
    readonly body: string;
    readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
    readonly parts: readonly (string)[] | null;
    readonly text_id: string;
    readonly verified_at: string;
  }> | null;
  readonly options: readonly (Readonly<{
      readonly operation_id: string | null;
      readonly option_key: string;
      readonly words: string | null;
    }>)[];
  readonly plan: Readonly<{
    readonly components: readonly (Readonly<{
        readonly action_id: string;
        readonly describe: string;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly ends_at: string | null;
        readonly label: Readonly<{
          readonly body: string;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly parts: readonly (string)[] | null;
          readonly text_id: string;
          readonly verified_at: string;
        }> | null;
        readonly money_at_risk_minor: number;
        readonly preview: Readonly<{
          readonly changes: readonly (Readonly<{
              readonly after: Readonly<{
                readonly text: string;
                readonly type: "text";
              }> | Readonly<{
                readonly figure: Readonly<{
                  readonly period: Readonly<{
                    readonly kind: "standing";
                  }>;
                  readonly provenance: Readonly<{
                    readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                  }>;
                  readonly scale: number;
                  readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                  readonly value: number;
                }>;
                readonly type: "figure";
              }> | Readonly<{
                readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
                readonly type: "state";
              }> | Readonly<{
                readonly date: string;
                readonly type: "date";
              }> | Readonly<{
                readonly at: string;
                readonly type: "instant";
              }> | Readonly<{
                readonly days: readonly (number)[];
                readonly type: "weekdays";
              }> | Readonly<{
                readonly type: "windows";
                readonly windows: readonly (Readonly<{
                    readonly from_minute: number;
                    readonly until_minute: number;
                    readonly weekday: number;
                  }>)[];
              }> | Readonly<{
                readonly items: readonly (string)[];
                readonly type: "list";
              }> | Readonly<{
                readonly at: "body" | number;
                readonly core_text_id: string;
                readonly sha256: string | null;
                readonly type: "core_text";
              }> | Readonly<{
                readonly rewards: readonly (Readonly<{
                    readonly count: number;
                    readonly tier: string;
                  }>)[];
                readonly type: "rewards";
              }>;
              readonly before: Readonly<{
                readonly text: string;
                readonly type: "text";
              }> | Readonly<{
                readonly figure: Readonly<{
                  readonly period: Readonly<{
                    readonly kind: "standing";
                  }>;
                  readonly provenance: Readonly<{
                    readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
                  }>;
                  readonly scale: number;
                  readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
                  readonly value: number;
                }>;
                readonly type: "figure";
              }> | Readonly<{
                readonly state: "shown" | "hidden" | "required" | "optional" | "on" | "off" | "active" | "paused";
                readonly type: "state";
              }> | Readonly<{
                readonly date: string;
                readonly type: "date";
              }> | Readonly<{
                readonly at: string;
                readonly type: "instant";
              }> | Readonly<{
                readonly days: readonly (number)[];
                readonly type: "weekdays";
              }> | Readonly<{
                readonly type: "windows";
                readonly windows: readonly (Readonly<{
                    readonly from_minute: number;
                    readonly until_minute: number;
                    readonly weekday: number;
                  }>)[];
              }> | Readonly<{
                readonly items: readonly (string)[];
                readonly type: "list";
              }> | Readonly<{
                readonly at: "body" | number;
                readonly core_text_id: string;
                readonly sha256: string | null;
                readonly type: "core_text";
              }> | Readonly<{
                readonly rewards: readonly (Readonly<{
                    readonly count: number;
                    readonly tier: string;
                  }>)[];
                readonly type: "rewards";
              }> | null;
              readonly field: "dish_name" | "dish_description" | "dish_price" | "dish_position" | "dish_shown" | "dish_option_required" | "dish_daily_suggestion" | "dish_featured" | "promotion_state" | "promotion_name" | "promotion_percent" | "promotion_amount" | "promotion_max_per_diner" | "promotion_max_diners" | "promotion_minimum_bill" | "promotion_from" | "promotion_to" | "promotion_weekdays" | "promotion_hours" | "promotion_applies_to" | "review_reply" | "guest_question" | "reward_packs" | "win_back_pack" | "win_back_guests" | "opening_days" | "service_hours" | "bill_discount_cap" | "stock_minimum" | "order_quantity" | "notice_title" | "notice_body" | "trial_what" | "trial_procedure" | "trial_services" | "waste_plan_measures" | "service_staff";
              readonly guest_reads: boolean;
              readonly label: string;
              readonly part: string | null;
              readonly part_name: string | null;
              readonly printed: Readonly<{
                readonly after: string;
                readonly before: string | null;
              }>;
            }>)[];
          readonly contract: "exylon.parte.piece-preview@1.0";
          readonly ends_at: string | null;
          readonly exposure?: Readonly<{
            readonly basis: "own_sales" | "estimate";
            readonly days: number;
            readonly estimate_minor: number;
          }> | null;
          readonly money: Readonly<{
            readonly at_risk: Readonly<{
              readonly period: Readonly<{
                readonly kind: "standing";
              }>;
              readonly provenance: Readonly<{
                readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
              }>;
              readonly scale: number;
              readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
              readonly value: number;
            }>;
            readonly diners: Readonly<{
              readonly period: Readonly<{
                readonly kind: "standing";
              }>;
              readonly provenance: Readonly<{
                readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
              }>;
              readonly scale: number;
              readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
              readonly value: number;
            }> | null;
            readonly per_diner: Readonly<{
              readonly period: Readonly<{
                readonly kind: "standing";
              }>;
              readonly provenance: Readonly<{
                readonly source: "recorded" | "delivery_note" | "typed_receipt" | "reference_list" | "estimate" | "forecast" | "configuration" | "external";
              }>;
              readonly scale: number;
              readonly unit: "eur" | "percent" | "rating_5" | "count" | "people" | "unit" | "mg" | "g" | "kg" | "ml" | "l" | "ms" | "s" | "min" | "h" | "day";
              readonly value: number;
            }> | null;
          }>;
          readonly object: Readonly<{
            readonly name: string | null;
            readonly object_id: string;
            readonly object_type: string;
            readonly owner: string;
          }>;
          readonly staffing?: Readonly<{
            readonly after: readonly (Readonly<{
                readonly employment_id: string;
                readonly role_name: string;
              }>)[];
            readonly before: readonly (Readonly<{
                readonly employment_id: string;
                readonly role_name: string;
              }>)[];
            readonly cost_per_service_minor: number | null;
            readonly direction: "add" | "remove";
            readonly forecast: Readonly<{
              readonly high_covers: number;
              readonly low_covers: number;
              readonly services_counted: number;
            }> | null;
            readonly history: readonly (Readonly<{
                readonly covers: number | null;
                readonly people: number | null;
                readonly per_person: number | null;
                readonly service_date: string;
              }>)[];
            readonly month_effect: Readonly<{
              readonly basis: "own_sales" | "estimate";
              readonly estimate_minor: number;
              readonly high_minor: number;
              readonly low_minor: number;
            }> | null;
            readonly person: Readonly<{
              readonly employment_id: string;
              readonly end: string;
              readonly role_name: string;
              readonly start: string;
            }>;
            readonly repeats: Readonly<{
              readonly until: string;
              readonly weekdays: readonly (number)[];
            }> | null;
            readonly service: Readonly<{
              readonly date: string;
              readonly role_name: string;
              readonly slot: "lunch" | "dinner";
            }>;
            readonly week_start: string;
          }> | null;
          readonly starts_at: string | null;
          readonly told: readonly ("guests" | "staff" | "public" | "owner")[];
          readonly tool_id: string;
          readonly undo: Readonly<{
            readonly window_hours: number;
          }> | null;
        }> | null;
        readonly runs_alone: boolean;
        readonly runs_at: string | null;
        readonly state: "planned" | "scheduled" | "applied" | "skipped" | "failed" | "undone" | "stopped";
        readonly tool_id: string;
      }>)[];
    readonly effects: readonly (Readonly<{
        readonly basis: readonly (string)[];
        readonly goal_id: string;
        readonly high: number;
        readonly low: number;
        readonly measure_label: string | null;
        readonly method: "desk_estimate";
        readonly metric_no: number;
        readonly stated_by: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly unit: "eur_minor" | "covers" | "tables";
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly money_at_risk_minor: number;
    readonly objections: readonly (Readonly<{
        readonly answer: Readonly<{
          readonly body: string;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly parts: readonly (string)[] | null;
          readonly text_id: string;
          readonly verified_at: string;
        }> | null;
        readonly kind: "alternative_explanation" | "cannibalisation" | "staff_impact" | "legal_risk" | "food_safety" | "money_beyond_budget" | "trial_conflict";
        readonly objection_id: string;
        readonly resolution: "changed" | "justified" | null;
        readonly rule: string | null;
        readonly state: "open" | "answered";
        readonly words: Readonly<{
          readonly body: string;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly parts: readonly (string)[] | null;
          readonly text_id: string;
          readonly verified_at: string;
        }> | null;
      }>)[];
    readonly offer_expires_at: string;
    readonly operation_id: string;
    readonly purpose: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
    readonly state: "proposed" | "approved" | "declined" | "expired" | "finished" | "withdrawn";
    readonly version: number;
    readonly why: Readonly<{
      readonly body: string;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly parts: readonly (string)[] | null;
      readonly text_id: string;
      readonly verified_at: string;
    }> | null;
  }> | null;
}>
export type ParteQueueRead = Readonly<{
  readonly asked: number;
  readonly contract: "exylon.parte.queue@1.0";
  readonly items: readonly (ParteQueueItemView)[];
  readonly read_at: string;
  readonly service_date: string;
  readonly truncated: boolean;
}>
export type ParteRecipeBatch = Readonly<{
  readonly carta_dishes: number;
  readonly contract: "exylon.parte.recipe-batch@1.0";
  readonly dishes: readonly (Readonly<{
      readonly allergens: Readonly<{
        readonly contains: readonly (string)[];
        readonly unknown: readonly (string)[];
      }>;
      readonly cost_minor: number | null;
      readonly dish_id: string;
      readonly draft_version: number;
      readonly lines: readonly (Readonly<{
          readonly line_cost_minor: number | null;
          readonly master_ingredient_id: string;
          readonly name: string;
          readonly price_base: "kilogram" | "litre" | "unit";
          readonly price_per_base_minor: number | null;
          readonly price_source: "delivery_note" | "market_estimate" | "owner" | null;
          readonly quantity: Readonly<{
            readonly amount: number;
            readonly unit: "grams" | "millilitres" | "units";
          }>;
        }>)[];
      readonly name: string;
      readonly portion: string | null;
      readonly unresolved: readonly (string)[];
    }>)[];
  readonly missing_ingredient: readonly (Readonly<{
      readonly allergens: Readonly<{
        readonly contains: readonly (string)[];
        readonly unknown: readonly (string)[];
      }>;
      readonly cost_minor: number | null;
      readonly dish_id: string;
      readonly draft_version: number;
      readonly lines: readonly (Readonly<{
          readonly line_cost_minor: number | null;
          readonly master_ingredient_id: string;
          readonly name: string;
          readonly price_base: "kilogram" | "litre" | "unit";
          readonly price_per_base_minor: number | null;
          readonly price_source: "delivery_note" | "market_estimate" | "owner" | null;
          readonly quantity: Readonly<{
            readonly amount: number;
            readonly unit: "grams" | "millilitres" | "units";
          }>;
        }>)[];
      readonly name: string;
      readonly portion: string | null;
      readonly unresolved: readonly (string)[];
    }>)[];
  readonly more: number;
  readonly priced_on: string;
  readonly publication_version: number | null;
  readonly restaurant_id: string;
}>
export type ParteRecipeBatchConfirmRequest = Readonly<{
  readonly items: readonly (Readonly<{
      readonly dish_id: string;
      readonly draft_version: number;
    }>)[];
  readonly publication_version: number;
}>
export type ParteRecipeBatchCorrection = Readonly<{
  readonly confirmable: boolean;
  readonly contract: "exylon.parte.recipe-batch-correction@1.0";
  readonly dish_id: string;
  readonly draft_version: number;
  readonly restaurant_id: string;
  readonly unresolved: readonly (string)[];
}>
export type ParteRecipeBatchCorrectRequest = Readonly<{
  readonly dish_id: string;
  readonly draft_version: number;
  readonly lines: readonly (Readonly<{
      readonly amount: number;
      readonly ingredient: string;
      readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning";
      readonly unit: "g" | "ml" | "unit";
    }>)[];
  readonly portion: string | null;
}>
export type ParteRecipeBatchReceipt = Readonly<{
  readonly action: "confirm" | "withdraw" | "undo";
  readonly catalog_receipt: Readonly<Record<string, unknown>> | null;
  readonly change_id: string | null;
  readonly contract: "exylon.parte.recipe-batch-receipt@1.0";
  readonly dishes: readonly (Readonly<{
      readonly allergen_codes: readonly (string)[];
      readonly dish_id: string;
      readonly recipe_lines: number | null;
    }>)[];
  readonly publication_version: number | null;
  readonly restaurant_id: string;
}>
export type ParteRecipeBatchUndoRequest = Readonly<{
  readonly catalog_receipt: Readonly<Record<string, unknown>>;
}>
export type ParteRecipeBatchWithdrawRequest = Readonly<{
  readonly items: readonly (Readonly<{
      readonly dish_id: string;
      readonly draft_version: number;
    }>)[];
}>
export type ParteReplyDraftSetAsideRequest = Readonly<{
  readonly expected_version: number;
  readonly reason: "will_answer_myself" | "not_this_day" | "disagree_with_data" | "ask_later";
}>
export type ParteReputation = Readonly<{
  readonly last_7_days: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteReviewAggregate;
  }> | ParteAbsent;
  readonly survey: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteSurveyAggregate;
  }> | ParteAbsent;
  readonly yesterday: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteReviewAggregate;
  }> | ParteAbsent;
}>
export type ParteReputationDrafts = Readonly<{
  readonly contract: "exylon.parte.reputation-drafts@2.0";
  readonly lapsed_pack: Readonly<{
    readonly declined: Readonly<{
      readonly on: string;
      readonly reason: "not_now" | "not_this_object" | "not_this_weekday" | "ask_later" | "disagree_with_data" | "already_handled" | "too_costly" | null;
    }> | null;
    readonly intent_id: string | null;
    readonly lapsed: number | null;
    readonly status: "none" | "proposed" | "declined" | "accepted" | "withheld";
    readonly terms: Readonly<{
      readonly cap_minor: number;
      readonly reward: string;
    }> | null;
  }>;
  readonly post_drafts: readonly (Readonly<{
      readonly about: string | null;
      readonly channel: "instagram" | "google_update";
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly dish_id: string | null;
      readonly draft_id: string;
      readonly drafted_at: string;
      readonly for_date: string | null;
      readonly grounded_on: readonly (string)[];
      readonly operation: Readonly<{
        readonly component_id: string;
        readonly operation_id: string;
      }> | null;
      readonly photo_direction: string | null;
      readonly state: "draft" | "declared_published" | "withdrawn";
      readonly text: string;
      readonly version: number;
    }>)[];
  readonly replies_28_days: Readonly<{
    readonly alone: number;
    readonly answered: number;
    readonly awaiting: number;
    readonly by_owner: number;
    readonly failed: number;
    readonly reviews: number;
    readonly sending: number;
    readonly undone_by_owner: number;
  }>;
  readonly replies_alone: boolean;
  readonly reply_cases: readonly (Readonly<{
      readonly alone: Readonly<{
        readonly applied_receipt_id: string;
        readonly checked: string;
        readonly level: 2 | 3;
        readonly probation: Readonly<{
          readonly index: number;
          readonly of: 5;
        }> | null;
        readonly published_at: string;
        readonly why_alone: string;
      }> | null;
      readonly asks_because: string | null;
      readonly checks: readonly (Readonly<{
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
          readonly label: string;
          readonly text: string;
        }>)[];
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly drafted_at: string | null;
      readonly facts_added: boolean;
      readonly guarantee: string | null;
      readonly published: Readonly<{
        readonly by: "team" | "owner";
        readonly confirmed_at: string | null;
        readonly sent_at: string;
      }> | null;
      readonly reason: "not_attempted_budget" | "not_attempted_privacy" | "not_attempted_stopped" | "model_failed" | "text_refused" | "low_review" | "complains" | "dish_not_on_carta" | "first_week" | "level_asks" | "team_stopped" | "check_refused" | "publication_refused" | "returned_after_set_aside" | "owner_published" | "owner_replaced" | "answered_on_google" | "owner_undid" | "owner_removed" | "google_refused" | "connection_lost" | "review_edited" | "review_removed" | null;
      readonly returned_on: string | null;
      readonly review_edited_at: string | null;
      readonly review_id: string;
      readonly review_version: number;
      readonly says: string;
      readonly set_aside: Readonly<{
        readonly on: string;
        readonly reason: "will_answer_myself" | "not_this_day" | "disagree_with_data" | "ask_later";
        readonly until: string | null;
      }> | null;
      readonly stars: number;
      readonly state: "facts_pending" | "drafted" | "waiting_owner" | "sent" | "confirmed" | "send_failed" | "undone" | "set_aside_until" | "could_not_draft";
      readonly text: string | null;
      readonly version: number;
      readonly with_desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
    }>)[];
  readonly restaurant_id: string;
  readonly signature: string;
}>
export type ParteRequestOpenRequest = Readonly<{
  readonly request_id: string;
  readonly via: "text" | "voice";
  readonly words: string;
}>
export type ParteReviewAggregate = Readonly<{
  readonly average_tenths: number;
  readonly count: number;
}>
export type ParteRotaProposal = Readonly<{
  readonly contract: "exylon.parte.rota-proposal@1.0";
  readonly cost: Readonly<{
    readonly by_role: readonly (Readonly<{
        readonly cost_minor: number;
        readonly minutes: number;
        readonly role_name: string;
      }>)[];
    readonly status: "available";
    readonly total_minor: number;
  }> | Readonly<{
    readonly missing: "labour_averages";
    readonly roles_without_average: readonly (string)[];
    readonly status: "missing";
  }>;
  readonly forecast: Readonly<{
    readonly contract: "exylon.parte.demand-forecast@1.0";
    readonly covers: readonly (Readonly<{
        readonly covers: Readonly<{
          readonly estimate: number;
          readonly lower: number;
          readonly upper: number;
        }>;
        readonly date: string;
        readonly slot: "lunch" | "dinner";
      }>)[];
    readonly issued_on: string;
  }> | null;
  readonly not_yet: Readonly<{
    readonly from: string | null;
    readonly grade: "declared" | "first_days" | "same_weekday" | "confirmed" | null;
    readonly needs: readonly ("opening_days" | "first_week" | "usual_people")[];
  }> | null;
  readonly people: readonly (Readonly<{
      readonly display_name: string;
      readonly employment_id: string;
      readonly planned_minutes: number;
      readonly role_name: string;
      readonly usual: Readonly<{
        readonly days: readonly (Readonly<{
            readonly end: string;
            readonly iso_weekday: number;
            readonly start: string;
            readonly weeks_worked: number;
          }>)[];
        readonly weekly_minutes: number | null;
        readonly weeks_observed: number;
      }>;
    }>)[];
  readonly prepared_on: string | null;
  readonly proposal_id: string | null;
  readonly publish_operation: "workforce.rota.publish.v1";
  readonly published: Readonly<{
    readonly cost: Readonly<{
      readonly by_role: readonly (Readonly<{
          readonly cost_minor: number;
          readonly minutes: number;
          readonly role_name: string;
        }>)[];
      readonly status: "available";
      readonly total_minor: number;
    }> | Readonly<{
      readonly missing: "labour_averages";
      readonly roles_without_average: readonly (string)[];
      readonly status: "missing";
    }>;
    readonly rota_version: number;
    readonly services: readonly (Readonly<{
        readonly covered: boolean;
        readonly date: string;
        readonly needed: number;
        readonly planned: number;
        readonly roles: readonly (Readonly<{
            readonly needed: number;
            readonly planned: number;
            readonly role_name: string;
          }>)[];
        readonly slot: "lunch" | "dinner";
      }>)[];
  }> | null;
  readonly replaces_version: number | null;
  readonly restaurant_id: string;
  readonly rules_check: Readonly<{
    readonly ok: boolean;
    readonly services: readonly (Readonly<{
        readonly covered: boolean;
        readonly date: string;
        readonly needed: number;
        readonly planned: number;
        readonly slot: "lunch" | "dinner";
      }>)[];
    readonly violations: readonly (Readonly<{
        readonly dates: readonly (string)[];
        readonly detail: string;
        readonly employment_id: string;
        readonly rule: "rest_between_shifts" | "daily_maximum" | "weekly_maximum" | "days_off" | "overlap" | "shape";
      }>)[];
  }>;
  readonly shifts: readonly (Readonly<{
      readonly date: string;
      readonly employment_id: string;
      readonly end: string;
      readonly role_name: string;
      readonly shift_id: string;
      readonly start: string;
    }>)[];
  readonly shortfall: Readonly<{
    readonly gaps: readonly (Readonly<{
        readonly date: string;
        readonly needed: number;
        readonly planned: number;
        readonly role_name: string;
        readonly slot: "lunch" | "dinner";
      }>)[];
    readonly objection: Readonly<{
      readonly by: "intervencion";
      readonly kind: "coverage_short";
      readonly objects_to: "publish_with_gaps";
      readonly people_short: number;
      readonly services_short: number;
    }>;
    readonly options: readonly (Readonly<{
        readonly accepts: readonly (Readonly<{
            readonly date: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly changes: readonly (Readonly<{
            readonly change: "added" | "extended";
            readonly date: string;
            readonly employment_id: string;
            readonly end: string;
            readonly role_name: string;
            readonly shift_id: string;
            readonly start: string;
          }>)[];
        readonly covers: readonly (Readonly<{
            readonly date: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly kind: "extend_hours";
      }> | Readonly<{
        readonly accepts: readonly (Readonly<{
            readonly date: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly gaps: readonly (Readonly<{
            readonly date: string;
            readonly needed: number;
            readonly planned: number;
            readonly role_name: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly kind: "ask_extra_staff";
      }> | Readonly<{
        readonly accepts: readonly (Readonly<{
            readonly date: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly kind: "reduce_service";
      }> | Readonly<{
        readonly accepts: readonly (Readonly<{
            readonly date: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly kind: "publish_with_gaps";
      }>)[];
    readonly services: readonly (Readonly<{
        readonly date: string;
        readonly needed: number;
        readonly planned: number;
        readonly roles: readonly (Readonly<{
            readonly needed: number;
            readonly planned: number;
            readonly role_name: string;
          }>)[];
        readonly slot: "lunch" | "dinner";
      }>)[];
  }> | null;
  readonly staffing: readonly (Readonly<{
      readonly change: "added" | "removed" | "short";
      readonly date: string;
      readonly expected_covers: number | null;
      readonly explained: string | null;
      readonly normal_covers: number | null;
      readonly role_name: string;
      readonly slot: "lunch" | "dinner";
    }>)[];
  readonly status: "proposed" | "published" | "declined" | "superseded" | "none";
  readonly ways_out: Readonly<{
    readonly decision: Readonly<{
      readonly acted_at: string | null;
      readonly chosen: "ask_extra_staff" | "extend_hours" | "reduce_service" | null;
      readonly item_id: string;
      readonly returns_at: string | null;
      readonly state: "offered" | "held" | "decided" | "done" | "returned" | "superseded" | "withdrawn" | "expired";
      readonly version: number;
      readonly words: string | null;
    }> | null;
    readonly max_weekly_minutes: number;
    readonly minutes_short: number;
    readonly options: readonly (Readonly<{
        readonly accepts: readonly (Readonly<{
            readonly date: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly cost: Readonly<{
          readonly estimate: true;
          readonly kind: "labour" | "sales";
          readonly minor: number;
          readonly status: "available";
        }> | Readonly<{
          readonly items: readonly (string)[];
          readonly missing: "labour_averages" | "service_sales";
          readonly status: "missing";
        }>;
        readonly covers_after: number;
        readonly covers_given_up: number | null;
        readonly extras: readonly (Readonly<{
            readonly minutes: number;
            readonly role_name: string;
            readonly services: readonly (Readonly<{
                readonly date: string;
                readonly slot: "lunch" | "dinner";
              }>)[];
          }>)[];
        readonly hours: readonly (Readonly<{
            readonly added: number;
            readonly display_name: string | null;
            readonly employment_id: string | null;
            readonly extra: number | null;
            readonly minutes: number;
            readonly role_name: string;
          }>)[];
        readonly kind: "ask_extra_staff" | "extend_hours" | "reduce_service";
        readonly month_effect: Readonly<{
          readonly basis: "own_sales" | "estimate";
          readonly estimate_minor: number;
          readonly high_minor: number;
          readonly low_minor: number;
        }> | null;
        readonly option_key: "ask_extra_staff" | "extend_hours" | "reduce_service";
        readonly people: readonly (Readonly<{
            readonly added_minutes: number;
            readonly display_name: string;
            readonly employment_id: string;
            readonly role_name: string;
          }>)[];
        readonly services: readonly (Readonly<{
            readonly date: string;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly week_cost_minor: number | null;
      }>)[];
    readonly services_total: number;
  }> | null;
  readonly week_start: string;
}>
export type ParteRotaProposalQuery = Readonly<{
  readonly week_start?: string;
}>
export type ParteScheduledActionStopped = Readonly<{
  readonly action_id: string;
  readonly contract: "exylon.parte.scheduled-action-stopped@1.0";
  readonly dependants_skipped: readonly (string)[];
  readonly stopped_at: string;
  readonly version: number;
}>
export type ParteScheduledActionStopRequest = Readonly<{
  readonly expected_version: number;
}>
export type ParteSetupWaiting = Readonly<{
  readonly case_id: string;
  readonly text: string;
  readonly waiting_since: string;
}>
export type ParteSourceRef = Readonly<{
  readonly operation: string;
  readonly reader: "L1" | "L5" | "L8" | "L18" | "L32" | "L33" | "L43" | "L2" | "L9" | "L11" | "L12" | "L13" | "L14" | "L17" | "L19" | "L20" | "L23" | "L24" | "L26" | "L27" | "L28" | "L29" | "L34" | "L35" | "L38" | "L39" | "L41" | "L42" | "L30" | "L31" | "L36" | "L37" | "EP-N04" | "C1" | "C2" | "C2-service" | "C2-occupancy" | "L2-latch" | "L43-expired" | "L13-weeks" | "L13-reorder" | "L26-annulled" | "L11-paid" | "L2-changes" | "L40" | "L12-prep" | "L17-notices" | "L38-dishes" | "L12-start" | "L9-late" | "L12-station" | "L9-remakes" | "L12-dish" | "L41-notices" | "L12-bill" | "L28-reviews" | "L13-voids" | "L43-usage" | "L43-unused" | "L11-dessert" | "L5-axes" | "L38-coupons" | "L1-weekdays" | "L15" | "L39-overrides" | "L17-pace" | "L17-delivered" | "L17-cooks" | "L32-placement" | "L17-people" | "L38-invitations" | "L38-mentions" | "L38-praise" | "L40-return" | "L38-question" | "L13-costing" | "L33-control" | "L11-floor" | "L39-load" | "L13-ideas" | "L20-sensory" | "L45";
  readonly refs: readonly (ParteOpaqueRef)[];
}>
export type ParteSurveyAggregate = Readonly<{
  readonly responses: number;
  readonly subratings: readonly (Readonly<{
      readonly average_tenths: number;
      readonly count: number;
      readonly key: string;
    }>)[];
}>
export type ParteTeam = Readonly<{
  readonly as_of: string;
  readonly contract: "exylon.parte.team@1.0";
  readonly desks: readonly (Readonly<{
      readonly area: string;
      readonly avatar: "dir" | "sara" | "lucia" | "nuria" | "brais" | "mateo" | "iker" | "rosa" | "pablo" | "carla" | "leo" | "elena" | "ines";
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
      readonly how_it_goes: readonly (Readonly<{
          readonly contribution_minor?: Readonly<{
            readonly estimate: number;
            readonly high: number;
            readonly low: number;
          }>;
          readonly key: string;
          readonly label: string;
          readonly note: string | null;
          readonly of: number | null;
          readonly previous?: Readonly<{
            readonly coverage?: Readonly<{
              readonly days: number;
              readonly of: number;
            }>;
            readonly value: number;
            readonly window: Readonly<{
              readonly from: string;
              readonly to: string;
            }> | null;
          }>;
          readonly reason: "no_data_yet" | "source_unavailable" | "not_measured" | "withheld" | null;
          readonly series?: Readonly<{
            readonly coverage: Readonly<{
              readonly expected: number;
              readonly observed: number;
              readonly state: "complete" | "partial" | "young";
            }>;
            readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
            readonly normal: Readonly<{
              readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
              readonly estimate: boolean;
              readonly hi: number;
              readonly lo: number;
              readonly mid: number | null;
              readonly observed: number;
              readonly window?: Readonly<{
                readonly from: string;
                readonly to: string;
              }>;
            }> | null;
            readonly of: string;
            readonly points: readonly (Readonly<{
                readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
                readonly days?: Readonly<{
                  readonly observed: number;
                  readonly of: number;
                }>;
                readonly part?: string;
                readonly partial?: true;
                readonly partial_reason?: "running" | "opened" | "uncounted";
                readonly range?: Readonly<{
                  readonly hi: number;
                  readonly lo: number;
                }>;
                readonly value: number | null;
                readonly window: Readonly<{
                  readonly from: string;
                  readonly to: string;
                }>;
              }>)[];
            readonly previous?: readonly (Readonly<{
                readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
                readonly days?: Readonly<{
                  readonly observed: number;
                  readonly of: number;
                }>;
                readonly part?: string;
                readonly partial?: true;
                readonly partial_reason?: "running" | "opened" | "uncounted";
                readonly range?: Readonly<{
                  readonly hi: number;
                  readonly lo: number;
                }>;
                readonly value: number | null;
                readonly window: Readonly<{
                  readonly from: string;
                  readonly to: string;
                }>;
              }>)[];
            readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
          }>;
          readonly status: "available" | "no_data";
          readonly unit: "count" | "minor" | "bps" | "minutes" | "days";
          readonly value: number | null;
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }> | null;
        }>)[];
      readonly mission: string;
      readonly money_desk: boolean;
      readonly name: string | null;
      readonly presentation: "card" | "compact";
    }>)[];
  readonly restaurant_id: string;
}>
export type ParteTeamActionUndoRequest = Readonly<{
  readonly expected_version: number;
}>
export type ParteTeamActionUndoRequested = Readonly<{
  readonly action_id: string;
  readonly contract: "exylon.parte.team-action-undo-requested@1.0";
  readonly receipt_id: string | null;
  readonly requested_at: string;
  readonly state: "requested" | "undone";
  readonly undo_operation: string;
  readonly undo_until: string;
  readonly version: number;
}>
export type ParteTeamStop = Readonly<{
  readonly changed_at: string | null;
  readonly contract: "exylon.parte.team-stop@1.0";
  readonly platform_stopped: boolean;
  readonly promotion_pause_stopped: boolean;
  readonly restaurant_stopped: boolean;
  readonly stop_version: number;
}>
export type ParteTeamStopSetRequest = Readonly<{
  readonly expected_version: number;
  readonly stopped: boolean;
}>
export type ParteVoiceAnswer = Readonly<{
  readonly business_date: string;
  readonly contract: "exylon.parte.voice-answer@1.0";
  readonly execution: "none";
  readonly outcomes: readonly (Readonly<{
      readonly card_id: string;
      readonly kind: "accept";
      readonly quote: string;
    }> | Readonly<{
      readonly card_id: string;
      readonly kind: "decline";
      readonly quote: string;
      readonly reason: string | null;
    }> | Readonly<{
      readonly card_id: string | null;
      readonly kind: "red_line";
      readonly quote: string;
      readonly text: string;
    }> | Readonly<{
      readonly kind: "encargo";
      readonly quote: string;
      readonly text: string;
    }> | Readonly<{
      readonly kind: "data_answer";
      readonly question_id: string;
      readonly quote: string;
      readonly value: Readonly<{
        readonly amount: number;
        readonly kind: "quantity";
        readonly unit?: "grams" | "millilitres" | "units";
      }> | Readonly<{
        readonly kind: "price";
        readonly price_per_base_minor: number;
      }> | Readonly<{
        readonly ingredient_id: string;
        readonly kind: "registry_ingredient";
      }> | Readonly<{
        readonly kind: "registry_ingredient";
        readonly name: string;
      }> | Readonly<{
        readonly amount: number;
        readonly kind: "minimum";
        readonly unit?: "grams" | "millilitres" | "units";
      }> | Readonly<{
        readonly cut_off: string | null;
        readonly delivery_weekdays: readonly (number)[];
        readonly kind: "supplier";
        readonly name: string;
        readonly phone: string | null;
      }> | Readonly<{
        readonly kind: "fixed_costs";
        readonly label: string;
        readonly monthly_minor: number;
      }> | Readonly<{
        readonly average_cost_per_hour_minor: number;
        readonly kind: "labour_average";
      }> | Readonly<{
        readonly kind: "house_fact";
        readonly text: string;
      }> | Readonly<{
        readonly date: string;
        readonly kind: "opening_exception";
        readonly open: boolean;
        readonly slots: readonly ("lunch" | "dinner")[] | null;
      }> | Readonly<{
        readonly iso_weekday: number;
        readonly kind: "opening_weekday";
        readonly open: boolean;
      }> | Readonly<{
        readonly iso_weekdays: readonly (number)[];
        readonly kind: "opening_weekdays";
      }> | Readonly<{
        readonly kind: "tax_rate";
        readonly rate_bps: 0 | 400 | 1000 | 2100;
      }> | Readonly<{
        readonly cause: "made_too_much" | "spoiled_in_storage" | "recording_error" | "unknown";
        readonly kind: "waste_cause";
      }> | Readonly<{
        readonly category_kind: "starter" | "main" | "dessert" | "drink" | "other";
        readonly kind: "category_kind";
      }> | Readonly<{
        readonly confirm: true;
        readonly kind: "restaurant_point";
      }>;
    }>)[];
  readonly status: "read" | "transcribed_only" | "unavailable";
  readonly stopped_because: string | null;
  readonly transcript: string | null;
  readonly unclear: readonly (string)[];
  readonly voice_answer_id: string;
}>
export type ParteVoiceAnswerSubmitRequest = Readonly<{
  readonly business_date: string;
  readonly mime_type: "audio/webm" | "audio/ogg" | "audio/mp4" | "audio/mpeg" | "audio/wav";
  readonly voice_answer_id: string;
}>
export type ParteWeekFigure = Readonly<{
  readonly reading: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: ParteMoney | number;
  }> | ParteAbsent;
  readonly slot: string;
}>
export type ParteWeeklyEditionContent = Readonly<{
  readonly c2_references?: Readonly<{
    readonly hourly?: Readonly<{
      readonly candidate_dates: number;
      readonly cohort: Readonly<{
        readonly registry_version: string;
        readonly restaurant_id: string;
        readonly timezone: "Europe/Madrid";
      }>;
      readonly computed_at: string;
      readonly contract: "exylon.insights.el-parte-comparable-services@1.0";
      readonly excluded: readonly (Readonly<{
          readonly business_date: string;
          readonly reason: string;
        }>)[];
      readonly metric: "net_cash_minor_per_local_hour";
      readonly population: "operating_days_with_complete_fresh_coverage";
      readonly references: Readonly<{
        readonly status: "available";
        readonly value: readonly (Readonly<{
            readonly currency: "EUR";
            readonly local_hour: number;
            readonly reference: Readonly<{
              readonly centre: number | null;
              readonly day_type: "weekday_without_holiday_calendar";
              readonly excluded: readonly (Readonly<{
                  readonly business_date: string;
                  readonly reason: string;
                }>)[];
              readonly formula_version: "comparable-services-median-range@1";
              readonly input_fingerprint: string;
              readonly missing_for_weekday: number;
              readonly n: number;
              readonly observations: readonly (Readonly<{
                  readonly business_date: string;
                  readonly value: number;
                }>)[];
              readonly parameters: Readonly<{
                readonly history_days: 120;
                readonly max_observations: 10;
                readonly provisional: true;
                readonly second_extremes_from: 6;
                readonly weekday_group_minimum: 4;
                readonly weekday_minimum: 3;
              }>;
              readonly range: Readonly<{
                readonly high: number;
                readonly low: number;
                readonly rule: "min_max" | "second_min_second_max";
              }> | null;
              readonly specificity: "weekday" | "weekday_group" | "none";
              readonly target_date: string;
              readonly target_iso_weekday: number;
            }>;
          }>)[];
      }> | Readonly<{
        readonly reason: "no_operating_days";
        readonly status: "no_data";
      }>;
      readonly registry_version: string;
      readonly restaurant_id: string;
      readonly slot_kind: "local_hour";
      readonly target_date: string;
      readonly tenant_id: string;
      readonly timezone: "Europe/Madrid";
      readonly unit: "money_minor";
    }>;
    readonly occupancy?: Readonly<{
      readonly candidate_dates: number;
      readonly contract: "exylon.insights.parte-occupancy-reference@1.0";
      readonly definition: "observed_table_time_over_available_table_time" | "open_bill_guests_over_published_seats";
      readonly observed_at: string;
      readonly owner_read_calls: number;
      readonly population: "service_slots_with_observed_table_sessions" | "service_slots_with_recorded_open_bill_participant_intervals";
      readonly restaurant_id: string;
      readonly slots: readonly (Readonly<{
          readonly local_start: string;
          readonly reference: Readonly<{
            readonly centre: number | null;
            readonly day_type: "weekday_without_holiday_calendar";
            readonly excluded: readonly (Readonly<{
                readonly business_date: string;
                readonly reason: string;
              }>)[];
            readonly formula_version: "comparable-services-median-range@1";
            readonly input_fingerprint: string;
            readonly missing_for_weekday: number;
            readonly n: number;
            readonly observations: readonly (Readonly<{
                readonly business_date: string;
                readonly value: number;
              }>)[];
            readonly parameters: Readonly<{
              readonly history_days: 120;
              readonly max_observations: 10;
              readonly provisional: true;
              readonly second_extremes_from: 6;
              readonly weekday_group_minimum: 4;
              readonly weekday_minimum: 3;
            }>;
            readonly range: Readonly<{
              readonly high: number;
              readonly low: number;
              readonly rule: "min_max" | "second_min_second_max";
            }> | null;
            readonly specificity: "weekday" | "weekday_group" | "none";
            readonly target_date: string;
            readonly target_iso_weekday: number;
          }>;
          readonly target: Readonly<{
            readonly occupancy_basis_points: number | null;
            readonly reason: "window_open" | "slot_not_observed" | "coverage_incomplete" | null;
            readonly status: "available" | "no_data";
          }>;
        }>)[];
      readonly target_date: string;
      readonly tenant_id: string;
      readonly timezone: "Europe/Madrid";
      readonly unit: "basis_points";
    }>;
    readonly service_slots?: Readonly<{
      readonly candidate_dates: number;
      readonly contract: "exylon.insights.el-parte-service-slots@1.0";
      readonly currency: "EUR";
      readonly observed_at: string;
      readonly population: "services_with_recorded_in_app_paid_checks";
      readonly references: readonly (Readonly<{
          readonly kind: "lunch" | "dinner";
          readonly metric: "in_app_paid_checks" | "collected_minor" | "net_sales_minor";
          readonly reference: Readonly<{
            readonly centre: number | null;
            readonly day_type: "weekday_without_holiday_calendar";
            readonly excluded: readonly (Readonly<{
                readonly business_date: string;
                readonly reason: string;
              }>)[];
            readonly formula_version: "comparable-services-median-range@1";
            readonly input_fingerprint: string;
            readonly missing_for_weekday: number;
            readonly n: number;
            readonly observations: readonly (Readonly<{
                readonly business_date: string;
                readonly value: number;
              }>)[];
            readonly parameters: Readonly<{
              readonly history_days: 120;
              readonly max_observations: 10;
              readonly provisional: true;
              readonly second_extremes_from: 6;
              readonly weekday_group_minimum: 4;
              readonly weekday_minimum: 3;
            }>;
            readonly range: Readonly<{
              readonly high: number;
              readonly low: number;
              readonly rule: "min_max" | "second_min_second_max";
            }> | null;
            readonly specificity: "weekday" | "weekday_group" | "none";
            readonly target_date: string;
            readonly target_iso_weekday: number;
          }>;
        }>)[];
      readonly registry_version: string;
      readonly restaurant_id: string;
      readonly slots: readonly (Readonly<{
          readonly collected_minor: number | null;
          readonly from: string;
          readonly from_hour: number;
          readonly in_app_paid_checks: number | null;
          readonly kind: "lunch" | "dinner";
          readonly net_sales_minor: number | null;
          readonly reason: "coverage_incomplete" | "window_open" | "projection_lagging" | "hourly_count_mismatch" | "slot_not_observed" | null;
          readonly refunded_minor: number | null;
          readonly status: "available" | "no_data";
          readonly until: string;
          readonly until_hour: number;
        }>)[];
      readonly target_date: string;
      readonly tenant_id: string;
      readonly timezone: "Europe/Madrid";
    }>;
  }>;
  readonly cards: readonly (ParteCard)[];
  readonly degraded: readonly (ParteDegradedSource)[];
  readonly kind?: "weekly";
  readonly notebook: readonly (ParteNotebookRef)[];
  readonly sections?: ParteBalanceSections;
  readonly setup: readonly (ParteCard)[];
  readonly setup_more?: readonly (ParteSetupWaiting)[];
  readonly week: Readonly<{
    readonly figures: readonly (ParteWeekFigure)[];
    readonly from_date: string;
    readonly series?: ParteBalanceWeekSeries;
    readonly until_date: string;
  }>;
}>
export type ParteWhatIfClosedWeekday = Readonly<{
  readonly contract: "exylon.parte.what-if-closed-weekday@1.0";
  readonly days: readonly (Readonly<{
      readonly paid_checks: number;
      readonly paid_total_minor: number;
      readonly service_date: string;
    }>)[];
  readonly iso_weekday: number;
  readonly kind: "closed_weekday";
  readonly limits: readonly (string)[];
  readonly reason: "no_counted_day" | null;
  readonly recorded: Readonly<{
    readonly paid_checks: number;
    readonly paid_total_minor: number;
    readonly per_day: Readonly<{
      readonly high_minor: number;
      readonly low_minor: number;
    }>;
    readonly share_of_sales_bps: number | null;
  }> | null;
  readonly restaurant_id: string;
  readonly status: "available" | "no_data";
  readonly window: Readonly<{
    readonly counted_dates: readonly (string)[];
    readonly from: string;
    readonly to: string;
    readonly uncounted_dates: readonly (string)[];
  }>;
}>
export type ParteWhatIfClosedWeekdayRequest = Readonly<{
  readonly iso_weekday: number;
}>
export type ParteWhatIfDishPrice = Readonly<{
  readonly change_bps: number;
  readonly contract: "exylon.parte.what-if-dish-price@1.0";
  readonly dish_id: string;
  readonly kind: "dish_price";
  readonly limits: readonly (string)[];
  readonly reason: "no_counted_day" | "dish_not_sold" | null;
  readonly recorded: Readonly<{
    readonly sales_minor: number;
    readonly units: number;
  }> | null;
  readonly replay: Readonly<{
    readonly break_even: Readonly<{
      readonly units: number;
      readonly units_difference: number;
    }>;
    readonly same_units: Readonly<{
      readonly difference_minor: number;
      readonly sales_minor: number;
    }>;
  }> | null;
  readonly restaurant_id: string;
  readonly status: "available" | "no_data";
  readonly window: Readonly<{
    readonly counted_dates: readonly (string)[];
    readonly from: string;
    readonly to: string;
    readonly uncounted_dates: readonly (string)[];
  }>;
}>
export type ParteWhatIfDishPriceRequest = Readonly<{
  readonly change_bps: number;
  readonly dish_id: string;
}>
export type ParteWhy = Readonly<{
  readonly refs: readonly (ParteSourceRef)[];
  readonly text: string;
}>
export type ParteWindow = Readonly<{
  readonly day_boundary: "local_midnight";
  readonly from: string;
  readonly timezone: "Europe/Madrid";
  readonly until: string;
}>
export type ParteWork = Readonly<{
  readonly as_of_service_date: string;
  readonly capabilities: readonly (Readonly<{
      readonly capability: string;
      readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
      readonly first_on: string;
      readonly item_id: string;
      readonly last_on: string;
      readonly nights: number;
      readonly state: "open" | "working" | "held" | "returned" | "repairing" | "retrying" | "offered" | "decided" | "scheduled" | "running" | "partly_applied" | "done" | "failed" | "declined" | "expired" | "withdrawn" | "superseded" | "dropped" | "answered" | "stopped" | "undone";
    }>)[];
  readonly changes: Readonly<{
    readonly as_of_service_date: string;
    readonly changes: readonly (Readonly<{
        readonly actions: readonly (Readonly<{
            readonly action_id: string;
            readonly answers: readonly (Readonly<{
                readonly label: string;
                readonly outcome: "done" | "requested" | "already_done" | "not_open" | "window_closed" | "stale" | "invalid" | "failed";
                readonly when: string;
              }>)[];
            readonly body: Readonly<{ readonly [key: string]: unknown }>;
            readonly collects: Readonly<{
              readonly into: "reason" | "words";
              readonly kind: "reason";
              readonly offered: readonly (string)[];
              readonly optional: boolean;
              readonly own_words: boolean;
            }> | Readonly<{
              readonly chosen: string | null;
              readonly into: "option_key";
              readonly kind: "option";
              readonly options: readonly (Readonly<{
                  readonly label: string;
                  readonly option_key: string;
                }>)[];
            }> | Readonly<{
              readonly into: "figure";
              readonly kind: "figure";
              readonly label: string;
              readonly now: number | null;
              readonly optional: boolean;
              readonly scale: number;
              readonly unit: string;
            }> | Readonly<{
              readonly answer_kind: string;
              readonly into: "value";
              readonly kind: "answer";
              readonly unit: string | null;
            }> | null;
            readonly expected_version: number | null;
            readonly href: string | null;
            readonly kind: "primary" | "secondary" | "link";
            readonly label: string;
            readonly operation: string | null;
            readonly params: Readonly<{ readonly [key: string]: string }>;
            readonly target: Readonly<{
              readonly item: string;
              readonly page: "hoy" | "encargos" | "equipo" | "pacto" | "radar" | "reputacion" | "costes" | "semana" | "consejo" | "balance";
            }> | null;
            readonly undo: Readonly<{
              readonly operation: string;
              readonly params: Readonly<{ readonly [key: string]: string }>;
              readonly until: string | null;
            }> | null;
            readonly until: string | null;
          }>)[];
        readonly applied: Readonly<{
          readonly at: string;
          readonly receipts: readonly (string)[];
        }> | null;
        readonly bucket: "decide" | "running" | "done";
        readonly change_id: string;
        readonly decided: Readonly<{
          readonly at: string | null;
          readonly by: "owner" | "team";
          readonly reason: string | null;
          readonly verdict: "approved" | "declined" | "expired";
        }> | null;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
        readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
        readonly ends_on: string | null;
        readonly identity: Readonly<{
          readonly intent_id: string;
          readonly kind: "proposal";
          readonly proposal_type: string;
        }> | Readonly<{
          readonly intent_id: string | null;
          readonly kind: "operation";
          readonly operation_id: string;
        }> | Readonly<{
          readonly action_id: string;
          readonly kind: "team_action";
        }> | Readonly<{
          readonly change_key: string;
          readonly kind: "owner_edit";
        }>;
        readonly last_at: string;
        readonly ledger_keys: readonly (string)[];
        readonly members?: readonly (string)[];
        readonly name: string;
        readonly notice: boolean;
        readonly object: Readonly<{
          readonly object_id: string;
          readonly object_type: string;
          readonly owner: string;
        }> | null;
        readonly owner_status: Readonly<{
          readonly next: Readonly<{
            readonly on: string;
            readonly what: "retry" | "reask" | "result" | "answer" | "deliver" | "decide";
          }> | null;
          readonly since: string;
          readonly state: "open" | "working" | "held" | "returned" | "repairing" | "retrying" | "offered" | "decided" | "scheduled" | "running" | "partly_applied" | "done" | "failed" | "declined" | "expired" | "withdrawn" | "superseded" | "dropped" | "answered" | "stopped" | "undone";
        }> | null;
        readonly partly_applied: Readonly<{
          readonly applied: number;
          readonly not_applied: number;
          readonly since: string;
        }> | null;
        readonly pieces: readonly (Readonly<{
            readonly at: string | null;
            readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
            readonly failure: Readonly<{
              readonly code: string;
              readonly flags: readonly (string)[];
              readonly source: "parser" | "judge" | "checker" | "intervencion" | "admission" | "build" | "domain" | "topic" | "provider" | "deadline" | "owner" | "team" | "schedule";
              readonly words: string | null;
            }> | null;
            readonly label: string;
            readonly object: Readonly<{
              readonly object_id: string;
              readonly object_type: string;
              readonly owner: string;
            }> | null;
            readonly piece_id: string;
            readonly reason: string | null;
            readonly receipt_id: string | null;
            readonly runs_at: string | null;
            readonly state: "proposed" | "scheduled" | "applying" | "applied" | "partly_applied" | "measuring" | "result" | "declined" | "expired" | "stopped" | "failed" | "undone" | "delivered" | "nothing_to_say" | "blocked";
            readonly stopped_by?: "owner" | "team_stop" | "platform";
            readonly tool_id: string | null;
            readonly version: number | null;
          }>)[];
        readonly proposed: Readonly<{
          readonly at: string;
          readonly expires_at: string | null;
          readonly prepared: boolean;
        }> | null;
        readonly runs_at: string | null;
        readonly state: "proposed" | "scheduled" | "applying" | "applied" | "partly_applied" | "measuring" | "result" | "declined" | "expired" | "stopped" | "failed" | "undone" | "delivered" | "nothing_to_say" | "blocked";
        readonly target: Readonly<{
          readonly item: string;
          readonly page: "hoy" | "encargos" | "equipo" | "pacto" | "radar" | "reputacion" | "costes" | "semana" | "consejo" | "balance";
        }> | null;
        readonly tool_id: string | null;
        readonly trial: Readonly<{
          readonly baseline: number | null;
          readonly day: number;
          readonly days_left: number;
          readonly level?: number | null;
          readonly measure: Readonly<{
            readonly label: string;
            readonly measure_id: string;
            readonly unit: string;
          }>;
          readonly of: number;
          readonly phase: "not_started" | "running" | "ended";
          readonly planned_end: string;
          readonly reading: Readonly<{
            readonly state: "awaiting_application";
          }> | Readonly<{
            readonly observed_days: number;
            readonly state: "insufficient_evidence";
            readonly target_observations: number | null;
            readonly through_service_date: string | null;
          }> | Readonly<{
            readonly interval: Readonly<{
              readonly estimate: number;
              readonly high: number;
              readonly low: number;
            }>;
            readonly leaning: "mejora_probable" | "sin_efecto_claro" | "empeora" | "no_medible" | null;
            readonly observed_days: number;
            readonly state: "provisional";
            readonly through_service_date: string;
          }> | Readonly<{
            readonly closed_on: string;
            readonly interval: Readonly<{
              readonly estimate: number;
              readonly high: number;
              readonly low: number;
            }> | null;
            readonly label: "mejora_probable" | "sin_efecto_claro" | "empeora" | "no_medible";
            readonly net_minor: Readonly<{
              readonly estimate: number;
              readonly high: number;
              readonly low: number;
            }> | null;
            readonly state: "closed";
          }>;
          readonly started_on: string;
        }> | null;
        readonly undo: Readonly<{
          readonly action_id: string | null;
          readonly last_day: string;
          readonly open: boolean;
          readonly requested_at: string | null;
          readonly until: string;
          readonly version: number | null;
          readonly via: "proposal" | "team_action";
        }> | null;
        readonly undone_at: string | null;
        readonly undone_by?: "owner" | "team" | null;
      }>)[];
    readonly contract_id: "exylon.parte.changes@1.0";
    readonly counts: Readonly<{
      readonly applying: number;
      readonly measuring: number;
      readonly partly_applied: number;
      readonly prepared: number;
      readonly questions: number;
      readonly running: number;
      readonly scheduled: number;
      readonly to_decide: number;
    }>;
    readonly read_at: string;
    readonly restaurant_id: string;
    readonly unavailable: readonly ("team_actions" | "ledger" | "proposals" | "encargos")[];
  }>;
  readonly contract_id: "exylon.parte.work@1.0";
  readonly figures: Readonly<{
    readonly ai_cost: Readonly<{
      readonly by_desk: readonly (Readonly<{
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          readonly minor: number;
        }>)[];
      readonly month_minor: number;
      readonly unattributed_minor: number;
    }> | null;
    readonly as_of_service_date: string;
    readonly changes: Readonly<{
      readonly applying: number;
      readonly decide: number;
      readonly done: number;
      readonly measuring: number;
      readonly prepared: number;
      readonly running: number;
      readonly scheduled: number;
    }>;
    readonly contract_id: "exylon.parte.figures@1.0";
    readonly desks: readonly (Readonly<{
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly month: Readonly<{
          readonly admitted: number;
          readonly approved_by_owner: number;
          readonly changes_alone: number;
          readonly closed: Readonly<{
            readonly empeora: number;
            readonly mejora_probable: number;
            readonly no_medible: number;
            readonly sin_efecto_claro: number;
          }>;
          readonly declined_by_owner: number;
          readonly drafted: number;
          readonly from: string;
          readonly notices_delivered: number;
          readonly reached_owner: number;
          readonly stopped_by_owner: number;
          readonly to: string;
          readonly undone_by_owner: number;
        }>;
        readonly weeks: readonly (Readonly<{
            readonly admitted: number;
            readonly approved_by_owner: number;
            readonly changes_alone: number;
            readonly closed: Readonly<{
              readonly empeora: number;
              readonly mejora_probable: number;
              readonly no_medible: number;
              readonly sin_efecto_claro: number;
            }>;
            readonly declined_by_owner: number;
            readonly drafted: number;
            readonly from: string;
            readonly notices_delivered: number;
            readonly reached_owner: number;
            readonly stopped_by_owner: number;
            readonly to: string;
            readonly undone_by_owner: number;
          }>)[];
      }>)[];
    readonly encargos_open: number;
    readonly encargos_row: Readonly<{
      readonly encargo_ids: readonly (string)[];
      readonly total: number;
    }>;
    readonly failed_for_owner: number;
    readonly house: Readonly<{
      readonly first_served_day: string | null;
      readonly served_days: number;
    }> | null;
    readonly month: Readonly<{
      readonly admitted: number;
      readonly approved_by_owner: number;
      readonly changes_alone: number;
      readonly closed: Readonly<{
        readonly empeora: number;
        readonly mejora_probable: number;
        readonly no_medible: number;
        readonly sin_efecto_claro: number;
      }>;
      readonly declined_by_owner: number;
      readonly drafted: number;
      readonly from: string;
      readonly notices_delivered: number;
      readonly reached_owner: number;
      readonly stopped_by_owner: number;
      readonly to: string;
      readonly undone_by_owner: number;
    }>;
    readonly nights: readonly (Readonly<{
        readonly admitted: number;
        readonly desks: readonly (Readonly<{
            readonly count: number;
            readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
          }>)[];
        readonly drafted: number;
        readonly night: string;
        readonly reached_owner: number;
      }>)[];
    readonly questions: Readonly<{
      readonly open: number;
      readonly shown: number;
      readonly team_shown: number;
    }>;
    readonly read: Readonly<{
      readonly ai_cost: boolean;
      readonly changes: boolean;
      readonly desks: boolean;
      readonly encargos_open: boolean;
      readonly encargos_row: boolean;
      readonly failed_for_owner: boolean;
      readonly house: boolean;
      readonly month: boolean;
      readonly nights: boolean;
      readonly questions: boolean;
      readonly returned_to_desks: boolean;
      readonly waiting: Readonly<{
        readonly autonomy_offers: boolean;
        readonly budget: boolean;
        readonly changes: boolean;
        readonly consejo: boolean;
        readonly core_queue: boolean;
        readonly owner_tasks: boolean;
        readonly partly_applied: boolean;
        readonly recipe_batch: boolean;
        readonly rota: boolean;
        readonly rota_week: boolean;
        readonly total: boolean;
      }>;
      readonly week: boolean;
      readonly weeks: boolean;
    }>;
    readonly returned_to_desks: number;
    readonly unavailable: readonly ("ledger" | "ledger_truncated" | "changes" | "team_actions" | "results_ledger" | "proposals" | "house" | "autonomy" | "ai_cost" | "encargos" | "questions" | "consejo" | "rota" | "recipes" | "core_queue")[];
    readonly waiting: Readonly<{
      readonly autonomy_offers: number;
      readonly budget: number;
      readonly changes: number;
      readonly consejo: number;
      readonly core_queue: number;
      readonly owner_tasks: number;
      readonly partly_applied: number;
      readonly recipe_batch: number;
      readonly rota: number;
      readonly rota_week: number;
      readonly total: number;
    }>;
    readonly week: Readonly<{
      readonly admitted: number;
      readonly approved_by_owner: number;
      readonly changes_alone: number;
      readonly closed: Readonly<{
        readonly empeora: number;
        readonly mejora_probable: number;
        readonly no_medible: number;
        readonly sin_efecto_claro: number;
      }>;
      readonly declined_by_owner: number;
      readonly desks: readonly (Readonly<{
          readonly count: number;
          readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        }>)[];
      readonly drafted: number;
      readonly from: string;
      readonly notices_delivered: number;
      readonly reached_owner: number;
      readonly stopped_by_owner: number;
      readonly to: string;
      readonly undone_by_owner: number;
    }>;
    readonly weeks: readonly (Readonly<{
        readonly admitted: number;
        readonly approved_by_owner: number;
        readonly change_ids: readonly (string)[];
        readonly changes_alone: number;
        readonly closed: Readonly<{
          readonly empeora: number;
          readonly mejora_probable: number;
          readonly no_medible: number;
          readonly sin_efecto_claro: number;
        }>;
        readonly declined_by_owner: number;
        readonly drafted: number;
        readonly from: string;
        readonly notices_delivered: number;
        readonly reached_owner: number;
        readonly stopped_by_owner: number;
        readonly to: string;
        readonly undone_by_owner: number;
      }>)[];
  }>;
  readonly items: readonly (Readonly<{
      readonly actions: readonly (Readonly<{
          readonly action_id: string;
          readonly answers: readonly (Readonly<{
              readonly label: string;
              readonly outcome: "done" | "requested" | "already_done" | "not_open" | "window_closed" | "stale" | "invalid" | "failed";
              readonly when: string;
            }>)[];
          readonly body: Readonly<{ readonly [key: string]: unknown }>;
          readonly collects: Readonly<{
            readonly into: "reason" | "words";
            readonly kind: "reason";
            readonly offered: readonly (string)[];
            readonly optional: boolean;
            readonly own_words: boolean;
          }> | Readonly<{
            readonly chosen: string | null;
            readonly into: "option_key";
            readonly kind: "option";
            readonly options: readonly (Readonly<{
                readonly label: string;
                readonly option_key: string;
              }>)[];
          }> | Readonly<{
            readonly into: "figure";
            readonly kind: "figure";
            readonly label: string;
            readonly now: number | null;
            readonly optional: boolean;
            readonly scale: number;
            readonly unit: string;
          }> | Readonly<{
            readonly answer_kind: string;
            readonly into: "value";
            readonly kind: "answer";
            readonly unit: string | null;
          }> | null;
          readonly expected_version: number | null;
          readonly href: string | null;
          readonly kind: "primary" | "secondary" | "link";
          readonly label: string;
          readonly operation: string | null;
          readonly params: Readonly<{ readonly [key: string]: string }>;
          readonly target: Readonly<{
            readonly item: string;
            readonly page: "hoy" | "encargos" | "equipo" | "pacto" | "radar" | "reputacion" | "costes" | "semana" | "consejo" | "balance";
          }> | null;
          readonly undo: Readonly<{
            readonly operation: string;
            readonly params: Readonly<{ readonly [key: string]: string }>;
            readonly until: string | null;
          }> | null;
          readonly until: string | null;
        }>)[];
      readonly attempts: number;
      readonly body: Readonly<{
        readonly answer: Readonly<{
          readonly kind: "figure";
          readonly label: string;
          readonly now: number | null;
          readonly scale: number;
          readonly unit: string;
        }> | Readonly<{
          readonly kind: "done";
        }> | null;
        readonly counterpart: Readonly<{
          readonly channels: readonly ("call" | "whatsapp" | "email")[];
          readonly contact_name: string | null;
          readonly email: string | null;
          readonly object: Readonly<{
            readonly label: string | null;
            readonly object_id: string;
            readonly object_type: string;
            readonly owner: string;
          }>;
          readonly phone: string | null;
        }> | null;
        readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
        readonly due: Readonly<{
          readonly before: "purchase_order" | "service" | "publication" | "date";
          readonly on: string;
        }> | null;
        readonly figure: Readonly<{
          readonly before: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }> | null;
          readonly history?: Readonly<{
            readonly coverage: Readonly<{
              readonly expected: number;
              readonly observed: number;
              readonly state: "complete" | "partial" | "young";
            }>;
            readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
            readonly normal: Readonly<{
              readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
              readonly estimate: boolean;
              readonly hi: number;
              readonly lo: number;
              readonly mid: number | null;
              readonly observed: number;
              readonly window?: Readonly<{
                readonly from: string;
                readonly to: string;
              }>;
            }> | null;
            readonly of: string;
            readonly points: readonly (Readonly<{
                readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
                readonly days?: Readonly<{
                  readonly observed: number;
                  readonly of: number;
                }>;
                readonly part?: string;
                readonly partial?: true;
                readonly partial_reason?: "running" | "opened" | "uncounted";
                readonly range?: Readonly<{
                  readonly hi: number;
                  readonly lo: number;
                }>;
                readonly value: number | null;
                readonly window: Readonly<{
                  readonly from: string;
                  readonly to: string;
                }>;
              }>)[];
            readonly previous?: readonly (Readonly<{
                readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
                readonly days?: Readonly<{
                  readonly observed: number;
                  readonly of: number;
                }>;
                readonly part?: string;
                readonly partial?: true;
                readonly partial_reason?: "running" | "opened" | "uncounted";
                readonly range?: Readonly<{
                  readonly hi: number;
                  readonly lo: number;
                }>;
                readonly value: number | null;
                readonly window: Readonly<{
                  readonly from: string;
                  readonly to: string;
                }>;
              }>)[];
            readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
          }>;
          readonly label: string;
          readonly now: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }>;
          readonly series: Readonly<{
            readonly measure_id: string;
            readonly subject: Readonly<{
              readonly label: string | null;
              readonly object_id: string;
              readonly object_type: string;
              readonly owner: string;
            }> | null;
          }> | null;
        }> | null;
        readonly headline: string;
        readonly impact: Readonly<{
          readonly figure: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }>;
          readonly label: string;
        }> | null;
        readonly lines: readonly (string)[];
        readonly pitch: string | null;
        readonly reason: "contact" | "publish";
        readonly shape: "owner_task";
      }> | Readonly<{
        readonly day_of: number | null;
        readonly days: number;
        readonly desks: readonly ("direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria")[];
        readonly encargo_id: string | null;
        readonly ends_on: string | null;
        readonly guest_visible: boolean;
        readonly headline: string;
        readonly judged_on: Readonly<{
          readonly before: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }> | null;
          readonly label: string;
          readonly now: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }> | null;
          readonly series: Readonly<{
            readonly measure_id: string;
            readonly subject: Readonly<{
              readonly label: string | null;
              readonly object_id: string;
              readonly object_type: string;
              readonly owner: string;
            }> | null;
          }> | null;
        }> | null;
        readonly new_dish: Readonly<{
          readonly allergens: readonly (string)[];
          readonly cost: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }> | null;
          readonly lines: readonly (Readonly<{
              readonly cost: Readonly<{
                readonly printed: string;
                readonly unit: string | null;
                readonly value: number | null;
              }> | null;
              readonly label: string;
              readonly quantity: string | null;
            }>)[];
          readonly margin: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }> | null;
          readonly name: string;
          readonly photo: Readonly<{
            readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
            readonly on_trial_day: number;
          }> | null;
          readonly price: Readonly<{
            readonly printed: string;
            readonly unit: string | null;
            readonly value: number | null;
          }>;
        }> | null;
        readonly protects: Readonly<{
          readonly measure: Readonly<{
            readonly label: string;
            readonly measure_id: string;
          }> | null;
          readonly object: Readonly<{
            readonly label: string | null;
            readonly object_id: string;
            readonly object_type: string;
            readonly owner: string;
          }> | null;
          readonly until: string | null;
        }>;
        readonly provisional: boolean;
        readonly result_on: string | null;
        readonly shape: "trial";
        readonly starts_on: string | null;
        readonly stoppable: boolean;
        readonly tool_id: string;
        readonly trial: "catalog" | "new_dish" | "process";
      }> | Readonly<{
        readonly because: string;
        readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria";
        readonly shape: "no_action";
      }> | Readonly<{
        readonly hours_short: Readonly<{
          readonly printed: string;
          readonly unit: string | null;
          readonly value: number | null;
        }> | null;
        readonly objection: Readonly<{
          readonly by: "intervencion";
          readonly note?: string | null;
          readonly objects_to: "publish_with_gaps";
          readonly people_short: number;
          readonly services_short: number;
        }>;
        readonly options: readonly (Readonly<{
            readonly cost: Readonly<{
              readonly estimate: boolean;
              readonly figure: Readonly<{
                readonly printed: string;
                readonly unit: string | null;
                readonly value: number | null;
              }>;
              readonly kind: "labour" | "sales";
            }> | null;
            readonly covers_after: number;
            readonly kind: "extend_hours" | "ask_extra_staff" | "reduce_service" | "publish_with_gaps";
            readonly option_key: string;
          }>)[];
        readonly rules: readonly (Readonly<{
            readonly met: boolean;
            readonly rule: "rest_between_shifts" | "daily_maximum" | "weekly_maximum" | "days_off" | "overlap" | "shape" | "coverage";
          }>)[];
        readonly services: readonly (Readonly<{
            readonly date: string;
            readonly needed: number;
            readonly planned: number;
            readonly short: number;
            readonly slot: "lunch" | "dinner";
          }>)[];
        readonly services_covered: number;
        readonly services_total: number;
        readonly shape: "rota_shortfall";
        readonly week_cost: Readonly<{
          readonly printed: string;
          readonly unit: string | null;
          readonly value: number | null;
        }> | null;
        readonly week_end: string;
        readonly week_start: string;
      }> | null;
      readonly change_id: string | null;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
      readonly identity: Readonly<{
        readonly facet: string | null;
        readonly key: string;
        readonly kind: "topic" | "investigation" | "finding" | "proposal" | "decision" | "piece" | "owner_task" | "notice" | "briefing" | "card" | "page_note" | "question" | "encargo_turn" | "data_defect" | "capability_request" | "matter" | "lesson" | "night_step" | "live_notice" | "change" | "encargo" | "pacto_line";
        readonly measure_id: string | null;
        readonly subjects: readonly (Readonly<{
            readonly object_id: string;
            readonly object_type: string;
            readonly owner: string;
          }>)[];
      }>;
      readonly item_id: string;
      readonly nights_without_action: number;
      readonly owner_facing: boolean;
      readonly owner_status: Readonly<{
        readonly next: Readonly<{
          readonly on: string;
          readonly what: "retry" | "reask" | "result" | "answer" | "deliver" | "decide";
        }> | null;
        readonly since: string;
        readonly state: "open" | "working" | "held" | "returned" | "repairing" | "retrying" | "offered" | "decided" | "scheduled" | "running" | "partly_applied" | "done" | "failed" | "declined" | "expired" | "withdrawn" | "superseded" | "dropped" | "answered" | "stopped" | "undone";
      }> | null;
      readonly reason: Readonly<{
        readonly code: string;
        readonly flags: readonly (string)[];
        readonly source: "parser" | "judge" | "checker" | "intervencion" | "admission" | "build" | "domain" | "topic" | "provider" | "deadline" | "owner" | "team" | "schedule";
        readonly words: string | null;
      }>;
      readonly since: string;
      readonly state: "open" | "working" | "held" | "returned" | "repairing" | "retrying" | "offered" | "decided" | "scheduled" | "running" | "partly_applied" | "done" | "failed" | "declined" | "expired" | "withdrawn" | "superseded" | "dropped" | "answered" | "stopped" | "undone";
      readonly superseded_by: string | null;
      readonly target: Readonly<{
        readonly item: string;
        readonly page: "hoy" | "encargos" | "equipo" | "pacto" | "radar" | "reputacion" | "costes" | "semana" | "consejo" | "balance";
      }> | null;
      readonly title: string;
      readonly transitions: readonly (Readonly<{
          readonly actor: Readonly<{
            readonly id: string | null;
            readonly kind: "desk" | "direccion" | "owner" | "code" | "worker" | "domain" | "laboratory";
          }>;
          readonly at: string;
          readonly from: "open" | "working" | "held" | "returned" | "repairing" | "retrying" | "offered" | "decided" | "scheduled" | "running" | "partly_applied" | "done" | "failed" | "declined" | "expired" | "withdrawn" | "superseded" | "dropped" | "answered" | "stopped" | "undone" | null;
          readonly night: string | null;
          readonly reason: Readonly<{
            readonly code: string;
            readonly flags: readonly (string)[];
            readonly source: "parser" | "judge" | "checker" | "intervencion" | "admission" | "build" | "domain" | "topic" | "provider" | "deadline" | "owner" | "team" | "schedule";
            readonly words: string | null;
          }>;
          readonly seq: number;
          readonly to: "open" | "working" | "held" | "returned" | "repairing" | "retrying" | "offered" | "decided" | "scheduled" | "running" | "partly_applied" | "done" | "failed" | "declined" | "expired" | "withdrawn" | "superseded" | "dropped" | "answered" | "stopped" | "undone";
        }>)[];
      readonly version: number;
    }>)[];
  readonly notices: readonly (Readonly<{
      readonly actions: readonly (Readonly<{
          readonly action_id: string;
          readonly answers: readonly (Readonly<{
              readonly label: string;
              readonly outcome: "done" | "requested" | "already_done" | "not_open" | "window_closed" | "stale" | "invalid" | "failed";
              readonly when: string;
            }>)[];
          readonly body: Readonly<{ readonly [key: string]: unknown }>;
          readonly collects: Readonly<{
            readonly into: "reason" | "words";
            readonly kind: "reason";
            readonly offered: readonly (string)[];
            readonly optional: boolean;
            readonly own_words: boolean;
          }> | Readonly<{
            readonly chosen: string | null;
            readonly into: "option_key";
            readonly kind: "option";
            readonly options: readonly (Readonly<{
                readonly label: string;
                readonly option_key: string;
              }>)[];
          }> | Readonly<{
            readonly into: "figure";
            readonly kind: "figure";
            readonly label: string;
            readonly now: number | null;
            readonly optional: boolean;
            readonly scale: number;
            readonly unit: string;
          }> | Readonly<{
            readonly answer_kind: string;
            readonly into: "value";
            readonly kind: "answer";
            readonly unit: string | null;
          }> | null;
          readonly expected_version: number | null;
          readonly href: string | null;
          readonly kind: "primary" | "secondary" | "link";
          readonly label: string;
          readonly operation: string | null;
          readonly params: Readonly<{ readonly [key: string]: string }>;
          readonly target: Readonly<{
            readonly item: string;
            readonly page: "hoy" | "encargos" | "equipo" | "pacto" | "radar" | "reputacion" | "costes" | "semana" | "consejo" | "balance";
          }> | null;
          readonly undo: Readonly<{
            readonly operation: string;
            readonly params: Readonly<{ readonly [key: string]: string }>;
            readonly until: string | null;
          }> | null;
          readonly until: string | null;
        }>)[];
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
      readonly notice_id: string;
      readonly receipt_id: string;
      readonly sent_at: string;
      readonly title: string | null;
      readonly tool_id: string;
      readonly until: string;
    }>)[];
  readonly questions: readonly (Readonly<{
      readonly actions: readonly (Readonly<{
          readonly action_id: string;
          readonly answers: readonly (Readonly<{
              readonly label: string;
              readonly outcome: "done" | "requested" | "already_done" | "not_open" | "window_closed" | "stale" | "invalid" | "failed";
              readonly when: string;
            }>)[];
          readonly body: Readonly<{ readonly [key: string]: unknown }>;
          readonly collects: Readonly<{
            readonly into: "reason" | "words";
            readonly kind: "reason";
            readonly offered: readonly (string)[];
            readonly optional: boolean;
            readonly own_words: boolean;
          }> | Readonly<{
            readonly chosen: string | null;
            readonly into: "option_key";
            readonly kind: "option";
            readonly options: readonly (Readonly<{
                readonly label: string;
                readonly option_key: string;
              }>)[];
          }> | Readonly<{
            readonly into: "figure";
            readonly kind: "figure";
            readonly label: string;
            readonly now: number | null;
            readonly optional: boolean;
            readonly scale: number;
            readonly unit: string;
          }> | Readonly<{
            readonly answer_kind: string;
            readonly into: "value";
            readonly kind: "answer";
            readonly unit: string | null;
          }> | null;
          readonly expected_version: number | null;
          readonly href: string | null;
          readonly kind: "primary" | "secondary" | "link";
          readonly label: string;
          readonly operation: string | null;
          readonly params: Readonly<{ readonly [key: string]: string }>;
          readonly target: Readonly<{
            readonly item: string;
            readonly page: "hoy" | "encargos" | "equipo" | "pacto" | "radar" | "reputacion" | "costes" | "semana" | "consejo" | "balance";
          }> | null;
          readonly undo: Readonly<{
            readonly operation: string;
            readonly params: Readonly<{ readonly [key: string]: string }>;
            readonly until: string | null;
          }> | null;
          readonly until: string | null;
        }>)[];
      readonly ask_again_on: string | null;
      readonly desk: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
      readonly first_asked_on: string | null;
      readonly item_id: string;
      readonly question_id: string;
      readonly shown: boolean;
      readonly text: string;
      readonly value: number;
    }>)[];
  readonly read_at: string;
  readonly restaurant_id: string;
  readonly unavailable: readonly ("ledger" | "changes" | "questions" | "ledger_truncated")[];
}>
export type ParteWorkActed = Readonly<{
  readonly contract: "exylon.parte.work-acted@1.0";
  readonly item_id: string;
  readonly state: "done" | "declined" | "returned" | "decided" | "held";
  readonly version: number;
}>
export type ParteWorkActRequest = Readonly<{
  readonly act: "done" | "unchanged" | "decline" | "choose" | "change";
  readonly expected_version: number;
  readonly figure?: number | null;
  readonly option_key?: string | null;
  readonly words: string | null;
}>
export type ParteYesterdayComparison = Readonly<{
  readonly reading: Readonly<{
    readonly coverage: ParteCoverage;
    readonly kind: "value";
    readonly period: PartePeriod;
    readonly source: ParteSourceRef;
    readonly unit: "money_minor" | "count" | "rating_5" | "seconds" | "grams" | "millilitres" | "units" | "date" | "basis_points" | "milliseconds";
    readonly value: Readonly<{
      readonly compared_days: number;
      readonly max: ParteMoney;
      readonly median: ParteMoney;
      readonly min: ParteMoney;
      readonly position: "below" | "within" | "above";
      readonly same_weekdays?: readonly (Readonly<{
          readonly business_date: string;
          readonly net: ParteMoney;
        }>)[];
      readonly yesterday: ParteMoney;
    }>;
  }> | ParteAbsent;
  readonly weeks: 8;
}>
export type PatchCatalogDraftEntitiesRequest = Readonly<{
  readonly editor_intent_id: string;
  readonly entities: readonly (Readonly<{
      readonly base_hash?: string | null;
      readonly id: string;
      readonly kind: "dish" | "category" | "section" | "modifier_group" | "modifier_option" | "ingredient" | "media_object" | "translation_set" | "collection";
      readonly rows: Readonly<{
        readonly allergens?: readonly (Readonly<{
            readonly active: boolean;
            readonly code: string;
            readonly description: string;
            readonly id: string;
            readonly name: string;
            readonly version: number;
          }>)[];
        readonly categories?: readonly (Readonly<{
            readonly active: boolean;
            readonly department_id?: string | null;
            readonly derived_kind?: "starter" | "main" | "dessert" | "drink" | "other";
            readonly featured: boolean;
            readonly icon: string | null;
            readonly id: string;
            readonly internal_name: string;
            readonly kind?: "starter" | "main" | "dessert" | "drink" | "other" | null;
            readonly media_object_id: string | null;
            readonly sort_order?: number;
            readonly version: number;
          }>)[];
        readonly diet_tags?: readonly (Readonly<{
            readonly active: boolean;
            readonly code: string;
            readonly description: string;
            readonly id: string;
            readonly name: string;
            readonly version: number;
          }>)[];
        readonly dish_allergens?: readonly (Readonly<{
            readonly allergen_id: string;
            readonly dish_id: string;
            readonly presence: "contains" | "may_contain";
            readonly source: "manual";
          }>)[];
        readonly dish_media?: readonly (Readonly<{
            readonly dish_id: string;
            readonly media_object_id: string;
            readonly sort_order: number;
          }>)[];
        readonly dish_modifier_groups?: readonly (Readonly<{
            readonly dish_id: string;
            readonly modifier_group_id: string;
            readonly sort_order: number;
          }>)[];
        readonly dishes?: readonly (Readonly<{
            readonly active: boolean;
            readonly available: boolean;
            readonly bottle_dish_id?: string | null;
            readonly category_id: string;
            readonly currency: "EUR";
            readonly id: string;
            readonly internal_name: string;
            readonly preparation_time_minutes: number | null;
            readonly price_minor: number;
            readonly role?: "cafe" | "agua" | "vino_copa" | "vino_botella" | "envase" | "cuchara" | null;
            readonly seasoning_style_codes: readonly (string)[];
            readonly sort_order?: number;
            readonly star_dish?: boolean;
            readonly tax_rate_bps?: 0 | 400 | 1000 | 2100;
            readonly version: number;
          }>)[];
        readonly ingredient_allergens?: readonly (Readonly<{
            readonly allergen_id: string;
            readonly ingredient_id: string;
            readonly presence: "contains" | "may_contain";
            readonly provenance: string;
            readonly version: number;
          }>)[];
        readonly ingredient_concept_mappings?: readonly (Readonly<{
            readonly allergen_coverage: "verified" | "incomplete" | "unknown";
            readonly concept_id: string | null;
            readonly coverage: "verified" | "incomplete" | "unknown";
            readonly diet_coverage: "verified" | "incomplete" | "unknown";
            readonly ingredient_id: string;
            readonly provenance: string;
            readonly registry_version: number;
            readonly version: number;
          }>)[];
        readonly ingredient_diet_properties?: readonly (Readonly<{
            readonly conflicts: boolean;
            readonly diet_tag_id: string;
            readonly explanation: string;
            readonly ingredient_id: string;
            readonly property_code: string;
            readonly provenance: string;
            readonly version: number;
          }>)[];
        readonly ingredient_sensory_profiles?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimensions: readonly (Readonly<{
                readonly confidence: number;
                readonly dimension_code: string;
                readonly score: number;
              }>)[];
            readonly ingredient_id: string;
            readonly profile_version: number;
            readonly provenance: string;
          }>)[];
        readonly ingredients?: readonly (Readonly<{
            readonly active: boolean;
            readonly base_unit_code: string;
            readonly default_role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
            readonly density_g_per_ml: number | null;
            readonly description: string;
            readonly id: string;
            readonly mass_per_unit_mg: number | null;
            readonly name: string;
            readonly seasoning_signature: readonly (Readonly<{
                readonly delta: number;
                readonly dimension_code: string;
              }>)[];
            readonly version: number;
          }>)[];
        readonly media_objects?: readonly (CatalogMediaObject)[];
        readonly modifier_group_options?: readonly (Readonly<{
            readonly is_default: boolean;
            readonly modifier_group_id: string;
            readonly modifier_option_id: string;
            readonly sort_order: number;
          }>)[];
        readonly modifier_groups?: readonly (Readonly<{
            readonly available: boolean;
            readonly course_codes: readonly (string)[];
            readonly id: string;
            readonly kind: "extra" | "size" | "topping" | "sauce" | "preparation";
            readonly name: string;
            readonly selection_max: number;
            readonly selection_min: number;
            readonly sort_order: number;
            readonly version: number;
          }>)[];
        readonly modifier_option_allergens?: readonly (Readonly<{
            readonly allergen_id: string;
            readonly modifier_option_id: string;
            readonly presence: "contains" | "may_contain";
            readonly source: "manual";
          }>)[];
        readonly modifier_option_ingredients?: readonly (Readonly<{
            readonly ingredient_id: string;
            readonly inventory_rule: "deducts" | "inform_only";
            readonly modifier_option_id: string;
            readonly quantity_base_units: number;
            readonly unit_code: string;
          }> | Readonly<{
            readonly entered_quantity: Readonly<{
              readonly unit_code: "mg" | "g" | "kg" | "ml" | "l" | "unit";
              readonly value: string;
            }>;
            readonly ingredient_id: string;
            readonly inventory_rule: "deducts" | "inform_only";
            readonly modifier_option_id: string;
            readonly unit_code: string;
          }>)[];
        readonly modifier_options?: readonly (Readonly<{
            readonly adds_no_ingredients?: true;
            readonly available: boolean;
            readonly currency: "EUR";
            readonly id: string;
            readonly media_object_id: string | null;
            readonly name: string;
            readonly price_delta_minor: number;
            readonly version: number;
          }>)[];
        readonly preparation_choices?: readonly (Readonly<{
            readonly available: boolean;
            readonly code: string;
            readonly default_selected: boolean;
            readonly dish_id: string;
            readonly id: string;
            readonly name: string;
            readonly semantic_provenance: string;
            readonly semantic_version: number;
            readonly sort_order: number;
            readonly version: number;
          }>)[];
        readonly preparation_sensory_modifiers?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimension_code: string;
            readonly modifier: number;
            readonly preparation_code: string;
            readonly preparation_semantic_version: number;
            readonly provenance: string;
          }>)[];
        readonly recipe_lines?: readonly (Readonly<{
            readonly dish_id: string;
            readonly ingredient_id: string;
            readonly inventory_rule: "deducts" | "inform_only";
            readonly preparation_code: string | null;
            readonly quantity_base_units: number;
            readonly recipe_version: number;
            readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
            readonly unit_code: string;
          }> | Readonly<{
            readonly dish_id: string;
            readonly entered_quantity: Readonly<{
              readonly unit_code: "mg" | "g" | "kg" | "ml" | "l" | "unit";
              readonly value: string;
            }>;
            readonly ingredient_id: string;
            readonly inventory_rule: "deducts" | "inform_only";
            readonly preparation_code: string | null;
            readonly recipe_version: number;
            readonly role: "main" | "secondary" | "garnish" | "sauce" | "seasoning" | null;
            readonly unit_code: string;
          }>)[];
        readonly seasoning_style_modifiers?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimension_code: string;
            readonly modifier: number;
            readonly provenance: string;
            readonly seasoning_style_code: string;
          }>)[];
        readonly section_categories?: readonly (Readonly<{
            readonly category_id: string;
            readonly section_id: string;
            readonly sort_order: number;
          }>)[];
        readonly sections?: readonly (Readonly<{
            readonly available: boolean;
            readonly id: string;
            readonly internal_name: string;
            readonly sort_order: number;
            readonly version: number;
          }>)[];
        readonly sensory_bases?: readonly (Readonly<{
            readonly basis_version: string;
            readonly provenance: string;
            readonly status: "active" | "retired";
            readonly version: number;
          }>)[];
        readonly sensory_dimensions?: readonly (Readonly<{
            readonly basis_version: string;
            readonly code: string;
            readonly dimension_label?: string;
            readonly group_code: string;
            readonly group_label?: string;
            readonly name: string;
            readonly sort_order: number;
          }>)[];
        readonly served_form_sensory_modifiers?: readonly (Readonly<{
            readonly basis_version: string;
            readonly confidence: number;
            readonly dimension_code: string;
            readonly modifier: number;
            readonly preparation_code: string;
            readonly provenance: string;
          }>)[];
        readonly translations?: readonly (Readonly<{
            readonly description: string;
            readonly entity_id: string;
            readonly entity_type: "category" | "dish" | "modifier_group" | "modifier_option" | "section";
            readonly locale: string;
            readonly name: string;
          }>)[];
        readonly unit_definitions?: readonly (Readonly<{
            readonly denominator_to_base: number;
            readonly dimension: "mass" | "volume" | "count";
            readonly numerator_to_base: number;
            readonly unit_code: string;
            readonly version: number;
          }>)[];
      }> | null;
    }>)[];
  readonly materialize_master_ingredient_ids?: readonly (string)[];
  readonly provisional_media_claims: readonly (Readonly<{
      readonly expected_version: number;
      readonly media_id: string;
      readonly sha256_digest: string;
    }>)[];
}>
export type PlatformBinaryContent = string
export type PlatformMessagingGuestRealtimeReplayRequest = Readonly<{
  readonly afterSequence: number;
  readonly limit?: number;
  readonly streamKey: string;
}>
export type PlatformMessagingNotice = Readonly<{
  readonly actionLabel: string | null;
  readonly activeFrom: string;
  readonly autoDismissSeconds: number | null;
  readonly body: string;
  readonly category: string;
  readonly coverage?: Readonly<{
    readonly readyPlates: number;
    readonly tables: readonly (string)[];
  }>;
  readonly createdAt: string;
  readonly dismissedAt: string | null;
  readonly dismissPolicy: "dismissible" | "required" | "auto";
  readonly expiresAt: string | null;
  readonly iconKey: string | null;
  readonly id: string;
  readonly priority: number;
  readonly readAt: string | null;
  readonly restaurantId: string | null;
  readonly seenAt: string | null;
  readonly severity: "info" | "success" | "warning" | "critical";
  readonly sourceEventId: string;
  readonly staffNotice?: Readonly<{
    readonly desk: string | null;
    readonly kind: string;
  }>;
  readonly tenantId: string;
  readonly title: string;
  readonly version: number;
}>
export type PlatformMessagingNoticeInbox = Readonly<{
  readonly items: readonly (PlatformMessagingNotice)[];
  readonly nextCursor: Readonly<{
    readonly createdAt: string;
    readonly id: string;
  }> | null;
  readonly queueCount: number;
  readonly staffNotices?: readonly (PlatformMessagingNotice)[];
  readonly unreadCount: number;
}>
export type PlatformMessagingNoticeInboxResponse = Readonly<{
  readonly result: PlatformMessagingNoticeInbox;
  readonly statusCode: 200;
  readonly success: true;
}>
export type PlatformMessagingNoticeList = Readonly<{
  readonly items: readonly (Readonly<{
      readonly actionLabel: string | null;
      readonly activeFrom: string;
      readonly autoDismissSeconds: number | null;
      readonly body: string;
      readonly category: string;
      readonly createdAt: string;
      readonly dismissedAt: string | null;
      readonly dismissPolicy: "dismissible" | "required" | "auto";
      readonly expiresAt: string | null;
      readonly iconKey: string | null;
      readonly id: string;
      readonly priority: number;
      readonly readAt: string | null;
      readonly restaurantId: string | null;
      readonly seenAt: string | null;
      readonly severity: "info" | "success" | "warning" | "critical";
      readonly sourceEventId: string;
      readonly tenantId: string;
      readonly title: string;
      readonly version: number;
    }>)[];
  readonly nextCursor: Readonly<{
    readonly createdAt: string;
    readonly id: string;
  }> | null;
  readonly queueCount: number;
}>
export type PlatformMessagingNoticeListResponse = Readonly<{
  readonly result: PlatformMessagingNoticeList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type PlatformMessagingNoticeReceipt = Readonly<{
  readonly changed: boolean;
  readonly dismissedAt: string | null;
  readonly noticeId: string;
  readonly readAt: string | null;
  readonly seenAt: string | null;
  readonly version: number;
}>
export type PlatformMessagingNoticeReceiptRequest = Readonly<Record<never, never>>
export type PlatformMessagingNoticeReceiptResponse = Readonly<{
  readonly result: PlatformMessagingNoticeReceipt;
  readonly statusCode: 200;
  readonly success: true;
}>
export type PlatformMessagingRealtimeEvent = Readonly<{
  readonly eventId: string;
  readonly eventType: string;
  readonly eventVersion: number;
  readonly occurredAt: string;
  readonly payload: unknown;
  readonly sequence: number;
}>
export type PlatformMessagingRealtimeReplay = Readonly<{
  readonly events: readonly (PlatformMessagingRealtimeEvent)[];
  readonly hasMore: boolean;
  readonly latestSequence: number;
  readonly retainedFromSequence: number;
}>
export type PlatformMessagingRealtimeReplayResponse = Readonly<{
  readonly result: PlatformMessagingRealtimeReplay;
  readonly statusCode: 200;
  readonly success: true;
}>
export type PlatformRefusal = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode?: string;
    readonly reason_text?: string;
  }> | null;
  readonly message: string;
  readonly statusCode: number;
}>
export type ProductResponseAbandonCatalogMediaProvisionals = Readonly<{
  readonly result: CatalogProvisionalMediaAbandonment;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseAnswerCatalogDishTrial = Readonly<{
  readonly result: CatalogDishTrial;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseApplyCatalogDishCopy = Readonly<{
  readonly result: CatalogDishCopyApplied;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseApplyCatalogDishNameSuggestion = Readonly<{
  readonly result: CatalogDishNameSuggestion;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseApplyCatalogDishProposal = Readonly<{
  readonly result: CatalogDishProposalApplication;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseApplyCatalogPhotoCorrection = Readonly<{
  readonly result: CatalogPhotoCorrectionApplied;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseApplyRestaurantConfiguration = Readonly<{
  readonly result: RestaurantConfigurationPublication;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseAutocompleteCatalogDishIngredients = Readonly<{
  readonly result: CatalogIngredientAutocomplete;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingActivate = Readonly<{
  readonly result: BillingConfiguration;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingConfigurationApply = Readonly<{
  readonly result: BillingConfiguration;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingConfigurationRead = Readonly<{
  readonly result: BillingConfiguration;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingDocumentLegibleCopy = Readonly<{
  readonly result: BillingLegibleCopy;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingDocumentRead = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingDocumentRender = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingDocumentsByCheck = Readonly<{
  readonly result: BillingDocumentsByCheck;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingDocumentsByChecks = Readonly<{
  readonly result: BillingDocumentsByChecks;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingExportList = Readonly<{
  readonly result: BillingExportList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingExportPrepare = Readonly<{
  readonly result: BillingExportSummary;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingFiscalIncidentMove = Readonly<{
  readonly result: BillingFiscalIncident;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingFiscalIncidentRecord = Readonly<{
  readonly result: BillingFiscalIncident;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingFiscalIncidentsList = Readonly<{
  readonly result: BillingFiscalIncidentList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingIncidentsList = Readonly<{
  readonly result: BillingIncidentPage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingIntentComplete = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingIntentRead = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingIntentReissue = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingIntentRetry = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingIntentVoid = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingInvoiceLinkReadV1 = Readonly<{
  readonly result: BillingInvoiceLink;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseBillingIssuerSuccessionRecord = Readonly<{
  readonly result: BillingIssuerSuccession;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingOfflineIntentsRelease = Readonly<{
  readonly result: BillingOfflineIntentsReleaseResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingPaymentInvoice = Readonly<{
  readonly result: BillingDocumentSummary;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingProviderConnect = Readonly<{
  readonly result: BillingConfiguration;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingProviderDisconnect = Readonly<{
  readonly result: BillingConfiguration;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingRequestCreate = Readonly<{
  readonly result: BillingRequestCreateResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseBillingStatusSummary = Readonly<{
  readonly result: BillingStatusSummary;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogBridgeDraftReplaceRevalidate = Readonly<{
  readonly result: CatalogBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogBridgeMediaWriteRevalidate = Readonly<{
  readonly result: CatalogBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogBridgePublishRevalidate = Readonly<{
  readonly result: CatalogBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogPosOperationalReadV1 = Readonly<{
  readonly result: CatalogPublishedCatalogue;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogPosRoutingReadV1 = Readonly<{
  readonly result: CatalogPosPublishedRouting;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogPublishedMediaDeliveryV1 = Readonly<{
  readonly result: CatalogMediaDelivery;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogPublishedMediaRenditionsV1 = Readonly<{
  readonly result: CatalogMediaRenditions;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseCatalogRepairedMasterHoldingsReadV1 = Readonly<{
  readonly result: CatalogRepairedMasterHoldings;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseDeleteCatalogAiProviderCredential = Readonly<{
  readonly result: CatalogAiProviderCredentialStatus;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseEvaluateCatalogWorkshopIdea = Readonly<{
  readonly result: CatalogWorkshopEvaluation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestBillingDocumentsList = Readonly<{
  readonly result: GuestBillingDocumentList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestBillingSessionChargesRead = Readonly<{
  readonly result: GuestBillingSessionCharges;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestDiagnosticsRecord = Readonly<{
  readonly result: GuestDiagnosticsReceipt;
  readonly statusCode: 202;
  readonly success: true;
}>
export type ProductResponseGuestIdentitySuggest = Readonly<{
  readonly result: GuestIdentitySuggestion;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestLoyaltyCardsDetail = Readonly<{
  readonly result: GuestLoyaltyCardDetailRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestLoyaltyCardsList = Readonly<{
  readonly result: GuestLoyaltyCardList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestPrivacyEraseAccount = Readonly<{
  readonly result: GuestAccountErasure;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseGuestPrivacyEraseDerived = Readonly<{
  readonly result: GuestPrivacyErasure;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseGuestPrivacyExport = Readonly<{
  readonly result: GuestPrivacyExport;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestPrivacyGet = Readonly<{
  readonly result: GuestConsent;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestPrivacyPersonalizationGet = Readonly<{
  readonly result: GuestPersonalizationSetting;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestPrivacyReplaceConsent = Readonly<{
  readonly result: GuestConsent;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseGuestPrivacyReplacePersonalization = Readonly<{
  readonly result: GuestPersonalizationSetting;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseGuestProfileGet = Readonly<{
  readonly result: GuestProfile;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseGuestProfileUpdate = Readonly<{
  readonly result: GuestProfile;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInsightsFranchiseMetrics = Readonly<{
  readonly result: InsightsMetricSummary;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInsightsLoyaltyPeriod = Readonly<{
  readonly result: InsightsPeriodRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInsightsParteRadarRead = Readonly<{
  readonly result: InsightsParteRadar;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInsightsRestaurantFlavourProfile = Readonly<{
  readonly result: InsightsFlavourProfileRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInsightsRestaurantPeriod = Readonly<{
  readonly result: InsightsPeriodRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInsightsRestaurantPromotionMonth = Readonly<{
  readonly result: InsightsPromotionMonthRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryBridgeStockItemReconcileRevalidate = Readonly<{
  readonly result: InventoryBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryBridgeStockItemRevalidate = Readonly<{
  readonly result: InventoryBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryDishCostingListV1 = Readonly<{
  readonly result: InventoryDishCostingList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryPublishedPolicyReadV1 = Readonly<{
  readonly result: InventoryPublishedPolicyDecision;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentArrivalAnswerV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentFigureValidateV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentKeepApartV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentLineAnswerV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentLineMeasureV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentReadV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentSameDeliveryAnswerV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentsListV1 = Readonly<{
  readonly result: InventoryPurchaseOverview;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentUndoV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseDocumentUploadV1 = Readonly<{
  readonly result: InventoryPurchaseDocument;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchasePeriodReadV1 = Readonly<{
  readonly result: InventoryPurchasePeriod;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseSettingsSetV1 = Readonly<{
  readonly result: InventoryPurchaseSettingsResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseTraceExportListV1 = Readonly<{
  readonly result: InventoryPurchaseTraceExportList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseTraceExportPrepareV1 = Readonly<{
  readonly result: InventoryPurchaseTraceExport;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryPurchaseTraceSearchV1 = Readonly<{
  readonly result: InventoryPurchaseTraceResult;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryRecipeCostingPreviewV1 = Readonly<{
  readonly result: InventoryRecipeCosting;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemAvailabilityReactivateV1 = Readonly<{
  readonly result: InventoryStockItemAvailabilityRecoveryResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemCostListV1 = Readonly<{
  readonly result: InventoryStockItemCostList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemCostRecordV1 = Readonly<{
  readonly result: RecordInventoryStockItemCostResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemListV1 = Readonly<{
  readonly result: InventoryStockItemPage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemPublishedUsageListV1 = Readonly<{
  readonly result: InventoryPublishedIngredientUsagePage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemReconcileV1 = Readonly<{
  readonly result: ReconcileInventoryStockItemResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemRetireV1 = Readonly<{
  readonly result: InventoryStockItemCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemSupplySetV1 = Readonly<{
  readonly result: SetInventoryStockItemSupplyResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryStockItemYieldRecordV1 = Readonly<{
  readonly result: RecordInventoryStockItemYieldResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventoryStockPolicySetV1 = Readonly<{
  readonly result: RestaurantInventoryPolicyDecision;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventorySupplierCreateV1 = Readonly<{
  readonly result: InventorySupplierResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventorySupplierUpdateV1 = Readonly<{
  readonly result: InventorySupplierResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseInventorySupplyListV1 = Readonly<{
  readonly result: InventorySupplyList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseListCatalogDailySuggestions = Readonly<{
  readonly result: CatalogDailySuggestionList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseListCatalogDishNameSuggestions = Readonly<{
  readonly result: CatalogDishNameSuggestionList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseListCatalogDishTrials = Readonly<{
  readonly result: CatalogDishTrialList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseListCatalogPublications = Readonly<{
  readonly result: CatalogPublicationPage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseMaterializeCatalogMasterIngredient = Readonly<{
  readonly result: CatalogMasterIngredientMaterialization;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersBridgeDefinitionPutRevalidate = Readonly<{
  readonly result: OffersBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersBridgeDefinitionRetireRevalidate = Readonly<{
  readonly result: OffersBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersCouponCodeCancel = Readonly<{
  readonly result: OfferCouponCode;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersCouponCodeIssue = Readonly<{
  readonly result: OfferCouponCode;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersCouponCodeList = Readonly<{
  readonly result: OfferCouponCodePage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionArchive = Readonly<{
  readonly result: OfferDefinition;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionGet = Readonly<{
  readonly result: OfferDefinition;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionHistory = Readonly<{
  readonly result: OfferDefinitionHistoryPage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionMarketingReplay = Readonly<{
  readonly result: OfferMarketingReplay;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionPut = Readonly<{
  readonly result: OfferDefinition;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionRecallCoupons = Readonly<{
  readonly result: OfferCouponRecall;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionRedemptionConsumptionGet = Readonly<{
  readonly result: OfferDefinitionRedemptionConsumption;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionReopen = Readonly<{
  readonly result: OfferDefinition;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionRetire = Readonly<{
  readonly result: OfferDefinition;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOffersDefinitionUsesList = Readonly<{
  readonly result: OfferDefinitionUsePage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersMarketingBoardPageRead = Readonly<{
  readonly result: OfferDefinitionPage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersMarketingBoardRead = Readonly<{
  readonly result: OfferMarketingBoard;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOffersWalletList = Readonly<{
  readonly result: readonly (OfferGuestWalletEntry)[];
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOwnerCalendarCancel = Readonly<{
  readonly result: OwnerCalendarDeclaration;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseOwnerCalendarHistory = Readonly<{
  readonly result: OwnerCalendarHistory;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOwnerCalendarList = Readonly<{
  readonly result: OwnerCalendarList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseOwnerCalendarPut = Readonly<{
  readonly result: OwnerCalendarDeclaration;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteAdvisorLibraryReadV1 = Readonly<{
  readonly result: ParteAdvisorLibrary;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteAdvisorLibraryReviewV1 = Readonly<{
  readonly result: ParteAdvisorLibraryEntry;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteAiAuditReadV1 = Readonly<{
  readonly result: ParteAiAudit;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteAutonomyOfferAnswerV1 = Readonly<{
  readonly result: ParteAutonomy;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteAutonomyReadV1 = Readonly<{
  readonly result: ParteAutonomy;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteCartaReadingCorrectV1 = Readonly<{
  readonly result: ParteCartaReading;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteCartaReadingReadV1 = Readonly<{
  readonly result: ParteCartaReading;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteComplianceCalendarReadV1 = Readonly<{
  readonly result: ParteComplianceCalendar;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteComprasCallListReadV1 = Readonly<{
  readonly result: ParteCallList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteComprasFoodWastePlanAdoptV1 = Readonly<{
  readonly result: ParteFoodWastePlan;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteComprasFoodWastePlanReadV1 = Readonly<{
  readonly result: ParteFoodWastePlan;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteComprasFoodWastePlanUpdateDeclineV1 = Readonly<{
  readonly result: ParteFoodWastePlan;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteComprasPrepPlanReadV1 = Readonly<{
  readonly result: PartePrepPlan;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteConsejoReadV1 = Readonly<{
  readonly result: ParteConsejo;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteCostsDishesReadV1 = Readonly<{
  readonly result: ParteDishCosts;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteCostsRecipeBatchConfirmV1 = Readonly<{
  readonly result: ParteRecipeBatchReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteCostsRecipeBatchCorrectV1 = Readonly<{
  readonly result: ParteRecipeBatchCorrection;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteCostsRecipeBatchReadV1 = Readonly<{
  readonly result: ParteRecipeBatch;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteCostsRecipeBatchUndoV1 = Readonly<{
  readonly result: ParteRecipeBatchReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteCostsRecipeBatchWithdrawV1 = Readonly<{
  readonly result: ParteRecipeBatchReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteEditionAudioReadV1 = Readonly<{
  readonly result: ParteEditionAudio;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteEditionList = Readonly<{
  readonly result: ParteEditionList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteEditionRead = Readonly<{
  readonly result: ParteEdition;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteEncargoCreateV1 = Readonly<{
  readonly result: ParteEncargo;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteEncargoReadV1 = Readonly<{
  readonly result: ParteEncargo;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteEncargosReadV1 = Readonly<{
  readonly result: ParteEncargoList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteFinanzasDailyAccountReadV1 = Readonly<{
  readonly result: ParteFinanzasDailyAccountRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteFinanzasFixedCostsDeclareV1 = Readonly<{
  readonly result: ParteFixedCostsDeclaration;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteFinanzasLabourAveragesDeclareV1 = Readonly<{
  readonly result: ParteLabourAveragesDeclaration;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteFinanzasNumberOfTodayReadV1 = Readonly<{
  readonly result: ParteFinanzasNumberOfTodayRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteGoalConfirmV1 = Readonly<{
  readonly result: ParteGoalView;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteGoalCorrectV1 = Readonly<{
  readonly result: ParteGoalView;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteGoalDeclineV1 = Readonly<{
  readonly result: ParteGoalView;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteGoalSayV1 = Readonly<{
  readonly result: ParteGoalView;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteGoalsReadV1 = Readonly<{
  readonly result: ParteGoalsRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteGoalWithdrawV1 = Readonly<{
  readonly result: ParteGoalView;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteHouseMemoryReadV1 = Readonly<{
  readonly result: ParteHouseMemory;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteHoyReadV1 = Readonly<{
  readonly result: ParteHoy;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteMatterReadV1 = Readonly<{
  readonly result: ParteMatterRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteMattersReadV1 = Readonly<{
  readonly result: ParteMattersRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteMissingDataAnswerV1 = Readonly<{
  readonly result: ParteMissingDataAnswered;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteNotebookRead = Readonly<{
  readonly result: ParteNotebook;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteOperationApproveV1 = Readonly<{
  readonly result: ParteOperation;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteOperationDeclineV1 = Readonly<{
  readonly result: ParteOperation;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteOperationReadV1 = Readonly<{
  readonly result: ParteOperation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteOperationResolveV1 = Readonly<{
  readonly result: ParteOperation;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePartePactoLineConfirmV1 = Readonly<{
  readonly result: PartePacto;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePartePactoLinePutV1 = Readonly<{
  readonly result: PartePacto;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePartePactoLineRetireV1 = Readonly<{
  readonly result: PartePacto;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePartePactoReadV1 = Readonly<{
  readonly result: PartePacto;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponsePartePageNotesReadV1 = Readonly<{
  readonly result: PartePageNotes;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponsePartePendienteDismissV1 = Readonly<{
  readonly result: PartePendiente;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePartePendientesReadV1 = Readonly<{
  readonly result: PartePendientes;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponsePartePersonWithdraw = Readonly<{
  readonly result: PartePersonWithdrawal;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePartePushKeyReadV1 = Readonly<{
  readonly result: PartePushKey;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponsePartePushSubscriptionRegisterV1 = Readonly<{
  readonly result: PartePushSubscriptionResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePartePushSubscriptionRemoveV1 = Readonly<{
  readonly result: PartePushSubscriptionResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteQueueAnswerV1 = Readonly<{
  readonly result: ParteQueueItemView;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteQueueReadV1 = Readonly<{
  readonly result: ParteQueueRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteReputationDraftsReadV1 = Readonly<{
  readonly result: ParteReputationDrafts;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteReputationPostDraftUseV1 = Readonly<{
  readonly result: ParteReputationDrafts;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteReputationPostDraftWithdrawV1 = Readonly<{
  readonly result: ParteReputationDrafts;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteReputationReplyDraftSetAsideV1 = Readonly<{
  readonly result: ParteReputationDrafts;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteRequestOpenV1 = Readonly<{
  readonly result: ParteOwnerRequestView;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteRotaProposalReadV1 = Readonly<{
  readonly result: ParteRotaProposal;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteScheduledActionStopV1 = Readonly<{
  readonly result: ParteScheduledActionStopped;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteTeamActionUndoV1 = Readonly<{
  readonly result: ParteTeamActionUndoRequested;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteTeamCoachNoteShareV1 = Readonly<{
  readonly result: ParteCoach;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteTeamCoachReadV1 = Readonly<{
  readonly result: ParteCoach;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteTeamReadV1 = Readonly<{
  readonly result: ParteTeam;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteTeamStopSetV1 = Readonly<{
  readonly result: ParteTeamStop;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteVoiceAnswerSubmitV1 = Readonly<{
  readonly result: ParteVoiceAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteWhatIfClosedWeekdayReadV1 = Readonly<{
  readonly result: ParteWhatIfClosedWeekday;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteWhatIfDishPriceReadV1 = Readonly<{
  readonly result: ParteWhatIfDishPrice;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseParteWorkActV1 = Readonly<{
  readonly result: ParteWorkActed;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseParteWorkReadV1 = Readonly<{
  readonly result: ParteWork;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponsePatchCatalogDraftEntities = Readonly<{
  readonly result: CatalogDraftEntityPatchResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePreviewCatalogCartaFisica = Readonly<{
  readonly result: CatalogCartaFisicaPreview;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponsePreviewCatalogDishDerivation = Readonly<{
  readonly result: CatalogDishDerivationPreview;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseProposalCatalogReviewedPreparationRead = Readonly<{
  readonly result: CatalogReviewedPreparation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseProposalCatalogReviewedPrepare = Readonly<{
  readonly result: CatalogReviewedPreparation;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseProposalConfirm = Readonly<{
  readonly result: ProposalReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseProposalDecline = Readonly<{
  readonly result: ProposalReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseProposalIntentList = Readonly<{
  readonly result: ProposalIntentList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseProposalIntentRead = Readonly<{
  readonly result: ProposalIntentState;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseProposalPreview = Readonly<{
  readonly result: ProposalPreview;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseProposalUndo = Readonly<{
  readonly result: ProposalReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseProposeCatalogAiDishCopy = Readonly<{
  readonly result: CatalogAiDishCopyProposalResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseProposeCatalogAiPhotoEnhancement = Readonly<{
  readonly result: CatalogAiPhotoEnhancementProposalResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseProposeCatalogAiTranslation = Readonly<{
  readonly result: CatalogAiTranslationProposalResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponsePublishCatalog = Readonly<{
  readonly result: CatalogPublicationReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseReadCatalogAiPhotoEnhancementPreview = Readonly<{
  readonly result: CatalogMediaDelivery;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogAiProviderCredentialStatus = Readonly<{
  readonly result: CatalogAiProviderCredentialStatus;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogAiUsageMonth = Readonly<{
  readonly result: CatalogAiUsageMonth;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogCartaFisica = Readonly<{
  readonly result: CatalogCartaFisicaState;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogDraft = Readonly<{
  readonly result: CatalogDraft;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogDraftDocument = Readonly<{
  readonly result: CatalogDraftDocument;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogDraftPhotoRenditions = Readonly<{
  readonly result: CatalogDraftPhotoRenditions;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogDraftSummary = Readonly<{
  readonly result: CatalogDraftSummary;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogMediaDelivery = Readonly<{
  readonly result: CatalogMediaDelivery;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogMediaRenditions = Readonly<{
  readonly result: CatalogMediaRenditions;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogPublication = Readonly<{
  readonly result: CatalogPublication;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogReferenceDocument = Readonly<{
  readonly result: CatalogReferenceDocument;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogStockDeactivationWarning = Readonly<{
  readonly result: CatalogStockDeactivationWarning;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadCatalogWorkshopCandidate = Readonly<{
  readonly result: CatalogWorkshopCandidate;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadGuestCatalogMediaDelivery = Readonly<{
  readonly result: CatalogMediaDelivery;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadGuestDailySuggestions = Readonly<{
  readonly result: CatalogGuestDailySuggestions;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadGuestLiveCatalogue = Readonly<{
  readonly result: CatalogGuestLiveOverlay;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadGuestMenuDocuments = Readonly<{
  readonly result: CatalogGuestMenuDocuments;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadGuestPublishedCatalogue = Readonly<{
  readonly result: CatalogGuestPublishedCatalogue;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadGuestPublishedDish = Readonly<{
  readonly result: CatalogGuestPublishedDish;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadPreauthenticatedCatalogMediaDelivery = Readonly<{
  readonly result: CatalogPreauthenticatedMediaDelivery;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadPreauthenticatedFeaturedCatalog = Readonly<{
  readonly result: CatalogPreauthenticatedFeatured;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadPreauthenticatedGuestCatalogue = Readonly<{
  readonly result: CatalogGuestEntryCatalogue;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadPublishedCatalogue = Readonly<{
  readonly result: CatalogPublishedCatalogue;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadPublishedRestaurantConfiguration = Readonly<{
  readonly result: RestaurantConfigurationPublication;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReadRestaurantConfigurationCurrent = Readonly<{
  readonly result: RestaurantConfigurationCurrent;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRecordCatalogWorkshopTrial = Readonly<{
  readonly result: CatalogWorkshopTrial;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRefreshCatalogDraft = Readonly<{
  readonly result: CatalogDraft;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipBridgeLoyaltyProgramPutRevalidate = Readonly<{
  readonly result: RelationshipBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipElParteGuestReturnReadV1 = Readonly<{
  readonly result: RelationshipGuestReturnPanel;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewConnectionComplete = Readonly<{
  readonly result: CompleteRelationshipGoogleConnectionResponse;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewConnectionDisconnect = Readonly<{
  readonly result: RelationshipExternalReviewConnection;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewConnectionGet = Readonly<{
  readonly result: RelationshipExternalReviewConnection;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewConnectionSelect = Readonly<{
  readonly result: RelationshipExternalReviewConnection;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewConnectionStart = Readonly<{
  readonly result: StartRelationshipGoogleConnectionResponse;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewFranchiseSummariesGet = Readonly<{
  readonly result: RelationshipExternalReviewFranchiseSummaries;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewList = Readonly<{
  readonly result: readonly (RelationshipExternalReview)[];
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewReply = Readonly<{
  readonly result: RelationshipExternalReview;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewReplyDelete = Readonly<{
  readonly result: RelationshipExternalReview;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewReplyPublish = Readonly<{
  readonly result: RelationshipExternalReview;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipExternalReviewReplyUndo = Readonly<{
  readonly result: RelationshipExternalReview;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipFeedbackRecord = Readonly<{
  readonly result: RelationshipFeedback;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipGuestQuestionAnswerGuestV1 = Readonly<{
  readonly result: RelationshipGuestQuestionAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipGuestQuestionOfferReadGuestV1 = Readonly<{
  readonly result: RelationshipGuestQuestionOffer;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipGuestQuestionPutV1 = Readonly<{
  readonly result: RelationshipGuestQuestion;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipGuestQuestionReadV1 = Readonly<{
  readonly result: RelationshipGuestQuestion;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipGuestQuestionRemoveV1 = Readonly<{
  readonly result: RelationshipGuestQuestionRemoval;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipImpressionRecord = Readonly<{
  readonly result: RelationshipRecommendationImpression;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipLoyaltyPopulationGet = Readonly<{
  readonly result: RelationshipLoyaltyPopulation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipLoyaltyProgramAdminGet = Readonly<{
  readonly result: RelationshipLoyaltyProgram;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipLoyaltyProgramPut = Readonly<{
  readonly result: RelationshipLoyaltyProgram;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipLoyaltyProgramRetire = Readonly<{
  readonly result: RelationshipLoyaltyProgram;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipLoyaltyTierCatalogueList = Readonly<{
  readonly result: readonly (RelationshipLoyaltyTierCatalogueEntry)[];
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipPreferencesGet = Readonly<{
  readonly result: RelationshipPreferenceProfileRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipPreferencesReplace = Readonly<{
  readonly result: RelationshipPreferenceProfile;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipRecommendationAssign = Readonly<{
  readonly result: RelationshipRecommendationAssignment;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipRecommendationCurrentReadGuestV1 = Readonly<{
  readonly result: RelationshipRecommendationAssignment;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipRestaurantReviewsListV1 = Readonly<{
  readonly result: RelationshipRestaurantReviews;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipReviewOfferReadGuestV1 = Readonly<{
  readonly result: RelationshipReviewOffer;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipReviewStarsWeeklyReadV1 = Readonly<{
  readonly result: RelationshipReviewStarsWeekly;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRelationshipReviewSubmit = Readonly<{
  readonly result: RelationshipReviewSubmission;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseRelationshipReviewTopicsReadV1 = Readonly<{
  readonly result: RelationshipReviewTopics;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRestaurantConfigurationBridgeApplyRevalidate = Readonly<{
  readonly result: ConfigurationBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRestaurantConfigurationBridgeFloorRevalidate = Readonly<{
  readonly result: ConfigurationBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRestaurantConfigurationGeocodeSearchV1 = Readonly<{
  readonly result: GeocodeSearch;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseRestoreCatalogDraftFromPublication = Readonly<{
  readonly result: CatalogDraftEntityPatchResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseReviewCatalogDishCopy = Readonly<{
  readonly result: CatalogDishCopyReview;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseReviewCatalogPhotoCorrection = Readonly<{
  readonly result: CatalogPhotoCorrectionReview;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseSaveCatalogWorkshopCandidate = Readonly<{
  readonly result: CatalogWorkshopCandidate;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseSearchCatalogMasterIngredients = Readonly<{
  readonly result: CatalogMasterIngredientSearch;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseSearchIneMunicipalities = Readonly<{
  readonly result: IneMunicipalitySearch;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceArrivalReadGuestV1 = Readonly<{
  readonly result: ServiceGuestArrival;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceBillRequestAcceptFloorV2 = Readonly<{
  readonly result: ServiceBillRequestAcceptFloorAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceBillRequestAcceptV1 = Readonly<{
  readonly result: ServiceBillRequestAcceptResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceBillRequestReopenV1 = Readonly<{
  readonly result: ServiceBillRequestReopenResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceBridgeHistoryRevalidate = Readonly<{
  readonly result: ServiceBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceBridgeTableSessionForceCloseRevalidate = Readonly<{
  readonly result: ServiceBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCartDiscardStaffV1 = Readonly<{
  readonly result: ServiceCartDiscardResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemAddStaffV1 = Readonly<{
  readonly result: ServiceCartItemAddResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemAddV1 = Readonly<{
  readonly result: ServiceCartItemAddResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemCopyV1 = Readonly<{
  readonly result: ServiceCartItemCopyResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemRemoveStaffV1 = Readonly<{
  readonly result: ServiceCartItemRemoveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemRemoveV1 = Readonly<{
  readonly result: ServiceCartItemRemoveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemSafetyAcknowledgeV1 = Readonly<{
  readonly result: ServiceCartItemSafetyAcknowledgeResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemSafetyChallengeReadV1 = Readonly<{
  readonly result: ServiceSafetyChallenge;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCartItemStealUndoV1 = Readonly<{
  readonly result: ServiceCartItemStealUndoResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemStealV1 = Readonly<{
  readonly result: ServiceCartItemStealResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemUpdateStaffV1 = Readonly<{
  readonly result: ServiceCartItemUpdateResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartItemUpdateV1 = Readonly<{
  readonly result: ServiceCartItemUpdateResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartOpenStaffV1 = Readonly<{
  readonly result: ServiceCartOpenResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCartOpenV1 = Readonly<{
  readonly result: ServiceCartOpenResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCashDocumentArchiveReadV1 = Readonly<{
  readonly result: ServiceCashDocumentArchive;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCashMovementRecordV1 = Readonly<{
  readonly result: ServiceCashMovementRecordResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCashMovementVoidV1 = Readonly<{
  readonly result: ServiceCashMovementVoidResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCashPaymentMethodCorrectV1 = Readonly<{
  readonly result: ServiceCashPaymentMethodCorrectResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCashReadV1 = Readonly<{
  readonly result: ServiceCashRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCashSessionCloseV1 = Readonly<{
  readonly result: ServiceCashSessionCloseResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCashSessionCountV1 = Readonly<{
  readonly result: ServiceCashSessionCountResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCashSessionOpenV1 = Readonly<{
  readonly result: ServiceCashSessionOpenResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCashSessionsReadV1 = Readonly<{
  readonly result: ServiceCashSessionsRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCheckChargePlanReadStaffV1 = Readonly<{
  readonly result: ServiceCheckChargePlan;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCheckChargeReverseV1 = Readonly<{
  readonly result: ServiceCheckChargeReverseResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCheckChargeV1 = Readonly<{
  readonly result: ServiceCheckChargeResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCheckFinalizeV1 = Readonly<{
  readonly result: ServiceCheckFinalizeResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCheckLineWaiveV1 = Readonly<{
  readonly result: ServiceCheckLineWaiveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceCheckOrderLoyaltyReadStaffV1 = Readonly<{
  readonly result: ServiceStaffCheckOrderLoyalty;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCheckPaymentReadV1 = Readonly<{
  readonly result: ServiceCheckPaymentRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCheckRefundPreviewStaffV1 = Readonly<{
  readonly result: ServiceCheckRefundPreviewResult;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceCheckSplitV1 = Readonly<{
  readonly result: ServiceCheckSplitResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceClockReadV1 = Readonly<{
  readonly result: ServiceClockRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceDepartmentCategoriesReadV1 = Readonly<{
  readonly result: ServiceDepartmentCategories;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceDinerOfferChooseStaffV1 = Readonly<{
  readonly result: ServiceDinerOfferChooseResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceDinerOfferChooseV1 = Readonly<{
  readonly result: ServiceDinerOfferChooseResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceDinerOfferRemoveStaffV1 = Readonly<{
  readonly result: ServiceDinerOfferRemoveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceDinerOfferRemoveV1 = Readonly<{
  readonly result: ServiceDinerOfferRemoveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceForceCloseReclassifyV1 = Readonly<{
  readonly result: ServiceForceCloseReclassifyResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentDeliverBatchFloorV2 = Readonly<{
  readonly result: ServiceFulfillmentDeliverBatchFloorAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentDeliverBatchV1 = Readonly<{
  readonly result: ServiceFulfillmentDeliverBatchResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentPlanReadV1 = Readonly<{
  readonly result: ServiceFulfillmentPlanRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentRemakeKitchenV2 = Readonly<{
  readonly result: ServiceFulfillmentRemakeKitchenAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentRemakeV1 = Readonly<{
  readonly result: ServiceFulfillmentRemakeResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentTransitionFloorV2 = Readonly<{
  readonly result: ServiceFulfillmentTransitionFloorAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentTransitionKitchenV2 = Readonly<{
  readonly result: ServiceFulfillmentTransitionKitchenAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceFulfillmentTransitionV1 = Readonly<{
  readonly result: ServiceFulfillmentTransitionResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceHistoryReadGuestV1 = Readonly<{
  readonly result: ServiceGuestHistory;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceHistoryReadStaffV1 = Readonly<{
  readonly result: ServiceStaffHistory;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceHistorySummaryReadStaffV1 = Readonly<{
  readonly result: ServiceStaffHistorySummary;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceKitchenPendingWorkImpactedReadV1 = Readonly<{
  readonly result: ServiceKitchenPendingWork;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceManagerFulfillmentDeliverBatchFloorV2 = Readonly<{
  readonly result: ServiceManagerFulfillmentDeliverBatchFloorAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceManagerFulfillmentDeliverBatchV1 = Readonly<{
  readonly result: ServiceManagerFulfillmentDeliverBatchResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceManagerFulfillmentTransitionFloorV2 = Readonly<{
  readonly result: ServiceManagerFulfillmentTransitionFloorAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceManagerFulfillmentTransitionKitchenV2 = Readonly<{
  readonly result: ServiceManagerFulfillmentTransitionKitchenAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceManagerFulfillmentTransitionV1 = Readonly<{
  readonly result: ServiceManagerFulfillmentTransitionResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOfflineReviewReadV1 = Readonly<{
  readonly result: ServiceOfflineReviewRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceOfflineReviewResolveV1 = Readonly<{
  readonly result: ServiceOfflineReviewResolveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOfflineSegmentRecordV1 = Readonly<{
  readonly result: ServiceOfflineSegmentRecordResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderCancelStaffV1 = Readonly<{
  readonly result: ServiceOrderCancelResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderConfirmV1 = Readonly<{
  readonly result: ServiceOrderConfirmResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderItemAddV1 = Readonly<{
  readonly result: ServiceOrderItemAddResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderItemRemoveStaffV1 = Readonly<{
  readonly result: ServiceOrderItemRemoveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderItemRemoveV1 = Readonly<{
  readonly result: ServiceOrderItemRemoveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderItemUpdateStaffV1 = Readonly<{
  readonly result: ServiceOrderItemUpdateResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderItemUpdateV1 = Readonly<{
  readonly result: ServiceOrderItemUpdateResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderSubmitStaffV1 = Readonly<{
  readonly result: ServiceOrderSubmitResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceOrderSubmitV1 = Readonly<{
  readonly result: ServiceOrderSubmitResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceParticipantCreateV1 = Readonly<{
  readonly result: ServiceParticipantCreateResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceParticipantJoinV1 = Readonly<{
  readonly result: ServiceParticipantJoinResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceParticipantRequestBillV1 = Readonly<{
  readonly result: ServiceParticipantRequestBillResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceProbeReadV1 = Readonly<{
  readonly result: ServiceProbeRead;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceQrOrdersPauseSetV1 = Readonly<{
  readonly result: ServiceQrOrdersPauseSetResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceRefundRecordV3 = Readonly<{
  readonly result: ServiceCheckRefundRecordResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceSnapshotReadFloorV1 = Readonly<{
  readonly result: ServiceFloorSnapshot;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceSnapshotReadGuestV1 = Readonly<{
  readonly result: ServiceGuestSnapshot;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceSnapshotReadKitchenV1 = Readonly<{
  readonly result: ServiceKitchenSnapshot;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceSnapshotReadPosV1 = Readonly<{
  readonly result: ServicePosSnapshot;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceTableOccupancyImpactedReadV1 = Readonly<{
  readonly result: ServiceTableOccupancy;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseServiceTableSessionCloseV1 = Readonly<{
  readonly result: ServiceTableSessionCloseResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceTableSessionForceCloseV1 = Readonly<{
  readonly result: ServiceTableSessionForceCloseResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceTableSessionNobodyHereFloorV2 = Readonly<{
  readonly result: ServiceTableSessionNobodyHereFloorAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceTableSessionNobodyHereV1 = Readonly<{
  readonly result: ServiceTableSessionNobodyHereResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceTableSessionOpenV1 = Readonly<{
  readonly result: ServiceTableSessionOpenResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceTableSessionPartySizeSetV1 = Readonly<{
  readonly result: ServiceTableSessionPartySizeSetResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceWaitingRoomEnterV1 = Readonly<{
  readonly result: ServiceWaitingRoomEnterResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceWaitingRoomLeaveV1 = Readonly<{
  readonly result: ServiceWaitingRoomLeaveResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseServiceWaitingRoomReadV1 = Readonly<{
  readonly result: ServiceWaitingRoundSnapshot;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseSetCatalogAiProviderCredential = Readonly<{
  readonly result: CatalogAiProviderCredentialStatus;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseSetCatalogDailySuggestion = Readonly<{
  readonly result: CatalogDailySuggestion;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseUndoCatalogCartaChange = Readonly<{
  readonly result: CatalogCartaChangeReceipt;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseUndoCatalogDishCopy = Readonly<{
  readonly result: CatalogDishCopyChange;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseUndoCatalogDishNameSuggestion = Readonly<{
  readonly result: CatalogDishNameSuggestion;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseUndoCatalogPhotoCorrection = Readonly<{
  readonly result: CatalogPhotoCorrectionChange;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseUploadCatalogPhoto = Readonly<{
  readonly result: CatalogProvisionalMedia;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseValidateCatalogDraft = Readonly<{
  readonly result: CatalogValidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWithdrawCatalogDailySuggestion = Readonly<{
  readonly result: CatalogDailySuggestion;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceBridgeFeedbackCreateRevalidate = Readonly<{
  readonly result: WorkforceBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceBridgeStaffNoticeComposeRevalidate = Readonly<{
  readonly result: WorkforceBridgeStaffNoticeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceBridgeWorkTargetAssignmentBulkApplyRevalidate = Readonly<{
  readonly result: WorkforceBridgeRevalidation;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceEligibilitySetV1 = Readonly<{
  readonly result: WorkforceEligibilityCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceEmployeeAccessRecoverV1 = Readonly<{
  readonly result: WorkforceEmployeeAccessRecoveryResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceEmployeeDetailReadV1 = Readonly<{
  readonly result: WorkforceEmployeeDetail;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceEmployeeFeedbackReadV1 = Readonly<{
  readonly result: WorkforceFeedbackAlertList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceEmployeeKpiReadV3 = Readonly<{
  readonly result: WorkforceEmployeeKpiExpansion;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceEmployeeListV1 = Readonly<{
  readonly result: WorkforceEmployeePage;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceEmployeePictureSetV1 = Readonly<{
  readonly result: WorkforceEmployeePictureSetResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceEmploymentEndV1 = Readonly<{
  readonly result: WorkforceEmploymentCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceEmploymentRegisterV1 = Readonly<{
  readonly result: WorkforceEmploymentRegisterCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceEmploymentRestoreV1 = Readonly<{
  readonly result: WorkforceEmploymentCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceEmploymentSuspendV1 = Readonly<{
  readonly result: WorkforceEmploymentCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceEmploymentUpdateV1 = Readonly<{
  readonly result: WorkforceEmploymentCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceFeedbackAcknowledgeV1 = Readonly<{
  readonly result: WorkforceFeedbackCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceFeedbackCreateV1 = Readonly<{
  readonly result: WorkforceFeedbackCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceOperationalPresenceRenewV1 = Readonly<{
  readonly result: WorkforceOperationalSessionResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceOperationalSessionEnterFloorV2 = Readonly<{
  readonly result: WorkforceOperationalSessionEnterFloorAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceOperationalSessionEnterKitchenV2 = Readonly<{
  readonly result: WorkforceOperationalSessionEnterKitchenAnswer;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceOperationalSessionEnterV1 = Readonly<{
  readonly result: WorkforceOperationalSessionResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceRotaPublishV1 = Readonly<{
  readonly result: WorkforceRota;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceRotaReadV1 = Readonly<{
  readonly result: WorkforceRota;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceStaffNoticeComposeV1 = Readonly<{
  readonly result: WorkforceStaffNoticeComposeResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceStaffNoticeReadV1 = Readonly<{
  readonly result: WorkforceStaffNoticeState;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceStaffNoticeWithdrawV1 = Readonly<{
  readonly result: WorkforceStaffNoticeWithdrawResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceTeamOnPlanReadV1 = Readonly<{
  readonly result: WorkforceTeamOnPlan;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProductResponseWorkforceWorkTargetAssignmentAssignV1 = Readonly<{
  readonly result: WorkforceWorkTargetAssignmentCommandResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceWorkTargetAssignmentBulkApplyV1 = Readonly<{
  readonly result: WorkforceWorkTargetAssignmentBulkApplyResult;
  readonly statusCode: 200 | 201;
  readonly success: true;
}>
export type ProductResponseWorkforceWorkTargetAssignmentListV1 = Readonly<{
  readonly result: WorkforceWorkTargetAssignmentList;
  readonly statusCode: 200;
  readonly success: true;
}>
export type ProposalConfirmRequest = Readonly<{
  readonly intent_hash: string;
  readonly trial_date?: string;
  readonly without_companion_notice?: boolean;
}>
export type ProposalDecision = Readonly<{
  readonly applied_at: string | null;
  readonly approval_id: string | null;
  readonly command_receipt_id: string | null;
  readonly command_type: string | null;
  readonly decided_at: string;
  readonly decided_by_principal_id: string | null;
  readonly decision_id: string;
  readonly intent_id: string;
  readonly outcome: "accepted" | "accepted_not_applied" | "rejected" | "ignored" | "undone";
  readonly reason_code: "not_now" | "not_this_object" | "not_this_weekday" | "ask_later" | "disagree_with_data" | "already_handled" | "too_costly" | "mistake" | "preference" | "external_change" | "operational_need" | null;
  readonly result_ref: Readonly<{ readonly [key: string]: unknown }> | null;
  readonly result_version: number | null;
  readonly undoes_decision_id: string | null;
}>
export type ProposalDeclineRequest = Readonly<{
  readonly intent_hash: string;
  readonly reason_code: "not_now" | "not_this_object" | "not_this_weekday" | "ask_later" | "disagree_with_data" | "already_handled" | "too_costly" | null;
}>
export type ProposalEditionSource = Readonly<{
  readonly business_date: string;
  readonly edition_kind: "daily" | "weekly";
  readonly edition_version: number;
  readonly published_at: string;
}>
export type ProposalEvidenceRef = Readonly<{
  readonly id: string;
  readonly kind: string;
  readonly operation?: string;
}>
export type ProposalIntent = Readonly<{
  readonly case_id: string | null;
  readonly diff: Readonly<{ readonly [key: string]: unknown }>;
  readonly edition_id: string | null;
  readonly edition_source?: ProposalEditionSource;
  readonly evidence_sources: readonly (ProposalEvidenceRef)[];
  readonly expires_at: string;
  readonly intent_hash: string;
  readonly intent_id: string;
  readonly measurement_plan: ProposalMeasurementPlan | null;
  readonly object: Readonly<{
    readonly id: string;
    readonly type: string;
  }>;
  readonly policy_version: number;
  readonly prepared_at: string;
  readonly producer: "parte";
  readonly producer_principal_id: string;
  readonly proposal_type: "offers.definition.retire" | "offers.definition.put" | "offers.definition-set.create" | "restaurant.configuration.settings" | "catalog.reviewed-field.publish" | "catalog.reviewed-field.undo" | "workforce.staff-notice.send" | "catalog.daily-suggestion.set" | "catalog.carta-change.apply" | "relationship.win-back-pack.issue";
  readonly required_versions: Readonly<{ readonly [key: string]: number }>;
  readonly restaurant_id: string;
  readonly reversibility: "reversible" | "irreversible";
  readonly tenant_id: string;
}>
export type ProposalIntentList = Readonly<{
  readonly contract: "exylon.proposals.intent-list@1.0";
  readonly items: readonly (ProposalIntentState)[];
  readonly next_cursor: string | null;
  readonly restaurant_id: string;
}>
export type ProposalIntentListQuery = Readonly<{
  readonly case_id?: string;
  readonly cursor?: string;
  readonly edition_id?: string;
  readonly limit?: number;
}>
export type ProposalIntentState = Readonly<{
  readonly answer: ProposalDecision | null;
  readonly approval?: "one_tap";
  readonly contract: "exylon.proposals.intent-state@1.0";
  readonly ignored: ProposalDecision | null;
  readonly intent: ProposalIntent;
  readonly operation?: Readonly<{
    readonly operation_id: string;
    readonly version: number;
  }> | null;
  readonly superseded_by_intent_id?: string | null;
  readonly undo: ProposalDecision | null;
}>
export type ProposalMeasurementPlan = Readonly<{
  readonly direction: "increase" | "decrease";
  readonly measure_id: string;
  readonly subject?: Readonly<{
    readonly id: string;
    readonly type: string;
  }>;
  readonly window_days: number;
}>
export type ProposalPreview = Readonly<{
  readonly catalogReviewed?: CatalogReviewedProposalPreview | null;
  readonly expiresAt: string;
  readonly intentHash: string;
  readonly intentId: string;
  readonly lines: Readonly<{
    readonly cost: string;
    readonly followUp: string;
    readonly undo: string;
    readonly until: string;
    readonly whatChanges: string;
  }> | null;
  readonly observedAt: string;
  readonly ownerVersion: number | null;
  readonly reason: "scope_mismatch" | "intent_changed" | "unsupported_action" | "delegation_unusable" | "already_answered" | "expired" | "owner_unavailable" | "object_changed" | "superseded" | "source_changed" | "source_unavailable" | "price_during_service" | "price_too_soon" | "price_undo_window_closed" | null;
  readonly validity: "valid" | "stale" | "unavailable";
}>
export type ProposalReceipt = Readonly<{
  readonly contract: "exylon.proposals.receipt@1.0";
  readonly decision: ProposalDecision;
  readonly intent_hash: string;
  readonly intent_id: string;
  readonly replayed: boolean;
}>
export type ProposalUndoRequest = Readonly<{
  readonly intent_hash: string;
  readonly reason_code: "mistake" | "preference" | "external_change" | "operational_need" | null;
}>
export type PublicReadiness = Readonly<{
  readonly status: "ready" | "degraded" | "not_ready";
}>
export type PublishAccessPolicyRequest = Readonly<{
  readonly content_hash: string;
  readonly expected_active_policy_version: number;
  readonly expected_draft_revision: number;
  readonly review_hash: string;
}>
export type PublishCatalogRequest = Readonly<{
  readonly expected_published_version: number;
}>
export type PublishRelationshipExternalReviewReplyRequest = Readonly<{
  readonly account_name: string;
  readonly expected_connection_version: number;
  readonly expected_version: number;
  readonly external_id: string;
  readonly location_name: string;
  readonly review_updated_at: string;
}>
export type PutOfferDefinitionRequest = Readonly<{
  readonly definition: Readonly<{
    readonly amount_minor: number | null;
    readonly benefit_kind: "percentage" | "fixed_amount" | "free_item" | "buy_x_get_y";
    readonly buy_quantity: number;
    readonly currency: "EUR" | null;
    readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
    readonly end_local_time?: string | null;
    readonly feedback_only: boolean;
    readonly loyalty_tier_id: string | null;
    readonly maximum_discount_minor: number | null;
    readonly maximum_subtotal_minor: number | null;
    readonly minimum_party_size: number;
    readonly minimum_subtotal_minor: number;
    readonly name: string;
    readonly new_guest_only: boolean;
    readonly percentage_bps: number | null;
    readonly reward_catalog_item_id: string | null;
    readonly reward_item?: Readonly<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly reward_quantity: number;
    readonly reward_tier?: "bronze" | "silver" | "gold" | null;
    readonly scope_kind: "ticket" | "catalog_item" | "catalog_category" | "catalog_section";
    readonly start_local_time?: string | null;
    readonly targets: readonly (Readonly<{
        readonly target_id: string;
        readonly target_kind: "catalog_item" | "catalog_category" | "catalog_section";
      }>)[];
    readonly total_redemption_limit: number | null;
    readonly uses_per_guest?: "once" | "every_visit";
    readonly valid_from_date: string | null;
    readonly valid_to_date: string | null;
    readonly weekdays: readonly (number)[];
  }>;
  readonly expected_version: number;
  readonly issue_codes?: readonly (string)[];
  readonly reason_code?: string;
  readonly reason_note?: string;
}>
export type PutRelationshipGuestQuestionRequest = Readonly<{
  readonly answer_kind: "yes_no" | "faces";
  readonly expected_question_id: string | null;
  readonly prompt: string;
  readonly question_id: string;
}>
export type PutRelationshipLoyaltyProgramRequest = Readonly<{
  readonly card_style: "japanese_card" | "nature_card" | "luxury_metal_card" | "joyful_card";
  readonly expected_version: number;
  readonly maintenance_rate_bps?: number;
  readonly name: string;
  readonly progress_engine: "spend" | "visit" | "both";
  readonly qualification_window_months?: number;
  readonly review_reward_packs?: Readonly<{
    readonly high: readonly (Readonly<{
        readonly count: number;
        readonly reward_tier: "bronze" | "silver" | "gold";
      }>)[];
    readonly low: readonly (Readonly<{
        readonly count: number;
        readonly reward_tier: "bronze" | "silver" | "gold";
      }>)[];
    readonly medium: readonly (Readonly<{
        readonly count: number;
        readonly reward_tier: "bronze" | "silver" | "gold";
      }>)[];
  }>;
  readonly shield_streak_months?: number;
  readonly state: "active" | "stopped";
  readonly tiers: readonly (Readonly<{
      readonly cashback_bps: number;
      readonly id: string;
      readonly level_key: "basic" | "silver" | "gold" | "black";
      readonly name: string;
      readonly sort_order: number;
      readonly spend_threshold_minor: number;
      readonly staff_heads_up: boolean;
      readonly unlock_reward_pack?: readonly (Readonly<{
          readonly count: number;
          readonly reward_tier: "bronze" | "silver" | "gold";
        }>)[];
      readonly visit_threshold: number;
    }>)[];
}>
export type ReactivateInventoryStockItemAvailabilityRequest = Readonly<{
  readonly reason_code: string;
}>
export type ReadCurrentRelationshipRecommendationRequest = Readonly<{
  readonly catalog_publication_version: number;
  readonly client_session_id: string;
  readonly surface: string;
}>
export type ReadOfferMarketingBoardPageQuery = Readonly<{
  readonly family: "discounts" | "codes" | "rewards";
  readonly group: "active" | "scheduled" | "paused" | "ended";
  readonly page: number;
  readonly page_size: number;
}>
export type ReadPreauthenticatedFeaturedCatalogRequest = Readonly<{
  readonly scan_ticket: string;
  readonly table_id: string;
}>
export type ReadRelationshipGuestQuestionOfferRequest = Readonly<{
  readonly table_session_id: string;
}>
export type ReadRelationshipMinimisedReviewsRequest = Readonly<{
  readonly windows: readonly (Readonly<{
      readonly from: string;
      readonly kind: "business_day" | "last_7_days";
      readonly until: string;
    }>)[];
}>
export type ReadRelationshipReviewOfferRequest = Readonly<{
  readonly table_session_id: string;
}>
export type RecallOfferCouponsRequest = Readonly<{
  readonly expected_version: number;
  readonly reason_code: string;
}>
export type ReconcileInventoryStockItemRequest = Readonly<{
  readonly expected_on_hand_units?: number;
  readonly nearest_expiration_at?: string | null;
  readonly reason_code: "goods_received" | "inventory_count" | "waste" | "breakage" | "expired_product" | "error_correction";
  readonly reorder_point_units: number;
  readonly target_on_hand_units: number;
  readonly unit_cost?: Readonly<{
    readonly cost_minor: number;
    readonly per: "kg" | "l" | "unit";
  }>;
}> | Readonly<{
  readonly entered_stock: Readonly<{
    readonly reorder_point: string;
    readonly target_on_hand: string;
    readonly unit_code: "mg" | "g" | "kg" | "ml" | "l" | "unit";
  }>;
  readonly expected_on_hand_units?: number;
  readonly nearest_expiration_at?: string | null;
  readonly reason_code: "goods_received" | "inventory_count" | "waste" | "breakage" | "expired_product" | "error_correction";
  readonly unit_cost?: Readonly<{
    readonly cost_minor: number;
    readonly per: "kg" | "l" | "unit";
  }>;
}>
export type ReconcileInventoryStockItemResult = Readonly<{
  readonly operation: "stock-item.reconcile";
  readonly reconciliation: Readonly<{
    readonly batch_adjustments: readonly (Readonly<{
        readonly batch_id: string;
        readonly batch_version: number;
        readonly delta_units: number | number;
        readonly expires_at: string | null;
        readonly on_hand_after_units: number;
        readonly on_hand_before_units: number;
      }>)[];
    readonly nearest_expiration_after_at: string | null;
    readonly nearest_expiration_after_batch_id: string | null;
    readonly nearest_expiration_before_at: string | null;
    readonly nearest_expiration_before_batch_id: string | null;
    readonly on_hand_after_units: number;
    readonly on_hand_before_units: number;
    readonly on_hand_delta_units: number;
    readonly reorder_point_after_units: number;
    readonly reorder_point_before_units: number;
  }>;
  readonly resource_id: string;
  readonly stock_item: InventoryStockItem;
  readonly version: number;
}>
export type RecordGuestDiagnosticsRequest = Readonly<{
  readonly app_build: string;
  readonly counters: readonly (Readonly<{
      readonly counter: "guest_mobile.command.failure" | "guest_mobile.contract.validation_failure" | "guest_mobile.realtime.controlled_hydrate_recovery" | "guest_mobile.realtime.dedupe_hit" | "guest_mobile.socket.reconnect" | "guest_mobile.cart_mutation.rollback" | "guest_mobile.checkout_payment.failure" | "guest_mobile.active_session_restore.failure" | "guest_mobile.alias.consumption" | "guest_mobile.realtime.invalid_patch_payload";
      readonly occurred_at: string;
      readonly tags: readonly (Readonly<{
          readonly key: "aggregate_kind" | "alias" | "command" | "contract" | "event_name" | "phase" | "reason" | "recovery" | "room_count" | "source" | "stage" | "surface";
          readonly value: string;
        }>)[];
      readonly value: number;
    }>)[];
}>
export type RecordInventoryStockItemCostRequest = Readonly<{
  readonly expected_cost_version: number;
  readonly unit_cost: Readonly<{
    readonly cost_minor: number;
    readonly per: "kg" | "l" | "unit";
  }>;
}>
export type RecordInventoryStockItemCostResult = Readonly<{
  readonly cost: Readonly<{
    readonly cost_minor: number;
    readonly cost_version: number;
    readonly currency: "EUR";
    readonly origin: "purchase_document" | "typed" | "invoice_correction";
    readonly per: "kg" | "l" | "unit";
    readonly purchase_document_id: string | null;
    readonly received_quantity_units: number | null;
    readonly recorded_at: string;
    readonly recorded_by: string;
    readonly source: "goods_receipt" | "manual" | "invoice_correction";
    readonly supplier_id: string | null;
  }>;
  readonly operation: "stock-item.cost.record";
  readonly stock_item_id: string;
  readonly stock_item_version: number;
}>
export type RecordInventoryStockItemYieldRequest = Readonly<{
  readonly expected_yield_version: number;
  readonly loss_bps: number | null;
}>
export type RecordInventoryStockItemYieldResult = Readonly<{
  readonly operation: "stock-item.yield.record";
  readonly stock_item_id: string;
  readonly stock_item_version: number;
  readonly yield: Readonly<{
    readonly loss_bps: number | null;
    readonly recorded_at: string;
    readonly recorded_by: string;
    readonly yield_version: number;
  }>;
}>
export type RecordRelationshipFeedbackRequest = Readonly<{
  readonly occurred_at: string;
  readonly outcome: "viewed" | "clicked" | "added" | "ordered" | "paid" | "reviewed" | "dismissed";
  readonly recommendation_assignment_id: string;
  readonly recommendation_item_id: string;
  readonly source_id: string;
  readonly source_order_id: string | null;
  readonly source_type: "guest_interaction" | "service_order" | "service_payment";
}>
export type RecordRelationshipRecommendationImpressionRequest = Readonly<{
  readonly exposure_ms: number;
  readonly occurred_at: string;
  readonly recommendation_assignment_id: string;
  readonly recommendation_item_id: string;
  readonly surface: string;
  readonly visibility_proven: boolean;
}>
export type RefundOfferRedemptionRequest = Readonly<{
  readonly expected_version: 1;
  readonly reason_code: string;
  readonly redemption_id: string;
  readonly service_order_id: string;
  readonly service_refund_id: string;
}>
export type RelationshipAssignmentRefreshRequiredHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode: "ASSIGNMENT_REFRESH_REQUIRED";
    readonly reason_text?: string;
  }>;
  readonly message: string;
  readonly statusCode: 409;
}>
export type RelationshipBridgeProgramQuery = Readonly<{
  readonly cashback_bps?: string;
  readonly count?: string;
  readonly expected_version?: string;
  readonly form: "relationship.loyalty-program.put";
  readonly review_bucket?: string;
  readonly reward_tier?: string;
  readonly state?: string;
  readonly tier_id?: string;
}>
export type RelationshipBridgeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.relationship.bridge-revalidation@1.0";
  readonly form: "relationship.loyalty-program.put";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{ readonly [key: string]: string | number | boolean | readonly (string)[] | readonly (number)[] }>;
  readonly verdict: "open" | "refused";
}>
export type RelationshipConfigurationUnavailableHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly cause: "relationship_public_review_url_duplicate" | "relationship_public_review_url_string_required" | "relationship_public_review_url_bounds_invalid" | "relationship_public_review_url_https_required" | "relationship_public_review_url_credentials_forbidden" | "relationship_public_review_url_destination_invalid";
    readonly errorCode: "RELATIONSHIP_CONFIGURATION_REFUSED";
    readonly reason_text?: string;
    readonly setting_key: "relationship.public_review_url";
  }>;
  readonly message: string;
  readonly statusCode: 503;
}>
export type RelationshipConstraintLookupFailedHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly errorCode: "RELATIONSHIP_CONSTRAINT_LOOKUP_FAILED";
    readonly reason_text?: string;
  }>;
  readonly message: string;
  readonly statusCode: 503;
}>
export type RelationshipDishBadge = Readonly<{
  readonly code: "star_dish" | "popular_today" | "top_rated" | "most_ordered" | "regulars_reorder" | "loved_before" | "ordered_before" | "likely_love" | "new_match" | "table_favorite";
  readonly scope: "personal" | "restaurant";
}>
export type RelationshipElParteGuestReturn = Readonly<{
  readonly codes: readonly (Readonly<{
      readonly allowed_guests: number;
      readonly definition_id: string;
      readonly identified_guests: number;
      readonly new_guests: number | null;
      readonly returning_guests: number | null;
      readonly suppressed: boolean;
      readonly unidentified_uses: number;
      readonly uses: number;
    }>)[];
  readonly contract: "exylon.relationship.el-parte-guest-return@1.0";
  readonly conversion: Readonly<{
    readonly cohorts: readonly (Readonly<{
        readonly cohort_from: string;
        readonly cohort_until: string;
        readonly first_timers: number;
        readonly returned: number;
        readonly suppressed: false;
      }> | Readonly<{
        readonly cohort_from: string;
        readonly cohort_until: string;
        readonly first_timers: null;
        readonly returned: null;
        readonly suppressed: true;
      }>)[];
    readonly follow_up_days: 28;
  }>;
  readonly from: string;
  readonly guests: Readonly<{
    readonly allowed: number;
    readonly identified: number;
  }>;
  readonly minimum_group: 5;
  readonly observed_at: string;
  readonly population: "identified_guests_allowed_for_analytics";
  readonly regulars: Readonly<{
    readonly lapse_days: 45;
    readonly lapsed: number;
    readonly minimum_visits: 3;
    readonly newly_lapsed: number | null;
    readonly regulars: number;
    readonly suppressed: false;
  }> | Readonly<{
    readonly lapse_days: 45;
    readonly lapsed: null;
    readonly minimum_visits: 3;
    readonly newly_lapsed: null;
    readonly regulars: null;
    readonly suppressed: true;
  }>;
  readonly restaurant_id: string;
  readonly status: "available";
  readonly tenant_id: string;
  readonly until: string;
  readonly visit: "closed_table_session_service_day";
  readonly week_start: string;
  readonly weeks: readonly (Readonly<{
      readonly guests: number;
      readonly new: number;
      readonly returning: number;
      readonly suppressed: false;
      readonly week_start: string;
    }> | Readonly<{
      readonly guests: null;
      readonly new: null;
      readonly returning: null;
      readonly suppressed: true;
      readonly week_start: string;
    }>)[];
}> | Readonly<{
  readonly contract: "exylon.relationship.el-parte-guest-return@1.0";
  readonly from: string;
  readonly minimum_group: 5;
  readonly observed_at: string;
  readonly population: "identified_guests_allowed_for_analytics";
  readonly reason: "source_incomplete" | "owner_source_capacity_exceeded";
  readonly restaurant_id: string;
  readonly status: "no_data";
  readonly tenant_id: string;
  readonly until: string;
  readonly visit: "closed_table_session_service_day";
  readonly week_start: string;
}>
export type RelationshipExternalReview = Readonly<{
  readonly account_name: string;
  readonly comment: string | null;
  readonly created_at: string;
  readonly draft_action: "update" | "delete" | null;
  readonly draft_comment: string | null;
  readonly external_id: string;
  readonly failure_reason: string | null;
  readonly id: string;
  readonly location_name: string;
  readonly provider: "google";
  readonly reply_comment: string | null;
  readonly reply_confirmed_at: string | null;
  readonly reply_receipt_id: string | null;
  readonly reply_state: "none" | "pending" | "indeterminate" | "published" | "failed";
  readonly reply_updated_at: string | null;
  readonly reviewer_name: string | null;
  readonly stars: number;
  readonly updated_at: string;
  readonly version: number;
}>
export type RelationshipExternalReviewConnection = Readonly<{
  readonly account_name: string | null;
  readonly capability: "available" | "pending_google_enablement";
  readonly failure_reason: string | null;
  readonly last_synced_at: string | null;
  readonly location_name: string | null;
  readonly location_title: string | null;
  readonly provider: "google";
  readonly review_url: string | null;
  readonly state: "connected" | "disconnected" | "error";
  readonly version: number;
}>
export type RelationshipExternalReviewFranchiseSummaries = readonly (RelationshipExternalReviewSummary)[]
export type RelationshipExternalReviewSummary = Readonly<{
  readonly connected: boolean;
  readonly received_count: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly unanswered_count: number;
}>
export type RelationshipFeedback = Readonly<{
  readonly analytics_consent: boolean;
  readonly consent_captured_at: string;
  readonly consent_version: number | null;
  readonly contract: "exylon.relationship.feedback@2.0";
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly occurred_at: string;
  readonly outcome: "viewed" | "clicked" | "added" | "ordered" | "paid" | "reviewed" | "dismissed";
  readonly personalization_consent: boolean;
  readonly recommendation_assignment_id: string;
  readonly recommendation_item_id: string;
  readonly restaurant_id: string;
  readonly source_id: string;
  readonly source_type: "guest_interaction" | "service_order" | "service_payment";
  readonly tenant_id: string;
}>
export type RelationshipGoogleLocation = Readonly<{
  readonly account_name: string;
  readonly location_name: string;
  readonly review_url: string | null;
  readonly title: string;
}>
export type RelationshipGuestLoyaltyProgram = Readonly<{
  readonly card_style: "japanese_card" | "nature_card" | "luxury_metal_card" | "joyful_card";
  readonly contract: "exylon.relationship.loyalty-program@1.0";
  readonly currency: "EUR";
  readonly id: string;
  readonly maintenance_rate_bps?: number;
  readonly name: string;
  readonly points_denominator_minor: 100;
  readonly points_numerator: 1;
  readonly progress_engine: "spend" | "visit" | "both";
  readonly qualification_window_months?: number;
  readonly restaurant_id: string;
  readonly shield_streak_months?: number;
  readonly state: "active" | "stopped" | "retired";
  readonly tenant_id: string;
  readonly tiers: readonly (Readonly<{
      readonly cashback_bps: number;
      readonly id: string;
      readonly level_key: "basic" | "silver" | "gold" | "black";
      readonly name: string;
      readonly sort_order: number;
      readonly spend_threshold_minor: number;
      readonly unlock_reward_pack?: readonly (Readonly<{
          readonly count: number;
          readonly reward_tier: "bronze" | "silver" | "gold";
        }>)[];
      readonly visit_threshold: number;
    }>)[];
  readonly updated_at: string;
  readonly version: number;
}>
export type RelationshipGuestQuestion = Readonly<{
  readonly asked: number;
  readonly contract: "exylon.relationship.guest-question@1.0";
  readonly minimum_group: 3;
  readonly question: Readonly<{
    readonly answer_kind: "yes_no" | "faces";
    readonly answers: Readonly<{
      readonly options: readonly (Readonly<{
          readonly answer: "yes" | "no" | "bad" | "ok" | "good";
          readonly count: number;
        }>)[];
      readonly status: "available";
      readonly total: number;
    }> | Readonly<{
      readonly reason: "below_minimum_group";
      readonly status: "no_data";
    }> | Readonly<{
      readonly status: "no_answers";
    }>;
    readonly prompt: string;
    readonly put_at: string;
    readonly put_by: "manager" | "team";
    readonly question_id: string;
  }> | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type RelationshipGuestQuestionAnswer = Readonly<{
  readonly contract: "exylon.relationship.guest-question-answer@1.0";
  readonly recorded: boolean;
}>
export type RelationshipGuestQuestionOffer = Readonly<{
  readonly contract: "exylon.relationship.guest-question-offer@1.0";
  readonly question: Readonly<{
    readonly answer_kind: "yes_no" | "faces";
    readonly answers: readonly ("yes" | "no" | "bad" | "ok" | "good")[];
    readonly prompt: string;
    readonly question_id: string;
  }> | null;
  readonly table_session_id: string;
}>
export type RelationshipGuestQuestionRemoval = Readonly<{
  readonly contract: "exylon.relationship.guest-question-removal@1.0";
  readonly question_id: string;
  readonly removed: boolean;
}>
export type RelationshipGuestQuestionResults = Readonly<{
  readonly from: string;
  readonly minimum_group: 3;
  readonly questions: readonly (Readonly<{
      readonly answer_kind: "yes_no" | "faces";
      readonly answers: Readonly<{
        readonly options: readonly (Readonly<{
            readonly answer: "yes" | "no" | "bad" | "ok" | "good";
            readonly count: number;
          }>)[];
        readonly status: "available";
        readonly total: number;
      }> | Readonly<{
        readonly reason: "below_minimum_group";
        readonly status: "no_data";
      }> | Readonly<{
        readonly status: "no_answers";
      }>;
      readonly prompt: string;
      readonly put_at: string;
      readonly put_by: "manager" | "team";
      readonly question_id: string;
      readonly shown_until: string | null;
    }>)[];
  readonly restaurant_id: string;
  readonly source_version: "relationship.guest-question-results.v1";
  readonly tenant_id: string;
  readonly until: string;
}>
export type RelationshipGuestReturnPanel = Readonly<{
  readonly closed_week: RelationshipElParteGuestReturn;
  readonly contract: "exylon.relationship.guest-return-panel@1.0";
  readonly first_service_on: string | null;
  readonly history?: Readonly<{
    readonly lapsed: Readonly<{
      readonly coverage: Readonly<{
        readonly expected: number;
        readonly observed: number;
        readonly state: "complete" | "partial" | "young";
      }>;
      readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
      readonly normal: Readonly<{
        readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
        readonly estimate: boolean;
        readonly hi: number;
        readonly lo: number;
        readonly mid: number | null;
        readonly observed: number;
        readonly window?: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }> | null;
      readonly of: string;
      readonly points: readonly (Readonly<{
          readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
          readonly days?: Readonly<{
            readonly observed: number;
            readonly of: number;
          }>;
          readonly part?: string;
          readonly partial?: true;
          readonly partial_reason?: "running" | "opened" | "uncounted";
          readonly range?: Readonly<{
            readonly hi: number;
            readonly lo: number;
          }>;
          readonly value: number | null;
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }>)[];
      readonly previous?: readonly (Readonly<{
          readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
          readonly days?: Readonly<{
            readonly observed: number;
            readonly of: number;
          }>;
          readonly part?: string;
          readonly partial?: true;
          readonly partial_reason?: "running" | "opened" | "uncounted";
          readonly range?: Readonly<{
            readonly hi: number;
            readonly lo: number;
          }>;
          readonly value: number | null;
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }>)[];
      readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
    }>;
    readonly returning: Readonly<{
      readonly coverage: Readonly<{
        readonly expected: number;
        readonly observed: number;
        readonly state: "complete" | "partial" | "young";
      }>;
      readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
      readonly normal: Readonly<{
        readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
        readonly estimate: boolean;
        readonly hi: number;
        readonly lo: number;
        readonly mid: number | null;
        readonly observed: number;
        readonly window?: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }> | null;
      readonly of: string;
      readonly points: readonly (Readonly<{
          readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
          readonly days?: Readonly<{
            readonly observed: number;
            readonly of: number;
          }>;
          readonly part?: string;
          readonly partial?: true;
          readonly partial_reason?: "running" | "opened" | "uncounted";
          readonly range?: Readonly<{
            readonly hi: number;
            readonly lo: number;
          }>;
          readonly value: number | null;
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }>)[];
      readonly previous?: readonly (Readonly<{
          readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
          readonly days?: Readonly<{
            readonly observed: number;
            readonly of: number;
          }>;
          readonly part?: string;
          readonly partial?: true;
          readonly partial_reason?: "running" | "opened" | "uncounted";
          readonly range?: Readonly<{
            readonly hi: number;
            readonly lo: number;
          }>;
          readonly value: number | null;
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }>)[];
      readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
    }>;
    readonly returning_weeks?: Readonly<{
      readonly coverage: Readonly<{
        readonly expected: number;
        readonly observed: number;
        readonly state: "complete" | "partial" | "young";
      }>;
      readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
      readonly normal: Readonly<{
        readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
        readonly estimate: boolean;
        readonly hi: number;
        readonly lo: number;
        readonly mid: number | null;
        readonly observed: number;
        readonly window?: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }> | null;
      readonly of: string;
      readonly points: readonly (Readonly<{
          readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
          readonly days?: Readonly<{
            readonly observed: number;
            readonly of: number;
          }>;
          readonly part?: string;
          readonly partial?: true;
          readonly partial_reason?: "running" | "opened" | "uncounted";
          readonly range?: Readonly<{
            readonly hi: number;
            readonly lo: number;
          }>;
          readonly value: number | null;
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }>)[];
      readonly previous?: readonly (Readonly<{
          readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
          readonly days?: Readonly<{
            readonly observed: number;
            readonly of: number;
          }>;
          readonly part?: string;
          readonly partial?: true;
          readonly partial_reason?: "running" | "opened" | "uncounted";
          readonly range?: Readonly<{
            readonly hi: number;
            readonly lo: number;
          }>;
          readonly value: number | null;
          readonly window: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }>)[];
      readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
    }>;
  }>;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly to_date: RelationshipGuestReturnToDate;
}>
export type RelationshipGuestReturnPanelRequest = Readonly<{
  readonly restaurant_id?: string;
  readonly week_start?: string;
}>
export type RelationshipGuestReturnToDate = Readonly<{
  readonly contract: "exylon.relationship.guest-return-to-date@1.0";
  readonly from: string;
  readonly guests: Readonly<{
    readonly allowed: number;
    readonly identified: number;
  }>;
  readonly minimum_group: 5;
  readonly observed_at: string;
  readonly population: "identified_guests_allowed_for_analytics";
  readonly regulars: Readonly<{
    readonly lapse_days: 45;
    readonly lapsed: number;
    readonly minimum_visits: 3;
    readonly regulars: number;
    readonly suppressed: false;
  }> | Readonly<{
    readonly lapse_days: 45;
    readonly lapsed: null;
    readonly minimum_visits: 3;
    readonly regulars: null;
    readonly suppressed: true;
  }>;
  readonly restaurant_id: string;
  readonly returned: Readonly<{
    readonly guests: number;
    readonly minimum_visits: 2;
    readonly suppressed: false;
  }> | Readonly<{
    readonly guests: null;
    readonly minimum_visits: 2;
    readonly suppressed: true;
  }>;
  readonly service_day: string;
  readonly status: "available";
  readonly tenant_id: string;
  readonly visit: "closed_table_session_service_day";
}> | Readonly<{
  readonly contract: "exylon.relationship.guest-return-to-date@1.0";
  readonly from: string;
  readonly minimum_group: 5;
  readonly observed_at: string;
  readonly population: "identified_guests_allowed_for_analytics";
  readonly reason: "source_incomplete" | "owner_source_capacity_exceeded";
  readonly restaurant_id: string;
  readonly service_day: string;
  readonly status: "no_data";
  readonly tenant_id: string;
  readonly visit: "closed_table_session_service_day";
}>
export type RelationshipLoyaltyAccount = Readonly<{
  readonly cashback_balance_minor: number;
  readonly cashback_currency: "EUR" | null;
  readonly contract: "exylon.relationship.loyalty-account@1.0";
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly lifetime_earned_points: number;
  readonly points_balance: number;
  readonly program_id: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly tier_id: string | null;
  readonly updated_at: string;
  readonly version: number;
}>
export type RelationshipLoyaltyDecision = Readonly<{
  readonly contract: "exylon.relationship.loyalty-decision@1.0";
  readonly decided_at: string;
  readonly decision_fingerprint: string;
  readonly guest_profile_id: string | null;
  readonly program_currency: "EUR" | null;
  readonly program_id: string | null;
  readonly program_state: "active" | "stopped" | "retired" | null;
  readonly program_version: number | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly tier: Readonly<{
    readonly id: string;
    readonly label?: string | null;
    readonly name: string;
    readonly sort_order?: number;
  }> | null;
  readonly tier_id: string | null;
}>
export type RelationshipLoyaltyEarnResponse = RelationshipLoyaltyAccount | null
export type RelationshipLoyaltyMonthClose = Readonly<{
  readonly closed_month: string | null;
  readonly contract: "exylon.relationship.loyalty-month-close@1.0";
  readonly next_after_account_id: string | null;
  readonly program_version: number | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly transitions: readonly (Readonly<{
      readonly account_id: string;
      readonly demoted: boolean;
      readonly previous_tier_id: string | null;
      readonly protected: boolean;
      readonly shield_earned: boolean;
      readonly streak_advanced: boolean;
      readonly streak_broken: boolean;
      readonly streak_months: number;
      readonly tier_id: string | null;
      readonly window_end_month: string;
      readonly window_start_month: string;
    }>)[];
}>
export type RelationshipLoyaltyPopulation = Readonly<{
  readonly contract: "exylon.relationship.loyalty-population@1.0";
  readonly tiers: readonly (Readonly<{
      readonly count: number;
      readonly name: string;
      readonly sort_order: number;
      readonly tier_id: string;
    }>)[];
  readonly total_linked_accounts: number;
  readonly unassigned_count: number;
}>
export type RelationshipLoyaltyProgram = Readonly<{
  readonly card_style: "japanese_card" | "nature_card" | "luxury_metal_card" | "joyful_card";
  readonly contract: "exylon.relationship.loyalty-program@1.0";
  readonly currency: "EUR";
  readonly id: string;
  readonly maintenance_rate_bps?: number;
  readonly name: string;
  readonly points_denominator_minor: 100;
  readonly points_numerator: 1;
  readonly progress_engine: "spend" | "visit" | "both";
  readonly qualification_window_months?: number;
  readonly restaurant_id: string;
  readonly review_reward_packs?: Readonly<{
    readonly high: readonly (Readonly<{
        readonly count: number;
        readonly reward_tier: "bronze" | "silver" | "gold";
      }>)[];
    readonly low: readonly (Readonly<{
        readonly count: number;
        readonly reward_tier: "bronze" | "silver" | "gold";
      }>)[];
    readonly medium: readonly (Readonly<{
        readonly count: number;
        readonly reward_tier: "bronze" | "silver" | "gold";
      }>)[];
  }>;
  readonly shield_streak_months?: number;
  readonly state: "active" | "stopped" | "retired";
  readonly tenant_id: string;
  readonly tiers: readonly (Readonly<{
      readonly cashback_bps: number;
      readonly id: string;
      readonly level_key: "basic" | "silver" | "gold" | "black";
      readonly name: string;
      readonly sort_order: number;
      readonly spend_threshold_minor: number;
      readonly staff_heads_up: boolean;
      readonly unlock_reward_pack?: readonly (Readonly<{
          readonly count: number;
          readonly reward_tier: "bronze" | "silver" | "gold";
        }>)[];
      readonly visit_threshold: number;
    }>)[];
  readonly unlock_pack_regrants?: readonly (Readonly<{
      readonly member_count: number;
      readonly tier_id: string;
    }>)[];
  readonly updated_at: string;
  readonly version: number;
}>
export type RelationshipLoyaltyTierCatalogueEntry = Readonly<{
  readonly id: string;
  readonly name: string;
  readonly sort_order: number;
}>
export type RelationshipLoyaltyTierState = Readonly<{
  readonly account_id: string;
  readonly consecutive_below_maintenance: number;
  readonly contract: "exylon.relationship.loyalty-tier-state@1.0";
  readonly current_tier_id: string | null;
  readonly evaluated_at: string;
  readonly last_closed_month: string | null;
  readonly program_version: number;
  readonly restaurant_id: string;
  readonly shield_window_start_month: string | null;
  readonly shields_consumed: number;
  readonly shields_earned: number;
  readonly streak_months: number;
  readonly tenant_id: string;
  readonly version: number;
  readonly window_end_month: string;
  readonly window_start_month: string;
}>
export type RelationshipMinimisedReviews = Readonly<{
  readonly contract: "exylon.relationship.minimised-reviews@1.0";
  readonly population: "internal_reviews_by_submitted_at";
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly windows: readonly (Readonly<{
      readonly from: string;
      readonly kind: "business_day" | "last_7_days";
      readonly reviews: Readonly<{
        readonly status: "available";
        readonly value: Readonly<{
          readonly average_tenths: number;
          readonly categories: readonly (Readonly<{
              readonly average_tenths: number;
              readonly count: number;
              readonly key: "food" | "service" | "ambience";
            }>)[];
          readonly count: number;
          readonly review_ids: readonly (string)[];
        }>;
      }> | Readonly<{
        readonly reason: "no_observations";
        readonly status: "no_data";
      }>;
      readonly until: string;
    }>)[];
}>
export type RelationshipOffersLoyaltyTierOrders = Readonly<{
  readonly program_id: string | null;
  readonly program_state: "active" | "stopped" | "retired" | null;
  readonly tiers: readonly (Readonly<{
      readonly sort_order: number;
      readonly tier_id: string;
    }>)[];
}>
export type RelationshipPreferenceProfile = Readonly<{
  readonly constraints: readonly (Readonly<{
      readonly code: string;
      readonly hard: boolean;
      readonly kind: "allergen" | "dietary" | "ingredient_exclusion" | "do_not_recommend";
      readonly reference_id: string | null;
    }>)[];
  readonly contract: "exylon.relationship.preference-profile@1.0";
  readonly guest_profile_id: string;
  readonly id: string;
  readonly preferred_dish_ids: readonly (string)[];
  readonly restaurant_id: string | null;
  readonly scope: "global" | "restaurant" | "session";
  readonly session_id: string | null;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type RelationshipPreferenceProfileRead = Readonly<{
  readonly contract: "exylon.relationship.preference-read@1.0";
  readonly profile: RelationshipPreferenceProfile | null;
}>
export type RelationshipRecommendationAssignment = Readonly<{
  readonly algorithm: "deterministic_preference_v1";
  readonly assigned_at: string;
  readonly badge_aggregate_version: number | null;
  readonly catalog_publication_version: number;
  readonly client_session_id: string;
  readonly contract: "exylon.relationship.recommendation-assignment@2.0";
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly items: readonly (Readonly<{
      readonly badge: Readonly<{
        readonly code: "star_dish" | "popular_today" | "top_rated" | "most_ordered" | "regulars_reorder" | "loved_before" | "ordered_before" | "likely_love" | "new_match" | "table_favorite";
        readonly scope: "personal" | "restaurant";
      }> | null;
      readonly dish_id: string;
      readonly group: "body";
      readonly id: string;
      readonly rank: number;
      readonly reasons: readonly (Readonly<{
          readonly canonical_id: string;
          readonly code: string;
          readonly icon_code: string;
          readonly kind: "allergen" | "dietary" | "ingredient" | "coverage_caution";
          readonly outcome: "contains" | "may_contain" | "conflict" | "incomplete" | "unknown";
        }>)[];
    }> | Readonly<{
      readonly badge: null;
      readonly dish_id: string;
      readonly group: "safety_tail";
      readonly id: string;
      readonly rank: number;
      readonly reasons: readonly (Readonly<{
          readonly canonical_id: string;
          readonly code: string;
          readonly icon_code: string;
          readonly kind: "allergen" | "dietary" | "ingredient" | "coverage_caution";
          readonly outcome: "contains" | "may_contain" | "conflict" | "incomplete" | "unknown";
        }>)[];
    }>)[];
  readonly personalization_applied: boolean;
  readonly restaurant_id: string;
  readonly source_fingerprint: string;
  readonly surface: string;
  readonly tenant_id: string;
}>
export type RelationshipRecommendationImpression = Readonly<{
  readonly analytics_consent: boolean;
  readonly consent_captured_at: string;
  readonly consent_version: number | null;
  readonly contract: "exylon.relationship.recommendation-impression@2.0";
  readonly exposure_ms: number;
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly occurred_at: string;
  readonly personalization_consent: boolean;
  readonly recommendation_assignment_id: string;
  readonly recommendation_item_id: string;
  readonly restaurant_id: string;
  readonly surface: string;
  readonly tenant_id: string;
  readonly visibility_proven: boolean;
}>
export type RelationshipResolvedPreferences = Readonly<{
  readonly contract: "exylon.relationship.resolved-preferences@1.0";
  readonly guest_profile_id: string;
  readonly hard_constraints: readonly (Readonly<{
      readonly code: string;
      readonly hard: boolean;
      readonly kind: "allergen" | "dietary" | "ingredient_exclusion" | "do_not_recommend";
      readonly reference_id: string | null;
    }>)[];
  readonly preferred_dish_ids: readonly (string)[];
  readonly restaurant_id: string;
  readonly scope_versions: Readonly<{
    readonly global: number;
    readonly restaurant: number;
    readonly session: number;
  }>;
  readonly session_id: string | null;
  readonly soft_constraints: readonly (Readonly<{
      readonly code: string;
      readonly hard: boolean;
      readonly kind: "allergen" | "dietary" | "ingredient_exclusion" | "do_not_recommend";
      readonly reference_id: string | null;
    }>)[];
  readonly tenant_id: string;
}>
export type RelationshipRestaurantReviews = Readonly<{
  readonly contract: "exylon.relationship.restaurant-reviews@1.0";
  readonly from: string;
  readonly identity: "minimised";
  readonly next_cursor: string | null;
  readonly order: "newest_first";
  readonly restaurant_id: string;
  readonly reviews: readonly (Readonly<{
      readonly axes: Readonly<{
        readonly ambience: number;
        readonly food: number;
        readonly service: number;
      }>;
      readonly comment: string | null;
      readonly guest: Readonly<{
        readonly loyalty: Readonly<{
          readonly tier: string | null;
        }> | null;
        readonly regular: boolean;
      }>;
      readonly rating: number;
      readonly reply?: Readonly<{
        readonly author: "team";
        readonly text: string;
        readonly written_at: string;
      }> | null;
      readonly review_id: string;
      readonly reward_coupon: "issued" | "none";
      readonly service_day: string;
      readonly submitted_at: string;
    }>)[];
  readonly source: "guest_app";
  readonly tenant_id: string;
  readonly texts: "manager_only";
  readonly to: string;
}>
export type RelationshipRestaurantReviewsRequest = Readonly<{
  readonly cursor?: string;
  readonly from?: string;
  readonly limit?: string;
  readonly restaurant_id?: string;
  readonly to?: string;
}>
export type RelationshipReview = Readonly<{
  readonly bucket_rules_version: number;
  readonly category_ratings: Readonly<{
    readonly ambience: number;
    readonly food: number;
    readonly service: number;
  }>;
  readonly comment: string | null;
  readonly contract: "exylon.relationship.review@1.0";
  readonly feedback_tags: readonly (string)[];
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly order_id: string;
  readonly overall_rating: number;
  readonly restaurant_id: string;
  readonly review_bucket: "low" | "medium" | "high";
  readonly reward_variant: "recovery" | "thank_you" | "advocacy";
  readonly submitted_at: string;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly version: number;
}>
export type RelationshipReviewOffer = Readonly<{
  readonly contract: "exylon.relationship.review-offer@1.0";
  readonly order_id: string | null;
  readonly table_session_id: string;
}>
export type RelationshipReviewStarsWeekly = Readonly<{
  readonly app: Readonly<{
    readonly normal_band: Readonly<{
      readonly high_tenths: number;
      readonly low_tenths: number;
      readonly weeks: number;
    }> | null;
    readonly population: "internal_reviews_by_submitted_at";
    readonly recent: Readonly<{
      readonly average_tenths: number;
      readonly distribution: readonly (number)[];
      readonly reviews: number;
      readonly status: "available";
    }> | Readonly<{
      readonly status: "no_reviews";
    }>;
    readonly running_week: Readonly<{
      readonly from: string;
      readonly stars: Readonly<{
        readonly average_tenths: number;
        readonly distribution: readonly (number)[];
        readonly reviews: number;
        readonly status: "available";
      }> | Readonly<{
        readonly status: "no_reviews";
      }>;
      readonly until: string;
      readonly week_start: string;
    }>;
    readonly trend_minimum_reviews: 5;
    readonly weeks: readonly (Readonly<{
        readonly from: string;
        readonly stars: Readonly<{
          readonly average_tenths: number;
          readonly distribution: readonly (number)[];
          readonly reviews: number;
          readonly status: "available";
        }> | Readonly<{
          readonly status: "no_reviews";
        }>;
        readonly until: string;
        readonly week_start: string;
      }>)[];
  }>;
  readonly average_series?: Readonly<{
    readonly coverage: Readonly<{
      readonly expected: number;
      readonly observed: number;
      readonly state: "complete" | "partial" | "young";
    }>;
    readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
    readonly normal: Readonly<{
      readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
      readonly estimate: boolean;
      readonly hi: number;
      readonly lo: number;
      readonly mid: number | null;
      readonly observed: number;
      readonly window?: Readonly<{
        readonly from: string;
        readonly to: string;
      }>;
    }> | null;
    readonly of: string;
    readonly points: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly previous?: readonly (Readonly<{
        readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
        readonly days?: Readonly<{
          readonly observed: number;
          readonly of: number;
        }>;
        readonly part?: string;
        readonly partial?: true;
        readonly partial_reason?: "running" | "opened" | "uncounted";
        readonly range?: Readonly<{
          readonly hi: number;
          readonly lo: number;
        }>;
        readonly value: number | null;
        readonly window: Readonly<{
          readonly from: string;
          readonly to: string;
        }>;
      }>)[];
    readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
  }>;
  readonly contract: "exylon.relationship.review-stars-weekly@1.0";
  readonly evaluated_at: string;
  readonly google: Readonly<{
    readonly normal_band: Readonly<{
      readonly high_tenths: number;
      readonly low_tenths: number;
      readonly weeks: number;
    }> | null;
    readonly population: "google_reviews_by_published_at";
    readonly recent: Readonly<{
      readonly average_tenths: number;
      readonly distribution: readonly (number)[];
      readonly reviews: number;
      readonly status: "available";
    }> | Readonly<{
      readonly status: "no_reviews";
    }>;
    readonly running_week: Readonly<{
      readonly from: string;
      readonly stars: Readonly<{
        readonly average_tenths: number;
        readonly distribution: readonly (number)[];
        readonly reviews: number;
        readonly status: "available";
      }> | Readonly<{
        readonly status: "no_reviews";
      }>;
      readonly until: string;
      readonly week_start: string;
    }>;
    readonly status: "connected";
    readonly trend_minimum_reviews: 1;
    readonly weeks: readonly (Readonly<{
        readonly from: string;
        readonly stars: Readonly<{
          readonly average_tenths: number;
          readonly distribution: readonly (number)[];
          readonly reviews: number;
          readonly status: "available";
        }> | Readonly<{
          readonly status: "no_reviews";
        }>;
        readonly until: string;
        readonly week_start: string;
      }>)[];
  }> | Readonly<{
    readonly status: "not_connected";
  }>;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly texts: "kept_in_relationship";
}>
export type RelationshipReviewStarsWeeklyRequest = Readonly<{
  readonly restaurant_id?: string;
}>
export type RelationshipReviewSubmission = Readonly<{
  readonly contract: "exylon.relationship.review-submission@1.0";
  readonly review: RelationshipReview;
  readonly reward: Readonly<{
    readonly issued_coupon_issuance_ids: readonly (string)[];
    readonly public_review_url: string | null;
    readonly requested: readonly (Readonly<{
        readonly count: number;
        readonly reward_tier: "bronze" | "silver" | "gold";
      }>)[];
    readonly review_bucket: "low" | "medium" | "high";
    readonly reward_variant: "recovery" | "thank_you" | "advocacy";
    readonly unhappy: boolean;
  }>;
}>
export type RelationshipReviewTopics = Readonly<{
  readonly classification_version: "relationship-review-topics@1";
  readonly contract: "exylon.relationship.review-topics@1.0";
  readonly counting: "one_count_per_review_and_topic";
  readonly dish_attribution: "dishes_on_the_reviewed_order";
  readonly dish_names: "current_menu" | "unavailable";
  readonly minimum_group: 5;
  readonly population: "internal_reviews_by_submitted_at";
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly texts: "kept_in_relationship";
  readonly topic_series?: readonly (Readonly<{
      readonly complaints: Readonly<{
        readonly coverage: Readonly<{
          readonly expected: number;
          readonly observed: number;
          readonly state: "complete" | "partial" | "young";
        }>;
        readonly grain: "day" | "week" | "month" | "service" | "hour" | "occurrence";
        readonly normal: Readonly<{
          readonly basis: "same_weekday" | "recent_weeks" | "recent_months" | "house" | "prior";
          readonly estimate: boolean;
          readonly hi: number;
          readonly lo: number;
          readonly mid: number | null;
          readonly observed: number;
          readonly window?: Readonly<{
            readonly from: string;
            readonly to: string;
          }>;
        }> | null;
        readonly of: string;
        readonly points: readonly (Readonly<{
            readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
            readonly days?: Readonly<{
              readonly observed: number;
              readonly of: number;
            }>;
            readonly part?: string;
            readonly partial?: true;
            readonly partial_reason?: "running" | "opened" | "uncounted";
            readonly range?: Readonly<{
              readonly hi: number;
              readonly lo: number;
            }>;
            readonly value: number | null;
            readonly window: Readonly<{
              readonly from: string;
              readonly to: string;
            }>;
          }>)[];
        readonly previous?: readonly (Readonly<{
            readonly absence?: "not_yet" | "to_come" | "closed" | "no_data" | "source_unavailable" | "not_measured";
            readonly days?: Readonly<{
              readonly observed: number;
              readonly of: number;
            }>;
            readonly part?: string;
            readonly partial?: true;
            readonly partial_reason?: "running" | "opened" | "uncounted";
            readonly range?: Readonly<{
              readonly hi: number;
              readonly lo: number;
            }>;
            readonly value: number | null;
            readonly window: Readonly<{
              readonly from: string;
              readonly to: string;
            }>;
          }>)[];
        readonly unit: "money_minor" | "count" | "basis_points" | "minutes" | "days" | "rating_tenths";
      }>;
      readonly topic: "service" | "wait" | "food" | "details" | "ambience" | "value";
    }>)[];
  readonly weeks: readonly (Readonly<{
      readonly dishes: Readonly<{
        readonly dishes: readonly (Readonly<{
            readonly dish_id: string;
            readonly dish_name: string | null;
            readonly reviews: number;
            readonly topics: readonly (Readonly<{
                readonly complaint: number;
                readonly could_improve: number;
                readonly negative: number;
                readonly praise: number;
                readonly reviews: number;
                readonly topic: "service" | "wait" | "food" | "details" | "ambience" | "value";
              }>)[];
          }>)[];
        readonly suppressed_dishes: number;
        readonly truncated: boolean;
      }>;
      readonly from: string;
      readonly restaurant: Readonly<{
        readonly reviews_examined: number;
        readonly status: "available";
        readonly topics: readonly (Readonly<{
            readonly complaint: number;
            readonly could_improve: number;
            readonly praise: number;
            readonly reviews: number;
            readonly topic: "service" | "wait" | "food" | "details" | "ambience" | "value";
          }>)[];
        readonly untagged: number;
        readonly with_unclassified_tag: number;
      }> | Readonly<{
        readonly reason: "below_minimum_group";
        readonly status: "no_data";
      }>;
      readonly until: string;
      readonly week_start: string;
    }>)[];
}>
export type RelationshipReviewTopicsRequest = Readonly<{
  readonly restaurant_id?: string;
  readonly weeks?: string;
}>
export type ReleaseIdentity = Readonly<{
  readonly api_version: "v1";
  readonly app_version: string;
  readonly build_id: string | null;
  readonly build_time_utc: string;
  readonly component: "backend-api";
  readonly dirty: boolean | null;
  readonly environment: string;
  readonly git_branch: string | null;
  readonly git_sha: string | null;
  readonly node_env: string;
  readonly package_name: string | null;
  readonly package_version: string | null;
  readonly release_id: string;
  readonly schema_version: "exylon.release.v1";
}>
export type RemoveRelationshipGuestQuestionRequest = Readonly<{
  readonly question_id: string;
}>
export type ReopenOfferDefinitionRequest = Readonly<{
  readonly expected_version: number;
  readonly reason_code: string;
  readonly reason_note?: string;
}>
export type ReplaceAccessPolicyDraftRequest = Readonly<{
  readonly configuration: Readonly<{
    readonly enabled_configurable_workspace_ids: readonly ("ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY")[];
    readonly manager_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
  }>;
  readonly content: Readonly<{
    readonly manager_default_workspace_id: "SERVICE" | "KITCHEN" | "ANALYTICS" | "INVENTORY" | "HR" | "POS" | "CUSTOMER_HISTORY" | "MARKETING" | "MENU" | "LOYALTY" | null;
    readonly memberships: readonly (Readonly<{
        readonly default_workspace_id: "ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY" | null;
        readonly employee_id: string;
        readonly membership_id: string;
        readonly principal_id: string;
        readonly workspace_ids: readonly ("ANALYTICS" | "MARKETING" | "INVENTORY" | "CUSTOMER_HISTORY" | "HR" | "MENU" | "LOYALTY")[];
      }>)[];
  }>;
}>
export type ReplaceGuestConsentRequest = Readonly<{
  readonly expected_profile_id?: string;
  readonly expected_version: number;
  readonly marketing_enabled: boolean;
}>
export type ReplaceGuestPersonalizationSettingRequest = Readonly<{
  readonly expected_profile_id?: string;
  readonly expected_version: number;
  readonly personalized_recommendations: boolean;
}>
export type ReplaceRelationshipPreferencesRequest = Readonly<{
  readonly constraints: readonly (Readonly<{
      readonly code: string;
      readonly hard: boolean;
      readonly kind: "allergen" | "dietary" | "ingredient_exclusion" | "do_not_recommend";
      readonly reference_id: string | null;
    }>)[];
  readonly expected_version: number;
  readonly preferred_dish_ids: readonly (string)[];
  readonly scope?: "global" | "restaurant" | "session";
  readonly session_id?: string | null;
  readonly updated_at: string;
}>
export type ReplayOfferDefinitionRequest = Readonly<{
  readonly definition: Readonly<{
    readonly amount_minor: number | null;
    readonly benefit_kind: "percentage" | "fixed_amount" | "free_item" | "buy_x_get_y";
    readonly buy_quantity: number;
    readonly currency: "EUR" | null;
    readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
    readonly end_local_time?: string | null;
    readonly feedback_only: boolean;
    readonly loyalty_tier_id: string | null;
    readonly maximum_discount_minor: number | null;
    readonly maximum_subtotal_minor: number | null;
    readonly minimum_party_size: number;
    readonly minimum_subtotal_minor: number;
    readonly name: string;
    readonly new_guest_only: boolean;
    readonly percentage_bps: number | null;
    readonly reward_catalog_item_id: string | null;
    readonly reward_item?: Readonly<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly reward_quantity: number;
    readonly reward_tier?: "bronze" | "silver" | "gold" | null;
    readonly scope_kind: "ticket" | "catalog_item" | "catalog_category" | "catalog_section";
    readonly start_local_time?: string | null;
    readonly targets: readonly (Readonly<{
        readonly target_id: string;
        readonly target_kind: "catalog_item" | "catalog_category" | "catalog_section";
      }>)[];
    readonly total_redemption_limit: number | null;
    readonly uses_per_guest?: "once" | "every_visit";
    readonly valid_from_date: string | null;
    readonly valid_to_date: string | null;
    readonly weekdays: readonly (number)[];
  }>;
  readonly definition_id: string;
}>
export type ReplyRelationshipExternalReviewRequest = Readonly<{
  readonly comment: string;
  readonly expected_version: number;
}>
export type ReserveInventoryForOrderRequest = Readonly<{
  readonly existing_reservation_id: string | null;
  readonly existing_reservation_version: number | null;
  readonly hold_seconds: number;
  readonly items: readonly (Readonly<{
      readonly catalog_publication_version: number;
      readonly dish_id: string;
      readonly modifier_option_ids: readonly (string)[];
      readonly quantity: number;
    }>)[];
  readonly order_id: string;
  readonly order_version: number;
  readonly reservation_id: string;
}>
export type ReserveInventoryStockRequest = Readonly<{
  readonly hold_seconds: number;
  readonly lines: readonly (Readonly<{
      readonly quantity_units: number;
      readonly stock_item_id: string;
      readonly stock_item_version: number;
    }>)[];
  readonly resource_id: string;
  readonly service_order_id: string;
  readonly service_order_version: number;
}>
export type RestaurantCashbackPolicy = Readonly<{
  readonly auto_apply: boolean;
  readonly ticket_cap_minor: number | null;
}>
export type RestaurantConfigurationCurrent = Readonly<{
  readonly contract: "exylon.restaurant-configuration.current@1.0";
  readonly derived_defaults: Readonly<{
    readonly delivery_threshold: Readonly<{
      readonly derived_until_day: string;
      readonly seconds: number;
    }> | null;
  }>;
  readonly draft: Readonly<{
    readonly content: Readonly<{
      readonly departments: readonly (Readonly<{
          readonly active: boolean;
          readonly artwork_key: "kitchen" | "cold-kitchen" | "grill" | "fryer" | "desserts" | "cocktails" | null;
          readonly floor_id: string;
          readonly height: number;
          readonly id: string;
          readonly kind: "kitchen" | "direct_service" | "access";
          readonly location_id: string;
          readonly name: string;
          readonly position_x: number;
          readonly position_y: number;
          readonly rotation_degrees: number;
          readonly width: number;
          readonly workspace_id: "MARKETING" | "LOYALTY" | "CUSTOMER_HISTORY" | "HR" | "INVENTORY" | "ANALYTICS" | "MENU" | "POS" | null;
        }>)[];
      readonly floors: readonly (Readonly<{
          readonly active: boolean;
          readonly canvas_height?: number;
          readonly canvas_width?: number;
          readonly grid_size?: number;
          readonly id: string;
          readonly location_id: string;
          readonly name: string;
          readonly sort_order: number;
        }>)[];
      readonly settings: readonly (RestaurantConfigurationSetting)[];
      readonly tables: readonly (Readonly<{
          readonly active: boolean;
          readonly capacity: number;
          readonly floor_id: string;
          readonly height: number;
          readonly id: string;
          readonly label: string;
          readonly location_id: string;
          readonly position_x: number;
          readonly position_y: number;
          readonly rotation_degrees: number;
          readonly shape?: "rectangular" | "round" | "bar";
          readonly width: number;
        }>)[];
    }> | null;
    readonly content_hash: string;
    readonly contract: "exylon.restaurant-configuration.draft@1.0";
    readonly draft_revision: number;
    readonly published_version: number;
    readonly restaurant_id: string;
    readonly tenant_id: string;
    readonly updated_at: string;
    readonly updated_by: string;
  }> | null;
  readonly effective: RestaurantConfigurationPublication | null;
  readonly has_unpublished_changes: boolean;
  readonly place_source: Readonly<{
    readonly location: "derived" | "manual" | null;
    readonly municipality: "derived" | "manual" | null;
  }>;
  readonly published_municipality: Readonly<{
    readonly code: string;
    readonly display_name: string;
    readonly province_name: string;
  }> | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type RestaurantConfigurationDepartment = Readonly<{
  readonly active: boolean;
  readonly artwork_key: "kitchen" | "cold-kitchen" | "grill" | "fryer" | "desserts" | "cocktails" | null;
  readonly floor_id: string;
  readonly height: number;
  readonly id: string;
  readonly kind: "kitchen" | "direct_service" | "access";
  readonly location_id: string;
  readonly name: string;
  readonly position_x: number;
  readonly position_y: number;
  readonly rotation_degrees: number;
  readonly width: number;
  readonly workspace_id: "MARKETING" | "LOYALTY" | "CUSTOMER_HISTORY" | "HR" | "INVENTORY" | "ANALYTICS" | "MENU" | "POS" | null;
}>
export type RestaurantConfigurationDraft = Readonly<{
  readonly content: Readonly<{
    readonly departments: readonly (Readonly<{
        readonly active: boolean;
        readonly artwork_key: "kitchen" | "cold-kitchen" | "grill" | "fryer" | "desserts" | "cocktails" | null;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly kind: "kitchen" | "direct_service" | "access";
        readonly location_id: string;
        readonly name: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly width: number;
        readonly workspace_id: "MARKETING" | "LOYALTY" | "CUSTOMER_HISTORY" | "HR" | "INVENTORY" | "ANALYTICS" | "MENU" | "POS" | null;
      }>)[];
    readonly floors: readonly (Readonly<{
        readonly active: boolean;
        readonly canvas_height?: number;
        readonly canvas_width?: number;
        readonly grid_size?: number;
        readonly id: string;
        readonly location_id: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly settings: readonly (RestaurantConfigurationSetting)[];
    readonly tables: readonly (Readonly<{
        readonly active: boolean;
        readonly capacity: number;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly label: string;
        readonly location_id: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly shape?: "rectangular" | "round" | "bar";
        readonly width: number;
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.restaurant-configuration.draft@1.0";
  readonly draft_revision: number;
  readonly published_version: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly updated_by: string;
}>
export type RestaurantConfigurationEffective = Readonly<{
  readonly content: Readonly<{
    readonly departments: readonly (Readonly<{
        readonly active: boolean;
        readonly artwork_key: "kitchen" | "cold-kitchen" | "grill" | "fryer" | "desserts" | "cocktails" | null;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly kind: "kitchen" | "direct_service" | "access";
        readonly location_id: string;
        readonly name: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly width: number;
        readonly workspace_id: "MARKETING" | "LOYALTY" | "CUSTOMER_HISTORY" | "HR" | "INVENTORY" | "ANALYTICS" | "MENU" | "POS" | null;
      }>)[];
    readonly floors: readonly (Readonly<{
        readonly active: boolean;
        readonly canvas_height?: number;
        readonly canvas_width?: number;
        readonly grid_size?: number;
        readonly id: string;
        readonly location_id: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly settings: readonly (RestaurantConfigurationSetting)[];
    readonly tables: readonly (Readonly<{
        readonly active: boolean;
        readonly capacity: number;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly label: string;
        readonly location_id: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly shape?: "rectangular" | "round" | "bar";
        readonly width: number;
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.restaurant-configuration.effective@1.0";
  readonly effective_from: string;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type RestaurantConfigurationFloor = Readonly<{
  readonly active: boolean;
  readonly canvas_height?: number;
  readonly canvas_width?: number;
  readonly grid_size?: number;
  readonly id: string;
  readonly location_id: string;
  readonly name: string;
  readonly sort_order: number;
}>
export type RestaurantConfigurationInvalidHttpError = Readonly<{
  readonly errors: Readonly<{
    readonly cause?: string;
    readonly errorCode: "RESTAURANT_CONFIGURATION_INVALID";
    readonly finding?: Readonly<{
      readonly code: string;
      readonly message: string;
      readonly path: string;
    }>;
    readonly findings?: readonly (Readonly<{
        readonly code: string;
        readonly message: string;
        readonly path: string;
      }>)[];
    readonly setting_key?: string;
  }> | Readonly<{
    readonly errorCode: "RESTAURANT_CONFIGURATION_IDEMPOTENCY_KEY_REQUIRED";
  }>;
  readonly message: string;
  readonly statusCode: 400;
}>
export type RestaurantConfigurationJsonValue = string | number | boolean | null | readonly (RestaurantConfigurationJsonValue)[] | Readonly<{ readonly [key: string]: RestaurantConfigurationJsonValue }>
export type RestaurantConfigurationPublication = Readonly<{
  readonly content: Readonly<{
    readonly departments: readonly (Readonly<{
        readonly active: boolean;
        readonly artwork_key: "kitchen" | "cold-kitchen" | "grill" | "fryer" | "desserts" | "cocktails" | null;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly kind: "kitchen" | "direct_service" | "access";
        readonly location_id: string;
        readonly name: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly width: number;
        readonly workspace_id: "MARKETING" | "LOYALTY" | "CUSTOMER_HISTORY" | "HR" | "INVENTORY" | "ANALYTICS" | "MENU" | "POS" | null;
      }>)[];
    readonly floors: readonly (Readonly<{
        readonly active: boolean;
        readonly canvas_height?: number;
        readonly canvas_width?: number;
        readonly grid_size?: number;
        readonly id: string;
        readonly location_id: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
    readonly settings: readonly (RestaurantConfigurationSetting)[];
    readonly tables: readonly (Readonly<{
        readonly active: boolean;
        readonly capacity: number;
        readonly floor_id: string;
        readonly height: number;
        readonly id: string;
        readonly label: string;
        readonly location_id: string;
        readonly position_x: number;
        readonly position_y: number;
        readonly rotation_degrees: number;
        readonly shape?: "rectangular" | "round" | "bar";
        readonly width: number;
      }>)[];
  }>;
  readonly content_hash: string;
  readonly contract: "exylon.restaurant-configuration.publication@1.0";
  readonly publication_version: number;
  readonly published_at: string;
  readonly published_by: string;
  readonly restaurant_id: string;
  readonly source_draft_revision: number;
  readonly tenant_id: string;
}>
/** @deprecated Consumer compatibility only; generated request validation remains discriminated and exact. */
export type RestaurantConfigurationSetting = Readonly<{
  readonly key: string
  readonly value_kind: 'boolean' | 'integer' | 'string' | 'json'
  readonly value: unknown
}>
export type RestaurantConfigurationTable = Readonly<{
  readonly active: boolean;
  readonly capacity: number;
  readonly floor_id: string;
  readonly height: number;
  readonly id: string;
  readonly label: string;
  readonly location_id: string;
  readonly position_x: number;
  readonly position_y: number;
  readonly rotation_degrees: number;
  readonly shape?: "rectangular" | "round" | "bar";
  readonly width: number;
}>
export type RestaurantConfigurationTableResolution = Readonly<{
  readonly active: boolean;
  readonly capacity: number;
  readonly contract: "exylon.restaurant-configuration.table-resolution@1.0";
  readonly floor_id: string;
  readonly label: string;
  readonly location_id: string;
  readonly published_configuration_version: number;
  readonly restaurant_id: string;
  readonly table_id: string;
  readonly tenant_id: string;
}>
export type RestaurantConfigurationValidation = Readonly<{
  readonly content_hash: string;
  readonly contract: "exylon.restaurant-configuration.validation@1.0";
  readonly errors: readonly (Readonly<{
      readonly code: string;
      readonly message: string;
      readonly path: string;
      readonly target_id?: string;
      readonly target_kind?: "floor" | "table" | "department";
    }>)[];
  readonly valid: boolean;
  readonly warnings: readonly (Readonly<{
      readonly code: string;
      readonly message: string;
      readonly path: string;
      readonly target_id?: string;
      readonly target_kind?: "floor" | "table" | "department";
    }>)[];
}>
export type RestaurantInventoryPolicyDecision = Readonly<{
  readonly contract: "exylon.restaurant-configuration.inventory-policy-decision@1.0";
  readonly defaults_applied: readonly ("inventory.stock_policy")[];
  readonly input_fingerprint: string;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly source: "published_configuration";
  readonly stock_policy: "none" | "hide_customer" | "hide_and_block";
  readonly tenant_id: string;
}>
export type RestaurantWorkforceAssignmentPolicyDecision = Readonly<{
  readonly contract: "exylon.restaurant-configuration.workforce-assignment-policy-decision@1.0";
  readonly defaults_applied: readonly ("workforce.assignment.kitchen.required" | "workforce.assignment.waiter.required")[];
  readonly input_fingerprint: string;
  readonly kitchen_assignment_required: boolean;
  readonly kitchen_policy_fingerprint: string;
  readonly publication_version: number;
  readonly restaurant_id: string;
  readonly source: "published_configuration";
  readonly target: Readonly<{
    readonly active: boolean;
    readonly target_fingerprint: string;
    readonly target_id: string;
    readonly target_kind: "table" | "department";
  }> | null;
  readonly tenant_id: string;
  readonly waiter_assignment_required: boolean;
  readonly waiter_policy_fingerprint: string;
}>
export type RestoreAccessPolicyRequest = Readonly<{
  readonly expected_active_policy_version: number;
  readonly review_hash: string;
  readonly target_policy_version: number;
}>
export type RestoreCatalogDraftFromPublicationRequest = Readonly<{
  readonly editor_intent_id: string;
  readonly publication_version: number;
}>
export type RetireInventoryResourceRequest = Readonly<{
  readonly reason_code: string;
}>
export type RetireOfferDefinitionRequest = Readonly<{
  readonly expected_version: number;
  readonly reason_code: string;
  readonly reason_note?: string;
}>
export type RetireRelationshipLoyaltyProgramRequest = Readonly<{
  readonly expected_version: number;
}>
export type ReverseRelationshipLoyaltyRequest = Readonly<{
  readonly payment_transitions: readonly (Readonly<{
      readonly allocation_id: string;
      readonly captured_amount_minor: number;
      readonly cashback_applied_minor?: number;
      readonly cashback_return_minor?: number;
      readonly currency: "EUR";
      readonly payment_fully_refunded: boolean;
      readonly payment_id: string;
      readonly planned_refund_minor: number;
      readonly prior_refunded_minor: number;
    }> | Readonly<{
      readonly allocation_id: string;
      readonly captured_amount_minor: number;
      readonly cashback_applied_minor: number;
      readonly cashback_return_minor?: number;
      readonly currency: "EUR";
      readonly payment_fully_refunded: boolean;
      readonly payment_id: string;
      readonly planned_refund_minor: 0;
      readonly prior_refunded_minor: number;
    }>)[];
  readonly refund_id: string;
  readonly refunded_at: string;
  readonly ticket_id: string;
}>
export type RuntimeHealth = Readonly<{
  readonly checks: Readonly<{
    readonly bootstrap: Readonly<{
      readonly detail?: string;
      readonly latency_ms?: number;
      readonly status: "pass" | "warn" | "fail";
    }>;
    readonly postgres: Readonly<{
      readonly detail?: string;
      readonly latency_ms?: number;
      readonly status: "pass" | "warn" | "fail";
    }>;
    readonly worker: Readonly<{
      readonly detail?: string;
      readonly latency_ms?: number;
      readonly status: "pass" | "warn" | "fail";
    }>;
  }>;
  readonly contract: "exylon.operations.runtime-health@1.0";
  readonly generated_at: string;
  readonly platform_messaging: Readonly<{
    readonly queue: Readonly<{
      readonly dead_letter: number;
      readonly due: number;
      readonly expired_leases: number;
      readonly failed: number;
      readonly oldest_due_at: string | null;
      readonly pending: number;
      readonly processing: number;
    }>;
    readonly worker: Readonly<{
      readonly detail?: string;
      readonly last_observed_at: string | null;
      readonly required: true;
      readonly running: boolean;
      readonly source: "postgres_lease";
      readonly worker_id: string | null;
    }>;
  }>;
  readonly process: Readonly<{
    readonly heap_used_bytes: number;
    readonly kind: "api";
    readonly pid: number;
    readonly rss_bytes: number;
    readonly uptime_seconds: number;
  }>;
  readonly status: "healthy" | "degraded" | "down";
}>
export type SelectRelationshipGoogleLocationRequest = Readonly<{
  readonly account_name: string;
  readonly location_name: string;
  readonly selection_id: string;
}>
export type ServiceActionActor = Readonly<{
  readonly operation?: "manager.fulfillment.transition" | "manager.fulfillment.deliver-batch";
  readonly permitted: boolean;
  readonly requires: "operational_session" | null;
}>
export type ServiceActionReasonCode = "service_bill_request_already_accepted" | "service_bill_request_participant_denied" | "service_bill_request_resolved" | "service_captured_order_cancel_forbidden" | "service_cart_empty_or_missing" | "service_cart_missing" | "service_charge_lines_undelivered" | "service_check_due_outstanding" | "service_course_not_released" | "service_force_close_authority_required" | "service_force_close_manager_authority_required" | "service_force_closure_missing" | "service_fulfillment_already_in_target_state" | "service_fulfillment_transition_invalid" | "service_guest_bill_requested" | "service_guest_checkout_requires_delivery" | "service_guest_line_participant_missing" | "service_guest_nothing_due" | "service_line_participant_invalid" | "service_line_void_after_settlement" | "service_order_item_edit_forbidden" | "service_order_not_accepted" | "service_order_transition_invalid" | "service_refund_charge_not_refundable" | "service_remake_direct_item_invalid" | "service_remake_transition_invalid" | "service_section_locked" | "service_staff_operation_denied" | "service_table_actions_unavailable" | "service_table_close_lines_undelivered" | "service_table_closed" | "service_table_nothing_due" | "service_table_session_transition_invalid"
export type ServiceActionVerdict = Readonly<{
  readonly actor?: ServiceActionActor;
  readonly allowed: boolean;
  readonly reason_code: ServiceActionReasonCode | null;
  readonly reason_text: string | null;
}>
export type ServiceBillRequest = Readonly<{
  readonly accepted_at: string | null;
  readonly accepted_by: string | null;
  readonly created_at: string;
  readonly id: string;
  readonly participant_id: string;
  readonly requested_at: string;
  readonly resolution: "paid" | "reopened" | "table_closed" | null;
  readonly resolved_at: string | null;
  readonly restaurant_id: string;
  readonly review_order_id: string | null;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceBillRequestAcceptFloorAnswer = Readonly<{
  readonly board: ServiceFloorSnapshot | null;
  readonly result: ServiceBillRequestAcceptResult;
  readonly revision: string | null;
}>
export type ServiceBillRequestAcceptRequest = Readonly<{
  readonly operation: "bill-request.accept";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceBillRequestAcceptResult = Readonly<{
  readonly bill_request: ServiceBillRequest;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "bill-request.accept";
}>
export type ServiceBillRequestReopenRequest = Readonly<{
  readonly operation: "bill-request.reopen";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceBillRequestReopenResult = Readonly<{
  readonly bill_request: ServiceBillRequest;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "bill-request.reopen";
}>
export type ServiceBridgeForceCloseQuery = Readonly<{
  readonly cause_code?: string;
  readonly form: "service.table-session.force-close";
  readonly table_ids?: string;
}>
export type ServiceBridgeHistoryQuery = Readonly<{
  readonly form: "service.history.filter" | "service.history.order";
  readonly order_id?: string;
  readonly outcomes?: string;
  readonly placed_from?: string;
  readonly placed_to?: string;
}>
export type ServiceBridgeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.service.bridge-revalidation@1.0";
  readonly form: "service.history.filter" | "service.history.order" | "service.table-session.force-close";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{ readonly [key: string]: string | number | boolean | readonly (string)[] | readonly (number)[] }>;
  readonly verdict: "open" | "refused";
}>
export type ServiceCart = Readonly<{
  readonly created_at: string;
  readonly currency: "EUR";
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly restaurant_id: string;
  readonly state: "active" | "converted" | "abandoned";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceCartDiscardRequest = Readonly<{
  readonly operation: "cart.discard";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceCartDiscardResult = Readonly<{
  readonly cart: ServiceCart;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "cart.discard";
}>
export type ServiceCartItem = Readonly<{
  readonly cart_id: string;
  readonly catalog_item_version: number;
  readonly catalog_publication_version: number;
  readonly category_id: string;
  readonly created_at: string;
  readonly dish_id: string;
  readonly id: string;
  readonly line_total_minor: number;
  readonly modifier_snapshot: readonly (Readonly<{
      readonly group_id: string;
      readonly name: string;
      readonly option_id: string;
      readonly price_delta_minor: number;
    }>)[];
  readonly modifier_total_minor: number;
  readonly name_snapshot: string;
  readonly note: string | null;
  readonly participant_id?: string | null;
  readonly quantity: number;
  readonly requested_section_id?: string | null;
  readonly restaurant_id: string;
  readonly safety_acknowledgement: Readonly<{
    readonly acknowledged_at: string;
    readonly cart_version: number;
    readonly configuration_fingerprint: string;
    readonly line_version: number;
    readonly notice_key: "safety_acknowledgement.responsibility_allergen@v1" | "safety_acknowledgement.responsibility_other@v1";
    readonly outcome: "conflict" | "unknown";
    readonly preference_versions: Readonly<{
      readonly global?: number;
      readonly restaurant?: number;
    }>;
  }> | null;
  readonly state: "active" | "removed";
  readonly tenant_id: string;
  readonly unit_price_minor: number;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceCartItemAddRequest = Readonly<{
  readonly operation: "cart.item.add";
  readonly payload: Readonly<{
    readonly cart_id: string;
    readonly catalog_publication_version?: number;
    readonly dish_id: string;
    readonly modifier_option_ids?: readonly (string)[];
    readonly note?: string | null;
    readonly participant_id?: string | null;
    readonly quantity: number;
    readonly requested_section_id?: string | null;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartItemAddResult = Readonly<{
  readonly cart_item: ServiceCartItem;
  readonly operation: "cart.item.add";
}>
export type ServiceCartItemAddStaffRequest = Readonly<{
  readonly operation: "cart.item.add";
  readonly payload: Readonly<{
    readonly cart_id: string;
    readonly catalog_publication_version?: number;
    readonly dish_id: string;
    readonly modifier_option_ids?: readonly (string)[];
    readonly note?: string | null;
    readonly participant_id?: string | null;
    readonly quantity: number;
    readonly reason_code?: "section_lock_override";
    readonly requested_section_id?: string | null;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartItemCopyRequest = Readonly<{
  readonly operation: "cart.item.copy";
  readonly payload: Readonly<{
    readonly source_cart_item_id: string;
    readonly target_cart_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartItemCopyResult = Readonly<{
  readonly cart_item: ServiceCartItem;
  readonly operation: "cart.item.copy";
}>
export type ServiceCartItemRemoveRequest = Readonly<{
  readonly operation: "cart.item.remove";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceCartItemRemoveResult = Readonly<{
  readonly cart_item: ServiceCartItem;
  readonly operation: "cart.item.remove";
}>
export type ServiceCartItemSafetyAcknowledgeRequest = Readonly<{
  readonly operation: "cart.item.safety.acknowledge";
  readonly payload: Readonly<{
    readonly cart_id: string;
    readonly configuration_fingerprint: string;
    readonly notice_key: "safety_acknowledgement.responsibility_allergen@v1" | "safety_acknowledgement.responsibility_other@v1";
    readonly outcome: "conflict" | "unknown";
    readonly preference_versions: Readonly<{
      readonly global?: number;
      readonly restaurant?: number;
    }>;
    readonly table_session_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartItemSafetyAcknowledgeResult = Readonly<{
  readonly cart_item: ServiceCartItem;
  readonly operation: "cart.item.safety.acknowledge";
}>
export type ServiceCartItemStealRequest = Readonly<{
  readonly operation: "cart.item.steal";
  readonly payload: Readonly<{
    readonly cart_id: string;
    readonly source_cart_item_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartItemStealResult = Readonly<{
  readonly cart_item: ServiceCartItem;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "cart.item.steal";
}>
export type ServiceCartItemStealUndoRequest = Readonly<{
  readonly operation: "cart.item.steal.undo";
  readonly payload: Readonly<{
    readonly source_cart_item_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartItemStealUndoResult = Readonly<{
  readonly cart_item: ServiceCartItem;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "cart.item.steal.undo";
}>
export type ServiceCartItemUpdateRequest = Readonly<{
  readonly operation: "cart.item.update";
  readonly payload: Readonly<{
    readonly modifier_option_ids?: readonly (string)[];
    readonly note?: string | null;
    readonly participant_id?: string | null;
    readonly quantity: number;
    readonly requested_section_id?: string | null;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartItemUpdateResult = Readonly<{
  readonly cart_item: ServiceCartItem;
  readonly operation: "cart.item.update";
}>
export type ServiceCartOfflineRoundRestoreRequest = Readonly<{
  readonly operation: "cart.offline-round.restore";
  readonly payload: Readonly<{
    readonly round_cart_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartOfflineRoundRestoreResult = Readonly<{
  readonly offline_round_cart: Readonly<{
    readonly moved: boolean;
  }>;
  readonly operation: "cart.offline-round.restore";
}>
export type ServiceCartOfflineRoundSplitRequest = Readonly<{
  readonly operation: "cart.offline-round.split";
  readonly payload: Readonly<{
    readonly line_ids: readonly (string)[];
    readonly staff_cart_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartOfflineRoundSplitResult = Readonly<{
  readonly offline_round_cart: Readonly<{
    readonly moved: boolean;
  }>;
  readonly operation: "cart.offline-round.split";
}>
export type ServiceCartOpenRequest = Readonly<{
  readonly operation: "cart.open";
  readonly payload: Readonly<{
    readonly currency: "EUR";
    readonly table_session_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCartOpenResult = Readonly<{
  readonly cart: ServiceCart;
  readonly operation: "cart.open";
}>
export type ServiceCashCorrection = Readonly<{
  readonly actor_id: string;
  readonly applied_to_session: boolean;
  readonly cash_session_id: string | null;
  readonly from_method: "cash" | "card" | "external" | "external_terminal";
  readonly id: string;
  readonly occurred_at: string;
  readonly payment_id: string;
  readonly reason: string;
  readonly tender_position: number;
  readonly to_method: "cash" | "card" | "external" | "external_terminal";
}>
export type ServiceCashCorrectionEntry = Readonly<{
  readonly actor_id: string;
  readonly actor_name: string | null;
  readonly applied_to_session: boolean;
  readonly from_method: "cash" | "card" | "external" | "external_terminal";
  readonly id: string;
  readonly occurred_at: string;
  readonly payment_id: string;
  readonly reason: string;
  readonly tender_position?: number;
  readonly to_method: "cash" | "card" | "external" | "external_terminal";
}>
export type ServiceCashDocumentArchive = Readonly<{
  readonly documents: readonly (Readonly<{
      readonly byte_size: number | null;
      readonly format: "pdf" | "xlsx";
      readonly from: string;
      readonly id: string;
      readonly sha256: string | null;
      readonly until: string;
    }>)[];
  readonly next: string | null;
}>
export type ServiceCashDocumentArchiveQuery = Readonly<{
  readonly before?: string;
}>
export type ServiceCashDocumentFileQuery = Readonly<Record<never, never>>
export type ServiceCashDocumentQuery = Readonly<{
  readonly format: "pdf" | "xlsx";
  readonly session_id: string;
}>
export type ServiceCashLaterCorrections = Readonly<{
  readonly method_corrections: readonly (ServiceCashCorrectionEntry)[];
  readonly movement_voids: readonly (Readonly<{
      readonly movement_id: string;
      readonly void_reason: string;
      readonly voided_at: string;
      readonly voided_by_name: string | null;
    }>)[];
  readonly offline_payments?: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly check_id: string;
      readonly id: string;
      readonly linked_at: string;
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
}>
export type ServiceCashMovement = Readonly<{
  readonly actor_id: string;
  readonly amount_minor: number;
  readonly cash_session_id: string;
  readonly direction: "in" | "out";
  readonly id: string;
  readonly occurred_at: string;
  readonly purpose: "tips_paid" | null;
  readonly reason: string;
  readonly version: number;
  readonly void_reason: string | null;
  readonly voided_at: string | null;
  readonly voided_by: string | null;
}>
export type ServiceCashMovementEntry = Readonly<{
  readonly actor_id: string;
  readonly actor_name: string | null;
  readonly amount_minor: number;
  readonly direction: "in" | "out";
  readonly id: string;
  readonly occurred_at: string;
  readonly purpose?: "tips_paid" | null;
  readonly reason: string;
  readonly void_reason: string | null;
  readonly voided_at: string | null;
  readonly voided_by_name: string | null;
}>
export type ServiceCashMovementRecordRequest = Readonly<{
  readonly operation: "cash.movement.record";
  readonly payload: Readonly<{
    readonly amount_minor: number;
    readonly direction: "in" | "out";
    readonly purpose?: "tips_paid";
    readonly reason: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCashMovementRecordResult = Readonly<{
  readonly cash_movement: ServiceCashMovement;
  readonly cash_session: ServiceCashSessionSummary;
  readonly operation: "cash.movement.record";
}>
export type ServiceCashMovementVoidRequest = Readonly<{
  readonly operation: "cash.movement.void";
  readonly payload: Readonly<{
    readonly movement_id: string;
    readonly reason: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCashMovementVoidResult = Readonly<{
  readonly cash_movement: ServiceCashMovement;
  readonly operation: "cash.movement.void";
}>
export type ServiceCashPaymentMethodCorrectRequest = Readonly<{
  readonly operation: "cash.payment-method.correct";
  readonly payload: Readonly<{
    readonly payment_id: string;
    readonly reason: string;
    readonly tender_position?: number;
    readonly to_method: "cash" | "card" | "external" | "external_terminal";
  }>;
  readonly resource_id: string;
}>
export type ServiceCashPaymentMethodCorrectResult = Readonly<{
  readonly cash_correction: ServiceCashCorrection;
  readonly operation: "cash.payment-method.correct";
}>
export type ServiceCashRead = Readonly<{
  readonly activated: boolean;
  readonly current: ServiceCashSessionSummary | null;
  readonly last_closed: ServiceCashSessionSummary | null;
  readonly late_count_allowed: boolean;
  readonly open_tables: Readonly<{
    readonly count: number;
    readonly due_minor: number;
  }>;
}>
export type ServiceCashSessionCloseRequest = Readonly<{
  readonly operation: "cash.session.close";
  readonly payload: Readonly<{
    readonly cash_session_id: string;
    readonly counted_cash_minor: number;
    readonly left_cash_minor: number;
    readonly note?: string;
    readonly terminal_total_minor?: number;
  }>;
  readonly resource_id: string;
}>
export type ServiceCashSessionCloseResult = Readonly<{
  readonly cash_session: ServiceCashSessionSummary;
  readonly operation: "cash.session.close";
}>
export type ServiceCashSessionCountRequest = Readonly<{
  readonly operation: "cash.session.count";
  readonly payload: Readonly<{
    readonly cash_session_id: string;
    readonly counted_cash_minor: number;
    readonly left_cash_minor: number;
    readonly note?: string;
    readonly terminal_total_minor?: number;
  }>;
  readonly resource_id: string;
}>
export type ServiceCashSessionCountResult = Readonly<{
  readonly cash_session: ServiceCashSessionSummary;
  readonly operation: "cash.session.count";
}>
export type ServiceCashSessionEntry = Readonly<{
  readonly card: Readonly<{
    readonly captured_minor: number;
    readonly count: number;
    readonly net_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly card_terminal?: Readonly<{
    readonly difference_minor: number;
    readonly recorded_minor: number;
    readonly terminal_total_minor: number;
  }> | null;
  readonly cash: Readonly<{
    readonly captured_minor: number;
    readonly expected_minor: number;
    readonly movements_in_minor: number;
    readonly movements_out_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly cash_limit_acknowledgements?: readonly (Readonly<{
      readonly acknowledged_at: string;
      readonly actor_name: string | null;
      readonly check_cash_minor: number;
      readonly check_id: string;
      readonly payment_id: string;
    }>)[];
  readonly change_given_minor?: number;
  readonly close: Readonly<{
    readonly closed_at: string;
    readonly closed_by: string;
    readonly counted_at: string | null;
    readonly counted_by: string | null;
    readonly counted_cash_minor: number | null;
    readonly difference_minor: number | null;
    readonly kind: "counted" | "counted_late" | "uncounted" | "no_activity";
    readonly left_cash_minor: number;
    readonly note: string | null;
    readonly terminal_total_minor?: number | null;
    readonly withdrawn_minor: number | null;
  }> | null;
  readonly corrections: readonly (ServiceCashCorrectionEntry)[];
  readonly external: Readonly<{
    readonly captured_minor: number;
    readonly count: number;
    readonly net_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly instruments?: Readonly<{
    readonly bizum?: number;
    readonly card?: number;
    readonly cash?: number;
    readonly meal_voucher?: number;
    readonly other?: number;
    readonly terminal_invoiced?: number;
    readonly transfer?: number;
  }>;
  readonly movements: readonly (ServiceCashMovementEntry)[];
  readonly names: Readonly<{
    readonly closed_by: string | null;
    readonly counted_by: string | null;
    readonly opened_by: string | null;
    readonly restaurant: string | null;
  }>;
  readonly paid_outside_minor: number;
  readonly payments: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly cashback_applied_minor: number;
      readonly check_id: string;
      readonly effective_method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
  readonly provisional: true;
  readonly refunds: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly check_id: string;
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal";
      readonly occurred_at: string;
      readonly payment_id: string;
    }>)[];
  readonly reversed_payments?: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly check_id: string;
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly reason_code: "card_declined" | "wrong_table" | "wrong_amount" | "wrong_payer" | "duplicate";
      readonly reversed_at: string;
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
  readonly schema: "exylon.service.cash-session-summary@1.0";
  readonly session: Readonly<{
    readonly closed_at: string | null;
    readonly closed_by: string | null;
    readonly id: string;
    readonly opened_at: string;
    readonly opened_by: string;
    readonly opening_business_date: string;
    readonly opening_float_minor: number;
    readonly opening_float_source: "declared" | "counted" | "theoretical";
    readonly state: "open" | "closed";
    readonly version: number;
  }>;
  readonly tips?: Readonly<{
    readonly card_minor: number;
    readonly external_minor: number;
    readonly paid_out_minor: number;
  }>;
}> | Readonly<{
  readonly card: Readonly<{
    readonly captured_minor: number;
    readonly count: number;
    readonly net_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly card_terminal?: Readonly<{
    readonly difference_minor: number;
    readonly recorded_minor: number;
    readonly terminal_total_minor: number;
  }> | null;
  readonly cash: Readonly<{
    readonly captured_minor: number;
    readonly expected_minor: number;
    readonly movements_in_minor: number;
    readonly movements_out_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly cash_limit_acknowledgements?: readonly (Readonly<{
      readonly acknowledged_at: string;
      readonly actor_name: string | null;
      readonly check_cash_minor: number;
      readonly check_id: string;
      readonly payment_id: string;
    }>)[];
  readonly change_given_minor?: number;
  readonly close: Readonly<{
    readonly closed_at: string;
    readonly closed_by: string;
    readonly counted_at: string | null;
    readonly counted_by: string | null;
    readonly counted_cash_minor: number | null;
    readonly difference_minor: number | null;
    readonly kind: "counted" | "counted_late" | "uncounted" | "no_activity";
    readonly left_cash_minor: number;
    readonly note: string | null;
    readonly terminal_total_minor?: number | null;
    readonly withdrawn_minor: number | null;
  }> | null;
  readonly corrections: readonly (ServiceCashCorrectionEntry)[];
  readonly external: Readonly<{
    readonly captured_minor: number;
    readonly count: number;
    readonly net_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly instruments?: Readonly<{
    readonly bizum?: number;
    readonly card?: number;
    readonly cash?: number;
    readonly meal_voucher?: number;
    readonly other?: number;
    readonly terminal_invoiced?: number;
    readonly transfer?: number;
  }>;
  readonly later_corrections: ServiceCashLaterCorrections;
  readonly movements: readonly (ServiceCashMovementEntry)[];
  readonly names: Readonly<{
    readonly closed_by: string | null;
    readonly counted_by: string | null;
    readonly opened_by: string | null;
    readonly restaurant: string | null;
  }>;
  readonly paid_outside_minor: number;
  readonly payments: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly cashback_applied_minor: number;
      readonly check_id: string;
      readonly effective_method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
  readonly provisional: false;
  readonly refunds: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly check_id: string;
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal";
      readonly occurred_at: string;
      readonly payment_id: string;
    }>)[];
  readonly reversed_payments?: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly check_id: string;
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly reason_code: "card_declined" | "wrong_table" | "wrong_amount" | "wrong_payer" | "duplicate";
      readonly reversed_at: string;
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
  readonly schema: "exylon.service.cash-session-summary@1.0";
  readonly session: Readonly<{
    readonly closed_at: string | null;
    readonly closed_by: string | null;
    readonly id: string;
    readonly opened_at: string;
    readonly opened_by: string;
    readonly opening_business_date: string;
    readonly opening_float_minor: number;
    readonly opening_float_source: "declared" | "counted" | "theoretical";
    readonly state: "open" | "closed";
    readonly version: number;
  }>;
  readonly tips?: Readonly<{
    readonly card_minor: number;
    readonly external_minor: number;
    readonly paid_out_minor: number;
  }>;
}>
export type ServiceCashSessionOpenRequest = Readonly<{
  readonly operation: "cash.session.open";
  readonly payload: Readonly<{
    readonly opening_float_minor: number;
  }>;
  readonly resource_id: string;
}>
export type ServiceCashSessionOpenResult = Readonly<{
  readonly cash_session: ServiceCashSessionSummary;
  readonly operation: "cash.session.open";
}>
export type ServiceCashSessionsQuery = Readonly<{
  readonly from?: string;
  readonly session_id?: string;
  readonly until?: string;
}>
export type ServiceCashSessionsRead = Readonly<{
  readonly coverage: Readonly<{
    readonly activated_on: string | null;
  }>;
  readonly sessions: readonly (ServiceCashSessionEntry)[];
}>
export type ServiceCashSessionSummary = Readonly<{
  readonly card: Readonly<{
    readonly captured_minor: number;
    readonly count: number;
    readonly net_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly card_terminal?: Readonly<{
    readonly difference_minor: number;
    readonly recorded_minor: number;
    readonly terminal_total_minor: number;
  }> | null;
  readonly cash: Readonly<{
    readonly captured_minor: number;
    readonly expected_minor: number;
    readonly movements_in_minor: number;
    readonly movements_out_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly cash_limit_acknowledgements?: readonly (Readonly<{
      readonly acknowledged_at: string;
      readonly actor_name: string | null;
      readonly check_cash_minor: number;
      readonly check_id: string;
      readonly payment_id: string;
    }>)[];
  readonly change_given_minor?: number;
  readonly close: Readonly<{
    readonly closed_at: string;
    readonly closed_by: string;
    readonly counted_at: string | null;
    readonly counted_by: string | null;
    readonly counted_cash_minor: number | null;
    readonly difference_minor: number | null;
    readonly kind: "counted" | "counted_late" | "uncounted" | "no_activity";
    readonly left_cash_minor: number;
    readonly note: string | null;
    readonly terminal_total_minor?: number | null;
    readonly withdrawn_minor: number | null;
  }> | null;
  readonly corrections: readonly (ServiceCashCorrectionEntry)[];
  readonly external: Readonly<{
    readonly captured_minor: number;
    readonly count: number;
    readonly net_minor: number;
    readonly refunded_minor: number;
  }>;
  readonly instruments?: Readonly<{
    readonly bizum?: number;
    readonly card?: number;
    readonly cash?: number;
    readonly meal_voucher?: number;
    readonly other?: number;
    readonly terminal_invoiced?: number;
    readonly transfer?: number;
  }>;
  readonly movements: readonly (ServiceCashMovementEntry)[];
  readonly names: Readonly<{
    readonly closed_by: string | null;
    readonly counted_by: string | null;
    readonly opened_by: string | null;
    readonly restaurant: string | null;
  }>;
  readonly paid_outside_minor: number;
  readonly payments: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly cashback_applied_minor: number;
      readonly check_id: string;
      readonly effective_method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
  readonly refunds: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly check_id: string;
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal";
      readonly occurred_at: string;
      readonly payment_id: string;
    }>)[];
  readonly reversed_payments?: readonly (Readonly<{
      readonly actor_id: string;
      readonly actor_name: string | null;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly check_id: string;
      readonly id: string;
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly reason_code: "card_declined" | "wrong_table" | "wrong_amount" | "wrong_payer" | "duplicate";
      readonly reversed_at: string;
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
  readonly schema: "exylon.service.cash-session-summary@1.0";
  readonly session: Readonly<{
    readonly closed_at: string | null;
    readonly closed_by: string | null;
    readonly id: string;
    readonly opened_at: string;
    readonly opened_by: string;
    readonly opening_business_date: string;
    readonly opening_float_minor: number;
    readonly opening_float_source: "declared" | "counted" | "theoretical";
    readonly state: "open" | "closed";
    readonly version: number;
  }>;
  readonly tips?: Readonly<{
    readonly card_minor: number;
    readonly external_minor: number;
    readonly paid_out_minor: number;
  }>;
}>
export type ServiceCheckAllocation = Readonly<{
  readonly actor_id: string;
  readonly amount_minor: number;
  readonly basis: "participant" | "lines" | "split_part";
  readonly check_id: string;
  readonly created_at: string;
  readonly id: string;
  readonly lines: readonly (Readonly<{
      readonly amount_minor: number;
      readonly order_item_id: string;
    }>)[];
  readonly part_ordinal: number | null;
  readonly payer_participant_id: string | null;
  readonly restaurant_id: string;
  readonly split_id: string | null;
  readonly state: "open" | "settled" | "superseded" | "voided" | "reversed";
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
  readonly whole_check?: boolean;
}>
export type ServiceCheckChargePlan = Readonly<{
  readonly cashback_available_minor: number;
  readonly cashback_minor: number;
  readonly check_due_minor: number;
  readonly check_id: string;
  readonly collect_minor: number;
  readonly currency: "EUR";
  readonly due_minor: number;
  readonly kind: "participants" | "whole_check" | "lines" | "split_part";
  readonly line_ids: readonly (string)[] | null;
  readonly lines: readonly (Readonly<{
      readonly amount_minor: number;
      readonly order_item_id: string;
    }>)[];
  readonly own_due_minor: number | null;
  readonly participant_ids: readonly (string)[] | null;
  readonly payer_participant_id: string | null;
  readonly plan_fingerprint: string;
  readonly shared_share_minor: number;
  readonly split_part_id: string | null;
}>
export type ServiceCheckChargePlanRequest = Readonly<{
  readonly cashback?: "apply" | "none";
  readonly check_id: string;
  readonly line_ids?: readonly (string)[];
  readonly participant_id?: string;
  readonly participant_ids?: readonly (string)[];
  readonly payer_participant_id?: string;
  readonly split_part_id?: string;
  readonly whole_check?: true;
}>
export type ServiceCheckChargeRequest = Readonly<{
  readonly operation: "check.charge";
  readonly payload: Readonly<{
    readonly cash_limit_acknowledged?: true;
    readonly cashback_minor?: number;
    readonly check_id: string;
    readonly expected_due_minor: number;
    readonly method?: "cash" | "card" | "external" | "external_terminal";
    readonly participant_id: string;
    readonly payer_participant_id?: string;
    readonly plan_fingerprint?: string;
    readonly recipient?: Readonly<{
      readonly city?: string;
      readonly country?: string;
      readonly fiscal_address?: string;
      readonly legal_name: string;
      readonly nif: string;
      readonly postal_code?: string;
      readonly province?: string;
      readonly street?: string;
    }>;
    readonly tenders?: readonly (Readonly<{
        readonly amount_minor: number;
        readonly brand?: string;
        readonly instrument: "cash" | "card" | "bizum" | "transfer" | "meal_voucher" | "terminal_invoiced" | "other";
        readonly reference?: string;
        readonly tendered_minor?: number;
        readonly tip_minor?: number;
      }>)[];
    readonly terminal_reference?: string;
  }> | Readonly<{
    readonly cash_limit_acknowledged?: true;
    readonly cashback_minor?: number;
    readonly check_id: string;
    readonly expected_due_minor: number;
    readonly method?: "cash" | "card" | "external" | "external_terminal";
    readonly participant_ids: readonly (string)[];
    readonly payer_participant_id?: string;
    readonly plan_fingerprint?: string;
    readonly recipient?: Readonly<{
      readonly city?: string;
      readonly country?: string;
      readonly fiscal_address?: string;
      readonly legal_name: string;
      readonly nif: string;
      readonly postal_code?: string;
      readonly province?: string;
      readonly street?: string;
    }>;
    readonly tenders?: readonly (Readonly<{
        readonly amount_minor: number;
        readonly brand?: string;
        readonly instrument: "cash" | "card" | "bizum" | "transfer" | "meal_voucher" | "terminal_invoiced" | "other";
        readonly reference?: string;
        readonly tendered_minor?: number;
        readonly tip_minor?: number;
      }>)[];
    readonly terminal_reference?: string;
  }> | Readonly<{
    readonly cash_limit_acknowledged?: true;
    readonly cashback_minor?: number;
    readonly check_id: string;
    readonly expected_due_minor: number;
    readonly line_ids: readonly (string)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal";
    readonly payer_participant_id?: string;
    readonly plan_fingerprint?: string;
    readonly recipient?: Readonly<{
      readonly city?: string;
      readonly country?: string;
      readonly fiscal_address?: string;
      readonly legal_name: string;
      readonly nif: string;
      readonly postal_code?: string;
      readonly province?: string;
      readonly street?: string;
    }>;
    readonly tenders?: readonly (Readonly<{
        readonly amount_minor: number;
        readonly brand?: string;
        readonly instrument: "cash" | "card" | "bizum" | "transfer" | "meal_voucher" | "terminal_invoiced" | "other";
        readonly reference?: string;
        readonly tendered_minor?: number;
        readonly tip_minor?: number;
      }>)[];
    readonly terminal_reference?: string;
  }> | Readonly<{
    readonly cash_limit_acknowledged?: true;
    readonly cashback_minor?: number;
    readonly check_id: string;
    readonly expected_due_minor: number;
    readonly method?: "cash" | "card" | "external" | "external_terminal";
    readonly payer_participant_id?: string;
    readonly plan_fingerprint?: string;
    readonly recipient?: Readonly<{
      readonly city?: string;
      readonly country?: string;
      readonly fiscal_address?: string;
      readonly legal_name: string;
      readonly nif: string;
      readonly postal_code?: string;
      readonly province?: string;
      readonly street?: string;
    }>;
    readonly split_part_id: string;
    readonly tenders?: readonly (Readonly<{
        readonly amount_minor: number;
        readonly brand?: string;
        readonly instrument: "cash" | "card" | "bizum" | "transfer" | "meal_voucher" | "terminal_invoiced" | "other";
        readonly reference?: string;
        readonly tendered_minor?: number;
        readonly tip_minor?: number;
      }>)[];
    readonly terminal_reference?: string;
  }> | Readonly<{
    readonly cash_limit_acknowledged?: true;
    readonly cashback_minor?: number;
    readonly check_id: string;
    readonly expected_due_minor: number;
    readonly method?: "cash" | "card" | "external" | "external_terminal";
    readonly payer_participant_id?: string;
    readonly plan_fingerprint?: string;
    readonly recipient?: Readonly<{
      readonly city?: string;
      readonly country?: string;
      readonly fiscal_address?: string;
      readonly legal_name: string;
      readonly nif: string;
      readonly postal_code?: string;
      readonly province?: string;
      readonly street?: string;
    }>;
    readonly tenders?: readonly (Readonly<{
        readonly amount_minor: number;
        readonly brand?: string;
        readonly instrument: "cash" | "card" | "bizum" | "transfer" | "meal_voucher" | "terminal_invoiced" | "other";
        readonly reference?: string;
        readonly tendered_minor?: number;
        readonly tip_minor?: number;
      }>)[];
    readonly terminal_reference?: string;
    readonly whole_check: true;
  }>;
  readonly resource_id: string;
}>
export type ServiceCheckChargeResult = Readonly<{
  readonly check: ServiceTableCheck;
  readonly check_allocation: ServiceCheckAllocation;
  readonly check_payment: ServiceCheckPayment;
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "check.charge";
  readonly table_closure?: ServiceTableClosure;
  readonly table_session?: ServiceTableSession;
}>
export type ServiceCheckChargeReverseRequest = Readonly<{
  readonly operation: "check.charge.reverse";
  readonly payload: Readonly<{
    readonly check_id: string;
    readonly payment_id: string;
    readonly reason_code: "card_declined" | "wrong_table" | "wrong_amount" | "wrong_payer" | "duplicate";
    readonly reason_note?: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCheckChargeReverseResult = Readonly<{
  readonly check: ServiceTableCheck;
  readonly check_payment: ServiceCheckPayment;
  readonly check_payment_reversal: Readonly<{
    readonly actor_id: string;
    readonly check_id: string;
    readonly id: string;
    readonly occurred_at: string;
    readonly payment_id: string;
    readonly reason_code: "card_declined" | "wrong_table" | "wrong_amount" | "wrong_payer" | "duplicate";
    readonly reason_note: string | null;
    readonly reopened_closure_id: string | null;
    readonly restaurant_id: string;
    readonly tenant_id: string;
  }>;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "check.charge.reverse";
  readonly table_session?: ServiceTableSession;
}>
export type ServiceCheckConsumptionReceiptQuery = Readonly<{
  readonly artifact_kind: "charge" | "closure" | "refund_appendix";
  readonly source_id: string;
}>
export type ServiceCheckFinalizeRequest = Readonly<{
  readonly operation: "check.finalize";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceCheckFinalizeResult = Readonly<{
  readonly check: ServiceTableCheck;
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "check.finalize";
}>
export type ServiceCheckLineWaiveRequest = Readonly<{
  readonly operation: "check.line.waive";
  readonly payload: Readonly<{
    readonly check_id: string;
    readonly order_item_id: string;
    readonly reason_code: "returned" | "wrong_table" | "house_invitation";
    readonly reason_note?: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCheckLineWaiveResult = Readonly<{
  readonly check: ServiceTableCheck;
  readonly check_line_waiver: Readonly<{
    readonly actor_id: string;
    readonly amount_minor: number;
    readonly check_id: string;
    readonly id: string;
    readonly occurred_at: string;
    readonly order_item_id: string;
    readonly reason_code: "returned" | "wrong_table" | "house_invitation";
    readonly reason_note: string | null;
    readonly restaurant_id: string;
    readonly tenant_id: string;
  }>;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "check.line.waive";
}>
export type ServiceCheckLoyaltyCapture = Readonly<{
  readonly covered_minor: number;
  readonly earning: Readonly<{
    readonly capture_id: string;
    readonly cashback_earned_minor: number;
    readonly currency: "EUR";
    readonly points_earned: number;
    readonly program_version: number;
    readonly recorded_at: string;
    readonly reversal_state: "active" | "reversed";
    readonly status: "recorded";
  }> | Readonly<{
    readonly capture_id: string;
    readonly reason: "table_not_closed";
    readonly recorded_at: string;
    readonly status: "pending";
  }> | Readonly<{
    readonly reason: "anonymous_payer" | "refunded_before_credit";
    readonly status: "not_applicable";
  }> | Readonly<{
    readonly reason: "historical_evidence_missing" | "evidence_inconsistent" | "owner_unavailable" | "payer_identity_unavailable";
    readonly status: "unavailable";
  }>;
  readonly payer_participant_id: string | null;
  readonly payment_id: string;
}>
export type ServiceCheckPayment = Readonly<{
  readonly actor_id: string;
  readonly allocation_id: string;
  readonly amount_minor: number;
  readonly captured_at: string;
  readonly cash_late_linked_at?: string | null;
  readonly cashback_applied_minor: number;
  readonly check_id: string;
  readonly id: string;
  readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
  readonly payer_kind: "identified" | "temporary" | null;
  readonly payer_participant_id: string | null;
  readonly recorded_offline?: boolean;
  readonly restaurant_id: string;
  readonly state: "captured" | "partially_refunded" | "refunded" | "reversed";
  readonly tenant_id: string;
  readonly tenders?: readonly (ServiceCheckPaymentTender)[];
  readonly terminal_reference: string | null;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceCheckPaymentRead = Readonly<{
  readonly found: false;
}> | Readonly<{
  readonly check_due_minor: number;
  readonly found: true;
  readonly payment: Readonly<{
    readonly amount_minor: number;
    readonly captured_at: string;
    readonly cashback_applied_minor: number;
    readonly check_id: string;
    readonly id: string;
    readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly state: "captured" | "partially_refunded" | "refunded" | "reversed";
  }>;
  readonly table_session: Readonly<{
    readonly closed_at: string | null;
    readonly id: string;
    readonly state: "open" | "closed";
    readonly table_id: string;
  }>;
}>
export type ServiceCheckPaymentTender = Readonly<{
  readonly amount_minor: number;
  readonly brand: string | null;
  readonly change_minor: number | null;
  readonly effective_method: "cash" | "card" | "external" | "external_terminal";
  readonly instrument: "cash" | "card" | "bizum" | "transfer" | "meal_voucher" | "terminal_invoiced" | "other";
  readonly method: "cash" | "card" | "external" | "external_terminal";
  readonly position: number;
  readonly reference: string | null;
  readonly tendered_minor: number | null;
  readonly tip_minor: number;
}>
export type ServiceCheckRefund = Readonly<{
  readonly actor_id: string;
  readonly amount_minor: number;
  readonly check_id: string;
  readonly id: string;
  readonly method: "cash" | "card" | "external" | "external_terminal";
  readonly occurred_at: string;
  readonly payment_id: string;
  readonly reason_code: "cold_dish" | "quality_issue" | "wrong_item" | "duplicate_order" | "food_safety_report" | "guest_request" | "other";
  readonly reason_note: string | null;
  readonly refund_group_id?: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type ServiceCheckRefundPreviewRequest = Readonly<{
  readonly check_id: string;
  readonly lines: readonly (ServiceRefundLineSelection)[];
}>
export type ServiceCheckRefundPreviewResult = Readonly<{
  readonly amount_minor: number;
  readonly check_fully_refunded: boolean;
  readonly check_id: string;
  readonly currency: "EUR";
  readonly lines: readonly (ServiceRefundLineFact)[];
  readonly loyalty_reversal: Readonly<{
    readonly affected_account_count: number;
    readonly cashback_minor_shortfall?: number;
    readonly cashback_minor_to_restore?: number;
    readonly cashback_minor_to_reverse: number;
    readonly cashback_minor_withheld_at_close?: number;
    readonly points_to_reverse: number;
    readonly points_withheld_at_close?: number;
    readonly tier_qualification?: Readonly<{
      readonly held_tier_name: string | null;
      readonly lower_tier_name: string | null;
      readonly maintains_held_tier_after: boolean;
      readonly maintains_held_tier_before: boolean;
      readonly spend_minor_leaving: number;
      readonly visits_leaving: number;
    }>;
  }>;
  readonly offer_uses?: readonly (Readonly<{
      readonly coupon_code: string | null;
      readonly definition_id: string;
      readonly display_name: string;
      readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
      readonly participant_id: string | null;
      readonly returns: boolean;
    }>)[];
  readonly payments: readonly (Readonly<{
      readonly amount_minor: number;
      readonly default_method: "cash" | "card" | "external" | "external_terminal";
      readonly payment_id: string;
    }>)[];
  readonly plan_fingerprint: string;
  readonly rounds: readonly (Readonly<{
      readonly order_id: string;
      readonly refund_state: "full" | "partial";
    }>)[];
}>
export type ServiceCheckRefundRecordRequest = Readonly<{
  readonly operation: "refund.record";
  readonly payload: Readonly<{
    readonly check_id: string;
    readonly lines: readonly (ServiceRefundLineSelection)[];
    readonly methods?: readonly (Readonly<{
        readonly method: "cash" | "card" | "external" | "external_terminal";
        readonly payment_id: string;
      }>)[];
    readonly plan_fingerprint: string;
    readonly reason_code: "cold_dish" | "quality_issue" | "wrong_item" | "duplicate_order" | "food_safety_report" | "guest_request" | "other";
    readonly reason_note?: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceCheckRefundRecordResult = Readonly<{
  readonly check_refund: ServiceCheckRefund;
  readonly check_refunds?: readonly (ServiceCheckRefund)[];
  readonly operation: "refund.record";
}>
export type ServiceCheckSplit = Readonly<{
  readonly actor_id: string;
  readonly basis_fingerprint: string;
  readonly basis_net_minor: number;
  readonly check_id: string;
  readonly created_at: string;
  readonly id: string;
  readonly mode: "equal" | "free";
  readonly part_count: number;
  readonly parts: readonly (ServiceCheckAllocation)[];
  readonly restaurant_id: string;
  readonly split_version: number;
  readonly state: "active" | "superseded";
  readonly superseded_at: string | null;
  readonly superseded_reason: "line_changed" | "resplit" | "direct_charge" | "table_closed" | "charge_reversed" | null;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceCheckSplitRequest = Readonly<{
  readonly operation: "check.split";
  readonly payload: Readonly<{
    readonly check_id: string;
    readonly expected_due_minor: number;
    readonly mode: "equal";
    readonly parts: readonly (Readonly<{
        readonly payer_participant_id?: string;
      }>)[];
  }> | Readonly<{
    readonly check_id: string;
    readonly expected_due_minor: number;
    readonly mode: "free";
    readonly parts: readonly (Readonly<{
        readonly amount_minor: number;
        readonly payer_participant_id?: string;
      }>)[];
  }>;
  readonly resource_id: string;
}>
export type ServiceCheckSplitResult = Readonly<{
  readonly check: ServiceTableCheck;
  readonly check_split: ServiceCheckSplit;
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "check.split";
}>
export type ServiceClockRead = Readonly<{
  readonly server_time: string;
}>
export type ServiceCourseAdvanceFact = Readonly<{
  readonly cause: "initial_engagement" | "completion" | "terminal_close";
  readonly course_ordinal: number;
  readonly released_at: string;
  readonly section_id: string;
  readonly table_session_id: string;
}>
export type ServiceCourseAdvanceResultFacts = Readonly<{
  readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
}>
export type ServiceCoursePresentation = Readonly<{
  readonly catalog_publication_version: number;
  readonly course_ordinal: number;
  readonly display_label: string | null;
  readonly section_id: string;
}>
export type ServiceCourseProgression = Readonly<{
  readonly active_courses: readonly (Readonly<{
      readonly course_ordinal: number;
      readonly section_id: string;
    }>)[];
  readonly locked_section_ids: readonly (string)[];
  readonly table_session_id: string;
}>
export type ServiceDepartmentCategories = Readonly<{
  readonly departments: readonly (Readonly<{
      readonly categories: readonly (Readonly<{
          readonly id: string;
          readonly name: string;
        }>)[];
      readonly department_id: string;
    }>)[];
}>
export type ServiceDepartmentDeliveryPresence = Readonly<{
  readonly category_ids: readonly (string)[];
  readonly department_name: string;
  readonly has_active_member: boolean;
  readonly location_id: string;
  readonly target_id: string;
  readonly target_kind: "department";
  readonly viewer_active: boolean;
  readonly viewer_assigned: boolean;
}>
export type ServiceDinerDiscount = Readonly<{
  readonly amount_minor: number;
  readonly campaign_code: string | null;
  readonly coupon_issuance_id: string | null;
  readonly definition_id: string;
  readonly name: string;
  readonly source: "automatic" | "code" | "coupon";
}>
export type ServiceDinerOfferChoice = Readonly<{
  readonly campaign_code: string | null;
  readonly chosen_at: string;
  readonly chosen_by: string;
  readonly chosen_by_kind: "guest" | "staff";
  readonly coupon_issuance_id: string | null;
  readonly created_at: string;
  readonly id: string;
  readonly notice_at: string | null;
  readonly notice_detail: Readonly<{ readonly [key: string]: unknown }> | null;
  readonly notice_reason_code: "better_offer_applied" | "equal_offer_applied" | "no_matching_items" | "conditions_not_met" | "bill_discount_cap_reached" | "total_capacity_reached" | "guest_already_used" | "coupon_expired" | null;
  readonly participant_id: string | null;
  readonly restaurant_id: string;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceDinerOfferChooseRequest = Readonly<{
  readonly operation: "diner.offer.choose";
  readonly payload: Readonly<{
    readonly campaign_code?: string | null;
    readonly choice_version?: number;
    readonly coupon_issuance_id?: string | null;
    readonly participant_id?: string | null;
  }>;
  readonly resource_id: string;
}>
export type ServiceDinerOfferChooseResult = Readonly<{
  readonly diner_offer_choice: ServiceDinerOfferChoice | null;
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "diner.offer.choose";
}>
export type ServiceDinerOfferNotice = Readonly<{
  readonly applied_offer_label: string | null;
  readonly campaign_code: string | null;
  readonly condition_reasons: readonly (string)[];
  readonly coupon_issuance_id: string | null;
  readonly coupon_label: string | null;
  readonly participant_id: string | null;
  readonly reason_code: "better_offer_applied" | "equal_offer_applied" | "no_matching_items" | "conditions_not_met" | "bill_discount_cap_reached" | "total_capacity_reached" | "guest_already_used" | "coupon_expired";
}>
export type ServiceDinerOfferRemoveRequest = Readonly<{
  readonly operation: "diner.offer.remove";
  readonly payload: Readonly<{
    readonly choice_version?: number;
    readonly participant_id?: string | null;
  }>;
  readonly resource_id: string;
}>
export type ServiceDinerOfferRemoveResult = Readonly<{
  readonly diner_offer_choice: ServiceDinerOfferChoice | null;
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "diner.offer.remove";
}>
export type ServiceDinerWithheldOffer = Readonly<{
  readonly definition_id: string;
  readonly name: string;
  readonly reason_code: "saved_account_required" | "party_size_cap_reached";
}>
export type ServiceError = Readonly<{
  readonly code: "AUTHORIZATION_DENIED" | "CLIENT_RESTAURANT_VISIT_ACTIVE_AT_OTHER_TABLE" | "CONFLICT" | "INPUT_INVALID" | "MISSING" | "ORDER_NOT_ACCEPTED" | "SECTION_LOCKED" | "STOCK_INSUFFICIENT" | "WRITE_FAILED";
  readonly message: string;
}>
export type ServiceFloorAssignee = Readonly<{
  readonly display_name: string;
  readonly image_url: string | null;
  readonly presence: "active" | "inactive";
  readonly relation: "self" | "colleague";
}>
export type ServiceFloorBillRequest = Readonly<{
  readonly accepted_at: string | null;
  readonly accepted_by_display_name: string | null;
  readonly accepted_by_self: boolean;
  readonly actions?: Readonly<{
    readonly accept: Readonly<{
      readonly actor?: ServiceActionActor;
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly idempotent: boolean;
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
      readonly reason_text: string | null;
    }>;
  }>;
  readonly currency: "EUR" | null;
  readonly due_minor: number;
  readonly guest_avatar_url?: string | null;
  readonly guest_display_name: string;
  readonly id: string;
  readonly participant_id: string;
  readonly requested_at: string;
  readonly table_id: string;
  readonly table_session_id: string;
  readonly version: number;
}>
export type ServiceFloorDeliveryRelease = Readonly<{
  readonly courses: readonly (Readonly<{
      readonly course_ordinal: number;
      readonly section_id: string;
    }>)[];
  readonly order_item_id: string;
}>
export type ServiceFloorDeliveryRoute = Readonly<{
  readonly active_lease_count: number;
  readonly assignee_scope: "complete" | "viewer_only";
  readonly assignees: readonly (ServiceFloorAssignee)[];
  readonly audience: "assigned" | "covered" | "uncovered";
  readonly coverage_active: boolean;
  readonly order_item_id: string;
}>
export type ServiceFloorDeliveryStaffing = Readonly<{
  readonly assigned_table_count: number;
  readonly assignment_scope: "restaurant" | "visible_work";
  readonly presence_source: "workforce_authenticated_activity_lease";
  readonly viewer_kind: "manager" | "waiter";
}>
export type ServiceFloorDepartmentTableStaffing = Readonly<{
  readonly assignee_scope: "complete" | "viewer_only";
  readonly assignees: readonly (ServiceFloorAssignee)[];
  readonly order_item_id: string;
}>
export type ServiceFloorFulfillmentEvent = Readonly<{
  readonly actor_display_name: string | null;
  readonly from_state: string;
  readonly id: string;
  readonly occurred_at: string;
  readonly order_id: string;
  readonly order_item_id: string;
  readonly reason_code: string;
  readonly reason_note?: string | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly to_state: string;
}>
export type ServiceFloorOrder = Readonly<{
  readonly id: string;
  readonly source_kind: "round" | "welcome";
  readonly table_session_id: string;
}>
export type ServiceFloorOrderItem = Readonly<{
  readonly catalog_publication_version: number;
  readonly category_id: string;
  readonly course_ordinal: number;
  readonly course_section_id: string | null;
  readonly created_at: string;
  readonly dish_id: string;
  readonly fulfillment_station: "kitchen" | "service";
  readonly id: string;
  readonly modifier_names: readonly (string)[];
  readonly name_snapshot: string;
  readonly note: string | null;
  readonly order_id: string;
  readonly quantity: number;
  readonly remake_count: number;
  readonly state: "queued" | "preparing" | "ready" | "delivered" | "cancelled";
  readonly version: number;
}>
export type ServiceFloorSnapshot = Readonly<{
  readonly bill_requests: readonly (ServiceFloorBillRequest)[];
  readonly catalog_publication_version: number | null;
  readonly course_presentations: readonly (ServiceCoursePresentation)[];
  readonly delivery_releases: readonly (ServiceFloorDeliveryRelease)[];
  readonly delivery_routes: readonly (ServiceFloorDeliveryRoute)[];
  readonly delivery_staffing: ServiceFloorDeliveryStaffing;
  readonly department_delivery_presence: readonly (ServiceDepartmentDeliveryPresence)[];
  readonly department_table_staffing: readonly (ServiceFloorDepartmentTableStaffing)[];
  readonly fulfillment_events: readonly (ServiceFloorFulfillmentEvent)[];
  readonly item_actions?: readonly (Readonly<{
      readonly actions: Readonly<{
        readonly deliver: ServiceActionVerdict;
      }>;
      readonly order_item_id: string;
    }>)[];
  readonly order_items: readonly (ServiceFloorOrderItem)[];
  readonly orders: readonly (ServiceFloorOrder)[];
  readonly qr_orders_pause?: ServiceQrOrdersPause;
  readonly restaurant_id: string;
  readonly staff_dishes: Readonly<{
    readonly catalog_publication_version: number | null;
    readonly dishes: readonly (Readonly<{
        readonly dish_id: string;
        readonly photo: Readonly<{
          readonly alt_text: string | null;
          readonly media_id: string;
          readonly sha256_digest: string;
          readonly version: number;
        }> | null;
        readonly preparation_time_minutes: number | null;
        readonly usual_time: Readonly<{
          readonly minutes: number;
          readonly plates: number;
          readonly source: "learned";
        }> | Readonly<{
          readonly minutes: number;
          readonly source: "carta";
        }> | null;
      }>)[];
  }> | null;
  readonly table_presence?: readonly (ServiceTablePresence)[];
  readonly table_qr_pauses?: readonly (ServiceTableQrPause)[];
  readonly table_session_courses: readonly (ServiceFloorTableSessionCourse)[];
  readonly table_sessions: readonly (ServiceFloorTableSession)[];
  readonly tenant_id: string;
  readonly urgency_thresholds: Readonly<{
    readonly department: Readonly<{
      readonly source?: "learned" | "cold_start";
      readonly urgent_after_seconds: number;
      readonly very_urgent_after_seconds: number;
    }>;
    readonly own: Readonly<{
      readonly source?: "learned" | "cold_start";
      readonly urgent_after_seconds: number;
      readonly very_urgent_after_seconds: number;
    }>;
  }>;
  readonly withheld_tables?: readonly (ServiceWithheldTable)[];
}>
export type ServiceFloorTableSession = Readonly<{
  readonly id: string;
  readonly label: string | null;
  readonly location_id: string;
  readonly state: "open" | "closed";
  readonly table_id: string;
  readonly version: number;
}>
export type ServiceFloorTableSessionCourse = Readonly<{
  readonly course_ordinal: number;
  readonly delivered_count: number;
  readonly line_count: number;
  readonly locked_at: string | null;
  readonly progress: "queued" | "preparing" | "ready";
  readonly ready_count: number;
  readonly released_at: string | null;
  readonly section_id: string;
  readonly state: "held" | "released" | "completed";
  readonly table_session_id: string;
}>
export type ServiceForceCloseCausesDetail = Readonly<{
  readonly causes: readonly (Readonly<{
      readonly cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other";
      readonly classification: "impago" | "cobro_externo" | "anulacion";
      readonly note_required: boolean;
    }>)[];
}>
export type ServiceForceCloseReclassifyRequest = Readonly<{
  readonly operation: "force-close.reclassify";
  readonly payload: Readonly<{
    readonly closure_cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other";
    readonly closure_note?: string;
    readonly reclassification_reason: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceForceCloseReclassifyResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "force-close.reclassify";
  readonly session_force_closure: ServiceSessionForceClosure;
}>
export type ServiceFulfillmentBatch = Readonly<{
  readonly delivered_count: number;
  readonly id: string;
  readonly occurred_at: string;
  readonly outcomes: readonly (Readonly<{
      readonly order_item_id: string;
      readonly outcome: "delivered" | "stale" | "invalid_state" | "order_not_accepted";
      readonly version: number;
    }>)[];
  readonly rejected_count: number;
  readonly restaurant_id: string;
  readonly table_session_id: string | null;
  readonly tenant_id: string;
}>
export type ServiceFulfillmentDeliverBatchFloorAnswer = Readonly<{
  readonly board: ServiceFloorSnapshot | null;
  readonly result: ServiceFulfillmentDeliverBatchResult;
  readonly revision: string | null;
}>
export type ServiceFulfillmentDeliverBatchRequest = Readonly<{
  readonly operation: "fulfillment.deliver-batch";
  readonly payload: Readonly<{
    readonly batch_items: readonly (Readonly<{
        readonly expected_version: number;
        readonly order_item_id: string;
      }>)[];
  }>;
  readonly resource_id: string;
}>
export type ServiceFulfillmentDeliverBatchResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly fulfillment_batch: ServiceFulfillmentBatch;
  readonly operation: "fulfillment.deliver-batch";
}>
export type ServiceFulfillmentEvent = Readonly<{
  readonly actor_id: string;
  readonly from_state: string;
  readonly id: string;
  readonly occurred_at: string;
  readonly order_id: string;
  readonly order_item_id: string;
  readonly reason_code: string;
  readonly reason_note?: string | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly to_state: string;
}>
export type ServiceFulfillmentLane = Readonly<{
  readonly category_ids: readonly (string)[];
  readonly configuration_target_id: string | null;
  readonly configuration_target_kind: "department" | null;
  readonly id: string;
  readonly name: string;
  readonly sort_order: number;
  readonly version: number;
}>
export type ServiceFulfillmentOfflineServeRequest = Readonly<{
  readonly operation: "fulfillment.offline-serve";
  readonly payload: Readonly<{
    readonly order_item_ids: readonly (string)[];
  }>;
  readonly resource_id: string;
}>
export type ServiceFulfillmentOfflineServeResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly offline_serve: ServiceOfflineServe;
  readonly operation: "fulfillment.offline-serve";
}>
export type ServiceFulfillmentPlan = Readonly<{
  readonly catalog_publication_version: number;
  readonly created_at: string;
  readonly id: string;
  readonly lanes: readonly (ServiceFulfillmentLane)[];
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceFulfillmentPlanAdvisory = Readonly<{
  readonly code: "configuration_target_missing" | "configuration_target_kind_mismatch";
  readonly configuration_target_id: string;
  readonly configuration_target_kind: "department";
  readonly derived_fulfillment_station: "kitchen";
  readonly lane_id: string;
}>
export type ServiceFulfillmentPlanRead = Readonly<{
  readonly fulfillment_plan: ServiceFulfillmentPlan | null;
}>
export type ServiceFulfillmentPlanReplaceRequest = Readonly<{
  readonly operation: "fulfillment-plan.replace";
  readonly payload: Readonly<{
    readonly catalog_publication_version: number;
    readonly lanes: readonly (Readonly<{
        readonly category_ids: readonly (string)[];
        readonly configuration_target_id?: string;
        readonly configuration_target_kind?: "department";
        readonly id: string;
        readonly name: string;
        readonly sort_order: number;
      }>)[];
  }>;
  readonly resource_id: string;
}>
export type ServiceFulfillmentPlanReplaceResult = Readonly<{
  readonly fulfillment_plan: ServiceFulfillmentPlan;
  readonly fulfillment_plan_advisories?: readonly (ServiceFulfillmentPlanAdvisory)[];
  readonly operation: "fulfillment-plan.replace";
}>
export type ServiceFulfillmentRemakeKitchenAnswer = Readonly<{
  readonly board: ServiceKitchenSnapshot | null;
  readonly result: ServiceFulfillmentRemakeResult;
  readonly revision: string | null;
}>
export type ServiceFulfillmentRemakeRequest = Readonly<{
  readonly operation: "fulfillment.remake";
  readonly payload: Readonly<{
    readonly reason_code: "punto_incorrecto" | "plato_frio" | "error_de_comanda" | "alergeno" | "otro";
  }>;
  readonly resource_id: string;
}>
export type ServiceFulfillmentRemakeResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "fulfillment.remake";
  readonly order_item: ServiceOrderItem;
}>
export type ServiceFulfillmentTransitionFloorAnswer = Readonly<{
  readonly board: ServiceFloorSnapshot | null;
  readonly result: ServiceFulfillmentTransitionResult;
  readonly revision: string | null;
}>
export type ServiceFulfillmentTransitionKitchenAnswer = Readonly<{
  readonly board: ServiceKitchenSnapshot | null;
  readonly result: ServiceFulfillmentTransitionResult;
  readonly revision: string | null;
}>
export type ServiceFulfillmentTransitionRequest = Readonly<{
  readonly operation: "fulfillment.transition";
  readonly payload: Readonly<{
    readonly reason_code?: string;
    readonly reason_note?: string;
    readonly target_state: "preparing" | "ready" | "delivered" | "cancelled";
  }>;
  readonly resource_id: string;
}>
export type ServiceFulfillmentTransitionResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "fulfillment.transition";
  readonly order_item: ServiceOrderItem;
}>
export type ServiceGuestActionVerdict = Readonly<{
  readonly allowed: boolean;
  readonly reason_code: ServiceActionReasonCode | null;
}>
export type ServiceGuestArrival = Readonly<{
  readonly as_of: string;
  readonly lines: readonly (Readonly<{
      readonly format: "minutes" | "window" | "clock" | null;
      readonly from_at: string | null;
      readonly order_item_id: string;
      readonly state: "live" | "learning" | "held";
      readonly to_at: string | null;
      readonly window_id: string;
    }>)[];
  readonly salidas: readonly (Readonly<{
      readonly format: "minutes" | "window" | "clock" | null;
      readonly from_at: string | null;
      readonly section_id: string;
      readonly state: "live" | "learning" | "held";
      readonly to_at: string | null;
      readonly window_id: string;
    }>)[];
  readonly table_session_id: string | null;
}>
export type ServiceGuestBillRequest = Readonly<{
  readonly accepted_at: string | null;
  readonly created_at: string;
  readonly id: string;
  readonly participant_id: string;
  readonly requested_at: string;
  readonly resolution: "paid" | "reopened" | "table_closed" | null;
  readonly resolved_at: string | null;
  readonly restaurant_id: string;
  readonly review_order_id: string | null;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceGuestFulfillmentEvent = Readonly<{
  readonly from_state: string;
  readonly id: string;
  readonly occurred_at: string;
  readonly order_id: string;
  readonly order_item_id: string;
  readonly reason_code: string;
  readonly reason_note?: string | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly to_state: string;
}>
export type ServiceGuestFulfillmentPlan = Readonly<{
  readonly catalog_publication_version: number;
  readonly id: string;
  readonly lanes: readonly (ServiceFulfillmentLane)[];
  readonly version: number;
}>
export type ServiceGuestHistory = Readonly<{
  readonly orders: readonly (ServiceGuestHistoryOrder)[];
  readonly pagination: ServiceGuestHistoryPagination;
  readonly restaurant_id: string;
  readonly spending: ServiceGuestHistorySpending | null;
  readonly tenant_id: string;
  readonly tickets: readonly (ServiceGuestHistoryTicket)[];
  readonly visit_pagination: ServiceGuestHistoryPagination;
  readonly visits: readonly (ServiceGuestHistoryVisit)[];
}>
export type ServiceGuestHistoryCharge = Readonly<{
  readonly amount_minor: number;
  readonly captured_at: string;
  readonly cashback_applied_minor: number;
  readonly covers_my_lines: boolean;
  readonly currency: "EUR";
  readonly invoice: ServiceHistoryChargeInvoice | null;
  readonly lines: readonly (ServiceHistoryChargeLine)[];
  readonly payer: "me" | "table" | "unnamed" | "other";
  readonly payment_id: string;
  readonly refunded_minor: number;
  readonly split?: ServiceHistoryChargeSplit;
}>
export type ServiceGuestHistoryItem = Readonly<{
  readonly id: string;
  readonly line_total_minor: number;
  readonly modifier_snapshot: readonly (Readonly<{
      readonly group_id: string;
      readonly name: string;
      readonly option_id: string;
      readonly price_delta_minor: number;
    }>)[];
  readonly modifier_total_minor: number;
  readonly name_snapshot: string;
  readonly note: string | null;
  readonly quantity: number;
  readonly unit_price_minor: number;
}>
export type ServiceGuestHistoryOrder = Readonly<{
  readonly cashback_applied_minor?: number;
  readonly check_id?: string | null;
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly id: string;
  readonly item_count: number;
  readonly party_size: number;
  readonly placed_at: string;
  readonly service_kind: "dine_in" | "takeaway";
  readonly state: "submitted" | "accepted" | "in_fulfillment" | "fulfilled" | "cancelled";
  readonly subtotal_minor: number;
  readonly total_minor: number;
  readonly updated_at: string;
}>
export type ServiceGuestHistoryPagination = Readonly<{
  readonly has_more: boolean;
  readonly limit: number;
  readonly next_offset: number | null;
  readonly offset: number;
  readonly total: number;
}>
export type ServiceGuestHistorySpending = Readonly<{
  readonly currency: "EUR";
  readonly gross_paid_minor: number;
  readonly last_spent_at: string | null;
  readonly net_spent_minor: number;
  readonly order_count: number;
  readonly refunded_minor: number;
  readonly ticket_count: number;
}>
export type ServiceGuestHistoryTicket = Readonly<{
  readonly captured_minor: number;
  readonly cashback_applied_minor?: number;
  readonly check_id?: string | null;
  readonly check_receipts?: readonly (Readonly<{
      readonly artifact_kind: "charge" | "closure" | "refund_appendix";
      readonly issued_at: string;
      readonly redundant?: boolean;
      readonly source_id: string;
    }>)[];
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly items: readonly (ServiceGuestHistoryItem)[];
  readonly net_paid_minor: number;
  readonly order_id: string;
  readonly order_state: "submitted" | "accepted" | "in_fulfillment" | "fulfilled" | "cancelled";
  readonly party_size: number;
  readonly payment_state: "none" | "settled" | "partially_refunded" | "refunded";
  readonly placed_at: string;
  readonly refunded_minor: number;
  readonly settled_at: string | null;
  readonly subtotal_minor: number;
  readonly total_minor: number;
}>
export type ServiceGuestHistoryVisit = Readonly<{
  readonly captured_minor: number;
  readonly cashback_applied_minor: number;
  readonly charges: readonly (ServiceGuestHistoryCharge)[];
  readonly check_id: string | null;
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly items: readonly (ServiceGuestHistoryItem)[];
  readonly last_order_at: string;
  readonly net_paid_minor: number;
  readonly opened_at: string;
  readonly order_ids: readonly (string)[];
  readonly party_size: number;
  readonly payment_state: "none" | "settled" | "partially_refunded" | "refunded";
  readonly receipts: readonly (Readonly<{
      readonly artifact_kind: "charge" | "closure" | "refund_appendix";
      readonly issued_at: string;
      readonly redundant?: boolean;
      readonly source_id: string;
    }>)[];
  readonly refunded_minor: number;
  readonly settled_at: string | null;
  readonly subtotal_minor: number;
  readonly table_label: string | null;
  readonly table_session_id: string;
  readonly total_minor: number;
}>
export type ServiceGuestParticipantPresentation = Readonly<{
  readonly avatar_url: string | null;
  readonly display_name: string;
}>
export type ServiceGuestPaymentState = "not_requested" | "requested" | "accepted" | "paid"
export type ServiceGuestQrOrdering = Readonly<{
  readonly cause: "restaurant" | "table" | "burst" | null;
  readonly held_order_ids: readonly (string)[];
  readonly state: "open" | "paused";
  readonly until: string | null;
}>
export type ServiceGuestSettlement = Readonly<{
  readonly consumed_minor: number;
  readonly owes_minor: number;
  readonly payment_ids: readonly (string)[];
  readonly settled_at: string | null;
  readonly state: "nothing_to_pay" | "open" | "settled";
}>
export type ServiceGuestSnapshot = Readonly<{
  readonly bill_requests: readonly (ServiceGuestBillRequest)[];
  readonly cart_items: readonly (ServiceCartItem)[];
  readonly carts: readonly (ServiceCart)[];
  readonly course_progression: ServiceCourseProgression | null;
  readonly fulfillment_events: readonly (ServiceGuestFulfillmentEvent)[];
  readonly fulfillment_plan: ServiceGuestFulfillmentPlan | null;
  readonly order_cart_sources: readonly (ServiceOrderCartSource)[];
  readonly order_items: readonly (ServiceOrderItem)[];
  readonly orders: readonly (ServiceOrder)[];
  readonly qr_ordering?: ServiceGuestQrOrdering;
  readonly restaurant_id: string;
  readonly revision: ServiceGuestSnapshotRevision;
  readonly table_lines?: readonly (ServiceGuestTableLine)[];
  readonly table_session_participants: readonly (ServiceGuestTableSessionParticipant)[];
  readonly table_sessions: readonly (ServiceTableSession)[];
  readonly tenant_id: string;
  readonly viewer?: ServiceGuestViewer | null;
  readonly waiting_room_entries: readonly (ServiceWaitingRoomEntry)[];
}>
export type ServiceGuestSnapshotRevision = Readonly<{
  readonly restaurant: number;
  readonly table_session: number;
  readonly table_session_id: string | null;
}>
export type ServiceGuestTableLine = Readonly<{
  readonly catalog_publication_version: number;
  readonly category_id: string;
  readonly created_at: string;
  readonly dish_id: string;
  readonly fulfillment_station: "kitchen" | "service";
  readonly held: boolean;
  readonly line_total_minor: number;
  readonly modifier_snapshot: readonly (Readonly<{
      readonly group_id: string;
      readonly name: string;
      readonly option_id: string;
      readonly price_delta_minor: number;
    }>)[];
  readonly name_snapshot: string;
  readonly order_item_id: string;
  readonly participant_id: string;
  readonly quantity: number;
  readonly requested_section_id: string | null;
  readonly state: "queued" | "preparing" | "ready" | "delivered";
}>
export type ServiceGuestTableSessionParticipant = Readonly<{
  readonly client_identity_id: string | null;
  readonly created_at: string;
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly join_kind: "open" | "join" | "resume" | "staff";
  readonly joined_at: string;
  readonly left_at: string | null;
  readonly participant_kind: "identified" | "temporary";
  readonly presentation?: ServiceGuestParticipantPresentation | null;
  readonly restaurant_id: string;
  readonly seat_label: string | null;
  readonly state: "active" | "left";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceGuestViewer = Readonly<{
  readonly actions: Readonly<{
    readonly order: Readonly<{
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly path: "direct" | "waiting_room";
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
    }>;
    readonly order_more?: Readonly<{
      readonly allowed: boolean;
      readonly reason_code: ServiceActionReasonCode | null;
    }>;
    readonly request_bill: Readonly<{
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly open_request_id: string;
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
    }>;
    readonly review: Readonly<{
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly order_id: string;
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
    }>;
  }>;
  readonly balance: Readonly<{
    readonly adjustments?: readonly (Readonly<{
        readonly discount_minor: number;
        readonly discount_status: "provisional" | "final";
        readonly lines: readonly (Readonly<{
            readonly cart_item_id: string | null;
            readonly discount_minor: number;
            readonly net_minor: number;
            readonly order_item_id: string;
          }>)[];
        readonly order_id: string;
      }>)[];
    readonly currency: "EUR" | null;
    readonly discount_minor?: number;
    readonly discount_status?: "provisional" | "final";
    readonly due_minor: number;
    readonly gross_minor?: number;
    readonly left?: boolean;
    readonly net_minor?: number;
    readonly paid_minor: number;
    readonly shared_due_minor: number;
    readonly shared_share_minor?: number;
  }>;
  readonly bill_request_id: string | null;
  readonly cart_quote?: Readonly<{
    readonly cart_id: string;
    readonly currency: "EUR";
    readonly line_count: number;
    readonly subtotal_minor: number;
  }> | null;
  readonly charge_preview?: Readonly<{
    readonly cashback_minor: number;
    readonly collect_minor: number;
    readonly due_minor: number;
    readonly own_due_minor: number;
    readonly paid_by_me_minor: number;
    readonly paid_for_me_by_others_minor: number;
    readonly shared_lines: readonly (Readonly<{
        readonly name: string;
        readonly order_item_id: string;
        readonly quantity: number;
        readonly share_minor: number;
      }>)[];
    readonly shared_share_minor: number;
    readonly split_parts: readonly (Readonly<{
        readonly amount_minor: number;
        readonly part_ordinal: number;
        readonly state: "open" | "settled";
      }>)[];
  }> | null;
  readonly discounts?: readonly (ServiceDinerDiscount)[];
  readonly lines?: readonly (Readonly<{
      readonly actions: Readonly<{
        readonly edit: ServiceGuestActionVerdict;
        readonly remove: ServiceGuestActionVerdict;
      }>;
      readonly order_item_id: string;
    }>)[];
  readonly offer_choice?: Readonly<{
    readonly campaign_code: string | null;
    readonly chosen_by_kind: "guest" | "staff";
    readonly coupon_issuance_id: string | null;
    readonly coupon_label: string | null;
    readonly notice: ServiceDinerOfferNotice | null;
    readonly version: number;
  }> | null;
  readonly participant_id: string;
  readonly payment_state: ServiceGuestPaymentState;
  readonly settlement?: ServiceGuestSettlement;
  readonly table_session_id: string;
  readonly withheld?: readonly (ServiceDinerWithheldOffer)[];
}>
export type ServiceHistoryChargeInvoice = Readonly<{
  readonly display_number: string | null;
  readonly id: string;
  readonly kind: "simplificada" | "completa";
  readonly state: "issued" | "pending";
}>
export type ServiceHistoryChargeLine = Readonly<{
  readonly amount_minor: number;
  readonly name_snapshot: string;
  readonly order_id: string;
  readonly order_item_id: string;
  readonly quantity: number;
}>
export type ServiceHistoryChargeSplit = Readonly<{
  readonly mode: "equal" | "free";
  readonly part_count: number;
  readonly part_ordinal: number;
}>
export type ServiceKitchenContext = Readonly<{
  readonly anchor_order_item_id: string;
  readonly items: readonly (Readonly<{
      readonly dish_id: string;
      readonly lane_name: string;
      readonly name: string;
      readonly quantity: number;
      readonly state: "queued" | "preparing" | "ready";
    }>)[];
}>
export type ServiceKitchenFulfillmentEvent = Readonly<{
  readonly actor_display_name: string | null;
  readonly from_state: string;
  readonly id: string;
  readonly occurred_at: string;
  readonly order_item_id: string;
  readonly reason_code: string;
  readonly to_state: string;
}>
export type ServiceKitchenHeldLine = Readonly<{
  readonly catalog_publication_version: number;
  readonly course_name: string | null;
  readonly course_ordinal: number;
  readonly course_section_id: string;
  readonly created_at: string;
  readonly dish_id: string;
  readonly lane_id: string;
  readonly modifier_names: readonly (string)[];
  readonly name_snapshot: string;
  readonly note: string | null;
  readonly order_item_id: string;
  readonly quantity: number;
  readonly table_id: string;
  readonly table_session_id: string;
}>
export type ServiceKitchenLane = Readonly<{
  readonly id: string;
  readonly load: Readonly<{
    readonly preparing: number;
    readonly queued: number;
    readonly ready: number;
    readonly total: number;
  }>;
  readonly name: string;
  readonly presence: "active" | "inactive" | null;
  readonly sort_order: number;
}>
export type ServiceKitchenLine = Readonly<{
  readonly actions: Readonly<{
    readonly mark_ready: ServiceActionVerdict;
    readonly remake: ServiceActionVerdict;
    readonly start: ServiceActionVerdict;
    readonly void: ServiceActionVerdict;
  }>;
  readonly catalog_publication_version: number;
  readonly course_ordinal: number;
  readonly course_section_id: string | null;
  readonly created_at: string;
  readonly dish_id: string;
  readonly id: string;
  readonly kitchen_arrival_at: string;
  readonly lane_id: string;
  readonly modifier_names: readonly (string)[];
  readonly name_snapshot: string;
  readonly note: string | null;
  readonly order_source_kind: "round" | "welcome";
  readonly order_state: "submitted" | "accepted" | "in_fulfillment" | "fulfilled" | "cancelled";
  readonly quantity: number;
  readonly remake_count: number;
  readonly state: "queued" | "preparing" | "ready";
  readonly table_session_id: string;
  readonly version: number;
}>
export type ServiceKitchenPendingWork = Readonly<{
  readonly configuration_version: number;
  readonly count: number;
  readonly department_ids: readonly (string)[];
  readonly items: readonly (ServiceKitchenPendingWorkItem)[];
  readonly restaurant_id: string;
  readonly target_id: string;
  readonly target_kind: "floor" | "department";
  readonly tenant_id: string;
}>
export type ServiceKitchenPendingWorkItem = Readonly<{
  readonly course_released: boolean;
  readonly department_id: string;
  readonly name: string;
  readonly order_id: string;
  readonly order_item_id: string;
  readonly quantity: number;
  readonly state: "queued" | "preparing" | "ready";
  readonly table_id: string;
  readonly table_label: string | null;
}>
export type ServiceKitchenPendingWorkQuery = Readonly<{
  readonly configuration_version: number;
  readonly target_id: string;
  readonly target_kind: "floor" | "department";
}>
export type ServiceKitchenProjection = Readonly<{
  readonly reason: "assignment_read_unavailable" | "projection_read_unavailable";
  readonly state: "unavailable";
}> | Readonly<{
  readonly context: readonly (ServiceKitchenContext)[];
  readonly lanes: readonly (ServiceKitchenLane)[];
  readonly lines: readonly (ServiceKitchenLine)[];
  readonly state: "available";
  readonly viewer_kind: "assigned" | "manager";
}>
export type ServiceKitchenSnapshot = Readonly<{
  readonly catalog_publication_version: number | null;
  readonly course_pacing?: Readonly<{
    readonly salidas: readonly (Readonly<{
        readonly basis: "released" | "estimated";
        readonly course_ordinal: number;
        readonly preparation_minutes: number;
        readonly section_id: string;
        readonly suggested_fire_at: string;
        readonly table_session_id: string;
      }>)[];
    readonly usual_gap: Readonly<{
      readonly minutes: number;
      readonly salidas: number;
    }>;
  }> | null;
  readonly course_presentations: readonly (ServiceCoursePresentation)[];
  readonly fulfillment_events: readonly (ServiceKitchenFulfillmentEvent)[];
  readonly held_lines: readonly (ServiceKitchenHeldLine)[];
  readonly kitchen_projection: ServiceKitchenProjection;
  readonly restaurant_id: string;
  readonly staff_dishes: Readonly<{
    readonly catalog_publication_version: number | null;
    readonly dishes: readonly (Readonly<{
        readonly dish_id: string;
        readonly photo: Readonly<{
          readonly alt_text: string | null;
          readonly media_id: string;
          readonly sha256_digest: string;
          readonly version: number;
        }> | null;
        readonly preparation_time_minutes: number | null;
        readonly usual_time: Readonly<{
          readonly minutes: number;
          readonly plates: number;
          readonly source: "learned";
        }> | Readonly<{
          readonly minutes: number;
          readonly source: "carta";
        }> | null;
      }>)[];
  }> | null;
  readonly table_session_courses: readonly (ServiceKitchenTableSessionCourse)[];
  readonly table_sessions: readonly (ServiceKitchenTableSession)[];
  readonly tenant_id: string;
  readonly withheld_tables?: readonly (ServiceWithheldTable)[];
}>
export type ServiceKitchenTableSession = Readonly<{
  readonly id: string;
  readonly label: string | null;
  readonly table_id: string;
}>
export type ServiceKitchenTableSessionCourse = Readonly<{
  readonly course_ordinal: number;
  readonly delivered_count: number;
  readonly late_add: boolean;
  readonly line_count: number;
  readonly locked_at: string | null;
  readonly progress: "queued" | "preparing" | "ready";
  readonly ready_count: number;
  readonly released_at: string | null;
  readonly section_id: string;
  readonly state: "held" | "released" | "completed";
  readonly table_session_id: string;
  readonly version: number;
}>
export type ServiceLiveTableSessionImpact = Readonly<{
  readonly floor_id: string;
  readonly opened_at: string;
  readonly table_id: string;
  readonly table_session_id: string;
}>
export type ServiceManagerFulfillmentDeliverBatchFloorAnswer = Readonly<{
  readonly board: ServiceFloorSnapshot | null;
  readonly result: ServiceManagerFulfillmentDeliverBatchResult;
  readonly revision: string | null;
}>
export type ServiceManagerFulfillmentDeliverBatchRequest = Readonly<{
  readonly operation: "manager.fulfillment.deliver-batch";
  readonly payload: Readonly<{
    readonly batch_items: readonly (Readonly<{
        readonly expected_version: number;
        readonly order_item_id: string;
      }>)[];
    readonly reason_code: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceManagerFulfillmentDeliverBatchResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly fulfillment_batch: ServiceFulfillmentBatch;
  readonly operation: "manager.fulfillment.deliver-batch";
}>
export type ServiceManagerFulfillmentTransitionFloorAnswer = Readonly<{
  readonly board: ServiceFloorSnapshot | null;
  readonly result: ServiceManagerFulfillmentTransitionResult;
  readonly revision: string | null;
}>
export type ServiceManagerFulfillmentTransitionKitchenAnswer = Readonly<{
  readonly board: ServiceKitchenSnapshot | null;
  readonly result: ServiceManagerFulfillmentTransitionResult;
  readonly revision: string | null;
}>
export type ServiceManagerFulfillmentTransitionRequest = Readonly<{
  readonly operation: "manager.fulfillment.transition";
  readonly payload: Readonly<{
    readonly reason_code: string;
    readonly reason_note?: string;
    readonly target_state: "preparing" | "ready" | "delivered" | "cancelled";
  }>;
  readonly resource_id: string;
}>
export type ServiceManagerFulfillmentTransitionResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "manager.fulfillment.transition";
  readonly order_item: ServiceOrderItem;
}>
export type ServiceNobodyHere = Readonly<{
  readonly blocked_guest_profile_ids: readonly (string)[];
  readonly cancelled_order_ids: readonly (string)[];
  readonly paused_until: string;
  readonly table_freed: boolean;
  readonly table_id: string;
  readonly table_session_id: string;
}>
export type ServiceOffersQuoteSourceFacts = Readonly<{
  readonly authorized_table_id: string;
  readonly cart_id: string;
  readonly checkout_order_id?: string;
  readonly contract: "exylon.service.offers-quote-source-facts@1.0";
  readonly currency: "EUR";
  readonly eligibility_at?: string;
  readonly evaluated_at: string;
  readonly feedback_eligible: boolean;
  readonly guest_id: string | null;
  readonly items: readonly (Readonly<{
      readonly catalog_category_id: string;
      readonly catalog_item_id: string;
      readonly catalog_publication_version: number;
      readonly guest_profile_id: string | null;
      readonly line_id: string;
      readonly modifier_option_ids: readonly (string)[];
      readonly quantity: number;
      readonly unit_price_minor: number;
    }>)[];
  readonly new_guest: boolean;
  readonly party_size: number;
  readonly party_size_basis: "roster" | "stated" | "opening_hint";
  readonly party_size_roster: number;
  readonly party_size_stated: number | null;
  readonly restaurant_id: string;
  readonly source_fingerprint: string;
  readonly source_kind: "direct_cart" | "waiting_round";
  readonly source_version: number;
  readonly tenant_id: string;
}>
export type ServiceOffersQuoteSourceItem = Readonly<{
  readonly catalog_category_id: string;
  readonly catalog_item_id: string;
  readonly catalog_publication_version: number;
  readonly guest_profile_id: string | null;
  readonly line_id: string;
  readonly modifier_option_ids: readonly (string)[];
  readonly quantity: number;
  readonly unit_price_minor: number;
}>
export type ServiceOfflineEntry = Readonly<{
  readonly anchor_age_ms: number;
  readonly author: Readonly<{
    readonly display_name: string;
    readonly principal_id: string;
  }>;
  readonly clock_basis: "monotonic" | "wall";
  readonly command: Readonly<{
    readonly expected_version: number | null;
    readonly idempotency_key: string;
    readonly operation: "table-session.open" | "table-session.party-size.set" | "participant.create" | "cart.open" | "cart.item.add" | "cart.item.update" | "cart.item.remove" | "order.submit" | "order.cancel" | "fulfillment.serve" | "check.split" | "check.charge" | "table-session.close";
    readonly payload: Readonly<{ readonly [key: string]: unknown }>;
    readonly resource_id: string;
  }>;
  readonly declared_at: string;
  readonly device_at: string;
  readonly device_id: string;
  readonly entry_id: string;
  readonly figure_shown_minor?: number;
  readonly hash: string;
  readonly invoice_token?: string;
  readonly kind: "table-session.open" | "table-session.party-size.set" | "participant.create" | "cart.open" | "cart.item.add" | "cart.item.update" | "cart.item.remove" | "order.submit" | "order.cancel" | "fulfillment.serve" | "check.split" | "check.charge" | "table-session.close";
  readonly last_contact?: Readonly<{
    readonly at: string;
    readonly proof: string;
  }>;
  readonly prev_hash: string;
  readonly restaurant_id: string;
  readonly scope_line_ids?: readonly (string)[];
  readonly seq: number;
  readonly table_id: string;
  readonly visit_id: string;
}>
export type ServiceOfflineReviewItem = Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly collected_minor: number;
    readonly lines: readonly (Readonly<{
        readonly due_minor: number;
        readonly name: string;
        readonly order_item_id: string;
      }>)[];
    readonly owed_minor: number;
  }>;
  readonly id: string;
  readonly kind: "unpaid_lines";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly collected_minor: number;
    readonly difference_minor: number;
    readonly service_minor: number;
  }>;
  readonly id: string;
  readonly kind: "price_difference_under";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly collected_minor: number;
    readonly difference_minor: number;
    readonly method: "cash" | "card" | "external" | "external_terminal";
    readonly payment_id: string;
    readonly service_minor: number;
  }>;
  readonly id: string;
  readonly kind: "price_difference_over";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly offline: Readonly<{
      readonly amount_minor: number;
      readonly declared_at: string;
      readonly method: "cash" | "card" | "external" | "external_terminal";
      readonly payment_id: string;
    }>;
    readonly online: Readonly<{
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly method: "cash" | "card" | "external" | "external_terminal";
      readonly payment_id: string;
    }>;
  }>;
  readonly id: string;
  readonly kind: "possible_double_charge";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly declared_at: string;
    readonly name: string;
    readonly order_item_id: string;
  }>;
  readonly id: string;
  readonly kind: "served_line_already_cancelled";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly first_declared_at: string;
    readonly last_declared_at: string;
    readonly reason: "future" | "past" | "order" | "after_held" | "publication";
    readonly segment_id: string;
  }>;
  readonly id: string;
  readonly kind: "instant_out_of_bounds";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly first_declared_at: string;
    readonly segment_id: string;
  }>;
  readonly id: string;
  readonly kind: "stale_segment";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly device_id: string;
    readonly from_seq: number;
    readonly to_seq: number;
  }>;
  readonly id: string;
  readonly kind: "sequence_gap";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly amount_minor: number;
    readonly payment_id: string;
  }>;
  readonly id: string;
  readonly kind: "invoice_recipient_required";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly from_visit_id: string;
    readonly into_table_session_id: string;
  }>;
  readonly id: string;
  readonly kind: "table_merged";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly entry_id: string;
    readonly order_id: string;
  }>;
  readonly id: string;
  readonly kind: "void_after_upload";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly captured_at: string;
    readonly payment_id: string;
  }>;
  readonly id: string;
  readonly kind: "loyalty_not_earned";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly charged_minor: number;
    readonly device_id: string;
    readonly entry_count: number;
    readonly first_declared_at: string;
    readonly first_seq?: number;
    readonly last_seq?: number;
    readonly refusal: string;
    readonly segment_id: string;
    readonly visit_id?: string;
  }>;
  readonly id: string;
  readonly kind: "segment_refused";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}> | Readonly<{
  readonly condition_holds: boolean;
  readonly created_at: string;
  readonly detail: Readonly<{
    readonly amount_minor: number;
    readonly declared_at: string;
    readonly payment_id: string;
  }>;
  readonly id: string;
  readonly kind: "charge_in_closed_day";
  readonly outage_started_at: string | null;
  readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared" | null;
  readonly resolutions: readonly ("write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared")[];
  readonly resolved_at: string | null;
  readonly resolved_by_display_name: string | null;
  readonly resolver: "pos" | "manager";
  readonly state: "open" | "resolved";
  readonly table_label: string | null;
  readonly table_session_id: string | null;
  readonly version: number;
}>
export type ServiceOfflineReviewQuery = Readonly<{
  readonly after?: string;
  readonly from?: string;
  readonly state?: "open" | "all";
  readonly to?: string;
}>
export type ServiceOfflineReviewRead = Readonly<{
  readonly items: readonly (ServiceOfflineReviewItem)[];
  readonly next_after: string | null;
}>
export type ServiceOfflineReviewResolution = Readonly<{
  readonly item: ServiceOfflineReviewItem;
}>
export type ServiceOfflineReviewResolveRequest = Readonly<{
  readonly operation: "offline-review.resolve";
  readonly payload: Readonly<{
    readonly resolution: "write_off" | "cash_in" | "acknowledge" | "release_at_receipt" | "release_as_declared";
  }>;
  readonly resource_id: string;
}>
export type ServiceOfflineReviewResolveResult = Readonly<{
  readonly offline_review: ServiceOfflineReviewResolution;
  readonly operation: "offline-review.resolve";
}>
export type ServiceOfflineSegmentRecordRequest = Readonly<{
  readonly contract_version: 1;
  readonly device_id: string;
  readonly entries: readonly (ServiceOfflineEntry)[];
  readonly gaps?: readonly (Readonly<{
      readonly from_seq: number;
      readonly to_seq: number;
    }>)[];
  readonly segment_id: string;
  readonly shell_release: string;
  readonly visit: Readonly<{
    readonly table_id: string;
    readonly visit_id: string;
  }>;
}>
export type ServiceOfflineSegmentRecordResult = Readonly<{
  readonly entries: readonly (Readonly<{
      readonly entry_id: string;
      readonly status: "applied" | "skipped" | "voided" | "held";
    }>)[];
  readonly id_map: readonly (Readonly<{
      readonly from: string;
      readonly to: string;
    }>)[];
  readonly outcome: "applied" | "already_applied" | "held";
  readonly payments: readonly (Readonly<{
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly cash_late: boolean;
      readonly method: "cash" | "card" | "external" | "external_terminal";
      readonly payment_id: string;
    }>)[];
  readonly recorded_at: string;
  readonly review_items: readonly (ServiceOfflineReviewItem)[];
  readonly segment_id: string;
  readonly table_closed: boolean;
  readonly table_session_id: string | null;
}>
export type ServiceOfflineServe = Readonly<{
  readonly already: readonly (string)[];
  readonly cancelled: readonly (string)[];
  readonly delivered: readonly (string)[];
  readonly not_accepted: readonly (string)[];
}>
export type ServiceOperationalCart = Readonly<{
  readonly created_at: string;
  readonly currency: "EUR";
  readonly id: string;
  readonly owner_kind: "staff" | "guest";
  readonly restaurant_id: string;
  readonly state: "active" | "converted" | "abandoned";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceOperationalOrder = Readonly<{
  readonly cart_id: string;
  readonly cashback_applied_minor?: number;
  readonly created_at: string;
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly id: string;
  readonly inventory_reservation_id: string | null;
  readonly inventory_reservation_version: number | null;
  readonly offer_quote_id: string | null;
  readonly offer_redemption_id: string | null;
  readonly placed_at: string;
  readonly reached_kitchen_at?: string | null;
  readonly recorded_offline?: boolean;
  readonly restaurant_id: string;
  readonly service_kind: "dine_in" | "takeaway";
  readonly source_kind: "round" | "welcome";
  readonly state: "submitted" | "accepted" | "in_fulfillment" | "fulfilled" | "cancelled";
  readonly subtotal_minor: number;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly total_minor: number;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceOperationalOrderCartSource = Readonly<{
  readonly cart_id: string;
  readonly cart_version: number;
  readonly order_id: string;
  readonly participant_id?: string | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type ServiceOperationalTableSession = Readonly<{
  readonly checkout_requested_at: string | null;
  readonly closed_at: string | null;
  readonly configuration_version: number;
  readonly created_at: string;
  readonly floor_id: string;
  readonly id: string;
  readonly location_id: string;
  readonly opened_at: string;
  readonly party_size: number | null;
  readonly party_size_stated_by_staff?: boolean;
  readonly recorded_offline?: boolean;
  readonly restaurant_id: string;
  readonly state: "open" | "closed";
  readonly table_id: string;
  readonly table_label?: string | null;
  readonly table_seats?: number | null;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceOperationalTableSessionParticipant = Readonly<{
  readonly created_at: string;
  readonly id: string;
  readonly join_kind: "open" | "join" | "resume" | "staff";
  readonly joined_at: string;
  readonly left_at: string | null;
  readonly participant_kind: "identified" | "temporary";
  readonly restaurant_id: string;
  readonly seat_label: string | null;
  readonly state: "active" | "left";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceOperationalWaitingRoomEntry = Readonly<{
  readonly cart_id: string;
  readonly cart_version: number;
  readonly entered_at: string;
  readonly id: string;
  readonly left_at: string | null;
  readonly restaurant_id: string;
  readonly state: "waiting" | "left" | "submitted";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceOrder = Readonly<{
  readonly cart_id: string;
  readonly cashback_applied_minor?: number;
  readonly created_at: string;
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly inventory_reservation_id: string | null;
  readonly inventory_reservation_version: number | null;
  readonly offer_quote_id: string | null;
  readonly offer_redemption_id: string | null;
  readonly placed_at: string;
  readonly reached_kitchen_at?: string | null;
  readonly recorded_offline?: boolean;
  readonly restaurant_id: string;
  readonly service_kind: "dine_in" | "takeaway";
  readonly source_kind: "round" | "welcome";
  readonly state: "submitted" | "accepted" | "in_fulfillment" | "fulfilled" | "cancelled";
  readonly subtotal_minor: number;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly total_minor: number;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceOrderAcceptRequest = Readonly<{
  readonly operation: "order.accept";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceOrderAcceptResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "order.accept";
  readonly order: ServiceOrder;
}>
export type ServiceOrderCancelRequest = Readonly<{
  readonly operation: "order.cancel";
  readonly payload: Readonly<{
    readonly reason_code?: "nobody_here";
  }>;
  readonly resource_id: string;
}>
export type ServiceOrderCancelResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "order.cancel";
  readonly order: ServiceOrder;
}>
export type ServiceOrderCartSource = Readonly<{
  readonly cart_id: string;
  readonly cart_version: number;
  readonly guest_profile_id: string | null;
  readonly order_id: string;
  readonly participant_id?: string | null;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type ServiceOrderConfirmRequest = Readonly<{
  readonly operation: "order.confirm";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceOrderConfirmResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "order.confirm";
  readonly order: ServiceOrder;
}>
export type ServiceOrderItem = Readonly<{
  readonly catalog_item_version: number;
  readonly catalog_publication_version: number;
  readonly category_id: string;
  readonly course_ordinal: number;
  readonly course_section_id: string | null;
  readonly created_at: string;
  readonly dish_id: string;
  readonly fulfillment_station: "kitchen" | "service";
  readonly id: string;
  readonly line_total_minor: number;
  readonly modifier_snapshot: readonly (Readonly<{
      readonly group_id: string;
      readonly name: string;
      readonly option_id: string;
      readonly price_delta_minor: number;
    }>)[];
  readonly modifier_total_minor: number;
  readonly name_snapshot: string;
  readonly note: string | null;
  readonly order_id: string;
  readonly participant_id?: string | null;
  readonly quantity: number;
  readonly remake_count: number;
  readonly requested_section_id?: string | null;
  readonly restaurant_id: string;
  readonly source_cart_item_id: string;
  readonly state: "queued" | "preparing" | "ready" | "delivered" | "cancelled";
  readonly tenant_id: string;
  readonly unit_price_minor: number;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceOrderItemAddRequest = Readonly<{
  readonly operation: "order.item.add";
  readonly payload: Readonly<{
    readonly catalog_publication_version?: number;
    readonly dish_id: string;
    readonly modifier_option_ids?: readonly (string)[];
    readonly note?: string | null;
    readonly order_id: string;
    readonly participant_id?: string | null;
    readonly quantity: number;
  }>;
  readonly resource_id: string;
}>
export type ServiceOrderItemAddResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "order.item.add";
  readonly order: ServiceOrder;
  readonly order_item: ServiceOrderItem;
}>
export type ServiceOrderItemRemoveRequest = Readonly<{
  readonly operation: "order.item.remove";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceOrderItemRemoveResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "order.item.remove";
  readonly order: ServiceOrder;
  readonly order_item: ServiceOrderItem;
}>
export type ServiceOrderItemUpdateRequest = Readonly<{
  readonly operation: "order.item.update";
  readonly payload: Readonly<{
    readonly modifier_option_ids?: readonly (string)[];
    readonly note?: string | null;
    readonly participant_id?: string | null;
    readonly quantity: number;
  }>;
  readonly resource_id: string;
}>
export type ServiceOrderItemUpdateResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly operation: "order.item.update";
  readonly order: ServiceOrder;
  readonly order_item: ServiceOrderItem;
}>
export type ServiceOrderSubmitRequest = Readonly<{
  readonly operation: "order.submit";
  readonly payload: Readonly<{
    readonly cart_id: string;
    readonly cart_version?: number;
    readonly safety_confirmation_fingerprint?: string;
    readonly service_kind?: "dine_in" | "takeaway";
  }>;
  readonly resource_id: string;
}>
export type ServiceOrderSubmitResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "order.submit";
  readonly order: ServiceOrder;
  readonly order_cart_sources: readonly (ServiceOrderCartSource)[];
}>
export type ServiceOrderSubmitStaffRequest = Readonly<{
  readonly operation: "order.submit";
  readonly payload: Readonly<{
    readonly cart_id: string;
    readonly cart_version?: number;
    readonly reason_code?: "section_lock_override";
    readonly safety_confirmation_fingerprint?: string;
    readonly service_kind?: "dine_in" | "takeaway";
  }>;
  readonly resource_id: string;
}>
export type ServiceParticipantClaimRequest = Readonly<{
  readonly operation: "participant.claim";
  readonly payload: Readonly<{
    readonly claimant_guest_profile_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceParticipantClaimResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "participant.claim";
  readonly participant: ServiceTableSessionParticipant;
}>
export type ServiceParticipantCreateRequest = Readonly<{
  readonly operation: "participant.create";
  readonly payload: Readonly<{
    readonly table_session_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceParticipantCreateResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "participant.create";
  readonly participant: ServiceTableSessionParticipant;
}>
export type ServiceParticipantJoinRequest = Readonly<{
  readonly operation: "participant.join";
  readonly payload: Readonly<{
    readonly seat_label?: string;
    readonly table_session_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceParticipantJoinResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "participant.join";
  readonly participant: ServiceTableSessionParticipant;
}>
export type ServiceParticipantRequestBillRequest = Readonly<{
  readonly operation: "participant.request-bill";
  readonly payload: Readonly<{
    readonly table_session_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceParticipantRequestBillResult = Readonly<{
  readonly bill_request: ServiceBillRequest;
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "participant.request-bill";
  readonly table_session?: ServiceTableSession;
}>
export type ServicePosBillRequest = Readonly<{
  readonly accepted_at: string | null;
  readonly accepted_by: string | null;
  readonly accepted_by_display_name: string | null;
  readonly created_at: string;
  readonly currency: "EUR" | null;
  readonly due_minor: number;
  readonly id: string;
  readonly participant_id: string;
  readonly requested_at: string;
  readonly resolution: "paid" | "reopened" | "table_closed" | null;
  readonly resolved_at: string | null;
  readonly restaurant_id: string;
  readonly review_order_id: string | null;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServicePosCheck = Readonly<{
  readonly balance: Readonly<{
    readonly due_minor: number;
    readonly net_minor: number;
    readonly reserved_minor: number;
    readonly settled_minor: number;
  }>;
  readonly currency: "EUR" | null;
  readonly diners?: readonly (Readonly<{
      readonly choice: Readonly<{
        readonly campaign_code: string | null;
        readonly chosen_by_kind: "guest" | "staff";
        readonly coupon_issuance_id: string | null;
        readonly coupon_label: string | null;
        readonly version: number;
      }> | null;
      readonly discounts: readonly (ServiceDinerDiscount)[];
      readonly notice: ServiceDinerOfferNotice | null;
      readonly participant_id: string | null;
      readonly wallet?: readonly (Readonly<{
          readonly benefit_kind: "percentage" | "fixed_amount" | "free_item";
          readonly benefit_value: number;
          readonly coupon_issuance_id: string;
          readonly fits: boolean;
          readonly label: string;
          readonly last_service_day: string | null;
          readonly level_key: string | null;
          readonly minimum_subtotal_minor: number | null;
        }>)[] | null;
      readonly wallet_coupon_count?: number;
      readonly withheld?: readonly (ServiceDinerWithheldOffer)[];
    }>)[];
  readonly id: string;
  readonly lines: readonly (Readonly<{
      readonly due_minor: number;
      readonly net_final: boolean;
      readonly net_minor: number;
      readonly order_id: string;
      readonly order_item_id: string;
      readonly participant_id: string | null;
      readonly reserved_minor: number;
      readonly settled_minor: number;
    }>)[];
  readonly money_model: "unstarted" | "check";
  readonly participants: readonly (Readonly<{
      readonly cashback_available_minor?: number;
      readonly due_minor: number;
      readonly net_minor: number;
      readonly participant_id: string;
      readonly settled_minor: number;
      readonly shared_share_minor?: number;
    }>)[];
  readonly payments: readonly (Readonly<{
      readonly allocation_id: string;
      readonly amount_minor: number;
      readonly captured_at: string;
      readonly cashback_applied_minor: number;
      readonly id: string;
      readonly lines?: readonly (Readonly<{
          readonly amount_minor: number;
          readonly order_item_id: string;
        }>)[];
      readonly method: "cash" | "card" | "external" | "external_terminal" | "mixed";
      readonly payer_kind: "identified" | "temporary" | null;
      readonly payer_participant_id: string | null;
      readonly state: "captured" | "partially_refunded" | "refunded" | "reversed";
      readonly tenders?: readonly (ServiceCheckPaymentTender)[];
    }>)[];
  readonly plans?: Readonly<{
    readonly diners: readonly (Readonly<{
        readonly participant_id: string;
        readonly plan: Readonly<{
          readonly cashback_minor: number;
          readonly collect_minor: number;
          readonly due_minor: number;
          readonly plan_fingerprint: string;
        }>;
        readonly plan_with_saldo: Readonly<{
          readonly cashback_minor: number;
          readonly collect_minor: number;
          readonly due_minor: number;
          readonly plan_fingerprint: string;
        }> | null;
      }>)[];
    readonly parts: readonly (Readonly<{
        readonly allocation_id: string;
        readonly plan: Readonly<{
          readonly cashback_minor: number;
          readonly collect_minor: number;
          readonly due_minor: number;
          readonly plan_fingerprint: string;
        }>;
      }>)[];
    readonly whole_check: Readonly<{
      readonly cashback_minor: number;
      readonly collect_minor: number;
      readonly due_minor: number;
      readonly plan_fingerprint: string;
    }>;
  }> | null;
  readonly rounds: readonly (Readonly<{
      readonly discount_state: "provisional" | "final";
      readonly order_id: string;
    }>)[];
  readonly shared: Readonly<{
    readonly due_minor: number;
    readonly line_ids: readonly (string)[];
    readonly net_minor: number;
  }>;
  readonly split: Readonly<{
    readonly basis_net_minor: number;
    readonly id: string;
    readonly mode: "equal" | "free";
    readonly parts: readonly (Readonly<{
        readonly allocation_id: string;
        readonly amount_minor: number;
        readonly line_ids: readonly (string)[];
        readonly part_ordinal: number;
        readonly payer_participant_id: string | null;
        readonly state: "open" | "settled" | "superseded" | "voided" | "reversed";
      }>)[];
    readonly split_version: number;
    readonly version: number;
  }> | null;
  readonly state: "open" | "closed";
  readonly table_session_id: string;
  readonly version: number;
  readonly waived_lines: readonly (Readonly<{
      readonly order_item_id: string;
      readonly reason_code: "returned" | "wrong_table" | "house_invitation";
    }>)[];
}>
export type ServicePosParticipantLoyaltyTier = Readonly<{
  readonly card_style: "japanese_card" | "nature_card" | "luxury_metal_card" | "joyful_card";
  readonly cashback_bps: number;
  readonly level_key: "basic" | "silver" | "gold" | "black" | null;
  readonly name: string;
  readonly staff_heads_up: boolean;
}>
export type ServicePosParticipantStaffCard = Readonly<{
  readonly avatar_url: string | null;
  readonly display_name: string;
  readonly loyalty_tier: ServicePosParticipantLoyaltyTier | null;
  readonly wallet_reward_as_of: string | null;
  readonly wallet_reward_count: number | null;
}>
export type ServicePosSnapshot = Readonly<{
  readonly bill_requests: readonly (ServicePosBillRequest)[];
  readonly cart_items: readonly (ServiceCartItem)[];
  readonly carts: readonly (ServiceOperationalCart)[];
  readonly catalog_publication_version: number | null;
  readonly checks?: readonly (ServicePosCheck)[];
  readonly course_presentations: readonly (ServiceCoursePresentation)[];
  readonly fulfillment_events: readonly (ServiceGuestFulfillmentEvent)[];
  readonly fulfillment_plan: null;
  readonly offline_reviews?: readonly (ServiceOfflineReviewItem)[];
  readonly order_cart_sources: readonly (ServiceOperationalOrderCartSource)[];
  readonly order_items: readonly (ServiceOrderItem)[];
  readonly orders: readonly (ServiceOperationalOrder)[];
  readonly pending_close?: readonly (Readonly<{
      readonly service_date: string;
      readonly table_session_id: string;
    }>)[];
  readonly qr_orders_pause?: ServiceQrOrdersPause;
  readonly restaurant_id: string;
  readonly table_actions?: readonly (ServicePosTableActions)[];
  readonly table_presence?: readonly (ServiceTablePresence)[];
  readonly table_qr_pauses?: readonly (ServiceTableQrPause)[];
  readonly table_session_courses: readonly (ServiceTableSessionCourse)[];
  readonly table_session_participants: readonly (ServicePosTableSessionParticipant)[];
  readonly table_sessions: readonly (ServiceOperationalTableSession)[];
  readonly tenant_id: string;
  readonly waiting_room_entries: readonly (ServiceOperationalWaitingRoomEntry)[];
}>
export type ServicePosTableActions = Readonly<{
  readonly actions: Readonly<{
    readonly charge: Readonly<{
      readonly actor?: ServiceActionActor;
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly order_item_ids?: readonly (string)[];
      }>;
      readonly preview?: Readonly<{
        readonly currency: "EUR" | null;
        readonly due_minor: number;
        readonly paid_minor: number;
        readonly per_participant: readonly (Readonly<{
            readonly accepted_by_display_name: string | null;
            readonly due_minor: number;
            readonly net_minor: number;
            readonly participant_id: string;
            readonly requested_at: string | null;
          }>)[];
        readonly shared_due_minor: number;
        readonly waiting_net_minor: number;
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
      readonly reason_text: string | null;
    }>;
    readonly charge_sheet?: ServiceActionVerdict;
    readonly close: Readonly<{
      readonly actor?: ServiceActionActor;
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly blocking_orders?: readonly (Readonly<{
            readonly currency: "EUR";
            readonly due_minor: number;
            readonly order_id: string;
            readonly placed_at: string;
            readonly state: "submitted" | "accepted" | "in_fulfillment" | "fulfilled" | "cancelled";
            readonly total_minor: number;
          }>)[];
        readonly currency: "EUR" | null;
        readonly due_minor: number;
        readonly order_item_ids?: readonly (string)[];
        readonly participants?: readonly (Readonly<{
            readonly due_minor: number;
            readonly participant_id: string;
          }>)[];
        readonly shared_due_minor?: number;
      }> | Readonly<{
        readonly order_item_ids: readonly (string)[];
      }>;
      readonly preview?: Readonly<{
        readonly currency: "EUR" | null;
        readonly due_minor: number;
        readonly paid_minor: number;
        readonly waiting_order_ids?: readonly (string)[];
        readonly waiting_round_count: number;
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
      readonly reason_text: string | null;
    }>;
    readonly force_close: Readonly<{
      readonly actor?: ServiceActionActor;
      readonly allowed: boolean;
      readonly detail?: ServiceForceCloseCausesDetail;
      readonly preview?: Readonly<{
        readonly currency: "EUR" | null;
        readonly due_minor: number;
        readonly made_unpaid_lines: readonly (ServicePosTableClosePreviewLine)[];
        readonly outcomes: Readonly<{
          readonly anulacion: ServicePosTableClosePreviewOutcome;
          readonly cobro_externo: ServicePosTableClosePreviewOutcome;
          readonly impago: ServicePosTableClosePreviewOutcome;
        }>;
        readonly paid_minor: number;
        readonly unmade_unpaid_lines: readonly (ServicePosTableClosePreviewLine)[];
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
      readonly reason_text: string | null;
    }>;
    readonly send: Readonly<{
      readonly actor?: ServiceActionActor;
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly cart_id: string | null;
        readonly item_count: number;
      }>;
      readonly preview?: Readonly<{
        readonly currency: "EUR" | null;
        readonly section_ids: readonly (string)[];
        readonly total_minor: number;
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
      readonly reason_text: string | null;
    }>;
  }>;
  readonly guest_carts?: readonly (Readonly<{
      readonly actions: Readonly<{
        readonly discard: Readonly<{
          readonly actor?: ServiceActionActor;
          readonly allowed: boolean;
          readonly detail?: Readonly<{
            readonly cart_id: string;
            readonly item_count: number;
          }>;
          readonly reason_code: ServiceActionReasonCode | null;
          readonly reason_text: string | null;
        }>;
        readonly send: Readonly<{
          readonly actor?: ServiceActionActor;
          readonly allowed: boolean;
          readonly detail?: Readonly<{
            readonly cart_id: string;
            readonly item_count: number;
          }>;
          readonly reason_code: ServiceActionReasonCode | null;
          readonly reason_text: string | null;
        }>;
      }>;
      readonly cart_id: string;
    }>)[];
  readonly lines: readonly (Readonly<{
      readonly actions: Readonly<{
        readonly deliver: ServiceActionVerdict;
        readonly edit: ServiceActionVerdict;
        readonly remove: ServiceActionVerdict;
        readonly void: ServiceActionVerdict;
      }>;
      readonly order_item_id: string;
    }>)[];
  readonly participants: readonly (Readonly<{
      readonly actions: Readonly<{
        readonly add_for_guest: Readonly<{
          readonly actor?: ServiceActionActor;
          readonly allowed: boolean;
          readonly detail?: Readonly<{
            readonly choices: readonly ("keep_request" | "reopen")[];
            readonly open_request_id: string;
          }>;
          readonly reason_code: ServiceActionReasonCode | null;
          readonly reason_text: string | null;
        }>;
        readonly charge_guest: Readonly<{
          readonly actor?: ServiceActionActor;
          readonly allowed: boolean;
          readonly detail?: Readonly<{
            readonly covers_shared: boolean;
            readonly order_item_ids?: readonly (string)[];
          }>;
          readonly preview?: Readonly<{
            readonly currency: "EUR" | null;
            readonly due_minor: number;
            readonly due_with_shared_minor?: number;
            readonly own_due_minor?: number;
            readonly requested_at: string | null;
            readonly shared_share_minor?: number;
          }>;
          readonly reason_code: ServiceActionReasonCode | null;
          readonly reason_text: string | null;
        }>;
        readonly reopen_request: ServiceActionVerdict;
      }>;
      readonly participant_id: string;
    }>)[];
  readonly phase: "no_rounds" | "ordering" | "in_kitchen" | "serving" | "payment_requested" | "charging" | "paid";
  readonly primary: "send" | "close" | "charge" | "add" | "none";
  readonly rounds: readonly (Readonly<{
      readonly actions: Readonly<{
        readonly cancel: ServiceActionVerdict;
      }>;
      readonly focus: boolean;
      readonly order_id: string;
    }>)[];
  readonly staff_cart_lines?: readonly (Readonly<{
      readonly actions: Readonly<{
        readonly edit: ServiceActionVerdict;
        readonly remove: ServiceActionVerdict;
      }>;
      readonly cart_item_id: string;
    }>)[];
  readonly table_id: string;
  readonly table_session_id: string;
}>
export type ServicePosTableClosePreviewLine = Readonly<{
  readonly line_total_minor: number;
  readonly name_snapshot: string;
  readonly order_id: string;
  readonly order_item_id: string;
  readonly quantity: number;
  readonly state: "queued" | "preparing" | "ready" | "delivered";
}>
export type ServicePosTableClosePreviewOutcome = Readonly<{
  readonly external_minor: number;
  readonly kept_line_count: number;
  readonly voided_line_count: number;
  readonly voided_net_minor: number;
  readonly written_off_minor: number;
}>
export type ServicePosTableSessionParticipant = Readonly<{
  readonly created_at: string;
  readonly id: string;
  readonly join_kind: "open" | "join" | "resume" | "staff";
  readonly joined_at: string;
  readonly left_at: string | null;
  readonly participant_kind: "identified" | "temporary";
  readonly restaurant_id: string;
  readonly seat_label: string | null;
  readonly staff_card: ServicePosParticipantStaffCard;
  readonly state: "active" | "left";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceProbeRead = Readonly<{
  readonly contact_proof: string;
  readonly server_time: string;
}>
export type ServiceQrOrdersPause = Readonly<{
  readonly changed_at: string | null;
  readonly paused: boolean;
  readonly version: number;
}>
export type ServiceQrOrdersPauseSetRequest = Readonly<{
  readonly operation: "qr-orders.pause.set";
  readonly payload: Readonly<{
    readonly paused: boolean;
  }>;
  readonly resource_id: string;
}>
export type ServiceQrOrdersPauseSetResult = Readonly<{
  readonly operation: "qr-orders.pause.set";
  readonly qr_orders_pause: ServiceQrOrdersPause;
}>
export type ServiceRefundLineFact = Readonly<{
  readonly amount_minor: number;
  readonly category_id: string;
  readonly dish_id: string;
  readonly order_item_id: string;
  readonly units: number;
}>
export type ServiceRefundLineSelection = Readonly<{
  readonly order_item_id: string;
  readonly units: number;
}>
export type ServiceRefundReasonCode = "cold_dish" | "quality_issue" | "wrong_item" | "duplicate_order" | "food_safety_report" | "guest_request" | "other"
export type ServiceRefundRecordRequest = Readonly<{
  readonly operation: "refund.record";
  readonly payload: Readonly<{
    readonly check_id: string;
    readonly lines: readonly (ServiceRefundLineSelection)[];
    readonly methods?: readonly (Readonly<{
        readonly method: "cash" | "card" | "external" | "external_terminal";
        readonly payment_id: string;
      }>)[];
    readonly plan_fingerprint: string;
    readonly reason_code: "cold_dish" | "quality_issue" | "wrong_item" | "duplicate_order" | "food_safety_report" | "guest_request" | "other";
    readonly reason_note?: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceRefundRecordResult = Readonly<{
  readonly check_refund: ServiceCheckRefund;
  readonly check_refunds?: readonly (ServiceCheckRefund)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "refund.record";
}>
export type ServiceRemakeReasonCode = "punto_incorrecto" | "plato_frio" | "error_de_comanda" | "alergeno" | "otro"
export type ServiceSafetyChallenge = Readonly<{
  readonly cart_id: string;
  readonly cart_item_id: string;
  readonly cart_version: number;
  readonly configuration_fingerprint: string;
  readonly line_version: number;
  readonly outcome: "conflict" | "unknown";
  readonly preference_versions: Readonly<{
    readonly global?: number;
    readonly restaurant?: number;
  }>;
  readonly reason_code: string;
  readonly reason_label: string;
  readonly table_session_id: string;
}>
export type ServiceSafetyChallengeQuery = Readonly<{
  readonly cart_id: string;
  readonly cart_item_id: string;
  readonly table_session_id: string;
}>
export type ServiceSessionForceClosure = Readonly<{
  readonly actor_id: string;
  readonly approved_by_principal_id: string | null;
  readonly cancelled_item_count: number;
  readonly closed_at: string;
  readonly closure_cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other";
  readonly closure_classification: "impago" | "cobro_externo" | "anulacion";
  readonly closure_note: string | null;
  readonly created_at: string;
  readonly currency: "EUR" | null;
  readonly external_minor: number;
  readonly id: string;
  readonly paid_minor: number;
  readonly restaurant_id: string;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
  readonly written_off_minor: number;
}>
export type ServiceSnapshot = Readonly<{
  readonly bill_requests?: readonly (ServiceBillRequest)[];
  readonly cart_items: readonly (ServiceCartItem)[];
  readonly carts: readonly (ServiceCart)[];
  readonly course_presentations: readonly (ServiceCoursePresentation)[];
  readonly fulfillment_events: readonly (ServiceFulfillmentEvent)[];
  readonly fulfillment_plan: ServiceFulfillmentPlan | null;
  readonly order_cart_sources: readonly (ServiceOrderCartSource)[];
  readonly order_items: readonly (ServiceOrderItem)[];
  readonly orders: readonly (ServiceOrder)[];
  readonly restaurant_id: string;
  readonly table_session_courses: readonly (ServiceTableSessionCourse)[];
  readonly table_session_participants: readonly (ServiceTableSessionParticipant)[];
  readonly table_sessions: readonly (ServiceTableSession)[];
  readonly tenant_id: string;
  readonly waiting_room_entries: readonly (ServiceWaitingRoomEntry)[];
}>
export type ServiceStaffCheckOrderLoyalty = Readonly<{
  readonly captures: readonly (ServiceCheckLoyaltyCapture)[];
  readonly check_id: string;
  readonly contract: "exylon.service.check-order-loyalty@1.0";
  readonly current_rewards: readonly (Readonly<{
      readonly as_of: string;
      readonly coverage: "wallet_only";
      readonly eligibility: "not_evaluated";
      readonly payer_participant_id: string;
      readonly reward_count: number;
      readonly status: "available";
    }> | Readonly<{
      readonly as_of: string | null;
      readonly payer_participant_id: string | null;
      readonly reason: "anonymous_payer";
      readonly reward_count: null;
      readonly status: "not_applicable";
    }> | Readonly<{
      readonly as_of: string | null;
      readonly payer_participant_id: string | null;
      readonly reason: "owner_unavailable" | "payer_identity_unavailable";
      readonly reward_count: null;
      readonly status: "unavailable";
    }>)[];
  readonly discounts: ServiceStaffOrderDiscounts;
  readonly order_id: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type ServiceStaffHistory = Readonly<{
  readonly course_presentations: readonly (Readonly<{
      readonly catalog_publication_version: number;
      readonly course_ordinal: number;
      readonly display_label: string | null;
      readonly locale: string | null;
      readonly resolution: "exact_locale" | "source_locale" | "publication_fallback" | "missing_publication" | "missing_section" | "missing_course" | "missing_label";
      readonly section_id: string;
    }>)[];
  readonly orders: readonly (ServiceStaffHistoryOrder)[];
  readonly pagination: ServiceStaffHistoryPagination;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type ServiceStaffHistoryCharge = Readonly<{
  readonly actions?: Readonly<{
    readonly refund: Readonly<{
      readonly actor?: ServiceActionActor;
      readonly allowed: boolean;
      readonly detail?: Readonly<{
        readonly lines: readonly (Readonly<{
            readonly max_units: number;
            readonly order_id: string;
            readonly order_item_id: string;
            readonly payments: readonly (Readonly<{
                readonly cash_left_minor: number;
                readonly cashback_minor: number;
                readonly payment_id: string;
              }>)[];
          }>)[];
      }>;
      readonly reason_code: ServiceActionReasonCode | null;
      readonly reason_text: string | null;
    }>;
  }>;
  readonly amount_minor: number;
  readonly basis: "lines" | "participant" | "split_part";
  readonly captured_at: string;
  readonly cashback_applied_minor: number;
  readonly currency: "EUR";
  readonly id: string;
  readonly invoice: ServiceHistoryChargeInvoice | null;
  readonly lines: readonly (ServiceHistoryChargeLine)[];
  readonly net_paid_minor: number;
  readonly offline_author_display_name?: string | null;
  readonly offline_recorded_at?: string | null;
  readonly offline_uploader_display_name?: string | null;
  readonly order_ids: readonly (string)[];
  readonly outcome: "cobrado" | "cobrado_con_reembolso_parcial" | "reembolsado" | "anulado";
  readonly payer_participant_id: string | null;
  readonly payment_method: "cash" | "card" | "external" | "external_terminal" | "mixed";
  readonly placed_at: string;
  readonly recorded_offline?: boolean;
  readonly rectification: Readonly<{
    readonly display_number: string | null;
  }> | null;
  readonly refunded_minor: number;
  readonly split?: ServiceHistoryChargeSplit;
  readonly state: "captured" | "partially_refunded" | "refunded" | "reversed";
  readonly tenders?: readonly (ServiceCheckPaymentTender)[];
  readonly whole_check: boolean;
}>
export type ServiceStaffHistoryFulfillmentTimeline = Readonly<{
  readonly from_state: "queued" | "preparing" | "ready" | "delivered" | "cancelled";
  readonly occurred_at: string;
  readonly order_item_id: string;
  readonly reason_code: string;
  readonly to_state: "queued" | "preparing" | "ready" | "delivered" | "cancelled";
}>
export type ServiceStaffHistoryItem = Readonly<{
  readonly catalog_publication_version: number;
  readonly category_id: string;
  readonly course_identity_resolution: "pinned" | "missing_historical_pins";
  readonly course_ordinal: number;
  readonly course_section_id: string | null;
  readonly dish_id: string;
  readonly id: string;
  readonly line_total_minor: number;
  readonly modifier_total_minor: number;
  readonly name_snapshot: string;
  readonly participant_id: string | null;
  readonly quantity: number;
  readonly refunded_minor: number;
  readonly refunded_units: number;
  readonly remake_count: number;
  readonly state: "queued" | "preparing" | "ready" | "delivered" | "cancelled";
  readonly unit_price_minor: number;
}>
export type ServiceStaffHistoryOrder = Readonly<{
  readonly actions?: Readonly<{
    readonly reclassify: Readonly<{
      readonly actor?: ServiceActionActor;
      readonly allowed: boolean;
      readonly detail?: ServiceForceCloseCausesDetail;
      readonly reason_code: ServiceActionReasonCode | null;
      readonly reason_text: string | null;
    }>;
  }>;
  readonly captured_minor: number;
  readonly cashback_applied_minor?: number;
  readonly charges: readonly (ServiceStaffHistoryCharge)[];
  readonly check_id?: string | null;
  readonly check_receipts?: readonly (Readonly<{
      readonly artifact_kind: "charge" | "closure" | "refund_appendix";
      readonly issued_at: string;
      readonly redundant?: boolean;
      readonly source_id: string;
    }>)[];
  readonly closure_actor_display_name: string | null;
  readonly closure_cancelled_item_count: number | null;
  readonly closure_cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other" | null;
  readonly closure_classification: "impago" | "cobro_externo" | "anulacion" | null;
  readonly closure_closed_at: string | null;
  readonly closure_id: string | null;
  readonly closure_kind: "normal" | "forced";
  readonly closure_note: string | null;
  readonly closure_reclassifications: readonly (ServiceStaffHistoryReclassification)[];
  readonly closure_version: number | null;
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly external_minor: number;
  readonly fulfillment_timeline: readonly (ServiceStaffHistoryFulfillmentTimeline)[];
  readonly id: string;
  readonly items: readonly (ServiceStaffHistoryItem)[];
  readonly net_paid_minor: number;
  readonly offline_author_display_name?: string | null;
  readonly offline_recorded_at?: string | null;
  readonly offline_uploader_display_name?: string | null;
  readonly outcome: "cobrado" | "cobrado_con_reembolso_parcial" | "reembolsado" | "impagado" | "cobro_externo" | "anulado_por_error" | "cancelado" | "en_curso";
  readonly participants: readonly (ServiceStaffHistoryParticipant)[];
  readonly party_size: number | null;
  readonly payments: readonly (ServiceStaffHistoryPayment)[];
  readonly placed_at: string;
  readonly recorded_offline?: boolean;
  readonly refunded_minor: number;
  readonly service_kind: "dine_in" | "takeaway";
  readonly settled_at: string | null;
  readonly state: "submitted" | "accepted" | "in_fulfillment" | "fulfilled" | "cancelled";
  readonly subtotal_minor: number;
  readonly table_id: string;
  readonly table_label: string | null;
  readonly table_session_id: string;
  readonly total_minor: number;
  readonly updated_at: string;
  readonly written_off_minor: number;
}>
export type ServiceStaffHistoryPagination = Readonly<{
  readonly has_more: boolean;
  readonly limit: number;
  readonly mode: "cursor";
  readonly next_cursor_order_id?: string;
  readonly next_cursor_placed_at?: string;
}>
export type ServiceStaffHistoryParticipant = Readonly<{
  readonly admission_handle?: string | null;
  readonly avatar_url: string | null;
  readonly display_name: string;
  readonly distinct_visit_count: number;
  readonly loyalty_tier: ServiceStaffHistoryParticipantTier | null;
  readonly moderation_handle: string | null;
  readonly participant_id: string | null;
  readonly participant_kind: "identified" | "temporary";
  readonly payment_label?: "captured" | "refunded" | "closure" | "none";
  readonly review: ServiceStaffHistoryReview | null;
}>
export type ServiceStaffHistoryParticipantTier = Readonly<{
  readonly card_style: "japanese_card" | "nature_card" | "luxury_metal_card" | "joyful_card";
  readonly cashback_bps: number;
  readonly level_key: "basic" | "silver" | "gold" | "black";
  readonly name: string;
  readonly staff_heads_up: boolean;
}>
export type ServiceStaffHistoryPayment = Readonly<{
  readonly allocation_id: string | null;
  readonly amount_minor: number;
  readonly captured_at: string | null;
  readonly cashback_applied_minor?: number;
  readonly id: string;
  readonly payer_participant_id: string | null;
  readonly payment_method: "cash" | "card" | "external" | "external_terminal" | "mixed" | null;
  readonly refunded_minor: number;
  readonly state: "captured" | "partially_refunded" | "refunded" | "reversed";
}> | Readonly<{
  readonly allocation_id: string;
  readonly amount_minor: number;
  readonly captured_at: null;
  readonly cashback_applied_minor?: 0;
  readonly id: null;
  readonly payer_participant_id: string;
  readonly payment_method: null;
  readonly refunded_minor: 0;
  readonly state: "open" | "settled" | "superseded" | "voided" | "reversed";
}>
export type ServiceStaffHistoryQuery = Readonly<{
  readonly billing?: "pending" | "incidents";
  readonly cursor_order_id?: string;
  readonly cursor_placed_at?: string;
  readonly limit?: number;
  readonly order_id?: string;
  readonly outcome?: readonly ("cobrado" | "cobrado_con_reembolso_parcial" | "reembolsado" | "impagado" | "cobro_externo" | "anulado_por_error" | "cancelado" | "en_curso" | "cierre_forzoso")[];
  readonly pagination_mode?: "cursor";
  readonly placed_from?: string;
  readonly placed_to?: string;
  readonly recorded_offline?: boolean;
  readonly search?: string;
}>
export type ServiceStaffHistoryReclassification = Readonly<{
  readonly actor_display_name: string | null;
  readonly from_cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other";
  readonly from_classification: "impago" | "cobro_externo" | "anulacion";
  readonly id: string;
  readonly occurred_at: string;
  readonly reason: string;
  readonly to_cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other";
  readonly to_classification: "impago" | "cobro_externo" | "anulacion";
}>
export type ServiceStaffHistoryReview = Readonly<{
  readonly category_ratings: Readonly<{
    readonly ambience: number;
    readonly food: number;
    readonly service: number;
  }>;
  readonly comment: string | null;
  readonly feedback_tags: readonly (string)[];
  readonly id: string;
  readonly issued_coupon_issuance_ids: readonly (string)[];
  readonly overall_rating: number;
  readonly review_bucket: "low" | "medium" | "high";
  readonly state: "submitted";
  readonly submitted_at: string;
  readonly version: number;
}>
export type ServiceStaffHistorySummary = Readonly<{
  readonly days: readonly (Readonly<{
      readonly captured_minor: number;
      readonly day: string;
      readonly order_count: number;
      readonly unpaid_written_off_minor: number;
    }>)[];
  readonly order_count: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly totals: ServiceStaffHistorySummaryTotals | null;
}>
export type ServiceStaffHistorySummaryQuery = Readonly<{
  readonly billing?: "pending" | "incidents";
  readonly order_id?: string;
  readonly outcome?: readonly ("cobrado" | "cobrado_con_reembolso_parcial" | "reembolsado" | "impagado" | "cobro_externo" | "anulado_por_error" | "cancelado" | "en_curso" | "cierre_forzoso")[];
  readonly placed_from?: string;
  readonly placed_to?: string;
  readonly recorded_offline?: boolean;
  readonly search?: string;
}>
export type ServiceStaffHistorySummaryTotals = Readonly<{
  readonly captured_minor: number;
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly external_closed_minor: number;
  readonly refunded_minor: number;
  readonly retained_minor: number;
  readonly unpaid_written_off_minor: number;
}>
export type ServiceStaffOrderDiscounts = Readonly<{
  readonly adjustments: readonly (ServiceStaffPaymentAdjustment)[];
  readonly currency: "EUR";
  readonly discount_minor: number;
  readonly discount_status?: "provisional" | "final";
  readonly pending_reason: null;
  readonly state: "current";
  readonly subtotal_minor: number;
  readonly total_minor: number;
}> | Readonly<{
  readonly adjustments: readonly (ServiceStaffPaymentAdjustment)[];
  readonly currency: null;
  readonly discount_minor: null;
  readonly pending_reason: "quote_missing" | "quote_stale" | "quote_unavailable";
  readonly state: "pending";
  readonly subtotal_minor: null;
  readonly total_minor: null;
}>
export type ServiceStaffPaymentAdjustment = Readonly<{
  readonly amount_minor: number;
  readonly benefit_kind: "percentage" | "fixed_amount" | "free_item" | "buy_x_get_y";
  readonly coupon_code: string | null;
  readonly covered_line_ids: readonly (string)[];
  readonly currency: "EUR";
  readonly definition_id: string;
  readonly display_name: string;
  readonly distribution_kind: "automatic" | "code_campaign" | "account_reward";
  readonly percentage_bps?: number | null;
  readonly source_id: string;
  readonly source_kind: "offer_definition";
  readonly use_returned?: boolean;
}>
export type ServiceTableCheck = Readonly<{
  readonly active_split_id: string | null;
  readonly charging_started_at: string | null;
  readonly closed_at: string | null;
  readonly created_at: string;
  readonly currency: "EUR" | null;
  readonly due_minor: number;
  readonly id: string;
  readonly net_minor: number;
  readonly opened_at: string;
  readonly restaurant_id: string;
  readonly settled_minor: number;
  readonly split_version: number;
  readonly state: "open" | "closed";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceTableClosure = Readonly<{
  readonly actor_id: string;
  readonly approved_by_principal_id: string | null;
  readonly cancelled_item_count: number;
  readonly cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other" | null;
  readonly check_id: string;
  readonly classification: "impago" | "cobro_externo" | "anulacion" | null;
  readonly closed_at: string;
  readonly created_at: string;
  readonly currency: "EUR" | null;
  readonly external_minor: number;
  readonly id: string;
  readonly kind: "ordinary" | "forced";
  readonly net_due_minor: number;
  readonly net_minor: number;
  readonly note: string | null;
  readonly paid_minor: number;
  readonly restaurant_id: string;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
  readonly written_off_minor: number;
}>
export type ServiceTableOccupancy = Readonly<{
  readonly configuration_version: number;
  readonly live_table_sessions: readonly (ServiceLiveTableSessionImpact)[];
  readonly restaurant_id: string;
  readonly target_id: string;
  readonly target_kind: "floor" | "table";
  readonly tenant_id: string;
}>
export type ServiceTableOccupancyQuery = Readonly<{
  readonly configuration_version: number;
  readonly target_id: string;
  readonly target_kind: "floor" | "table";
}>
export type ServiceTablePresence = Readonly<{
  readonly burst: Readonly<{
    readonly joined_count: number;
    readonly window_minutes: number;
  }> | null;
  readonly confirmed_at: string | null;
  readonly held_order_ids: readonly (string)[];
  readonly opened_by_guest_at: string;
  readonly table_id: string;
  readonly table_session_id: string;
  readonly unconfirmed: boolean;
}>
export type ServiceTableQrPause = Readonly<{
  readonly cause: "nobody_here";
  readonly paused_at: string;
  readonly paused_until: string;
  readonly table_id: string;
  readonly table_session_id: string;
}>
export type ServiceTableSession = Readonly<{
  readonly checkout_requested_at: string | null;
  readonly closed_at: string | null;
  readonly configuration_version: number;
  readonly created_at: string;
  readonly floor_id: string;
  readonly id: string;
  readonly location_id: string;
  readonly opened_at: string;
  readonly opener_guest_profile_id: string | null;
  readonly party_size: number | null;
  readonly party_size_stated_by_staff?: boolean;
  readonly recorded_offline?: boolean;
  readonly restaurant_id: string;
  readonly state: "open" | "closed";
  readonly table_id: string;
  readonly table_label?: string | null;
  readonly table_seats?: number | null;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceTableSessionCloseRequest = Readonly<{
  readonly operation: "table-session.close";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceTableSessionCloseResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "table-session.close";
  readonly table_session: ServiceTableSession;
}>
export type ServiceTableSessionCourse = Readonly<{
  readonly course_ordinal: number;
  readonly created_at: string;
  readonly delivered_count?: number;
  readonly late_add?: boolean;
  readonly line_count?: number;
  readonly locked_at: string | null;
  readonly ready_count?: number;
  readonly released_at: string | null;
  readonly released_by: string | null;
  readonly restaurant_id: string;
  readonly section_id: string;
  readonly state?: "held" | "released" | "completed";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceTableSessionForceCloseRequest = Readonly<{
  readonly operation: "table-session.force-close";
  readonly payload: Readonly<{
    readonly closure_cause: "walkout" | "opened_by_mistake" | "paid_outside_system" | "emergency" | "other";
    readonly closure_note?: string;
    readonly expected_due_minor?: number;
  }>;
  readonly resource_id: string;
}>
export type ServiceTableSessionForceCloseResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "table-session.force-close";
  readonly session_force_closure: ServiceSessionForceClosure;
  readonly table_session: ServiceTableSession;
}>
export type ServiceTableSessionNobodyHereFloorAnswer = Readonly<{
  readonly board: ServiceFloorSnapshot | null;
  readonly result: ServiceTableSessionNobodyHereResult;
  readonly revision: string | null;
}>
export type ServiceTableSessionNobodyHereRequest = Readonly<{
  readonly operation: "table-session.nobody-here";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceTableSessionNobodyHereResult = Readonly<{
  readonly nobody_here: ServiceNobodyHere;
  readonly operation: "table-session.nobody-here";
  readonly table_session: ServiceTableSession;
}>
export type ServiceTableSessionOpenRequest = Readonly<{
  readonly operation: "table-session.open";
  readonly payload: Readonly<{
    readonly configuration_version?: number;
    readonly party_size?: number;
    readonly table_id: string;
  }>;
  readonly resource_id: string;
}>
export type ServiceTableSessionOpenResult = Readonly<{
  readonly operation: "table-session.open";
  readonly table_session: ServiceTableSession;
}>
export type ServiceTableSessionParticipant = Readonly<{
  readonly client_identity_id: string | null;
  readonly created_at: string;
  readonly guest_profile_id: string | null;
  readonly id: string;
  readonly join_kind: "open" | "join" | "resume" | "staff";
  readonly joined_at: string;
  readonly left_at: string | null;
  readonly participant_kind: "identified" | "temporary";
  readonly restaurant_id: string;
  readonly seat_label: string | null;
  readonly state: "active" | "left";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceTableSessionPartySizeSetRequest = Readonly<{
  readonly operation: "table-session.party-size.set";
  readonly payload: Readonly<{
    readonly party_size: number | null;
  }>;
  readonly resource_id: string;
}>
export type ServiceTableSessionPartySizeSetResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly operation: "table-session.party-size.set";
  readonly table_session: ServiceTableSession;
}>
export type ServiceWaitingRoomEnterRequest = Readonly<{
  readonly operation: "waiting-room.enter";
  readonly payload: Readonly<{
    readonly cart_id: string;
    readonly cart_version: number;
  }>;
  readonly resource_id: string;
}>
export type ServiceWaitingRoomEnterResult = Readonly<{
  readonly diner_offer_notices?: readonly (ServiceDinerOfferNotice)[];
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly held_participant_count?: number;
  readonly operation: "waiting-room.enter";
  readonly order?: ServiceOrder;
  readonly order_cart_sources?: readonly (ServiceOrderCartSource)[];
  readonly waiting_room_entry: ServiceWaitingRoomEntry;
}>
export type ServiceWaitingRoomEntry = Readonly<{
  readonly cart_id: string;
  readonly cart_version: number;
  readonly client_identity_id: string;
  readonly entered_at: string;
  readonly id: string;
  readonly left_at: string | null;
  readonly restaurant_id: string;
  readonly state: "waiting" | "left" | "submitted";
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type ServiceWaitingRoomLeaveRequest = Readonly<{
  readonly operation: "waiting-room.leave";
  readonly payload: Readonly<Record<never, never>>;
  readonly resource_id: string;
}>
export type ServiceWaitingRoomLeaveResult = Readonly<{
  readonly event_facts?: Readonly<{
    readonly accepted_from_state?: string;
    readonly allocation_count?: number;
    readonly amount_minor?: number;
    readonly basis?: "participant" | "lines" | "split_part";
    readonly bill_id?: string;
    readonly cancelled_item_count?: number;
    readonly capture_ordinal?: number;
    readonly cash_late?: boolean;
    readonly cashback_applied_minor?: number;
    readonly catalog_publication_version?: number;
    readonly charge_ordinal?: number;
    readonly check_fully_refunded?: boolean;
    readonly check_id?: string;
    readonly close_event_facts?: Readonly<{
      readonly course_advances: readonly (ServiceCourseAdvanceFact)[];
      readonly duration_seconds: number;
      readonly order_count: number;
    }> | null;
    readonly course_advances?: readonly (ServiceCourseAdvanceFact)[];
    readonly currency?: "EUR";
    readonly declared_difference_minor?: number;
    readonly delivered_at?: string | null;
    readonly due_minor?: number;
    readonly duration_seconds?: number;
    readonly finalized_order_ids?: readonly (string)[];
    readonly first_request?: boolean;
    readonly from_cause?: string;
    readonly from_classification?: string;
    readonly from_state?: string;
    readonly item_count?: number;
    readonly items?: readonly (Readonly<{
        readonly category_id: string;
        readonly dish_id: string;
        readonly line_total_minor: number;
        readonly modifier_option_ids: readonly (string)[];
        readonly order_item_id: string;
        readonly quantity: number;
        readonly unit_price_minor: number;
      }>)[];
    readonly lines?: readonly (ServiceRefundLineFact)[];
    readonly method?: "cash" | "card" | "external" | "external_terminal" | "mixed";
    readonly mode?: "equal" | "free";
    readonly order_count?: number;
    readonly order_fully_refunded?: boolean;
    readonly order_item_id?: string;
    readonly order_state_before?: string;
    readonly outcome_dishes?: readonly (Readonly<{
        readonly dish_id: string | null;
        readonly order_item_id: string;
      }>)[];
    readonly part_count?: number;
    readonly participant_count?: number;
    readonly participant_id?: string;
    readonly payer_guest_profile_id?: string | null;
    readonly payer_kind?: "identified" | "temporary" | null;
    readonly payer_participant_id?: string | null;
    readonly payment_id?: string;
    readonly payment_method?: "cash" | "card_terminal";
    readonly preparing_at?: string | null;
    readonly queued_at?: string;
    readonly ready_at?: string | null;
    readonly ready_count?: number;
    readonly reason_code?: string;
    readonly reclassification_id?: string;
    readonly refund_group_id?: string;
    readonly released_course_count?: number;
    readonly released_offer?: boolean;
    readonly released_reservation?: boolean;
    readonly remaining_due_minor?: number;
    readonly reopened?: boolean;
    readonly reversal_id?: string;
    readonly segment_id?: string;
    readonly settled_departures?: readonly (Readonly<{
        readonly bill_request_id: string | null;
        readonly participant_id: string;
        readonly participant_left: boolean;
        readonly table_session_id: string;
      }>)[];
    readonly source_cart_id?: string;
    readonly source_cart_item_id?: string;
    readonly source_cart_version?: number;
    readonly split_id?: string | null;
    readonly split_version?: number;
    readonly table_close?: Readonly<{
      readonly closed: boolean;
      readonly reason_code: string | null;
      readonly waiting_order_ids?: readonly (string)[];
    }> | null;
    readonly table_session_id?: string;
    readonly target_cart_version?: number;
    readonly waiver_id?: string;
    readonly written_off_line_count?: number;
  }>;
  readonly operation: "waiting-room.leave";
  readonly waiting_room_entry: ServiceWaitingRoomEntry;
}>
export type ServiceWaitingRoundSnapshot = Readonly<{
  readonly participants: readonly (Readonly<{
      readonly guest_profile_id: string | null;
      readonly id: string;
      readonly join_kind: "open" | "join" | "resume" | "staff";
      readonly participant_kind: "identified" | "temporary";
      readonly presentation?: ServiceGuestParticipantPresentation | null;
      readonly seat_label: string | null;
      readonly state: "active";
      readonly version: number;
    }>)[];
  readonly party_size: number;
  readonly quorum: Readonly<{
    readonly active_carts: number;
    readonly reached: boolean;
    readonly ready_carts: number;
  }>;
  readonly readiness: readonly (Readonly<{
      readonly cart_id: string;
      readonly cart_version: number;
      readonly guest_profile_id: string | null;
      readonly ready: boolean;
    }>)[];
  readonly table_session_id: string;
}>
export type ServiceWithheldTable = Readonly<{
  readonly label: string | null;
  readonly table_id: string | null;
  readonly table_session_id: string;
}>
export type SetInventoryStockItemSupplyRequest = Readonly<{
  readonly expected_supply_version: number;
  readonly supply: Readonly<{
    readonly delivery_weekdays: readonly (number)[];
    readonly lead_time_days: number | null;
    readonly supplier_id: string | null;
  }>;
}>
export type SetInventoryStockItemSupplyResult = Readonly<{
  readonly operation: "stock-item.supply.set";
  readonly stock_item_id: string;
  readonly stock_item_version: number;
  readonly supply: Readonly<{
    readonly delivery_weekdays: readonly (number)[];
    readonly lead_time_days: number | null;
    readonly stock_item_id: string;
    readonly supplier_id: string | null;
    readonly supply_version: number;
    readonly updated_at: string;
  }>;
}>
export type SetInventoryStockPolicyRequest = Readonly<{
  readonly stock_policy: "none" | "hide_customer" | "hide_and_block";
}>
export type StartRelationshipGoogleConnectionRequest = Readonly<Record<never, never>>
export type StartRelationshipGoogleConnectionResponse = Readonly<{
  readonly authorization_url: string;
  readonly expires_at: string;
  readonly state: string;
}>
export type SubmitRelationshipReviewRequest = Readonly<{
  readonly category_ratings: Readonly<{
    readonly ambience: number;
    readonly food: number;
    readonly service: number;
  }>;
  readonly comment: string | null;
  readonly feedback_tags: readonly (string)[];
  readonly order_id: string;
  readonly overall_rating: number;
  readonly submitted_at?: string;
}>
export type TenantDirectoryFranchise = Readonly<{
  readonly address: string;
  readonly authority_version: number;
  readonly created_at: string;
  readonly email: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly logo_url?: string | null;
  readonly name: string;
  readonly phone: string | null;
  readonly updated_at: string;
}>
export type TenantDirectoryFranchiseDetails = Readonly<{
  readonly address: string;
  readonly authority_version: number;
  readonly created_at: string;
  readonly director: TenantDirectoryFranchiseDirectorPresentation | null;
  readonly email: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly logo_url?: string | null;
  readonly name: string;
  readonly phone: string | null;
  readonly restaurants: readonly (TenantDirectoryRestaurantSummary)[];
  readonly updated_at: string;
}>
export type TenantDirectoryFranchiseDirectorPresentation = Readonly<{
  readonly email: string;
  readonly id: string;
  readonly name: string;
  readonly phone: string;
  readonly status: "active" | "suspended";
}>
export type TenantDirectoryFranchiseListItem = Readonly<{
  readonly active_restaurant_count: number;
  readonly address: string;
  readonly authority_version: number;
  readonly created_at: string;
  readonly email: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly logo_url?: string | null;
  readonly name: string;
  readonly phone: string | null;
  readonly restaurant_count: number;
  readonly updated_at: string;
}>
export type TenantDirectoryGuestRestaurantPresentation = Readonly<{
  readonly address: string;
  readonly id: string;
  readonly logo: string | null;
  readonly name: string;
  readonly phone: string | null;
}>
export type TenantDirectoryInvitationPresentation = Readonly<{
  readonly claimed_at: string | null;
  readonly delivered_at: string | null;
  readonly delivery_attempt_count: number;
  readonly delivery_error_code: string | null;
  readonly delivery_failed_at: string | null;
  readonly delivery_outcome_resolved_at: string | null;
  readonly delivery_provider_message_id: string | null;
  readonly employee_id: string;
  readonly expires_at: string | null;
  readonly id: string;
  readonly invitation_kind: "account_claim" | "account_recovery" | "existing_user_membership";
  readonly restaurant_id: string;
  readonly revoked_at: string | null;
  readonly state: "pending" | "delivered" | "delivery_failed" | "delivery_outcome_unknown" | "delivery_suppressed" | "claimed" | "expired" | "revoked";
  readonly updated_at: string;
  readonly version: number;
}>
export type TenantDirectoryLocation = Readonly<{
  readonly authority_version: number;
  readonly code: string;
  readonly franchise_id: string;
  readonly id: string;
  readonly is_active: boolean;
  readonly name: string;
  readonly restaurant_id: string;
}>
export type TenantDirectoryRestaurant = Readonly<{
  readonly address: string;
  readonly authority_version: number;
  readonly created_at: string;
  readonly email: string | null;
  readonly franchise_id: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly is_effectively_disabled: boolean;
  readonly logo?: string | null;
  readonly name: string;
  readonly owner_id: string;
  readonly phone: string | null;
  readonly updated_at: string;
}>
export type TenantDirectoryRestaurantDetails = Readonly<{
  readonly address: string;
  readonly authority_version: number;
  readonly created_at: string;
  readonly email: string | null;
  readonly franchise_id: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly is_effectively_disabled: boolean;
  readonly logo?: string | null;
  readonly manager: TenantDirectoryRestaurantManagerPresentation | null;
  readonly name: string;
  readonly owner_id: string;
  readonly phone: string | null;
  readonly updated_at: string;
}>
export type TenantDirectoryRestaurantListItem = Readonly<{
  readonly address: string;
  readonly authority_version: number;
  readonly created_at: string;
  readonly email: string | null;
  readonly franchise_id: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly is_effectively_disabled: boolean;
  readonly logo?: string | null;
  readonly name: string;
  readonly owner_id: string;
  readonly phone: string | null;
  readonly updated_at: string;
}>
export type TenantDirectoryRestaurantManagerPresentation = Readonly<{
  readonly authority_version: number;
  readonly email: string;
  readonly employee_id: string;
  readonly invitation: TenantDirectoryInvitationPresentation | null;
  readonly name: string;
  readonly phone: string;
  readonly status: "active" | "suspended";
  readonly user_id: string;
}>
export type TenantDirectoryRestaurantSummary = Readonly<{
  readonly address: string;
  readonly email: string | null;
  readonly franchise_id: string | null;
  readonly id: string;
  readonly is_active: boolean;
  readonly is_effectively_disabled: boolean;
  readonly name: string;
  readonly phone: string | null;
}>
export type TenantResource = Readonly<{
  readonly contract: "exylon.tenant-directory.resource@1.0";
  readonly resource_id: string;
  readonly resource_type: "franchise" | "restaurant" | "location";
  readonly version: number;
}>
export type UndoRelationshipExternalReviewReplyRequest = Readonly<{
  readonly applied_receipt_id: string;
  readonly expected_version: number;
  readonly previous_reply: string | null;
}>
export type UpdateGuestProfileRequest = Readonly<{
  readonly avatar_object_key: string | null;
  readonly display_name: string;
  readonly expected_version: number;
  readonly locale: string;
}>
export type UpdateInventorySupplierRequest = Readonly<{
  readonly active: boolean;
  readonly name: string;
  readonly notes: string | null;
  readonly order_cut_off?: string | null;
  readonly phone: string | null;
}>
export type UploadCatalogPhotoRequest = Readonly<{
  readonly metadata: Readonly<{
    readonly alt_text: string;
    readonly content_type: "image/jpeg" | "image/png" | "image/webp";
    readonly editor_intent_id: string;
    readonly file_name: string;
    readonly photo_crop?: Readonly<{
      readonly height: number;
      readonly left: number;
      readonly top: number;
      readonly width: number;
    }>;
  }>;
}>
export type ValidateAccessPolicyDraftRequest = Readonly<{
  readonly expected_active_policy_version: number;
}>
export type ValidateAccessPolicyRestoreRequest = Readonly<{
  readonly expected_active_policy_version: number;
  readonly target_policy_version: number;
}>
export type VoidOfferRedemptionRequest = Readonly<{
  readonly expected_version: 1;
  readonly reason_code: string;
  readonly redemption_id: string;
  readonly service_order_id: string;
}>
export type WorkforceBridgeBulkQuery = Readonly<{
  readonly employment_ids?: string;
  readonly form: "workforce.work-target-assignment.bulk-apply";
  readonly table_ids?: string;
}>
export type WorkforceBridgeFeedbackQuery = Readonly<{
  readonly employment_id?: string;
  readonly feedback_id?: string;
  readonly form: "workforce.feedback.create";
  readonly review_tag?: string;
  readonly severity?: string;
}>
export type WorkforceBridgeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.workforce.bridge-revalidation@1.0";
  readonly form: "workforce.feedback.create" | "workforce.work-target-assignment.bulk-apply";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{ readonly [key: string]: string | number | boolean | readonly (string)[] | readonly (number)[] }>;
  readonly verdict: "open" | "refused";
}>
export type WorkforceBridgeStaffNoticeQuery = Readonly<{
  readonly audience?: string;
  readonly form: "workforce.staff-notice.compose";
  readonly notice_id?: string;
  readonly severity?: string;
  readonly topic?: string;
}>
export type WorkforceBridgeStaffNoticeRevalidation = Readonly<{
  readonly base: readonly (Readonly<{
      readonly id: string;
      readonly kind: string;
      readonly state: string | null;
      readonly version: number | null;
    }>)[];
  readonly contract: "exylon.workforce.bridge-revalidation@1.0";
  readonly form: "workforce.staff-notice.compose";
  readonly reason: "base_changed" | "not_found" | "already_applied" | "invalid_parameters" | null;
  readonly seed: Readonly<{
    readonly audience?: "floor_team";
    readonly body?: string;
    readonly notice_id?: string;
    readonly severity?: "info";
    readonly title?: string;
    readonly topic?: "offer_qr_at_seating" | "offer_dessert_at_clearing" | "ask_review_at_payment";
  }>;
  readonly verdict: "open" | "refused";
}>
export type WorkforceCn92AdvisoryPresence = Readonly<{
  readonly contract: "exylon.workforce.cn92-advisory-presence@1.0";
  readonly coverage: "complete" | "missing";
  readonly duration_minutes: number | null;
  readonly evaluated_at: string;
  readonly first_full_room_at: string | null;
  readonly first_table_at: string | null;
  readonly first_waiter_app_at: string | null;
  readonly first_waiter_app_coverage: "not_applicable" | "not_observed" | "complete";
  readonly from: string;
  readonly interval_end: string | null;
  readonly interval_start: string | null;
  readonly local_date: string;
  readonly observation_basis: "recorded_app_sessions_only";
  readonly reason: "exact_interval_observed" | "complete_no_matching_interval" | "before_operational_source_cut" | "operational_session_history_incomplete" | "owner_source_capacity_exceeded" | "owner_source_invalid" | "owner_source_incomplete_or_too_large" | "published_capacity_history_incomplete";
  readonly restaurant_id: string;
  readonly status: "candidate" | "none" | "no_data";
  readonly tenant_id: string;
  readonly timezone: "Europe/Madrid";
  readonly until: string;
}>
export type WorkforceEligibility = Readonly<{
  readonly employment_id: string;
  readonly id: string;
  readonly restaurant_id: string;
  readonly state: "eligible" | "suspended" | "expired";
  readonly tenant_id: string;
  readonly valid_from: string;
  readonly valid_until: string | null;
  readonly version: number;
  readonly work_type: string;
}>
export type WorkforceEligibilityCommandResult = Readonly<{
  readonly eligibility: WorkforceEligibility;
  readonly operation: "eligibility.set";
}>
export type WorkforceEligibilitySetRequest = Readonly<{
  readonly eligibility_id: string;
  readonly employment_id: string;
  readonly expected_version: number;
  readonly state: "eligible" | "suspended" | "expired";
  readonly valid_from: string;
  readonly valid_until: string | null;
  readonly work_type: string;
}>
export type WorkforceEmployeeAccessRecoveryRequest = Readonly<Record<never, never>>
export type WorkforceEmployeeAccessRecoveryResult = Readonly<{
  readonly principal_id: string;
  readonly replayed: false;
  readonly temporary_password: string;
}> | Readonly<{
  readonly principal_id: string;
  readonly replayed: true;
}>
export type WorkforceEmployeeDetail = Readonly<{
  readonly eligibilities: readonly (WorkforceEligibility)[];
  readonly employment: WorkforceEmployment;
  readonly identity: WorkforceEmployeeIdentityDetail;
  readonly latest_presence: WorkforcePresence | null;
  readonly needs_placement: boolean;
}>
export type WorkforceEmployeeIdentityDetail = Readonly<{
  readonly email: string;
  readonly image_url: string | null;
  readonly invitation: WorkforceInvitationStatus | null;
  readonly is_manager: boolean;
  readonly name: string;
  readonly phone: string;
  readonly role_names: readonly (string)[];
  readonly within_reach: boolean;
}>
export type WorkforceEmployeeIdentitySummary = Readonly<{
  readonly image_url: string | null;
  readonly invitation: WorkforceInvitationStatus | null;
  readonly is_manager: boolean;
  readonly name: string;
  readonly role_names: readonly (string)[];
  readonly within_reach: boolean;
}>
export type WorkforceEmployeeKpiActivity = Readonly<{
  readonly days: readonly (Readonly<{
      readonly delivered_items: number;
      readonly local_date: string;
      readonly prepared_items: number;
      readonly tables_served: number;
      readonly worked_ms: number;
    }>)[];
  readonly window_minutes: 30;
  readonly windows: readonly (Readonly<{
      readonly delivered_items: number;
      readonly end: string;
      readonly prepared_items: number;
      readonly start: string;
      readonly tables_served: number;
      readonly worked_ms: number;
    }>)[] | null;
}>
export type WorkforceEmployeeKpiCoverage = Readonly<{
  readonly covered_utc_end: string | null;
  readonly covered_utc_start: string | null;
  readonly requested_utc_end: string;
  readonly requested_utc_start: string;
  readonly state: "complete" | "partial" | "missing";
}>
export type WorkforceEmployeeKpiExpansion = Readonly<{
  readonly activity: WorkforceEmployeeKpiActivity;
  readonly actual_time: readonly (WorkforceKpiActualTimeMetric)[];
  readonly computed_at: string;
  readonly employee_metrics: WorkforceKpiEmployeeMetrics;
  readonly employment_id: string;
  readonly families: readonly (WorkforceEmployeeKpiFamily)[];
  readonly formula_registry_version: "workforce-kpi-v5";
  readonly manager_context: WorkforceManagerKpiContext;
  readonly policy: WorkforceKpiPolicy;
  readonly range: WorkforceEmployeeKpiRange;
  readonly restaurant_id: string;
  readonly selected_metrics: readonly (WorkforceKpiMeasuredMetric)[] | null;
  readonly tenant_id: string;
}>
export type WorkforceEmployeeKpiExpansionQuery = Readonly<{
  readonly load_windows?: "included";
  readonly metric_keys?: readonly ("K1" | "K2" | "K3" | "K4" | "K5" | "W1" | "W2" | "W3" | "W4" | "W5" | "weighted_delivery_milliseconds")[];
  readonly preset?: "today" | "yesterday" | "7_days" | "30_days" | "60_days";
  readonly range_kind?: "preset";
}> | Readonly<{
  readonly end_local_date_exclusive: string;
  readonly load_windows?: "included";
  readonly metric_keys?: readonly ("K1" | "K2" | "K3" | "K4" | "K5" | "W1" | "W2" | "W3" | "W4" | "W5" | "weighted_delivery_milliseconds")[];
  readonly range_kind: "custom";
  readonly start_local_date: string;
}>
export type WorkforceEmployeeKpiFamily = Readonly<{
  readonly activity_recency: Readonly<{
    readonly latest_action_at: string | null;
    readonly state: "activity_observed" | "no_activity";
  }>;
  readonly current_coverage: WorkforceEmployeeKpiCoverage;
  readonly previous_coverage: WorkforceEmployeeKpiCoverage;
  readonly projection_freshness: Readonly<{
    readonly covered_through: string | null;
    readonly projected_at: string | null;
    readonly state: "current" | "partial" | "unavailable";
  }>;
  readonly reason: string | null;
  readonly role_family: "kitchen" | "waiter";
  readonly sample_size: number | null;
  readonly status: "available" | "partial" | "no_activity" | "unavailable";
  readonly unassigned_sample_size: number | null;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}>
export type WorkforceEmployeeKpiQuery = Readonly<{
  readonly preset?: "today" | "yesterday" | "7_days" | "30_days" | "60_days";
  readonly range_kind?: "preset";
}> | Readonly<{
  readonly end_local_date_exclusive: string;
  readonly range_kind: "custom";
  readonly start_local_date: string;
}>
export type WorkforceEmployeeKpiRange = Readonly<{
  readonly business_timezone: "Europe/Madrid";
  readonly current_utc_end: string;
  readonly current_utc_start: string;
  readonly end_local_date_exclusive: string;
  readonly interval_days: number;
  readonly kind: "preset" | "custom";
  readonly preset: "today" | "yesterday" | "7_days" | "30_days" | "60_days" | null;
  readonly previous_end_local_date_exclusive: string;
  readonly previous_start_local_date: string;
  readonly previous_utc_end: string;
  readonly previous_utc_start: string;
  readonly start_local_date: string;
}>
export type WorkforceEmployeeListItem = Readonly<{
  readonly employment: WorkforceEmploymentSummary;
  readonly identity: WorkforceEmployeeIdentitySummary;
  readonly latest_presence: WorkforcePresence | null;
  readonly needs_placement: boolean;
  readonly open_alert_count: number;
}>
export type WorkforceEmployeeListQuery = Readonly<{
  readonly page?: number;
  readonly page_size?: number;
  readonly search?: string;
  readonly status?: "active" | "suspended" | "ended";
}>
export type WorkforceEmployeePage = Readonly<{
  readonly alert_counts_as_of: string;
  readonly items: readonly (WorkforceEmployeeListItem)[];
  readonly page: number;
  readonly page_size: number;
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly total: number;
}>
export type WorkforceEmployeePerformanceActorEvidence = Readonly<{
  readonly eligibility: WorkforceEmployeePerformanceEligibilityEvidence;
  readonly employment: WorkforceEmployeePerformanceEmploymentEvidence;
  readonly kind: "employee";
  readonly operational: WorkforceEmployeePerformanceOperationalEvidence;
  readonly principal_id: string;
  readonly routing: WorkforceEmployeePerformanceRoutingEvidence;
}> | Readonly<{
  readonly audit_event_id: string;
  readonly employment: WorkforceEmployeePerformanceEmploymentEvidence | null;
  readonly kind: "manager_override";
  readonly operational_manager_authority: WorkforceOperationalManagerAuthorityEvidence;
  readonly override_command_id: string;
  readonly override_command_version: number;
  readonly principal_id: string;
  readonly reason_code: string;
}>
export type WorkforceEmployeePerformanceConfigurationEvidence = Readonly<{
  readonly input_fingerprint: string;
  readonly publication_version: number;
}>
export type WorkforceEmployeePerformanceEligibilityEvidence = Readonly<{
  readonly eligibility_id: string;
  readonly eligibility_version: number;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}>
export type WorkforceEmployeePerformanceEmploymentEvidence = Readonly<{
  readonly employment_id: string;
  readonly employment_version: number;
}>
export type WorkforceEmployeePerformanceOperationalEvidence = Readonly<{
  readonly contribution_id: string;
  readonly contribution_version: number;
  readonly lineage_fingerprint: string;
  readonly shift_id: string;
  readonly shift_version: number;
}>
export type WorkforceEmployeePerformanceRoutingEvidence = Readonly<{
  readonly assignment_id: string;
  readonly assignment_policy_fingerprint: string;
  readonly assignment_version: number;
  readonly configuration: WorkforceEmployeePerformanceConfigurationEvidence;
  readonly kind: "durable_assignment";
  readonly location_id: string;
  readonly target_fingerprint: string;
  readonly target_id: string;
  readonly target_kind: "table" | "department";
}> | Readonly<{
  readonly anchor_assignment_id: string;
  readonly anchor_assignment_version: number;
  readonly configuration: WorkforceEmployeePerformanceConfigurationEvidence;
  readonly coverage_id: string;
  readonly coverage_version: number;
  readonly covered_table_id: string;
  readonly kind: "waiter_fallback_coverage";
  readonly location_id: string;
  readonly routing_generation: number;
}> | Readonly<{
  readonly assignment_id: null;
  readonly configuration: WorkforceEmployeePerformanceConfigurationEvidence;
  readonly fulfillment_station: "kitchen" | "service";
  readonly kind: "unassigned_station";
  readonly location_id: string;
}>
export type WorkforceEmployeePerformanceSourceCoverage = Readonly<{
  readonly contract: "exylon.workforce.employee-performance-source-coverage@2.0";
  readonly coverage_end: string;
  readonly coverage_id: string;
  readonly coverage_start: string;
  readonly projected_at: string;
  readonly restaurant_id: string;
  readonly role_family: "kitchen" | "waiter";
  readonly source_schema_version: 3;
  readonly tenant_id: string;
}>
export type WorkforceEmployeePerformanceSourceFact = Readonly<{
  readonly actor: WorkforceEmployeePerformanceActorEvidence;
  readonly contract: "exylon.workforce.employee-performance-source-fact@3.0";
  readonly duration_item_count: number;
  readonly duration_total_ms: number;
  readonly item_count: number;
  readonly location_id: string;
  readonly occurred_at: string;
  readonly operation: "kitchen.start" | "kitchen.ready" | "kitchen.remake" | "waiter.delivered" | "waiter.mark_all" | "manager.kitchen.start" | "manager.kitchen.ready" | "manager.kitchen.remake" | "manager.waiter.delivered" | "manager.waiter.mark_all";
  readonly remade_count: number;
  readonly restaurant_id: string;
  readonly resulting_state: "started" | "ready" | "remade" | "delivered";
  readonly role_family: "kitchen" | "waiter";
  readonly source_entity_id: string;
  readonly source_entity_prior_version: number;
  readonly source_entity_result_version: number;
  readonly source_entity_type: "service.order_item" | "service.ready_item";
  readonly source_event_id: string;
  readonly source_schema_version: 3;
  readonly successful_count: number;
  readonly supersedes_source_event_id: string | null;
  readonly tenant_id: string;
  readonly transition_identity_fingerprint: string;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}> | Readonly<{
  readonly actor: WorkforceEmployeePerformanceActorEvidence;
  readonly catalog_category_id: string;
  readonly catalog_dish_id: string;
  readonly contract: "exylon.workforce.employee-performance-source-fact@4.0";
  readonly course_ordinal: number;
  readonly course_released_at: string | null;
  readonly coverage_episode_id: string | null;
  readonly coverage_role: "provided" | null;
  readonly duration_item_count: number;
  readonly duration_total_ms: number;
  readonly item_count: 1;
  readonly location_id: string;
  readonly occurred_at: string;
  readonly operation: "kitchen.start" | "kitchen.ready" | "kitchen.remake" | "waiter.delivered" | "waiter.mark_all" | "manager.kitchen.start" | "manager.kitchen.ready" | "manager.kitchen.remake" | "manager.waiter.delivered" | "manager.waiter.mark_all";
  readonly queue_to_start_ms: number | null;
  readonly ready_to_delivered_ms: number | null;
  readonly remade_count: number;
  readonly restaurant_id: string;
  readonly resulting_state: "started" | "ready" | "remade" | "delivered";
  readonly role_family: "kitchen" | "waiter";
  readonly source_entity_id: string;
  readonly source_entity_prior_version: number;
  readonly source_entity_result_version: number;
  readonly source_entity_type: "service.order_item" | "service.ready_item";
  readonly source_event_id: string;
  readonly source_schema_version: 4;
  readonly successful_count: number;
  readonly supersedes_source_event_id: string | null;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly transition_identity_fingerprint: string;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}>
export type WorkforceEmployeePerformanceSourceFactV3 = Readonly<{
  readonly actor: WorkforceEmployeePerformanceActorEvidence;
  readonly contract: "exylon.workforce.employee-performance-source-fact@3.0";
  readonly duration_item_count: number;
  readonly duration_total_ms: number;
  readonly item_count: number;
  readonly location_id: string;
  readonly occurred_at: string;
  readonly operation: "kitchen.start" | "kitchen.ready" | "kitchen.remake" | "waiter.delivered" | "waiter.mark_all" | "manager.kitchen.start" | "manager.kitchen.ready" | "manager.kitchen.remake" | "manager.waiter.delivered" | "manager.waiter.mark_all";
  readonly remade_count: number;
  readonly restaurant_id: string;
  readonly resulting_state: "started" | "ready" | "remade" | "delivered";
  readonly role_family: "kitchen" | "waiter";
  readonly source_entity_id: string;
  readonly source_entity_prior_version: number;
  readonly source_entity_result_version: number;
  readonly source_entity_type: "service.order_item" | "service.ready_item";
  readonly source_event_id: string;
  readonly source_schema_version: 3;
  readonly successful_count: number;
  readonly supersedes_source_event_id: string | null;
  readonly tenant_id: string;
  readonly transition_identity_fingerprint: string;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}>
export type WorkforceEmployeePerformanceSourceFactV4 = Readonly<{
  readonly actor: WorkforceEmployeePerformanceActorEvidence;
  readonly catalog_category_id: string;
  readonly catalog_dish_id: string;
  readonly contract: "exylon.workforce.employee-performance-source-fact@4.0";
  readonly course_ordinal: number;
  readonly course_released_at: string | null;
  readonly coverage_episode_id: string | null;
  readonly coverage_role: "provided" | null;
  readonly duration_item_count: number;
  readonly duration_total_ms: number;
  readonly item_count: 1;
  readonly location_id: string;
  readonly occurred_at: string;
  readonly operation: "kitchen.start" | "kitchen.ready" | "kitchen.remake" | "waiter.delivered" | "waiter.mark_all" | "manager.kitchen.start" | "manager.kitchen.ready" | "manager.kitchen.remake" | "manager.waiter.delivered" | "manager.waiter.mark_all";
  readonly queue_to_start_ms: number | null;
  readonly ready_to_delivered_ms: number | null;
  readonly remade_count: number;
  readonly restaurant_id: string;
  readonly resulting_state: "started" | "ready" | "remade" | "delivered";
  readonly role_family: "kitchen" | "waiter";
  readonly source_entity_id: string;
  readonly source_entity_prior_version: number;
  readonly source_entity_result_version: number;
  readonly source_entity_type: "service.order_item" | "service.ready_item";
  readonly source_event_id: string;
  readonly source_schema_version: 4;
  readonly successful_count: number;
  readonly supersedes_source_event_id: string | null;
  readonly table_session_id: string;
  readonly tenant_id: string;
  readonly transition_identity_fingerprint: string;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}>
export type WorkforceEmployeePictureSetRequest = Readonly<{
  readonly crew_key: "01_proud_frying_pan" | "02_sleepy_stock_pot" | "03_cheeky_rolling_pin" | "04_shy_soup_ladle" | "05_determined_spatula" | "06_goofy_oven_mitt" | "07_smug_service_bell" | "08_sleepy_espresso_cup" | "09_giggling_teapot" | "10_cool_cocktail_shaker" | "11_blushing_water_jug" | "12_mischievous_moka_pot" | "13_grumpy_pepper_mill" | "14_excited_salt_shaker" | "15_curious_cheese_grater" | "16_silly_colander" | "17_nervous_kitchen_timer" | "18_beaming_mortar";
  readonly source: "crew";
}> | Readonly<{
  readonly source: "photo";
}>
export type WorkforceEmployeePictureSetResult = Readonly<{
  readonly contract: "exylon.workforce.employee-picture@1.0";
  readonly crew_key: "01_proud_frying_pan" | "02_sleepy_stock_pot" | "03_cheeky_rolling_pin" | "04_shy_soup_ladle" | "05_determined_spatula" | "06_goofy_oven_mitt" | "07_smug_service_bell" | "08_sleepy_espresso_cup" | "09_giggling_teapot" | "10_cool_cocktail_shaker" | "11_blushing_water_jug" | "12_mischievous_moka_pot" | "13_grumpy_pepper_mill" | "14_excited_salt_shaker" | "15_curious_cheese_grater" | "16_silly_colander" | "17_nervous_kitchen_timer" | "18_beaming_mortar" | null;
  readonly employment_id: string;
  readonly image_url: string;
  readonly source: "crew" | "photo";
}>
export type WorkforceEmployment = Readonly<{
  readonly ends_on: string | null;
  readonly id: string;
  readonly identity_membership_version: number;
  readonly job_title: string;
  readonly membership_id: string;
  readonly principal_id: string;
  readonly restaurant_id: string;
  readonly starts_on: string;
  readonly status: "active" | "suspended" | "ended";
  readonly tenant_id: string;
  readonly version: number;
}>
export type WorkforceEmploymentCommandResult = Readonly<{
  readonly employment: WorkforceEmployment;
  readonly operation: "employment.register" | "employment.update" | "employment.suspend" | "employment.restore" | "employment.end";
}>
export type WorkforceEmploymentEndRequest = Readonly<{
  readonly employment_id: string;
  readonly ends_on?: string;
  readonly reason_code: string;
}>
export type WorkforceEmploymentRegisterCommandResult = Readonly<{
  readonly employment: WorkforceEmployment;
  readonly operation: "employment.register";
  readonly temporary_password?: string;
}>
export type WorkforceEmploymentRegisterRequest = Readonly<{
  readonly email: string;
  readonly employment_id: string;
  readonly job_title: string;
  readonly name: string;
  readonly phone: string;
  readonly starts_on: string;
}>
export type WorkforceEmploymentRestoreRequest = Readonly<{
  readonly employment_id: string;
  readonly reason_code: string;
}>
export type WorkforceEmploymentSummary = Readonly<{
  readonly ends_on: string | null;
  readonly id: string;
  readonly job_title: string;
  readonly restaurant_id: string;
  readonly starts_on: string;
  readonly status: "active" | "suspended" | "ended";
  readonly tenant_id: string;
  readonly version: number;
}>
export type WorkforceEmploymentSuspendRequest = Readonly<{
  readonly employment_id: string;
  readonly reason_code: string;
}>
export type WorkforceEmploymentUpdateRequest = Readonly<{
  readonly employment_id: string;
  readonly job_title?: string;
  readonly role_ids?: readonly (string)[];
}>
export type WorkforceError = Readonly<{
  readonly code: "AUTHORIZATION_DENIED" | "CAPACITY_EXCEEDED" | "CAPACITY_UNAVAILABLE" | "CONFLICT" | "INPUT_INVALID" | "MISSING" | "PRIVACY_DENIED" | "WRITE_FAILED";
  readonly message: string;
}>
export type WorkforceFeedbackAcknowledgeRequest = Readonly<{
  readonly feedback_id: string;
}>
export type WorkforceFeedbackAlert = Readonly<{
  readonly acknowledged_at: string | null;
  readonly acknowledged_by_principal_id: string | null;
  readonly audit: readonly (WorkforceFeedbackAuditFact)[];
  readonly author_name: string;
  readonly author_principal_id: string;
  readonly body: string;
  readonly created_at: string;
  readonly employment_id: string;
  readonly id: string;
  readonly restaurant_id: string;
  readonly severity: "info" | "warning" | "critical";
  readonly status: "open" | "acknowledged";
  readonly tenant_id: string;
  readonly title: string;
  readonly updated_at: string;
  readonly version: number;
}>
export type WorkforceFeedbackAlertList = Readonly<{
  readonly alerts: readonly (WorkforceFeedbackAlert)[];
  readonly employment_id: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type WorkforceFeedbackAuditFact = Readonly<{
  readonly action: "created" | "acknowledged";
  readonly actor_principal_id: string;
  readonly occurred_at: string;
  readonly version: number;
}>
export type WorkforceFeedbackCommandResult = Readonly<{
  readonly feedback: WorkforceFeedbackAlert;
  readonly operation: "feedback.create" | "feedback.acknowledge";
}>
export type WorkforceFeedbackCreateRequest = Readonly<{
  readonly body: string;
  readonly employment_id: string;
  readonly feedback_id: string;
  readonly severity: "info" | "warning" | "critical";
  readonly title: string;
}>
export type WorkforceInvitationStatus = Readonly<{
  readonly expires_at: string | null;
  readonly id: string;
  readonly state: "pending" | "delivered" | "delivery_failed" | "delivery_outcome_unknown" | "delivery_suppressed" | "claimed" | "expired" | "revoked";
  readonly updated_at: string;
  readonly version: number;
}>
export type WorkforceKpiActualTimeMetric = Readonly<{
  readonly change_basis_points: number | null;
  readonly current: WorkforceKpiMeasuredPeriod;
  readonly key: "dishes_per_hour";
  readonly previous: WorkforceKpiMeasuredPeriod;
  readonly role_family: "kitchen" | "waiter";
  readonly subject: "employee";
  readonly unit: "count";
}>
export type WorkforceKpiDeliveryPair = Readonly<{
  readonly correct_deliveries: Readonly<{
    readonly change_basis_points: number | null;
    readonly current: WorkforceKpiMeasuredPeriod;
    readonly key: "W2";
    readonly previous: WorkforceKpiMeasuredPeriod;
    readonly role_family: "waiter";
    readonly subject: "employee";
    readonly unit: "count" | "milliseconds" | "basis_points";
  }>;
  readonly delivery_speed: Readonly<{
    readonly change_basis_points: number | null;
    readonly current: WorkforceKpiMeasuredPeriod;
    readonly key: "weighted_delivery_milliseconds";
    readonly previous: WorkforceKpiMeasuredPeriod;
    readonly role_family: "waiter";
    readonly subject: "employee";
    readonly unit: "count" | "milliseconds" | "basis_points";
  }>;
}>
export type WorkforceKpiEmployeeMetrics = Readonly<{
  readonly kitchen: Readonly<{
    readonly course_synchrony: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "K3";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "kitchen";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
    readonly high_load_preparation: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "K5";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "kitchen";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
    readonly preparation: WorkforceKpiPreparationPair;
    readonly start_latency: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "K2";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "kitchen";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
  }> | null;
  readonly waiter: Readonly<{
    readonly concurrent_tables: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "W3_concurrent";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "waiter";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
    readonly coverage_provided: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "W4";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "waiter";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
    readonly coverage_received: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "W5";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "waiter";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
    readonly delivery: WorkforceKpiDeliveryPair;
    readonly dish_wait: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "W1";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "waiter";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
    readonly tables_served: Readonly<{
      readonly change_basis_points: number | null;
      readonly current: WorkforceKpiMeasuredPeriod;
      readonly key: "W3";
      readonly previous: WorkforceKpiMeasuredPeriod;
      readonly role_family: "waiter";
      readonly subject: "employee";
      readonly unit: "count" | "milliseconds" | "basis_points";
    }>;
  }> | null;
}>
export type WorkforceKpiMeasuredMetric = Readonly<{
  readonly change_basis_points: number | null;
  readonly current: WorkforceKpiMeasuredPeriod;
  readonly key: string;
  readonly previous: WorkforceKpiMeasuredPeriod;
  readonly role_family: "kitchen" | "waiter";
  readonly subject: "employee" | "restaurant";
  readonly unit: "count" | "milliseconds" | "basis_points";
}>
export type WorkforceKpiMeasuredPeriod = Readonly<{
  readonly coverage: "complete" | "partial" | "missing";
  readonly denominator: number;
  readonly numerator: number;
  readonly reasons: readonly (string)[];
  readonly sample_size: number;
  readonly value: number | null;
}>
export type WorkforceKpiPolicy = Readonly<{
  readonly publication_version: number;
  readonly ready_wait_threshold_ms: number;
  readonly restaurant_id: string;
  readonly source: "published_setting" | "derived" | "default";
  readonly tenant_id: string;
}>
export type WorkforceKpiPreparationPair = Readonly<{
  readonly normalized_preparation: Readonly<{
    readonly change_basis_points: number | null;
    readonly current: WorkforceKpiMeasuredPeriod;
    readonly key: "K1";
    readonly previous: WorkforceKpiMeasuredPeriod;
    readonly role_family: "kitchen";
    readonly subject: "employee";
    readonly unit: "count" | "milliseconds" | "basis_points";
  }>;
  readonly remake_rate: Readonly<{
    readonly change_basis_points: number | null;
    readonly current: WorkforceKpiMeasuredPeriod;
    readonly key: "K4";
    readonly previous: WorkforceKpiMeasuredPeriod;
    readonly role_family: "kitchen";
    readonly subject: "employee";
    readonly unit: "count" | "milliseconds" | "basis_points";
  }>;
  readonly sala_wait: Readonly<{
    readonly change_basis_points: number | null;
    readonly current: WorkforceKpiMeasuredPeriod;
    readonly key: "W1";
    readonly previous: WorkforceKpiMeasuredPeriod;
    readonly role_family: "waiter";
    readonly subject: "restaurant";
    readonly unit: "count" | "milliseconds" | "basis_points";
  }>;
}>
export type WorkforceManagerKpiContext = Readonly<{
  readonly employee_score: false;
  readonly evaluated_at: string;
  readonly interventions: Readonly<{
    readonly by_manager: readonly (Readonly<{
        readonly actor_principal_id: string;
        readonly operations: readonly (Readonly<{
            readonly change: Readonly<{
              readonly action_count: number | null;
              readonly item_count: number | null;
            }>;
            readonly current: Readonly<{
              readonly action_count: number | null;
              readonly coverage: "complete" | "partial" | "missing";
              readonly item_count: number | null;
              readonly reasons: readonly (string)[];
            }>;
            readonly operation: "manager.kitchen.start" | "manager.kitchen.ready" | "manager.kitchen.remake" | "manager.waiter.delivered" | "manager.waiter.mark_all";
            readonly previous: Readonly<{
              readonly action_count: number | null;
              readonly coverage: "complete" | "partial" | "missing";
              readonly item_count: number | null;
              readonly reasons: readonly (string)[];
            }>;
          }>)[];
      }>)[];
    readonly change: Readonly<{
      readonly action_count: number | null;
      readonly item_count: number | null;
    }>;
    readonly current: Readonly<{
      readonly action_count: number | null;
      readonly coverage: "complete" | "partial" | "missing";
      readonly item_count: number | null;
      readonly reasons: readonly (string)[];
    }>;
    readonly previous: Readonly<{
      readonly action_count: number | null;
      readonly coverage: "complete" | "partial" | "missing";
      readonly item_count: number | null;
      readonly reasons: readonly (string)[];
    }>;
  }>;
  readonly load_context: Readonly<{
    readonly change: Readonly<{
      readonly average_observed_in_flight_items: number | null;
      readonly distinct_observed_table_sessions: number | null;
    }>;
    readonly current: Readonly<{
      readonly average_observed_in_flight_items: Readonly<{
        readonly coverage: "complete" | "partial" | "missing";
        readonly reasons: readonly (string)[];
        readonly semantics: "lower_bound_from_matched_start_ready_cycles";
        readonly value: number | null;
      }>;
      readonly distinct_observed_table_sessions: Readonly<{
        readonly coverage: "complete" | "partial" | "missing";
        readonly reasons: readonly (string)[];
        readonly semantics: "lower_bound_of_distinct_active_sessions";
        readonly value: number | null;
      }>;
      readonly end: string;
      readonly observed_duration_milliseconds: number;
      readonly pressure: WorkforceRestaurantPressureWindow;
      readonly start: string;
      readonly windows?: readonly (Readonly<{
          readonly average_observed_in_flight_items: Readonly<{
            readonly coverage: "complete" | "partial" | "missing";
            readonly reasons: readonly (string)[];
            readonly semantics: "lower_bound_from_matched_start_ready_cycles";
            readonly value: number | null;
          }>;
          readonly distinct_observed_table_sessions: Readonly<{
            readonly coverage: "complete" | "partial" | "missing";
            readonly reasons: readonly (string)[];
            readonly semantics: "lower_bound_of_distinct_active_sessions";
            readonly value: number | null;
          }>;
          readonly end: string;
          readonly observed_duration_milliseconds: number;
          readonly pressure: WorkforceRestaurantPressureWindow;
          readonly start: string;
        }>)[];
    }>;
    readonly previous: Readonly<{
      readonly average_observed_in_flight_items: Readonly<{
        readonly coverage: "complete" | "partial" | "missing";
        readonly reasons: readonly (string)[];
        readonly semantics: "lower_bound_from_matched_start_ready_cycles";
        readonly value: number | null;
      }>;
      readonly distinct_observed_table_sessions: Readonly<{
        readonly coverage: "complete" | "partial" | "missing";
        readonly reasons: readonly (string)[];
        readonly semantics: "lower_bound_of_distinct_active_sessions";
        readonly value: number | null;
      }>;
      readonly end: string;
      readonly observed_duration_milliseconds: number;
      readonly pressure: WorkforceRestaurantPressureWindow;
      readonly start: string;
      readonly windows?: readonly (Readonly<{
          readonly average_observed_in_flight_items: Readonly<{
            readonly coverage: "complete" | "partial" | "missing";
            readonly reasons: readonly (string)[];
            readonly semantics: "lower_bound_from_matched_start_ready_cycles";
            readonly value: number | null;
          }>;
          readonly distinct_observed_table_sessions: Readonly<{
            readonly coverage: "complete" | "partial" | "missing";
            readonly reasons: readonly (string)[];
            readonly semantics: "lower_bound_of_distinct_active_sessions";
            readonly value: number | null;
          }>;
          readonly end: string;
          readonly observed_duration_milliseconds: number;
          readonly pressure: WorkforceRestaurantPressureWindow;
          readonly start: string;
        }>)[];
    }>;
    readonly window_minutes: 30;
  }>;
  readonly restaurant_id: string;
  readonly restaurant_pressure: WorkforceRestaurantPressureLive;
  readonly scope: "restaurant_process";
  readonly shift_load_index: Readonly<{
    readonly change: number | null;
    readonly current: Readonly<{
      readonly coverage: "complete" | "partial" | "missing";
      readonly reasons: readonly (string)[];
      readonly value: number | null;
    }>;
    readonly previous: Readonly<{
      readonly coverage: "complete" | "partial" | "missing";
      readonly reasons: readonly (string)[];
      readonly value: number | null;
    }>;
  }>;
  readonly tenant_id: string;
}>
export type WorkforceOperationalActivityContribution = Readonly<{
  readonly contract: "exylon.workforce.operational-activity-contribution@2.0";
  readonly contribution_id: string;
  readonly contribution_version: number;
  readonly employment_id: string;
  readonly fresh_lineage_count: number;
  readonly identity_membership_id: string;
  readonly identity_membership_version: number;
  readonly identity_session_expires_at: string;
  readonly identity_session_generation: number;
  readonly identity_session_record_id: string;
  readonly identity_session_record_version: number;
  readonly last_authenticated_activity_at: string;
  readonly last_signal: "login" | "reconnect" | "foreground" | "foreground_heartbeat" | "authenticated_operation";
  readonly lease_policy_version: "workforce-authenticated-activity-v2";
  readonly lineage_fingerprint: string;
  readonly restaurant_id: string;
  readonly shift_id: string;
  readonly shift_version: number;
  readonly state: "active";
  readonly tenant_id: string;
  readonly valid_until: string;
}>
export type WorkforceOperationalEligibilityDecision = Readonly<{
  readonly contract: "exylon.workforce.operational-eligibility.decision@1.0";
  readonly decision_fingerprint: string;
  readonly eligible: true;
  readonly evaluated_at: string;
  readonly evidence: Readonly<{
    readonly assignment: Readonly<{
      readonly assignment_policy_fingerprint: string;
      readonly configuration_version: number;
      readonly employment_id: string;
      readonly id: string;
      readonly location_id: string;
      readonly state: "assigned";
      readonly target_fingerprint: string;
      readonly target_id: string;
      readonly target_kind: "table" | "department";
      readonly updated_at: string;
      readonly version: number;
      readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
    }> | null;
    readonly assignment_policy: Readonly<{
      readonly assignment_required: boolean;
      readonly configuration_version: number;
      readonly input_fingerprint: string;
      readonly source: "published_setting" | "unconfigured_fallback";
      readonly target: Readonly<{
        readonly active: boolean;
        readonly target_fingerprint: string;
        readonly target_id: string;
        readonly target_kind: "table" | "department";
      }> | null;
    }>;
    readonly eligibility: Readonly<{
      readonly employment_id: string;
      readonly id: string;
      readonly state: "eligible";
      readonly valid_from: string;
      readonly valid_until: string | null;
      readonly version: number;
      readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
    }>;
    readonly employment: Readonly<{
      readonly id: string;
      readonly status: "active";
      readonly version: number;
    }>;
    readonly presence: Readonly<{
      readonly aggregate_fingerprint: string;
      readonly fresh_lineage_count: number;
      readonly last_authenticated_activity_at: string;
      readonly lease_policy_version: "workforce-authenticated-activity-v2";
      readonly scope: "aggregate";
      readonly shift_id: string;
      readonly shift_version: number;
      readonly state: "active";
      readonly valid_until: string;
    }> | Readonly<{
      readonly contribution_id: string;
      readonly contribution_version: number;
      readonly identity_membership_id: string;
      readonly identity_membership_version: number;
      readonly identity_session_expires_at: string;
      readonly identity_session_generation: number;
      readonly identity_session_record_id: string;
      readonly identity_session_record_version: number;
      readonly last_authenticated_activity_at: string;
      readonly lease_policy_version: "workforce-authenticated-activity-v2";
      readonly lineage_fingerprint: string;
      readonly scope: "caller_lineage";
      readonly shift_id: string;
      readonly shift_version: number;
      readonly state: "active";
      readonly valid_until: string;
    }>;
    readonly shift: Readonly<{
      readonly employment_id: string;
      readonly ended_at: null;
      readonly id: string;
      readonly location_id: string;
      readonly started_at: string;
      readonly status: "started";
      readonly version: number;
    }>;
  }>;
  readonly input_fingerprint: string;
  readonly mode: "general_operational_eligibility" | "exact_target_routing";
  readonly principal_id: string;
  readonly reason: "eligible";
  readonly restaurant_id: string;
  readonly target: Readonly<{
    readonly target_id: string;
    readonly target_kind: "department";
  }> | Readonly<{
    readonly target_id: string;
    readonly target_kind: "table";
  }> | null;
  readonly tenant_id: string;
  readonly valid_until: string;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}> | Readonly<{
  readonly contract: "exylon.workforce.operational-eligibility.decision@1.0";
  readonly decision_fingerprint: string;
  readonly eligible: false;
  readonly evaluated_at: string;
  readonly evidence: Readonly<{
    readonly assignment: Readonly<{
      readonly assignment_policy_fingerprint: string;
      readonly configuration_version: number;
      readonly employment_id: string;
      readonly id: string;
      readonly location_id: string;
      readonly state: "assigned" | "unassigned";
      readonly target_fingerprint: string;
      readonly target_id: string;
      readonly target_kind: "table" | "department";
      readonly updated_at: string;
      readonly version: number;
      readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
    }> | null;
    readonly assignment_policy: Readonly<{
      readonly assignment_required: boolean;
      readonly configuration_version: number;
      readonly input_fingerprint: string;
      readonly source: "published_setting" | "unconfigured_fallback";
      readonly target: Readonly<{
        readonly active: boolean;
        readonly target_fingerprint: string;
        readonly target_id: string;
        readonly target_kind: "table" | "department";
      }> | null;
    }> | null;
    readonly eligibility: Readonly<{
      readonly employment_id: string;
      readonly id: string;
      readonly state: "eligible" | "suspended" | "expired";
      readonly valid_from: string;
      readonly valid_until: string | null;
      readonly version: number;
      readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
    }> | null;
    readonly employment: Readonly<{
      readonly id: string;
      readonly status: "active" | "suspended" | "ended";
      readonly version: number;
    }> | null;
    readonly presence: Readonly<{
      readonly aggregate_fingerprint: string;
      readonly fresh_lineage_count: number;
      readonly last_authenticated_activity_at: string;
      readonly lease_policy_version: "workforce-authenticated-activity-v2";
      readonly scope: "aggregate";
      readonly shift_id: string;
      readonly shift_version: number;
      readonly state: "active" | "inactive";
      readonly valid_until: string;
    }> | Readonly<{
      readonly contribution_id: string;
      readonly contribution_version: number;
      readonly identity_membership_id: string;
      readonly identity_membership_version: number;
      readonly identity_session_expires_at: string;
      readonly identity_session_generation: number;
      readonly identity_session_record_id: string;
      readonly identity_session_record_version: number;
      readonly last_authenticated_activity_at: string;
      readonly lease_policy_version: "workforce-authenticated-activity-v2";
      readonly lineage_fingerprint: string;
      readonly scope: "caller_lineage";
      readonly shift_id: string;
      readonly shift_version: number;
      readonly state: "active" | "revoked" | "closed";
      readonly valid_until: string;
    }> | null;
    readonly shift: Readonly<{
      readonly employment_id: string;
      readonly ended_at: string | null;
      readonly id: string;
      readonly location_id: string;
      readonly started_at: string;
      readonly status: "started" | "completed";
      readonly version: number;
    }> | null;
  }>;
  readonly input_fingerprint: string;
  readonly mode: "general_operational_eligibility" | "exact_target_routing";
  readonly principal_id: string;
  readonly reason: "foreign_scope" | "employment_inactive" | "wrong_work_type" | "target_work_type_mismatch" | "work_session_missing" | "session_proof_missing" | "session_proof_revoked" | "session_proof_expired" | "session_proof_mismatched" | "activity_contribution_missing" | "activity_contribution_revoked" | "activity_contribution_stale" | "activity_contribution_mismatched" | "assignment_policy_invalid" | "target_required" | "assignment_missing" | "assignment_mismatched" | "assignment_foreign" | "assignment_stale";
  readonly restaurant_id: string;
  readonly target: Readonly<{
    readonly target_id: string;
    readonly target_kind: "department";
  }> | Readonly<{
    readonly target_id: string;
    readonly target_kind: "table";
  }> | null;
  readonly tenant_id: string;
  readonly valid_until: null;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}>
export type WorkforceOperationalEligibilityRequest = Readonly<{
  readonly contract: "exylon.workforce.operational-eligibility.request@1.0";
  readonly input_fingerprint: string;
  readonly mode: "general_operational_eligibility" | "exact_target_routing";
  readonly principal_id: string;
  readonly restaurant_id: string;
  readonly target: Readonly<{
    readonly target_id: string;
    readonly target_kind: "department";
  }> | Readonly<{
    readonly target_id: string;
    readonly target_kind: "table";
  }> | null;
  readonly tenant_id: string;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery";
}>
export type WorkforceOperationalManagerAuthorityEvidence = Readonly<{
  readonly authority_fingerprint: string;
  readonly authority_kind: "platform_admin" | "exact_restaurant_manager";
  readonly canonical_role: "SUPERADMIN" | "RESTAURANT_MANAGER";
  readonly contract: "exylon.workforce.operational-manager-authority-evidence@1.0";
  readonly membership_id: string;
  readonly membership_resource_id: string;
  readonly membership_resource_type: "workspace" | "restaurant";
  readonly membership_tenant_id: string;
  readonly membership_tenant_type: "platform" | "restaurant";
  readonly membership_version: number;
  readonly principal_id: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type WorkforceOperationalPresenceRenewRequest = Readonly<{
  readonly signal: "foreground_heartbeat";
}>
export type WorkforceOperationalSessionEnterFloorAnswer = Readonly<{
  readonly board: ServiceFloorSnapshot | null;
  readonly result: WorkforceOperationalSessionResult;
  readonly revision: string | null;
}>
export type WorkforceOperationalSessionEnterKitchenAnswer = Readonly<{
  readonly board: ServiceKitchenSnapshot | null;
  readonly result: WorkforceOperationalSessionResult;
  readonly revision: string | null;
}>
export type WorkforceOperationalSessionEnterRequest = Readonly<{
  readonly signal: "login" | "reconnect" | "foreground";
}>
export type WorkforceOperationalSessionResult = Readonly<{
  readonly contribution: WorkforceOperationalActivityContribution;
  readonly operation: "operational-session.enter" | "operational-presence.renew";
  readonly shift: WorkforceShift;
}>
export type WorkforcePresence = Readonly<{
  readonly employment_id: string;
  readonly last_authenticated_activity_at: string;
  readonly operational_state: "online" | "offline";
  readonly shift_id: string;
  readonly valid_until: string;
}>
export type WorkforceRestaurantPressureLive = Readonly<{
  readonly active_participants: number | null;
  readonly coverage: "complete" | "partial" | "missing";
  readonly evaluated_at: string;
  readonly label: "alta" | "media" | "baja" | "sin_datos";
  readonly occupancy_basis_points: number | null;
  readonly published_floor_seats: number | null;
  readonly reasons: readonly (string)[];
}>
export type WorkforceRestaurantPressureWindow = Readonly<{
  readonly coverage: "complete" | "partial" | "missing";
  readonly label: "alta" | "media" | "baja" | "sin_datos";
  readonly occupancy_basis_points: number | null;
  readonly published_floor_seats: number | null;
  readonly reasons: readonly (string)[];
}>
export type WorkforceRota = Readonly<{
  readonly changes: number | null;
  readonly contract: "exylon.workforce.rota@1.0";
  readonly publication: Readonly<{
    readonly contract: "exylon.workforce.rota-publication@1.0";
    readonly notices: readonly (Readonly<{
        readonly employment_id: string;
        readonly notice_id: string;
      }>)[];
    readonly published_at: string;
    readonly published_by: Readonly<{
      readonly kind: "owner";
      readonly principal_id: string;
    }>;
    readonly receipt_id: string;
    readonly rota_version: number;
  }> | null;
  readonly restaurant_id: string;
  readonly rules_check: Readonly<{
    readonly ok: boolean;
    readonly rules: Readonly<{
      readonly max_daily_minutes: number;
      readonly max_weekly_minutes: number;
      readonly min_days_off_per_week: number;
      readonly min_rest_between_shifts_minutes: number;
    }>;
    readonly violations: readonly (Readonly<{
        readonly dates: readonly (string)[];
        readonly detail: string;
        readonly employment_id: string;
        readonly rule: "rest_between_shifts" | "daily_maximum" | "weekly_maximum" | "days_off" | "overlap" | "shape";
      }>)[];
  }>;
  readonly shifts: readonly (Readonly<{
      readonly date: string;
      readonly display_name: string;
      readonly employment_id: string;
      readonly end: string;
      readonly role_name: string;
      readonly shift_id: string;
      readonly start: string;
    }>)[];
  readonly state: "absent" | "draft" | "published" | "superseded";
  readonly version: number;
  readonly week_start: string;
}>
export type WorkforceRotaPublishRequest = Readonly<{
  readonly expected_version: number;
  readonly proposal_id: string | null;
  readonly shifts: readonly (Readonly<{
      readonly date: string;
      readonly employment_id: string;
      readonly end: string;
      readonly role_name: string;
      readonly shift_id: string;
      readonly start: string;
    }>)[];
  readonly shortfall_choice?: Readonly<{
    readonly option: "extend_hours" | "ask_extra_staff" | "reduce_service" | "publish_with_gaps";
    readonly services: readonly (Readonly<{
        readonly date: string;
        readonly slot: "lunch" | "dinner";
      }>)[];
  }> | null;
  readonly week_start: string;
}>
export type WorkforceRotaQuery = Readonly<{
  readonly week_start: string;
}>
export type WorkforceShift = Readonly<{
  readonly close_reason: "activity_expired" | "session_revoked" | "authority_revoked" | null;
  readonly closed_observed_at: string | null;
  readonly employment_id: string;
  readonly ended_at: string | null;
  readonly id: string;
  readonly location_id: string;
  readonly restaurant_id: string;
  readonly started_at: string;
  readonly status: "started" | "completed";
  readonly tenant_id: string;
  readonly version: number;
}>
export type WorkforceStaffNoticeComposeRequest = Readonly<{
  readonly audience?: "floor_team" | "kitchen_team" | "whole_team" | "one_person";
  readonly body: string;
  readonly desk?: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
  readonly expires_at?: string;
  readonly kind?: "briefing" | "guard" | "production_plan" | "new_dish" | "recognition" | "your_week" | "closing" | "notice";
  readonly notice_id: string;
  readonly recipient_employment_id?: string | null;
  readonly title: string;
  readonly topic: "offer_qr_at_seating" | "offer_dessert_at_clearing" | "ask_review_at_payment" | "new_price" | "bill_with_coffee" | "use_expiring_stock" | "event_today" | "coupons_expiring" | "rain_terrace" | "stock_running_low" | "first_round_at_seating" | "review_topic_rising" | "team_thanks" | "sold_out_at_peak" | "kitchen_running_late" | "pass_waiting" | "production_plan" | "team_briefing" | "academia" | "team_recognition" | "team_notice" | "your_week" | "coach_note";
}>
export type WorkforceStaffNoticeComposeResult = Readonly<{
  readonly notice_id: string;
  readonly review_sha256: string;
  readonly status: "queued";
}>
export type WorkforceStaffNoticeState = Readonly<{
  readonly audience?: "floor_team" | "kitchen_team" | "whole_team" | "one_person";
  readonly body: string | null;
  readonly contract: "exylon.workforce.staff-notice-state@1.0";
  readonly desk?: "direccion" | "finanzas" | "carta" | "cocina" | "clientes" | "equipo" | "operaciones" | "compras" | "prevision" | "marca" | "innovacion" | "intervencion" | "secretaria" | null;
  readonly expires_at?: string;
  readonly kind?: "briefing" | "guard" | "production_plan" | "new_dish" | "recognition" | "your_week" | "closing" | "notice";
  readonly notice_id: string;
  readonly recipient_employment_id?: string | null;
  readonly requested_at: string | null;
  readonly state: "absent" | "live" | "withdrawn" | "expired";
  readonly title: string | null;
  readonly topic: "offer_qr_at_seating" | "offer_dessert_at_clearing" | "ask_review_at_payment" | "new_price" | "bill_with_coffee" | "use_expiring_stock" | "event_today" | "coupons_expiring" | "rain_terrace" | "stock_running_low" | "first_round_at_seating" | "review_topic_rising" | "team_thanks" | "sold_out_at_peak" | "kitchen_running_late" | "pass_waiting" | "production_plan" | "team_briefing" | "academia" | "team_recognition" | "team_notice" | "your_week" | "coach_note" | null;
  readonly withdrawn_at: string | null;
}>
export type WorkforceStaffNoticeWithdrawRequest = Readonly<Record<never, never>>
export type WorkforceStaffNoticeWithdrawResult = Readonly<{
  readonly notice_id: string;
  readonly status: "withdrawn";
  readonly withdrawn_at: string;
}>
export type WorkforceTeamOnPlan = Readonly<{
  readonly assignments: readonly (WorkforceWorkTargetAssignment)[];
  readonly contract: "exylon.workforce.team-on-plan@1.0";
  readonly people: readonly (Readonly<{
      readonly assignable: boolean;
      readonly avatar_url: string | null;
      readonly display_name: string;
      readonly employee_id: string;
      readonly job_title: string;
    }>)[];
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type WorkforceWaiterDeliveryCoverageAssignmentEvidence = Readonly<{
  readonly assignment_id: string;
  readonly assignment_version: number;
  readonly configuration_version: number;
  readonly target_fingerprint: string;
  readonly target_id: string;
}>
export type WorkforceWaiterDeliveryCoverageCandidate = Readonly<{
  readonly assignment_policy_fingerprint: string;
  readonly assignments: readonly (WorkforceWaiterDeliveryCoverageAssignmentEvidence)[];
  readonly candidate_fingerprint: string;
  readonly configuration_version: number;
  readonly eligibility_id: string;
  readonly eligibility_version: number;
  readonly employment_id: string;
  readonly employment_version: number;
  readonly fresh_lineage_count: number;
  readonly last_authenticated_activity_at: string;
  readonly location_id: string;
  readonly shift_id: string;
  readonly shift_version: number;
  readonly valid_until: string;
  readonly waiter: boolean;
}>
export type WorkforceWaiterDeliveryCoverageCandidateList = Readonly<{
  readonly assignment_policy_fingerprint: string;
  readonly candidates: readonly (WorkforceWaiterDeliveryCoverageCandidate)[];
  readonly configuration_version: number;
  readonly contract: "exylon.workforce.waiter-delivery-coverage-candidates@1.0";
  readonly evaluated_at: string;
  readonly location_id: string;
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>
export type WorkforceWaiterDeliveryCoverageRevalidation = Readonly<{
  readonly candidate: WorkforceWaiterDeliveryCoverageCandidate | null;
  readonly contract: "exylon.workforce.waiter-delivery-coverage-revalidation@1.0";
  readonly eligible: boolean;
  readonly evaluated_at: string;
  readonly expected_candidate_fingerprint: string;
  readonly location_id: string;
  readonly principal_id: string;
  readonly reason: "eligible" | "not_candidate" | "candidate_stale";
  readonly restaurant_id: string;
  readonly tenant_id: string;
  readonly valid_until: string | null;
}>
export type WorkforceWorkTargetAssignment = Readonly<{
  readonly assignment_policy_fingerprint: string;
  readonly configuration_version: number;
  readonly created_at: string;
  readonly employment_id: string;
  readonly floor_id: string;
  readonly id: string;
  readonly location_id: string;
  readonly restaurant_id: string;
  readonly state: "assigned" | "unassigned";
  readonly target_fingerprint: string;
  readonly target_id: string;
  readonly target_kind: "table" | "department";
  readonly tenant_id: string;
  readonly updated_at: string;
  readonly version: number;
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery" | "department.access" | "service.pos-checkout";
}>
export type WorkforceWorkTargetAssignmentAssignRequest = Readonly<{
  readonly assignment_id: string;
  readonly configuration_version: number;
  readonly employment_id: string;
  readonly target_id: string;
  readonly target_kind: "table" | "department";
  readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery" | "department.access" | "service.pos-checkout";
}>
export type WorkforceWorkTargetAssignmentBulkApplyRequest = Readonly<{
  readonly commands: readonly (Readonly<{
      readonly assignment_id: string;
      readonly configuration_version: number;
      readonly employment_id: string;
      readonly expected_version: 0;
      readonly operation: "assign";
      readonly target_id: string;
      readonly target_kind: "table" | "department";
      readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery" | "department.access" | "service.pos-checkout";
    }> | Readonly<{
      readonly assignment_id: string;
      readonly configuration_version: number;
      readonly expected_version: number;
      readonly operation: "reassign";
      readonly target_id: string;
      readonly target_kind: "table" | "department";
      readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery" | "department.access" | "service.pos-checkout";
    }> | Readonly<{
      readonly assignment_id: string;
      readonly expected_version: number;
      readonly operation: "unassign";
      readonly reason_code: string;
    }>)[];
}>
export type WorkforceWorkTargetAssignmentBulkApplyResult = Readonly<{
  readonly applied_count: number;
  readonly results: readonly (WorkforceWorkTargetAssignmentCommandResult)[];
}>
export type WorkforceWorkTargetAssignmentCommandResult = Readonly<{
  readonly assignment: WorkforceWorkTargetAssignment;
  readonly operation: "assign" | "reassign" | "unassign";
}>
export type WorkforceWorkTargetAssignmentList = Readonly<{
  readonly assignments: readonly (Readonly<{
      readonly assignment_policy_fingerprint: string;
      readonly configuration_version: number;
      readonly created_at: string;
      readonly employment_id: string;
      readonly floor_id: string;
      readonly id: string;
      readonly location_id: string;
      readonly restaurant_id: string;
      readonly state: "assigned" | "unassigned";
      readonly target_fingerprint: string;
      readonly target_id: string;
      readonly target_kind: "table" | "department";
      readonly target_label: string | null;
      readonly tenant_id: string;
      readonly updated_at: string;
      readonly version: number;
      readonly work_type: "kitchen.fulfillment" | "service.ready-item-delivery" | "department.access" | "service.pos-checkout";
    }>)[];
  readonly restaurant_id: string;
  readonly tenant_id: string;
}>

/** @deprecated Use an operation-specific generated Service result after W5.3.5 consumer cutover. */
export type ServiceCommandResult = Readonly<{
  readonly bill_request?: ServiceBillRequest;
  readonly cart?: ServiceCart;
  readonly cart_item?: ServiceCartItem;
  readonly fulfillment_batch?: ServiceFulfillmentBatch;
  readonly fulfillment_plan?: ServiceFulfillmentPlan;
  readonly operation: string;
  readonly participant?: ServiceTableSessionParticipant;
  readonly order?: ServiceOrder;
  readonly order_cart_sources?: readonly ServiceOrderCartSource[];
  readonly order_item?: ServiceOrderItem;
  readonly table_session?: ServiceTableSession;
  readonly waiting_room_entry?: ServiceWaitingRoomEntry;
}>
export const TENANT_RESOURCE_CONTRACT = 'exylon.tenant-directory.resource@1.0' as const
export const IDENTITY_MEMBERSHIP_CONTRACT = 'exylon.identity-access.membership@1.0' as const
export const IDENTITY_SESSION_CONTRACT = 'exylon.identity-access.session@1.0' as const
export const IDENTITY_AUTHORIZATION_CONTRACT = 'exylon.identity-access.authorization@1.0' as const
export const IDENTITY_DECISION_CONTRACT = 'exylon.identity-access.decision@1.0' as const
export const IDENTITY_ROUTE_POLICY_CONTRACT = 'exylon.identity-access.route-policy@1.0' as const
export const PLATFORM_MESSAGING_REALTIME_REPLAY_CONTRACT = 'exylon.platform-messaging.realtime-replay@1.0' as const
export const RUNTIME_HEALTH_CONTRACT = 'exylon.operations.runtime-health@1.0' as const
export type CoreQuery = Readonly<Record<string, string | number | boolean | readonly (string | number | boolean)[] | null | undefined>>
export type CoreRead =
  | Readonly<{ operation: "GET /auth/current"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /clients/:clientId/admission"; params: Readonly<{ readonly clientId: string }>; query: IdentityRequestGuestAdmissionStaffRead }>
  | Readonly<{ operation: "GET /franchises"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /franchises/:franchiseId"; params: Readonly<{ readonly franchiseId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /franchises/:franchiseId/logo"; params: Readonly<{ readonly franchiseId: string }>; query: Readonly<{ readonly v: string }> }>
  | Readonly<{ operation: "GET /guest/home"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /guest/restaurant-presentation"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /identity-access/restaurants/:restaurantId/qr-tokens"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens"; params: Readonly<{ readonly restaurantId: string; readonly tableId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /identity/guest/auth/current"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /identity/guest/qr/handoff/:handoffToken"; params: Readonly<{ readonly handoffToken: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /identity/guest/qr/resolve/:qrId"; params: Readonly<{ readonly qrId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /me/profile"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /me/sessions"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /me/workspaces"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /restaurants"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /restaurants/:restaurantId"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /restaurants/:restaurantId/access-policy/current-grants"; params: Readonly<{ readonly restaurantId: string }>; query: AccessPolicyCurrentGrantBatchQuery }>
  | Readonly<{ operation: "GET /restaurants/:restaurantId/access-policy/directory"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /restaurants/:restaurantId/access-policy/receipts/:receiptId"; params: Readonly<{ readonly restaurantId: string; readonly receiptId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /restaurants/:restaurantId/locations"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /restaurants/:restaurantId/logo"; params: Readonly<{ readonly restaurantId: string }>; query: Readonly<{ readonly v: string }> }>
  | Readonly<{ operation: "GET /restaurants/:restaurantId/staff-invitations/:invitationId"; params: Readonly<{ readonly restaurantId: string; readonly invitationId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "GET /users/:userId/avatar"; params: Readonly<{ readonly userId: string }>; query: Readonly<{ readonly v: string }> }>
  | Readonly<{ operation: "platformMessaging.guestRealtimeReplay.v1"; params: Readonly<Record<never, never>>; query: PlatformMessagingGuestRealtimeReplayRequest }>
  | Readonly<{ operation: "platformMessaging.panelNoticesInbox.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "platformMessaging.guestNoticesPendingOverlay.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "readRestaurantConfigurationCurrent"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "searchIneMunicipalities"; params: Readonly<{ readonly restaurantId: string }>; query: IneMunicipalitySearchRequest }>
  | Readonly<{ operation: "restaurant-configuration.geocode.search.v1"; params: Readonly<{ readonly restaurantId: string }>; query: GeocodeSearchRequest }>
  | Readonly<{ operation: "readPublishedRestaurantConfiguration"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogWorkshopCandidate"; params: Readonly<{ readonly restaurantId: string; readonly candidateId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogDraft"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogStockDeactivationWarning"; params: Readonly<{ readonly restaurantId: string }>; query: CatalogStockDeactivationWarningRequest }>
  | Readonly<{ operation: "listCatalogPublications"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogPublication"; params: Readonly<{ readonly restaurantId: string; readonly publicationVersion: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readPublishedCatalogue"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "catalog.pos-operational.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "catalog.pos-routing.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly publicationVersion: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readGuestPublishedCatalogue"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readGuestLiveCatalogue"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readGuestMenuDocuments"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readGuestPublishedDish"; params: Readonly<{ readonly restaurantId: string; readonly dishId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "searchCatalogMasterIngredients"; params: Readonly<{ readonly restaurantId: string }>; query: CatalogMasterIngredientSearchRequest }>
  | Readonly<{ operation: "readCatalogAiPhotoEnhancementPreview"; params: Readonly<{ readonly restaurantId: string; readonly mediaId: string }>; query: CatalogAiPhotoEnhancementPreviewRequest }>
  | Readonly<{ operation: "readCatalogAiProviderCredentialStatus"; params: Readonly<{ readonly restaurantId: string }>; query: CatalogAiProviderCredentialReadRequest }>
  | Readonly<{ operation: "readCatalogAiUsageMonth"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "listCatalogDishNameSuggestions"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "listCatalogDailySuggestions"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readGuestDailySuggestions"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogCartaFisica"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "listCatalogDishTrials"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogDraftSummary"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogDraftDocument"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogReferenceDocument"; params: Readonly<{ readonly restaurantId: string; readonly digest: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "catalog.repaired-master-holdings.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "readCatalogMediaDelivery"; params: Readonly<{ readonly restaurantId: string; readonly mediaId: string }>; query: CatalogMediaDeliveryRequest }>
  | Readonly<{ operation: "catalog.published-media.delivery.v1"; params: Readonly<{ readonly restaurantId: string; readonly publicationVersion: string; readonly mediaId: string }>; query: CatalogPublishedMediaDeliveryRequest }>
  | Readonly<{ operation: "readCatalogMediaRenditions"; params: Readonly<{ readonly restaurantId: string; readonly mediaId: string }>; query: CatalogMediaRenditionsRequest }>
  | Readonly<{ operation: "readCatalogDraftPhotoRenditions"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "catalog.published-media.renditions.v1"; params: Readonly<{ readonly restaurantId: string; readonly publicationVersion: string; readonly mediaId: string }>; query: CatalogMediaRenditionsRequest }>
  | Readonly<{ operation: "readGuestCatalogMediaDelivery"; params: Readonly<{ readonly restaurantId: string; readonly mediaId: string }>; query: CatalogMediaDeliveryRequest }>
  | Readonly<{ operation: "offers.marketing-board.read"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "offers.marketing-board.page.read"; params: Readonly<Record<never, never>>; query: ReadOfferMarketingBoardPageQuery }>
  | Readonly<{ operation: "offers.definition.get"; params: Readonly<{ readonly definitionId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "offers.definition.history"; params: Readonly<{ readonly definitionId: string }>; query: ListOfferDefinitionHistoryQuery }>
  | Readonly<{ operation: "offers.definition.redemption-consumption.get"; params: Readonly<{ readonly definitionId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "offers.coupon-code.list"; params: Readonly<Record<never, never>>; query: ListOfferCouponCodesQuery }>
  | Readonly<{ operation: "offers.wallet.list"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "offers.definition.uses.list"; params: Readonly<{ readonly definitionId: string }>; query: ListOfferDefinitionUsesQuery }>
  | Readonly<{ operation: "inventory.published-policy.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "inventory.stock-item.published-usage.list.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; query?: ListInventoryPublishedIngredientUsageQuery }>
  | Readonly<{ operation: "inventory.stock-item.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ListInventoryStockItemsQuery }>
  | Readonly<{ operation: "inventory.stock-item.cost.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "inventory.dish-costing.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "inventory.supply.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "inventory.purchase-document.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; query?: InventoryPurchaseDocumentReadQuery }>
  | Readonly<{ operation: "inventory.purchase-documents.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: InventoryPurchaseOverviewQuery }>
  | Readonly<{ operation: "inventory.purchase-trace.search.v1"; params: Readonly<{ readonly restaurantId: string }>; query: InventoryPurchaseTraceQuery }>
  | Readonly<{ operation: "inventory.purchase-trace.export.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: InventoryPurchaseTraceExportListQuery }>
  | Readonly<{ operation: "inventory.purchase-trace.export.download.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; query?: InventoryPurchaseTraceExportDownloadQuery }>
  | Readonly<{ operation: "inventory.purchase-period.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: InventoryPurchasePeriodQuery }>
  | Readonly<{ operation: "workforce.work-target-assignment.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "workforce.team-on-plan.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "workforce.employee.list.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: WorkforceEmployeeListQuery }>
  | Readonly<{ operation: "workforce.employee.detail.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly employmentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "workforce.employee.kpi.read.v3"; params: Readonly<{ readonly restaurantId: string; readonly employmentId: string }>; query?: WorkforceEmployeeKpiExpansionQuery }>
  | Readonly<{ operation: "workforce.employee.feedback.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly employmentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "workforce.staff-notice.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly noticeId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "workforce.rota.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query: WorkforceRotaQuery }>
  | Readonly<{ operation: "guest.profile.get"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "guest.loyalty-cards.list"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "guest.loyalty-cards.detail"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "guest.privacy.get"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "guest.privacy.personalization.get"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "guest.privacy.export"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "guest.billing.documents.list"; params: Readonly<Record<never, never>>; query?: GuestBillingDocumentListQuery }>
  | Readonly<{ operation: "guest.billing.session-charges.read"; params: Readonly<{ readonly tableSessionId: string }>; query?: GuestBillingSessionChargesQuery }>
  | Readonly<{ operation: "guest.billing.document.download"; params: Readonly<{ readonly documentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.table-occupancy.impacted.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query: ServiceTableOccupancyQuery }>
  | Readonly<{ operation: "service.kitchen-pending-work.impacted.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query: ServiceKitchenPendingWorkQuery }>
  | Readonly<{ operation: "service.fulfillment-plan.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.department-categories.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.snapshot.read.pos.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.snapshot.read.kitchen.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.snapshot.read.floor.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.check-consumption-receipt.read.staff.v1"; params: Readonly<{ readonly restaurantId: string; readonly checkId: string }>; query: ServiceCheckConsumptionReceiptQuery }>
  | Readonly<{ operation: "service.check-order-loyalty.read.staff.v1"; params: Readonly<{ readonly restaurantId: string; readonly checkId: string; readonly orderId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.check-consumption-receipt.read.guest.v1"; params: Readonly<{ readonly checkId: string }>; query: ServiceCheckConsumptionReceiptQuery }>
  | Readonly<{ operation: "service.history.read.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ServiceStaffHistoryQuery }>
  | Readonly<{ operation: "service.history-summary.read.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ServiceStaffHistorySummaryQuery }>
  | Readonly<{ operation: "service.cart.item.safety.challenge.read.v1"; params: Readonly<Record<never, never>>; query: ServiceSafetyChallengeQuery }>
  | Readonly<{ operation: "service.snapshot.read.guest.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "service.arrival.read.guest.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "service.waiting-room.read.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "service.history.read.guest.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "service.cash.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.cash-sessions.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ServiceCashSessionsQuery }>
  | Readonly<{ operation: "service.cash-document-archive.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ServiceCashDocumentArchiveQuery }>
  | Readonly<{ operation: "service.cash-document-archive.file.v1"; params: Readonly<{ readonly restaurantId: string; readonly documentId: string }>; query?: ServiceCashDocumentFileQuery }>
  | Readonly<{ operation: "service.cash-document.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query: ServiceCashDocumentQuery }>
  | Readonly<{ operation: "service.check-payment.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly paymentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.probe.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "service.clock.read.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "service.offline-review.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ServiceOfflineReviewQuery }>
  | Readonly<{ operation: "relationship.external-review.franchise-summaries.get"; params: Readonly<{ readonly franchiseId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.external-review.connection.get"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.external-review.list"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.review-topics.read.v1"; params: Readonly<Record<never, never>>; query?: RelationshipReviewTopicsRequest }>
  | Readonly<{ operation: "relationship.review-stars-weekly.read.v1"; params: Readonly<Record<never, never>>; query?: RelationshipReviewStarsWeeklyRequest }>
  | Readonly<{ operation: "relationship.el-parte-guest-return.read.v1"; params: Readonly<Record<never, never>>; query?: RelationshipGuestReturnPanelRequest }>
  | Readonly<{ operation: "relationship.restaurant-reviews.list.v1"; params: Readonly<Record<never, never>>; query?: RelationshipRestaurantReviewsRequest }>
  | Readonly<{ operation: "relationship.review.offer.read.guest.v1"; params: Readonly<Record<never, never>>; query: ReadRelationshipReviewOfferRequest }>
  | Readonly<{ operation: "relationship.guest-question.read.v1"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.guest-question.offer.read.guest.v1"; params: Readonly<Record<never, never>>; query: ReadRelationshipGuestQuestionOfferRequest }>
  | Readonly<{ operation: "relationship.loyalty.program.admin-get"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.loyalty.tier-catalogue.list"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.loyalty.population.get"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.preferences.get"; params: Readonly<Record<never, never>>; query?: CoreQuery }>
  | Readonly<{ operation: "relationship.recommendation.current.read.guest.v1"; params: Readonly<Record<never, never>>; query: ReadCurrentRelationshipRecommendationRequest }>
  | Readonly<{ operation: "insights.franchise.metrics"; params: Readonly<{ readonly franchiseId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "insights.restaurant.period"; params: Readonly<{ readonly restaurantId: string }>; query: InsightsPeriodQuery }>
  | Readonly<{ operation: "insights.loyalty.period"; params: Readonly<{ readonly restaurantId: string }>; query: InsightsLoyaltyPeriodQuery }>
  | Readonly<{ operation: "insights.restaurant.promotion-month"; params: Readonly<{ readonly restaurantId: string }>; query: InsightsPromotionMonthQuery }>
  | Readonly<{ operation: "insights.restaurant.flavour-profile"; params: Readonly<{ readonly restaurantId: string }>; query: InsightsFlavourProfileQuery }>
  | Readonly<{ operation: "parte.edition.read"; params: Readonly<{ readonly restaurantId: string; readonly editionKind: string; readonly businessDate: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.edition.list"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteEditionListQuery }>
  | Readonly<{ operation: "parte.work.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.notebook.read"; params: Readonly<{ readonly restaurantId: string; readonly editionKind: string; readonly businessDate: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.pendientes.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: PartePendientesQuery }>
  | Readonly<{ operation: "parte.costs.dishes.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteDishCostsQuery }>
  | Readonly<{ operation: "parte.costs.recipe-batch.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.finanzas.daily-account.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteFinanzasReadQuery }>
  | Readonly<{ operation: "parte.finanzas.number-of-today.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteFinanzasReadQuery }>
  | Readonly<{ operation: "parte.edition-audio.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly editionKind: string; readonly businessDate: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.edition-audio.segment.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly editionKind: string; readonly businessDate: string; readonly segmentIndex: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.push-key.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.pacto.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.operation.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly operationId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.autonomy.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.hoy.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly businessDate: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.house-memory.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteHouseMemoryQuery }>
  | Readonly<{ operation: "parte.compras.call-list.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteCallListQuery }>
  | Readonly<{ operation: "parte.compras.prep-plan.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteCallListQuery }>
  | Readonly<{ operation: "parte.compras.food-waste-plan.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteFoodWastePlanQuery }>
  | Readonly<{ operation: "parte.team.coach.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteCoachQuery }>
  | Readonly<{ operation: "parte.rota-proposal.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteRotaProposalQuery }>
  | Readonly<{ operation: "parte.ai-audit.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteAiAuditQuery }>
  | Readonly<{ operation: "parte.compliance-calendar.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.consejo.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly month: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.consejo-pdf.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly month: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.carta-reading.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.encargos.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.encargo.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly encargoId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.page-notes.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly page: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.reputation.drafts.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.team.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.goals.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: ParteGoalsQuery }>
  | Readonly<{ operation: "parte.queue.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.matter.read.v1"; params: Readonly<{ readonly restaurantId: string; readonly matterId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.matters.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "parte.advisor-library.read.v1"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "insights.parte-radar.read"; params: Readonly<{ readonly restaurantId: string }>; query?: InsightsParteRadarQuery }>
  | Readonly<{ operation: "owner-calendar.list"; params: Readonly<{ readonly restaurantId: string }>; query: OwnerCalendarWindowQuery }>
  | Readonly<{ operation: "owner-calendar.history"; params: Readonly<{ readonly restaurantId: string; readonly declarationId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "proposal.catalog-reviewed.preparation.read"; params: Readonly<{ readonly restaurantId: string; readonly requestId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "proposal.intent.list"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "proposal.intent.read"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "proposal.preview"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.configuration.read"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.documents.by-check"; params: Readonly<{ readonly restaurantId: string; readonly checkId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.documents.by-checks"; params: Readonly<{ readonly restaurantId: string }>; query: BillingDocumentsByChecksQuery }>
  | Readonly<{ operation: "billing.document.read"; params: Readonly<{ readonly restaurantId: string; readonly documentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.document.download"; params: Readonly<{ readonly restaurantId: string; readonly documentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.intent.read"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.intent.download"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.status.summary"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.fiscal-incidents.list"; params: Readonly<{ readonly restaurantId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.incidents.list"; params: Readonly<{ readonly restaurantId: string }>; query?: BillingIncidentListQuery }>
  | Readonly<{ operation: "billing.export.list"; params: Readonly<{ readonly restaurantId: string }>; query?: BillingExportListQuery }>
  | Readonly<{ operation: "billing.export.download"; params: Readonly<{ readonly restaurantId: string; readonly exportId: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.invoice-link.read.v1"; params: Readonly<{ readonly token: string }>; query?: CoreQuery }>
  | Readonly<{ operation: "billing.invoice-link.document.v1"; params: Readonly<{ readonly token: string }>; query?: BillingInvoiceLinkDocumentQuery }>
  | Readonly<{ operation: "offers.bridge.definition-put.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: OffersBridgePutQuery }>
  | Readonly<{ operation: "offers.bridge.definition-retire.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: OffersBridgeRetireQuery }>
  | Readonly<{ operation: "inventory.bridge.stock-item-reconcile.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: InventoryBridgeReconcileQuery }>
  | Readonly<{ operation: "inventory.bridge.stock-item.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: InventoryBridgeItemQuery }>
  | Readonly<{ operation: "service.bridge.history.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: ServiceBridgeHistoryQuery }>
  | Readonly<{ operation: "service.bridge.table-session-force-close.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: ServiceBridgeForceCloseQuery }>
  | Readonly<{ operation: "workforce.bridge.feedback-create.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: WorkforceBridgeFeedbackQuery }>
  | Readonly<{ operation: "workforce.bridge.work-target-assignment-bulk-apply.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: WorkforceBridgeBulkQuery }>
  | Readonly<{ operation: "workforce.bridge.staff-notice-compose.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: WorkforceBridgeStaffNoticeQuery }>
  | Readonly<{ operation: "catalog.bridge.draft-replace.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: CatalogBridgeDraftQuery }>
  | Readonly<{ operation: "catalog.bridge.media-write.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: CatalogBridgeMediaQuery }>
  | Readonly<{ operation: "catalog.bridge.publish.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: CatalogBridgePublishQuery }>
  | Readonly<{ operation: "restaurant-configuration.bridge.apply.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: ConfigurationBridgeApplyQuery }>
  | Readonly<{ operation: "restaurant-configuration.bridge.floor.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: ConfigurationBridgeFloorQuery }>
  | Readonly<{ operation: "relationship.bridge.loyalty-program-put.revalidate"; params: Readonly<{ readonly restaurantId: string }>; query: RelationshipBridgeProgramQuery }>
export type CoreExactReadResponseMap = Readonly<{
  readonly "GET /auth/current": IdentityResponseGETAuthCurrent;
  readonly "GET /clients/:clientId/admission": IdentityResponseGETClientsClientIdAdmission;
  readonly "GET /franchises": IdentityResponseGETFranchises;
  readonly "GET /franchises/:franchiseId": IdentityResponseGETFranchisesFranchiseId;
  readonly "GET /franchises/:franchiseId/logo": Blob;
  readonly "GET /guest/home": IdentityResponseGETGuestHome;
  readonly "GET /guest/restaurant-presentation": IdentityResponseGETGuestRestaurantPresentation;
  readonly "GET /identity-access/restaurants/:restaurantId/qr-tokens": IdentityResponseGETIdentityAccessRestaurantsRestaurantIdQrTokens;
  readonly "GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens": IdentityResponseGETIdentityAccessRestaurantsRestaurantIdTablesTableIdQrTokens;
  readonly "GET /identity/guest/auth/current": IdentityResponseGETIdentityGuestAuthCurrent;
  readonly "GET /identity/guest/qr/handoff/:handoffToken": IdentityResponseGETIdentityGuestQrHandoffHandoffToken;
  readonly "GET /identity/guest/qr/resolve/:qrId": IdentityResponseGETIdentityGuestQrResolveQrId;
  readonly "GET /me/profile": IdentityResponseGETMeProfile;
  readonly "GET /me/sessions": IdentityResponseGETMeSessions;
  readonly "GET /me/workspaces": IdentityResponseGETMeWorkspaces;
  readonly "GET /restaurants": IdentityResponseGETRestaurants;
  readonly "GET /restaurants/:restaurantId": IdentityResponseGETRestaurantsRestaurantId;
  readonly "GET /restaurants/:restaurantId/access-policy/current-grants": AccessPolicyCurrentGrantBatchEnvelope;
  readonly "GET /restaurants/:restaurantId/access-policy/directory": AccessPolicyDirectoryEnvelope;
  readonly "GET /restaurants/:restaurantId/access-policy/receipts/:receiptId": AccessPolicyReceiptEnvelope;
  readonly "GET /restaurants/:restaurantId/locations": IdentityResponseGETRestaurantsRestaurantIdLocations;
  readonly "GET /restaurants/:restaurantId/logo": Blob;
  readonly "GET /restaurants/:restaurantId/staff-invitations/:invitationId": IdentityResponseGETRestaurantsRestaurantIdStaffInvitationsInvitationId;
  readonly "GET /users/:userId/avatar": Blob;
  readonly "platformMessaging.guestRealtimeReplay.v1": PlatformMessagingRealtimeReplayResponse;
  readonly "platformMessaging.panelNoticesInbox.v1": PlatformMessagingNoticeInboxResponse;
  readonly "platformMessaging.guestNoticesPendingOverlay.v1": PlatformMessagingNoticeListResponse;
  readonly "readRestaurantConfigurationCurrent": ProductResponseReadRestaurantConfigurationCurrent;
  readonly "searchIneMunicipalities": ProductResponseSearchIneMunicipalities;
  readonly "restaurant-configuration.geocode.search.v1": ProductResponseRestaurantConfigurationGeocodeSearchV1;
  readonly "readPublishedRestaurantConfiguration": ProductResponseReadPublishedRestaurantConfiguration;
  readonly "readCatalogWorkshopCandidate": ProductResponseReadCatalogWorkshopCandidate;
  readonly "readCatalogDraft": ProductResponseReadCatalogDraft;
  readonly "readCatalogStockDeactivationWarning": ProductResponseReadCatalogStockDeactivationWarning;
  readonly "listCatalogPublications": ProductResponseListCatalogPublications;
  readonly "readCatalogPublication": ProductResponseReadCatalogPublication;
  readonly "readPublishedCatalogue": ProductResponseReadPublishedCatalogue;
  readonly "catalog.pos-operational.read.v1": ProductResponseCatalogPosOperationalReadV1;
  readonly "catalog.pos-routing.read.v1": ProductResponseCatalogPosRoutingReadV1;
  readonly "readGuestPublishedCatalogue": ProductResponseReadGuestPublishedCatalogue;
  readonly "readGuestLiveCatalogue": ProductResponseReadGuestLiveCatalogue;
  readonly "readGuestMenuDocuments": ProductResponseReadGuestMenuDocuments;
  readonly "readGuestPublishedDish": ProductResponseReadGuestPublishedDish;
  readonly "searchCatalogMasterIngredients": ProductResponseSearchCatalogMasterIngredients;
  readonly "readCatalogAiPhotoEnhancementPreview": ProductResponseReadCatalogAiPhotoEnhancementPreview;
  readonly "readCatalogAiProviderCredentialStatus": ProductResponseReadCatalogAiProviderCredentialStatus;
  readonly "readCatalogAiUsageMonth": ProductResponseReadCatalogAiUsageMonth;
  readonly "listCatalogDishNameSuggestions": ProductResponseListCatalogDishNameSuggestions;
  readonly "listCatalogDailySuggestions": ProductResponseListCatalogDailySuggestions;
  readonly "readGuestDailySuggestions": ProductResponseReadGuestDailySuggestions;
  readonly "readCatalogCartaFisica": ProductResponseReadCatalogCartaFisica;
  readonly "listCatalogDishTrials": ProductResponseListCatalogDishTrials;
  readonly "readCatalogDraftSummary": ProductResponseReadCatalogDraftSummary;
  readonly "readCatalogDraftDocument": ProductResponseReadCatalogDraftDocument;
  readonly "readCatalogReferenceDocument": ProductResponseReadCatalogReferenceDocument;
  readonly "catalog.repaired-master-holdings.read.v1": ProductResponseCatalogRepairedMasterHoldingsReadV1;
  readonly "readCatalogMediaDelivery": ProductResponseReadCatalogMediaDelivery;
  readonly "catalog.published-media.delivery.v1": ProductResponseCatalogPublishedMediaDeliveryV1;
  readonly "readCatalogMediaRenditions": ProductResponseReadCatalogMediaRenditions;
  readonly "readCatalogDraftPhotoRenditions": ProductResponseReadCatalogDraftPhotoRenditions;
  readonly "catalog.published-media.renditions.v1": ProductResponseCatalogPublishedMediaRenditionsV1;
  readonly "readGuestCatalogMediaDelivery": ProductResponseReadGuestCatalogMediaDelivery;
  readonly "offers.marketing-board.read": ProductResponseOffersMarketingBoardRead;
  readonly "offers.marketing-board.page.read": ProductResponseOffersMarketingBoardPageRead;
  readonly "offers.definition.get": ProductResponseOffersDefinitionGet;
  readonly "offers.definition.history": ProductResponseOffersDefinitionHistory;
  readonly "offers.definition.redemption-consumption.get": ProductResponseOffersDefinitionRedemptionConsumptionGet;
  readonly "offers.coupon-code.list": ProductResponseOffersCouponCodeList;
  readonly "offers.wallet.list": ProductResponseOffersWalletList;
  readonly "offers.definition.uses.list": ProductResponseOffersDefinitionUsesList;
  readonly "inventory.published-policy.read.v1": ProductResponseInventoryPublishedPolicyReadV1;
  readonly "inventory.stock-item.published-usage.list.v1": ProductResponseInventoryStockItemPublishedUsageListV1;
  readonly "inventory.stock-item.list.v1": ProductResponseInventoryStockItemListV1;
  readonly "inventory.stock-item.cost.list.v1": ProductResponseInventoryStockItemCostListV1;
  readonly "inventory.dish-costing.list.v1": ProductResponseInventoryDishCostingListV1;
  readonly "inventory.supply.list.v1": ProductResponseInventorySupplyListV1;
  readonly "inventory.purchase-document.read.v1": ProductResponseInventoryPurchaseDocumentReadV1;
  readonly "inventory.purchase-documents.list.v1": ProductResponseInventoryPurchaseDocumentsListV1;
  readonly "inventory.purchase-trace.search.v1": ProductResponseInventoryPurchaseTraceSearchV1;
  readonly "inventory.purchase-trace.export.list.v1": ProductResponseInventoryPurchaseTraceExportListV1;
  readonly "inventory.purchase-trace.export.download.v1": Blob;
  readonly "inventory.purchase-period.read.v1": ProductResponseInventoryPurchasePeriodReadV1;
  readonly "workforce.work-target-assignment.list.v1": ProductResponseWorkforceWorkTargetAssignmentListV1;
  readonly "workforce.team-on-plan.read.v1": ProductResponseWorkforceTeamOnPlanReadV1;
  readonly "workforce.employee.list.v1": ProductResponseWorkforceEmployeeListV1;
  readonly "workforce.employee.detail.read.v1": ProductResponseWorkforceEmployeeDetailReadV1;
  readonly "workforce.employee.kpi.read.v3": ProductResponseWorkforceEmployeeKpiReadV3;
  readonly "workforce.employee.feedback.read.v1": ProductResponseWorkforceEmployeeFeedbackReadV1;
  readonly "workforce.staff-notice.read.v1": ProductResponseWorkforceStaffNoticeReadV1;
  readonly "workforce.rota.read.v1": ProductResponseWorkforceRotaReadV1;
  readonly "guest.profile.get": ProductResponseGuestProfileGet;
  readonly "guest.loyalty-cards.list": ProductResponseGuestLoyaltyCardsList;
  readonly "guest.loyalty-cards.detail": ProductResponseGuestLoyaltyCardsDetail;
  readonly "guest.privacy.get": ProductResponseGuestPrivacyGet;
  readonly "guest.privacy.personalization.get": ProductResponseGuestPrivacyPersonalizationGet;
  readonly "guest.privacy.export": ProductResponseGuestPrivacyExport;
  readonly "guest.billing.documents.list": ProductResponseGuestBillingDocumentsList;
  readonly "guest.billing.session-charges.read": ProductResponseGuestBillingSessionChargesRead;
  readonly "guest.billing.document.download": Blob;
  readonly "service.table-occupancy.impacted.read.v1": ProductResponseServiceTableOccupancyImpactedReadV1;
  readonly "service.kitchen-pending-work.impacted.read.v1": ProductResponseServiceKitchenPendingWorkImpactedReadV1;
  readonly "service.fulfillment-plan.read.v1": ProductResponseServiceFulfillmentPlanReadV1;
  readonly "service.department-categories.read.v1": ProductResponseServiceDepartmentCategoriesReadV1;
  readonly "service.snapshot.read.pos.v1": ProductResponseServiceSnapshotReadPosV1;
  readonly "service.snapshot.read.kitchen.v1": ProductResponseServiceSnapshotReadKitchenV1;
  readonly "service.snapshot.read.floor.v1": ProductResponseServiceSnapshotReadFloorV1;
  readonly "service.check-consumption-receipt.read.staff.v1": Blob;
  readonly "service.check-order-loyalty.read.staff.v1": ProductResponseServiceCheckOrderLoyaltyReadStaffV1;
  readonly "service.check-consumption-receipt.read.guest.v1": Blob;
  readonly "service.history.read.staff.v1": ProductResponseServiceHistoryReadStaffV1;
  readonly "service.history-summary.read.staff.v1": ProductResponseServiceHistorySummaryReadStaffV1;
  readonly "service.cart.item.safety.challenge.read.v1": ProductResponseServiceCartItemSafetyChallengeReadV1;
  readonly "service.snapshot.read.guest.v1": ProductResponseServiceSnapshotReadGuestV1;
  readonly "service.arrival.read.guest.v1": ProductResponseServiceArrivalReadGuestV1;
  readonly "service.waiting-room.read.v1": ProductResponseServiceWaitingRoomReadV1;
  readonly "service.history.read.guest.v1": ProductResponseServiceHistoryReadGuestV1;
  readonly "service.cash.read.v1": ProductResponseServiceCashReadV1;
  readonly "service.cash-sessions.read.v1": ProductResponseServiceCashSessionsReadV1;
  readonly "service.cash-document-archive.read.v1": ProductResponseServiceCashDocumentArchiveReadV1;
  readonly "service.cash-document-archive.file.v1": Blob;
  readonly "service.cash-document.read.v1": Blob;
  readonly "service.check-payment.read.v1": ProductResponseServiceCheckPaymentReadV1;
  readonly "service.probe.read.v1": ProductResponseServiceProbeReadV1;
  readonly "service.clock.read.v1": ProductResponseServiceClockReadV1;
  readonly "service.offline-review.read.v1": ProductResponseServiceOfflineReviewReadV1;
  readonly "relationship.external-review.franchise-summaries.get": ProductResponseRelationshipExternalReviewFranchiseSummariesGet;
  readonly "relationship.external-review.connection.get": ProductResponseRelationshipExternalReviewConnectionGet;
  readonly "relationship.external-review.list": ProductResponseRelationshipExternalReviewList;
  readonly "relationship.review-topics.read.v1": ProductResponseRelationshipReviewTopicsReadV1;
  readonly "relationship.review-stars-weekly.read.v1": ProductResponseRelationshipReviewStarsWeeklyReadV1;
  readonly "relationship.el-parte-guest-return.read.v1": ProductResponseRelationshipElParteGuestReturnReadV1;
  readonly "relationship.restaurant-reviews.list.v1": ProductResponseRelationshipRestaurantReviewsListV1;
  readonly "relationship.review.offer.read.guest.v1": ProductResponseRelationshipReviewOfferReadGuestV1;
  readonly "relationship.guest-question.read.v1": ProductResponseRelationshipGuestQuestionReadV1;
  readonly "relationship.guest-question.offer.read.guest.v1": ProductResponseRelationshipGuestQuestionOfferReadGuestV1;
  readonly "relationship.loyalty.program.admin-get": ProductResponseRelationshipLoyaltyProgramAdminGet;
  readonly "relationship.loyalty.tier-catalogue.list": ProductResponseRelationshipLoyaltyTierCatalogueList;
  readonly "relationship.loyalty.population.get": ProductResponseRelationshipLoyaltyPopulationGet;
  readonly "relationship.preferences.get": ProductResponseRelationshipPreferencesGet;
  readonly "relationship.recommendation.current.read.guest.v1": ProductResponseRelationshipRecommendationCurrentReadGuestV1;
  readonly "insights.franchise.metrics": ProductResponseInsightsFranchiseMetrics;
  readonly "insights.restaurant.period": ProductResponseInsightsRestaurantPeriod;
  readonly "insights.loyalty.period": ProductResponseInsightsLoyaltyPeriod;
  readonly "insights.restaurant.promotion-month": ProductResponseInsightsRestaurantPromotionMonth;
  readonly "insights.restaurant.flavour-profile": ProductResponseInsightsRestaurantFlavourProfile;
  readonly "parte.edition.read": ProductResponseParteEditionRead;
  readonly "parte.edition.list": ProductResponseParteEditionList;
  readonly "parte.work.read.v1": ProductResponseParteWorkReadV1;
  readonly "parte.notebook.read": ProductResponseParteNotebookRead;
  readonly "parte.pendientes.read.v1": ProductResponsePartePendientesReadV1;
  readonly "parte.costs.dishes.read.v1": ProductResponseParteCostsDishesReadV1;
  readonly "parte.costs.recipe-batch.read.v1": ProductResponseParteCostsRecipeBatchReadV1;
  readonly "parte.finanzas.daily-account.read.v1": ProductResponseParteFinanzasDailyAccountReadV1;
  readonly "parte.finanzas.number-of-today.read.v1": ProductResponseParteFinanzasNumberOfTodayReadV1;
  readonly "parte.edition-audio.read.v1": ProductResponseParteEditionAudioReadV1;
  readonly "parte.edition-audio.segment.read.v1": Blob;
  readonly "parte.push-key.read.v1": ProductResponsePartePushKeyReadV1;
  readonly "parte.pacto.read.v1": ProductResponsePartePactoReadV1;
  readonly "parte.operation.read.v1": ProductResponseParteOperationReadV1;
  readonly "parte.autonomy.read.v1": ProductResponseParteAutonomyReadV1;
  readonly "parte.hoy.read.v1": ProductResponseParteHoyReadV1;
  readonly "parte.house-memory.read.v1": ProductResponseParteHouseMemoryReadV1;
  readonly "parte.compras.call-list.read.v1": ProductResponseParteComprasCallListReadV1;
  readonly "parte.compras.prep-plan.read.v1": ProductResponseParteComprasPrepPlanReadV1;
  readonly "parte.compras.food-waste-plan.read.v1": ProductResponseParteComprasFoodWastePlanReadV1;
  readonly "parte.team.coach.read.v1": ProductResponseParteTeamCoachReadV1;
  readonly "parte.rota-proposal.read.v1": ProductResponseParteRotaProposalReadV1;
  readonly "parte.ai-audit.read.v1": ProductResponseParteAiAuditReadV1;
  readonly "parte.compliance-calendar.read.v1": ProductResponseParteComplianceCalendarReadV1;
  readonly "parte.consejo.read.v1": ProductResponseParteConsejoReadV1;
  readonly "parte.consejo-pdf.read.v1": Blob;
  readonly "parte.carta-reading.read.v1": ProductResponseParteCartaReadingReadV1;
  readonly "parte.encargos.read.v1": ProductResponseParteEncargosReadV1;
  readonly "parte.encargo.read.v1": ProductResponseParteEncargoReadV1;
  readonly "parte.page-notes.read.v1": ProductResponsePartePageNotesReadV1;
  readonly "parte.reputation.drafts.read.v1": ProductResponseParteReputationDraftsReadV1;
  readonly "parte.team.read.v1": ProductResponseParteTeamReadV1;
  readonly "parte.goals.read.v1": ProductResponseParteGoalsReadV1;
  readonly "parte.queue.read.v1": ProductResponseParteQueueReadV1;
  readonly "parte.matter.read.v1": ProductResponseParteMatterReadV1;
  readonly "parte.matters.read.v1": ProductResponseParteMattersReadV1;
  readonly "parte.advisor-library.read.v1": ProductResponseParteAdvisorLibraryReadV1;
  readonly "insights.parte-radar.read": ProductResponseInsightsParteRadarRead;
  readonly "owner-calendar.list": ProductResponseOwnerCalendarList;
  readonly "owner-calendar.history": ProductResponseOwnerCalendarHistory;
  readonly "proposal.catalog-reviewed.preparation.read": ProductResponseProposalCatalogReviewedPreparationRead;
  readonly "proposal.intent.list": ProductResponseProposalIntentList;
  readonly "proposal.intent.read": ProductResponseProposalIntentRead;
  readonly "proposal.preview": ProductResponseProposalPreview;
  readonly "billing.configuration.read": ProductResponseBillingConfigurationRead;
  readonly "billing.documents.by-check": ProductResponseBillingDocumentsByCheck;
  readonly "billing.documents.by-checks": ProductResponseBillingDocumentsByChecks;
  readonly "billing.document.read": ProductResponseBillingDocumentRead;
  readonly "billing.document.download": Blob;
  readonly "billing.intent.read": ProductResponseBillingIntentRead;
  readonly "billing.intent.download": Blob;
  readonly "billing.status.summary": ProductResponseBillingStatusSummary;
  readonly "billing.fiscal-incidents.list": ProductResponseBillingFiscalIncidentsList;
  readonly "billing.incidents.list": ProductResponseBillingIncidentsList;
  readonly "billing.export.list": ProductResponseBillingExportList;
  readonly "billing.export.download": Blob;
  readonly "billing.invoice-link.read.v1": ProductResponseBillingInvoiceLinkReadV1;
  readonly "billing.invoice-link.document.v1": Blob;
  readonly "offers.bridge.definition-put.revalidate": ProductResponseOffersBridgeDefinitionPutRevalidate;
  readonly "offers.bridge.definition-retire.revalidate": ProductResponseOffersBridgeDefinitionRetireRevalidate;
  readonly "inventory.bridge.stock-item-reconcile.revalidate": ProductResponseInventoryBridgeStockItemReconcileRevalidate;
  readonly "inventory.bridge.stock-item.revalidate": ProductResponseInventoryBridgeStockItemRevalidate;
  readonly "service.bridge.history.revalidate": ProductResponseServiceBridgeHistoryRevalidate;
  readonly "service.bridge.table-session-force-close.revalidate": ProductResponseServiceBridgeTableSessionForceCloseRevalidate;
  readonly "workforce.bridge.feedback-create.revalidate": ProductResponseWorkforceBridgeFeedbackCreateRevalidate;
  readonly "workforce.bridge.work-target-assignment-bulk-apply.revalidate": ProductResponseWorkforceBridgeWorkTargetAssignmentBulkApplyRevalidate;
  readonly "workforce.bridge.staff-notice-compose.revalidate": ProductResponseWorkforceBridgeStaffNoticeComposeRevalidate;
  readonly "catalog.bridge.draft-replace.revalidate": ProductResponseCatalogBridgeDraftReplaceRevalidate;
  readonly "catalog.bridge.media-write.revalidate": ProductResponseCatalogBridgeMediaWriteRevalidate;
  readonly "catalog.bridge.publish.revalidate": ProductResponseCatalogBridgePublishRevalidate;
  readonly "restaurant-configuration.bridge.apply.revalidate": ProductResponseRestaurantConfigurationBridgeApplyRevalidate;
  readonly "restaurant-configuration.bridge.floor.revalidate": ProductResponseRestaurantConfigurationBridgeFloorRevalidate;
  readonly "relationship.bridge.loyalty-program-put.revalidate": ProductResponseRelationshipBridgeLoyaltyProgramPutRevalidate;
}>
export type CoreReadResponseMap = Readonly<{
  readonly "GET /auth/current": IdentityResponseGETAuthCurrent;
  readonly "GET /clients/:clientId/admission": IdentityResponseGETClientsClientIdAdmission;
  readonly "GET /franchises": IdentityResponseGETFranchises;
  readonly "GET /franchises/:franchiseId": IdentityResponseGETFranchisesFranchiseId;
  readonly "GET /franchises/:franchiseId/logo": Blob;
  readonly "GET /guest/home": IdentityResponseGETGuestHome;
  readonly "GET /guest/restaurant-presentation": IdentityResponseGETGuestRestaurantPresentation;
  readonly "GET /identity-access/restaurants/:restaurantId/qr-tokens": IdentityResponseGETIdentityAccessRestaurantsRestaurantIdQrTokens;
  readonly "GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens": IdentityResponseGETIdentityAccessRestaurantsRestaurantIdTablesTableIdQrTokens;
  readonly "GET /identity/guest/auth/current": IdentityResponseGETIdentityGuestAuthCurrent;
  readonly "GET /identity/guest/qr/handoff/:handoffToken": IdentityResponseGETIdentityGuestQrHandoffHandoffToken;
  readonly "GET /identity/guest/qr/resolve/:qrId": IdentityResponseGETIdentityGuestQrResolveQrId;
  readonly "GET /me/profile": IdentityResponseGETMeProfile;
  readonly "GET /me/sessions": IdentityResponseGETMeSessions;
  readonly "GET /me/workspaces": IdentityResponseGETMeWorkspaces;
  readonly "GET /restaurants": IdentityResponseGETRestaurants;
  readonly "GET /restaurants/:restaurantId": IdentityResponseGETRestaurantsRestaurantId;
  readonly "GET /restaurants/:restaurantId/access-policy/current-grants": AccessPolicyCurrentGrantBatchEnvelope;
  readonly "GET /restaurants/:restaurantId/access-policy/directory": AccessPolicyDirectoryEnvelope;
  readonly "GET /restaurants/:restaurantId/access-policy/receipts/:receiptId": AccessPolicyReceiptEnvelope;
  readonly "GET /restaurants/:restaurantId/locations": IdentityResponseGETRestaurantsRestaurantIdLocations;
  readonly "GET /restaurants/:restaurantId/logo": Blob;
  readonly "GET /restaurants/:restaurantId/staff-invitations/:invitationId": IdentityResponseGETRestaurantsRestaurantIdStaffInvitationsInvitationId;
  readonly "GET /users/:userId/avatar": Blob;
  readonly "platformMessaging.guestRealtimeReplay.v1": PlatformMessagingRealtimeReplayResponse;
  readonly "platformMessaging.panelNoticesInbox.v1": PlatformMessagingNoticeInboxResponse;
  readonly "platformMessaging.guestNoticesPendingOverlay.v1": PlatformMessagingNoticeListResponse;
  readonly "readRestaurantConfigurationCurrent": ProductResponseReadRestaurantConfigurationCurrent;
  readonly "searchIneMunicipalities": ProductResponseSearchIneMunicipalities;
  readonly "restaurant-configuration.geocode.search.v1": ProductResponseRestaurantConfigurationGeocodeSearchV1;
  readonly "readPublishedRestaurantConfiguration": ProductResponseReadPublishedRestaurantConfiguration;
  readonly "readCatalogWorkshopCandidate": ProductResponseReadCatalogWorkshopCandidate;
  readonly "readCatalogDraft": ProductResponseReadCatalogDraft;
  readonly "readCatalogStockDeactivationWarning": ProductResponseReadCatalogStockDeactivationWarning;
  readonly "listCatalogPublications": ProductResponseListCatalogPublications;
  readonly "readCatalogPublication": ProductResponseReadCatalogPublication;
  readonly "readPublishedCatalogue": ProductResponseReadPublishedCatalogue;
  readonly "catalog.pos-operational.read.v1": ProductResponseCatalogPosOperationalReadV1;
  readonly "catalog.pos-routing.read.v1": ProductResponseCatalogPosRoutingReadV1;
  readonly "readGuestPublishedCatalogue": ProductResponseReadGuestPublishedCatalogue;
  readonly "readGuestLiveCatalogue": ProductResponseReadGuestLiveCatalogue;
  readonly "readGuestMenuDocuments": ProductResponseReadGuestMenuDocuments;
  readonly "readGuestPublishedDish": ProductResponseReadGuestPublishedDish;
  readonly "searchCatalogMasterIngredients": ProductResponseSearchCatalogMasterIngredients;
  readonly "readCatalogAiPhotoEnhancementPreview": ProductResponseReadCatalogAiPhotoEnhancementPreview;
  readonly "readCatalogAiProviderCredentialStatus": ProductResponseReadCatalogAiProviderCredentialStatus;
  readonly "readCatalogAiUsageMonth": ProductResponseReadCatalogAiUsageMonth;
  readonly "listCatalogDishNameSuggestions": ProductResponseListCatalogDishNameSuggestions;
  readonly "listCatalogDailySuggestions": ProductResponseListCatalogDailySuggestions;
  readonly "readGuestDailySuggestions": ProductResponseReadGuestDailySuggestions;
  readonly "readCatalogCartaFisica": ProductResponseReadCatalogCartaFisica;
  readonly "listCatalogDishTrials": ProductResponseListCatalogDishTrials;
  readonly "readCatalogDraftSummary": ProductResponseReadCatalogDraftSummary;
  readonly "readCatalogDraftDocument": ProductResponseReadCatalogDraftDocument;
  readonly "readCatalogReferenceDocument": ProductResponseReadCatalogReferenceDocument;
  readonly "catalog.repaired-master-holdings.read.v1": ProductResponseCatalogRepairedMasterHoldingsReadV1;
  readonly "readCatalogMediaDelivery": ProductResponseReadCatalogMediaDelivery;
  readonly "catalog.published-media.delivery.v1": ProductResponseCatalogPublishedMediaDeliveryV1;
  readonly "readCatalogMediaRenditions": ProductResponseReadCatalogMediaRenditions;
  readonly "readCatalogDraftPhotoRenditions": ProductResponseReadCatalogDraftPhotoRenditions;
  readonly "catalog.published-media.renditions.v1": ProductResponseCatalogPublishedMediaRenditionsV1;
  readonly "readGuestCatalogMediaDelivery": ProductResponseReadGuestCatalogMediaDelivery;
  readonly "offers.marketing-board.read": ProductResponseOffersMarketingBoardRead;
  readonly "offers.marketing-board.page.read": ProductResponseOffersMarketingBoardPageRead;
  readonly "offers.definition.get": ProductResponseOffersDefinitionGet;
  readonly "offers.definition.history": ProductResponseOffersDefinitionHistory;
  readonly "offers.definition.redemption-consumption.get": ProductResponseOffersDefinitionRedemptionConsumptionGet;
  readonly "offers.coupon-code.list": ProductResponseOffersCouponCodeList;
  readonly "offers.wallet.list": ProductResponseOffersWalletList;
  readonly "offers.definition.uses.list": ProductResponseOffersDefinitionUsesList;
  readonly "inventory.published-policy.read.v1": ProductResponseInventoryPublishedPolicyReadV1;
  readonly "inventory.stock-item.published-usage.list.v1": ProductResponseInventoryStockItemPublishedUsageListV1;
  readonly "inventory.stock-item.list.v1": ProductResponseInventoryStockItemListV1;
  readonly "inventory.stock-item.cost.list.v1": ProductResponseInventoryStockItemCostListV1;
  readonly "inventory.dish-costing.list.v1": ProductResponseInventoryDishCostingListV1;
  readonly "inventory.supply.list.v1": ProductResponseInventorySupplyListV1;
  readonly "inventory.purchase-document.read.v1": ProductResponseInventoryPurchaseDocumentReadV1;
  readonly "inventory.purchase-documents.list.v1": ProductResponseInventoryPurchaseDocumentsListV1;
  readonly "inventory.purchase-trace.search.v1": ProductResponseInventoryPurchaseTraceSearchV1;
  readonly "inventory.purchase-trace.export.list.v1": ProductResponseInventoryPurchaseTraceExportListV1;
  readonly "inventory.purchase-trace.export.download.v1": Blob;
  readonly "inventory.purchase-period.read.v1": ProductResponseInventoryPurchasePeriodReadV1;
  readonly "workforce.work-target-assignment.list.v1": ProductResponseWorkforceWorkTargetAssignmentListV1;
  readonly "workforce.team-on-plan.read.v1": ProductResponseWorkforceTeamOnPlanReadV1;
  readonly "workforce.employee.list.v1": ProductResponseWorkforceEmployeeListV1;
  readonly "workforce.employee.detail.read.v1": ProductResponseWorkforceEmployeeDetailReadV1;
  readonly "workforce.employee.kpi.read.v3": ProductResponseWorkforceEmployeeKpiReadV3;
  readonly "workforce.employee.feedback.read.v1": ProductResponseWorkforceEmployeeFeedbackReadV1;
  readonly "workforce.staff-notice.read.v1": ProductResponseWorkforceStaffNoticeReadV1;
  readonly "workforce.rota.read.v1": ProductResponseWorkforceRotaReadV1;
  readonly "guest.profile.get": ProductResponseGuestProfileGet;
  readonly "guest.loyalty-cards.list": ProductResponseGuestLoyaltyCardsList;
  readonly "guest.loyalty-cards.detail": ProductResponseGuestLoyaltyCardsDetail;
  readonly "guest.privacy.get": ProductResponseGuestPrivacyGet;
  readonly "guest.privacy.personalization.get": ProductResponseGuestPrivacyPersonalizationGet;
  readonly "guest.privacy.export": ProductResponseGuestPrivacyExport;
  readonly "guest.billing.documents.list": ProductResponseGuestBillingDocumentsList;
  readonly "guest.billing.session-charges.read": ProductResponseGuestBillingSessionChargesRead;
  readonly "guest.billing.document.download": Blob;
  readonly "service.table-occupancy.impacted.read.v1": ProductResponseServiceTableOccupancyImpactedReadV1;
  readonly "service.kitchen-pending-work.impacted.read.v1": ProductResponseServiceKitchenPendingWorkImpactedReadV1;
  readonly "service.fulfillment-plan.read.v1": ProductResponseServiceFulfillmentPlanReadV1;
  readonly "service.department-categories.read.v1": ProductResponseServiceDepartmentCategoriesReadV1;
  readonly "service.snapshot.read.pos.v1": ProductResponseServiceSnapshotReadPosV1;
  readonly "service.snapshot.read.kitchen.v1": ProductResponseServiceSnapshotReadKitchenV1;
  readonly "service.snapshot.read.floor.v1": ProductResponseServiceSnapshotReadFloorV1;
  readonly "service.check-consumption-receipt.read.staff.v1": Blob;
  readonly "service.check-order-loyalty.read.staff.v1": ProductResponseServiceCheckOrderLoyaltyReadStaffV1;
  readonly "service.check-consumption-receipt.read.guest.v1": Blob;
  readonly "service.history.read.staff.v1": ProductResponseServiceHistoryReadStaffV1;
  readonly "service.history-summary.read.staff.v1": ProductResponseServiceHistorySummaryReadStaffV1;
  readonly "service.cart.item.safety.challenge.read.v1": ProductResponseServiceCartItemSafetyChallengeReadV1;
  readonly "service.snapshot.read.guest.v1": ProductResponseServiceSnapshotReadGuestV1;
  readonly "service.arrival.read.guest.v1": ProductResponseServiceArrivalReadGuestV1;
  readonly "service.waiting-room.read.v1": ProductResponseServiceWaitingRoomReadV1;
  readonly "service.history.read.guest.v1": ProductResponseServiceHistoryReadGuestV1;
  readonly "service.cash.read.v1": ProductResponseServiceCashReadV1;
  readonly "service.cash-sessions.read.v1": ProductResponseServiceCashSessionsReadV1;
  readonly "service.cash-document-archive.read.v1": ProductResponseServiceCashDocumentArchiveReadV1;
  readonly "service.cash-document-archive.file.v1": Blob;
  readonly "service.cash-document.read.v1": Blob;
  readonly "service.check-payment.read.v1": ProductResponseServiceCheckPaymentReadV1;
  readonly "service.probe.read.v1": ProductResponseServiceProbeReadV1;
  readonly "service.clock.read.v1": ProductResponseServiceClockReadV1;
  readonly "service.offline-review.read.v1": ProductResponseServiceOfflineReviewReadV1;
  readonly "relationship.external-review.franchise-summaries.get": ProductResponseRelationshipExternalReviewFranchiseSummariesGet;
  readonly "relationship.external-review.connection.get": ProductResponseRelationshipExternalReviewConnectionGet;
  readonly "relationship.external-review.list": ProductResponseRelationshipExternalReviewList;
  readonly "relationship.review-topics.read.v1": ProductResponseRelationshipReviewTopicsReadV1;
  readonly "relationship.review-stars-weekly.read.v1": ProductResponseRelationshipReviewStarsWeeklyReadV1;
  readonly "relationship.el-parte-guest-return.read.v1": ProductResponseRelationshipElParteGuestReturnReadV1;
  readonly "relationship.restaurant-reviews.list.v1": ProductResponseRelationshipRestaurantReviewsListV1;
  readonly "relationship.review.offer.read.guest.v1": ProductResponseRelationshipReviewOfferReadGuestV1;
  readonly "relationship.guest-question.read.v1": ProductResponseRelationshipGuestQuestionReadV1;
  readonly "relationship.guest-question.offer.read.guest.v1": ProductResponseRelationshipGuestQuestionOfferReadGuestV1;
  readonly "relationship.loyalty.program.admin-get": ProductResponseRelationshipLoyaltyProgramAdminGet;
  readonly "relationship.loyalty.tier-catalogue.list": ProductResponseRelationshipLoyaltyTierCatalogueList;
  readonly "relationship.loyalty.population.get": ProductResponseRelationshipLoyaltyPopulationGet;
  readonly "relationship.preferences.get": ProductResponseRelationshipPreferencesGet;
  readonly "relationship.recommendation.current.read.guest.v1": ProductResponseRelationshipRecommendationCurrentReadGuestV1;
  readonly "insights.franchise.metrics": ProductResponseInsightsFranchiseMetrics;
  readonly "insights.restaurant.period": ProductResponseInsightsRestaurantPeriod;
  readonly "insights.loyalty.period": ProductResponseInsightsLoyaltyPeriod;
  readonly "insights.restaurant.promotion-month": ProductResponseInsightsRestaurantPromotionMonth;
  readonly "insights.restaurant.flavour-profile": ProductResponseInsightsRestaurantFlavourProfile;
  readonly "parte.edition.read": ProductResponseParteEditionRead;
  readonly "parte.edition.list": ProductResponseParteEditionList;
  readonly "parte.work.read.v1": ProductResponseParteWorkReadV1;
  readonly "parte.notebook.read": ProductResponseParteNotebookRead;
  readonly "parte.pendientes.read.v1": ProductResponsePartePendientesReadV1;
  readonly "parte.costs.dishes.read.v1": ProductResponseParteCostsDishesReadV1;
  readonly "parte.costs.recipe-batch.read.v1": ProductResponseParteCostsRecipeBatchReadV1;
  readonly "parte.finanzas.daily-account.read.v1": ProductResponseParteFinanzasDailyAccountReadV1;
  readonly "parte.finanzas.number-of-today.read.v1": ProductResponseParteFinanzasNumberOfTodayReadV1;
  readonly "parte.edition-audio.read.v1": ProductResponseParteEditionAudioReadV1;
  readonly "parte.edition-audio.segment.read.v1": Blob;
  readonly "parte.push-key.read.v1": ProductResponsePartePushKeyReadV1;
  readonly "parte.pacto.read.v1": ProductResponsePartePactoReadV1;
  readonly "parte.operation.read.v1": ProductResponseParteOperationReadV1;
  readonly "parte.autonomy.read.v1": ProductResponseParteAutonomyReadV1;
  readonly "parte.hoy.read.v1": ProductResponseParteHoyReadV1;
  readonly "parte.house-memory.read.v1": ProductResponseParteHouseMemoryReadV1;
  readonly "parte.compras.call-list.read.v1": ProductResponseParteComprasCallListReadV1;
  readonly "parte.compras.prep-plan.read.v1": ProductResponseParteComprasPrepPlanReadV1;
  readonly "parte.compras.food-waste-plan.read.v1": ProductResponseParteComprasFoodWastePlanReadV1;
  readonly "parte.team.coach.read.v1": ProductResponseParteTeamCoachReadV1;
  readonly "parte.rota-proposal.read.v1": ProductResponseParteRotaProposalReadV1;
  readonly "parte.ai-audit.read.v1": ProductResponseParteAiAuditReadV1;
  readonly "parte.compliance-calendar.read.v1": ProductResponseParteComplianceCalendarReadV1;
  readonly "parte.consejo.read.v1": ProductResponseParteConsejoReadV1;
  readonly "parte.consejo-pdf.read.v1": Blob;
  readonly "parte.carta-reading.read.v1": ProductResponseParteCartaReadingReadV1;
  readonly "parte.encargos.read.v1": ProductResponseParteEncargosReadV1;
  readonly "parte.encargo.read.v1": ProductResponseParteEncargoReadV1;
  readonly "parte.page-notes.read.v1": ProductResponsePartePageNotesReadV1;
  readonly "parte.reputation.drafts.read.v1": ProductResponseParteReputationDraftsReadV1;
  readonly "parte.team.read.v1": ProductResponseParteTeamReadV1;
  readonly "parte.goals.read.v1": ProductResponseParteGoalsReadV1;
  readonly "parte.queue.read.v1": ProductResponseParteQueueReadV1;
  readonly "parte.matter.read.v1": ProductResponseParteMatterReadV1;
  readonly "parte.matters.read.v1": ProductResponseParteMattersReadV1;
  readonly "parte.advisor-library.read.v1": ProductResponseParteAdvisorLibraryReadV1;
  readonly "insights.parte-radar.read": ProductResponseInsightsParteRadarRead;
  readonly "owner-calendar.list": ProductResponseOwnerCalendarList;
  readonly "owner-calendar.history": ProductResponseOwnerCalendarHistory;
  readonly "proposal.catalog-reviewed.preparation.read": ProductResponseProposalCatalogReviewedPreparationRead;
  readonly "proposal.intent.list": ProductResponseProposalIntentList;
  readonly "proposal.intent.read": ProductResponseProposalIntentRead;
  readonly "proposal.preview": ProductResponseProposalPreview;
  readonly "billing.configuration.read": ProductResponseBillingConfigurationRead;
  readonly "billing.documents.by-check": ProductResponseBillingDocumentsByCheck;
  readonly "billing.documents.by-checks": ProductResponseBillingDocumentsByChecks;
  readonly "billing.document.read": ProductResponseBillingDocumentRead;
  readonly "billing.document.download": Blob;
  readonly "billing.intent.read": ProductResponseBillingIntentRead;
  readonly "billing.intent.download": Blob;
  readonly "billing.status.summary": ProductResponseBillingStatusSummary;
  readonly "billing.fiscal-incidents.list": ProductResponseBillingFiscalIncidentsList;
  readonly "billing.incidents.list": ProductResponseBillingIncidentsList;
  readonly "billing.export.list": ProductResponseBillingExportList;
  readonly "billing.export.download": Blob;
  readonly "billing.invoice-link.read.v1": ProductResponseBillingInvoiceLinkReadV1;
  readonly "billing.invoice-link.document.v1": Blob;
  readonly "offers.bridge.definition-put.revalidate": ProductResponseOffersBridgeDefinitionPutRevalidate;
  readonly "offers.bridge.definition-retire.revalidate": ProductResponseOffersBridgeDefinitionRetireRevalidate;
  readonly "inventory.bridge.stock-item-reconcile.revalidate": ProductResponseInventoryBridgeStockItemReconcileRevalidate;
  readonly "inventory.bridge.stock-item.revalidate": ProductResponseInventoryBridgeStockItemRevalidate;
  readonly "service.bridge.history.revalidate": ProductResponseServiceBridgeHistoryRevalidate;
  readonly "service.bridge.table-session-force-close.revalidate": ProductResponseServiceBridgeTableSessionForceCloseRevalidate;
  readonly "workforce.bridge.feedback-create.revalidate": ProductResponseWorkforceBridgeFeedbackCreateRevalidate;
  readonly "workforce.bridge.work-target-assignment-bulk-apply.revalidate": ProductResponseWorkforceBridgeWorkTargetAssignmentBulkApplyRevalidate;
  readonly "workforce.bridge.staff-notice-compose.revalidate": ProductResponseWorkforceBridgeStaffNoticeComposeRevalidate;
  readonly "catalog.bridge.draft-replace.revalidate": ProductResponseCatalogBridgeDraftReplaceRevalidate;
  readonly "catalog.bridge.media-write.revalidate": ProductResponseCatalogBridgeMediaWriteRevalidate;
  readonly "catalog.bridge.publish.revalidate": ProductResponseCatalogBridgePublishRevalidate;
  readonly "restaurant-configuration.bridge.apply.revalidate": ProductResponseRestaurantConfigurationBridgeApplyRevalidate;
  readonly "restaurant-configuration.bridge.floor.revalidate": ProductResponseRestaurantConfigurationBridgeFloorRevalidate;
  readonly "relationship.bridge.loyalty-program-put.revalidate": ProductResponseRelationshipBridgeLoyaltyProgramPutRevalidate;
}>
export type CoreExactMutation =
  | Readonly<{ operation: "POST /auth/2fa/delete-secret"; params: Readonly<Record<never, never>>; body: IdentityRequestStaff2faDeleteSecret; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "POST /auth/2fa/disable"; params: Readonly<Record<never, never>>; body: IdentityRequestStaff2faDisable; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "POST /auth/2fa/enable"; params: Readonly<Record<never, never>>; body: IdentityRequestStaff2faEnable; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "POST /auth/2fa/generate"; params: Readonly<Record<never, never>>; body: IdentityRequestStaff2faGenerate; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "POST /auth/employee-invitations/claim"; params: Readonly<Record<never, never>>; body: IdentityRequestEmployeeInvitationClaim; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /auth/employee-invitations/recover"; params: Readonly<Record<never, never>>; body: IdentityRequestEmployeeInvitationRecover; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /auth/login"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffLogin; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /auth/login/memberships"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffLoginMembershipSelectionRead; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /auth/login/memberships/select"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffLoginMembershipSelectionComplete; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /auth/logout"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffLogout; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /auth/renew"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffRenew; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "DELETE /clients/:clientId/block"; params: Readonly<{ readonly clientId: string }>; body: IdentityRequestGuestAdmissionBlockLift; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /clients/:clientId/block"; params: Readonly<{ readonly clientId: string }>; body: IdentityRequestGuestAdmissionBlock; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "DELETE /clients/:clientId/notice"; params: Readonly<{ readonly clientId: string }>; body: IdentityRequestGuestAdmissionNoticeClear; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /clients/:clientId/notice"; params: Readonly<{ readonly clientId: string }>; body: IdentityRequestGuestAdmissionNotice; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /franchises"; params: Readonly<Record<never, never>>; body: IdentityRequestFranchiseCreate; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "DELETE /franchises/:franchiseId"; params: Readonly<{ readonly franchiseId: string }>; body: IdentityRequestFranchiseDelete; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "PUT /franchises/:franchiseId"; params: Readonly<{ readonly franchiseId: string }>; body: IdentityRequestFranchiseUpdateById; query?: CoreQuery; idempotencyKey: string; files?: Readonly<{ readonly logo_url?: Blob }>; expectedVersion: number }>
  | Readonly<{ operation: "POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access"; params: Readonly<{ readonly franchiseId: string; readonly directorId: string }>; body: IdentityRequestStaffCredentialRecoverFranchiseDirector; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "PUT /franchises/:franchiseId/reactivate"; params: Readonly<{ readonly franchiseId: string }>; body: IdentityRequestFranchiseReactivate; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace"; params: Readonly<{ readonly restaurantId: string; readonly tokenId: string }>; body: IdentityRequestQrTableTokenReplace; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /identity-access/restaurants/:restaurantId/qr-tokens/prints"; params: Readonly<{ readonly restaurantId: string }>; body: IdentityRequestQrTableTokenPrint; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "POST /identity/guest/account/save"; params: Readonly<Record<never, never>>; body: IdentityRequestGuestAccountSave; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /identity/guest/auth/forget"; params: Readonly<Record<never, never>>; body: IdentityRequestGuestForget; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /identity/guest/entry"; params: Readonly<Record<never, never>>; body: IdentityRequestGuestEntry; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /identity/guest/entry/start-order"; params: Readonly<Record<never, never>>; body: IdentityRequestGuestStartOrder; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /identity/guest/passkey/challenge"; params: Readonly<Record<never, never>>; body: IdentityRequestGuestPasskeyChallenge; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /identity/guest/passkey/recover"; params: Readonly<Record<never, never>>; body: IdentityRequestGuestPasskeyRecover; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /identity/guest/passkey/save"; params: Readonly<Record<never, never>>; body: IdentityRequestGuestPasskeySave; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "POST /me/credential"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffSelfCredentialUpdate; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "PUT /me/profile"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffSelfProfileUpdate; query?: CoreQuery; idempotencyKey: string; files?: Readonly<{ readonly avatar?: Blob }>; expectedVersion: number }>
  | Readonly<{ operation: "DELETE /me/sessions/:sessionId"; params: Readonly<{ readonly sessionId: string }>; body: IdentityRequestStaffSessionRevoke; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /me/sessions/revoke-all"; params: Readonly<Record<never, never>>; body: IdentityRequestStaffSessionsRevokeAll; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "POST /restaurants"; params: Readonly<Record<never, never>>; body: IdentityRequestRestaurantCreate; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "DELETE /restaurants/:restaurantId"; params: Readonly<{ readonly restaurantId: string }>; body: IdentityRequestRestaurantDelete; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "PUT /restaurants/:restaurantId"; params: Readonly<{ readonly restaurantId: string }>; body: IdentityRequestRestaurantUpdate; query?: CoreQuery; idempotencyKey: string; files?: Readonly<{ readonly logo?: Blob }>; expectedVersion: number }>
  | Readonly<{ operation: "POST /restaurants/:restaurantId/access-policy/restore"; params: Readonly<{ readonly restaurantId: string }>; body: RestoreAccessPolicyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /restaurants/:restaurantId/access-policy/restore/validate"; params: Readonly<{ readonly restaurantId: string }>; body: ValidateAccessPolicyRestoreRequest; query?: CoreQuery; idempotencyKey?: string; expectedVersion: number }>
  | Readonly<{ operation: "PUT /restaurants/:restaurantId/managers/:managerId/email"; params: Readonly<{ readonly restaurantId: string; readonly managerId: string }>; body: IdentityRequestFranchiseManagerEmailUpdate; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "PUT /restaurants/:restaurantId/reactivate"; params: Readonly<{ readonly restaurantId: string }>; body: IdentityRequestRestaurantReactivate; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue"; params: Readonly<{ readonly restaurantId: string; readonly invitationId: string }>; body: IdentityRequestStaffInvitationAdminReissue; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome"; params: Readonly<{ readonly restaurantId: string; readonly invitationId: string }>; body: IdentityRequestStaffInvitationAdminResolveDeliveryOutcome; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke"; params: Readonly<{ readonly restaurantId: string; readonly invitationId: string }>; body: IdentityRequestStaffInvitationAdminRevoke; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "POST /restaurants/:restaurantId/staff-invitations/recover"; params: Readonly<{ readonly restaurantId: string }>; body: IdentityRequestStaffInvitationAdminRecoverScopedManager; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "platformMessaging.panelNoticeSeen.v1"; params: Readonly<{ readonly noticeId: string }>; body: PlatformMessagingNoticeReceiptRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "platformMessaging.panelNoticeRead.v1"; params: Readonly<{ readonly noticeId: string }>; body: PlatformMessagingNoticeReceiptRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "platformMessaging.panelNoticeDismiss.v1"; params: Readonly<{ readonly noticeId: string }>; body: PlatformMessagingNoticeReceiptRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "platformMessaging.guestNoticeSeen.v1"; params: Readonly<{ readonly noticeId: string }>; body: PlatformMessagingNoticeReceiptRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "platformMessaging.guestNoticeDismiss.v1"; params: Readonly<{ readonly noticeId: string }>; body: PlatformMessagingNoticeReceiptRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "applyRestaurantConfiguration"; params: Readonly<{ readonly restaurantId: string }>; body: ApplyRestaurantConfigurationRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.stock-policy.set.v1"; params: Readonly<{ readonly restaurantId: string }>; body: SetInventoryStockPolicyRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "evaluateCatalogWorkshopIdea"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogWorkshopEvaluateRequest; query?: CoreQuery; idempotencyKey?: string; expectedVersion: number }>
  | Readonly<{ operation: "recordCatalogWorkshopTrial"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogWorkshopTrialRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "saveCatalogWorkshopCandidate"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogWorkshopSaveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "validateCatalogDraft"; params: Readonly<{ readonly restaurantId: string }>; body: Readonly<Record<never, never>>; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "publishCatalog"; params: Readonly<{ readonly restaurantId: string }>; body: PublishCatalogRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "readPreauthenticatedGuestCatalogue"; params: Readonly<{ readonly restaurantId: string }>; body: ReadPreauthenticatedFeaturedCatalogRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "readPreauthenticatedFeaturedCatalog"; params: Readonly<{ readonly restaurantId: string }>; body: ReadPreauthenticatedFeaturedCatalogRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "readPreauthenticatedCatalogMediaDelivery"; params: Readonly<{ readonly restaurantId: string; readonly mediaId: string }>; body: CatalogPreauthenticatedMediaDeliveryRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "materializeCatalogMasterIngredient"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogMasterIngredientMaterializationRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "previewCatalogDishDerivation"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogDishDerivationPreviewRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "applyCatalogDishProposal"; params: Readonly<{ readonly restaurantId: string; readonly proposalId: string }>; body: CatalogDishProposalApplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "proposeCatalogAiDishCopy"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogAiDishCopyProposalRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "autocompleteCatalogDishIngredients"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogIngredientAutocompleteRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "proposeCatalogAiTranslation"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogAiTranslationProposalRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "proposeCatalogAiPhotoEnhancement"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogAiPhotoEnhancementProposalRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "setCatalogAiProviderCredential"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogAiProviderCredentialSetRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "deleteCatalogAiProviderCredential"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogAiProviderCredentialDeleteRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "reviewCatalogDishCopy"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogDishCopyReviewRequest; query?: CoreQuery; idempotencyKey?: string; expectedVersion: number }>
  | Readonly<{ operation: "applyCatalogDishCopy"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogDishCopyApplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "undoCatalogDishCopy"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogDishCopyUndoRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "applyCatalogDishNameSuggestion"; params: Readonly<{ readonly restaurantId: string; readonly suggestionId: string }>; body: CatalogDishNameApplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "undoCatalogDishNameSuggestion"; params: Readonly<{ readonly restaurantId: string; readonly suggestionId: string }>; body: CatalogDishNameUndoRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "setCatalogDailySuggestion"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogDailySuggestionSetRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "withdrawCatalogDailySuggestion"; params: Readonly<{ readonly restaurantId: string; readonly suggestionId: string }>; body: CatalogDailySuggestionWithdrawRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "previewCatalogCartaFisica"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogCartaFisicaPreviewRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "renderCatalogCartaFisicaDocument"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogCartaFisicaDocumentRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "answerCatalogDishTrial"; params: Readonly<{ readonly restaurantId: string; readonly trialId: string }>; body: CatalogDishTrialAnswerRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "undoCatalogCartaChange"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogCartaChangeUndoRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "refreshCatalogDraft"; params: Readonly<{ readonly restaurantId: string }>; body: Readonly<Record<never, never>>; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "patchCatalogDraftEntities"; params: Readonly<{ readonly restaurantId: string }>; body: PatchCatalogDraftEntitiesRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "restoreCatalogDraftFromPublication"; params: Readonly<{ readonly restaurantId: string }>; body: RestoreCatalogDraftFromPublicationRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "reviewCatalogPhotoCorrection"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogPhotoCorrectionReviewRequest; query?: CoreQuery; idempotencyKey?: string; expectedVersion: number }>
  | Readonly<{ operation: "applyCatalogPhotoCorrection"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogPhotoCorrectionApplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "undoCatalogPhotoCorrection"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogPhotoCorrectionUndoRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "uploadCatalogPhoto"; params: Readonly<{ readonly restaurantId: string }>; body: UploadCatalogPhotoRequest; query?: CoreQuery; idempotencyKey: string; files?: Readonly<{ readonly photo?: Blob }> }>
  | Readonly<{ operation: "abandonCatalogMediaProvisionals"; params: Readonly<{ readonly restaurantId: string }>; body: AbandonCatalogMediaProvisionalsRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "offers.definition.marketing-replay"; params: Readonly<Record<never, never>>; body: ReplayOfferDefinitionRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "offers.definition.put"; params: Readonly<{ readonly definitionId: string }>; body: PutOfferDefinitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "offers.definition.archive"; params: Readonly<{ readonly definitionId: string }>; body: ArchiveOfferDefinitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "offers.definition.recall-coupons"; params: Readonly<{ readonly definitionId: string }>; body: RecallOfferCouponsRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "offers.definition.retire"; params: Readonly<{ readonly definitionId: string }>; body: RetireOfferDefinitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "offers.definition.reopen"; params: Readonly<{ readonly definitionId: string }>; body: ReopenOfferDefinitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "offers.coupon-code.issue"; params: Readonly<Record<never, never>>; body: IssueOfferCouponCodeRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "offers.coupon-code.cancel"; params: Readonly<{ readonly codeId: string }>; body: CancelOfferCouponCodeRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "inventory.stock-item.reconcile.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: ReconcileInventoryStockItemRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.stock-item.availability-reactivate.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: ReactivateInventoryStockItemAvailabilityRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.stock-item.retire.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: RetireInventoryResourceRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.stock-item.cost.record.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: RecordInventoryStockItemCostRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.stock-item.yield.record.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: RecordInventoryStockItemYieldRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.recipe-costing.preview.v1"; params: Readonly<{ readonly restaurantId: string }>; body: InventoryRecipeCostingRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "inventory.supplier.create.v1"; params: Readonly<{ readonly restaurantId: string }>; body: CreateInventorySupplierRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "inventory.supplier.update.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: UpdateInventorySupplierRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.stock-item.supply.set.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: SetInventoryStockItemSupplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-document.upload.v1"; params: Readonly<{ readonly restaurantId: string }>; body: InventoryPurchasePageUploadRequest; query?: CoreQuery; idempotencyKey: string; files?: Readonly<{ readonly page?: Blob }> }>
  | Readonly<{ operation: "inventory.purchase-document.line.answer.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: InventoryPurchaseLineAnswerRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-document.line.measure.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: InventoryPurchaseLineMeasureRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-document.undo.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: InventoryPurchaseDocumentUndoRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-document.figure.validate.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: InventoryPurchaseFigureValidateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-document.same-delivery.answer.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: InventoryPurchaseSameDeliveryAnswerRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-document.arrival.answer.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: InventoryPurchaseArrivalAnswerRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-document.keep-apart.v1"; params: Readonly<{ readonly restaurantId: string; readonly resourceId: string }>; body: InventoryPurchaseKeepApartRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-settings.set.v1"; params: Readonly<{ readonly restaurantId: string }>; body: InventoryPurchaseSettingsRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "inventory.purchase-trace.export.prepare.v1"; params: Readonly<{ readonly restaurantId: string }>; body: InventoryPurchaseTraceExportPrepareRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.operational-session.enter.kitchen.v2"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceOperationalSessionEnterRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.operational-session.enter.floor.v2"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceOperationalSessionEnterRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.work-target-assignment.bulk-apply.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceWorkTargetAssignmentBulkApplyRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.work-target-assignment.assign.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceWorkTargetAssignmentAssignRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "workforce.employee.access.recover.v1"; params: Readonly<{ readonly restaurantId: string; readonly employeeId: string }>; body: WorkforceEmployeeAccessRecoveryRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.employee.picture.set.v1"; params: Readonly<{ readonly restaurantId: string; readonly employeeId: string }>; body: WorkforceEmployeePictureSetRequest; query?: CoreQuery; idempotencyKey: string; files?: Readonly<{ readonly photo?: Blob }> }>
  | Readonly<{ operation: "workforce.employment.register.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceEmploymentRegisterRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.employment.update.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceEmploymentUpdateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "workforce.employment.suspend.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceEmploymentSuspendRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "workforce.employment.restore.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceEmploymentRestoreRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "workforce.employment.end.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceEmploymentEndRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "workforce.eligibility.set.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceEligibilitySetRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.operational-session.enter.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceOperationalSessionEnterRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.operational-presence.renew.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceOperationalPresenceRenewRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.feedback.create.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceFeedbackCreateRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.feedback.acknowledge.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceFeedbackAcknowledgeRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "workforce.staff-notice.compose.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceStaffNoticeComposeRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.staff-notice.withdraw.v1"; params: Readonly<{ readonly restaurantId: string; readonly noticeId: string }>; body: WorkforceStaffNoticeWithdrawRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "workforce.rota.publish.v1"; params: Readonly<{ readonly restaurantId: string }>; body: WorkforceRotaPublishRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "guest.profile.update"; params: Readonly<Record<never, never>>; body: UpdateGuestProfileRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "guest.diagnostics.record"; params: Readonly<Record<never, never>>; body: RecordGuestDiagnosticsRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "guest.identity.suggest"; params: Readonly<Record<never, never>>; body: GuestIdentitySuggestionRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "guest.privacy.replace-consent"; params: Readonly<Record<never, never>>; body: ReplaceGuestConsentRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "guest.privacy.replace-personalization"; params: Readonly<Record<never, never>>; body: ReplaceGuestPersonalizationSettingRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "guest.privacy.erase-derived"; params: Readonly<Record<never, never>>; body: EraseGuestPrivacyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "guest.privacy.erase-account"; params: Readonly<Record<never, never>>; body: EraseGuestAccountRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.check-charge-plan.read.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckChargePlanRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "service.check-refund.preview.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckRefundPreviewRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "service.refund.record.v3"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckRefundRecordRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.offline-segment.record.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOfflineSegmentRecordRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.fulfillment.transition.kitchen.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceFulfillmentTransitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.manager.fulfillment.transition.kitchen.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceManagerFulfillmentTransitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.fulfillment.remake.kitchen.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceFulfillmentRemakeRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.fulfillment.transition.floor.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceFulfillmentTransitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.manager.fulfillment.transition.floor.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceManagerFulfillmentTransitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.fulfillment.deliver-batch.floor.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceFulfillmentDeliverBatchRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.manager.fulfillment.deliver-batch.floor.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceManagerFulfillmentDeliverBatchRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.bill-request.accept.floor.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceBillRequestAcceptRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.table-session.nobody-here.floor.v2"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceTableSessionNobodyHereRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.participant.join.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceParticipantJoinRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.participant.request-bill.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceParticipantRequestBillRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.open.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartOpenRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.item.add.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemAddRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.item.copy.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemCopyRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.item.steal.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemStealRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.item.steal.undo.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemStealUndoRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cart.item.safety.acknowledge.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemSafetyAcknowledgeRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cart.item.update.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemUpdateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cart.item.remove.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemRemoveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.diner.offer.choose.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceDinerOfferChooseRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.diner.offer.remove.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceDinerOfferRemoveRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.waiting-room.enter.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceWaitingRoomEnterRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.waiting-room.leave.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceWaitingRoomLeaveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.order.submit.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderSubmitRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.order.item.add.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderItemAddRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.order.item.update.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderItemUpdateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.order.item.remove.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderItemRemoveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.table-session.open.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceTableSessionOpenRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.table-session.party-size.set.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceTableSessionPartySizeSetRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.table-session.close.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceTableSessionCloseRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.bill-request.accept.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceBillRequestAcceptRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.bill-request.reopen.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceBillRequestReopenRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.table-session.force-close.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceTableSessionForceCloseRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.force-close.reclassify.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceForceCloseReclassifyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.participant.create.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceParticipantCreateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cart.open.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartOpenRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.item.add.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemAddStaffRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.item.update.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemUpdateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cart.item.remove.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartItemRemoveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.diner.offer.choose.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceDinerOfferChooseRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.diner.offer.remove.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceDinerOfferRemoveRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cart.discard.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCartDiscardRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.order.submit.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderSubmitStaffRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.order.item.update.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderItemUpdateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.order.item.remove.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderItemRemoveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.order.cancel.staff.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderCancelRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.fulfillment.transition.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceFulfillmentTransitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.fulfillment.remake.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceFulfillmentRemakeRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.fulfillment.deliver-batch.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceFulfillmentDeliverBatchRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.manager.fulfillment.transition.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceManagerFulfillmentTransitionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.manager.fulfillment.deliver-batch.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceManagerFulfillmentDeliverBatchRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.check.finalize.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckFinalizeRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.check.charge.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckChargeRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.check.charge.reverse.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckChargeReverseRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.check.line.waive.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckLineWaiveRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.check.split.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCheckSplitRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cash.movement.record.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCashMovementRecordRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cash.session.open.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCashSessionOpenRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.cash.movement.void.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCashMovementVoidRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cash.session.close.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCashSessionCloseRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cash.session.count.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCashSessionCountRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.cash.payment-method.correct.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceCashPaymentMethodCorrectRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.order.confirm.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOrderConfirmRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "service.table-session.nobody-here.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceTableSessionNobodyHereRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.qr-orders.pause.set.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceQrOrdersPauseSetRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "service.offline-review.resolve.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ServiceOfflineReviewResolveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.external-review.connection.start"; params: Readonly<Record<never, never>>; body: StartRelationshipGoogleConnectionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.external-review.connection.complete"; params: Readonly<Record<never, never>>; body: CompleteRelationshipGoogleConnectionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.external-review.connection.select"; params: Readonly<Record<never, never>>; body: SelectRelationshipGoogleLocationRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.external-review.connection.disconnect"; params: Readonly<Record<never, never>>; body: DisconnectRelationshipGoogleConnectionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.external_review.reply"; params: Readonly<{ readonly reviewId: string }>; body: ReplyRelationshipExternalReviewRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.external_review.reply.delete"; params: Readonly<{ readonly reviewId: string }>; body: DeleteRelationshipExternalReviewReplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.external_review.reply.publish"; params: Readonly<{ readonly reviewId: string }>; body: PublishRelationshipExternalReviewReplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.external_review.reply.undo"; params: Readonly<{ readonly reviewId: string }>; body: UndoRelationshipExternalReviewReplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.guest-question.put.v1"; params: Readonly<Record<never, never>>; body: PutRelationshipGuestQuestionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.guest-question.remove.v1"; params: Readonly<Record<never, never>>; body: RemoveRelationshipGuestQuestionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.guest-question.answer.guest.v1"; params: Readonly<Record<never, never>>; body: AnswerRelationshipGuestQuestionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.review.submit"; params: Readonly<Record<never, never>>; body: SubmitRelationshipReviewRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.loyalty.program.put"; params: Readonly<Record<never, never>>; body: PutRelationshipLoyaltyProgramRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.loyalty.program.retire"; params: Readonly<Record<never, never>>; body: RetireRelationshipLoyaltyProgramRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.preferences.replace"; params: Readonly<Record<never, never>>; body: ReplaceRelationshipPreferencesRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "relationship.recommendation.assign"; params: Readonly<Record<never, never>>; body: AssignRelationshipRecommendationRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.impression.record"; params: Readonly<Record<never, never>>; body: RecordRelationshipRecommendationImpressionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "relationship.feedback.record"; params: Readonly<Record<never, never>>; body: RecordRelationshipFeedbackRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.pendiente.dismiss.v1"; params: Readonly<{ readonly restaurantId: string; readonly pendienteId: string }>; body: PartePendienteDismissRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.costs.recipe-batch.confirm.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteRecipeBatchConfirmRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.costs.recipe-batch.withdraw.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteRecipeBatchWithdrawRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.costs.recipe-batch.undo.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteRecipeBatchUndoRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.costs.recipe-batch.correct.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteRecipeBatchCorrectRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.finanzas.fixed-costs.declare.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteFixedCostsDeclareRequest; query?: CoreQuery; idempotencyKey?: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.finanzas.labour-averages.declare.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteLabourAveragesDeclareRequest; query?: CoreQuery; idempotencyKey?: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.voice-answer.submit.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteVoiceAnswerSubmitRequest; query?: CoreQuery; idempotencyKey: string; files?: Readonly<{ readonly audio?: Blob }> }>
  | Readonly<{ operation: "parte.push-subscription.register.v1"; params: Readonly<{ readonly restaurantId: string }>; body: PartePushSubscriptionRegisterRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.push-subscription.remove.v1"; params: Readonly<{ readonly restaurantId: string; readonly subscriptionId: string }>; body: PartePushSubscriptionRemoveRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.pacto.line.put.v1"; params: Readonly<{ readonly restaurantId: string }>; body: PartePactoLinePutRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.pacto.line.confirm.v1"; params: Readonly<{ readonly restaurantId: string }>; body: PartePactoLineConfirmRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.pacto.line.retire.v1"; params: Readonly<{ readonly restaurantId: string }>; body: PartePactoLineRetireRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.team-stop.set.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteTeamStopSetRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.operation.approve.v1"; params: Readonly<{ readonly restaurantId: string; readonly operationId: string }>; body: ParteOperationApproveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.operation.decline.v1"; params: Readonly<{ readonly restaurantId: string; readonly operationId: string }>; body: ParteOperationDeclineRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.operation.resolve.v1"; params: Readonly<{ readonly restaurantId: string; readonly operationId: string }>; body: ParteOperationResolveRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.scheduled-action.stop.v1"; params: Readonly<{ readonly restaurantId: string; readonly actionId: string }>; body: ParteScheduledActionStopRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.team-action.undo.v1"; params: Readonly<{ readonly restaurantId: string; readonly actionId: string }>; body: ParteTeamActionUndoRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.work.act.v1"; params: Readonly<{ readonly restaurantId: string; readonly itemId: string }>; body: ParteWorkActRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.autonomy.offer.answer.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteAutonomyOfferAnswerRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.compras.food-waste-plan.adopt.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteFoodWastePlanAdoptRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.compras.food-waste-plan.update.decline.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteFoodWastePlanUpdateDeclineRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.team.coach.note.share.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteCoachShareRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.missing-data.answer.v1"; params: Readonly<{ readonly restaurantId: string; readonly questionId: string }>; body: ParteMissingDataAnswerRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.carta-reading.correct.v1"; params: Readonly<{ readonly restaurantId: string; readonly categoryId: string }>; body: ParteCartaReadingCorrectRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.encargo.create.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteEncargoCreateRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.reputation.reply-draft.set-aside.v1"; params: Readonly<{ readonly restaurantId: string; readonly reviewId: string }>; body: ParteReplyDraftSetAsideRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.reputation.post-draft.use.v1"; params: Readonly<{ readonly restaurantId: string; readonly draftId: string }>; body: PartePostDraftDecisionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.reputation.post-draft.withdraw.v1"; params: Readonly<{ readonly restaurantId: string; readonly draftId: string }>; body: PartePostDraftDecisionRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.what-if.dish-price.read.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteWhatIfDishPriceRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "parte.what-if.closed-weekday.read.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteWhatIfClosedWeekdayRequest; query?: CoreQuery; idempotencyKey?: string }>
  | Readonly<{ operation: "parte.goal.say.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteGoalSayRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.goal.confirm.v1"; params: Readonly<{ readonly restaurantId: string; readonly goalId: string }>; body: ParteGoalConfirmRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.goal.correct.v1"; params: Readonly<{ readonly restaurantId: string; readonly goalId: string }>; body: ParteGoalCorrectRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.goal.decline.v1"; params: Readonly<{ readonly restaurantId: string; readonly goalId: string }>; body: ParteGoalDeclineRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.goal.withdraw.v1"; params: Readonly<{ readonly restaurantId: string; readonly goalId: string }>; body: ParteGoalWithdrawRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.queue.answer.v1"; params: Readonly<{ readonly restaurantId: string; readonly itemId: string }>; body: ParteQueueAnswerRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.request.open.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteRequestOpenRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "parte.advisor-library.review.v1"; params: Readonly<{ readonly restaurantId: string }>; body: ParteAdvisorLibraryReviewRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "parte.person.withdraw"; params: Readonly<{ readonly restaurantId: string }>; body: PartePersonWithdrawalRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "owner-calendar.put"; params: Readonly<{ readonly restaurantId: string; readonly declarationId: string }>; body: OwnerCalendarPutRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "owner-calendar.cancel"; params: Readonly<{ readonly restaurantId: string; readonly declarationId: string }>; body: OwnerCalendarCancelRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "proposal.catalog-reviewed.prepare"; params: Readonly<{ readonly restaurantId: string }>; body: CatalogReviewedPrepareRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "proposal.confirm"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; body: ProposalConfirmRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "proposal.decline"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; body: ProposalDeclineRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "proposal.undo"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; body: ProposalUndoRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.configuration.apply"; params: Readonly<{ readonly restaurantId: string }>; body: BillingConfigurationApplyRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "billing.provider.connect"; params: Readonly<{ readonly restaurantId: string }>; body: BillingProviderConnectRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.provider.disconnect"; params: Readonly<{ readonly restaurantId: string }>; body: Readonly<Record<never, never>>; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.activate"; params: Readonly<{ readonly restaurantId: string }>; body: BillingActivateRequest; query?: CoreQuery; idempotencyKey: string; expectedVersion: number }>
  | Readonly<{ operation: "billing.request.create"; params: Readonly<{ readonly restaurantId: string }>; body: BillingRequestCreateRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.intent.retry"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; body: BillingIntentActionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.intent.void"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; body: BillingIntentActionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.document.render"; params: Readonly<{ readonly restaurantId: string; readonly documentId: string }>; body: BillingIntentActionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.fiscal-incident.record"; params: Readonly<{ readonly restaurantId: string }>; body: BillingFiscalIncidentRecordRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.fiscal-incident.move"; params: Readonly<{ readonly restaurantId: string; readonly incidentId: string }>; body: BillingFiscalIncidentMoveRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.document.legible-copy"; params: Readonly<{ readonly restaurantId: string; readonly documentId: string }>; body: BillingLegibleCopyRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.issuer-succession.record"; params: Readonly<{ readonly restaurantId: string }>; body: BillingIssuerSuccessionRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.intent.complete"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; body: BillingIntentCompleteRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.intent.reissue"; params: Readonly<{ readonly restaurantId: string; readonly intentId: string }>; body: BillingIntentReissueRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.export.prepare"; params: Readonly<{ readonly restaurantId: string }>; body: BillingExportPrepareRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.offline-intents.release"; params: Readonly<{ readonly restaurantId: string }>; body: BillingOfflineIntentsReleaseRequest; query?: CoreQuery; idempotencyKey: string }>
  | Readonly<{ operation: "billing.payment.invoice"; params: Readonly<{ readonly restaurantId: string; readonly paymentId: string }>; body: BillingPaymentInvoiceRequest; query?: CoreQuery; idempotencyKey: string }>
export type CoreMutation = CoreExactMutation
export type CoreExactMutationResponseMap = Readonly<{
  readonly "POST /auth/2fa/delete-secret": IdentityResponsePOSTAuth2faDeleteSecret;
  readonly "POST /auth/2fa/disable": IdentityResponsePOSTAuth2faDisable;
  readonly "POST /auth/2fa/enable": IdentityResponsePOSTAuth2faEnable;
  readonly "POST /auth/2fa/generate": IdentityResponsePOSTAuth2faGenerate;
  readonly "POST /auth/employee-invitations/claim": IdentityResponsePOSTAuthEmployeeInvitationsClaim;
  readonly "POST /auth/employee-invitations/recover": IdentityResponsePOSTAuthEmployeeInvitationsRecover;
  readonly "POST /auth/login": IdentityResponsePOSTAuthLogin;
  readonly "POST /auth/login/memberships": IdentityResponsePOSTAuthLoginMemberships;
  readonly "POST /auth/login/memberships/select": IdentityResponsePOSTAuthLoginMembershipsSelect;
  readonly "POST /auth/logout": IdentityResponsePOSTAuthLogout;
  readonly "POST /auth/renew": IdentityResponsePOSTAuthRenew;
  readonly "DELETE /clients/:clientId/block": IdentityResponseDELETEClientsClientIdBlock;
  readonly "POST /clients/:clientId/block": IdentityResponsePOSTClientsClientIdBlock;
  readonly "DELETE /clients/:clientId/notice": IdentityResponseDELETEClientsClientIdNotice;
  readonly "POST /clients/:clientId/notice": IdentityResponsePOSTClientsClientIdNotice;
  readonly "POST /franchises": IdentityResponsePOSTFranchises;
  readonly "DELETE /franchises/:franchiseId": IdentityResponseDELETEFranchisesFranchiseId;
  readonly "PUT /franchises/:franchiseId": IdentityResponsePUTFranchisesFranchiseId;
  readonly "POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access": IdentityResponsePOSTFranchisesFranchiseIdFranchiseDirectorsDirectorIdRecoverAccess;
  readonly "PUT /franchises/:franchiseId/reactivate": IdentityResponsePUTFranchisesFranchiseIdReactivate;
  readonly "POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace": IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensTokenIdReplace;
  readonly "POST /identity-access/restaurants/:restaurantId/qr-tokens/prints": IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensPrints;
  readonly "POST /identity/guest/account/save": IdentityResponsePOSTIdentityGuestAccountSave;
  readonly "POST /identity/guest/auth/forget": IdentityResponsePOSTIdentityGuestAuthForget;
  readonly "POST /identity/guest/entry": IdentityResponsePOSTIdentityGuestEntry;
  readonly "POST /identity/guest/entry/start-order": IdentityResponsePOSTIdentityGuestEntryStartOrder;
  readonly "POST /identity/guest/passkey/challenge": IdentityResponsePOSTIdentityGuestPasskeyChallenge;
  readonly "POST /identity/guest/passkey/recover": IdentityResponsePOSTIdentityGuestPasskeyRecover;
  readonly "POST /identity/guest/passkey/save": IdentityResponsePOSTIdentityGuestPasskeySave;
  readonly "POST /me/credential": IdentityResponsePOSTMeCredential;
  readonly "PUT /me/profile": IdentityResponsePUTMeProfile;
  readonly "DELETE /me/sessions/:sessionId": IdentityResponseDELETEMeSessionsSessionId;
  readonly "POST /me/sessions/revoke-all": IdentityResponsePOSTMeSessionsRevokeAll;
  readonly "POST /restaurants": IdentityResponsePOSTRestaurants;
  readonly "DELETE /restaurants/:restaurantId": IdentityResponseDELETERestaurantsRestaurantId;
  readonly "PUT /restaurants/:restaurantId": IdentityResponsePUTRestaurantsRestaurantId;
  readonly "POST /restaurants/:restaurantId/access-policy/restore": AccessPolicyVersionCommandEnvelope;
  readonly "POST /restaurants/:restaurantId/access-policy/restore/validate": AccessPolicyValidationEnvelope;
  readonly "PUT /restaurants/:restaurantId/managers/:managerId/email": IdentityResponsePUTRestaurantsRestaurantIdManagersManagerIdEmail;
  readonly "PUT /restaurants/:restaurantId/reactivate": IdentityResponsePUTRestaurantsRestaurantIdReactivate;
  readonly "PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue": IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdReissue;
  readonly "PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome": IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdResolveDeliveryOutcome;
  readonly "PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke": IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdRevoke;
  readonly "POST /restaurants/:restaurantId/staff-invitations/recover": IdentityResponsePOSTRestaurantsRestaurantIdStaffInvitationsRecover;
  readonly "platformMessaging.panelNoticeSeen.v1": PlatformMessagingNoticeReceiptResponse;
  readonly "platformMessaging.panelNoticeRead.v1": PlatformMessagingNoticeReceiptResponse;
  readonly "platformMessaging.panelNoticeDismiss.v1": PlatformMessagingNoticeReceiptResponse;
  readonly "platformMessaging.guestNoticeSeen.v1": PlatformMessagingNoticeReceiptResponse;
  readonly "platformMessaging.guestNoticeDismiss.v1": PlatformMessagingNoticeReceiptResponse;
  readonly "applyRestaurantConfiguration": ProductResponseApplyRestaurantConfiguration;
  readonly "inventory.stock-policy.set.v1": ProductResponseInventoryStockPolicySetV1;
  readonly "evaluateCatalogWorkshopIdea": ProductResponseEvaluateCatalogWorkshopIdea;
  readonly "recordCatalogWorkshopTrial": ProductResponseRecordCatalogWorkshopTrial;
  readonly "saveCatalogWorkshopCandidate": ProductResponseSaveCatalogWorkshopCandidate;
  readonly "validateCatalogDraft": ProductResponseValidateCatalogDraft;
  readonly "publishCatalog": ProductResponsePublishCatalog;
  readonly "readPreauthenticatedGuestCatalogue": ProductResponseReadPreauthenticatedGuestCatalogue;
  readonly "readPreauthenticatedFeaturedCatalog": ProductResponseReadPreauthenticatedFeaturedCatalog;
  readonly "readPreauthenticatedCatalogMediaDelivery": ProductResponseReadPreauthenticatedCatalogMediaDelivery;
  readonly "materializeCatalogMasterIngredient": ProductResponseMaterializeCatalogMasterIngredient;
  readonly "previewCatalogDishDerivation": ProductResponsePreviewCatalogDishDerivation;
  readonly "applyCatalogDishProposal": ProductResponseApplyCatalogDishProposal;
  readonly "proposeCatalogAiDishCopy": ProductResponseProposeCatalogAiDishCopy;
  readonly "autocompleteCatalogDishIngredients": ProductResponseAutocompleteCatalogDishIngredients;
  readonly "proposeCatalogAiTranslation": ProductResponseProposeCatalogAiTranslation;
  readonly "proposeCatalogAiPhotoEnhancement": ProductResponseProposeCatalogAiPhotoEnhancement;
  readonly "setCatalogAiProviderCredential": ProductResponseSetCatalogAiProviderCredential;
  readonly "deleteCatalogAiProviderCredential": ProductResponseDeleteCatalogAiProviderCredential;
  readonly "reviewCatalogDishCopy": ProductResponseReviewCatalogDishCopy;
  readonly "applyCatalogDishCopy": ProductResponseApplyCatalogDishCopy;
  readonly "undoCatalogDishCopy": ProductResponseUndoCatalogDishCopy;
  readonly "applyCatalogDishNameSuggestion": ProductResponseApplyCatalogDishNameSuggestion;
  readonly "undoCatalogDishNameSuggestion": ProductResponseUndoCatalogDishNameSuggestion;
  readonly "setCatalogDailySuggestion": ProductResponseSetCatalogDailySuggestion;
  readonly "withdrawCatalogDailySuggestion": ProductResponseWithdrawCatalogDailySuggestion;
  readonly "previewCatalogCartaFisica": ProductResponsePreviewCatalogCartaFisica;
  readonly "renderCatalogCartaFisicaDocument": Blob;
  readonly "answerCatalogDishTrial": ProductResponseAnswerCatalogDishTrial;
  readonly "undoCatalogCartaChange": ProductResponseUndoCatalogCartaChange;
  readonly "refreshCatalogDraft": ProductResponseRefreshCatalogDraft;
  readonly "patchCatalogDraftEntities": ProductResponsePatchCatalogDraftEntities;
  readonly "restoreCatalogDraftFromPublication": ProductResponseRestoreCatalogDraftFromPublication;
  readonly "reviewCatalogPhotoCorrection": ProductResponseReviewCatalogPhotoCorrection;
  readonly "applyCatalogPhotoCorrection": ProductResponseApplyCatalogPhotoCorrection;
  readonly "undoCatalogPhotoCorrection": ProductResponseUndoCatalogPhotoCorrection;
  readonly "uploadCatalogPhoto": ProductResponseUploadCatalogPhoto;
  readonly "abandonCatalogMediaProvisionals": ProductResponseAbandonCatalogMediaProvisionals;
  readonly "offers.definition.marketing-replay": ProductResponseOffersDefinitionMarketingReplay;
  readonly "offers.definition.put": ProductResponseOffersDefinitionPut;
  readonly "offers.definition.archive": ProductResponseOffersDefinitionArchive;
  readonly "offers.definition.recall-coupons": ProductResponseOffersDefinitionRecallCoupons;
  readonly "offers.definition.retire": ProductResponseOffersDefinitionRetire;
  readonly "offers.definition.reopen": ProductResponseOffersDefinitionReopen;
  readonly "offers.coupon-code.issue": ProductResponseOffersCouponCodeIssue;
  readonly "offers.coupon-code.cancel": ProductResponseOffersCouponCodeCancel;
  readonly "inventory.stock-item.reconcile.v1": ProductResponseInventoryStockItemReconcileV1;
  readonly "inventory.stock-item.availability-reactivate.v1": ProductResponseInventoryStockItemAvailabilityReactivateV1;
  readonly "inventory.stock-item.retire.v1": ProductResponseInventoryStockItemRetireV1;
  readonly "inventory.stock-item.cost.record.v1": ProductResponseInventoryStockItemCostRecordV1;
  readonly "inventory.stock-item.yield.record.v1": ProductResponseInventoryStockItemYieldRecordV1;
  readonly "inventory.recipe-costing.preview.v1": ProductResponseInventoryRecipeCostingPreviewV1;
  readonly "inventory.supplier.create.v1": ProductResponseInventorySupplierCreateV1;
  readonly "inventory.supplier.update.v1": ProductResponseInventorySupplierUpdateV1;
  readonly "inventory.stock-item.supply.set.v1": ProductResponseInventoryStockItemSupplySetV1;
  readonly "inventory.purchase-document.upload.v1": ProductResponseInventoryPurchaseDocumentUploadV1;
  readonly "inventory.purchase-document.line.answer.v1": ProductResponseInventoryPurchaseDocumentLineAnswerV1;
  readonly "inventory.purchase-document.line.measure.v1": ProductResponseInventoryPurchaseDocumentLineMeasureV1;
  readonly "inventory.purchase-document.undo.v1": ProductResponseInventoryPurchaseDocumentUndoV1;
  readonly "inventory.purchase-document.figure.validate.v1": ProductResponseInventoryPurchaseDocumentFigureValidateV1;
  readonly "inventory.purchase-document.same-delivery.answer.v1": ProductResponseInventoryPurchaseDocumentSameDeliveryAnswerV1;
  readonly "inventory.purchase-document.arrival.answer.v1": ProductResponseInventoryPurchaseDocumentArrivalAnswerV1;
  readonly "inventory.purchase-document.keep-apart.v1": ProductResponseInventoryPurchaseDocumentKeepApartV1;
  readonly "inventory.purchase-settings.set.v1": ProductResponseInventoryPurchaseSettingsSetV1;
  readonly "inventory.purchase-trace.export.prepare.v1": ProductResponseInventoryPurchaseTraceExportPrepareV1;
  readonly "workforce.operational-session.enter.kitchen.v2": ProductResponseWorkforceOperationalSessionEnterKitchenV2;
  readonly "workforce.operational-session.enter.floor.v2": ProductResponseWorkforceOperationalSessionEnterFloorV2;
  readonly "workforce.work-target-assignment.bulk-apply.v1": ProductResponseWorkforceWorkTargetAssignmentBulkApplyV1;
  readonly "workforce.work-target-assignment.assign.v1": ProductResponseWorkforceWorkTargetAssignmentAssignV1;
  readonly "workforce.employee.access.recover.v1": ProductResponseWorkforceEmployeeAccessRecoverV1;
  readonly "workforce.employee.picture.set.v1": ProductResponseWorkforceEmployeePictureSetV1;
  readonly "workforce.employment.register.v1": ProductResponseWorkforceEmploymentRegisterV1;
  readonly "workforce.employment.update.v1": ProductResponseWorkforceEmploymentUpdateV1;
  readonly "workforce.employment.suspend.v1": ProductResponseWorkforceEmploymentSuspendV1;
  readonly "workforce.employment.restore.v1": ProductResponseWorkforceEmploymentRestoreV1;
  readonly "workforce.employment.end.v1": ProductResponseWorkforceEmploymentEndV1;
  readonly "workforce.eligibility.set.v1": ProductResponseWorkforceEligibilitySetV1;
  readonly "workforce.operational-session.enter.v1": ProductResponseWorkforceOperationalSessionEnterV1;
  readonly "workforce.operational-presence.renew.v1": ProductResponseWorkforceOperationalPresenceRenewV1;
  readonly "workforce.feedback.create.v1": ProductResponseWorkforceFeedbackCreateV1;
  readonly "workforce.feedback.acknowledge.v1": ProductResponseWorkforceFeedbackAcknowledgeV1;
  readonly "workforce.staff-notice.compose.v1": ProductResponseWorkforceStaffNoticeComposeV1;
  readonly "workforce.staff-notice.withdraw.v1": ProductResponseWorkforceStaffNoticeWithdrawV1;
  readonly "workforce.rota.publish.v1": ProductResponseWorkforceRotaPublishV1;
  readonly "guest.profile.update": ProductResponseGuestProfileUpdate;
  readonly "guest.diagnostics.record": ProductResponseGuestDiagnosticsRecord;
  readonly "guest.identity.suggest": ProductResponseGuestIdentitySuggest;
  readonly "guest.privacy.replace-consent": ProductResponseGuestPrivacyReplaceConsent;
  readonly "guest.privacy.replace-personalization": ProductResponseGuestPrivacyReplacePersonalization;
  readonly "guest.privacy.erase-derived": ProductResponseGuestPrivacyEraseDerived;
  readonly "guest.privacy.erase-account": ProductResponseGuestPrivacyEraseAccount;
  readonly "service.check-charge-plan.read.staff.v1": ProductResponseServiceCheckChargePlanReadStaffV1;
  readonly "service.check-refund.preview.staff.v1": ProductResponseServiceCheckRefundPreviewStaffV1;
  readonly "service.refund.record.v3": ProductResponseServiceRefundRecordV3;
  readonly "service.offline-segment.record.v1": ProductResponseServiceOfflineSegmentRecordV1;
  readonly "service.fulfillment.transition.kitchen.v2": ProductResponseServiceFulfillmentTransitionKitchenV2;
  readonly "service.manager.fulfillment.transition.kitchen.v2": ProductResponseServiceManagerFulfillmentTransitionKitchenV2;
  readonly "service.fulfillment.remake.kitchen.v2": ProductResponseServiceFulfillmentRemakeKitchenV2;
  readonly "service.fulfillment.transition.floor.v2": ProductResponseServiceFulfillmentTransitionFloorV2;
  readonly "service.manager.fulfillment.transition.floor.v2": ProductResponseServiceManagerFulfillmentTransitionFloorV2;
  readonly "service.fulfillment.deliver-batch.floor.v2": ProductResponseServiceFulfillmentDeliverBatchFloorV2;
  readonly "service.manager.fulfillment.deliver-batch.floor.v2": ProductResponseServiceManagerFulfillmentDeliverBatchFloorV2;
  readonly "service.bill-request.accept.floor.v2": ProductResponseServiceBillRequestAcceptFloorV2;
  readonly "service.table-session.nobody-here.floor.v2": ProductResponseServiceTableSessionNobodyHereFloorV2;
  readonly "service.participant.join.v1": ProductResponseServiceParticipantJoinV1;
  readonly "service.participant.request-bill.v1": ProductResponseServiceParticipantRequestBillV1;
  readonly "service.cart.open.v1": ProductResponseServiceCartOpenV1;
  readonly "service.cart.item.add.v1": ProductResponseServiceCartItemAddV1;
  readonly "service.cart.item.copy.v1": ProductResponseServiceCartItemCopyV1;
  readonly "service.cart.item.steal.v1": ProductResponseServiceCartItemStealV1;
  readonly "service.cart.item.steal.undo.v1": ProductResponseServiceCartItemStealUndoV1;
  readonly "service.cart.item.safety.acknowledge.v1": ProductResponseServiceCartItemSafetyAcknowledgeV1;
  readonly "service.cart.item.update.v1": ProductResponseServiceCartItemUpdateV1;
  readonly "service.cart.item.remove.v1": ProductResponseServiceCartItemRemoveV1;
  readonly "service.diner.offer.choose.v1": ProductResponseServiceDinerOfferChooseV1;
  readonly "service.diner.offer.remove.v1": ProductResponseServiceDinerOfferRemoveV1;
  readonly "service.waiting-room.enter.v1": ProductResponseServiceWaitingRoomEnterV1;
  readonly "service.waiting-room.leave.v1": ProductResponseServiceWaitingRoomLeaveV1;
  readonly "service.order.submit.v1": ProductResponseServiceOrderSubmitV1;
  readonly "service.order.item.add.v1": ProductResponseServiceOrderItemAddV1;
  readonly "service.order.item.update.v1": ProductResponseServiceOrderItemUpdateV1;
  readonly "service.order.item.remove.v1": ProductResponseServiceOrderItemRemoveV1;
  readonly "service.table-session.open.v1": ProductResponseServiceTableSessionOpenV1;
  readonly "service.table-session.party-size.set.v1": ProductResponseServiceTableSessionPartySizeSetV1;
  readonly "service.table-session.close.v1": ProductResponseServiceTableSessionCloseV1;
  readonly "service.bill-request.accept.v1": ProductResponseServiceBillRequestAcceptV1;
  readonly "service.bill-request.reopen.v1": ProductResponseServiceBillRequestReopenV1;
  readonly "service.table-session.force-close.v1": ProductResponseServiceTableSessionForceCloseV1;
  readonly "service.force-close.reclassify.v1": ProductResponseServiceForceCloseReclassifyV1;
  readonly "service.participant.create.v1": ProductResponseServiceParticipantCreateV1;
  readonly "service.cart.open.staff.v1": ProductResponseServiceCartOpenStaffV1;
  readonly "service.cart.item.add.staff.v1": ProductResponseServiceCartItemAddStaffV1;
  readonly "service.cart.item.update.staff.v1": ProductResponseServiceCartItemUpdateStaffV1;
  readonly "service.cart.item.remove.staff.v1": ProductResponseServiceCartItemRemoveStaffV1;
  readonly "service.diner.offer.choose.staff.v1": ProductResponseServiceDinerOfferChooseStaffV1;
  readonly "service.diner.offer.remove.staff.v1": ProductResponseServiceDinerOfferRemoveStaffV1;
  readonly "service.cart.discard.staff.v1": ProductResponseServiceCartDiscardStaffV1;
  readonly "service.order.submit.staff.v1": ProductResponseServiceOrderSubmitStaffV1;
  readonly "service.order.item.update.staff.v1": ProductResponseServiceOrderItemUpdateStaffV1;
  readonly "service.order.item.remove.staff.v1": ProductResponseServiceOrderItemRemoveStaffV1;
  readonly "service.order.cancel.staff.v1": ProductResponseServiceOrderCancelStaffV1;
  readonly "service.fulfillment.transition.v1": ProductResponseServiceFulfillmentTransitionV1;
  readonly "service.fulfillment.remake.v1": ProductResponseServiceFulfillmentRemakeV1;
  readonly "service.fulfillment.deliver-batch.v1": ProductResponseServiceFulfillmentDeliverBatchV1;
  readonly "service.manager.fulfillment.transition.v1": ProductResponseServiceManagerFulfillmentTransitionV1;
  readonly "service.manager.fulfillment.deliver-batch.v1": ProductResponseServiceManagerFulfillmentDeliverBatchV1;
  readonly "service.check.finalize.v1": ProductResponseServiceCheckFinalizeV1;
  readonly "service.check.charge.v1": ProductResponseServiceCheckChargeV1;
  readonly "service.check.charge.reverse.v1": ProductResponseServiceCheckChargeReverseV1;
  readonly "service.check.line.waive.v1": ProductResponseServiceCheckLineWaiveV1;
  readonly "service.check.split.v1": ProductResponseServiceCheckSplitV1;
  readonly "service.cash.movement.record.v1": ProductResponseServiceCashMovementRecordV1;
  readonly "service.cash.session.open.v1": ProductResponseServiceCashSessionOpenV1;
  readonly "service.cash.movement.void.v1": ProductResponseServiceCashMovementVoidV1;
  readonly "service.cash.session.close.v1": ProductResponseServiceCashSessionCloseV1;
  readonly "service.cash.session.count.v1": ProductResponseServiceCashSessionCountV1;
  readonly "service.cash.payment-method.correct.v1": ProductResponseServiceCashPaymentMethodCorrectV1;
  readonly "service.order.confirm.v1": ProductResponseServiceOrderConfirmV1;
  readonly "service.table-session.nobody-here.v1": ProductResponseServiceTableSessionNobodyHereV1;
  readonly "service.qr-orders.pause.set.v1": ProductResponseServiceQrOrdersPauseSetV1;
  readonly "service.offline-review.resolve.v1": ProductResponseServiceOfflineReviewResolveV1;
  readonly "relationship.external-review.connection.start": ProductResponseRelationshipExternalReviewConnectionStart;
  readonly "relationship.external-review.connection.complete": ProductResponseRelationshipExternalReviewConnectionComplete;
  readonly "relationship.external-review.connection.select": ProductResponseRelationshipExternalReviewConnectionSelect;
  readonly "relationship.external-review.connection.disconnect": ProductResponseRelationshipExternalReviewConnectionDisconnect;
  readonly "relationship.external_review.reply": ProductResponseRelationshipExternalReviewReply;
  readonly "relationship.external_review.reply.delete": ProductResponseRelationshipExternalReviewReplyDelete;
  readonly "relationship.external_review.reply.publish": ProductResponseRelationshipExternalReviewReplyPublish;
  readonly "relationship.external_review.reply.undo": ProductResponseRelationshipExternalReviewReplyUndo;
  readonly "relationship.guest-question.put.v1": ProductResponseRelationshipGuestQuestionPutV1;
  readonly "relationship.guest-question.remove.v1": ProductResponseRelationshipGuestQuestionRemoveV1;
  readonly "relationship.guest-question.answer.guest.v1": ProductResponseRelationshipGuestQuestionAnswerGuestV1;
  readonly "relationship.review.submit": ProductResponseRelationshipReviewSubmit;
  readonly "relationship.loyalty.program.put": ProductResponseRelationshipLoyaltyProgramPut;
  readonly "relationship.loyalty.program.retire": ProductResponseRelationshipLoyaltyProgramRetire;
  readonly "relationship.preferences.replace": ProductResponseRelationshipPreferencesReplace;
  readonly "relationship.recommendation.assign": ProductResponseRelationshipRecommendationAssign;
  readonly "relationship.impression.record": ProductResponseRelationshipImpressionRecord;
  readonly "relationship.feedback.record": ProductResponseRelationshipFeedbackRecord;
  readonly "parte.pendiente.dismiss.v1": ProductResponsePartePendienteDismissV1;
  readonly "parte.costs.recipe-batch.confirm.v1": ProductResponseParteCostsRecipeBatchConfirmV1;
  readonly "parte.costs.recipe-batch.withdraw.v1": ProductResponseParteCostsRecipeBatchWithdrawV1;
  readonly "parte.costs.recipe-batch.undo.v1": ProductResponseParteCostsRecipeBatchUndoV1;
  readonly "parte.costs.recipe-batch.correct.v1": ProductResponseParteCostsRecipeBatchCorrectV1;
  readonly "parte.finanzas.fixed-costs.declare.v1": ProductResponseParteFinanzasFixedCostsDeclareV1;
  readonly "parte.finanzas.labour-averages.declare.v1": ProductResponseParteFinanzasLabourAveragesDeclareV1;
  readonly "parte.voice-answer.submit.v1": ProductResponseParteVoiceAnswerSubmitV1;
  readonly "parte.push-subscription.register.v1": ProductResponsePartePushSubscriptionRegisterV1;
  readonly "parte.push-subscription.remove.v1": ProductResponsePartePushSubscriptionRemoveV1;
  readonly "parte.pacto.line.put.v1": ProductResponsePartePactoLinePutV1;
  readonly "parte.pacto.line.confirm.v1": ProductResponsePartePactoLineConfirmV1;
  readonly "parte.pacto.line.retire.v1": ProductResponsePartePactoLineRetireV1;
  readonly "parte.team-stop.set.v1": ProductResponseParteTeamStopSetV1;
  readonly "parte.operation.approve.v1": ProductResponseParteOperationApproveV1;
  readonly "parte.operation.decline.v1": ProductResponseParteOperationDeclineV1;
  readonly "parte.operation.resolve.v1": ProductResponseParteOperationResolveV1;
  readonly "parte.scheduled-action.stop.v1": ProductResponseParteScheduledActionStopV1;
  readonly "parte.team-action.undo.v1": ProductResponseParteTeamActionUndoV1;
  readonly "parte.work.act.v1": ProductResponseParteWorkActV1;
  readonly "parte.autonomy.offer.answer.v1": ProductResponseParteAutonomyOfferAnswerV1;
  readonly "parte.compras.food-waste-plan.adopt.v1": ProductResponseParteComprasFoodWastePlanAdoptV1;
  readonly "parte.compras.food-waste-plan.update.decline.v1": ProductResponseParteComprasFoodWastePlanUpdateDeclineV1;
  readonly "parte.team.coach.note.share.v1": ProductResponseParteTeamCoachNoteShareV1;
  readonly "parte.missing-data.answer.v1": ProductResponseParteMissingDataAnswerV1;
  readonly "parte.carta-reading.correct.v1": ProductResponseParteCartaReadingCorrectV1;
  readonly "parte.encargo.create.v1": ProductResponseParteEncargoCreateV1;
  readonly "parte.reputation.reply-draft.set-aside.v1": ProductResponseParteReputationReplyDraftSetAsideV1;
  readonly "parte.reputation.post-draft.use.v1": ProductResponseParteReputationPostDraftUseV1;
  readonly "parte.reputation.post-draft.withdraw.v1": ProductResponseParteReputationPostDraftWithdrawV1;
  readonly "parte.what-if.dish-price.read.v1": ProductResponseParteWhatIfDishPriceReadV1;
  readonly "parte.what-if.closed-weekday.read.v1": ProductResponseParteWhatIfClosedWeekdayReadV1;
  readonly "parte.goal.say.v1": ProductResponseParteGoalSayV1;
  readonly "parte.goal.confirm.v1": ProductResponseParteGoalConfirmV1;
  readonly "parte.goal.correct.v1": ProductResponseParteGoalCorrectV1;
  readonly "parte.goal.decline.v1": ProductResponseParteGoalDeclineV1;
  readonly "parte.goal.withdraw.v1": ProductResponseParteGoalWithdrawV1;
  readonly "parte.queue.answer.v1": ProductResponseParteQueueAnswerV1;
  readonly "parte.request.open.v1": ProductResponseParteRequestOpenV1;
  readonly "parte.advisor-library.review.v1": ProductResponseParteAdvisorLibraryReviewV1;
  readonly "parte.person.withdraw": ProductResponsePartePersonWithdraw;
  readonly "owner-calendar.put": ProductResponseOwnerCalendarPut;
  readonly "owner-calendar.cancel": ProductResponseOwnerCalendarCancel;
  readonly "proposal.catalog-reviewed.prepare": ProductResponseProposalCatalogReviewedPrepare;
  readonly "proposal.confirm": ProductResponseProposalConfirm;
  readonly "proposal.decline": ProductResponseProposalDecline;
  readonly "proposal.undo": ProductResponseProposalUndo;
  readonly "billing.configuration.apply": ProductResponseBillingConfigurationApply;
  readonly "billing.provider.connect": ProductResponseBillingProviderConnect;
  readonly "billing.provider.disconnect": ProductResponseBillingProviderDisconnect;
  readonly "billing.activate": ProductResponseBillingActivate;
  readonly "billing.request.create": ProductResponseBillingRequestCreate;
  readonly "billing.intent.retry": ProductResponseBillingIntentRetry;
  readonly "billing.intent.void": ProductResponseBillingIntentVoid;
  readonly "billing.document.render": ProductResponseBillingDocumentRender;
  readonly "billing.fiscal-incident.record": ProductResponseBillingFiscalIncidentRecord;
  readonly "billing.fiscal-incident.move": ProductResponseBillingFiscalIncidentMove;
  readonly "billing.document.legible-copy": ProductResponseBillingDocumentLegibleCopy;
  readonly "billing.issuer-succession.record": ProductResponseBillingIssuerSuccessionRecord;
  readonly "billing.intent.complete": ProductResponseBillingIntentComplete;
  readonly "billing.intent.reissue": ProductResponseBillingIntentReissue;
  readonly "billing.export.prepare": ProductResponseBillingExportPrepare;
  readonly "billing.offline-intents.release": ProductResponseBillingOfflineIntentsRelease;
  readonly "billing.payment.invoice": ProductResponseBillingPaymentInvoice;
}>
export type CoreMutationResponseMap = CoreExactMutationResponseMap
export type IdentityOwnerRead = CoreRead
export type IdentityOwnerReadResponseMap = CoreReadResponseMap
export type IdentityOwnerCommand = CoreMutation
export type IdentityOwnerResponseMap = CoreMutationResponseMap
export type IdentityGuestEnvelope = IdentityResponseGETGuestHome | IdentityResponseGETGuestRestaurantPresentation | IdentityResponsePOSTIdentityGuestAccountSave | IdentityResponseGETIdentityGuestAuthCurrent | IdentityResponsePOSTIdentityGuestAuthForget | IdentityResponsePOSTIdentityGuestEntry | IdentityResponsePOSTIdentityGuestEntryStartOrder | IdentityResponsePOSTIdentityGuestPasskeyChallenge | IdentityResponsePOSTIdentityGuestPasskeyRecover | IdentityResponsePOSTIdentityGuestPasskeySave | IdentityResponseGETIdentityGuestQrHandoffHandoffToken | IdentityResponseGETIdentityGuestQrResolveQrId
export const RESTAURANT_TABLE_CAPACITY = {"minimum":1,"maximum":60} as const
export const CORE_OPERATION_METADATA = {"POST /auth/2fa/delete-secret":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/delete-secret","owner":"identity-access","path":"/auth/2fa/delete-secret","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faDeleteSecret","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faDeleteSecret","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/2fa/disable":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/disable","owner":"identity-access","path":"/auth/2fa/disable","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faDisable","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faDisable","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/2fa/enable":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/enable","owner":"identity-access","path":"/auth/2fa/enable","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faEnable","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faEnable","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/2fa/generate":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/generate","owner":"identity-access","path":"/auth/2fa/generate","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faGenerate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faGenerate","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /auth/current":{"audiences":["panel"],"method":"GET","operation":"GET /auth/current","owner":"identity-access","path":"/auth/current","permission":"identity.session.read","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETAuthCurrent","response_statuses":[200],"scope":"none","side_effect":"none"},"POST /auth/employee-invitations/claim":{"audiences":["panel","public"],"method":"POST","operation":"POST /auth/employee-invitations/claim","owner":"identity-access","path":"/auth/employee-invitations/claim","permission":"identity.invitation.claim","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestEmployeeInvitationClaim","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthEmployeeInvitationsClaim","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/employee-invitations/recover":{"audiences":["panel","public"],"method":"POST","operation":"POST /auth/employee-invitations/recover","owner":"identity-access","path":"/auth/employee-invitations/recover","permission":"identity.invitation.recover","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestEmployeeInvitationRecover","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthEmployeeInvitationsRecover","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/login":{"audiences":["panel","public"],"method":"POST","operation":"POST /auth/login","owner":"identity-access","path":"/auth/login","permission":"identity.login","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLogin","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLogin","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/login/memberships":{"audiences":["panel"],"method":"POST","operation":"POST /auth/login/memberships","owner":"identity-access","path":"/auth/login/memberships","permission":"identity.login.memberships.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLoginMembershipSelectionRead","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLoginMemberships","response_statuses":[200],"scope":"none","side_effect":"none"},"POST /auth/login/memberships/select":{"audiences":["panel"],"method":"POST","operation":"POST /auth/login/memberships/select","owner":"identity-access","path":"/auth/login/memberships/select","permission":"identity.login.membership.select","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLoginMembershipSelectionComplete","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLoginMembershipsSelect","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/logout":{"audiences":["panel"],"method":"POST","operation":"POST /auth/logout","owner":"identity-access","path":"/auth/logout","permission":"identity.session.revoke","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLogout","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLogout","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/renew":{"audiences":["panel"],"method":"POST","operation":"POST /auth/renew","owner":"identity-access","path":"/auth/renew","permission":"identity.session.renew","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffRenew","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthRenew","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /clients/:clientId/admission":{"audiences":["panel"],"method":"GET","operation":"GET /clients/:clientId/admission","owner":"identity-access","path":"/clients/:clientId/admission","permission":"identity.guest.admission.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"IdentityRequestGuestAdmissionStaffRead","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETClientsClientIdAdmission","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"DELETE /clients/:clientId/block":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /clients/:clientId/block","owner":"identity-access","path":"/clients/:clientId/block","permission":"identity.guest.admission.restore","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionBlockLift","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEClientsClientIdBlock","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /clients/:clientId/block":{"audiences":["panel"],"method":"POST","operation":"POST /clients/:clientId/block","owner":"identity-access","path":"/clients/:clientId/block","permission":"identity.guest.admission.deny","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionBlock","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTClientsClientIdBlock","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"DELETE /clients/:clientId/notice":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /clients/:clientId/notice","owner":"identity-access","path":"/clients/:clientId/notice","permission":"identity.guest.admission.restore","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionNoticeClear","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEClientsClientIdNotice","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /clients/:clientId/notice":{"audiences":["panel"],"method":"POST","operation":"POST /clients/:clientId/notice","owner":"identity-access","path":"/clients/:clientId/notice","permission":"identity.guest.admission.flag","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionNotice","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTClientsClientIdNotice","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /franchises":{"audiences":["panel"],"method":"GET","operation":"GET /franchises","owner":"tenant-directory","path":"/franchises","permission":"tenant.franchise.read","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETFranchises","response_statuses":[200],"scope":"platform","side_effect":"none"},"POST /franchises":{"audiences":["panel"],"method":"POST","operation":"POST /franchises","owner":"tenant-directory","path":"/franchises","permission":"tenant.franchise.create","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseCreate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTFranchises","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"DELETE /franchises/:franchiseId":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /franchises/:franchiseId","owner":"tenant-directory","path":"/franchises/:franchiseId","permission":"tenant.franchise.delete","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseDelete","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"franchiseId","id_source":"path","type":"franchises"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEFranchisesFranchiseId","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"GET /franchises/:franchiseId":{"audiences":["panel"],"method":"GET","operation":"GET /franchises/:franchiseId","owner":"tenant-directory","path":"/franchises/:franchiseId","permission":"tenant.franchise.read","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETFranchisesFranchiseId","response_statuses":[200],"scope":"franchise","side_effect":"none"},"PUT /franchises/:franchiseId":{"audiences":["panel"],"method":"PUT","operation":"PUT /franchises/:franchiseId","owner":"tenant-directory","path":"/franchises/:franchiseId","permission":"tenant.franchise.update","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":["logo_url"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestFranchiseUpdateById","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"franchiseId","id_source":"path","type":"franchises"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTFranchisesFranchiseId","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access":{"audiences":["panel"],"method":"POST","operation":"POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access","owner":"identity-access","path":"/franchises/:franchiseId/franchise-directors/:directorId/recover-access","permission":"identity.user.franchise-director.recover","policy":"platform","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffCredentialRecoverFranchiseDirector","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":{"id_key":"directorId","id_source":"path","type":"users"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTFranchisesFranchiseIdFranchiseDirectorsDirectorIdRecoverAccess","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"GET /franchises/:franchiseId/logo":{"audiences":["panel","public"],"method":"GET","operation":"GET /franchises/:franchiseId/logo","owner":"tenant-directory","path":"/franchises/:franchiseId/logo","permission":"tenant.franchise.logo.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETFranchisesFranchiseIdLogo","response_statuses":[200],"scope":"franchise","side_effect":"none"},"PUT /franchises/:franchiseId/reactivate":{"audiences":["panel"],"method":"PUT","operation":"PUT /franchises/:franchiseId/reactivate","owner":"tenant-directory","path":"/franchises/:franchiseId/reactivate","permission":"tenant.franchise.reactivate","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseReactivate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"franchiseId","id_source":"path","type":"franchises"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTFranchisesFranchiseIdReactivate","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"GET /guest/home":{"audiences":["guest"],"method":"GET","operation":"GET /guest/home","owner":"identity-access","path":"/guest/home","permission":"identity.guest.session.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestHome","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"GET /guest/restaurant-presentation":{"audiences":["guest"],"method":"GET","operation":"GET /guest/restaurant-presentation","owner":"tenant-directory","path":"/guest/restaurant-presentation","permission":"tenant.restaurant.presentation.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestRestaurantPresentation","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"GET /identity-access/restaurants/:restaurantId/qr-tokens":{"audiences":["panel"],"method":"GET","operation":"GET /identity-access/restaurants/:restaurantId/qr-tokens","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/qr-tokens","permission":"identity.qr.table-token.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityAccessRestaurantsRestaurantIdQrTokens","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace":{"audiences":["panel"],"method":"POST","operation":"POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace","permission":"identity.qr.table-token.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestQrTableTokenReplace","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensTokenIdReplace","response_statuses":[201],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /identity-access/restaurants/:restaurantId/qr-tokens/prints":{"audiences":["panel"],"method":"POST","operation":"POST /identity-access/restaurants/:restaurantId/qr-tokens/prints","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/qr-tokens/prints","permission":"identity.qr.table-token.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestQrTableTokenPrint","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensPrints","response_statuses":[201],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens":{"audiences":["panel"],"method":"GET","operation":"GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens","permission":"identity.qr.table-token.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityAccessRestaurantsRestaurantIdTablesTableIdQrTokens","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"POST /identity/guest/account/save":{"audiences":["guest"],"method":"POST","operation":"POST /identity/guest/account/save","owner":"identity-access","path":"/identity/guest/account/save","permission":"identity.guest.account.save","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAccountSave","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAccountSave","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"GET /identity/guest/auth/current":{"audiences":["guest"],"method":"GET","operation":"GET /identity/guest/auth/current","owner":"identity-access","path":"/identity/guest/auth/current","permission":"identity.guest.session.read","policy":"guest-session","public":false,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestAuthCurrent","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"POST /identity/guest/auth/forget":{"audiences":["guest"],"method":"POST","operation":"POST /identity/guest/auth/forget","owner":"identity-access","path":"/identity/guest/auth/forget","permission":"identity.guest.session.revoke","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestForget","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAuthForget","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"POST /identity/guest/entry":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/entry","owner":"identity-access","path":"/identity/guest/entry","permission":"identity.qr.resolve","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestEntry","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntry","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/entry/start-order":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/entry/start-order","owner":"identity-access","path":"/identity/guest/entry/start-order","permission":"identity.guest.order.start","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestStartOrder","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntryStartOrder","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/challenge":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/passkey/challenge","owner":"identity-access","path":"/identity/guest/passkey/challenge","permission":"identity.guest.passkey.challenge","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyChallenge","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyChallenge","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/recover":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/passkey/recover","owner":"identity-access","path":"/identity/guest/passkey/recover","permission":"identity.guest.passkey.recover","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyRecover","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyRecover","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/save":{"audiences":["guest"],"method":"POST","operation":"POST /identity/guest/passkey/save","owner":"identity-access","path":"/identity/guest/passkey/save","permission":"identity.guest.passkey.save","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeySave","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeySave","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"GET /identity/guest/qr/handoff/:handoffToken":{"audiences":["guest","public"],"method":"GET","operation":"GET /identity/guest/qr/handoff/:handoffToken","owner":"identity-access","path":"/identity/guest/qr/handoff/:handoffToken","permission":"identity.qr.handoff.consume","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrHandoffHandoffToken","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"GET /identity/guest/qr/resolve/:qrId":{"audiences":["guest","panel","public"],"method":"GET","operation":"GET /identity/guest/qr/resolve/:qrId","owner":"identity-access","path":"/identity/guest/qr/resolve/:qrId","permission":"identity.qr.resolve","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrResolveQrId","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation"},"POST /me/credential":{"audiences":["panel"],"method":"POST","operation":"POST /me/credential","owner":"identity-access","path":"/me/credential","permission":"identity.staff-credential.update","policy":"staff-session","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":401},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409},{"schema":"PlatformRefusal","status":429}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSelfCredentialUpdate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTMeCredential","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /me/profile":{"audiences":["panel"],"method":"GET","operation":"GET /me/profile","owner":"identity-access","path":"/me/profile","permission":"identity.staff-profile.read","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeProfile","response_statuses":[200],"scope":"none","side_effect":"none"},"PUT /me/profile":{"audiences":["panel"],"method":"PUT","operation":"PUT /me/profile","owner":"identity-access","path":"/me/profile","permission":"identity.staff-profile.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":["avatar"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestStaffSelfProfileUpdate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTMeProfile","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /me/sessions":{"audiences":["panel"],"method":"GET","operation":"GET /me/sessions","owner":"identity-access","path":"/me/sessions","permission":"identity.session.read","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeSessions","response_statuses":[200],"scope":"none","side_effect":"none"},"DELETE /me/sessions/:sessionId":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /me/sessions/:sessionId","owner":"identity-access","path":"/me/sessions/:sessionId","permission":"identity.session.revoke","policy":"staff-session","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":404}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSessionRevoke","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEMeSessionsSessionId","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /me/sessions/revoke-all":{"audiences":["panel"],"method":"POST","operation":"POST /me/sessions/revoke-all","owner":"identity-access","path":"/me/sessions/revoke-all","permission":"identity.session.revoke","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSessionsRevokeAll","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTMeSessionsRevokeAll","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /me/workspaces":{"audiences":["panel"],"method":"GET","operation":"GET /me/workspaces","owner":"identity-access","path":"/me/workspaces","permission":"identity.workspace.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeWorkspaces","response_statuses":[200,304],"scope":"restaurant","side_effect":"none"},"GET /restaurants":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants","owner":"tenant-directory","path":"/restaurants","permission":"tenant.restaurant.read","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurants","response_statuses":[200],"scope":"franchise","side_effect":"none"},"POST /restaurants":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants","owner":"tenant-directory","path":"/restaurants","permission":"tenant.restaurant.create","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantCreate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTRestaurants","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"DELETE /restaurants/:restaurantId":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /restaurants/:restaurantId","owner":"tenant-directory","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.delete","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantDelete","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETERestaurantsRestaurantId","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId","owner":"tenant-directory","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantId","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"PUT /restaurants/:restaurantId":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId","owner":"tenant-directory","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.update","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":["logo"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestRestaurantUpdate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantId","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId/access-policy/current-grants":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/current-grants","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/current-grants","permission":"identity.access-policy.read","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":"AccessPolicyCurrentGrantBatchQuery","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyCurrentGrantBatchEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/access-policy/directory":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/directory","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/directory","permission":"identity.access-policy.read","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyDirectoryEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/access-policy/receipts/:receiptId":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/receipts/:receiptId","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/receipts/:receiptId","permission":"identity.access-policy.receipt.read","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyReceiptEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"POST /restaurants/:restaurantId/access-policy/restore":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants/:restaurantId/access-policy/restore","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/restore","permission":"identity.access-policy.restore","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"RestoreAccessPolicyRequest","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_schema":"AccessPolicyVersionCommandEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /restaurants/:restaurantId/access-policy/restore/validate":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants/:restaurantId/access-policy/restore/validate","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/restore/validate","permission":"identity.access-policy.validate","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"ValidateAccessPolicyRestoreRequest","requires_expected_version":true,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyValidationEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/locations":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/locations","owner":"tenant-directory","path":"/restaurants/:restaurantId/locations","permission":"tenant.location.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdLocations","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/logo":{"audiences":["panel","public"],"method":"GET","operation":"GET /restaurants/:restaurantId/logo","owner":"tenant-directory","path":"/restaurants/:restaurantId/logo","permission":"tenant.restaurant.logo.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdLogo","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"PUT /restaurants/:restaurantId/managers/:managerId/email":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/managers/:managerId/email","owner":"identity-access","path":"/restaurants/:restaurantId/managers/:managerId/email","permission":"identity.user.franchise-manager-email.update","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseManagerEmailUpdate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdManagersManagerIdEmail","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/reactivate":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/reactivate","owner":"tenant-directory","path":"/restaurants/:restaurantId/reactivate","permission":"tenant.restaurant.reactivate","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantReactivate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdReactivate","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId/staff-invitations/:invitationId":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/staff-invitations/:invitationId","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId","permission":"core.hr.employee.invitation.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdStaffInvitationsInvitationId","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/reissue","permission":"core.hr.employee.invitation.resend","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminReissue","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdReissue","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome","permission":"core.hr.employee.invitation.resolve-delivery-outcome","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminResolveDeliveryOutcome","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdResolveDeliveryOutcome","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/revoke","permission":"core.hr.employee.invitation.revoke","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminRevoke","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdRevoke","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /restaurants/:restaurantId/staff-invitations/recover":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants/:restaurantId/staff-invitations/recover","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/recover","permission":"core.hr.employee.invitation.resend","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminRecoverScopedManager","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTRestaurantsRestaurantIdStaffInvitationsRecover","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /users/:userId/avatar":{"audiences":["panel","public"],"method":"GET","operation":"GET /users/:userId/avatar","owner":"identity-access","path":"/users/:userId/avatar","permission":"identity.user.avatar.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETUsersUserIdAvatar","response_statuses":[200],"scope":"none","side_effect":"none"},"platformMessaging.guestRealtimeReplay.v1":{"audiences":["guest"],"method":"GET","operation":"platformMessaging.guestRealtimeReplay.v1","operation_id":"platformMessaging.guestRealtimeReplay.v1","owner":"platform-messaging","path":"/platform/realtime/guest-replay","permission":"platform.realtime.guest-replay","policy":"guest-session","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":"PlatformMessagingGuestRealtimeReplayRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"PlatformMessagingRealtimeReplayResponse","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"platformMessaging.panelNoticeSeen.v1":{"audiences":["panel"],"method":"POST","operation":"platformMessaging.panelNoticeSeen.v1","operation_id":"platformMessaging.panelNoticeSeen.v1","owner":"platform-messaging","path":"/platform/notices/:noticeId/seen","permission":"platform.notice.staff.seen","policy":"staff-session","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"platformMessaging.panelNoticeRead.v1":{"audiences":["panel"],"method":"POST","operation":"platformMessaging.panelNoticeRead.v1","operation_id":"platformMessaging.panelNoticeRead.v1","owner":"platform-messaging","path":"/platform/notices/:noticeId/read","permission":"platform.notice.staff.read","policy":"staff-session","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"platformMessaging.panelNoticeDismiss.v1":{"audiences":["panel"],"method":"POST","operation":"platformMessaging.panelNoticeDismiss.v1","operation_id":"platformMessaging.panelNoticeDismiss.v1","owner":"platform-messaging","path":"/platform/notices/:noticeId/dismiss","permission":"platform.notice.staff.dismiss","policy":"staff-session","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"platformMessaging.panelNoticesInbox.v1":{"audiences":["panel"],"conditional_read":"etag","method":"GET","operation":"platformMessaging.panelNoticesInbox.v1","operation_id":"platformMessaging.panelNoticesInbox.v1","owner":"platform-messaging","path":"/platform/notices/inbox","permission":"platform.notice.staff.inbox","policy":"restaurant-read","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"PlatformMessagingNoticeInboxResponse","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"platformMessaging.guestNoticeSeen.v1":{"audiences":["guest"],"method":"POST","operation":"platformMessaging.guestNoticeSeen.v1","operation_id":"platformMessaging.guestNoticeSeen.v1","owner":"platform-messaging","path":"/platform/guest-notices/:noticeId/seen","permission":"platform.notice.guest.seen","policy":"guest-session","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"platformMessaging.guestNoticeDismiss.v1":{"audiences":["guest"],"method":"POST","operation":"platformMessaging.guestNoticeDismiss.v1","operation_id":"platformMessaging.guestNoticeDismiss.v1","owner":"platform-messaging","path":"/platform/guest-notices/:noticeId/dismiss","permission":"platform.notice.guest.dismiss","policy":"guest-session","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"platformMessaging.guestNoticesPendingOverlay.v1":{"audiences":["guest"],"method":"GET","operation":"platformMessaging.guestNoticesPendingOverlay.v1","operation_id":"platformMessaging.guestNoticesPendingOverlay.v1","owner":"platform-messaging","path":"/platform/guest-notices/pending-overlay","permission":"platform.notice.guest.read","policy":"guest-session","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"PlatformMessagingNoticeListResponse","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"readRestaurantConfigurationCurrent":{"audiences":["panel"],"method":"GET","operation":"readRestaurantConfigurationCurrent","owner":"restaurant_configuration","path":"/restaurant-configurations/:restaurantId/current","permission":"restaurant.configuration.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadRestaurantConfigurationCurrent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"applyRestaurantConfiguration":{"audiences":["panel"],"method":"POST","operation":"applyRestaurantConfiguration","owner":"restaurant_configuration","path":"/restaurant-configurations/:restaurantId/apply","permission":"restaurant.configuration.publish","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"RestaurantConfigurationInvalidHttpError","status":400}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ApplyRestaurantConfigurationRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyRestaurantConfiguration","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"searchIneMunicipalities":{"audiences":["panel"],"method":"GET","operation":"searchIneMunicipalities","owner":"restaurant_configuration","path":"/restaurant-configurations/:restaurantId/ine-municipalities","permission":"restaurant.configuration.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"IneMunicipalitySearchRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseSearchIneMunicipalities","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"restaurant-configuration.geocode.search.v1":{"audiences":["panel"],"method":"GET","operation":"restaurant-configuration.geocode.search.v1","owner":"restaurant_configuration","path":"/restaurant-configurations/:restaurantId/geocode","permission":"restaurant.configuration.read","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"GeocodeSearchUnavailableHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"GeocodeSearchRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRestaurantConfigurationGeocodeSearchV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.stock-policy.set.v1":{"audiences":["panel"],"method":"PUT","operation":"inventory.stock-policy.set.v1","owner":"restaurant_configuration","path":"/inventory/restaurants/:restaurantId/stock-policy","permission":"restaurant.configuration.publish","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"RestaurantConfigurationInvalidHttpError","status":400}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"SetInventoryStockPolicyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockPolicySetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"readPublishedRestaurantConfiguration":{"audiences":["panel"],"method":"GET","operation":"readPublishedRestaurantConfiguration","owner":"restaurant_configuration","path":"/restaurant-configurations/:restaurantId/published","permission":"restaurant.configuration.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPublishedRestaurantConfiguration","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"evaluateCatalogWorkshopIdea":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"evaluateCatalogWorkshopIdea","owner":"catalog","path":"/catalogs/:restaurantId/workshop/evaluate","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogWorkshopEvaluateRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseEvaluateCatalogWorkshopIdea","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"recordCatalogWorkshopTrial":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"recordCatalogWorkshopTrial","owner":"catalog","path":"/catalogs/:restaurantId/workshop/trials","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogWorkshopTrialRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRecordCatalogWorkshopTrial","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"saveCatalogWorkshopCandidate":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"saveCatalogWorkshopCandidate","owner":"catalog","path":"/catalogs/:restaurantId/workshop/candidates","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogWorkshopSaveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseSaveCatalogWorkshopCandidate","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"readCatalogWorkshopCandidate":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"readCatalogWorkshopCandidate","owner":"catalog","path":"/catalogs/:restaurantId/workshop/candidates/:candidateId","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogWorkshopCandidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogDraft":{"audiences":["panel"],"conditional_read":"etag","method":"GET","operation":"readCatalogDraft","owner":"catalog","path":"/catalogs/:restaurantId/draft","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraft","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogStockDeactivationWarning":{"audiences":["panel"],"method":"GET","operation":"readCatalogStockDeactivationWarning","owner":"catalog","path":"/catalogs/:restaurantId/stock-deactivation-warning","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogStockDeactivationWarningRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogStockDeactivationWarning","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"validateCatalogDraft":{"audiences":["panel"],"method":"POST","operation":"validateCatalogDraft","owner":"catalog","path":"/catalogs/:restaurantId/validate","permission":"catalog.validate","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseValidateCatalogDraft","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"publishCatalog":{"audiences":["panel"],"method":"POST","operation":"publishCatalog","owner":"catalog","path":"/catalogs/:restaurantId/publish","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"CatalogPublishRefusedHttpError","status":400}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PublishCatalogRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePublishCatalog","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"listCatalogPublications":{"audiences":["panel"],"method":"GET","operation":"listCatalogPublications","owner":"catalog","path":"/catalogs/:restaurantId/publications","permission":"catalog.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogPublications","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogPublication":{"audiences":["panel"],"conditional_read":"etag","method":"GET","operation":"readCatalogPublication","owner":"catalog","path":"/catalogs/:restaurantId/publications/:publicationVersion","permission":"catalog.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogPublication","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readPublishedCatalogue":{"audiences":["panel"],"conditional_read":"etag","method":"GET","operation":"readPublishedCatalogue","owner":"catalog","path":"/catalogs/:restaurantId/published","permission":"catalog.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPublishedCatalogue","response_statuses":[200],"scope":"restaurant","side_effect":"mutation"},"catalog.pos-operational.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN"],"method":"GET","operation":"catalog.pos-operational.read.v1","owner":"catalog","path":"/catalogs/:restaurantId/pos-operational","permission":"catalog.pos-operational.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPosOperationalReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"mutation"},"catalog.pos-routing.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN"],"method":"GET","operation":"catalog.pos-routing.read.v1","owner":"catalog","path":"/catalogs/:restaurantId/pos-publication/:publicationVersion/routing","permission":"catalog.pos-routing.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPosRoutingReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readGuestPublishedCatalogue":{"audiences":["guest"],"method":"GET","operation":"readGuestPublishedCatalogue","owner":"catalog","path":"/guest/catalogs/:restaurantId/published","permission":"catalog.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestPublishedCatalogue","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readGuestLiveCatalogue":{"audiences":["guest"],"method":"GET","operation":"readGuestLiveCatalogue","owner":"catalog","path":"/guest/catalogs/:restaurantId/live","permission":"catalog.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestLiveCatalogue","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readGuestMenuDocuments":{"audiences":["guest"],"method":"GET","operation":"readGuestMenuDocuments","owner":"catalog","path":"/guest/catalogs/:restaurantId/documents","permission":"catalog.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestMenuDocuments","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readPreauthenticatedGuestCatalogue":{"audiences":["guest","public"],"method":"POST","operation":"readPreauthenticatedGuestCatalogue","owner":"catalog","path":"/guest/catalogs/:restaurantId/preauthenticated-live","permission":"catalog.featured.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReadPreauthenticatedFeaturedCatalogRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPreauthenticatedGuestCatalogue","response_statuses":[200],"scope":"none","side_effect":"none"},"readPreauthenticatedFeaturedCatalog":{"audiences":["guest","public"],"method":"POST","operation":"readPreauthenticatedFeaturedCatalog","owner":"catalog","path":"/guest/catalogs/:restaurantId/preauthenticated-featured","permission":"catalog.featured.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReadPreauthenticatedFeaturedCatalogRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPreauthenticatedFeaturedCatalog","response_statuses":[200],"scope":"none","side_effect":"none"},"readPreauthenticatedCatalogMediaDelivery":{"audiences":["guest","public"],"method":"POST","operation":"readPreauthenticatedCatalogMediaDelivery","owner":"catalog","path":"/guest/catalogs/:restaurantId/preauthenticated-featured/media/:mediaId/delivery","permission":"catalog.featured.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogPreauthenticatedMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPreauthenticatedCatalogMediaDelivery","response_statuses":[200],"scope":"none","side_effect":"none"},"readGuestPublishedDish":{"audiences":["guest"],"method":"GET","operation":"readGuestPublishedDish","owner":"catalog","path":"/guest/catalogs/:restaurantId/published/dishes/:dishId","permission":"catalog.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestPublishedDish","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"searchCatalogMasterIngredients":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"searchCatalogMasterIngredients","owner":"catalog","path":"/catalogs/:restaurantId/master-ingredients/search","permission":"catalog.master-ingredient.search","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogMasterIngredientSearchRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseSearchCatalogMasterIngredients","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"materializeCatalogMasterIngredient":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER"],"method":"POST","operation":"materializeCatalogMasterIngredient","owner":"catalog","path":"/catalogs/:restaurantId/draft/master-ingredients","permission":"catalog.master-ingredient.materialize","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogMasterIngredientMaterializationRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseMaterializeCatalogMasterIngredient","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"previewCatalogDishDerivation":{"audiences":["panel"],"method":"POST","operation":"previewCatalogDishDerivation","owner":"catalog","path":"/catalogs/:restaurantId/dishes/derivation-preview","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishDerivationPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePreviewCatalogDishDerivation","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"applyCatalogDishProposal":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER"],"method":"POST","operation":"applyCatalogDishProposal","owner":"catalog","path":"/catalogs/:restaurantId/dishes/proposals/:proposalId/apply","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishProposalApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogDishProposal","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"proposeCatalogAiDishCopy":{"audiences":["panel"],"method":"POST","operation":"proposeCatalogAiDishCopy","owner":"catalog","path":"/catalogs/:restaurantId/ai/dish-copy-proposal","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogAiDishCopyProposalRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposeCatalogAiDishCopy","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"autocompleteCatalogDishIngredients":{"audiences":["panel"],"method":"POST","operation":"autocompleteCatalogDishIngredients","owner":"catalog","path":"/catalogs/:restaurantId/dishes/ingredient-autocomplete","permission":"catalog.autocomplete","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogIngredientAutocompleteRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseAutocompleteCatalogDishIngredients","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"proposeCatalogAiTranslation":{"audiences":["panel"],"method":"POST","operation":"proposeCatalogAiTranslation","owner":"catalog","path":"/catalogs/:restaurantId/ai/translation-proposal","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogAiTranslationProposalRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposeCatalogAiTranslation","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"proposeCatalogAiPhotoEnhancement":{"audiences":["panel"],"method":"POST","operation":"proposeCatalogAiPhotoEnhancement","owner":"catalog","path":"/catalogs/:restaurantId/ai/photo-enhancement-proposal","permission":"catalog.media.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogAiPhotoEnhancementProposalRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposeCatalogAiPhotoEnhancement","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"readCatalogAiPhotoEnhancementPreview":{"audiences":["panel"],"method":"GET","operation":"readCatalogAiPhotoEnhancementPreview","owner":"catalog","path":"/catalogs/:restaurantId/ai/photo-enhancement-proposals/:mediaId/preview","permission":"catalog.media.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogAiPhotoEnhancementPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogAiPhotoEnhancementPreview","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogAiProviderCredentialStatus":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"readCatalogAiProviderCredentialStatus","owner":"catalog","path":"/catalogs/:restaurantId/ai/provider-credential","permission":"catalog.ai-credential.manage","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"CatalogAiCredentialUnavailableHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogAiProviderCredentialReadRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogAiProviderCredentialStatus","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogAiUsageMonth":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"readCatalogAiUsageMonth","owner":"catalog","path":"/catalogs/:restaurantId/ai/usage/month","permission":"catalog.ai-credential.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogAiUsageMonth","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"setCatalogAiProviderCredential":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"PUT","operation":"setCatalogAiProviderCredential","owner":"catalog","path":"/catalogs/:restaurantId/ai/provider-credential","permission":"catalog.ai-credential.manage","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"CatalogAiCredentialUnavailableHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogAiProviderCredentialSetRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseSetCatalogAiProviderCredential","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"deleteCatalogAiProviderCredential":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"DELETE","operation":"deleteCatalogAiProviderCredential","owner":"catalog","path":"/catalogs/:restaurantId/ai/provider-credential","permission":"catalog.ai-credential.manage","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"CatalogAiCredentialUnavailableHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogAiProviderCredentialDeleteRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseDeleteCatalogAiProviderCredential","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"reviewCatalogDishCopy":{"audiences":["panel"],"method":"POST","operation":"reviewCatalogDishCopy","owner":"catalog","path":"/catalogs/:restaurantId/dishes/copy/review","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishCopyReviewRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReviewCatalogDishCopy","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"applyCatalogDishCopy":{"audiences":["panel"],"method":"POST","operation":"applyCatalogDishCopy","owner":"catalog","path":"/catalogs/:restaurantId/dishes/copy/apply","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishCopyApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogDishCopy","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"undoCatalogDishCopy":{"audiences":["panel"],"method":"POST","operation":"undoCatalogDishCopy","owner":"catalog","path":"/catalogs/:restaurantId/dishes/copy/undo","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishCopyUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogDishCopy","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"listCatalogDishNameSuggestions":{"audiences":["panel"],"method":"GET","operation":"listCatalogDishNameSuggestions","owner":"catalog","path":"/catalogs/:restaurantId/dish-name-suggestions","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogDishNameSuggestions","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"applyCatalogDishNameSuggestion":{"audiences":["panel"],"method":"POST","operation":"applyCatalogDishNameSuggestion","owner":"catalog","path":"/catalogs/:restaurantId/dish-name-suggestions/:suggestionId/apply","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishNameApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogDishNameSuggestion","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"undoCatalogDishNameSuggestion":{"audiences":["panel"],"method":"POST","operation":"undoCatalogDishNameSuggestion","owner":"catalog","path":"/catalogs/:restaurantId/dish-name-suggestions/:suggestionId/undo","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishNameUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogDishNameSuggestion","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"listCatalogDailySuggestions":{"audiences":["panel"],"method":"GET","operation":"listCatalogDailySuggestions","owner":"catalog","path":"/catalogs/:restaurantId/daily-suggestions","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogDailySuggestions","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"setCatalogDailySuggestion":{"audiences":["panel"],"method":"POST","operation":"setCatalogDailySuggestion","owner":"catalog","path":"/catalogs/:restaurantId/daily-suggestions","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDailySuggestionSetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseSetCatalogDailySuggestion","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"withdrawCatalogDailySuggestion":{"audiences":["panel"],"method":"POST","operation":"withdrawCatalogDailySuggestion","owner":"catalog","path":"/catalogs/:restaurantId/daily-suggestions/:suggestionId/withdraw","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDailySuggestionWithdrawRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWithdrawCatalogDailySuggestion","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"readGuestDailySuggestions":{"audiences":["guest"],"method":"GET","operation":"readGuestDailySuggestions","owner":"catalog","path":"/guest/catalogs/:restaurantId/daily-suggestions","permission":"catalog.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestDailySuggestions","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogCartaFisica":{"audiences":["panel"],"method":"GET","operation":"readCatalogCartaFisica","owner":"catalog","path":"/catalogs/:restaurantId/carta-fisica","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogCartaFisica","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"previewCatalogCartaFisica":{"audiences":["panel"],"method":"POST","operation":"previewCatalogCartaFisica","owner":"catalog","path":"/catalogs/:restaurantId/carta-fisica/preview","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogCartaFisicaPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePreviewCatalogCartaFisica","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"renderCatalogCartaFisicaDocument":{"audiences":["panel"],"method":"POST","operation":"renderCatalogCartaFisicaDocument","owner":"catalog","path":"/catalogs/:restaurantId/carta-fisica/document","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogCartaFisicaDocumentRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"listCatalogDishTrials":{"audiences":["panel"],"method":"GET","operation":"listCatalogDishTrials","owner":"catalog","path":"/catalogs/:restaurantId/dish-trials","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogDishTrials","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"answerCatalogDishTrial":{"audiences":["panel"],"method":"POST","operation":"answerCatalogDishTrial","owner":"catalog","path":"/catalogs/:restaurantId/dish-trials/:trialId/answer","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogDishTrialAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseAnswerCatalogDishTrial","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"undoCatalogCartaChange":{"audiences":["panel"],"method":"POST","operation":"undoCatalogCartaChange","owner":"catalog","path":"/catalogs/:restaurantId/carta-changes/undo","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogCartaChangeUndoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogCartaChange","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"refreshCatalogDraft":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER"],"method":"POST","operation":"refreshCatalogDraft","owner":"catalog","path":"/catalogs/:restaurantId/draft/refresh","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"CatalogPublishRefusedHttpError","status":400}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRefreshCatalogDraft","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"patchCatalogDraftEntities":{"audiences":["panel"],"method":"POST","operation":"patchCatalogDraftEntities","owner":"catalog","path":"/catalogs/:restaurantId/draft/entities","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"CatalogDraftEntityInvalidHttpError","status":400},{"include_generic_identity":true,"schema":"CatalogDraftEntityConflictHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PatchCatalogDraftEntitiesRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePatchCatalogDraftEntities","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"readCatalogDraftSummary":{"audiences":["panel"],"conditional_read":"etag","method":"GET","operation":"readCatalogDraftSummary","owner":"catalog","path":"/catalogs/:restaurantId/draft/summary","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraftSummary","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogDraftDocument":{"audiences":["panel"],"conditional_read":"etag","method":"GET","operation":"readCatalogDraftDocument","owner":"catalog","path":"/catalogs/:restaurantId/draft/document","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraftDocument","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogReferenceDocument":{"audiences":["panel"],"conditional_read":"etag","method":"GET","operation":"readCatalogReferenceDocument","owner":"catalog","path":"/catalogs/:restaurantId/reference-documents/:digest","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogReferenceDocument","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"catalog.repaired-master-holdings.read.v1":{"audiences":["panel"],"method":"GET","operation":"catalog.repaired-master-holdings.read.v1","owner":"catalog","path":"/catalogs/:restaurantId/repaired-master-holdings","permission":"catalog.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogRepairedMasterHoldingsReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"restoreCatalogDraftFromPublication":{"audiences":["panel"],"method":"POST","operation":"restoreCatalogDraftFromPublication","owner":"catalog","path":"/catalogs/:restaurantId/draft/restore","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RestoreCatalogDraftFromPublicationRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRestoreCatalogDraftFromPublication","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"reviewCatalogPhotoCorrection":{"audiences":["panel"],"method":"POST","operation":"reviewCatalogPhotoCorrection","owner":"catalog","path":"/catalogs/:restaurantId/dishes/photo-correction/review","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogPhotoCorrectionReviewRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReviewCatalogPhotoCorrection","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"applyCatalogPhotoCorrection":{"audiences":["panel"],"method":"POST","operation":"applyCatalogPhotoCorrection","owner":"catalog","path":"/catalogs/:restaurantId/dishes/photo-correction/apply","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogPhotoCorrectionApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogPhotoCorrection","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"undoCatalogPhotoCorrection":{"audiences":["panel"],"method":"POST","operation":"undoCatalogPhotoCorrection","owner":"catalog","path":"/catalogs/:restaurantId/dishes/photo-correction/undo","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogPhotoCorrectionUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogPhotoCorrection","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"uploadCatalogPhoto":{"audiences":["panel"],"method":"POST","operation":"uploadCatalogPhoto","owner":"catalog","path":"/catalogs/:restaurantId/media/photos","permission":"catalog.media.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":["photo"],"request_max_bytes":8388608,"request_media_type":"multipart/form-data","request_schema":"UploadCatalogPhotoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUploadCatalogPhoto","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"abandonCatalogMediaProvisionals":{"audiences":["panel"],"method":"POST","operation":"abandonCatalogMediaProvisionals","owner":"catalog","path":"/catalogs/:restaurantId/media/provisionals/abandon","permission":"catalog.media.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"AbandonCatalogMediaProvisionalsRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseAbandonCatalogMediaProvisionals","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"readCatalogMediaDelivery":{"audiences":["panel"],"method":"GET","operation":"readCatalogMediaDelivery","owner":"catalog","path":"/catalogs/:restaurantId/media/:mediaId/delivery","permission":"catalog.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogMediaDelivery","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"catalog.published-media.delivery.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN"],"method":"GET","operation":"catalog.published-media.delivery.v1","owner":"catalog","path":"/catalogs/:restaurantId/publications/:publicationVersion/media/:mediaId/delivery","permission":"catalog.published-media.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogPublishedMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPublishedMediaDeliveryV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogMediaRenditions":{"audiences":["panel"],"method":"GET","operation":"readCatalogMediaRenditions","owner":"catalog","path":"/catalogs/:restaurantId/media/:mediaId/renditions","permission":"catalog.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogMediaRenditionsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogMediaRenditions","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readCatalogDraftPhotoRenditions":{"audiences":["panel"],"method":"GET","operation":"readCatalogDraftPhotoRenditions","owner":"catalog","path":"/catalogs/:restaurantId/draft/photo-renditions","permission":"catalog.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraftPhotoRenditions","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"catalog.published-media.renditions.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN"],"method":"GET","operation":"catalog.published-media.renditions.v1","owner":"catalog","path":"/catalogs/:restaurantId/publications/:publicationVersion/media/:mediaId/renditions","permission":"catalog.published-media.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogMediaRenditionsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPublishedMediaRenditionsV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"readGuestCatalogMediaDelivery":{"audiences":["guest"],"method":"GET","operation":"readGuestCatalogMediaDelivery","owner":"catalog","path":"/guest/catalogs/:restaurantId/media/:mediaId/delivery","permission":"catalog.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestCatalogMediaDelivery","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.marketing-board.read":{"audiences":["panel"],"method":"GET","operation":"offers.marketing-board.read","owner":"offers","path":"/offers/marketing-board","permission":"offers.definition.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersMarketingBoardRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.marketing-board.page.read":{"audiences":["panel"],"method":"GET","operation":"offers.marketing-board.page.read","owner":"offers","path":"/offers/marketing-board/page","permission":"offers.definition.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ReadOfferMarketingBoardPageQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersMarketingBoardPageRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.definition.marketing-replay":{"audiences":["panel"],"method":"POST","operation":"offers.definition.marketing-replay","owner":"offers","path":"/offers/definitions/marketing-replay","permission":"offers.definition.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReplayOfferDefinitionRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionMarketingReplay","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.definition.get":{"audiences":["panel"],"method":"GET","operation":"offers.definition.get","owner":"offers","path":"/offers/definitions/:definitionId","permission":"offers.definition.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.definition.history":{"audiences":["panel"],"method":"GET","operation":"offers.definition.history","owner":"offers","path":"/offers/definitions/:definitionId/history","permission":"offers.definition.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ListOfferDefinitionHistoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionHistory","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.definition.redemption-consumption.get":{"audiences":["panel"],"method":"GET","operation":"offers.definition.redemption-consumption.get","owner":"offers","path":"/offers/definitions/:definitionId/redemption-consumption","permission":"offers.definition.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionRedemptionConsumptionGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.definition.put":{"audiences":["panel"],"method":"PUT","operation":"offers.definition.put","owner":"offers","path":"/offers/definitions/:definitionId","permission":"offers.definition.write","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferDefinitionRefusedHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PutOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionPut","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"offers.definition.archive":{"audiences":["panel"],"method":"POST","operation":"offers.definition.archive","owner":"offers","path":"/offers/definitions/:definitionId/archive","permission":"offers.definition.retire","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ArchiveOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionArchive","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"offers.definition.recall-coupons":{"audiences":["panel"],"method":"POST","operation":"offers.definition.recall-coupons","owner":"offers","path":"/offers/definitions/:definitionId/recall-coupons","permission":"offers.definition.retire","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RecallOfferCouponsRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionRecallCoupons","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"offers.definition.retire":{"audiences":["panel"],"method":"POST","operation":"offers.definition.retire","owner":"offers","path":"/offers/definitions/:definitionId/retire","permission":"offers.definition.retire","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RetireOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionRetire","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"offers.definition.reopen":{"audiences":["panel"],"method":"POST","operation":"offers.definition.reopen","owner":"offers","path":"/offers/definitions/:definitionId/reopen","permission":"offers.definition.reopen","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferDefinitionArchivedHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReopenOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionReopen","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"offers.coupon-code.list":{"audiences":["panel"],"method":"GET","operation":"offers.coupon-code.list","owner":"offers","path":"/offers/coupon-codes","permission":"offers.definition.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ListOfferCouponCodesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersCouponCodeList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.coupon-code.issue":{"audiences":["panel"],"method":"POST","operation":"offers.coupon-code.issue","owner":"offers","path":"/offers/coupon-codes","permission":"offers.coupon-code.issue","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferCouponCodeTakenHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"IssueOfferCouponCodeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersCouponCodeIssue","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"offers.coupon-code.cancel":{"audiences":["panel"],"method":"POST","operation":"offers.coupon-code.cancel","owner":"offers","path":"/offers/coupon-codes/:codeId/cancel","permission":"offers.coupon-code.issue","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CancelOfferCouponCodeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersCouponCodeCancel","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"offers.wallet.list":{"audiences":["guest"],"method":"GET","operation":"offers.wallet.list","owner":"offers","path":"/offers/wallet","permission":"offers.wallet.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersWalletList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.definition.uses.list":{"audiences":["panel"],"method":"GET","operation":"offers.definition.uses.list","owner":"offers","path":"/offers/definitions/:definitionId/uses","permission":"offers.definition.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ListOfferDefinitionUsesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionUsesList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.published-policy.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.published-policy.read.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/published-policy","permission":"inventory.stock-item.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPublishedPolicyReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.stock-item.published-usage.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.stock-item.published-usage.list.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/published-usage","permission":"inventory.stock-item.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ListInventoryPublishedIngredientUsageQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemPublishedUsageListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.stock-item.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.stock-item.list.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items","permission":"inventory.stock-item.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ListInventoryStockItemsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.stock-item.reconcile.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.stock-item.reconcile.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/reconcile","permission":"inventory.stock-item.reconcile","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"InventoryReconcileBelowReservedHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReconcileInventoryStockItemRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemReconcileV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.stock-item.availability-reactivate.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.stock-item.availability-reactivate.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/reactivate-availability","permission":"inventory.stock-item.availability-reactivate","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReactivateInventoryStockItemAvailabilityRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemAvailabilityReactivateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.stock-item.retire.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.stock-item.retire.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/retire","permission":"inventory.stock-item.retire","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RetireInventoryResourceRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemRetireV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.stock-item.cost.record.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.stock-item.cost.record.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/costs","permission":"inventory.stock-item.cost.record","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RecordInventoryStockItemCostRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemCostRecordV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.stock-item.cost.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.stock-item.cost.list.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-item-costs","permission":"inventory.stock-item.cost.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemCostListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.stock-item.yield.record.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.stock-item.yield.record.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/yield","permission":"inventory.stock-item.cost.record","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RecordInventoryStockItemYieldRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemYieldRecordV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.recipe-costing.preview.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER"],"method":"POST","operation":"inventory.recipe-costing.preview.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/recipe-costing","permission":"inventory.recipe-costing.read","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryRecipeCostingRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryRecipeCostingPreviewV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.dish-costing.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER"],"method":"GET","operation":"inventory.dish-costing.list.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/dish-costing","permission":"inventory.recipe-costing.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryDishCostingListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.supply.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.supply.list.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/supply","permission":"inventory.supply.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventorySupplyListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.supplier.create.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.supplier.create.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/suppliers","permission":"inventory.supply.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CreateInventorySupplierRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventorySupplierCreateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.supplier.update.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.supplier.update.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/suppliers/:resourceId","permission":"inventory.supply.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"UpdateInventorySupplierRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventorySupplierUpdateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.stock-item.supply.set.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.stock-item.supply.set.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/supply","permission":"inventory.supply.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"SetInventoryStockItemSupplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemSupplySetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.upload.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM","KITCHEN"],"method":"POST","operation":"inventory.purchase-document.upload.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/pages","permission":"inventory.purchase-document.capture","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":["page"],"request_max_bytes":8388608,"request_media_type":"multipart/form-data","request_schema":"InventoryPurchasePageUploadRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentUploadV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM","KITCHEN"],"method":"GET","operation":"inventory.purchase-document.read.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId","permission":"inventory.purchase-document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryPurchaseDocumentReadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.purchase-document.line.answer.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-document.line.answer.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/answer","permission":"inventory.purchase-document.resolve","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseLineAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentLineAnswerV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.line.measure.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-document.line.measure.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/measure","permission":"inventory.purchase-document.resolve","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseLineMeasureRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentLineMeasureV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.undo.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-document.undo.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/undo","permission":"inventory.purchase-document.resolve","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseDocumentUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentUndoV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.figure.validate.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-document.figure.validate.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/figure-validation","permission":"inventory.purchase-document.resolve","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseFigureValidateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentFigureValidateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.same-delivery.answer.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-document.same-delivery.answer.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/same-delivery","permission":"inventory.purchase-document.resolve","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseSameDeliveryAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentSameDeliveryAnswerV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.arrival.answer.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-document.arrival.answer.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/arrival","permission":"inventory.purchase-document.resolve","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseArrivalAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentArrivalAnswerV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-document.keep-apart.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-document.keep-apart.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/keep-apart","permission":"inventory.purchase-document.resolve","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseKeepApartRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentKeepApartV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-documents.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM","KITCHEN"],"method":"GET","operation":"inventory.purchase-documents.list.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-documents","permission":"inventory.purchase-document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryPurchaseOverviewQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentsListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.purchase-settings.set.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN"],"method":"POST","operation":"inventory.purchase-settings.set.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-settings","permission":"inventory.purchase-settings.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseSettingsRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseSettingsSetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-trace.search.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.purchase-trace.search.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-trace","permission":"inventory.purchase-register.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryPurchaseTraceQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseTraceSearchV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.purchase-trace.export.prepare.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"POST","operation":"inventory.purchase-trace.export.prepare.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-trace/exports","permission":"inventory.purchase-register.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"InventoryPurchaseTraceExportPrepareRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseTraceExportPrepareV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"inventory.purchase-trace.export.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.purchase-trace.export.list.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-trace/exports","permission":"inventory.purchase-register.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryPurchaseTraceExportListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseTraceExportListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.purchase-trace.export.download.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.purchase-trace.export.download.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-trace/exports/:resourceId/file","permission":"inventory.purchase-register.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryPurchaseTraceExportDownloadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.purchase-period.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.purchase-period.read.v1","owner":"inventory","path":"/inventory/restaurants/:restaurantId/purchase-period","permission":"inventory.purchase-register.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryPurchasePeriodQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchasePeriodReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.operational-session.enter.kitchen.v2":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","RESTAURANT_EMPLOYEE","KITCHEN","POS","WAITER"],"method":"POST","operation":"workforce.operational-session.enter.kitchen.v2","owner":"workforce","path":"/workforce/restaurants/:restaurantId/operational-session/enter/kitchen","permission":"workforce.operational-session.enter","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceOperationalSessionEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalSessionEnterKitchenV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.operational-session.enter.floor.v2":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","RESTAURANT_EMPLOYEE","KITCHEN","POS","WAITER"],"method":"POST","operation":"workforce.operational-session.enter.floor.v2","owner":"workforce","path":"/workforce/restaurants/:restaurantId/operational-session/enter/floor","permission":"workforce.operational-session.enter","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceOperationalSessionEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalSessionEnterFloorV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.work-target-assignment.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.work-target-assignment.list.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/work-target-assignments","permission":"workforce.work-target-assignment.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceWorkTargetAssignmentListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.team-on-plan.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.team-on-plan.read.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/team-on-plan","permission":"workforce.team-on-plan.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceTeamOnPlanReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.work-target-assignment.bulk-apply.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.work-target-assignment.bulk-apply.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/work-target-assignment/bulk-apply","permission":"workforce.work-target-assignment.bulk-apply","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceWorkTargetAssignmentBulkApplyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceWorkTargetAssignmentBulkApplyV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.work-target-assignment.assign.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.work-target-assignment.assign.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/work-target-assignment/assign","permission":"workforce.work-target-assignment.assign","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceWorkTargetAssignmentAssignRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceWorkTargetAssignmentAssignV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.employee.list.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.employee.list.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employees","permission":"workforce.employee.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"WorkforceEmployeeListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.employee.detail.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.employee.detail.read.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employees/:employmentId","permission":"workforce.employee.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeDetailReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.employee.kpi.read.v3":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.employee.kpi.read.v3","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employees/:employmentId/kpis","permission":"workforce.employee.kpi.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"WorkforceEmployeeKpiExpansionQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeKpiReadV3","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.employee.feedback.read.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.employee.feedback.read.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employees/:employmentId/feedback-alerts","permission":"workforce.feedback.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeFeedbackReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.employee.access.recover.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.employee.access.recover.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employees/:employeeId/recover-access","permission":"core.hr.employee.recover","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceEmployeeAccessRecoveryRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeAccessRecoverV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.employee.picture.set.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.employee.picture.set.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employees/:employeeId/picture","permission":"workforce.employment.update","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":["photo"],"request_max_bytes":2097152,"request_media_type":"multipart/form-data","request_schema":"WorkforceEmployeePictureSetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeePictureSetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.employment.register.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.employment.register.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employment/register","permission":"workforce.employment.register","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceEmploymentRegisterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentRegisterV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.employment.update.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","FRANCHISE_DIRECTOR"],"method":"POST","operation":"workforce.employment.update.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employment/update","permission":"workforce.employment.update","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceEmploymentUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentUpdateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.employment.suspend.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","FRANCHISE_DIRECTOR"],"method":"POST","operation":"workforce.employment.suspend.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employment/suspend","permission":"workforce.employment.suspend","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceEmploymentSuspendRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentSuspendV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.employment.restore.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","FRANCHISE_DIRECTOR"],"method":"POST","operation":"workforce.employment.restore.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employment/restore","permission":"workforce.employment.restore","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceEmploymentRestoreRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentRestoreV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.employment.end.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","FRANCHISE_DIRECTOR"],"method":"POST","operation":"workforce.employment.end.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/employment/end","permission":"workforce.employment.end","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceEmploymentEndRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentEndV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.eligibility.set.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.eligibility.set.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/eligibility/set","permission":"workforce.eligibility.set","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceEligibilitySetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEligibilitySetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.operational-session.enter.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","RESTAURANT_EMPLOYEE","KITCHEN","POS","WAITER"],"method":"POST","operation":"workforce.operational-session.enter.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/operational-session/enter","permission":"workforce.operational-session.enter","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceOperationalSessionEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalSessionEnterV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.operational-presence.renew.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER","RESTAURANT_EMPLOYEE","KITCHEN","POS","WAITER"],"method":"POST","operation":"workforce.operational-presence.renew.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/operational-presence/renew","permission":"workforce.operational-presence.renew","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceOperationalPresenceRenewRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalPresenceRenewV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.feedback.create.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.feedback.create.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/feedback/create","permission":"workforce.feedback.create","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceFeedbackCreateRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceFeedbackCreateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.feedback.acknowledge.v1":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.feedback.acknowledge.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/feedback/acknowledge","permission":"workforce.feedback.acknowledge","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceFeedbackAcknowledgeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceFeedbackAcknowledgeV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.staff-notice.compose.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.staff-notice.compose.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/staff-notices","permission":"workforce.staff-notice.compose","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceStaffNoticeComposeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceStaffNoticeComposeV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.staff-notice.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.staff-notice.read.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/staff-notices/:noticeId","permission":"workforce.staff-notice.compose","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceStaffNoticeReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.staff-notice.withdraw.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"workforce.staff-notice.withdraw.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/staff-notices/:noticeId/withdraw","permission":"workforce.staff-notice.compose","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceStaffNoticeWithdrawRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceStaffNoticeWithdrawV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"workforce.rota.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"workforce.rota.read.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/rota","permission":"workforce.rota.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"WorkforceRotaQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceRotaReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.rota.publish.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"workforce.rota.publish.v1","owner":"workforce","path":"/workforce/restaurants/:restaurantId/rota/publish","permission":"workforce.rota.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"WorkforceRotaPublishRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceRotaPublishV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"guest.profile.get":{"audiences":["guest"],"method":"GET","operation":"guest.profile.get","owner":"guest","path":"/guest/profile","permission":"guest.profile.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestProfileGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"guest.loyalty-cards.list":{"audiences":["guest"],"method":"GET","operation":"guest.loyalty-cards.list","owner":"guest","path":"/guest/loyalty-cards","permission":"guest.profile.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestLoyaltyCardsList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"guest.loyalty-cards.detail":{"audiences":["guest"],"method":"GET","operation":"guest.loyalty-cards.detail","owner":"guest","path":"/guest/loyalty-cards/:restaurantId","permission":"guest.profile.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestLoyaltyCardsDetail","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"guest.profile.update":{"audiences":["guest"],"method":"PUT","operation":"guest.profile.update","owner":"guest","path":"/guest/profile","permission":"guest.profile.update","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"UpdateGuestProfileRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestProfileUpdate","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"guest.diagnostics.record":{"audiences":["guest"],"method":"POST","operation":"guest.diagnostics.record","owner":"guest","path":"/guest/diagnostics","permission":"guest.diagnostics.record","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RecordGuestDiagnosticsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestDiagnosticsRecord","response_statuses":[202],"scope":"restaurant","side_effect":"none"},"guest.identity.suggest":{"audiences":["guest"],"method":"POST","operation":"guest.identity.suggest","owner":"guest","path":"/guest/identity-suggestions","permission":"guest.identity.suggest","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"GuestIdentitySuggestionRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestIdentitySuggest","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"guest.privacy.get":{"audiences":["guest"],"method":"GET","operation":"guest.privacy.get","owner":"guest","path":"/guest/privacy","permission":"guest.privacy.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"guest.privacy.replace-consent":{"audiences":["guest"],"method":"PUT","operation":"guest.privacy.replace-consent","owner":"guest","path":"/guest/privacy/consent","permission":"guest.privacy.consent.replace","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReplaceGuestConsentRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyReplaceConsent","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"guest.privacy.personalization.get":{"audiences":["guest"],"method":"GET","operation":"guest.privacy.personalization.get","owner":"guest","path":"/guest/privacy/personalization","permission":"guest.privacy.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyPersonalizationGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"guest.privacy.replace-personalization":{"audiences":["guest"],"method":"PUT","operation":"guest.privacy.replace-personalization","owner":"guest","path":"/guest/privacy/personalization","permission":"guest.privacy.personalization.replace","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReplaceGuestPersonalizationSettingRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyReplacePersonalization","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"guest.privacy.export":{"audiences":["guest"],"method":"GET","operation":"guest.privacy.export","owner":"guest","path":"/guest/privacy/export","permission":"guest.privacy.export","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyExport","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"guest.privacy.erase-derived":{"audiences":["guest"],"method":"POST","operation":"guest.privacy.erase-derived","owner":"guest","path":"/guest/privacy/erase-derived","permission":"guest.privacy.erase","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"EraseGuestPrivacyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyEraseDerived","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"guest.privacy.erase-account":{"audiences":["guest"],"method":"POST","operation":"guest.privacy.erase-account","owner":"guest","path":"/guest/privacy/erase-account","permission":"guest.privacy.erase","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"EraseGuestAccountRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyEraseAccount","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"guest.billing.documents.list":{"audiences":["guest"],"method":"GET","operation":"guest.billing.documents.list","owner":"guest","path":"/guest/billing/documents","permission":"guest.billing.documents.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"GuestBillingDocumentListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestBillingDocumentsList","response_statuses":[200],"scope":"none","side_effect":"none"},"guest.billing.session-charges.read":{"audiences":["guest"],"method":"GET","operation":"guest.billing.session-charges.read","owner":"guest","path":"/guest/billing/sessions/:tableSessionId/charges","permission":"guest.billing.documents.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"GuestBillingSessionChargesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestBillingSessionChargesRead","response_statuses":[200],"scope":"none","side_effect":"none"},"guest.billing.document.download":{"audiences":["guest"],"method":"GET","operation":"guest.billing.document.download","owner":"guest","path":"/guest/billing/documents/:documentId/pdf","permission":"guest.billing.documents.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"none","side_effect":"none"},"service.table-occupancy.impacted.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.table-occupancy.impacted.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/table-occupancy/impacted","permission":"service.table-occupancy.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceTableOccupancyQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceTableOccupancyImpactedReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.kitchen-pending-work.impacted.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.kitchen-pending-work.impacted.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/kitchen-pending-work/impacted","permission":"service.kitchen-pending-work.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceKitchenPendingWorkQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceKitchenPendingWorkImpactedReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.fulfillment-plan.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.fulfillment-plan.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment-plan","permission":"service.fulfillment-plan.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentPlanReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.department-categories.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.department-categories.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/department-categories","permission":"service.department-categories.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceDepartmentCategoriesReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.snapshot.read.pos.v1":{"audiences":["panel"],"canonical_roles":["POS"],"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.pos.v1","owner":"service","path":"/service/restaurants/:restaurantId/snapshots/pos","permission":"service.snapshot.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadPosV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.snapshot.read.kitchen.v1":{"audiences":["panel"],"canonical_roles":["KITCHEN"],"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.kitchen.v1","owner":"service","path":"/service/restaurants/:restaurantId/snapshots/kitchen","permission":"service.snapshot.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadKitchenV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.snapshot.read.floor.v1":{"audiences":["panel"],"canonical_roles":["WAITER"],"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.floor.v1","owner":"service","path":"/service/restaurants/:restaurantId/snapshots/floor","permission":"service.snapshot.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadFloorV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.check-consumption-receipt.read.staff.v1":{"audiences":["panel"],"canonical_roles":["ANALYST","DELIVERY","FRANCHISE_DIRECTOR","HR","KITCHEN","MARKETING","POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","STOCKROOM","SUPERADMIN","WAITER"],"method":"GET","operation":"service.check-consumption-receipt.read.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/checks/:checkId/consumption-receipt","permission":"service.history.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceCheckConsumptionReceiptQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.check-order-loyalty.read.staff.v1":{"audiences":["panel"],"canonical_roles":["ANALYST","DELIVERY","FRANCHISE_DIRECTOR","HR","KITCHEN","MARKETING","POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","STOCKROOM","SUPERADMIN","WAITER"],"method":"GET","operation":"service.check-order-loyalty.read.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/checks/:checkId/orders/:orderId/loyalty","permission":"service.history.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckOrderLoyaltyReadStaffV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.check-consumption-receipt.read.guest.v1":{"audiences":["guest"],"method":"GET","operation":"service.check-consumption-receipt.read.guest.v1","owner":"service","path":"/service/guest/checks/:checkId/consumption-receipt","permission":"service.history.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceCheckConsumptionReceiptQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.history.read.staff.v1":{"audiences":["panel"],"canonical_roles":["ANALYST","DELIVERY","FRANCHISE_DIRECTOR","HR","KITCHEN","MARKETING","POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","STOCKROOM","SUPERADMIN","WAITER"],"method":"GET","operation":"service.history.read.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/history","permission":"service.history.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceStaffHistoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceHistoryReadStaffV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.history-summary.read.staff.v1":{"audiences":["panel"],"canonical_roles":["ANALYST","DELIVERY","FRANCHISE_DIRECTOR","HR","KITCHEN","MARKETING","POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","STOCKROOM","SUPERADMIN","WAITER"],"method":"GET","operation":"service.history-summary.read.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/history/summary","permission":"service.history.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceStaffHistorySummaryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceHistorySummaryReadStaffV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.check-charge-plan.read.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.check-charge-plan.read.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/check-charge-plans","permission":"service.check.charge","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckChargePlanRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckChargePlanReadStaffV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.check-refund.preview.staff.v1":{"audiences":["panel"],"canonical_roles":["ANALYST","DELIVERY","FRANCHISE_DIRECTOR","HR","KITCHEN","MARKETING","POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","STOCKROOM","SUPERADMIN","WAITER"],"method":"POST","operation":"service.check-refund.preview.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/check-refunds/preview","permission":"service.history.read","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckRefundPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckRefundPreviewStaffV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.cart.item.safety.challenge.read.v1":{"audiences":["guest"],"method":"GET","operation":"service.cart.item.safety.challenge.read.v1","owner":"service","path":"/service/guest/cart-item-safety-challenge","permission":"service.snapshot.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceSafetyChallengeQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCartItemSafetyChallengeReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.snapshot.read.guest.v1":{"audiences":["guest"],"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.guest.v1","owner":"service","path":"/service/guest/snapshot","permission":"service.snapshot.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadGuestV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.arrival.read.guest.v1":{"audiences":["guest"],"conditional_read":"etag","method":"GET","operation":"service.arrival.read.guest.v1","owner":"service","path":"/service/guest/arrival","permission":"service.snapshot.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceArrivalReadGuestV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.waiting-room.read.v1":{"audiences":["guest"],"method":"GET","operation":"service.waiting-room.read.v1","owner":"service","path":"/service/guest/waiting-room","permission":"service.snapshot.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceWaitingRoomReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.history.read.guest.v1":{"audiences":["guest"],"method":"GET","operation":"service.history.read.guest.v1","owner":"service","path":"/service/guest/history","permission":"service.history.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceHistoryReadGuestV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.refund.record.v3":{"audiences":["panel"],"canonical_roles":["ANALYST","DELIVERY","FRANCHISE_DIRECTOR","HR","KITCHEN","MARKETING","POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","STOCKROOM","SUPERADMIN","WAITER"],"method":"POST","operation":"service.refund.record.v3","owner":"service","path":"/service/restaurants/:restaurantId/refund/record/v3","permission":"service.refund.record","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckRefundRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceRefundRecordV3","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cash.read.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.cash.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash","permission":"service.cash.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCashReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.cash-sessions.read.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.cash-sessions.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/sessions","permission":"service.cash.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceCashSessionsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionsReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.cash-document-archive.read.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.cash-document-archive.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/document-archive","permission":"service.cash.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceCashDocumentArchiveQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCashDocumentArchiveReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.cash-document-archive.file.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.cash-document-archive.file.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/document-archive/:documentId/file","permission":"service.cash.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceCashDocumentFileQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.cash-document.read.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.cash-document.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/document","permission":"service.cash.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceCashDocumentQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.check-payment.read.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.check-payment.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/check-payments/:paymentId","permission":"service.check-payment.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckPaymentReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.probe.read.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.probe.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/probe","permission":"service.probe.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceProbeReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.clock.read.v1":{"audiences":["panel","public"],"method":"GET","operation":"service.clock.read.v1","owner":"service","path":"/service/clock","permission":"service.clock.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceClockReadV1","response_statuses":[200],"scope":"none","side_effect":"none"},"service.offline-review.read.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.offline-review.read.v1","owner":"service","path":"/service/restaurants/:restaurantId/offline-review","permission":"service.offline-review.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceOfflineReviewQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceOfflineReviewReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.offline-segment.record.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.offline-segment.record.v1","owner":"service","path":"/service/restaurants/:restaurantId/offline-segment/record","permission":"service.offline-segment.record","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOfflineSegmentRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOfflineSegmentRecordV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.fulfillment.transition.kitchen.v2":{"audiences":["panel"],"canonical_roles":["KITCHEN","POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.fulfillment.transition.kitchen.v2","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment/transition/kitchen","permission":"service.fulfillment.transition","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentTransitionKitchenV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.manager.fulfillment.transition.kitchen.v2":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.manager.fulfillment.transition.kitchen.v2","owner":"service","path":"/service/restaurants/:restaurantId/manager/fulfillment/transition/kitchen","permission":"service.manager.fulfillment.transition","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentTransitionKitchenV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.fulfillment.remake.kitchen.v2":{"audiences":["panel"],"canonical_roles":["KITCHEN"],"method":"POST","operation":"service.fulfillment.remake.kitchen.v2","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment/remake/kitchen","permission":"service.fulfillment.remake","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceFulfillmentRemakeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentRemakeKitchenV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.fulfillment.transition.floor.v2":{"audiences":["panel"],"canonical_roles":["KITCHEN","POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.fulfillment.transition.floor.v2","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment/transition/floor","permission":"service.fulfillment.transition","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentTransitionFloorV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.manager.fulfillment.transition.floor.v2":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.manager.fulfillment.transition.floor.v2","owner":"service","path":"/service/restaurants/:restaurantId/manager/fulfillment/transition/floor","permission":"service.manager.fulfillment.transition","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentTransitionFloorV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.fulfillment.deliver-batch.floor.v2":{"audiences":["panel"],"canonical_roles":["POS","WAITER"],"method":"POST","operation":"service.fulfillment.deliver-batch.floor.v2","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment/deliver-batch/floor","permission":"service.fulfillment.deliver-batch","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentDeliverBatchFloorV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.manager.fulfillment.deliver-batch.floor.v2":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.manager.fulfillment.deliver-batch.floor.v2","owner":"service","path":"/service/restaurants/:restaurantId/manager/fulfillment/deliver-batch/floor","permission":"service.manager.fulfillment.deliver-batch","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentDeliverBatchFloorV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.bill-request.accept.floor.v2":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.bill-request.accept.floor.v2","owner":"service","path":"/service/restaurants/:restaurantId/bill-request/accept/floor","permission":"service.bill-request.accept","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceBillRequestAcceptRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceBillRequestAcceptFloorV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.table-session.nobody-here.floor.v2":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.table-session.nobody-here.floor.v2","owner":"service","path":"/service/restaurants/:restaurantId/table-session/nobody-here/floor","permission":"service.table-session.nobody-here","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceTableSessionNobodyHereRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionNobodyHereFloorV2","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.participant.join.v1":{"audiences":["guest"],"method":"POST","operation":"service.participant.join.v1","owner":"service","path":"/service/restaurants/:restaurantId/participant/join","permission":"service.participant.join","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceParticipantJoinRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceParticipantJoinV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.participant.request-bill.v1":{"audiences":["guest"],"method":"POST","operation":"service.participant.request-bill.v1","owner":"service","path":"/service/restaurants/:restaurantId/participant/request-bill","permission":"service.participant.request-bill","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceParticipantRequestBillRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceParticipantRequestBillV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.open.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.open.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/open","permission":"service.cart.open","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartOpenV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.add.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.item.add.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/item/add","permission":"service.cart.item.add","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemAddRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemAddV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.copy.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.item.copy.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/item/copy","permission":"service.cart.item.copy","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemCopyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemCopyV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.steal.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.item.steal.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/item/steal","permission":"service.cart.item.steal","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemStealRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemStealV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.steal.undo.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.item.steal.undo.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/item/steal/undo","permission":"service.cart.item.steal.undo","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemStealUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemStealUndoV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.safety.acknowledge.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.item.safety.acknowledge.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/item/safety/acknowledge","permission":"service.cart.item.safety.acknowledge","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemSafetyAcknowledgeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemSafetyAcknowledgeV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.update.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.item.update.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/item/update","permission":"service.cart.item.update","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemUpdateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.remove.v1":{"audiences":["guest"],"method":"POST","operation":"service.cart.item.remove.v1","owner":"service","path":"/service/restaurants/:restaurantId/cart/item/remove","permission":"service.cart.item.remove","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemRemoveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.diner.offer.choose.v1":{"audiences":["guest"],"method":"POST","operation":"service.diner.offer.choose.v1","owner":"service","path":"/service/restaurants/:restaurantId/diner/offer/choose","permission":"service.diner.offer.choose","policy":"guest-session","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferCouponRefusalHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceDinerOfferChooseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferChooseV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.diner.offer.remove.v1":{"audiences":["guest"],"method":"POST","operation":"service.diner.offer.remove.v1","owner":"service","path":"/service/restaurants/:restaurantId/diner/offer/remove","permission":"service.diner.offer.remove","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceDinerOfferRemoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferRemoveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.waiting-room.enter.v1":{"audiences":["guest"],"method":"POST","operation":"service.waiting-room.enter.v1","owner":"service","path":"/service/restaurants/:restaurantId/waiting-room/enter","permission":"service.waiting-room.enter","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceWaitingRoomEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceWaitingRoomEnterV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.waiting-room.leave.v1":{"audiences":["guest"],"method":"POST","operation":"service.waiting-room.leave.v1","owner":"service","path":"/service/restaurants/:restaurantId/waiting-room/leave","permission":"service.waiting-room.leave","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceWaitingRoomLeaveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceWaitingRoomLeaveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.submit.v1":{"audiences":["guest"],"method":"POST","operation":"service.order.submit.v1","owner":"service","path":"/service/restaurants/:restaurantId/order/submit","permission":"service.order.submit","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderSubmitRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderSubmitV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.item.add.v1":{"audiences":["guest"],"method":"POST","operation":"service.order.item.add.v1","owner":"service","path":"/service/restaurants/:restaurantId/order/item/add","permission":"service.order.item.add","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderItemAddRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemAddV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.item.update.v1":{"audiences":["guest"],"method":"POST","operation":"service.order.item.update.v1","owner":"service","path":"/service/restaurants/:restaurantId/order/item/update","permission":"service.order.item.update","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemUpdateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.item.remove.v1":{"audiences":["guest"],"method":"POST","operation":"service.order.item.remove.v1","owner":"service","path":"/service/restaurants/:restaurantId/order/item/remove","permission":"service.order.item.remove","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemRemoveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.table-session.open.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.table-session.open.v1","owner":"service","path":"/service/restaurants/:restaurantId/table-session/open","permission":"service.table-session.open","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceTableSessionOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionOpenV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.table-session.party-size.set.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.table-session.party-size.set.v1","owner":"service","path":"/service/restaurants/:restaurantId/table-session/party-size/set","permission":"service.table-session.party-size.set","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceTableSessionPartySizeSetRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionPartySizeSetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.table-session.close.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.table-session.close.v1","owner":"service","path":"/service/restaurants/:restaurantId/table-session/close","permission":"service.table-session.close","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceTableSessionCloseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionCloseV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.bill-request.accept.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.bill-request.accept.v1","owner":"service","path":"/service/restaurants/:restaurantId/bill-request/accept","permission":"service.bill-request.accept","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceBillRequestAcceptRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceBillRequestAcceptV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.bill-request.reopen.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.bill-request.reopen.v1","owner":"service","path":"/service/restaurants/:restaurantId/bill-request/reopen","permission":"service.bill-request.reopen","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceBillRequestReopenRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceBillRequestReopenV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.table-session.force-close.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.table-session.force-close.v1","owner":"service","path":"/service/restaurants/:restaurantId/table-session/force-close","permission":"service.table-session.force-close","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceTableSessionForceCloseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionForceCloseV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.force-close.reclassify.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.force-close.reclassify.v1","owner":"service","path":"/service/restaurants/:restaurantId/force-close/reclassify","permission":"service.force-close.reclassify","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceForceCloseReclassifyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceForceCloseReclassifyV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.participant.create.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.participant.create.v1","owner":"service","path":"/service/restaurants/:restaurantId/participant/create","permission":"service.participant.create","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceParticipantCreateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceParticipantCreateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.open.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cart.open.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/cart/open","permission":"service.cart.open","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartOpenStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.add.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cart.item.add.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/cart/item/add","permission":"service.cart.item.add","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemAddStaffRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemAddStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.update.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cart.item.update.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/cart/item/update","permission":"service.cart.item.update","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemUpdateStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.item.remove.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cart.item.remove.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/cart/item/remove","permission":"service.cart.item.remove","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemRemoveStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.diner.offer.choose.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.diner.offer.choose.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/diner/offer/choose","permission":"service.diner.offer.choose","policy":"restaurant-staff-write","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferCouponRefusalHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceDinerOfferChooseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferChooseStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.diner.offer.remove.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.diner.offer.remove.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/diner/offer/remove","permission":"service.diner.offer.remove","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceDinerOfferRemoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferRemoveStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cart.discard.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cart.discard.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/cart/discard","permission":"service.cart.discard","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCartDiscardRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartDiscardStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.submit.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.order.submit.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/order/submit","permission":"service.order.submit","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderSubmitStaffRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderSubmitStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.item.update.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.order.item.update.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/order/item/update","permission":"service.order.item.update","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemUpdateStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.item.remove.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.order.item.remove.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/order/item/remove","permission":"service.order.item.remove","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemRemoveStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.cancel.staff.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.order.cancel.staff.v1","owner":"service","path":"/service/restaurants/:restaurantId/staff/order/cancel","permission":"service.order.cancel","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderCancelRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderCancelStaffV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.fulfillment.transition.v1":{"audiences":["panel"],"canonical_roles":["KITCHEN","POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.fulfillment.transition.v1","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment/transition","permission":"service.fulfillment.transition","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentTransitionV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.fulfillment.remake.v1":{"audiences":["panel"],"canonical_roles":["KITCHEN"],"method":"POST","operation":"service.fulfillment.remake.v1","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment/remake","permission":"service.fulfillment.remake","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceFulfillmentRemakeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentRemakeV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.fulfillment.deliver-batch.v1":{"audiences":["panel"],"canonical_roles":["POS","WAITER"],"method":"POST","operation":"service.fulfillment.deliver-batch.v1","owner":"service","path":"/service/restaurants/:restaurantId/fulfillment/deliver-batch","permission":"service.fulfillment.deliver-batch","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentDeliverBatchV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.manager.fulfillment.transition.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.manager.fulfillment.transition.v1","owner":"service","path":"/service/restaurants/:restaurantId/manager/fulfillment/transition","permission":"service.manager.fulfillment.transition","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentTransitionV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.manager.fulfillment.deliver-batch.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.manager.fulfillment.deliver-batch.v1","owner":"service","path":"/service/restaurants/:restaurantId/manager/fulfillment/deliver-batch","permission":"service.manager.fulfillment.deliver-batch","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentDeliverBatchV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.check.finalize.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.check.finalize.v1","owner":"service","path":"/service/restaurants/:restaurantId/check/finalize","permission":"service.check.finalize","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckFinalizeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckFinalizeV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.check.charge.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.check.charge.v1","owner":"service","path":"/service/restaurants/:restaurantId/check/charge","permission":"service.check.charge","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckChargeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckChargeV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.check.charge.reverse.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.check.charge.reverse.v1","owner":"service","path":"/service/restaurants/:restaurantId/check/charge/reverse","permission":"service.check.charge.reverse","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckChargeReverseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckChargeReverseV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.check.line.waive.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.check.line.waive.v1","owner":"service","path":"/service/restaurants/:restaurantId/check/line/waive","permission":"service.check.line.waive","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckLineWaiveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckLineWaiveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.check.split.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.check.split.v1","owner":"service","path":"/service/restaurants/:restaurantId/check/split","permission":"service.check.split","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCheckSplitRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckSplitV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cash.movement.record.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cash.movement.record.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/movement/record","permission":"service.cash.movement.record","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCashMovementRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashMovementRecordV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cash.session.open.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cash.session.open.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/session/open","permission":"service.cash.session.open","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCashSessionOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionOpenV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cash.movement.void.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cash.movement.void.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/movement/void","permission":"service.cash.movement.void","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCashMovementVoidRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashMovementVoidV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cash.session.close.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cash.session.close.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/session/close","permission":"service.cash.session.close","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCashSessionCloseRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionCloseV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cash.session.count.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cash.session.count.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/session/count","permission":"service.cash.session.count","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCashSessionCountRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionCountV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.cash.payment-method.correct.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.cash.payment-method.correct.v1","owner":"service","path":"/service/restaurants/:restaurantId/cash/payment-method/correct","permission":"service.cash.payment-method.correct","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceCashPaymentMethodCorrectRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashPaymentMethodCorrectV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.order.confirm.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.order.confirm.v1","owner":"service","path":"/service/restaurants/:restaurantId/order/confirm","permission":"service.order.confirm","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOrderConfirmRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderConfirmV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.table-session.nobody-here.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","WAITER","SUPERADMIN"],"method":"POST","operation":"service.table-session.nobody-here.v1","owner":"service","path":"/service/restaurants/:restaurantId/table-session/nobody-here","permission":"service.table-session.nobody-here","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceTableSessionNobodyHereRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionNobodyHereV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.qr-orders.pause.set.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.qr-orders.pause.set.v1","owner":"service","path":"/service/restaurants/:restaurantId/qr-orders/pause/set","permission":"service.qr-orders.pause.set","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceQrOrdersPauseSetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceQrOrdersPauseSetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"service.offline-review.resolve.v1":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"service.offline-review.resolve.v1","owner":"service","path":"/service/restaurants/:restaurantId/offline-review/resolve","permission":"service.offline-review.resolve","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ServiceOfflineReviewResolveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOfflineReviewResolveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external-review.franchise-summaries.get":{"audiences":["panel"],"canonical_roles":["FRANCHISE_DIRECTOR"],"method":"GET","operation":"relationship.external-review.franchise-summaries.get","owner":"relationship","path":"/relationship/external-reviews/franchises/:franchiseId/summaries","permission":"relationship.external_review.franchise.read","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewFranchiseSummariesGet","response_statuses":[200],"scope":"franchise","side_effect":"none"},"relationship.external-review.connection.get":{"audiences":["panel"],"method":"GET","operation":"relationship.external-review.connection.get","owner":"relationship","path":"/relationship/external-reviews/google/connection","permission":"relationship.external_review.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.external-review.connection.start":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"relationship.external-review.connection.start","owner":"relationship","path":"/relationship/external-reviews/google/connection/start","permission":"relationship.external_review.connect","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"StartRelationshipGoogleConnectionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionStart","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external-review.connection.complete":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"relationship.external-review.connection.complete","owner":"relationship","path":"/relationship/external-reviews/google/connection/complete","permission":"relationship.external_review.connect","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CompleteRelationshipGoogleConnectionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionComplete","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external-review.connection.select":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"PUT","operation":"relationship.external-review.connection.select","owner":"relationship","path":"/relationship/external-reviews/google/connection","permission":"relationship.external_review.connect","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"SelectRelationshipGoogleLocationRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionSelect","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external-review.connection.disconnect":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"DELETE","operation":"relationship.external-review.connection.disconnect","owner":"relationship","path":"/relationship/external-reviews/google/connection","permission":"relationship.external_review.connect","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"DisconnectRelationshipGoogleConnectionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionDisconnect","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external-review.list":{"audiences":["panel"],"method":"GET","operation":"relationship.external-review.list","owner":"relationship","path":"/relationship/external-reviews","permission":"relationship.external_review.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.external_review.reply":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"PUT","operation":"relationship.external_review.reply","owner":"relationship","path":"/relationship/external-reviews/:reviewId/reply","permission":"relationship.external_review.reply","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReplyRelationshipExternalReviewRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReply","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external_review.reply.delete":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"DELETE","operation":"relationship.external_review.reply.delete","owner":"relationship","path":"/relationship/external-reviews/:reviewId/reply","permission":"relationship.external_review.reply","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"DeleteRelationshipExternalReviewReplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReplyDelete","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external_review.reply.publish":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"relationship.external_review.reply.publish","owner":"relationship","path":"/relationship/external-reviews/:reviewId/reply/publish","permission":"relationship.external_review.reply","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PublishRelationshipExternalReviewReplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReplyPublish","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.external_review.reply.undo":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"relationship.external_review.reply.undo","owner":"relationship","path":"/relationship/external-reviews/:reviewId/reply/undo","permission":"relationship.external_review.reply","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"UndoRelationshipExternalReviewReplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReplyUndo","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.review-topics.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"relationship.review-topics.read.v1","owner":"relationship","path":"/relationship/reviews/topics","permission":"relationship.review.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"RelationshipReviewTopicsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewTopicsReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.review-stars-weekly.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"relationship.review-stars-weekly.read.v1","owner":"relationship","path":"/relationship/reviews/stars/weekly","permission":"relationship.review.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"RelationshipReviewStarsWeeklyRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewStarsWeeklyReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.el-parte-guest-return.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"relationship.el-parte-guest-return.read.v1","owner":"relationship","path":"/relationship/el-parte/guest-return","permission":"relationship.preferences.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"RelationshipGuestReturnPanelRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipElParteGuestReturnReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.restaurant-reviews.list.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"relationship.restaurant-reviews.list.v1","owner":"relationship","path":"/relationship/reviews/restaurant","permission":"relationship.review.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"RelationshipRestaurantReviewsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipRestaurantReviewsListV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.review.offer.read.guest.v1":{"audiences":["guest"],"method":"GET","operation":"relationship.review.offer.read.guest.v1","owner":"relationship","path":"/relationship/reviews/offer","permission":"relationship.review.submit","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ReadRelationshipReviewOfferRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewOfferReadGuestV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.guest-question.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"relationship.guest-question.read.v1","owner":"relationship","path":"/relationship/guest-question","permission":"relationship.review.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.guest-question.put.v1":{"audiences":["panel"],"method":"PUT","operation":"relationship.guest-question.put.v1","owner":"relationship","path":"/relationship/guest-question","permission":"relationship.loyalty.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PutRelationshipGuestQuestionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionPutV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.guest-question.remove.v1":{"audiences":["panel"],"method":"POST","operation":"relationship.guest-question.remove.v1","owner":"relationship","path":"/relationship/guest-question/remove","permission":"relationship.loyalty.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RemoveRelationshipGuestQuestionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionRemoveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.guest-question.offer.read.guest.v1":{"audiences":["guest"],"method":"GET","operation":"relationship.guest-question.offer.read.guest.v1","owner":"relationship","path":"/relationship/guest-question/offer","permission":"relationship.review.submit","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ReadRelationshipGuestQuestionOfferRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionOfferReadGuestV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.guest-question.answer.guest.v1":{"audiences":["guest"],"method":"POST","operation":"relationship.guest-question.answer.guest.v1","owner":"relationship","path":"/relationship/guest-question/answers","permission":"relationship.review.submit","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"AnswerRelationshipGuestQuestionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionAnswerGuestV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.review.submit":{"audiences":["guest"],"method":"POST","operation":"relationship.review.submit","owner":"relationship","path":"/relationship/reviews","permission":"relationship.review.submit","policy":"guest-session","public":false,"refusal_responses":[{"schema":"RelationshipConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"SubmitRelationshipReviewRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewSubmit","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.loyalty.program.admin-get":{"audiences":["panel"],"method":"GET","operation":"relationship.loyalty.program.admin-get","owner":"relationship","path":"/relationship/loyalty/program/admin","permission":"relationship.loyalty.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyProgramAdminGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.loyalty.tier-catalogue.list":{"audiences":["panel"],"method":"GET","operation":"relationship.loyalty.tier-catalogue.list","owner":"relationship","path":"/relationship/loyalty/tier-catalogue","permission":"relationship.loyalty.tier-catalogue.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyTierCatalogueList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.loyalty.population.get":{"audiences":["panel"],"method":"GET","operation":"relationship.loyalty.population.get","owner":"relationship","path":"/relationship/loyalty/population","permission":"relationship.loyalty.population.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyPopulationGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.loyalty.program.put":{"audiences":["panel"],"method":"PUT","operation":"relationship.loyalty.program.put","owner":"relationship","path":"/relationship/loyalty/program","permission":"relationship.loyalty.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PutRelationshipLoyaltyProgramRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyProgramPut","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.loyalty.program.retire":{"audiences":["panel"],"method":"POST","operation":"relationship.loyalty.program.retire","owner":"relationship","path":"/relationship/loyalty/program/retire","permission":"relationship.loyalty.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RetireRelationshipLoyaltyProgramRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyProgramRetire","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.preferences.get":{"audiences":["guest"],"method":"GET","operation":"relationship.preferences.get","owner":"relationship","path":"/relationship/preferences","permission":"relationship.preferences.read","policy":"guest-session","public":false,"refusal_responses":[{"schema":"RelationshipConstraintLookupFailedHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipPreferencesGet","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.preferences.replace":{"audiences":["guest"],"method":"PUT","operation":"relationship.preferences.replace","owner":"relationship","path":"/relationship/preferences","permission":"relationship.preferences.replace","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ReplaceRelationshipPreferencesRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipPreferencesReplace","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.recommendation.current.read.guest.v1":{"audiences":["guest"],"method":"GET","operation":"relationship.recommendation.current.read.guest.v1","owner":"relationship","path":"/relationship/recommendations/current","permission":"relationship.recommendation.assign","policy":"guest-session","public":false,"refusal_responses":[{"schema":"RelationshipAssignmentRefreshRequiredHttpError","status":409},{"schema":"RelationshipConstraintLookupFailedHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ReadCurrentRelationshipRecommendationRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipRecommendationCurrentReadGuestV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.recommendation.assign":{"audiences":["guest"],"method":"POST","operation":"relationship.recommendation.assign","owner":"relationship","path":"/relationship/recommendations","permission":"relationship.recommendation.assign","policy":"guest-session","public":false,"refusal_responses":[{"schema":"RelationshipConstraintLookupFailedHttpError","status":503}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"AssignRelationshipRecommendationRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipRecommendationAssign","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.impression.record":{"audiences":["guest"],"method":"POST","operation":"relationship.impression.record","owner":"relationship","path":"/relationship/impressions","permission":"relationship.impression.record","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RecordRelationshipRecommendationImpressionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipImpressionRecord","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"relationship.feedback.record":{"audiences":["guest"],"method":"POST","operation":"relationship.feedback.record","owner":"relationship","path":"/relationship/feedback","permission":"relationship.feedback.record","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"RecordRelationshipFeedbackRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipFeedbackRecord","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"insights.franchise.metrics":{"audiences":["panel"],"method":"GET","operation":"insights.franchise.metrics","owner":"insights","path":"/insights/franchises/:franchiseId/metrics","permission":"insights.metrics.read","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsFranchiseMetrics","response_statuses":[200],"scope":"franchise","side_effect":"none"},"insights.restaurant.period":{"audiences":["panel"],"method":"GET","operation":"insights.restaurant.period","owner":"insights","path":"/insights/restaurants/:restaurantId/period","permission":"insights.metrics.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InsightsPeriodQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsRestaurantPeriod","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"insights.loyalty.period":{"audiences":["panel"],"method":"GET","operation":"insights.loyalty.period","owner":"insights","path":"/insights/restaurants/:restaurantId/loyalty/period","permission":"relationship.loyalty.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InsightsLoyaltyPeriodQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsLoyaltyPeriod","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"insights.restaurant.promotion-month":{"audiences":["panel"],"method":"GET","operation":"insights.restaurant.promotion-month","owner":"insights","path":"/insights/restaurants/:restaurantId/promotions/monthly","permission":"insights.promotions.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InsightsPromotionMonthQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsRestaurantPromotionMonth","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"insights.restaurant.flavour-profile":{"audiences":["panel"],"method":"GET","operation":"insights.restaurant.flavour-profile","owner":"insights","path":"/insights/restaurants/:restaurantId/flavour-profile","permission":"insights.metrics.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InsightsFlavourProfileQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsRestaurantFlavourProfile","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.edition.read":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.edition.read","owner":"parte","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEditionRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.edition.list":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.edition.list","owner":"parte","path":"/parte/restaurants/:restaurantId/editions","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteEditionListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEditionList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.work.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.work.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/work","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteWorkReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.notebook.read":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.notebook.read","owner":"parte","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate/notebook","permission":"parte.notebook.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteNotebookRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.pendientes.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.pendientes.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/pendientes","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"PartePendientesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePendientesReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.pendiente.dismiss.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.pendiente.dismiss.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/pendientes/:pendienteId/dismiss","permission":"parte.pendiente.dismiss","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePendienteDismissRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePendienteDismissV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.costs.dishes.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.costs.dishes.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/costs/dishes","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteDishCostsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteCostsDishesReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.costs.recipe-batch.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.costs.recipe-batch.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/costs/recipe-batch","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.costs.recipe-batch.confirm.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.costs.recipe-batch.confirm.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/confirm","permission":"parte.recipe-batch.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteRecipeBatchConfirmRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchConfirmV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.costs.recipe-batch.withdraw.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.costs.recipe-batch.withdraw.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/withdraw","permission":"parte.recipe-batch.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteRecipeBatchWithdrawRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchWithdrawV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.costs.recipe-batch.undo.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.costs.recipe-batch.undo.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/undo","permission":"parte.recipe-batch.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteRecipeBatchUndoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchUndoV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.costs.recipe-batch.correct.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.costs.recipe-batch.correct.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/correct","permission":"parte.recipe-batch.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteRecipeBatchCorrectRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchCorrectV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.finanzas.daily-account.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.finanzas.daily-account.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/finanzas/daily-account","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteFinanzasReadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasDailyAccountReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.finanzas.number-of-today.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.finanzas.number-of-today.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/finanzas/number-of-today","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteFinanzasReadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasNumberOfTodayReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.finanzas.fixed-costs.declare.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.finanzas.fixed-costs.declare.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/finanzas/fixed-costs","permission":"parte.finanzas.declare","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteFixedCostsDeclareRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasFixedCostsDeclareV1","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.finanzas.labour-averages.declare.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.finanzas.labour-averages.declare.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/finanzas/labour-averages","permission":"parte.finanzas.declare","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteLabourAveragesDeclareRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasLabourAveragesDeclareV1","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.edition-audio.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.edition-audio.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate/audio","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEditionAudioReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.edition-audio.segment.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.edition-audio.segment.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate/audio/segments/:segmentIndex","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.voice-answer.submit.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.voice-answer.submit.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/voice-answers","permission":"parte.question.answer","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":["audio"],"request_max_bytes":4194304,"request_media_type":"multipart/form-data","request_schema":"ParteVoiceAnswerSubmitRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteVoiceAnswerSubmitV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation"},"parte.push-key.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.push-key.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/push/key","permission":"parte.push.subscribe","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePushKeyReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.push-subscription.register.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.push-subscription.register.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/push/subscriptions","permission":"parte.push.subscribe","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePushSubscriptionRegisterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePushSubscriptionRegisterV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation"},"parte.push-subscription.remove.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.push-subscription.remove.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/push/subscriptions/:subscriptionId/remove","permission":"parte.push.subscribe","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePushSubscriptionRemoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePushSubscriptionRemoveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation"},"parte.pacto.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.pacto.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/pacto","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePactoReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.pacto.line.put.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.pacto.line.put.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/pacto/lines","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePactoLinePutRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePactoLinePutV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.pacto.line.confirm.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.pacto.line.confirm.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/pacto/lines/confirm","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePactoLineConfirmRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePactoLineConfirmV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.pacto.line.retire.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.pacto.line.retire.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/pacto/lines/retire","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePactoLineRetireRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePactoLineRetireV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.team-stop.set.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"PUT","operation":"parte.team-stop.set.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/team-stop","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteTeamStopSetRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteTeamStopSetV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.operation.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.operation.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/operations/:operationId","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteOperationReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.operation.approve.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.operation.approve.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/operations/:operationId/approve","permission":"parte.operation.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteOperationApproveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteOperationApproveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.operation.decline.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.operation.decline.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/operations/:operationId/decline","permission":"parte.operation.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteOperationDeclineRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteOperationDeclineV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.operation.resolve.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.operation.resolve.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/operations/:operationId/resolve","permission":"parte.operation.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteOperationResolveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteOperationResolveV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.scheduled-action.stop.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.scheduled-action.stop.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/scheduled-actions/:actionId/stop","permission":"parte.operation.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteScheduledActionStopRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteScheduledActionStopV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.team-action.undo.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.team-action.undo.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/team-actions/:actionId/undo","permission":"parte.operation.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteTeamActionUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteTeamActionUndoV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.work.act.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.work.act.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/work/:itemId/act","permission":"parte.operation.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteWorkActRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteWorkActV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.autonomy.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.autonomy.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/autonomy","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteAutonomyReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.autonomy.offer.answer.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.autonomy.offer.answer.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/autonomy/offers/answer","permission":"parte.autonomy.decide","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteAutonomyOfferAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteAutonomyOfferAnswerV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.hoy.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.hoy.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/hoy/:businessDate","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteHoyReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.house-memory.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.house-memory.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/house-memory","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteHouseMemoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteHouseMemoryReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.compras.call-list.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.compras.call-list.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/compras/call-list","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteCallListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComprasCallListReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.compras.prep-plan.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.compras.prep-plan.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/compras/prep-plan","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteCallListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComprasPrepPlanReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.compras.food-waste-plan.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.compras.food-waste-plan.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/compras/food-waste-plan","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteFoodWastePlanQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComprasFoodWastePlanReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.compras.food-waste-plan.adopt.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.compras.food-waste-plan.adopt.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/compras/food-waste-plan/adopt","permission":"parte.question.answer","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteFoodWastePlanAdoptRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteComprasFoodWastePlanAdoptV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.compras.food-waste-plan.update.decline.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.compras.food-waste-plan.update.decline.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/compras/food-waste-plan/update/decline","permission":"parte.question.answer","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteFoodWastePlanUpdateDeclineRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteComprasFoodWastePlanUpdateDeclineV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.team.coach.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.team.coach.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/team/coach","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteCoachQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteTeamCoachReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.team.coach.note.share.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.team.coach.note.share.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/team/coach/share","permission":"parte.coach.share","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteCoachShareRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteTeamCoachNoteShareV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.rota-proposal.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.rota-proposal.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/rota-proposal","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteRotaProposalQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteRotaProposalReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.ai-audit.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.ai-audit.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/ai-audit","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteAiAuditQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteAiAuditReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.compliance-calendar.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.compliance-calendar.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/compliance-calendar","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComplianceCalendarReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.consejo.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.consejo.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/consejo/:month","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteConsejoReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.consejo-pdf.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.consejo-pdf.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/consejo/:month/pdf","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.missing-data.answer.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.missing-data.answer.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/missing-data/:questionId/answer","permission":"parte.question.answer","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteMissingDataAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteMissingDataAnswerV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.carta-reading.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.carta-reading.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/carta-reading","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteCartaReadingReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.carta-reading.correct.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.carta-reading.correct.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/carta-reading/:categoryId","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteCartaReadingCorrectRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCartaReadingCorrectV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.encargo.create.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.encargo.create.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/encargos/requests","permission":"parte.consulta.request","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteEncargoCreateRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteEncargoCreateV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.encargos.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.encargos.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/encargos/requests","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEncargosReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.encargo.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.encargo.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/encargos/requests/:encargoId","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEncargoReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.page-notes.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.page-notes.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/page-notes/:page","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePageNotesReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.reputation.drafts.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.reputation.drafts.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/reputation/drafts","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteReputationDraftsReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.reputation.reply-draft.set-aside.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.reputation.reply-draft.set-aside.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/reputation/reply-drafts/:reviewId/set-aside","permission":"parte.question.answer","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteReplyDraftSetAsideRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteReputationReplyDraftSetAsideV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.reputation.post-draft.use.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.reputation.post-draft.use.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/reputation/post-drafts/:draftId/use","permission":"parte.question.answer","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePostDraftDecisionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteReputationPostDraftUseV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.reputation.post-draft.withdraw.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.reputation.post-draft.withdraw.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/reputation/post-drafts/:draftId/withdraw","permission":"parte.question.answer","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePostDraftDecisionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteReputationPostDraftWithdrawV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.team.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.team.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/team","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteTeamReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.what-if.dish-price.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.what-if.dish-price.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/what-if/dish-price","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteWhatIfDishPriceRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteWhatIfDishPriceReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.what-if.closed-weekday.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.what-if.closed-weekday.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/what-if/closed-weekday","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteWhatIfClosedWeekdayRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteWhatIfClosedWeekdayReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.goals.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.goals.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/goals","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ParteGoalsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteGoalsReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.queue.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.queue.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/queue","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteQueueReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.matter.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.matter.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/matters/:matterId","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteMatterReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.goal.say.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.goal.say.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/goals","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteGoalSayRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalSayV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.goal.confirm.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.goal.confirm.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/goals/:goalId/confirm","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteGoalConfirmRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalConfirmV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.goal.correct.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.goal.correct.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/goals/:goalId/correct","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteGoalCorrectRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalCorrectV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.goal.decline.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.goal.decline.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/goals/:goalId/decline","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteGoalDeclineRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalDeclineV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.goal.withdraw.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.goal.withdraw.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/goals/:goalId/withdraw","permission":"parte.pacto.write","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteGoalWithdrawRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalWithdrawV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.queue.answer.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.queue.answer.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/queue/:itemId/answer","permission":"parte.operation.decide","policy":"restaurant-admin","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteQueueAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteQueueAnswerV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.matters.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.matters.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/matters","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteMattersReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.request.open.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.request.open.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/requests","permission":"parte.consulta.request","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteRequestOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteRequestOpenV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.advisor-library.read.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"parte.advisor-library.read.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/advisor-library","permission":"parte.edition.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteAdvisorLibraryReadV1","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"parte.advisor-library.review.v1":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.advisor-library.review.v1","owner":"parte","path":"/parte/restaurants/:restaurantId/advisor-library/reviews","permission":"parte.advisor-library.review","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ParteAdvisorLibraryReviewRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteAdvisorLibraryReviewV1","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"parte.person.withdraw":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"parte.person.withdraw","owner":"parte","path":"/parte/restaurants/:restaurantId/person-withdrawals","permission":"parte.person.withdraw","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"PartePersonWithdrawalRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePersonWithdraw","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"insights.parte-radar.read":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"insights.parte-radar.read","owner":"parte","path":"/insights/restaurants/:restaurantId/parte-radar","permission":"insights.metrics.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InsightsParteRadarQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsParteRadarRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"owner-calendar.list":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"owner-calendar.list","owner":"proposals","path":"/proposals/restaurants/:restaurantId/calendar","permission":"proposal.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"OwnerCalendarWindowQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"owner-calendar.history":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"owner-calendar.history","owner":"proposals","path":"/proposals/restaurants/:restaurantId/calendar/:declarationId/history","permission":"proposal.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarHistory","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"owner-calendar.put":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"PUT","operation":"owner-calendar.put","owner":"proposals","path":"/proposals/restaurants/:restaurantId/calendar/:declarationId","permission":"preference.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"OwnerCalendarPutRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarPut","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"owner-calendar.cancel":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"owner-calendar.cancel","owner":"proposals","path":"/proposals/restaurants/:restaurantId/calendar/:declarationId/cancel","permission":"preference.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"OwnerCalendarCancelRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarCancel","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"proposal.catalog-reviewed.prepare":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"proposal.catalog-reviewed.prepare","owner":"proposals","path":"/proposals/restaurants/:restaurantId/catalog-reviewed/preparations","permission":"proposal.confirm","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"CatalogReviewedPrepareRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalCatalogReviewedPrepare","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"proposal.catalog-reviewed.preparation.read":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"proposal.catalog-reviewed.preparation.read","owner":"proposals","path":"/proposals/restaurants/:restaurantId/catalog-reviewed/preparations/:requestId","permission":"proposal.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalCatalogReviewedPreparationRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"proposal.intent.list":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"proposal.intent.list","owner":"proposals","path":"/proposals/restaurants/:restaurantId/intents","permission":"proposal.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalIntentList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"proposal.intent.read":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"proposal.intent.read","owner":"proposals","path":"/proposals/restaurants/:restaurantId/intents/:intentId","permission":"proposal.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalIntentRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"proposal.preview":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"proposal.preview","owner":"proposals","path":"/proposals/restaurants/:restaurantId/intents/:intentId/preview","permission":"proposal.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalPreview","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"proposal.confirm":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"proposal.confirm","owner":"proposals","path":"/proposals/restaurants/:restaurantId/intents/:intentId/confirm","permission":"proposal.confirm","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ProposalConfirmRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalConfirm","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"proposal.decline":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"proposal.decline","owner":"proposals","path":"/proposals/restaurants/:restaurantId/intents/:intentId/decline","permission":"proposal.decline","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ProposalDeclineRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalDecline","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"proposal.undo":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"proposal.undo","owner":"proposals","path":"/proposals/restaurants/:restaurantId/intents/:intentId/undo","permission":"proposal.undo","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"ProposalUndoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalUndo","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.configuration.read":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"billing.configuration.read","owner":"billing","path":"/restaurants/:restaurantId/billing","permission":"billing.manage","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingConfigurationRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.configuration.apply":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"PUT","operation":"billing.configuration.apply","owner":"billing","path":"/restaurants/:restaurantId/billing","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingConfigurationApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingConfigurationApply","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.provider.connect":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"PUT","operation":"billing.provider.connect","owner":"billing","path":"/restaurants/:restaurantId/billing/provider","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingProviderConnectRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingProviderConnect","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.provider.disconnect":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"DELETE","operation":"billing.provider.disconnect","owner":"billing","path":"/restaurants/:restaurantId/billing/provider","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingProviderDisconnect","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.activate":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.activate","owner":"billing","path":"/restaurants/:restaurantId/billing/activate","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingActivateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingActivate","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.documents.by-check":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.documents.by-check","owner":"billing","path":"/restaurants/:restaurantId/billing/checks/:checkId/documents","permission":"billing.document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingDocumentsByCheck","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.documents.by-checks":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.documents.by-checks","owner":"billing","path":"/restaurants/:restaurantId/billing/checks/documents","permission":"billing.document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"BillingDocumentsByChecksQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingDocumentsByChecks","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.document.read":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.document.read","owner":"billing","path":"/restaurants/:restaurantId/billing/documents/:documentId","permission":"billing.document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingDocumentRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.document.download":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.document.download","owner":"billing","path":"/restaurants/:restaurantId/billing/documents/:documentId/pdf","permission":"billing.document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.intent.read":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.intent.read","owner":"billing","path":"/restaurants/:restaurantId/billing/intents/:intentId","permission":"billing.document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingIntentRead","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.intent.download":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.intent.download","owner":"billing","path":"/restaurants/:restaurantId/billing/intents/:intentId/pdf","permission":"billing.document.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.request.create":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"billing.request.create","owner":"billing","path":"/restaurants/:restaurantId/billing/requests","permission":"billing.request.create","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingRequestCreateRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingRequestCreate","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.status.summary":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.status.summary","owner":"billing","path":"/restaurants/:restaurantId/billing/status","permission":"billing.status.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingStatusSummary","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.intent.retry":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.intent.retry","owner":"billing","path":"/restaurants/:restaurantId/billing/intents/:intentId/retry","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingIntentActionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentRetry","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.intent.void":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.intent.void","owner":"billing","path":"/restaurants/:restaurantId/billing/intents/:intentId/void","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingIntentActionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentVoid","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.document.render":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.document.render","owner":"billing","path":"/restaurants/:restaurantId/billing/documents/:documentId/render","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingIntentActionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingDocumentRender","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.fiscal-incidents.list":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"billing.fiscal-incidents.list","owner":"billing","path":"/restaurants/:restaurantId/billing/fiscal-incidents","permission":"billing.manage","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingFiscalIncidentsList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.fiscal-incident.record":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.fiscal-incident.record","owner":"billing","path":"/restaurants/:restaurantId/billing/fiscal-incidents","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingFiscalIncidentRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingFiscalIncidentRecord","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.fiscal-incident.move":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.fiscal-incident.move","owner":"billing","path":"/restaurants/:restaurantId/billing/fiscal-incidents/:incidentId/state","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingFiscalIncidentMoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingFiscalIncidentMove","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.document.legible-copy":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.document.legible-copy","owner":"billing","path":"/restaurants/:restaurantId/billing/documents/:documentId/legible-copy","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingLegibleCopyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingDocumentLegibleCopy","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.incidents.list":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"billing.incidents.list","owner":"billing","path":"/restaurants/:restaurantId/billing/incidents","permission":"billing.manage","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"BillingIncidentListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingIncidentsList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.issuer-succession.record":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.issuer-succession.record","owner":"billing","path":"/restaurants/:restaurantId/billing/issuer-successions","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingIssuerSuccessionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIssuerSuccessionRecord","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.intent.complete":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"billing.intent.complete","owner":"billing","path":"/restaurants/:restaurantId/billing/intents/:intentId/complete","permission":"billing.request.create","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingIntentCompleteRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentComplete","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.intent.reissue":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.intent.reissue","owner":"billing","path":"/restaurants/:restaurantId/billing/intents/:intentId/reissue","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingIntentReissueRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentReissue","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.export.prepare":{"audiences":["panel"],"canonical_roles":["FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"billing.export.prepare","owner":"billing","path":"/restaurants/:restaurantId/billing/exports","permission":"service.history.export","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingExportPrepareRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingExportPrepare","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.export.list":{"audiences":["panel"],"canonical_roles":["FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.export.list","owner":"billing","path":"/restaurants/:restaurantId/billing/exports","permission":"service.history.export","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"BillingExportListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingExportList","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.export.download":{"audiences":["panel"],"canonical_roles":["FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"billing.export.download","owner":"billing","path":"/restaurants/:restaurantId/billing/exports/:exportId/file","permission":"service.history.export","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"billing.offline-intents.release":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"POST","operation":"billing.offline-intents.release","owner":"billing","path":"/restaurants/:restaurantId/billing/offline-intents/release","permission":"billing.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingOfflineIntentsReleaseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingOfflineIntentsRelease","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.payment.invoice":{"audiences":["panel"],"canonical_roles":["POS","RESTAURANT_MANAGER","SUPERADMIN"],"method":"POST","operation":"billing.payment.invoice","owner":"billing","path":"/restaurants/:restaurantId/billing/payments/:paymentId/invoice","permission":"billing.request.create","policy":"restaurant-staff-write","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":"application/json","request_schema":"BillingPaymentInvoiceRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingPaymentInvoice","response_statuses":[200,201],"scope":"restaurant","side_effect":"mutation-and-audit"},"billing.invoice-link.read.v1":{"audiences":["guest","public"],"method":"GET","operation":"billing.invoice-link.read.v1","owner":"billing","path":"/billing/invoice-links/:token","permission":"billing.invoice-link.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingInvoiceLinkReadV1","response_statuses":[200],"scope":"none","side_effect":"none"},"billing.invoice-link.document.v1":{"audiences":["guest","public"],"method":"GET","operation":"billing.invoice-link.document.v1","owner":"billing","path":"/billing/invoice-links/:token/document","permission":"billing.invoice-link.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"BillingInvoiceLinkDocumentQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"scope":"none","side_effect":"none"},"offers.bridge.definition-put.revalidate":{"audiences":["panel"],"method":"GET","operation":"offers.bridge.definition-put.revalidate","owner":"offers","path":"/offers/restaurants/:restaurantId/bridge/definition-put","permission":"offers.definition.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"OffersBridgePutQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersBridgeDefinitionPutRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"offers.bridge.definition-retire.revalidate":{"audiences":["panel"],"method":"GET","operation":"offers.bridge.definition-retire.revalidate","owner":"offers","path":"/offers/restaurants/:restaurantId/bridge/definition-retire","permission":"offers.definition.retire","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"OffersBridgeRetireQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersBridgeDefinitionRetireRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.bridge.stock-item-reconcile.revalidate":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.bridge.stock-item-reconcile.revalidate","owner":"inventory","path":"/inventory/restaurants/:restaurantId/bridge/stock-item-reconcile","permission":"inventory.stock-item.reconcile","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryBridgeReconcileQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryBridgeStockItemReconcileRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"inventory.bridge.stock-item.revalidate":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","FRANCHISE_DIRECTOR","RESTAURANT_MANAGER","STOCKROOM"],"method":"GET","operation":"inventory.bridge.stock-item.revalidate","owner":"inventory","path":"/inventory/restaurants/:restaurantId/bridge/stock-item","permission":"inventory.stock-item.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"InventoryBridgeItemQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryBridgeStockItemRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.bridge.history.revalidate":{"audiences":["panel"],"canonical_roles":["ANALYST","DELIVERY","FRANCHISE_DIRECTOR","HR","KITCHEN","MARKETING","POS","RESTAURANT_EMPLOYEE","RESTAURANT_MANAGER","STOCKROOM","SUPERADMIN","WAITER"],"method":"GET","operation":"service.bridge.history.revalidate","owner":"service","path":"/service/restaurants/:restaurantId/bridge/history","permission":"service.history.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceBridgeHistoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceBridgeHistoryRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"service.bridge.table-session-force-close.revalidate":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER","SUPERADMIN"],"method":"GET","operation":"service.bridge.table-session-force-close.revalidate","owner":"service","path":"/service/restaurants/:restaurantId/bridge/table-session-force-close","permission":"service.table-session.force-close","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ServiceBridgeForceCloseQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceBridgeTableSessionForceCloseRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.bridge.feedback-create.revalidate":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.bridge.feedback-create.revalidate","owner":"workforce","path":"/workforce/restaurants/:restaurantId/bridge/feedback-create","permission":"workforce.feedback.create","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"WorkforceBridgeFeedbackQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceBridgeFeedbackCreateRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.bridge.work-target-assignment-bulk-apply.revalidate":{"audiences":["panel"],"canonical_roles":["SUPERADMIN","HR","RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.bridge.work-target-assignment-bulk-apply.revalidate","owner":"workforce","path":"/workforce/restaurants/:restaurantId/bridge/work-target-assignment-bulk-apply","permission":"workforce.work-target-assignment.bulk-apply","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"WorkforceBridgeBulkQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceBridgeWorkTargetAssignmentBulkApplyRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"workforce.bridge.staff-notice-compose.revalidate":{"audiences":["panel"],"canonical_roles":["RESTAURANT_MANAGER"],"method":"GET","operation":"workforce.bridge.staff-notice-compose.revalidate","owner":"workforce","path":"/workforce/restaurants/:restaurantId/bridge/staff-notice-compose","permission":"workforce.staff-notice.compose","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"WorkforceBridgeStaffNoticeQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceBridgeStaffNoticeComposeRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"catalog.bridge.draft-replace.revalidate":{"audiences":["panel"],"method":"GET","operation":"catalog.bridge.draft-replace.revalidate","owner":"catalog","path":"/catalogs/:restaurantId/bridge/draft-replace","permission":"catalog.draft.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogBridgeDraftQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogBridgeDraftReplaceRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"catalog.bridge.media-write.revalidate":{"audiences":["panel"],"method":"GET","operation":"catalog.bridge.media-write.revalidate","owner":"catalog","path":"/catalogs/:restaurantId/bridge/media-write","permission":"catalog.media.write","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogBridgeMediaQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogBridgeMediaWriteRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"catalog.bridge.publish.revalidate":{"audiences":["panel"],"method":"GET","operation":"catalog.bridge.publish.revalidate","owner":"catalog","path":"/catalogs/:restaurantId/bridge/publish","permission":"catalog.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"CatalogBridgePublishQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogBridgePublishRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"restaurant-configuration.bridge.apply.revalidate":{"audiences":["panel"],"method":"GET","operation":"restaurant-configuration.bridge.apply.revalidate","owner":"restaurant_configuration","path":"/restaurant-configurations/:restaurantId/bridge/apply","permission":"restaurant.configuration.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ConfigurationBridgeApplyQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRestaurantConfigurationBridgeApplyRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"restaurant-configuration.bridge.floor.revalidate":{"audiences":["panel"],"method":"GET","operation":"restaurant-configuration.bridge.floor.revalidate","owner":"restaurant_configuration","path":"/restaurant-configurations/:restaurantId/bridge/floor","permission":"restaurant.configuration.publish","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"ConfigurationBridgeFloorQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRestaurantConfigurationBridgeFloorRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"relationship.bridge.loyalty-program-put.revalidate":{"audiences":["panel"],"method":"GET","operation":"relationship.bridge.loyalty-program-put.revalidate","owner":"relationship","path":"/relationship/restaurants/:restaurantId/bridge/loyalty-program-put","permission":"relationship.loyalty.manage","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_max_bytes":null,"request_media_type":null,"request_schema":"RelationshipBridgeProgramQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipBridgeLoyaltyProgramPutRevalidate","response_statuses":[200],"scope":"restaurant","side_effect":"none"}} as const
export const IDENTITY_OPERATION_METADATA = {"POST /auth/2fa/delete-secret":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/delete-secret","owner":"identity-access","path":"/auth/2fa/delete-secret","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faDeleteSecret","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faDeleteSecret","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/2fa/disable":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/disable","owner":"identity-access","path":"/auth/2fa/disable","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faDisable","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faDisable","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/2fa/enable":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/enable","owner":"identity-access","path":"/auth/2fa/enable","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faEnable","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faEnable","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/2fa/generate":{"audiences":["panel"],"method":"POST","operation":"POST /auth/2fa/generate","owner":"identity-access","path":"/auth/2fa/generate","permission":"identity.second-factor.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faGenerate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faGenerate","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /auth/current":{"audiences":["panel"],"method":"GET","operation":"GET /auth/current","owner":"identity-access","path":"/auth/current","permission":"identity.session.read","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETAuthCurrent","response_statuses":[200],"scope":"none","side_effect":"none"},"POST /auth/employee-invitations/claim":{"audiences":["panel","public"],"method":"POST","operation":"POST /auth/employee-invitations/claim","owner":"identity-access","path":"/auth/employee-invitations/claim","permission":"identity.invitation.claim","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestEmployeeInvitationClaim","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthEmployeeInvitationsClaim","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/employee-invitations/recover":{"audiences":["panel","public"],"method":"POST","operation":"POST /auth/employee-invitations/recover","owner":"identity-access","path":"/auth/employee-invitations/recover","permission":"identity.invitation.recover","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestEmployeeInvitationRecover","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthEmployeeInvitationsRecover","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/login":{"audiences":["panel","public"],"method":"POST","operation":"POST /auth/login","owner":"identity-access","path":"/auth/login","permission":"identity.login","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLogin","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLogin","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/login/memberships":{"audiences":["panel"],"method":"POST","operation":"POST /auth/login/memberships","owner":"identity-access","path":"/auth/login/memberships","permission":"identity.login.memberships.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLoginMembershipSelectionRead","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLoginMemberships","response_statuses":[200],"scope":"none","side_effect":"none"},"POST /auth/login/memberships/select":{"audiences":["panel"],"method":"POST","operation":"POST /auth/login/memberships/select","owner":"identity-access","path":"/auth/login/memberships/select","permission":"identity.login.membership.select","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLoginMembershipSelectionComplete","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLoginMembershipsSelect","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/logout":{"audiences":["panel"],"method":"POST","operation":"POST /auth/logout","owner":"identity-access","path":"/auth/logout","permission":"identity.session.revoke","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLogout","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLogout","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /auth/renew":{"audiences":["panel"],"method":"POST","operation":"POST /auth/renew","owner":"identity-access","path":"/auth/renew","permission":"identity.session.renew","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffRenew","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthRenew","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /clients/:clientId/admission":{"audiences":["panel"],"method":"GET","operation":"GET /clients/:clientId/admission","owner":"identity-access","path":"/clients/:clientId/admission","permission":"identity.guest.admission.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"IdentityRequestGuestAdmissionStaffRead","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETClientsClientIdAdmission","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"DELETE /clients/:clientId/block":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /clients/:clientId/block","owner":"identity-access","path":"/clients/:clientId/block","permission":"identity.guest.admission.restore","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionBlockLift","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEClientsClientIdBlock","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /clients/:clientId/block":{"audiences":["panel"],"method":"POST","operation":"POST /clients/:clientId/block","owner":"identity-access","path":"/clients/:clientId/block","permission":"identity.guest.admission.deny","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionBlock","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTClientsClientIdBlock","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"DELETE /clients/:clientId/notice":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /clients/:clientId/notice","owner":"identity-access","path":"/clients/:clientId/notice","permission":"identity.guest.admission.restore","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionNoticeClear","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEClientsClientIdNotice","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /clients/:clientId/notice":{"audiences":["panel"],"method":"POST","operation":"POST /clients/:clientId/notice","owner":"identity-access","path":"/clients/:clientId/notice","permission":"identity.guest.admission.flag","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionNotice","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTClientsClientIdNotice","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /franchises":{"audiences":["panel"],"method":"GET","operation":"GET /franchises","owner":"tenant-directory","path":"/franchises","permission":"tenant.franchise.read","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETFranchises","response_statuses":[200],"scope":"platform","side_effect":"none"},"POST /franchises":{"audiences":["panel"],"method":"POST","operation":"POST /franchises","owner":"tenant-directory","path":"/franchises","permission":"tenant.franchise.create","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseCreate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTFranchises","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"DELETE /franchises/:franchiseId":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /franchises/:franchiseId","owner":"tenant-directory","path":"/franchises/:franchiseId","permission":"tenant.franchise.delete","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseDelete","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"franchiseId","id_source":"path","type":"franchises"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEFranchisesFranchiseId","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"GET /franchises/:franchiseId":{"audiences":["panel"],"method":"GET","operation":"GET /franchises/:franchiseId","owner":"tenant-directory","path":"/franchises/:franchiseId","permission":"tenant.franchise.read","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETFranchisesFranchiseId","response_statuses":[200],"scope":"franchise","side_effect":"none"},"PUT /franchises/:franchiseId":{"audiences":["panel"],"method":"PUT","operation":"PUT /franchises/:franchiseId","owner":"tenant-directory","path":"/franchises/:franchiseId","permission":"tenant.franchise.update","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":["logo_url"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestFranchiseUpdateById","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"franchiseId","id_source":"path","type":"franchises"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTFranchisesFranchiseId","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access":{"audiences":["panel"],"method":"POST","operation":"POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access","owner":"identity-access","path":"/franchises/:franchiseId/franchise-directors/:directorId/recover-access","permission":"identity.user.franchise-director.recover","policy":"platform","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffCredentialRecoverFranchiseDirector","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":{"id_key":"directorId","id_source":"path","type":"users"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTFranchisesFranchiseIdFranchiseDirectorsDirectorIdRecoverAccess","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"GET /franchises/:franchiseId/logo":{"audiences":["panel","public"],"method":"GET","operation":"GET /franchises/:franchiseId/logo","owner":"tenant-directory","path":"/franchises/:franchiseId/logo","permission":"tenant.franchise.logo.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETFranchisesFranchiseIdLogo","response_statuses":[200],"scope":"franchise","side_effect":"none"},"PUT /franchises/:franchiseId/reactivate":{"audiences":["panel"],"method":"PUT","operation":"PUT /franchises/:franchiseId/reactivate","owner":"tenant-directory","path":"/franchises/:franchiseId/reactivate","permission":"tenant.franchise.reactivate","policy":"platform","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseReactivate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"franchiseId","id_source":"path","type":"franchises"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTFranchisesFranchiseIdReactivate","response_statuses":[200],"scope":"platform","side_effect":"mutation-and-audit"},"GET /guest/home":{"audiences":["guest"],"method":"GET","operation":"GET /guest/home","owner":"identity-access","path":"/guest/home","permission":"identity.guest.session.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestHome","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"GET /guest/restaurant-presentation":{"audiences":["guest"],"method":"GET","operation":"GET /guest/restaurant-presentation","owner":"tenant-directory","path":"/guest/restaurant-presentation","permission":"tenant.restaurant.presentation.read","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestRestaurantPresentation","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"GET /identity-access/restaurants/:restaurantId/qr-tokens":{"audiences":["panel"],"method":"GET","operation":"GET /identity-access/restaurants/:restaurantId/qr-tokens","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/qr-tokens","permission":"identity.qr.table-token.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityAccessRestaurantsRestaurantIdQrTokens","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace":{"audiences":["panel"],"method":"POST","operation":"POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace","permission":"identity.qr.table-token.replace","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestQrTableTokenReplace","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensTokenIdReplace","response_statuses":[201],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /identity-access/restaurants/:restaurantId/qr-tokens/prints":{"audiences":["panel"],"method":"POST","operation":"POST /identity-access/restaurants/:restaurantId/qr-tokens/prints","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/qr-tokens/prints","permission":"identity.qr.table-token.read","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestQrTableTokenPrint","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensPrints","response_statuses":[201],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens":{"audiences":["panel"],"method":"GET","operation":"GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens","owner":"identity-access","path":"/identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens","permission":"identity.qr.table-token.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityAccessRestaurantsRestaurantIdTablesTableIdQrTokens","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"POST /identity/guest/account/save":{"audiences":["guest"],"method":"POST","operation":"POST /identity/guest/account/save","owner":"identity-access","path":"/identity/guest/account/save","permission":"identity.guest.account.save","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAccountSave","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAccountSave","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"GET /identity/guest/auth/current":{"audiences":["guest"],"method":"GET","operation":"GET /identity/guest/auth/current","owner":"identity-access","path":"/identity/guest/auth/current","permission":"identity.guest.session.read","policy":"guest-session","public":false,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestAuthCurrent","response_statuses":[200],"scope":"guest-session","side_effect":"none"},"POST /identity/guest/auth/forget":{"audiences":["guest"],"method":"POST","operation":"POST /identity/guest/auth/forget","owner":"identity-access","path":"/identity/guest/auth/forget","permission":"identity.guest.session.revoke","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestForget","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAuthForget","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"POST /identity/guest/entry":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/entry","owner":"identity-access","path":"/identity/guest/entry","permission":"identity.qr.resolve","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestEntry","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntry","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/entry/start-order":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/entry/start-order","owner":"identity-access","path":"/identity/guest/entry/start-order","permission":"identity.guest.order.start","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestStartOrder","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntryStartOrder","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/challenge":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/passkey/challenge","owner":"identity-access","path":"/identity/guest/passkey/challenge","permission":"identity.guest.passkey.challenge","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyChallenge","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyChallenge","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/recover":{"audiences":["guest","public"],"method":"POST","operation":"POST /identity/guest/passkey/recover","owner":"identity-access","path":"/identity/guest/passkey/recover","permission":"identity.guest.passkey.recover","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyRecover","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyRecover","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/save":{"audiences":["guest"],"method":"POST","operation":"POST /identity/guest/passkey/save","owner":"identity-access","path":"/identity/guest/passkey/save","permission":"identity.guest.passkey.save","policy":"guest-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeySave","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeySave","response_statuses":[200],"scope":"guest-session","side_effect":"mutation-and-audit"},"GET /identity/guest/qr/handoff/:handoffToken":{"audiences":["guest","public"],"method":"GET","operation":"GET /identity/guest/qr/handoff/:handoffToken","owner":"identity-access","path":"/identity/guest/qr/handoff/:handoffToken","permission":"identity.qr.handoff.consume","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrHandoffHandoffToken","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation-and-audit"},"GET /identity/guest/qr/resolve/:qrId":{"audiences":["guest","panel","public"],"method":"GET","operation":"GET /identity/guest/qr/resolve/:qrId","owner":"identity-access","path":"/identity/guest/qr/resolve/:qrId","permission":"identity.qr.resolve","policy":"public","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrResolveQrId","response_statuses":[200],"scope":"guest-bootstrap","side_effect":"mutation"},"POST /me/credential":{"audiences":["panel"],"method":"POST","operation":"POST /me/credential","owner":"identity-access","path":"/me/credential","permission":"identity.staff-credential.update","policy":"staff-session","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":401},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409},{"schema":"PlatformRefusal","status":429}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSelfCredentialUpdate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTMeCredential","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /me/profile":{"audiences":["panel"],"method":"GET","operation":"GET /me/profile","owner":"identity-access","path":"/me/profile","permission":"identity.staff-profile.read","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeProfile","response_statuses":[200],"scope":"none","side_effect":"none"},"PUT /me/profile":{"audiences":["panel"],"method":"PUT","operation":"PUT /me/profile","owner":"identity-access","path":"/me/profile","permission":"identity.staff-profile.update","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":["avatar"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestStaffSelfProfileUpdate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTMeProfile","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /me/sessions":{"audiences":["panel"],"method":"GET","operation":"GET /me/sessions","owner":"identity-access","path":"/me/sessions","permission":"identity.session.read","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeSessions","response_statuses":[200],"scope":"none","side_effect":"none"},"DELETE /me/sessions/:sessionId":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /me/sessions/:sessionId","owner":"identity-access","path":"/me/sessions/:sessionId","permission":"identity.session.revoke","policy":"staff-session","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":404}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSessionRevoke","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEMeSessionsSessionId","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"POST /me/sessions/revoke-all":{"audiences":["panel"],"method":"POST","operation":"POST /me/sessions/revoke-all","owner":"identity-access","path":"/me/sessions/revoke-all","permission":"identity.session.revoke","policy":"staff-session","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSessionsRevokeAll","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTMeSessionsRevokeAll","response_statuses":[200],"scope":"none","side_effect":"mutation-and-audit"},"GET /me/workspaces":{"audiences":["panel"],"method":"GET","operation":"GET /me/workspaces","owner":"identity-access","path":"/me/workspaces","permission":"identity.workspace.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeWorkspaces","response_statuses":[200,304],"scope":"restaurant","side_effect":"none"},"GET /restaurants":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants","owner":"tenant-directory","path":"/restaurants","permission":"tenant.restaurant.read","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurants","response_statuses":[200],"scope":"franchise","side_effect":"none"},"POST /restaurants":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants","owner":"tenant-directory","path":"/restaurants","permission":"tenant.restaurant.create","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantCreate","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTRestaurants","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"DELETE /restaurants/:restaurantId":{"audiences":["panel"],"method":"DELETE","operation":"DELETE /restaurants/:restaurantId","owner":"tenant-directory","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.delete","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantDelete","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETERestaurantsRestaurantId","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId","owner":"tenant-directory","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantId","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"PUT /restaurants/:restaurantId":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId","owner":"tenant-directory","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.update","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":["logo"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestRestaurantUpdate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantId","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId/access-policy/current-grants":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/current-grants","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/current-grants","permission":"identity.access-policy.read","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":"AccessPolicyCurrentGrantBatchQuery","requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyCurrentGrantBatchEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/access-policy/directory":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/directory","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/directory","permission":"identity.access-policy.read","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyDirectoryEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/access-policy/receipts/:receiptId":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/receipts/:receiptId","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/receipts/:receiptId","permission":"identity.access-policy.receipt.read","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyReceiptEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"POST /restaurants/:restaurantId/access-policy/restore":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants/:restaurantId/access-policy/restore","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/restore","permission":"identity.access-policy.restore","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"RestoreAccessPolicyRequest","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_schema":"AccessPolicyVersionCommandEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /restaurants/:restaurantId/access-policy/restore/validate":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants/:restaurantId/access-policy/restore/validate","owner":"identity-access","path":"/restaurants/:restaurantId/access-policy/restore/validate","permission":"identity.access-policy.validate","policy":"restaurant-admin","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"ValidateAccessPolicyRestoreRequest","requires_expected_version":true,"requires_idempotency_key":false,"resource_binding":null,"response_schema":"AccessPolicyValidationEnvelope","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/locations":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/locations","owner":"tenant-directory","path":"/restaurants/:restaurantId/locations","permission":"tenant.location.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdLocations","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"GET /restaurants/:restaurantId/logo":{"audiences":["panel","public"],"method":"GET","operation":"GET /restaurants/:restaurantId/logo","owner":"tenant-directory","path":"/restaurants/:restaurantId/logo","permission":"tenant.restaurant.logo.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdLogo","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"PUT /restaurants/:restaurantId/managers/:managerId/email":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/managers/:managerId/email","owner":"identity-access","path":"/restaurants/:restaurantId/managers/:managerId/email","permission":"identity.user.franchise-manager-email.update","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseManagerEmailUpdate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdManagersManagerIdEmail","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/reactivate":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/reactivate","owner":"tenant-directory","path":"/restaurants/:restaurantId/reactivate","permission":"tenant.restaurant.reactivate","policy":"franchise","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantReactivate","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":{"id_key":"restaurantId","id_source":"path","type":"restaurants"},"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdReactivate","response_statuses":[200],"scope":"franchise","side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId/staff-invitations/:invitationId":{"audiences":["panel"],"method":"GET","operation":"GET /restaurants/:restaurantId/staff-invitations/:invitationId","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId","permission":"core.hr.employee.invitation.read","policy":"restaurant-read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdStaffInvitationsInvitationId","response_statuses":[200],"scope":"restaurant","side_effect":"none"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/reissue","permission":"core.hr.employee.invitation.resend","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminReissue","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdReissue","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome","permission":"core.hr.employee.invitation.resolve-delivery-outcome","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminResolveDeliveryOutcome","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdResolveDeliveryOutcome","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke":{"audiences":["panel"],"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/revoke","permission":"core.hr.employee.invitation.revoke","policy":"restaurant-admin","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminRevoke","requires_expected_version":true,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdRevoke","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"POST /restaurants/:restaurantId/staff-invitations/recover":{"audiences":["panel"],"method":"POST","operation":"POST /restaurants/:restaurantId/staff-invitations/recover","owner":"identity-access","path":"/restaurants/:restaurantId/staff-invitations/recover","permission":"core.hr.employee.invitation.resend","policy":"restaurant-admin","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminRecoverScopedManager","requires_expected_version":false,"requires_idempotency_key":true,"resource_binding":null,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTRestaurantsRestaurantIdStaffInvitationsRecover","response_statuses":[200],"scope":"restaurant","side_effect":"mutation-and-audit"},"GET /users/:userId/avatar":{"audiences":["panel","public"],"method":"GET","operation":"GET /users/:userId/avatar","owner":"identity-access","path":"/users/:userId/avatar","permission":"identity.user.avatar.read","policy":"public","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"resource_binding":null,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETUsersUserIdAvatar","response_statuses":[200],"scope":"none","side_effect":"none"}} as const
export const PANEL_OPERATION_METADATA = {"POST /auth/2fa/delete-secret":{"method":"POST","operation":"POST /auth/2fa/delete-secret","path":"/auth/2fa/delete-secret","permission":"identity.second-factor.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faDeleteSecret","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faDeleteSecret","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/2fa/disable":{"method":"POST","operation":"POST /auth/2fa/disable","path":"/auth/2fa/disable","permission":"identity.second-factor.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faDisable","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faDisable","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/2fa/enable":{"method":"POST","operation":"POST /auth/2fa/enable","path":"/auth/2fa/enable","permission":"identity.second-factor.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faEnable","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faEnable","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/2fa/generate":{"method":"POST","operation":"POST /auth/2fa/generate","path":"/auth/2fa/generate","permission":"identity.second-factor.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaff2faGenerate","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuth2faGenerate","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /auth/current":{"method":"GET","operation":"GET /auth/current","path":"/auth/current","permission":"identity.session.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETAuthCurrent","response_statuses":[200],"side_effect":"none"},"POST /auth/employee-invitations/claim":{"method":"POST","operation":"POST /auth/employee-invitations/claim","path":"/auth/employee-invitations/claim","permission":"identity.invitation.claim","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestEmployeeInvitationClaim","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthEmployeeInvitationsClaim","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/employee-invitations/recover":{"method":"POST","operation":"POST /auth/employee-invitations/recover","path":"/auth/employee-invitations/recover","permission":"identity.invitation.recover","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestEmployeeInvitationRecover","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthEmployeeInvitationsRecover","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/login":{"method":"POST","operation":"POST /auth/login","path":"/auth/login","permission":"identity.login","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLogin","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLogin","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/login/memberships":{"method":"POST","operation":"POST /auth/login/memberships","path":"/auth/login/memberships","permission":"identity.login.memberships.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLoginMembershipSelectionRead","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLoginMemberships","response_statuses":[200],"side_effect":"none"},"POST /auth/login/memberships/select":{"method":"POST","operation":"POST /auth/login/memberships/select","path":"/auth/login/memberships/select","permission":"identity.login.membership.select","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLoginMembershipSelectionComplete","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLoginMembershipsSelect","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/logout":{"method":"POST","operation":"POST /auth/logout","path":"/auth/logout","permission":"identity.session.revoke","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffLogout","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthLogout","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /auth/renew":{"method":"POST","operation":"POST /auth/renew","path":"/auth/renew","permission":"identity.session.renew","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffRenew","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTAuthRenew","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /clients/:clientId/admission":{"method":"GET","operation":"GET /clients/:clientId/admission","path":"/clients/:clientId/admission","permission":"identity.guest.admission.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"IdentityRequestGuestAdmissionStaffRead","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETClientsClientIdAdmission","response_statuses":[200],"side_effect":"none"},"DELETE /clients/:clientId/block":{"method":"DELETE","operation":"DELETE /clients/:clientId/block","path":"/clients/:clientId/block","permission":"identity.guest.admission.restore","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionBlockLift","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEClientsClientIdBlock","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /clients/:clientId/block":{"method":"POST","operation":"POST /clients/:clientId/block","path":"/clients/:clientId/block","permission":"identity.guest.admission.deny","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionBlock","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTClientsClientIdBlock","response_statuses":[200],"side_effect":"mutation-and-audit"},"DELETE /clients/:clientId/notice":{"method":"DELETE","operation":"DELETE /clients/:clientId/notice","path":"/clients/:clientId/notice","permission":"identity.guest.admission.restore","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionNoticeClear","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEClientsClientIdNotice","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /clients/:clientId/notice":{"method":"POST","operation":"POST /clients/:clientId/notice","path":"/clients/:clientId/notice","permission":"identity.guest.admission.flag","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAdmissionNotice","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTClientsClientIdNotice","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /franchises":{"method":"GET","operation":"GET /franchises","path":"/franchises","permission":"tenant.franchise.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETFranchises","response_statuses":[200],"side_effect":"none"},"POST /franchises":{"method":"POST","operation":"POST /franchises","path":"/franchises","permission":"tenant.franchise.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseCreate","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTFranchises","response_statuses":[200],"side_effect":"mutation-and-audit"},"DELETE /franchises/:franchiseId":{"method":"DELETE","operation":"DELETE /franchises/:franchiseId","path":"/franchises/:franchiseId","permission":"tenant.franchise.delete","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseDelete","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEFranchisesFranchiseId","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /franchises/:franchiseId":{"method":"GET","operation":"GET /franchises/:franchiseId","path":"/franchises/:franchiseId","permission":"tenant.franchise.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETFranchisesFranchiseId","response_statuses":[200],"side_effect":"none"},"PUT /franchises/:franchiseId":{"method":"PUT","operation":"PUT /franchises/:franchiseId","path":"/franchises/:franchiseId","permission":"tenant.franchise.update","public":false,"refusal_responses":[],"request_file_fields":["logo_url"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestFranchiseUpdateById","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTFranchisesFranchiseId","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access":{"method":"POST","operation":"POST /franchises/:franchiseId/franchise-directors/:directorId/recover-access","path":"/franchises/:franchiseId/franchise-directors/:directorId/recover-access","permission":"identity.user.franchise-director.recover","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffCredentialRecoverFranchiseDirector","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTFranchisesFranchiseIdFranchiseDirectorsDirectorIdRecoverAccess","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /franchises/:franchiseId/logo":{"method":"GET","operation":"GET /franchises/:franchiseId/logo","path":"/franchises/:franchiseId/logo","permission":"tenant.franchise.logo.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETFranchisesFranchiseIdLogo","response_statuses":[200],"side_effect":"none"},"PUT /franchises/:franchiseId/reactivate":{"method":"PUT","operation":"PUT /franchises/:franchiseId/reactivate","path":"/franchises/:franchiseId/reactivate","permission":"tenant.franchise.reactivate","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseReactivate","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTFranchisesFranchiseIdReactivate","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /identity-access/restaurants/:restaurantId/qr-tokens":{"method":"GET","operation":"GET /identity-access/restaurants/:restaurantId/qr-tokens","path":"/identity-access/restaurants/:restaurantId/qr-tokens","permission":"identity.qr.table-token.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityAccessRestaurantsRestaurantIdQrTokens","response_statuses":[200],"side_effect":"none"},"POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace":{"method":"POST","operation":"POST /identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace","path":"/identity-access/restaurants/:restaurantId/qr-tokens/:tokenId/replace","permission":"identity.qr.table-token.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestQrTableTokenReplace","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensTokenIdReplace","response_statuses":[201],"side_effect":"mutation-and-audit"},"POST /identity-access/restaurants/:restaurantId/qr-tokens/prints":{"method":"POST","operation":"POST /identity-access/restaurants/:restaurantId/qr-tokens/prints","path":"/identity-access/restaurants/:restaurantId/qr-tokens/prints","permission":"identity.qr.table-token.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestQrTableTokenPrint","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityAccessRestaurantsRestaurantIdQrTokensPrints","response_statuses":[201],"side_effect":"mutation-and-audit"},"GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens":{"method":"GET","operation":"GET /identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens","path":"/identity-access/restaurants/:restaurantId/tables/:tableId/qr-tokens","permission":"identity.qr.table-token.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityAccessRestaurantsRestaurantIdTablesTableIdQrTokens","response_statuses":[200],"side_effect":"none"},"GET /identity/guest/qr/resolve/:qrId":{"method":"GET","operation":"GET /identity/guest/qr/resolve/:qrId","path":"/identity/guest/qr/resolve/:qrId","permission":"identity.qr.resolve","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrResolveQrId","response_statuses":[200],"side_effect":"mutation"},"POST /me/credential":{"method":"POST","operation":"POST /me/credential","path":"/me/credential","permission":"identity.staff-credential.update","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":401},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409},{"schema":"PlatformRefusal","status":429}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSelfCredentialUpdate","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTMeCredential","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /me/profile":{"method":"GET","operation":"GET /me/profile","path":"/me/profile","permission":"identity.staff-profile.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeProfile","response_statuses":[200],"side_effect":"none"},"PUT /me/profile":{"method":"PUT","operation":"PUT /me/profile","path":"/me/profile","permission":"identity.staff-profile.update","public":false,"refusal_responses":[],"request_file_fields":["avatar"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestStaffSelfProfileUpdate","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTMeProfile","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /me/sessions":{"method":"GET","operation":"GET /me/sessions","path":"/me/sessions","permission":"identity.session.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeSessions","response_statuses":[200],"side_effect":"none"},"DELETE /me/sessions/:sessionId":{"method":"DELETE","operation":"DELETE /me/sessions/:sessionId","path":"/me/sessions/:sessionId","permission":"identity.session.revoke","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":404}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSessionRevoke","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETEMeSessionsSessionId","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /me/sessions/revoke-all":{"method":"POST","operation":"POST /me/sessions/revoke-all","path":"/me/sessions/revoke-all","permission":"identity.session.revoke","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffSessionsRevokeAll","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTMeSessionsRevokeAll","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /me/workspaces":{"method":"GET","operation":"GET /me/workspaces","path":"/me/workspaces","permission":"identity.workspace.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETMeWorkspaces","response_statuses":[200,304],"side_effect":"none"},"GET /restaurants":{"method":"GET","operation":"GET /restaurants","path":"/restaurants","permission":"tenant.restaurant.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurants","response_statuses":[200],"side_effect":"none"},"POST /restaurants":{"method":"POST","operation":"POST /restaurants","path":"/restaurants","permission":"tenant.restaurant.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantCreate","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTRestaurants","response_statuses":[200],"side_effect":"mutation-and-audit"},"DELETE /restaurants/:restaurantId":{"method":"DELETE","operation":"DELETE /restaurants/:restaurantId","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.delete","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantDelete","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseDELETERestaurantsRestaurantId","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId":{"method":"GET","operation":"GET /restaurants/:restaurantId","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantId","response_statuses":[200],"side_effect":"none"},"PUT /restaurants/:restaurantId":{"method":"PUT","operation":"PUT /restaurants/:restaurantId","path":"/restaurants/:restaurantId","permission":"tenant.restaurant.update","public":false,"refusal_responses":[],"request_file_fields":["logo"],"request_media_type":"multipart/form-data","request_schema":"IdentityRequestRestaurantUpdate","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantId","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId/access-policy/current-grants":{"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/current-grants","path":"/restaurants/:restaurantId/access-policy/current-grants","permission":"identity.access-policy.read","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":"AccessPolicyCurrentGrantBatchQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"AccessPolicyCurrentGrantBatchEnvelope","response_statuses":[200],"side_effect":"none"},"GET /restaurants/:restaurantId/access-policy/directory":{"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/directory","path":"/restaurants/:restaurantId/access-policy/directory","permission":"identity.access-policy.read","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"AccessPolicyDirectoryEnvelope","response_statuses":[200],"side_effect":"none"},"GET /restaurants/:restaurantId/access-policy/receipts/:receiptId":{"method":"GET","operation":"GET /restaurants/:restaurantId/access-policy/receipts/:receiptId","path":"/restaurants/:restaurantId/access-policy/receipts/:receiptId","permission":"identity.access-policy.receipt.read","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"AccessPolicyReceiptEnvelope","response_statuses":[200],"side_effect":"none"},"POST /restaurants/:restaurantId/access-policy/restore":{"method":"POST","operation":"POST /restaurants/:restaurantId/access-policy/restore","path":"/restaurants/:restaurantId/access-policy/restore","permission":"identity.access-policy.restore","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"RestoreAccessPolicyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_schema":"AccessPolicyVersionCommandEnvelope","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /restaurants/:restaurantId/access-policy/restore/validate":{"method":"POST","operation":"POST /restaurants/:restaurantId/access-policy/restore/validate","path":"/restaurants/:restaurantId/access-policy/restore/validate","permission":"identity.access-policy.validate","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"ValidateAccessPolicyRestoreRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_schema":"AccessPolicyValidationEnvelope","response_statuses":[200],"side_effect":"none"},"GET /restaurants/:restaurantId/locations":{"method":"GET","operation":"GET /restaurants/:restaurantId/locations","path":"/restaurants/:restaurantId/locations","permission":"tenant.location.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdLocations","response_statuses":[200],"side_effect":"none"},"GET /restaurants/:restaurantId/logo":{"method":"GET","operation":"GET /restaurants/:restaurantId/logo","path":"/restaurants/:restaurantId/logo","permission":"tenant.restaurant.logo.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdLogo","response_statuses":[200],"side_effect":"none"},"PUT /restaurants/:restaurantId/managers/:managerId/email":{"method":"PUT","operation":"PUT /restaurants/:restaurantId/managers/:managerId/email","path":"/restaurants/:restaurantId/managers/:managerId/email","permission":"identity.user.franchise-manager-email.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestFranchiseManagerEmailUpdate","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdManagersManagerIdEmail","response_statuses":[200],"side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/reactivate":{"method":"PUT","operation":"PUT /restaurants/:restaurantId/reactivate","path":"/restaurants/:restaurantId/reactivate","permission":"tenant.restaurant.reactivate","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestRestaurantReactivate","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdReactivate","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /restaurants/:restaurantId/staff-invitations/:invitationId":{"method":"GET","operation":"GET /restaurants/:restaurantId/staff-invitations/:invitationId","path":"/restaurants/:restaurantId/staff-invitations/:invitationId","permission":"core.hr.employee.invitation.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETRestaurantsRestaurantIdStaffInvitationsInvitationId","response_statuses":[200],"side_effect":"none"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue":{"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/reissue","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/reissue","permission":"core.hr.employee.invitation.resend","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminReissue","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdReissue","response_statuses":[200],"side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome":{"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/resolve-delivery-outcome","permission":"core.hr.employee.invitation.resolve-delivery-outcome","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminResolveDeliveryOutcome","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdResolveDeliveryOutcome","response_statuses":[200],"side_effect":"mutation-and-audit"},"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke":{"method":"PUT","operation":"PUT /restaurants/:restaurantId/staff-invitations/:invitationId/revoke","path":"/restaurants/:restaurantId/staff-invitations/:invitationId/revoke","permission":"core.hr.employee.invitation.revoke","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminRevoke","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePUTRestaurantsRestaurantIdStaffInvitationsInvitationIdRevoke","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /restaurants/:restaurantId/staff-invitations/recover":{"method":"POST","operation":"POST /restaurants/:restaurantId/staff-invitations/recover","path":"/restaurants/:restaurantId/staff-invitations/recover","permission":"core.hr.employee.invitation.resend","public":false,"refusal_responses":[{"schema":"PlatformRefusal","status":400},{"schema":"PlatformRefusal","status":403},{"schema":"PlatformRefusal","status":404},{"schema":"PlatformRefusal","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestStaffInvitationAdminRecoverScopedManager","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTRestaurantsRestaurantIdStaffInvitationsRecover","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /users/:userId/avatar":{"method":"GET","operation":"GET /users/:userId/avatar","path":"/users/:userId/avatar","permission":"identity.user.avatar.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary-image","response_media_types":["image/jpeg","image/png","image/webp"],"response_schema":"IdentityResponseGETUsersUserIdAvatar","response_statuses":[200],"side_effect":"none"},"platformMessaging.panelNoticeSeen.v1":{"method":"POST","operation":"platformMessaging.panelNoticeSeen.v1","path":"/platform/notices/:noticeId/seen","permission":"platform.notice.staff.seen","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"side_effect":"mutation-and-audit"},"platformMessaging.panelNoticeRead.v1":{"method":"POST","operation":"platformMessaging.panelNoticeRead.v1","path":"/platform/notices/:noticeId/read","permission":"platform.notice.staff.read","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"side_effect":"mutation-and-audit"},"platformMessaging.panelNoticeDismiss.v1":{"method":"POST","operation":"platformMessaging.panelNoticeDismiss.v1","path":"/platform/notices/:noticeId/dismiss","permission":"platform.notice.staff.dismiss","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"side_effect":"mutation-and-audit"},"platformMessaging.panelNoticesInbox.v1":{"conditional_read":"etag","method":"GET","operation":"platformMessaging.panelNoticesInbox.v1","path":"/platform/notices/inbox","permission":"platform.notice.staff.inbox","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"PlatformMessagingNoticeInboxResponse","response_statuses":[200],"side_effect":"none"},"readRestaurantConfigurationCurrent":{"method":"GET","operation":"readRestaurantConfigurationCurrent","path":"/restaurant-configurations/:restaurantId/current","permission":"restaurant.configuration.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadRestaurantConfigurationCurrent","response_statuses":[200],"side_effect":"none"},"applyRestaurantConfiguration":{"method":"POST","operation":"applyRestaurantConfiguration","path":"/restaurant-configurations/:restaurantId/apply","permission":"restaurant.configuration.publish","public":false,"refusal_responses":[{"schema":"RestaurantConfigurationInvalidHttpError","status":400}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ApplyRestaurantConfigurationRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyRestaurantConfiguration","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"searchIneMunicipalities":{"method":"GET","operation":"searchIneMunicipalities","path":"/restaurant-configurations/:restaurantId/ine-municipalities","permission":"restaurant.configuration.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"IneMunicipalitySearchRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseSearchIneMunicipalities","response_statuses":[200],"side_effect":"none"},"restaurant-configuration.geocode.search.v1":{"method":"GET","operation":"restaurant-configuration.geocode.search.v1","path":"/restaurant-configurations/:restaurantId/geocode","permission":"restaurant.configuration.read","public":false,"refusal_responses":[{"schema":"GeocodeSearchUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":"GeocodeSearchRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRestaurantConfigurationGeocodeSearchV1","response_statuses":[200],"side_effect":"none"},"inventory.stock-policy.set.v1":{"method":"PUT","operation":"inventory.stock-policy.set.v1","path":"/inventory/restaurants/:restaurantId/stock-policy","permission":"restaurant.configuration.publish","public":false,"refusal_responses":[{"schema":"RestaurantConfigurationInvalidHttpError","status":400}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"SetInventoryStockPolicyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockPolicySetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"readPublishedRestaurantConfiguration":{"method":"GET","operation":"readPublishedRestaurantConfiguration","path":"/restaurant-configurations/:restaurantId/published","permission":"restaurant.configuration.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPublishedRestaurantConfiguration","response_statuses":[200],"side_effect":"none"},"evaluateCatalogWorkshopIdea":{"method":"POST","operation":"evaluateCatalogWorkshopIdea","path":"/catalogs/:restaurantId/workshop/evaluate","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogWorkshopEvaluateRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseEvaluateCatalogWorkshopIdea","response_statuses":[200],"side_effect":"none"},"recordCatalogWorkshopTrial":{"method":"POST","operation":"recordCatalogWorkshopTrial","path":"/catalogs/:restaurantId/workshop/trials","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogWorkshopTrialRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRecordCatalogWorkshopTrial","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"saveCatalogWorkshopCandidate":{"method":"POST","operation":"saveCatalogWorkshopCandidate","path":"/catalogs/:restaurantId/workshop/candidates","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogWorkshopSaveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseSaveCatalogWorkshopCandidate","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"readCatalogWorkshopCandidate":{"method":"GET","operation":"readCatalogWorkshopCandidate","path":"/catalogs/:restaurantId/workshop/candidates/:candidateId","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogWorkshopCandidate","response_statuses":[200],"side_effect":"none"},"readCatalogDraft":{"conditional_read":"etag","method":"GET","operation":"readCatalogDraft","path":"/catalogs/:restaurantId/draft","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraft","response_statuses":[200],"side_effect":"none"},"readCatalogStockDeactivationWarning":{"method":"GET","operation":"readCatalogStockDeactivationWarning","path":"/catalogs/:restaurantId/stock-deactivation-warning","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogStockDeactivationWarningRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogStockDeactivationWarning","response_statuses":[200],"side_effect":"none"},"validateCatalogDraft":{"method":"POST","operation":"validateCatalogDraft","path":"/catalogs/:restaurantId/validate","permission":"catalog.validate","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseValidateCatalogDraft","response_statuses":[200],"side_effect":"none"},"publishCatalog":{"method":"POST","operation":"publishCatalog","path":"/catalogs/:restaurantId/publish","permission":"catalog.publish","public":false,"refusal_responses":[{"schema":"CatalogPublishRefusedHttpError","status":400}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PublishCatalogRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePublishCatalog","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"listCatalogPublications":{"method":"GET","operation":"listCatalogPublications","path":"/catalogs/:restaurantId/publications","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogPublications","response_statuses":[200],"side_effect":"none"},"readCatalogPublication":{"conditional_read":"etag","method":"GET","operation":"readCatalogPublication","path":"/catalogs/:restaurantId/publications/:publicationVersion","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogPublication","response_statuses":[200],"side_effect":"none"},"readPublishedCatalogue":{"conditional_read":"etag","method":"GET","operation":"readPublishedCatalogue","path":"/catalogs/:restaurantId/published","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPublishedCatalogue","response_statuses":[200],"side_effect":"mutation"},"catalog.pos-operational.read.v1":{"method":"GET","operation":"catalog.pos-operational.read.v1","path":"/catalogs/:restaurantId/pos-operational","permission":"catalog.pos-operational.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPosOperationalReadV1","response_statuses":[200],"side_effect":"mutation"},"catalog.pos-routing.read.v1":{"method":"GET","operation":"catalog.pos-routing.read.v1","path":"/catalogs/:restaurantId/pos-publication/:publicationVersion/routing","permission":"catalog.pos-routing.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPosRoutingReadV1","response_statuses":[200],"side_effect":"none"},"searchCatalogMasterIngredients":{"method":"GET","operation":"searchCatalogMasterIngredients","path":"/catalogs/:restaurantId/master-ingredients/search","permission":"catalog.master-ingredient.search","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogMasterIngredientSearchRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseSearchCatalogMasterIngredients","response_statuses":[200],"side_effect":"none"},"materializeCatalogMasterIngredient":{"method":"POST","operation":"materializeCatalogMasterIngredient","path":"/catalogs/:restaurantId/draft/master-ingredients","permission":"catalog.master-ingredient.materialize","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogMasterIngredientMaterializationRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseMaterializeCatalogMasterIngredient","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"previewCatalogDishDerivation":{"method":"POST","operation":"previewCatalogDishDerivation","path":"/catalogs/:restaurantId/dishes/derivation-preview","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishDerivationPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePreviewCatalogDishDerivation","response_statuses":[200],"side_effect":"none"},"applyCatalogDishProposal":{"method":"POST","operation":"applyCatalogDishProposal","path":"/catalogs/:restaurantId/dishes/proposals/:proposalId/apply","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishProposalApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogDishProposal","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"proposeCatalogAiDishCopy":{"method":"POST","operation":"proposeCatalogAiDishCopy","path":"/catalogs/:restaurantId/ai/dish-copy-proposal","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogAiDishCopyProposalRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposeCatalogAiDishCopy","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"autocompleteCatalogDishIngredients":{"method":"POST","operation":"autocompleteCatalogDishIngredients","path":"/catalogs/:restaurantId/dishes/ingredient-autocomplete","permission":"catalog.autocomplete","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogIngredientAutocompleteRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseAutocompleteCatalogDishIngredients","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"proposeCatalogAiTranslation":{"method":"POST","operation":"proposeCatalogAiTranslation","path":"/catalogs/:restaurantId/ai/translation-proposal","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogAiTranslationProposalRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposeCatalogAiTranslation","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"proposeCatalogAiPhotoEnhancement":{"method":"POST","operation":"proposeCatalogAiPhotoEnhancement","path":"/catalogs/:restaurantId/ai/photo-enhancement-proposal","permission":"catalog.media.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogAiPhotoEnhancementProposalRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposeCatalogAiPhotoEnhancement","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"readCatalogAiPhotoEnhancementPreview":{"method":"GET","operation":"readCatalogAiPhotoEnhancementPreview","path":"/catalogs/:restaurantId/ai/photo-enhancement-proposals/:mediaId/preview","permission":"catalog.media.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogAiPhotoEnhancementPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogAiPhotoEnhancementPreview","response_statuses":[200],"side_effect":"none"},"readCatalogAiProviderCredentialStatus":{"method":"GET","operation":"readCatalogAiProviderCredentialStatus","path":"/catalogs/:restaurantId/ai/provider-credential","permission":"catalog.ai-credential.manage","public":false,"refusal_responses":[{"schema":"CatalogAiCredentialUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogAiProviderCredentialReadRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogAiProviderCredentialStatus","response_statuses":[200],"side_effect":"none"},"readCatalogAiUsageMonth":{"method":"GET","operation":"readCatalogAiUsageMonth","path":"/catalogs/:restaurantId/ai/usage/month","permission":"catalog.ai-credential.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogAiUsageMonth","response_statuses":[200],"side_effect":"none"},"setCatalogAiProviderCredential":{"method":"PUT","operation":"setCatalogAiProviderCredential","path":"/catalogs/:restaurantId/ai/provider-credential","permission":"catalog.ai-credential.manage","public":false,"refusal_responses":[{"schema":"CatalogAiCredentialUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogAiProviderCredentialSetRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseSetCatalogAiProviderCredential","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"deleteCatalogAiProviderCredential":{"method":"DELETE","operation":"deleteCatalogAiProviderCredential","path":"/catalogs/:restaurantId/ai/provider-credential","permission":"catalog.ai-credential.manage","public":false,"refusal_responses":[{"schema":"CatalogAiCredentialUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogAiProviderCredentialDeleteRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseDeleteCatalogAiProviderCredential","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"reviewCatalogDishCopy":{"method":"POST","operation":"reviewCatalogDishCopy","path":"/catalogs/:restaurantId/dishes/copy/review","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishCopyReviewRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReviewCatalogDishCopy","response_statuses":[200],"side_effect":"none"},"applyCatalogDishCopy":{"method":"POST","operation":"applyCatalogDishCopy","path":"/catalogs/:restaurantId/dishes/copy/apply","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishCopyApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogDishCopy","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"undoCatalogDishCopy":{"method":"POST","operation":"undoCatalogDishCopy","path":"/catalogs/:restaurantId/dishes/copy/undo","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishCopyUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogDishCopy","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"listCatalogDishNameSuggestions":{"method":"GET","operation":"listCatalogDishNameSuggestions","path":"/catalogs/:restaurantId/dish-name-suggestions","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogDishNameSuggestions","response_statuses":[200],"side_effect":"none"},"applyCatalogDishNameSuggestion":{"method":"POST","operation":"applyCatalogDishNameSuggestion","path":"/catalogs/:restaurantId/dish-name-suggestions/:suggestionId/apply","permission":"catalog.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishNameApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogDishNameSuggestion","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"undoCatalogDishNameSuggestion":{"method":"POST","operation":"undoCatalogDishNameSuggestion","path":"/catalogs/:restaurantId/dish-name-suggestions/:suggestionId/undo","permission":"catalog.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishNameUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogDishNameSuggestion","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"listCatalogDailySuggestions":{"method":"GET","operation":"listCatalogDailySuggestions","path":"/catalogs/:restaurantId/daily-suggestions","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogDailySuggestions","response_statuses":[200],"side_effect":"none"},"setCatalogDailySuggestion":{"method":"POST","operation":"setCatalogDailySuggestion","path":"/catalogs/:restaurantId/daily-suggestions","permission":"catalog.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDailySuggestionSetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseSetCatalogDailySuggestion","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"withdrawCatalogDailySuggestion":{"method":"POST","operation":"withdrawCatalogDailySuggestion","path":"/catalogs/:restaurantId/daily-suggestions/:suggestionId/withdraw","permission":"catalog.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDailySuggestionWithdrawRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWithdrawCatalogDailySuggestion","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"readCatalogCartaFisica":{"method":"GET","operation":"readCatalogCartaFisica","path":"/catalogs/:restaurantId/carta-fisica","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogCartaFisica","response_statuses":[200],"side_effect":"none"},"previewCatalogCartaFisica":{"method":"POST","operation":"previewCatalogCartaFisica","path":"/catalogs/:restaurantId/carta-fisica/preview","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogCartaFisicaPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePreviewCatalogCartaFisica","response_statuses":[200],"side_effect":"none"},"renderCatalogCartaFisicaDocument":{"method":"POST","operation":"renderCatalogCartaFisicaDocument","path":"/catalogs/:restaurantId/carta-fisica/document","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogCartaFisicaDocumentRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"listCatalogDishTrials":{"method":"GET","operation":"listCatalogDishTrials","path":"/catalogs/:restaurantId/dish-trials","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseListCatalogDishTrials","response_statuses":[200],"side_effect":"none"},"answerCatalogDishTrial":{"method":"POST","operation":"answerCatalogDishTrial","path":"/catalogs/:restaurantId/dish-trials/:trialId/answer","permission":"catalog.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogDishTrialAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseAnswerCatalogDishTrial","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"undoCatalogCartaChange":{"method":"POST","operation":"undoCatalogCartaChange","path":"/catalogs/:restaurantId/carta-changes/undo","permission":"catalog.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogCartaChangeUndoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogCartaChange","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"refreshCatalogDraft":{"method":"POST","operation":"refreshCatalogDraft","path":"/catalogs/:restaurantId/draft/refresh","permission":"catalog.draft.replace","public":false,"refusal_responses":[{"schema":"CatalogPublishRefusedHttpError","status":400}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRefreshCatalogDraft","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"patchCatalogDraftEntities":{"method":"POST","operation":"patchCatalogDraftEntities","path":"/catalogs/:restaurantId/draft/entities","permission":"catalog.draft.replace","public":false,"refusal_responses":[{"schema":"CatalogDraftEntityInvalidHttpError","status":400},{"include_generic_identity":true,"schema":"CatalogDraftEntityConflictHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PatchCatalogDraftEntitiesRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePatchCatalogDraftEntities","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"readCatalogDraftSummary":{"conditional_read":"etag","method":"GET","operation":"readCatalogDraftSummary","path":"/catalogs/:restaurantId/draft/summary","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraftSummary","response_statuses":[200],"side_effect":"none"},"readCatalogDraftDocument":{"conditional_read":"etag","method":"GET","operation":"readCatalogDraftDocument","path":"/catalogs/:restaurantId/draft/document","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraftDocument","response_statuses":[200],"side_effect":"none"},"readCatalogReferenceDocument":{"conditional_read":"etag","method":"GET","operation":"readCatalogReferenceDocument","path":"/catalogs/:restaurantId/reference-documents/:digest","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogReferenceDocument","response_statuses":[200],"side_effect":"none"},"catalog.repaired-master-holdings.read.v1":{"method":"GET","operation":"catalog.repaired-master-holdings.read.v1","path":"/catalogs/:restaurantId/repaired-master-holdings","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogRepairedMasterHoldingsReadV1","response_statuses":[200],"side_effect":"none"},"restoreCatalogDraftFromPublication":{"method":"POST","operation":"restoreCatalogDraftFromPublication","path":"/catalogs/:restaurantId/draft/restore","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RestoreCatalogDraftFromPublicationRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRestoreCatalogDraftFromPublication","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"reviewCatalogPhotoCorrection":{"method":"POST","operation":"reviewCatalogPhotoCorrection","path":"/catalogs/:restaurantId/dishes/photo-correction/review","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogPhotoCorrectionReviewRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReviewCatalogPhotoCorrection","response_statuses":[200],"side_effect":"none"},"applyCatalogPhotoCorrection":{"method":"POST","operation":"applyCatalogPhotoCorrection","path":"/catalogs/:restaurantId/dishes/photo-correction/apply","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogPhotoCorrectionApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseApplyCatalogPhotoCorrection","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"undoCatalogPhotoCorrection":{"method":"POST","operation":"undoCatalogPhotoCorrection","path":"/catalogs/:restaurantId/dishes/photo-correction/undo","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogPhotoCorrectionUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUndoCatalogPhotoCorrection","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"uploadCatalogPhoto":{"method":"POST","operation":"uploadCatalogPhoto","path":"/catalogs/:restaurantId/media/photos","permission":"catalog.media.write","public":false,"refusal_responses":[],"request_file_fields":["photo"],"request_media_type":"multipart/form-data","request_schema":"UploadCatalogPhotoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseUploadCatalogPhoto","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"abandonCatalogMediaProvisionals":{"method":"POST","operation":"abandonCatalogMediaProvisionals","path":"/catalogs/:restaurantId/media/provisionals/abandon","permission":"catalog.media.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"AbandonCatalogMediaProvisionalsRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseAbandonCatalogMediaProvisionals","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"readCatalogMediaDelivery":{"method":"GET","operation":"readCatalogMediaDelivery","path":"/catalogs/:restaurantId/media/:mediaId/delivery","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogMediaDelivery","response_statuses":[200],"side_effect":"none"},"catalog.published-media.delivery.v1":{"method":"GET","operation":"catalog.published-media.delivery.v1","path":"/catalogs/:restaurantId/publications/:publicationVersion/media/:mediaId/delivery","permission":"catalog.published-media.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogPublishedMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPublishedMediaDeliveryV1","response_statuses":[200],"side_effect":"none"},"readCatalogMediaRenditions":{"method":"GET","operation":"readCatalogMediaRenditions","path":"/catalogs/:restaurantId/media/:mediaId/renditions","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogMediaRenditionsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogMediaRenditions","response_statuses":[200],"side_effect":"none"},"readCatalogDraftPhotoRenditions":{"method":"GET","operation":"readCatalogDraftPhotoRenditions","path":"/catalogs/:restaurantId/draft/photo-renditions","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadCatalogDraftPhotoRenditions","response_statuses":[200],"side_effect":"none"},"catalog.published-media.renditions.v1":{"method":"GET","operation":"catalog.published-media.renditions.v1","path":"/catalogs/:restaurantId/publications/:publicationVersion/media/:mediaId/renditions","permission":"catalog.published-media.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogMediaRenditionsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogPublishedMediaRenditionsV1","response_statuses":[200],"side_effect":"none"},"offers.marketing-board.read":{"method":"GET","operation":"offers.marketing-board.read","path":"/offers/marketing-board","permission":"offers.definition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersMarketingBoardRead","response_statuses":[200],"side_effect":"none"},"offers.marketing-board.page.read":{"method":"GET","operation":"offers.marketing-board.page.read","path":"/offers/marketing-board/page","permission":"offers.definition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ReadOfferMarketingBoardPageQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersMarketingBoardPageRead","response_statuses":[200],"side_effect":"none"},"offers.definition.marketing-replay":{"method":"POST","operation":"offers.definition.marketing-replay","path":"/offers/definitions/marketing-replay","permission":"offers.definition.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReplayOfferDefinitionRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionMarketingReplay","response_statuses":[200],"side_effect":"none"},"offers.definition.get":{"method":"GET","operation":"offers.definition.get","path":"/offers/definitions/:definitionId","permission":"offers.definition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionGet","response_statuses":[200],"side_effect":"none"},"offers.definition.history":{"method":"GET","operation":"offers.definition.history","path":"/offers/definitions/:definitionId/history","permission":"offers.definition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ListOfferDefinitionHistoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionHistory","response_statuses":[200],"side_effect":"none"},"offers.definition.redemption-consumption.get":{"method":"GET","operation":"offers.definition.redemption-consumption.get","path":"/offers/definitions/:definitionId/redemption-consumption","permission":"offers.definition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionRedemptionConsumptionGet","response_statuses":[200],"side_effect":"none"},"offers.definition.put":{"method":"PUT","operation":"offers.definition.put","path":"/offers/definitions/:definitionId","permission":"offers.definition.write","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferDefinitionRefusedHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PutOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionPut","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.definition.archive":{"method":"POST","operation":"offers.definition.archive","path":"/offers/definitions/:definitionId/archive","permission":"offers.definition.retire","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ArchiveOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionArchive","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.definition.recall-coupons":{"method":"POST","operation":"offers.definition.recall-coupons","path":"/offers/definitions/:definitionId/recall-coupons","permission":"offers.definition.retire","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RecallOfferCouponsRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionRecallCoupons","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.definition.retire":{"method":"POST","operation":"offers.definition.retire","path":"/offers/definitions/:definitionId/retire","permission":"offers.definition.retire","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RetireOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionRetire","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.definition.reopen":{"method":"POST","operation":"offers.definition.reopen","path":"/offers/definitions/:definitionId/reopen","permission":"offers.definition.reopen","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferDefinitionArchivedHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReopenOfferDefinitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionReopen","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.coupon-code.list":{"method":"GET","operation":"offers.coupon-code.list","path":"/offers/coupon-codes","permission":"offers.definition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ListOfferCouponCodesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersCouponCodeList","response_statuses":[200],"side_effect":"none"},"offers.coupon-code.issue":{"method":"POST","operation":"offers.coupon-code.issue","path":"/offers/coupon-codes","permission":"offers.coupon-code.issue","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferCouponCodeTakenHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IssueOfferCouponCodeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersCouponCodeIssue","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.coupon-code.cancel":{"method":"POST","operation":"offers.coupon-code.cancel","path":"/offers/coupon-codes/:codeId/cancel","permission":"offers.coupon-code.issue","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CancelOfferCouponCodeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOffersCouponCodeCancel","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.definition.uses.list":{"method":"GET","operation":"offers.definition.uses.list","path":"/offers/definitions/:definitionId/uses","permission":"offers.definition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ListOfferDefinitionUsesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersDefinitionUsesList","response_statuses":[200],"side_effect":"none"},"inventory.published-policy.read.v1":{"method":"GET","operation":"inventory.published-policy.read.v1","path":"/inventory/restaurants/:restaurantId/published-policy","permission":"inventory.stock-item.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPublishedPolicyReadV1","response_statuses":[200],"side_effect":"none"},"inventory.stock-item.published-usage.list.v1":{"method":"GET","operation":"inventory.stock-item.published-usage.list.v1","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/published-usage","permission":"inventory.stock-item.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ListInventoryPublishedIngredientUsageQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemPublishedUsageListV1","response_statuses":[200],"side_effect":"none"},"inventory.stock-item.list.v1":{"method":"GET","operation":"inventory.stock-item.list.v1","path":"/inventory/restaurants/:restaurantId/stock-items","permission":"inventory.stock-item.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ListInventoryStockItemsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemListV1","response_statuses":[200],"side_effect":"none"},"inventory.stock-item.reconcile.v1":{"method":"POST","operation":"inventory.stock-item.reconcile.v1","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/reconcile","permission":"inventory.stock-item.reconcile","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"InventoryReconcileBelowReservedHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReconcileInventoryStockItemRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemReconcileV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.stock-item.availability-reactivate.v1":{"method":"POST","operation":"inventory.stock-item.availability-reactivate.v1","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/reactivate-availability","permission":"inventory.stock-item.availability-reactivate","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReactivateInventoryStockItemAvailabilityRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemAvailabilityReactivateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.stock-item.retire.v1":{"method":"POST","operation":"inventory.stock-item.retire.v1","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/retire","permission":"inventory.stock-item.retire","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RetireInventoryResourceRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemRetireV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.stock-item.cost.record.v1":{"method":"POST","operation":"inventory.stock-item.cost.record.v1","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/costs","permission":"inventory.stock-item.cost.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RecordInventoryStockItemCostRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemCostRecordV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.stock-item.cost.list.v1":{"method":"GET","operation":"inventory.stock-item.cost.list.v1","path":"/inventory/restaurants/:restaurantId/stock-item-costs","permission":"inventory.stock-item.cost.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemCostListV1","response_statuses":[200],"side_effect":"none"},"inventory.stock-item.yield.record.v1":{"method":"POST","operation":"inventory.stock-item.yield.record.v1","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/yield","permission":"inventory.stock-item.cost.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RecordInventoryStockItemYieldRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemYieldRecordV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.recipe-costing.preview.v1":{"method":"POST","operation":"inventory.recipe-costing.preview.v1","path":"/inventory/restaurants/:restaurantId/recipe-costing","permission":"inventory.recipe-costing.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryRecipeCostingRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryRecipeCostingPreviewV1","response_statuses":[200],"side_effect":"none"},"inventory.dish-costing.list.v1":{"method":"GET","operation":"inventory.dish-costing.list.v1","path":"/inventory/restaurants/:restaurantId/dish-costing","permission":"inventory.recipe-costing.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryDishCostingListV1","response_statuses":[200],"side_effect":"none"},"inventory.supply.list.v1":{"method":"GET","operation":"inventory.supply.list.v1","path":"/inventory/restaurants/:restaurantId/supply","permission":"inventory.supply.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventorySupplyListV1","response_statuses":[200],"side_effect":"none"},"inventory.supplier.create.v1":{"method":"POST","operation":"inventory.supplier.create.v1","path":"/inventory/restaurants/:restaurantId/suppliers","permission":"inventory.supply.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CreateInventorySupplierRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventorySupplierCreateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.supplier.update.v1":{"method":"POST","operation":"inventory.supplier.update.v1","path":"/inventory/restaurants/:restaurantId/suppliers/:resourceId","permission":"inventory.supply.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"UpdateInventorySupplierRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventorySupplierUpdateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.stock-item.supply.set.v1":{"method":"POST","operation":"inventory.stock-item.supply.set.v1","path":"/inventory/restaurants/:restaurantId/stock-items/:resourceId/supply","permission":"inventory.supply.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"SetInventoryStockItemSupplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryStockItemSupplySetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.upload.v1":{"method":"POST","operation":"inventory.purchase-document.upload.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/pages","permission":"inventory.purchase-document.capture","public":false,"refusal_responses":[],"request_file_fields":["page"],"request_media_type":"multipart/form-data","request_schema":"InventoryPurchasePageUploadRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentUploadV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.read.v1":{"method":"GET","operation":"inventory.purchase-document.read.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId","permission":"inventory.purchase-document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryPurchaseDocumentReadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentReadV1","response_statuses":[200],"side_effect":"none"},"inventory.purchase-document.line.answer.v1":{"method":"POST","operation":"inventory.purchase-document.line.answer.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/answer","permission":"inventory.purchase-document.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseLineAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentLineAnswerV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.line.measure.v1":{"method":"POST","operation":"inventory.purchase-document.line.measure.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/measure","permission":"inventory.purchase-document.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseLineMeasureRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentLineMeasureV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.undo.v1":{"method":"POST","operation":"inventory.purchase-document.undo.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/undo","permission":"inventory.purchase-document.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseDocumentUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentUndoV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.figure.validate.v1":{"method":"POST","operation":"inventory.purchase-document.figure.validate.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/figure-validation","permission":"inventory.purchase-document.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseFigureValidateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentFigureValidateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.same-delivery.answer.v1":{"method":"POST","operation":"inventory.purchase-document.same-delivery.answer.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/same-delivery","permission":"inventory.purchase-document.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseSameDeliveryAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentSameDeliveryAnswerV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.arrival.answer.v1":{"method":"POST","operation":"inventory.purchase-document.arrival.answer.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/arrival","permission":"inventory.purchase-document.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseArrivalAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentArrivalAnswerV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-document.keep-apart.v1":{"method":"POST","operation":"inventory.purchase-document.keep-apart.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents/:resourceId/keep-apart","permission":"inventory.purchase-document.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseKeepApartRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentKeepApartV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-documents.list.v1":{"method":"GET","operation":"inventory.purchase-documents.list.v1","path":"/inventory/restaurants/:restaurantId/purchase-documents","permission":"inventory.purchase-document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryPurchaseOverviewQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseDocumentsListV1","response_statuses":[200],"side_effect":"none"},"inventory.purchase-settings.set.v1":{"method":"POST","operation":"inventory.purchase-settings.set.v1","path":"/inventory/restaurants/:restaurantId/purchase-settings","permission":"inventory.purchase-settings.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseSettingsRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseSettingsSetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-trace.search.v1":{"method":"GET","operation":"inventory.purchase-trace.search.v1","path":"/inventory/restaurants/:restaurantId/purchase-trace","permission":"inventory.purchase-register.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryPurchaseTraceQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseTraceSearchV1","response_statuses":[200],"side_effect":"none"},"inventory.purchase-trace.export.prepare.v1":{"method":"POST","operation":"inventory.purchase-trace.export.prepare.v1","path":"/inventory/restaurants/:restaurantId/purchase-trace/exports","permission":"inventory.purchase-register.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"InventoryPurchaseTraceExportPrepareRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseTraceExportPrepareV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"inventory.purchase-trace.export.list.v1":{"method":"GET","operation":"inventory.purchase-trace.export.list.v1","path":"/inventory/restaurants/:restaurantId/purchase-trace/exports","permission":"inventory.purchase-register.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryPurchaseTraceExportListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchaseTraceExportListV1","response_statuses":[200],"side_effect":"none"},"inventory.purchase-trace.export.download.v1":{"method":"GET","operation":"inventory.purchase-trace.export.download.v1","path":"/inventory/restaurants/:restaurantId/purchase-trace/exports/:resourceId/file","permission":"inventory.purchase-register.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryPurchaseTraceExportDownloadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"inventory.purchase-period.read.v1":{"method":"GET","operation":"inventory.purchase-period.read.v1","path":"/inventory/restaurants/:restaurantId/purchase-period","permission":"inventory.purchase-register.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryPurchasePeriodQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryPurchasePeriodReadV1","response_statuses":[200],"side_effect":"none"},"workforce.operational-session.enter.kitchen.v2":{"method":"POST","operation":"workforce.operational-session.enter.kitchen.v2","path":"/workforce/restaurants/:restaurantId/operational-session/enter/kitchen","permission":"workforce.operational-session.enter","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceOperationalSessionEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalSessionEnterKitchenV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.operational-session.enter.floor.v2":{"method":"POST","operation":"workforce.operational-session.enter.floor.v2","path":"/workforce/restaurants/:restaurantId/operational-session/enter/floor","permission":"workforce.operational-session.enter","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceOperationalSessionEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalSessionEnterFloorV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.work-target-assignment.list.v1":{"method":"GET","operation":"workforce.work-target-assignment.list.v1","path":"/workforce/restaurants/:restaurantId/work-target-assignments","permission":"workforce.work-target-assignment.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceWorkTargetAssignmentListV1","response_statuses":[200],"side_effect":"none"},"workforce.team-on-plan.read.v1":{"method":"GET","operation":"workforce.team-on-plan.read.v1","path":"/workforce/restaurants/:restaurantId/team-on-plan","permission":"workforce.team-on-plan.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceTeamOnPlanReadV1","response_statuses":[200],"side_effect":"none"},"workforce.work-target-assignment.bulk-apply.v1":{"method":"POST","operation":"workforce.work-target-assignment.bulk-apply.v1","path":"/workforce/restaurants/:restaurantId/work-target-assignment/bulk-apply","permission":"workforce.work-target-assignment.bulk-apply","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceWorkTargetAssignmentBulkApplyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceWorkTargetAssignmentBulkApplyV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.work-target-assignment.assign.v1":{"method":"POST","operation":"workforce.work-target-assignment.assign.v1","path":"/workforce/restaurants/:restaurantId/work-target-assignment/assign","permission":"workforce.work-target-assignment.assign","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceWorkTargetAssignmentAssignRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceWorkTargetAssignmentAssignV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.employee.list.v1":{"method":"GET","operation":"workforce.employee.list.v1","path":"/workforce/restaurants/:restaurantId/employees","permission":"workforce.employee.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"WorkforceEmployeeListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeListV1","response_statuses":[200],"side_effect":"none"},"workforce.employee.detail.read.v1":{"method":"GET","operation":"workforce.employee.detail.read.v1","path":"/workforce/restaurants/:restaurantId/employees/:employmentId","permission":"workforce.employee.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeDetailReadV1","response_statuses":[200],"side_effect":"none"},"workforce.employee.kpi.read.v3":{"method":"GET","operation":"workforce.employee.kpi.read.v3","path":"/workforce/restaurants/:restaurantId/employees/:employmentId/kpis","permission":"workforce.employee.kpi.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"WorkforceEmployeeKpiExpansionQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeKpiReadV3","response_statuses":[200],"side_effect":"none"},"workforce.employee.feedback.read.v1":{"method":"GET","operation":"workforce.employee.feedback.read.v1","path":"/workforce/restaurants/:restaurantId/employees/:employmentId/feedback-alerts","permission":"workforce.feedback.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeFeedbackReadV1","response_statuses":[200],"side_effect":"none"},"workforce.employee.access.recover.v1":{"method":"POST","operation":"workforce.employee.access.recover.v1","path":"/workforce/restaurants/:restaurantId/employees/:employeeId/recover-access","permission":"core.hr.employee.recover","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceEmployeeAccessRecoveryRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeeAccessRecoverV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.employee.picture.set.v1":{"method":"POST","operation":"workforce.employee.picture.set.v1","path":"/workforce/restaurants/:restaurantId/employees/:employeeId/picture","permission":"workforce.employment.update","public":false,"refusal_responses":[],"request_file_fields":["photo"],"request_media_type":"multipart/form-data","request_schema":"WorkforceEmployeePictureSetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmployeePictureSetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.employment.register.v1":{"method":"POST","operation":"workforce.employment.register.v1","path":"/workforce/restaurants/:restaurantId/employment/register","permission":"workforce.employment.register","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceEmploymentRegisterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentRegisterV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.employment.update.v1":{"method":"POST","operation":"workforce.employment.update.v1","path":"/workforce/restaurants/:restaurantId/employment/update","permission":"workforce.employment.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceEmploymentUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentUpdateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.employment.suspend.v1":{"method":"POST","operation":"workforce.employment.suspend.v1","path":"/workforce/restaurants/:restaurantId/employment/suspend","permission":"workforce.employment.suspend","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceEmploymentSuspendRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentSuspendV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.employment.restore.v1":{"method":"POST","operation":"workforce.employment.restore.v1","path":"/workforce/restaurants/:restaurantId/employment/restore","permission":"workforce.employment.restore","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceEmploymentRestoreRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentRestoreV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.employment.end.v1":{"method":"POST","operation":"workforce.employment.end.v1","path":"/workforce/restaurants/:restaurantId/employment/end","permission":"workforce.employment.end","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceEmploymentEndRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEmploymentEndV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.eligibility.set.v1":{"method":"POST","operation":"workforce.eligibility.set.v1","path":"/workforce/restaurants/:restaurantId/eligibility/set","permission":"workforce.eligibility.set","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceEligibilitySetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceEligibilitySetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.operational-session.enter.v1":{"method":"POST","operation":"workforce.operational-session.enter.v1","path":"/workforce/restaurants/:restaurantId/operational-session/enter","permission":"workforce.operational-session.enter","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceOperationalSessionEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalSessionEnterV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.operational-presence.renew.v1":{"method":"POST","operation":"workforce.operational-presence.renew.v1","path":"/workforce/restaurants/:restaurantId/operational-presence/renew","permission":"workforce.operational-presence.renew","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceOperationalPresenceRenewRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceOperationalPresenceRenewV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.feedback.create.v1":{"method":"POST","operation":"workforce.feedback.create.v1","path":"/workforce/restaurants/:restaurantId/feedback/create","permission":"workforce.feedback.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceFeedbackCreateRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceFeedbackCreateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.feedback.acknowledge.v1":{"method":"POST","operation":"workforce.feedback.acknowledge.v1","path":"/workforce/restaurants/:restaurantId/feedback/acknowledge","permission":"workforce.feedback.acknowledge","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceFeedbackAcknowledgeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceFeedbackAcknowledgeV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.staff-notice.compose.v1":{"method":"POST","operation":"workforce.staff-notice.compose.v1","path":"/workforce/restaurants/:restaurantId/staff-notices","permission":"workforce.staff-notice.compose","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceStaffNoticeComposeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceStaffNoticeComposeV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.staff-notice.read.v1":{"method":"GET","operation":"workforce.staff-notice.read.v1","path":"/workforce/restaurants/:restaurantId/staff-notices/:noticeId","permission":"workforce.staff-notice.compose","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceStaffNoticeReadV1","response_statuses":[200],"side_effect":"none"},"workforce.staff-notice.withdraw.v1":{"method":"POST","operation":"workforce.staff-notice.withdraw.v1","path":"/workforce/restaurants/:restaurantId/staff-notices/:noticeId/withdraw","permission":"workforce.staff-notice.compose","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceStaffNoticeWithdrawRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceStaffNoticeWithdrawV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"workforce.rota.read.v1":{"method":"GET","operation":"workforce.rota.read.v1","path":"/workforce/restaurants/:restaurantId/rota","permission":"workforce.rota.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"WorkforceRotaQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceRotaReadV1","response_statuses":[200],"side_effect":"none"},"workforce.rota.publish.v1":{"method":"POST","operation":"workforce.rota.publish.v1","path":"/workforce/restaurants/:restaurantId/rota/publish","permission":"workforce.rota.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"WorkforceRotaPublishRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseWorkforceRotaPublishV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.table-occupancy.impacted.read.v1":{"method":"GET","operation":"service.table-occupancy.impacted.read.v1","path":"/service/restaurants/:restaurantId/table-occupancy/impacted","permission":"service.table-occupancy.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceTableOccupancyQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceTableOccupancyImpactedReadV1","response_statuses":[200],"side_effect":"none"},"service.kitchen-pending-work.impacted.read.v1":{"method":"GET","operation":"service.kitchen-pending-work.impacted.read.v1","path":"/service/restaurants/:restaurantId/kitchen-pending-work/impacted","permission":"service.kitchen-pending-work.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceKitchenPendingWorkQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceKitchenPendingWorkImpactedReadV1","response_statuses":[200],"side_effect":"none"},"service.fulfillment-plan.read.v1":{"method":"GET","operation":"service.fulfillment-plan.read.v1","path":"/service/restaurants/:restaurantId/fulfillment-plan","permission":"service.fulfillment-plan.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentPlanReadV1","response_statuses":[200],"side_effect":"none"},"service.department-categories.read.v1":{"method":"GET","operation":"service.department-categories.read.v1","path":"/service/restaurants/:restaurantId/department-categories","permission":"service.department-categories.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceDepartmentCategoriesReadV1","response_statuses":[200],"side_effect":"none"},"service.snapshot.read.pos.v1":{"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.pos.v1","path":"/service/restaurants/:restaurantId/snapshots/pos","permission":"service.snapshot.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadPosV1","response_statuses":[200],"side_effect":"none"},"service.snapshot.read.kitchen.v1":{"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.kitchen.v1","path":"/service/restaurants/:restaurantId/snapshots/kitchen","permission":"service.snapshot.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadKitchenV1","response_statuses":[200],"side_effect":"none"},"service.snapshot.read.floor.v1":{"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.floor.v1","path":"/service/restaurants/:restaurantId/snapshots/floor","permission":"service.snapshot.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadFloorV1","response_statuses":[200],"side_effect":"none"},"service.check-consumption-receipt.read.staff.v1":{"method":"GET","operation":"service.check-consumption-receipt.read.staff.v1","path":"/service/restaurants/:restaurantId/checks/:checkId/consumption-receipt","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceCheckConsumptionReceiptQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"service.check-order-loyalty.read.staff.v1":{"method":"GET","operation":"service.check-order-loyalty.read.staff.v1","path":"/service/restaurants/:restaurantId/checks/:checkId/orders/:orderId/loyalty","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckOrderLoyaltyReadStaffV1","response_statuses":[200],"side_effect":"none"},"service.history.read.staff.v1":{"method":"GET","operation":"service.history.read.staff.v1","path":"/service/restaurants/:restaurantId/history","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceStaffHistoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceHistoryReadStaffV1","response_statuses":[200],"side_effect":"none"},"service.history-summary.read.staff.v1":{"method":"GET","operation":"service.history-summary.read.staff.v1","path":"/service/restaurants/:restaurantId/history/summary","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceStaffHistorySummaryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceHistorySummaryReadStaffV1","response_statuses":[200],"side_effect":"none"},"service.check-charge-plan.read.staff.v1":{"method":"POST","operation":"service.check-charge-plan.read.staff.v1","path":"/service/restaurants/:restaurantId/check-charge-plans","permission":"service.check.charge","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckChargePlanRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckChargePlanReadStaffV1","response_statuses":[200],"side_effect":"none"},"service.check-refund.preview.staff.v1":{"method":"POST","operation":"service.check-refund.preview.staff.v1","path":"/service/restaurants/:restaurantId/check-refunds/preview","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckRefundPreviewRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckRefundPreviewStaffV1","response_statuses":[200],"side_effect":"none"},"service.refund.record.v3":{"method":"POST","operation":"service.refund.record.v3","path":"/service/restaurants/:restaurantId/refund/record/v3","permission":"service.refund.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckRefundRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceRefundRecordV3","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cash.read.v1":{"method":"GET","operation":"service.cash.read.v1","path":"/service/restaurants/:restaurantId/cash","permission":"service.cash.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCashReadV1","response_statuses":[200],"side_effect":"none"},"service.cash-sessions.read.v1":{"method":"GET","operation":"service.cash-sessions.read.v1","path":"/service/restaurants/:restaurantId/cash/sessions","permission":"service.cash.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceCashSessionsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionsReadV1","response_statuses":[200],"side_effect":"none"},"service.cash-document-archive.read.v1":{"method":"GET","operation":"service.cash-document-archive.read.v1","path":"/service/restaurants/:restaurantId/cash/document-archive","permission":"service.cash.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceCashDocumentArchiveQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCashDocumentArchiveReadV1","response_statuses":[200],"side_effect":"none"},"service.cash-document-archive.file.v1":{"method":"GET","operation":"service.cash-document-archive.file.v1","path":"/service/restaurants/:restaurantId/cash/document-archive/:documentId/file","permission":"service.cash.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceCashDocumentFileQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"service.cash-document.read.v1":{"method":"GET","operation":"service.cash-document.read.v1","path":"/service/restaurants/:restaurantId/cash/document","permission":"service.cash.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceCashDocumentQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"service.check-payment.read.v1":{"method":"GET","operation":"service.check-payment.read.v1","path":"/service/restaurants/:restaurantId/check-payments/:paymentId","permission":"service.check-payment.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCheckPaymentReadV1","response_statuses":[200],"side_effect":"none"},"service.probe.read.v1":{"method":"GET","operation":"service.probe.read.v1","path":"/service/restaurants/:restaurantId/probe","permission":"service.probe.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceProbeReadV1","response_statuses":[200],"side_effect":"none"},"service.clock.read.v1":{"method":"GET","operation":"service.clock.read.v1","path":"/service/clock","permission":"service.clock.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceClockReadV1","response_statuses":[200],"side_effect":"none"},"service.offline-review.read.v1":{"method":"GET","operation":"service.offline-review.read.v1","path":"/service/restaurants/:restaurantId/offline-review","permission":"service.offline-review.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceOfflineReviewQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceOfflineReviewReadV1","response_statuses":[200],"side_effect":"none"},"service.offline-segment.record.v1":{"method":"POST","operation":"service.offline-segment.record.v1","path":"/service/restaurants/:restaurantId/offline-segment/record","permission":"service.offline-segment.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOfflineSegmentRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOfflineSegmentRecordV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.fulfillment.transition.kitchen.v2":{"method":"POST","operation":"service.fulfillment.transition.kitchen.v2","path":"/service/restaurants/:restaurantId/fulfillment/transition/kitchen","permission":"service.fulfillment.transition","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentTransitionKitchenV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.manager.fulfillment.transition.kitchen.v2":{"method":"POST","operation":"service.manager.fulfillment.transition.kitchen.v2","path":"/service/restaurants/:restaurantId/manager/fulfillment/transition/kitchen","permission":"service.manager.fulfillment.transition","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentTransitionKitchenV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.fulfillment.remake.kitchen.v2":{"method":"POST","operation":"service.fulfillment.remake.kitchen.v2","path":"/service/restaurants/:restaurantId/fulfillment/remake/kitchen","permission":"service.fulfillment.remake","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceFulfillmentRemakeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentRemakeKitchenV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.fulfillment.transition.floor.v2":{"method":"POST","operation":"service.fulfillment.transition.floor.v2","path":"/service/restaurants/:restaurantId/fulfillment/transition/floor","permission":"service.fulfillment.transition","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentTransitionFloorV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.manager.fulfillment.transition.floor.v2":{"method":"POST","operation":"service.manager.fulfillment.transition.floor.v2","path":"/service/restaurants/:restaurantId/manager/fulfillment/transition/floor","permission":"service.manager.fulfillment.transition","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentTransitionFloorV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.fulfillment.deliver-batch.floor.v2":{"method":"POST","operation":"service.fulfillment.deliver-batch.floor.v2","path":"/service/restaurants/:restaurantId/fulfillment/deliver-batch/floor","permission":"service.fulfillment.deliver-batch","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentDeliverBatchFloorV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.manager.fulfillment.deliver-batch.floor.v2":{"method":"POST","operation":"service.manager.fulfillment.deliver-batch.floor.v2","path":"/service/restaurants/:restaurantId/manager/fulfillment/deliver-batch/floor","permission":"service.manager.fulfillment.deliver-batch","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentDeliverBatchFloorV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.bill-request.accept.floor.v2":{"method":"POST","operation":"service.bill-request.accept.floor.v2","path":"/service/restaurants/:restaurantId/bill-request/accept/floor","permission":"service.bill-request.accept","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceBillRequestAcceptRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceBillRequestAcceptFloorV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.table-session.nobody-here.floor.v2":{"method":"POST","operation":"service.table-session.nobody-here.floor.v2","path":"/service/restaurants/:restaurantId/table-session/nobody-here/floor","permission":"service.table-session.nobody-here","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceTableSessionNobodyHereRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionNobodyHereFloorV2","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.table-session.open.v1":{"method":"POST","operation":"service.table-session.open.v1","path":"/service/restaurants/:restaurantId/table-session/open","permission":"service.table-session.open","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceTableSessionOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionOpenV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.table-session.party-size.set.v1":{"method":"POST","operation":"service.table-session.party-size.set.v1","path":"/service/restaurants/:restaurantId/table-session/party-size/set","permission":"service.table-session.party-size.set","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceTableSessionPartySizeSetRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionPartySizeSetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.table-session.close.v1":{"method":"POST","operation":"service.table-session.close.v1","path":"/service/restaurants/:restaurantId/table-session/close","permission":"service.table-session.close","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceTableSessionCloseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionCloseV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.bill-request.accept.v1":{"method":"POST","operation":"service.bill-request.accept.v1","path":"/service/restaurants/:restaurantId/bill-request/accept","permission":"service.bill-request.accept","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceBillRequestAcceptRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceBillRequestAcceptV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.bill-request.reopen.v1":{"method":"POST","operation":"service.bill-request.reopen.v1","path":"/service/restaurants/:restaurantId/bill-request/reopen","permission":"service.bill-request.reopen","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceBillRequestReopenRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceBillRequestReopenV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.table-session.force-close.v1":{"method":"POST","operation":"service.table-session.force-close.v1","path":"/service/restaurants/:restaurantId/table-session/force-close","permission":"service.table-session.force-close","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceTableSessionForceCloseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionForceCloseV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.force-close.reclassify.v1":{"method":"POST","operation":"service.force-close.reclassify.v1","path":"/service/restaurants/:restaurantId/force-close/reclassify","permission":"service.force-close.reclassify","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceForceCloseReclassifyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceForceCloseReclassifyV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.participant.create.v1":{"method":"POST","operation":"service.participant.create.v1","path":"/service/restaurants/:restaurantId/participant/create","permission":"service.participant.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceParticipantCreateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceParticipantCreateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.open.staff.v1":{"method":"POST","operation":"service.cart.open.staff.v1","path":"/service/restaurants/:restaurantId/staff/cart/open","permission":"service.cart.open","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartOpenStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.add.staff.v1":{"method":"POST","operation":"service.cart.item.add.staff.v1","path":"/service/restaurants/:restaurantId/staff/cart/item/add","permission":"service.cart.item.add","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemAddStaffRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemAddStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.update.staff.v1":{"method":"POST","operation":"service.cart.item.update.staff.v1","path":"/service/restaurants/:restaurantId/staff/cart/item/update","permission":"service.cart.item.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemUpdateStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.remove.staff.v1":{"method":"POST","operation":"service.cart.item.remove.staff.v1","path":"/service/restaurants/:restaurantId/staff/cart/item/remove","permission":"service.cart.item.remove","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemRemoveStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.diner.offer.choose.staff.v1":{"method":"POST","operation":"service.diner.offer.choose.staff.v1","path":"/service/restaurants/:restaurantId/staff/diner/offer/choose","permission":"service.diner.offer.choose","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferCouponRefusalHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceDinerOfferChooseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferChooseStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.diner.offer.remove.staff.v1":{"method":"POST","operation":"service.diner.offer.remove.staff.v1","path":"/service/restaurants/:restaurantId/staff/diner/offer/remove","permission":"service.diner.offer.remove","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceDinerOfferRemoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferRemoveStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.discard.staff.v1":{"method":"POST","operation":"service.cart.discard.staff.v1","path":"/service/restaurants/:restaurantId/staff/cart/discard","permission":"service.cart.discard","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartDiscardRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartDiscardStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.submit.staff.v1":{"method":"POST","operation":"service.order.submit.staff.v1","path":"/service/restaurants/:restaurantId/staff/order/submit","permission":"service.order.submit","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderSubmitStaffRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderSubmitStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.item.update.staff.v1":{"method":"POST","operation":"service.order.item.update.staff.v1","path":"/service/restaurants/:restaurantId/staff/order/item/update","permission":"service.order.item.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemUpdateStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.item.remove.staff.v1":{"method":"POST","operation":"service.order.item.remove.staff.v1","path":"/service/restaurants/:restaurantId/staff/order/item/remove","permission":"service.order.item.remove","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemRemoveStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.cancel.staff.v1":{"method":"POST","operation":"service.order.cancel.staff.v1","path":"/service/restaurants/:restaurantId/staff/order/cancel","permission":"service.order.cancel","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderCancelRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderCancelStaffV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.fulfillment.transition.v1":{"method":"POST","operation":"service.fulfillment.transition.v1","path":"/service/restaurants/:restaurantId/fulfillment/transition","permission":"service.fulfillment.transition","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentTransitionV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.fulfillment.remake.v1":{"method":"POST","operation":"service.fulfillment.remake.v1","path":"/service/restaurants/:restaurantId/fulfillment/remake","permission":"service.fulfillment.remake","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceFulfillmentRemakeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentRemakeV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.fulfillment.deliver-batch.v1":{"method":"POST","operation":"service.fulfillment.deliver-batch.v1","path":"/service/restaurants/:restaurantId/fulfillment/deliver-batch","permission":"service.fulfillment.deliver-batch","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceFulfillmentDeliverBatchV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.manager.fulfillment.transition.v1":{"method":"POST","operation":"service.manager.fulfillment.transition.v1","path":"/service/restaurants/:restaurantId/manager/fulfillment/transition","permission":"service.manager.fulfillment.transition","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentTransitionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentTransitionV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.manager.fulfillment.deliver-batch.v1":{"method":"POST","operation":"service.manager.fulfillment.deliver-batch.v1","path":"/service/restaurants/:restaurantId/manager/fulfillment/deliver-batch","permission":"service.manager.fulfillment.deliver-batch","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceManagerFulfillmentDeliverBatchRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceManagerFulfillmentDeliverBatchV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.check.finalize.v1":{"method":"POST","operation":"service.check.finalize.v1","path":"/service/restaurants/:restaurantId/check/finalize","permission":"service.check.finalize","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckFinalizeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckFinalizeV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.check.charge.v1":{"method":"POST","operation":"service.check.charge.v1","path":"/service/restaurants/:restaurantId/check/charge","permission":"service.check.charge","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckChargeRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckChargeV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.check.charge.reverse.v1":{"method":"POST","operation":"service.check.charge.reverse.v1","path":"/service/restaurants/:restaurantId/check/charge/reverse","permission":"service.check.charge.reverse","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckChargeReverseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckChargeReverseV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.check.line.waive.v1":{"method":"POST","operation":"service.check.line.waive.v1","path":"/service/restaurants/:restaurantId/check/line/waive","permission":"service.check.line.waive","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckLineWaiveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckLineWaiveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.check.split.v1":{"method":"POST","operation":"service.check.split.v1","path":"/service/restaurants/:restaurantId/check/split","permission":"service.check.split","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCheckSplitRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCheckSplitV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cash.movement.record.v1":{"method":"POST","operation":"service.cash.movement.record.v1","path":"/service/restaurants/:restaurantId/cash/movement/record","permission":"service.cash.movement.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCashMovementRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashMovementRecordV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cash.session.open.v1":{"method":"POST","operation":"service.cash.session.open.v1","path":"/service/restaurants/:restaurantId/cash/session/open","permission":"service.cash.session.open","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCashSessionOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionOpenV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cash.movement.void.v1":{"method":"POST","operation":"service.cash.movement.void.v1","path":"/service/restaurants/:restaurantId/cash/movement/void","permission":"service.cash.movement.void","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCashMovementVoidRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashMovementVoidV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cash.session.close.v1":{"method":"POST","operation":"service.cash.session.close.v1","path":"/service/restaurants/:restaurantId/cash/session/close","permission":"service.cash.session.close","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCashSessionCloseRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionCloseV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cash.session.count.v1":{"method":"POST","operation":"service.cash.session.count.v1","path":"/service/restaurants/:restaurantId/cash/session/count","permission":"service.cash.session.count","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCashSessionCountRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashSessionCountV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cash.payment-method.correct.v1":{"method":"POST","operation":"service.cash.payment-method.correct.v1","path":"/service/restaurants/:restaurantId/cash/payment-method/correct","permission":"service.cash.payment-method.correct","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCashPaymentMethodCorrectRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCashPaymentMethodCorrectV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.confirm.v1":{"method":"POST","operation":"service.order.confirm.v1","path":"/service/restaurants/:restaurantId/order/confirm","permission":"service.order.confirm","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderConfirmRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderConfirmV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.table-session.nobody-here.v1":{"method":"POST","operation":"service.table-session.nobody-here.v1","path":"/service/restaurants/:restaurantId/table-session/nobody-here","permission":"service.table-session.nobody-here","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceTableSessionNobodyHereRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceTableSessionNobodyHereV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.qr-orders.pause.set.v1":{"method":"POST","operation":"service.qr-orders.pause.set.v1","path":"/service/restaurants/:restaurantId/qr-orders/pause/set","permission":"service.qr-orders.pause.set","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceQrOrdersPauseSetRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceQrOrdersPauseSetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.offline-review.resolve.v1":{"method":"POST","operation":"service.offline-review.resolve.v1","path":"/service/restaurants/:restaurantId/offline-review/resolve","permission":"service.offline-review.resolve","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOfflineReviewResolveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOfflineReviewResolveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external-review.franchise-summaries.get":{"method":"GET","operation":"relationship.external-review.franchise-summaries.get","path":"/relationship/external-reviews/franchises/:franchiseId/summaries","permission":"relationship.external_review.franchise.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewFranchiseSummariesGet","response_statuses":[200],"side_effect":"none"},"relationship.external-review.connection.get":{"method":"GET","operation":"relationship.external-review.connection.get","path":"/relationship/external-reviews/google/connection","permission":"relationship.external_review.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionGet","response_statuses":[200],"side_effect":"none"},"relationship.external-review.connection.start":{"method":"POST","operation":"relationship.external-review.connection.start","path":"/relationship/external-reviews/google/connection/start","permission":"relationship.external_review.connect","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"StartRelationshipGoogleConnectionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionStart","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external-review.connection.complete":{"method":"POST","operation":"relationship.external-review.connection.complete","path":"/relationship/external-reviews/google/connection/complete","permission":"relationship.external_review.connect","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CompleteRelationshipGoogleConnectionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionComplete","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external-review.connection.select":{"method":"PUT","operation":"relationship.external-review.connection.select","path":"/relationship/external-reviews/google/connection","permission":"relationship.external_review.connect","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"SelectRelationshipGoogleLocationRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionSelect","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external-review.connection.disconnect":{"method":"DELETE","operation":"relationship.external-review.connection.disconnect","path":"/relationship/external-reviews/google/connection","permission":"relationship.external_review.connect","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"DisconnectRelationshipGoogleConnectionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewConnectionDisconnect","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external-review.list":{"method":"GET","operation":"relationship.external-review.list","path":"/relationship/external-reviews","permission":"relationship.external_review.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewList","response_statuses":[200],"side_effect":"none"},"relationship.external_review.reply":{"method":"PUT","operation":"relationship.external_review.reply","path":"/relationship/external-reviews/:reviewId/reply","permission":"relationship.external_review.reply","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReplyRelationshipExternalReviewRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReply","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external_review.reply.delete":{"method":"DELETE","operation":"relationship.external_review.reply.delete","path":"/relationship/external-reviews/:reviewId/reply","permission":"relationship.external_review.reply","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"DeleteRelationshipExternalReviewReplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReplyDelete","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external_review.reply.publish":{"method":"POST","operation":"relationship.external_review.reply.publish","path":"/relationship/external-reviews/:reviewId/reply/publish","permission":"relationship.external_review.reply","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PublishRelationshipExternalReviewReplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReplyPublish","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.external_review.reply.undo":{"method":"POST","operation":"relationship.external_review.reply.undo","path":"/relationship/external-reviews/:reviewId/reply/undo","permission":"relationship.external_review.reply","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"UndoRelationshipExternalReviewReplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipExternalReviewReplyUndo","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.review-topics.read.v1":{"method":"GET","operation":"relationship.review-topics.read.v1","path":"/relationship/reviews/topics","permission":"relationship.review.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"RelationshipReviewTopicsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewTopicsReadV1","response_statuses":[200],"side_effect":"none"},"relationship.review-stars-weekly.read.v1":{"method":"GET","operation":"relationship.review-stars-weekly.read.v1","path":"/relationship/reviews/stars/weekly","permission":"relationship.review.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"RelationshipReviewStarsWeeklyRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewStarsWeeklyReadV1","response_statuses":[200],"side_effect":"none"},"relationship.el-parte-guest-return.read.v1":{"method":"GET","operation":"relationship.el-parte-guest-return.read.v1","path":"/relationship/el-parte/guest-return","permission":"relationship.preferences.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"RelationshipGuestReturnPanelRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipElParteGuestReturnReadV1","response_statuses":[200],"side_effect":"none"},"relationship.restaurant-reviews.list.v1":{"method":"GET","operation":"relationship.restaurant-reviews.list.v1","path":"/relationship/reviews/restaurant","permission":"relationship.review.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"RelationshipRestaurantReviewsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipRestaurantReviewsListV1","response_statuses":[200],"side_effect":"none"},"relationship.guest-question.read.v1":{"method":"GET","operation":"relationship.guest-question.read.v1","path":"/relationship/guest-question","permission":"relationship.review.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionReadV1","response_statuses":[200],"side_effect":"none"},"relationship.guest-question.put.v1":{"method":"PUT","operation":"relationship.guest-question.put.v1","path":"/relationship/guest-question","permission":"relationship.loyalty.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PutRelationshipGuestQuestionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionPutV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.guest-question.remove.v1":{"method":"POST","operation":"relationship.guest-question.remove.v1","path":"/relationship/guest-question/remove","permission":"relationship.loyalty.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RemoveRelationshipGuestQuestionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionRemoveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.loyalty.program.admin-get":{"method":"GET","operation":"relationship.loyalty.program.admin-get","path":"/relationship/loyalty/program/admin","permission":"relationship.loyalty.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyProgramAdminGet","response_statuses":[200],"side_effect":"none"},"relationship.loyalty.tier-catalogue.list":{"method":"GET","operation":"relationship.loyalty.tier-catalogue.list","path":"/relationship/loyalty/tier-catalogue","permission":"relationship.loyalty.tier-catalogue.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyTierCatalogueList","response_statuses":[200],"side_effect":"none"},"relationship.loyalty.population.get":{"method":"GET","operation":"relationship.loyalty.population.get","path":"/relationship/loyalty/population","permission":"relationship.loyalty.population.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyPopulationGet","response_statuses":[200],"side_effect":"none"},"relationship.loyalty.program.put":{"method":"PUT","operation":"relationship.loyalty.program.put","path":"/relationship/loyalty/program","permission":"relationship.loyalty.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PutRelationshipLoyaltyProgramRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyProgramPut","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.loyalty.program.retire":{"method":"POST","operation":"relationship.loyalty.program.retire","path":"/relationship/loyalty/program/retire","permission":"relationship.loyalty.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RetireRelationshipLoyaltyProgramRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipLoyaltyProgramRetire","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"insights.franchise.metrics":{"method":"GET","operation":"insights.franchise.metrics","path":"/insights/franchises/:franchiseId/metrics","permission":"insights.metrics.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsFranchiseMetrics","response_statuses":[200],"side_effect":"none"},"insights.restaurant.period":{"method":"GET","operation":"insights.restaurant.period","path":"/insights/restaurants/:restaurantId/period","permission":"insights.metrics.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InsightsPeriodQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsRestaurantPeriod","response_statuses":[200],"side_effect":"none"},"insights.loyalty.period":{"method":"GET","operation":"insights.loyalty.period","path":"/insights/restaurants/:restaurantId/loyalty/period","permission":"relationship.loyalty.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InsightsLoyaltyPeriodQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsLoyaltyPeriod","response_statuses":[200],"side_effect":"none"},"insights.restaurant.promotion-month":{"method":"GET","operation":"insights.restaurant.promotion-month","path":"/insights/restaurants/:restaurantId/promotions/monthly","permission":"insights.promotions.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InsightsPromotionMonthQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsRestaurantPromotionMonth","response_statuses":[200],"side_effect":"none"},"insights.restaurant.flavour-profile":{"method":"GET","operation":"insights.restaurant.flavour-profile","path":"/insights/restaurants/:restaurantId/flavour-profile","permission":"insights.metrics.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InsightsFlavourProfileQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsRestaurantFlavourProfile","response_statuses":[200],"side_effect":"none"},"parte.edition.read":{"method":"GET","operation":"parte.edition.read","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEditionRead","response_statuses":[200],"side_effect":"none"},"parte.edition.list":{"method":"GET","operation":"parte.edition.list","path":"/parte/restaurants/:restaurantId/editions","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteEditionListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEditionList","response_statuses":[200],"side_effect":"none"},"parte.work.read.v1":{"method":"GET","operation":"parte.work.read.v1","path":"/parte/restaurants/:restaurantId/work","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteWorkReadV1","response_statuses":[200],"side_effect":"none"},"parte.notebook.read":{"method":"GET","operation":"parte.notebook.read","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate/notebook","permission":"parte.notebook.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteNotebookRead","response_statuses":[200],"side_effect":"none"},"parte.pendientes.read.v1":{"method":"GET","operation":"parte.pendientes.read.v1","path":"/parte/restaurants/:restaurantId/pendientes","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"PartePendientesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePendientesReadV1","response_statuses":[200],"side_effect":"none"},"parte.pendiente.dismiss.v1":{"method":"POST","operation":"parte.pendiente.dismiss.v1","path":"/parte/restaurants/:restaurantId/pendientes/:pendienteId/dismiss","permission":"parte.pendiente.dismiss","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePendienteDismissRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePendienteDismissV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.costs.dishes.read.v1":{"method":"GET","operation":"parte.costs.dishes.read.v1","path":"/parte/restaurants/:restaurantId/costs/dishes","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteDishCostsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteCostsDishesReadV1","response_statuses":[200],"side_effect":"none"},"parte.costs.recipe-batch.read.v1":{"method":"GET","operation":"parte.costs.recipe-batch.read.v1","path":"/parte/restaurants/:restaurantId/costs/recipe-batch","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchReadV1","response_statuses":[200],"side_effect":"none"},"parte.costs.recipe-batch.confirm.v1":{"method":"POST","operation":"parte.costs.recipe-batch.confirm.v1","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/confirm","permission":"parte.recipe-batch.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteRecipeBatchConfirmRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchConfirmV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.costs.recipe-batch.withdraw.v1":{"method":"POST","operation":"parte.costs.recipe-batch.withdraw.v1","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/withdraw","permission":"parte.recipe-batch.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteRecipeBatchWithdrawRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchWithdrawV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.costs.recipe-batch.undo.v1":{"method":"POST","operation":"parte.costs.recipe-batch.undo.v1","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/undo","permission":"parte.recipe-batch.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteRecipeBatchUndoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchUndoV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.costs.recipe-batch.correct.v1":{"method":"POST","operation":"parte.costs.recipe-batch.correct.v1","path":"/parte/restaurants/:restaurantId/costs/recipe-batch/correct","permission":"parte.recipe-batch.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteRecipeBatchCorrectRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCostsRecipeBatchCorrectV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.finanzas.daily-account.read.v1":{"method":"GET","operation":"parte.finanzas.daily-account.read.v1","path":"/parte/restaurants/:restaurantId/finanzas/daily-account","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteFinanzasReadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasDailyAccountReadV1","response_statuses":[200],"side_effect":"none"},"parte.finanzas.number-of-today.read.v1":{"method":"GET","operation":"parte.finanzas.number-of-today.read.v1","path":"/parte/restaurants/:restaurantId/finanzas/number-of-today","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteFinanzasReadQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasNumberOfTodayReadV1","response_statuses":[200],"side_effect":"none"},"parte.finanzas.fixed-costs.declare.v1":{"method":"POST","operation":"parte.finanzas.fixed-costs.declare.v1","path":"/parte/restaurants/:restaurantId/finanzas/fixed-costs","permission":"parte.finanzas.declare","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteFixedCostsDeclareRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasFixedCostsDeclareV1","response_statuses":[200],"side_effect":"mutation-and-audit"},"parte.finanzas.labour-averages.declare.v1":{"method":"POST","operation":"parte.finanzas.labour-averages.declare.v1","path":"/parte/restaurants/:restaurantId/finanzas/labour-averages","permission":"parte.finanzas.declare","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteLabourAveragesDeclareRequest","requires_expected_version":true,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteFinanzasLabourAveragesDeclareV1","response_statuses":[200],"side_effect":"mutation-and-audit"},"parte.edition-audio.read.v1":{"method":"GET","operation":"parte.edition-audio.read.v1","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate/audio","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEditionAudioReadV1","response_statuses":[200],"side_effect":"none"},"parte.edition-audio.segment.read.v1":{"method":"GET","operation":"parte.edition-audio.segment.read.v1","path":"/parte/restaurants/:restaurantId/editions/:editionKind/:businessDate/audio/segments/:segmentIndex","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"parte.voice-answer.submit.v1":{"method":"POST","operation":"parte.voice-answer.submit.v1","path":"/parte/restaurants/:restaurantId/voice-answers","permission":"parte.question.answer","public":false,"refusal_responses":[],"request_file_fields":["audio"],"request_media_type":"multipart/form-data","request_schema":"ParteVoiceAnswerSubmitRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteVoiceAnswerSubmitV1","response_statuses":[200,201],"side_effect":"mutation"},"parte.push-key.read.v1":{"method":"GET","operation":"parte.push-key.read.v1","path":"/parte/restaurants/:restaurantId/push/key","permission":"parte.push.subscribe","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePushKeyReadV1","response_statuses":[200],"side_effect":"none"},"parte.push-subscription.register.v1":{"method":"POST","operation":"parte.push-subscription.register.v1","path":"/parte/restaurants/:restaurantId/push/subscriptions","permission":"parte.push.subscribe","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePushSubscriptionRegisterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePushSubscriptionRegisterV1","response_statuses":[200,201],"side_effect":"mutation"},"parte.push-subscription.remove.v1":{"method":"POST","operation":"parte.push-subscription.remove.v1","path":"/parte/restaurants/:restaurantId/push/subscriptions/:subscriptionId/remove","permission":"parte.push.subscribe","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePushSubscriptionRemoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePushSubscriptionRemoveV1","response_statuses":[200,201],"side_effect":"mutation"},"parte.pacto.read.v1":{"method":"GET","operation":"parte.pacto.read.v1","path":"/parte/restaurants/:restaurantId/pacto","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePactoReadV1","response_statuses":[200],"side_effect":"none"},"parte.pacto.line.put.v1":{"method":"POST","operation":"parte.pacto.line.put.v1","path":"/parte/restaurants/:restaurantId/pacto/lines","permission":"parte.pacto.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePactoLinePutRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePactoLinePutV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.pacto.line.confirm.v1":{"method":"POST","operation":"parte.pacto.line.confirm.v1","path":"/parte/restaurants/:restaurantId/pacto/lines/confirm","permission":"parte.pacto.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePactoLineConfirmRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePactoLineConfirmV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.pacto.line.retire.v1":{"method":"POST","operation":"parte.pacto.line.retire.v1","path":"/parte/restaurants/:restaurantId/pacto/lines/retire","permission":"parte.pacto.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePactoLineRetireRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePactoLineRetireV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.team-stop.set.v1":{"method":"PUT","operation":"parte.team-stop.set.v1","path":"/parte/restaurants/:restaurantId/team-stop","permission":"parte.pacto.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteTeamStopSetRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteTeamStopSetV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.operation.read.v1":{"method":"GET","operation":"parte.operation.read.v1","path":"/parte/restaurants/:restaurantId/operations/:operationId","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteOperationReadV1","response_statuses":[200],"side_effect":"none"},"parte.operation.approve.v1":{"method":"POST","operation":"parte.operation.approve.v1","path":"/parte/restaurants/:restaurantId/operations/:operationId/approve","permission":"parte.operation.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteOperationApproveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteOperationApproveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.operation.decline.v1":{"method":"POST","operation":"parte.operation.decline.v1","path":"/parte/restaurants/:restaurantId/operations/:operationId/decline","permission":"parte.operation.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteOperationDeclineRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteOperationDeclineV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.operation.resolve.v1":{"method":"POST","operation":"parte.operation.resolve.v1","path":"/parte/restaurants/:restaurantId/operations/:operationId/resolve","permission":"parte.operation.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteOperationResolveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteOperationResolveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.scheduled-action.stop.v1":{"method":"POST","operation":"parte.scheduled-action.stop.v1","path":"/parte/restaurants/:restaurantId/scheduled-actions/:actionId/stop","permission":"parte.operation.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteScheduledActionStopRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteScheduledActionStopV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.team-action.undo.v1":{"method":"POST","operation":"parte.team-action.undo.v1","path":"/parte/restaurants/:restaurantId/team-actions/:actionId/undo","permission":"parte.operation.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteTeamActionUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteTeamActionUndoV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.work.act.v1":{"method":"POST","operation":"parte.work.act.v1","path":"/parte/restaurants/:restaurantId/work/:itemId/act","permission":"parte.operation.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteWorkActRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteWorkActV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.autonomy.read.v1":{"method":"GET","operation":"parte.autonomy.read.v1","path":"/parte/restaurants/:restaurantId/autonomy","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteAutonomyReadV1","response_statuses":[200],"side_effect":"none"},"parte.autonomy.offer.answer.v1":{"method":"POST","operation":"parte.autonomy.offer.answer.v1","path":"/parte/restaurants/:restaurantId/autonomy/offers/answer","permission":"parte.autonomy.decide","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteAutonomyOfferAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteAutonomyOfferAnswerV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.hoy.read.v1":{"method":"GET","operation":"parte.hoy.read.v1","path":"/parte/restaurants/:restaurantId/hoy/:businessDate","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteHoyReadV1","response_statuses":[200],"side_effect":"none"},"parte.house-memory.read.v1":{"method":"GET","operation":"parte.house-memory.read.v1","path":"/parte/restaurants/:restaurantId/house-memory","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteHouseMemoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteHouseMemoryReadV1","response_statuses":[200],"side_effect":"none"},"parte.compras.call-list.read.v1":{"method":"GET","operation":"parte.compras.call-list.read.v1","path":"/parte/restaurants/:restaurantId/compras/call-list","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteCallListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComprasCallListReadV1","response_statuses":[200],"side_effect":"none"},"parte.compras.prep-plan.read.v1":{"method":"GET","operation":"parte.compras.prep-plan.read.v1","path":"/parte/restaurants/:restaurantId/compras/prep-plan","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteCallListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComprasPrepPlanReadV1","response_statuses":[200],"side_effect":"none"},"parte.compras.food-waste-plan.read.v1":{"method":"GET","operation":"parte.compras.food-waste-plan.read.v1","path":"/parte/restaurants/:restaurantId/compras/food-waste-plan","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteFoodWastePlanQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComprasFoodWastePlanReadV1","response_statuses":[200],"side_effect":"none"},"parte.compras.food-waste-plan.adopt.v1":{"method":"POST","operation":"parte.compras.food-waste-plan.adopt.v1","path":"/parte/restaurants/:restaurantId/compras/food-waste-plan/adopt","permission":"parte.question.answer","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteFoodWastePlanAdoptRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteComprasFoodWastePlanAdoptV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.compras.food-waste-plan.update.decline.v1":{"method":"POST","operation":"parte.compras.food-waste-plan.update.decline.v1","path":"/parte/restaurants/:restaurantId/compras/food-waste-plan/update/decline","permission":"parte.question.answer","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteFoodWastePlanUpdateDeclineRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteComprasFoodWastePlanUpdateDeclineV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.team.coach.read.v1":{"method":"GET","operation":"parte.team.coach.read.v1","path":"/parte/restaurants/:restaurantId/team/coach","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteCoachQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteTeamCoachReadV1","response_statuses":[200],"side_effect":"none"},"parte.team.coach.note.share.v1":{"method":"POST","operation":"parte.team.coach.note.share.v1","path":"/parte/restaurants/:restaurantId/team/coach/share","permission":"parte.coach.share","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteCoachShareRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteTeamCoachNoteShareV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.rota-proposal.read.v1":{"method":"GET","operation":"parte.rota-proposal.read.v1","path":"/parte/restaurants/:restaurantId/rota-proposal","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteRotaProposalQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteRotaProposalReadV1","response_statuses":[200],"side_effect":"none"},"parte.ai-audit.read.v1":{"method":"GET","operation":"parte.ai-audit.read.v1","path":"/parte/restaurants/:restaurantId/ai-audit","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteAiAuditQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteAiAuditReadV1","response_statuses":[200],"side_effect":"none"},"parte.compliance-calendar.read.v1":{"method":"GET","operation":"parte.compliance-calendar.read.v1","path":"/parte/restaurants/:restaurantId/compliance-calendar","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteComplianceCalendarReadV1","response_statuses":[200],"side_effect":"none"},"parte.consejo.read.v1":{"method":"GET","operation":"parte.consejo.read.v1","path":"/parte/restaurants/:restaurantId/consejo/:month","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteConsejoReadV1","response_statuses":[200],"side_effect":"none"},"parte.consejo-pdf.read.v1":{"method":"GET","operation":"parte.consejo-pdf.read.v1","path":"/parte/restaurants/:restaurantId/consejo/:month/pdf","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"parte.missing-data.answer.v1":{"method":"POST","operation":"parte.missing-data.answer.v1","path":"/parte/restaurants/:restaurantId/missing-data/:questionId/answer","permission":"parte.question.answer","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteMissingDataAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteMissingDataAnswerV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.carta-reading.read.v1":{"method":"GET","operation":"parte.carta-reading.read.v1","path":"/parte/restaurants/:restaurantId/carta-reading","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteCartaReadingReadV1","response_statuses":[200],"side_effect":"none"},"parte.carta-reading.correct.v1":{"method":"POST","operation":"parte.carta-reading.correct.v1","path":"/parte/restaurants/:restaurantId/carta-reading/:categoryId","permission":"parte.pacto.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteCartaReadingCorrectRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteCartaReadingCorrectV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.encargo.create.v1":{"method":"POST","operation":"parte.encargo.create.v1","path":"/parte/restaurants/:restaurantId/encargos/requests","permission":"parte.consulta.request","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteEncargoCreateRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteEncargoCreateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.encargos.read.v1":{"method":"GET","operation":"parte.encargos.read.v1","path":"/parte/restaurants/:restaurantId/encargos/requests","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEncargosReadV1","response_statuses":[200],"side_effect":"none"},"parte.encargo.read.v1":{"method":"GET","operation":"parte.encargo.read.v1","path":"/parte/restaurants/:restaurantId/encargos/requests/:encargoId","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteEncargoReadV1","response_statuses":[200],"side_effect":"none"},"parte.page-notes.read.v1":{"method":"GET","operation":"parte.page-notes.read.v1","path":"/parte/restaurants/:restaurantId/page-notes/:page","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponsePartePageNotesReadV1","response_statuses":[200],"side_effect":"none"},"parte.reputation.drafts.read.v1":{"method":"GET","operation":"parte.reputation.drafts.read.v1","path":"/parte/restaurants/:restaurantId/reputation/drafts","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteReputationDraftsReadV1","response_statuses":[200],"side_effect":"none"},"parte.reputation.reply-draft.set-aside.v1":{"method":"POST","operation":"parte.reputation.reply-draft.set-aside.v1","path":"/parte/restaurants/:restaurantId/reputation/reply-drafts/:reviewId/set-aside","permission":"parte.question.answer","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteReplyDraftSetAsideRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteReputationReplyDraftSetAsideV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.reputation.post-draft.use.v1":{"method":"POST","operation":"parte.reputation.post-draft.use.v1","path":"/parte/restaurants/:restaurantId/reputation/post-drafts/:draftId/use","permission":"parte.question.answer","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePostDraftDecisionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteReputationPostDraftUseV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.reputation.post-draft.withdraw.v1":{"method":"POST","operation":"parte.reputation.post-draft.withdraw.v1","path":"/parte/restaurants/:restaurantId/reputation/post-drafts/:draftId/withdraw","permission":"parte.question.answer","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePostDraftDecisionRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteReputationPostDraftWithdrawV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.team.read.v1":{"method":"GET","operation":"parte.team.read.v1","path":"/parte/restaurants/:restaurantId/team","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteTeamReadV1","response_statuses":[200],"side_effect":"none"},"parte.what-if.dish-price.read.v1":{"method":"POST","operation":"parte.what-if.dish-price.read.v1","path":"/parte/restaurants/:restaurantId/what-if/dish-price","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteWhatIfDishPriceRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteWhatIfDishPriceReadV1","response_statuses":[200],"side_effect":"none"},"parte.what-if.closed-weekday.read.v1":{"method":"POST","operation":"parte.what-if.closed-weekday.read.v1","path":"/parte/restaurants/:restaurantId/what-if/closed-weekday","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteWhatIfClosedWeekdayRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteWhatIfClosedWeekdayReadV1","response_statuses":[200],"side_effect":"none"},"parte.goals.read.v1":{"method":"GET","operation":"parte.goals.read.v1","path":"/parte/restaurants/:restaurantId/goals","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ParteGoalsQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteGoalsReadV1","response_statuses":[200],"side_effect":"none"},"parte.queue.read.v1":{"method":"GET","operation":"parte.queue.read.v1","path":"/parte/restaurants/:restaurantId/queue","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteQueueReadV1","response_statuses":[200],"side_effect":"none"},"parte.matter.read.v1":{"method":"GET","operation":"parte.matter.read.v1","path":"/parte/restaurants/:restaurantId/matters/:matterId","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteMatterReadV1","response_statuses":[200],"side_effect":"none"},"parte.goal.say.v1":{"method":"POST","operation":"parte.goal.say.v1","path":"/parte/restaurants/:restaurantId/goals","permission":"parte.pacto.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteGoalSayRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalSayV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.goal.confirm.v1":{"method":"POST","operation":"parte.goal.confirm.v1","path":"/parte/restaurants/:restaurantId/goals/:goalId/confirm","permission":"parte.pacto.write","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteGoalConfirmRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalConfirmV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.goal.correct.v1":{"method":"POST","operation":"parte.goal.correct.v1","path":"/parte/restaurants/:restaurantId/goals/:goalId/correct","permission":"parte.pacto.write","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteGoalCorrectRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalCorrectV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.goal.decline.v1":{"method":"POST","operation":"parte.goal.decline.v1","path":"/parte/restaurants/:restaurantId/goals/:goalId/decline","permission":"parte.pacto.write","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteGoalDeclineRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalDeclineV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.goal.withdraw.v1":{"method":"POST","operation":"parte.goal.withdraw.v1","path":"/parte/restaurants/:restaurantId/goals/:goalId/withdraw","permission":"parte.pacto.write","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteGoalWithdrawRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteGoalWithdrawV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.queue.answer.v1":{"method":"POST","operation":"parte.queue.answer.v1","path":"/parte/restaurants/:restaurantId/queue/:itemId/answer","permission":"parte.operation.decide","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"ParteCoreStaleHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteQueueAnswerRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteQueueAnswerV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.matters.read.v1":{"method":"GET","operation":"parte.matters.read.v1","path":"/parte/restaurants/:restaurantId/matters","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteMattersReadV1","response_statuses":[200],"side_effect":"none"},"parte.request.open.v1":{"method":"POST","operation":"parte.request.open.v1","path":"/parte/restaurants/:restaurantId/requests","permission":"parte.consulta.request","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteRequestOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteRequestOpenV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.advisor-library.read.v1":{"method":"GET","operation":"parte.advisor-library.read.v1","path":"/parte/restaurants/:restaurantId/advisor-library","permission":"parte.edition.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseParteAdvisorLibraryReadV1","response_statuses":[200],"side_effect":"none"},"parte.advisor-library.review.v1":{"method":"POST","operation":"parte.advisor-library.review.v1","path":"/parte/restaurants/:restaurantId/advisor-library/reviews","permission":"parte.advisor-library.review","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ParteAdvisorLibraryReviewRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseParteAdvisorLibraryReviewV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"parte.person.withdraw":{"method":"POST","operation":"parte.person.withdraw","path":"/parte/restaurants/:restaurantId/person-withdrawals","permission":"parte.person.withdraw","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"PartePersonWithdrawalRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponsePartePersonWithdraw","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"insights.parte-radar.read":{"method":"GET","operation":"insights.parte-radar.read","path":"/insights/restaurants/:restaurantId/parte-radar","permission":"insights.metrics.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InsightsParteRadarQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInsightsParteRadarRead","response_statuses":[200],"side_effect":"none"},"owner-calendar.list":{"method":"GET","operation":"owner-calendar.list","path":"/proposals/restaurants/:restaurantId/calendar","permission":"proposal.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"OwnerCalendarWindowQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarList","response_statuses":[200],"side_effect":"none"},"owner-calendar.history":{"method":"GET","operation":"owner-calendar.history","path":"/proposals/restaurants/:restaurantId/calendar/:declarationId/history","permission":"proposal.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarHistory","response_statuses":[200],"side_effect":"none"},"owner-calendar.put":{"method":"PUT","operation":"owner-calendar.put","path":"/proposals/restaurants/:restaurantId/calendar/:declarationId","permission":"preference.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"OwnerCalendarPutRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarPut","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"owner-calendar.cancel":{"method":"POST","operation":"owner-calendar.cancel","path":"/proposals/restaurants/:restaurantId/calendar/:declarationId/cancel","permission":"preference.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"OwnerCalendarCancelRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseOwnerCalendarCancel","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"proposal.catalog-reviewed.prepare":{"method":"POST","operation":"proposal.catalog-reviewed.prepare","path":"/proposals/restaurants/:restaurantId/catalog-reviewed/preparations","permission":"proposal.confirm","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogReviewedPrepareRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalCatalogReviewedPrepare","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"proposal.catalog-reviewed.preparation.read":{"method":"GET","operation":"proposal.catalog-reviewed.preparation.read","path":"/proposals/restaurants/:restaurantId/catalog-reviewed/preparations/:requestId","permission":"proposal.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalCatalogReviewedPreparationRead","response_statuses":[200],"side_effect":"none"},"proposal.intent.list":{"method":"GET","operation":"proposal.intent.list","path":"/proposals/restaurants/:restaurantId/intents","permission":"proposal.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalIntentList","response_statuses":[200],"side_effect":"none"},"proposal.intent.read":{"method":"GET","operation":"proposal.intent.read","path":"/proposals/restaurants/:restaurantId/intents/:intentId","permission":"proposal.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalIntentRead","response_statuses":[200],"side_effect":"none"},"proposal.preview":{"method":"GET","operation":"proposal.preview","path":"/proposals/restaurants/:restaurantId/intents/:intentId/preview","permission":"proposal.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseProposalPreview","response_statuses":[200],"side_effect":"none"},"proposal.confirm":{"method":"POST","operation":"proposal.confirm","path":"/proposals/restaurants/:restaurantId/intents/:intentId/confirm","permission":"proposal.confirm","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ProposalConfirmRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalConfirm","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"proposal.decline":{"method":"POST","operation":"proposal.decline","path":"/proposals/restaurants/:restaurantId/intents/:intentId/decline","permission":"proposal.decline","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ProposalDeclineRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalDecline","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"proposal.undo":{"method":"POST","operation":"proposal.undo","path":"/proposals/restaurants/:restaurantId/intents/:intentId/undo","permission":"proposal.undo","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ProposalUndoRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseProposalUndo","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.configuration.read":{"method":"GET","operation":"billing.configuration.read","path":"/restaurants/:restaurantId/billing","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingConfigurationRead","response_statuses":[200],"side_effect":"none"},"billing.configuration.apply":{"method":"PUT","operation":"billing.configuration.apply","path":"/restaurants/:restaurantId/billing","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingConfigurationApplyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingConfigurationApply","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.provider.connect":{"method":"PUT","operation":"billing.provider.connect","path":"/restaurants/:restaurantId/billing/provider","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingProviderConnectRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingProviderConnect","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.provider.disconnect":{"method":"DELETE","operation":"billing.provider.disconnect","path":"/restaurants/:restaurantId/billing/provider","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingProviderDisconnect","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.activate":{"method":"POST","operation":"billing.activate","path":"/restaurants/:restaurantId/billing/activate","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingActivateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingActivate","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.documents.by-check":{"method":"GET","operation":"billing.documents.by-check","path":"/restaurants/:restaurantId/billing/checks/:checkId/documents","permission":"billing.document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingDocumentsByCheck","response_statuses":[200],"side_effect":"none"},"billing.documents.by-checks":{"method":"GET","operation":"billing.documents.by-checks","path":"/restaurants/:restaurantId/billing/checks/documents","permission":"billing.document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"BillingDocumentsByChecksQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingDocumentsByChecks","response_statuses":[200],"side_effect":"none"},"billing.document.read":{"method":"GET","operation":"billing.document.read","path":"/restaurants/:restaurantId/billing/documents/:documentId","permission":"billing.document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingDocumentRead","response_statuses":[200],"side_effect":"none"},"billing.document.download":{"method":"GET","operation":"billing.document.download","path":"/restaurants/:restaurantId/billing/documents/:documentId/pdf","permission":"billing.document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"billing.intent.read":{"method":"GET","operation":"billing.intent.read","path":"/restaurants/:restaurantId/billing/intents/:intentId","permission":"billing.document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingIntentRead","response_statuses":[200],"side_effect":"none"},"billing.intent.download":{"method":"GET","operation":"billing.intent.download","path":"/restaurants/:restaurantId/billing/intents/:intentId/pdf","permission":"billing.document.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"billing.request.create":{"method":"POST","operation":"billing.request.create","path":"/restaurants/:restaurantId/billing/requests","permission":"billing.request.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingRequestCreateRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingRequestCreate","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.status.summary":{"method":"GET","operation":"billing.status.summary","path":"/restaurants/:restaurantId/billing/status","permission":"billing.status.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingStatusSummary","response_statuses":[200],"side_effect":"none"},"billing.intent.retry":{"method":"POST","operation":"billing.intent.retry","path":"/restaurants/:restaurantId/billing/intents/:intentId/retry","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingIntentActionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentRetry","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.intent.void":{"method":"POST","operation":"billing.intent.void","path":"/restaurants/:restaurantId/billing/intents/:intentId/void","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingIntentActionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentVoid","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.document.render":{"method":"POST","operation":"billing.document.render","path":"/restaurants/:restaurantId/billing/documents/:documentId/render","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingIntentActionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingDocumentRender","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.fiscal-incidents.list":{"method":"GET","operation":"billing.fiscal-incidents.list","path":"/restaurants/:restaurantId/billing/fiscal-incidents","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingFiscalIncidentsList","response_statuses":[200],"side_effect":"none"},"billing.fiscal-incident.record":{"method":"POST","operation":"billing.fiscal-incident.record","path":"/restaurants/:restaurantId/billing/fiscal-incidents","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingFiscalIncidentRecordRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingFiscalIncidentRecord","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.fiscal-incident.move":{"method":"POST","operation":"billing.fiscal-incident.move","path":"/restaurants/:restaurantId/billing/fiscal-incidents/:incidentId/state","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingFiscalIncidentMoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingFiscalIncidentMove","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.document.legible-copy":{"method":"POST","operation":"billing.document.legible-copy","path":"/restaurants/:restaurantId/billing/documents/:documentId/legible-copy","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingLegibleCopyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingDocumentLegibleCopy","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.incidents.list":{"method":"GET","operation":"billing.incidents.list","path":"/restaurants/:restaurantId/billing/incidents","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"BillingIncidentListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingIncidentsList","response_statuses":[200],"side_effect":"none"},"billing.issuer-succession.record":{"method":"POST","operation":"billing.issuer-succession.record","path":"/restaurants/:restaurantId/billing/issuer-successions","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingIssuerSuccessionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIssuerSuccessionRecord","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.intent.complete":{"method":"POST","operation":"billing.intent.complete","path":"/restaurants/:restaurantId/billing/intents/:intentId/complete","permission":"billing.request.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingIntentCompleteRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentComplete","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.intent.reissue":{"method":"POST","operation":"billing.intent.reissue","path":"/restaurants/:restaurantId/billing/intents/:intentId/reissue","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingIntentReissueRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingIntentReissue","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.export.prepare":{"method":"POST","operation":"billing.export.prepare","path":"/restaurants/:restaurantId/billing/exports","permission":"service.history.export","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingExportPrepareRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingExportPrepare","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.export.list":{"method":"GET","operation":"billing.export.list","path":"/restaurants/:restaurantId/billing/exports","permission":"service.history.export","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"BillingExportListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingExportList","response_statuses":[200],"side_effect":"none"},"billing.export.download":{"method":"GET","operation":"billing.export.download","path":"/restaurants/:restaurantId/billing/exports/:exportId/file","permission":"service.history.export","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"billing.offline-intents.release":{"method":"POST","operation":"billing.offline-intents.release","path":"/restaurants/:restaurantId/billing/offline-intents/release","permission":"billing.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingOfflineIntentsReleaseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingOfflineIntentsRelease","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.payment.invoice":{"method":"POST","operation":"billing.payment.invoice","path":"/restaurants/:restaurantId/billing/payments/:paymentId/invoice","permission":"billing.request.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"BillingPaymentInvoiceRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseBillingPaymentInvoice","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"offers.bridge.definition-put.revalidate":{"method":"GET","operation":"offers.bridge.definition-put.revalidate","path":"/offers/restaurants/:restaurantId/bridge/definition-put","permission":"offers.definition.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"OffersBridgePutQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersBridgeDefinitionPutRevalidate","response_statuses":[200],"side_effect":"none"},"offers.bridge.definition-retire.revalidate":{"method":"GET","operation":"offers.bridge.definition-retire.revalidate","path":"/offers/restaurants/:restaurantId/bridge/definition-retire","permission":"offers.definition.retire","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"OffersBridgeRetireQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersBridgeDefinitionRetireRevalidate","response_statuses":[200],"side_effect":"none"},"inventory.bridge.stock-item-reconcile.revalidate":{"method":"GET","operation":"inventory.bridge.stock-item-reconcile.revalidate","path":"/inventory/restaurants/:restaurantId/bridge/stock-item-reconcile","permission":"inventory.stock-item.reconcile","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryBridgeReconcileQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryBridgeStockItemReconcileRevalidate","response_statuses":[200],"side_effect":"none"},"inventory.bridge.stock-item.revalidate":{"method":"GET","operation":"inventory.bridge.stock-item.revalidate","path":"/inventory/restaurants/:restaurantId/bridge/stock-item","permission":"inventory.stock-item.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"InventoryBridgeItemQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseInventoryBridgeStockItemRevalidate","response_statuses":[200],"side_effect":"none"},"service.bridge.history.revalidate":{"method":"GET","operation":"service.bridge.history.revalidate","path":"/service/restaurants/:restaurantId/bridge/history","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceBridgeHistoryQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceBridgeHistoryRevalidate","response_statuses":[200],"side_effect":"none"},"service.bridge.table-session-force-close.revalidate":{"method":"GET","operation":"service.bridge.table-session-force-close.revalidate","path":"/service/restaurants/:restaurantId/bridge/table-session-force-close","permission":"service.table-session.force-close","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceBridgeForceCloseQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceBridgeTableSessionForceCloseRevalidate","response_statuses":[200],"side_effect":"none"},"workforce.bridge.feedback-create.revalidate":{"method":"GET","operation":"workforce.bridge.feedback-create.revalidate","path":"/workforce/restaurants/:restaurantId/bridge/feedback-create","permission":"workforce.feedback.create","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"WorkforceBridgeFeedbackQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceBridgeFeedbackCreateRevalidate","response_statuses":[200],"side_effect":"none"},"workforce.bridge.work-target-assignment-bulk-apply.revalidate":{"method":"GET","operation":"workforce.bridge.work-target-assignment-bulk-apply.revalidate","path":"/workforce/restaurants/:restaurantId/bridge/work-target-assignment-bulk-apply","permission":"workforce.work-target-assignment.bulk-apply","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"WorkforceBridgeBulkQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceBridgeWorkTargetAssignmentBulkApplyRevalidate","response_statuses":[200],"side_effect":"none"},"workforce.bridge.staff-notice-compose.revalidate":{"method":"GET","operation":"workforce.bridge.staff-notice-compose.revalidate","path":"/workforce/restaurants/:restaurantId/bridge/staff-notice-compose","permission":"workforce.staff-notice.compose","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"WorkforceBridgeStaffNoticeQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseWorkforceBridgeStaffNoticeComposeRevalidate","response_statuses":[200],"side_effect":"none"},"catalog.bridge.draft-replace.revalidate":{"method":"GET","operation":"catalog.bridge.draft-replace.revalidate","path":"/catalogs/:restaurantId/bridge/draft-replace","permission":"catalog.draft.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogBridgeDraftQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogBridgeDraftReplaceRevalidate","response_statuses":[200],"side_effect":"none"},"catalog.bridge.media-write.revalidate":{"method":"GET","operation":"catalog.bridge.media-write.revalidate","path":"/catalogs/:restaurantId/bridge/media-write","permission":"catalog.media.write","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogBridgeMediaQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogBridgeMediaWriteRevalidate","response_statuses":[200],"side_effect":"none"},"catalog.bridge.publish.revalidate":{"method":"GET","operation":"catalog.bridge.publish.revalidate","path":"/catalogs/:restaurantId/bridge/publish","permission":"catalog.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogBridgePublishQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseCatalogBridgePublishRevalidate","response_statuses":[200],"side_effect":"none"},"restaurant-configuration.bridge.apply.revalidate":{"method":"GET","operation":"restaurant-configuration.bridge.apply.revalidate","path":"/restaurant-configurations/:restaurantId/bridge/apply","permission":"restaurant.configuration.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ConfigurationBridgeApplyQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRestaurantConfigurationBridgeApplyRevalidate","response_statuses":[200],"side_effect":"none"},"restaurant-configuration.bridge.floor.revalidate":{"method":"GET","operation":"restaurant-configuration.bridge.floor.revalidate","path":"/restaurant-configurations/:restaurantId/bridge/floor","permission":"restaurant.configuration.publish","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ConfigurationBridgeFloorQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRestaurantConfigurationBridgeFloorRevalidate","response_statuses":[200],"side_effect":"none"},"relationship.bridge.loyalty-program-put.revalidate":{"method":"GET","operation":"relationship.bridge.loyalty-program-put.revalidate","path":"/relationship/restaurants/:restaurantId/bridge/loyalty-program-put","permission":"relationship.loyalty.manage","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"RelationshipBridgeProgramQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipBridgeLoyaltyProgramPutRevalidate","response_statuses":[200],"side_effect":"none"}} as const
export const GUEST_OPERATION_METADATA = {"GET /guest/home":{"method":"GET","operation":"GET /guest/home","path":"/guest/home","permission":"identity.guest.session.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestHome","response_statuses":[200],"side_effect":"none"},"GET /guest/restaurant-presentation":{"method":"GET","operation":"GET /guest/restaurant-presentation","path":"/guest/restaurant-presentation","permission":"tenant.restaurant.presentation.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestRestaurantPresentation","response_statuses":[200],"side_effect":"none"},"POST /identity/guest/account/save":{"method":"POST","operation":"POST /identity/guest/account/save","path":"/identity/guest/account/save","permission":"identity.guest.account.save","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAccountSave","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAccountSave","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /identity/guest/auth/current":{"method":"GET","operation":"GET /identity/guest/auth/current","path":"/identity/guest/auth/current","permission":"identity.guest.session.read","public":false,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestAuthCurrent","response_statuses":[200],"side_effect":"none"},"POST /identity/guest/auth/forget":{"method":"POST","operation":"POST /identity/guest/auth/forget","path":"/identity/guest/auth/forget","permission":"identity.guest.session.revoke","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestForget","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAuthForget","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/entry":{"method":"POST","operation":"POST /identity/guest/entry","path":"/identity/guest/entry","permission":"identity.qr.resolve","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestEntry","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntry","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/entry/start-order":{"method":"POST","operation":"POST /identity/guest/entry/start-order","path":"/identity/guest/entry/start-order","permission":"identity.guest.order.start","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestStartOrder","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntryStartOrder","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/challenge":{"method":"POST","operation":"POST /identity/guest/passkey/challenge","path":"/identity/guest/passkey/challenge","permission":"identity.guest.passkey.challenge","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyChallenge","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyChallenge","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/recover":{"method":"POST","operation":"POST /identity/guest/passkey/recover","path":"/identity/guest/passkey/recover","permission":"identity.guest.passkey.recover","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyRecover","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyRecover","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/save":{"method":"POST","operation":"POST /identity/guest/passkey/save","path":"/identity/guest/passkey/save","permission":"identity.guest.passkey.save","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeySave","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeySave","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /identity/guest/qr/handoff/:handoffToken":{"method":"GET","operation":"GET /identity/guest/qr/handoff/:handoffToken","path":"/identity/guest/qr/handoff/:handoffToken","permission":"identity.qr.handoff.consume","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrHandoffHandoffToken","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /identity/guest/qr/resolve/:qrId":{"method":"GET","operation":"GET /identity/guest/qr/resolve/:qrId","path":"/identity/guest/qr/resolve/:qrId","permission":"identity.qr.resolve","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrResolveQrId","response_statuses":[200],"side_effect":"mutation"},"platformMessaging.guestRealtimeReplay.v1":{"method":"GET","operation":"platformMessaging.guestRealtimeReplay.v1","path":"/platform/realtime/guest-replay","permission":"platform.realtime.guest-replay","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":"PlatformMessagingGuestRealtimeReplayRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"PlatformMessagingRealtimeReplayResponse","response_statuses":[200],"side_effect":"none"},"platformMessaging.guestNoticeSeen.v1":{"method":"POST","operation":"platformMessaging.guestNoticeSeen.v1","path":"/platform/guest-notices/:noticeId/seen","permission":"platform.notice.guest.seen","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"side_effect":"mutation-and-audit"},"platformMessaging.guestNoticeDismiss.v1":{"method":"POST","operation":"platformMessaging.guestNoticeDismiss.v1","path":"/platform/guest-notices/:noticeId/dismiss","permission":"platform.notice.guest.dismiss","public":false,"request_file_fields":[],"request_media_type":"application/json","request_schema":"PlatformMessagingNoticeReceiptRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_schema":"PlatformMessagingNoticeReceiptResponse","response_statuses":[200],"side_effect":"mutation-and-audit"},"platformMessaging.guestNoticesPendingOverlay.v1":{"method":"GET","operation":"platformMessaging.guestNoticesPendingOverlay.v1","path":"/platform/guest-notices/pending-overlay","permission":"platform.notice.guest.read","public":false,"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_schema":"PlatformMessagingNoticeListResponse","response_statuses":[200],"side_effect":"none"},"readGuestPublishedCatalogue":{"method":"GET","operation":"readGuestPublishedCatalogue","path":"/guest/catalogs/:restaurantId/published","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestPublishedCatalogue","response_statuses":[200],"side_effect":"none"},"readGuestLiveCatalogue":{"method":"GET","operation":"readGuestLiveCatalogue","path":"/guest/catalogs/:restaurantId/live","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestLiveCatalogue","response_statuses":[200],"side_effect":"none"},"readGuestMenuDocuments":{"method":"GET","operation":"readGuestMenuDocuments","path":"/guest/catalogs/:restaurantId/documents","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestMenuDocuments","response_statuses":[200],"side_effect":"none"},"readPreauthenticatedGuestCatalogue":{"method":"POST","operation":"readPreauthenticatedGuestCatalogue","path":"/guest/catalogs/:restaurantId/preauthenticated-live","permission":"catalog.featured.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReadPreauthenticatedFeaturedCatalogRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPreauthenticatedGuestCatalogue","response_statuses":[200],"side_effect":"none"},"readPreauthenticatedFeaturedCatalog":{"method":"POST","operation":"readPreauthenticatedFeaturedCatalog","path":"/guest/catalogs/:restaurantId/preauthenticated-featured","permission":"catalog.featured.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReadPreauthenticatedFeaturedCatalogRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPreauthenticatedFeaturedCatalog","response_statuses":[200],"side_effect":"none"},"readPreauthenticatedCatalogMediaDelivery":{"method":"POST","operation":"readPreauthenticatedCatalogMediaDelivery","path":"/guest/catalogs/:restaurantId/preauthenticated-featured/media/:mediaId/delivery","permission":"catalog.featured.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"CatalogPreauthenticatedMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadPreauthenticatedCatalogMediaDelivery","response_statuses":[200],"side_effect":"none"},"readGuestPublishedDish":{"method":"GET","operation":"readGuestPublishedDish","path":"/guest/catalogs/:restaurantId/published/dishes/:dishId","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestPublishedDish","response_statuses":[200],"side_effect":"none"},"readGuestDailySuggestions":{"method":"GET","operation":"readGuestDailySuggestions","path":"/guest/catalogs/:restaurantId/daily-suggestions","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestDailySuggestions","response_statuses":[200],"side_effect":"none"},"readGuestCatalogMediaDelivery":{"method":"GET","operation":"readGuestCatalogMediaDelivery","path":"/guest/catalogs/:restaurantId/media/:mediaId/delivery","permission":"catalog.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"CatalogMediaDeliveryRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseReadGuestCatalogMediaDelivery","response_statuses":[200],"side_effect":"none"},"offers.wallet.list":{"method":"GET","operation":"offers.wallet.list","path":"/offers/wallet","permission":"offers.wallet.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseOffersWalletList","response_statuses":[200],"side_effect":"none"},"guest.profile.get":{"method":"GET","operation":"guest.profile.get","path":"/guest/profile","permission":"guest.profile.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestProfileGet","response_statuses":[200],"side_effect":"none"},"guest.loyalty-cards.list":{"method":"GET","operation":"guest.loyalty-cards.list","path":"/guest/loyalty-cards","permission":"guest.profile.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestLoyaltyCardsList","response_statuses":[200],"side_effect":"none"},"guest.loyalty-cards.detail":{"method":"GET","operation":"guest.loyalty-cards.detail","path":"/guest/loyalty-cards/:restaurantId","permission":"guest.profile.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestLoyaltyCardsDetail","response_statuses":[200],"side_effect":"none"},"guest.profile.update":{"method":"PUT","operation":"guest.profile.update","path":"/guest/profile","permission":"guest.profile.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"UpdateGuestProfileRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestProfileUpdate","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"guest.diagnostics.record":{"method":"POST","operation":"guest.diagnostics.record","path":"/guest/diagnostics","permission":"guest.diagnostics.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RecordGuestDiagnosticsRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestDiagnosticsRecord","response_statuses":[202],"side_effect":"none"},"guest.identity.suggest":{"method":"POST","operation":"guest.identity.suggest","path":"/guest/identity-suggestions","permission":"guest.identity.suggest","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"GuestIdentitySuggestionRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestIdentitySuggest","response_statuses":[200],"side_effect":"none"},"guest.privacy.get":{"method":"GET","operation":"guest.privacy.get","path":"/guest/privacy","permission":"guest.privacy.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyGet","response_statuses":[200],"side_effect":"none"},"guest.privacy.replace-consent":{"method":"PUT","operation":"guest.privacy.replace-consent","path":"/guest/privacy/consent","permission":"guest.privacy.consent.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReplaceGuestConsentRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyReplaceConsent","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"guest.privacy.personalization.get":{"method":"GET","operation":"guest.privacy.personalization.get","path":"/guest/privacy/personalization","permission":"guest.privacy.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyPersonalizationGet","response_statuses":[200],"side_effect":"none"},"guest.privacy.replace-personalization":{"method":"PUT","operation":"guest.privacy.replace-personalization","path":"/guest/privacy/personalization","permission":"guest.privacy.personalization.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReplaceGuestPersonalizationSettingRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyReplacePersonalization","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"guest.privacy.export":{"method":"GET","operation":"guest.privacy.export","path":"/guest/privacy/export","permission":"guest.privacy.export","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyExport","response_statuses":[200],"side_effect":"none"},"guest.privacy.erase-derived":{"method":"POST","operation":"guest.privacy.erase-derived","path":"/guest/privacy/erase-derived","permission":"guest.privacy.erase","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"EraseGuestPrivacyRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyEraseDerived","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"guest.privacy.erase-account":{"method":"POST","operation":"guest.privacy.erase-account","path":"/guest/privacy/erase-account","permission":"guest.privacy.erase","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"EraseGuestAccountRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseGuestPrivacyEraseAccount","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"guest.billing.documents.list":{"method":"GET","operation":"guest.billing.documents.list","path":"/guest/billing/documents","permission":"guest.billing.documents.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"GuestBillingDocumentListQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestBillingDocumentsList","response_statuses":[200],"side_effect":"none"},"guest.billing.session-charges.read":{"method":"GET","operation":"guest.billing.session-charges.read","path":"/guest/billing/sessions/:tableSessionId/charges","permission":"guest.billing.documents.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"GuestBillingSessionChargesQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseGuestBillingSessionChargesRead","response_statuses":[200],"side_effect":"none"},"guest.billing.document.download":{"method":"GET","operation":"guest.billing.document.download","path":"/guest/billing/documents/:documentId/pdf","permission":"guest.billing.documents.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"service.check-consumption-receipt.read.guest.v1":{"method":"GET","operation":"service.check-consumption-receipt.read.guest.v1","path":"/service/guest/checks/:checkId/consumption-receipt","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceCheckConsumptionReceiptQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"},"service.cart.item.safety.challenge.read.v1":{"method":"GET","operation":"service.cart.item.safety.challenge.read.v1","path":"/service/guest/cart-item-safety-challenge","permission":"service.snapshot.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ServiceSafetyChallengeQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceCartItemSafetyChallengeReadV1","response_statuses":[200],"side_effect":"none"},"service.snapshot.read.guest.v1":{"conditional_read":"etag","method":"GET","operation":"service.snapshot.read.guest.v1","path":"/service/guest/snapshot","permission":"service.snapshot.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceSnapshotReadGuestV1","response_statuses":[200],"side_effect":"none"},"service.arrival.read.guest.v1":{"conditional_read":"etag","method":"GET","operation":"service.arrival.read.guest.v1","path":"/service/guest/arrival","permission":"service.snapshot.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceArrivalReadGuestV1","response_statuses":[200],"side_effect":"none"},"service.waiting-room.read.v1":{"method":"GET","operation":"service.waiting-room.read.v1","path":"/service/guest/waiting-room","permission":"service.snapshot.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceWaitingRoomReadV1","response_statuses":[200],"side_effect":"none"},"service.history.read.guest.v1":{"method":"GET","operation":"service.history.read.guest.v1","path":"/service/guest/history","permission":"service.history.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseServiceHistoryReadGuestV1","response_statuses":[200],"side_effect":"none"},"service.participant.join.v1":{"method":"POST","operation":"service.participant.join.v1","path":"/service/restaurants/:restaurantId/participant/join","permission":"service.participant.join","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceParticipantJoinRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceParticipantJoinV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.participant.request-bill.v1":{"method":"POST","operation":"service.participant.request-bill.v1","path":"/service/restaurants/:restaurantId/participant/request-bill","permission":"service.participant.request-bill","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceParticipantRequestBillRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceParticipantRequestBillV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.open.v1":{"method":"POST","operation":"service.cart.open.v1","path":"/service/restaurants/:restaurantId/cart/open","permission":"service.cart.open","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartOpenRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartOpenV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.add.v1":{"method":"POST","operation":"service.cart.item.add.v1","path":"/service/restaurants/:restaurantId/cart/item/add","permission":"service.cart.item.add","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemAddRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemAddV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.copy.v1":{"method":"POST","operation":"service.cart.item.copy.v1","path":"/service/restaurants/:restaurantId/cart/item/copy","permission":"service.cart.item.copy","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemCopyRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemCopyV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.steal.v1":{"method":"POST","operation":"service.cart.item.steal.v1","path":"/service/restaurants/:restaurantId/cart/item/steal","permission":"service.cart.item.steal","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemStealRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemStealV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.steal.undo.v1":{"method":"POST","operation":"service.cart.item.steal.undo.v1","path":"/service/restaurants/:restaurantId/cart/item/steal/undo","permission":"service.cart.item.steal.undo","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemStealUndoRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemStealUndoV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.safety.acknowledge.v1":{"method":"POST","operation":"service.cart.item.safety.acknowledge.v1","path":"/service/restaurants/:restaurantId/cart/item/safety/acknowledge","permission":"service.cart.item.safety.acknowledge","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemSafetyAcknowledgeRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemSafetyAcknowledgeV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.update.v1":{"method":"POST","operation":"service.cart.item.update.v1","path":"/service/restaurants/:restaurantId/cart/item/update","permission":"service.cart.item.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemUpdateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.cart.item.remove.v1":{"method":"POST","operation":"service.cart.item.remove.v1","path":"/service/restaurants/:restaurantId/cart/item/remove","permission":"service.cart.item.remove","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceCartItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceCartItemRemoveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.diner.offer.choose.v1":{"method":"POST","operation":"service.diner.offer.choose.v1","path":"/service/restaurants/:restaurantId/diner/offer/choose","permission":"service.diner.offer.choose","public":false,"refusal_responses":[{"include_generic_identity":true,"schema":"OfferCouponRefusalHttpError","status":409}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceDinerOfferChooseRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferChooseV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.diner.offer.remove.v1":{"method":"POST","operation":"service.diner.offer.remove.v1","path":"/service/restaurants/:restaurantId/diner/offer/remove","permission":"service.diner.offer.remove","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceDinerOfferRemoveRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceDinerOfferRemoveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.waiting-room.enter.v1":{"method":"POST","operation":"service.waiting-room.enter.v1","path":"/service/restaurants/:restaurantId/waiting-room/enter","permission":"service.waiting-room.enter","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceWaitingRoomEnterRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceWaitingRoomEnterV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.waiting-room.leave.v1":{"method":"POST","operation":"service.waiting-room.leave.v1","path":"/service/restaurants/:restaurantId/waiting-room/leave","permission":"service.waiting-room.leave","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceWaitingRoomLeaveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceWaitingRoomLeaveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.submit.v1":{"method":"POST","operation":"service.order.submit.v1","path":"/service/restaurants/:restaurantId/order/submit","permission":"service.order.submit","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderSubmitRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderSubmitV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.item.add.v1":{"method":"POST","operation":"service.order.item.add.v1","path":"/service/restaurants/:restaurantId/order/item/add","permission":"service.order.item.add","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderItemAddRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemAddV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.item.update.v1":{"method":"POST","operation":"service.order.item.update.v1","path":"/service/restaurants/:restaurantId/order/item/update","permission":"service.order.item.update","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderItemUpdateRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemUpdateV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"service.order.item.remove.v1":{"method":"POST","operation":"service.order.item.remove.v1","path":"/service/restaurants/:restaurantId/order/item/remove","permission":"service.order.item.remove","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ServiceOrderItemRemoveRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseServiceOrderItemRemoveV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.review.offer.read.guest.v1":{"method":"GET","operation":"relationship.review.offer.read.guest.v1","path":"/relationship/reviews/offer","permission":"relationship.review.submit","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ReadRelationshipReviewOfferRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewOfferReadGuestV1","response_statuses":[200],"side_effect":"none"},"relationship.guest-question.offer.read.guest.v1":{"method":"GET","operation":"relationship.guest-question.offer.read.guest.v1","path":"/relationship/guest-question/offer","permission":"relationship.review.submit","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"ReadRelationshipGuestQuestionOfferRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionOfferReadGuestV1","response_statuses":[200],"side_effect":"none"},"relationship.guest-question.answer.guest.v1":{"method":"POST","operation":"relationship.guest-question.answer.guest.v1","path":"/relationship/guest-question/answers","permission":"relationship.review.submit","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"AnswerRelationshipGuestQuestionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipGuestQuestionAnswerGuestV1","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.review.submit":{"method":"POST","operation":"relationship.review.submit","path":"/relationship/reviews","permission":"relationship.review.submit","public":false,"refusal_responses":[{"schema":"RelationshipConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"SubmitRelationshipReviewRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipReviewSubmit","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.preferences.get":{"method":"GET","operation":"relationship.preferences.get","path":"/relationship/preferences","permission":"relationship.preferences.read","public":false,"refusal_responses":[{"schema":"RelationshipConstraintLookupFailedHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipPreferencesGet","response_statuses":[200],"side_effect":"none"},"relationship.preferences.replace":{"method":"PUT","operation":"relationship.preferences.replace","path":"/relationship/preferences","permission":"relationship.preferences.replace","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"ReplaceRelationshipPreferencesRequest","requires_expected_version":true,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipPreferencesReplace","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.recommendation.current.read.guest.v1":{"method":"GET","operation":"relationship.recommendation.current.read.guest.v1","path":"/relationship/recommendations/current","permission":"relationship.recommendation.assign","public":false,"refusal_responses":[{"schema":"RelationshipAssignmentRefreshRequiredHttpError","status":409},{"schema":"RelationshipConstraintLookupFailedHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":"ReadCurrentRelationshipRecommendationRequest","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseRelationshipRecommendationCurrentReadGuestV1","response_statuses":[200],"side_effect":"none"},"relationship.recommendation.assign":{"method":"POST","operation":"relationship.recommendation.assign","path":"/relationship/recommendations","permission":"relationship.recommendation.assign","public":false,"refusal_responses":[{"schema":"RelationshipConstraintLookupFailedHttpError","status":503}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"AssignRelationshipRecommendationRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipRecommendationAssign","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.impression.record":{"method":"POST","operation":"relationship.impression.record","path":"/relationship/impressions","permission":"relationship.impression.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RecordRelationshipRecommendationImpressionRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipImpressionRecord","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"relationship.feedback.record":{"method":"POST","operation":"relationship.feedback.record","path":"/relationship/feedback","permission":"relationship.feedback.record","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"RecordRelationshipFeedbackRequest","requires_expected_version":false,"requires_idempotency_key":true,"response_kind":"json","response_schema":"ProductResponseRelationshipFeedbackRecord","response_statuses":[200,201],"side_effect":"mutation-and-audit"},"billing.invoice-link.read.v1":{"method":"GET","operation":"billing.invoice-link.read.v1","path":"/billing/invoice-links/:token","permission":"billing.invoice-link.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_schema":"ProductResponseBillingInvoiceLinkReadV1","response_statuses":[200],"side_effect":"none"},"billing.invoice-link.document.v1":{"method":"GET","operation":"billing.invoice-link.document.v1","path":"/billing/invoice-links/:token/document","permission":"billing.invoice-link.read","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":"BillingInvoiceLinkDocumentQuery","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"binary","response_schema":"PlatformBinaryContent","response_statuses":[200],"side_effect":"none"}} as const
export const GUEST_IDENTITY_OPERATION_METADATA = {"GET /guest/home":{"method":"GET","operation":"GET /guest/home","path":"/guest/home","permission":"identity.guest.session.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestHome","response_statuses":[200],"side_effect":"none"},"GET /guest/restaurant-presentation":{"method":"GET","operation":"GET /guest/restaurant-presentation","path":"/guest/restaurant-presentation","permission":"tenant.restaurant.presentation.read","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETGuestRestaurantPresentation","response_statuses":[200],"side_effect":"none"},"POST /identity/guest/account/save":{"method":"POST","operation":"POST /identity/guest/account/save","path":"/identity/guest/account/save","permission":"identity.guest.account.save","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestAccountSave","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAccountSave","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /identity/guest/auth/current":{"method":"GET","operation":"GET /identity/guest/auth/current","path":"/identity/guest/auth/current","permission":"identity.guest.session.read","public":false,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestAuthCurrent","response_statuses":[200],"side_effect":"none"},"POST /identity/guest/auth/forget":{"method":"POST","operation":"POST /identity/guest/auth/forget","path":"/identity/guest/auth/forget","permission":"identity.guest.session.revoke","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestForget","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestAuthForget","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/entry":{"method":"POST","operation":"POST /identity/guest/entry","path":"/identity/guest/entry","permission":"identity.qr.resolve","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestEntry","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntry","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/entry/start-order":{"method":"POST","operation":"POST /identity/guest/entry/start-order","path":"/identity/guest/entry/start-order","permission":"identity.guest.order.start","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestStartOrder","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestEntryStartOrder","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/challenge":{"method":"POST","operation":"POST /identity/guest/passkey/challenge","path":"/identity/guest/passkey/challenge","permission":"identity.guest.passkey.challenge","public":true,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyChallenge","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyChallenge","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/recover":{"method":"POST","operation":"POST /identity/guest/passkey/recover","path":"/identity/guest/passkey/recover","permission":"identity.guest.passkey.recover","public":true,"refusal_responses":[{"schema":"IdentityGuestAdmissionDeniedOrHttpError","status":403}],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeyRecover","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeyRecover","response_statuses":[200],"side_effect":"mutation-and-audit"},"POST /identity/guest/passkey/save":{"method":"POST","operation":"POST /identity/guest/passkey/save","path":"/identity/guest/passkey/save","permission":"identity.guest.passkey.save","public":false,"refusal_responses":[],"request_file_fields":[],"request_media_type":"application/json","request_schema":"IdentityRequestGuestPasskeySave","requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponsePOSTIdentityGuestPasskeySave","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /identity/guest/qr/handoff/:handoffToken":{"method":"GET","operation":"GET /identity/guest/qr/handoff/:handoffToken","path":"/identity/guest/qr/handoff/:handoffToken","permission":"identity.qr.handoff.consume","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrHandoffHandoffToken","response_statuses":[200],"side_effect":"mutation-and-audit"},"GET /identity/guest/qr/resolve/:qrId":{"method":"GET","operation":"GET /identity/guest/qr/resolve/:qrId","path":"/identity/guest/qr/resolve/:qrId","permission":"identity.qr.resolve","public":true,"refusal_responses":[{"schema":"IdentityQrRestaurantConfigurationUnavailableHttpError","status":503}],"request_file_fields":[],"request_media_type":null,"request_schema":null,"requires_expected_version":false,"requires_idempotency_key":false,"response_kind":"json","response_media_types":["application/json"],"response_schema":"IdentityResponseGETIdentityGuestQrResolveQrId","response_statuses":[200],"side_effect":"mutation"}} as const
export const isCorePublicRequest = (method: string, requestUrl: string): boolean => {
  const parsed = new URL(requestUrl, 'http://localhost')
  const marker = '/api/v1'
  const markerIndex = parsed.pathname.lastIndexOf(marker)
  const path = markerIndex >= 0 ? parsed.pathname.slice(markerIndex + marker.length) || '/' : parsed.pathname
  return Object.values(CORE_OPERATION_METADATA).some((operation) =>
    operation.public === true &&
    operation.method === method.toUpperCase() &&
    new RegExp('^' + operation.path.replace(/:[A-Za-z][A-Za-z0-9_]*/g, '[^/]+') + '$').test(path)
  )
}
